'use strict';

// TODO: remove this file once common.js ('Configuration' module) doesn't need it anymore
angular.module('EnvironmentConfiguration', []);
'use strict';

(function () {
    'use strict';
    // TODO: remove this once gaf-ng-components doesn't rely on DashboardLegacy.Constants

    angular.module('MW.DashboardLegacy.Constants', ['MW.Configuration']).constant('DASHBOARD_LEGACY_VIEWS_FOLDER', '/views').constant('DASHBOARD_LEGACY_TRANSLATIONS', '/translations').factory('DASHBOARD_LEGACY_VIEW_PATH', ['DASHBOARD_LEGACY_URL', 'DASHBOARD_LEGACY_VIEWS_FOLDER', function getDashboardLegacyViewPathValue(DASHBOARD_LEGACY_URL, DASHBOARD_LEGACY_VIEWS_FOLDER) {
        return DASHBOARD_LEGACY_URL + DASHBOARD_LEGACY_VIEWS_FOLDER;
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.CoreStream', ['MW.CoreStream.CsHeader', 'MW.CoreStream.CsSelectAllHeader', 'MW.CoreStream.CsSelectDropDown', 'MW.Influencers.ContactCard', 'MW.CoreStream.SourceCard']);

    angular.module('MW.CustomValidation', ['MW.CustomValidation.ContactManagerUsernameService', 'MW.CustomValidation.twitterValidator', 'MW.CustomValidation.facebookValidator', 'MW.CustomValidation.linkedinValidator', 'MW.CustomValidation.validateOnblur', 'MW.Framework.InfluencerContactService', 'MW.Framework.RelevantArticlesDialogService', 'MW.Framework.EntitlementService', 'MW.Framework.ICMEntitlementService', 'MW.Framework.ICMEmailService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Framework.ICMUserService']);

    angular.module('icmWebApp', ['ngMaterial', 'ngMessages', 'templates', 'mwAppComponents', 'navigationController',

    //Controllers
    'MW.ContactManager.ContactLandingController', 'MW.ContactManager.ContactManagerAddController', 'MW.ContactManager.ContactManagerFormController', 'MW.ContactManager.ContactManagerIcmEnquiryController', 'MW.ContactManager.ContactManagerImportController', 'MW.ContactManager.ContactManagerInfluencerDatabaseUpsellController', 'MW.ContactManager.ListViewController', 'MW.ContactManager.ContactManagerNavigationService', 'MW.ContactManager.ContactManagerOutreachComposeController', 'MW.ContactManager.ContactManagerOutreachListController', 'MW.ContactManager.ContactManagerOutreachViewController', 'MW.ContactManager.ContactManagerProfileController', 'MW.ContactManager.ContactManagerSourceProfileController', 'MW.ContactManager.ContactHistoryTableController', 'MW.ContactManager.MediaListController', 'MW.ContactManager.SearchTutorial', 'MW.ContactManager.MediaListEmptyState', 'MW.ContactManager.DeleteMediaList', 'MW.ContactManager.TemplateWarning', 'MW.ContactManager.ProtectEditedOutreach', 'MW.CoreStream.ComposeMedialists', 'MW.ContactManager.SelectionFactory', 'MW.Influencers.AlertController', 'MW.Framework.Breadcrumb', 'MW.Framework.CoreBreadcrumb', 'MW.Framework.CoreGrid', 'MW.Framework.CoreGridActionButtons', 'MW.Framework.CoreGridFilterBox', 'MW.Framework.CoreGridTable', 'MW.Framework.CoreStaticPageController', 'MW.Framework.CoreUserService', 'MW.Framework.Dialog', 'MW.Framework.GydaSwitch', 'MW.Framework.inputCancel', 'MW.Framework.FeatureToggleService', 'MW.Framework.PageStateService', 'MW.Framework.ScrollableDiv', 'MW.Framework.SearchBar', 'MW.Framework.SelectAccordion', 'MW.Framework.SettingsSummary', 'MW.Framework.SettingsTabBar', 'MW.Framwork.TranslateAttribute', 'MW.Framework.TranslateFilter', 'MW.Framework.TranslationService', 'MW.Framework.Translate', 'pascalprecht.translate', 'MW.Framework.UIFilters', 'MW.Framework.CsStickyHeader', 'MW.Framework.NotificationsModule', 'MW.Influencers.IcmDialogService', 'AuthTokenHttpInterceptor', 'MW.Framework.Editor.v4', 'MW.Framework.Editor.v5', 'MW.Influencers.SearchV2', 'MW.Influencers.SearchSwitcherController', 'MW.Influencers.ProfileSwitcherController', 'MW.Influencers.SourceSwitcherController', 'MW.Influencers.SearchEmptyState', 'MW.Influencers.IcmLanguageService', 'MW.Influencers.OutreachBannerService', 'MW.Influencers.SendgridService', 'MW.Influencers.IdentityService', 'MW.Configuration', 'MW.Influencers.ActionBarComponent', 'MW.Influencers.CloudwatchService']).constant('MW_STATE_TRACKING_ENABLED', true);
})();
'use strict';

(function () {
    'use strict';

    //Bootstrap the application AFTER loading translation files

    angular.element(document).ready(function () {
        window.deferredBootstrapper.bootstrap({
            element: document,
            module: 'icmWebApp',
            injectorModules: ['MW.Influencers.TranslationBootstrapService', 'MW.Configuration', 'MW.influencers.AuthTokenService'],
            resolve: {
                // IS_USER_LOGGED_IN: ['$q', 'AuthTokenService', '$window','LOGOUT_URL', function ($q, AuthTokenService, $window, LOGOUT_URL) {
                //     if (AuthTokenService.isTokenExpired()) {
                //         $window.location.href = LOGOUT_URL;
                //     }
                //
                //     return $q.when(true);
                // }],
                TRANSLATION_CONFIG: ['TranslationBootstrapService', 'ICM_ASSETS_URL', function (TranslationBootstrapService, ICM_ASSETS_URL) {
                    return TranslationBootstrapService.getUserTranslationData(ICM_ASSETS_URL);
                }]
            }
        });
    });

    angular.module('icmWebApp').config(['$locationProvider', '$routeProvider', '$httpProvider', 'tagsInputConfigProvider', 'ICM_ASSETS_URL', 'NEWSWIRE_WEB_URL', 'ATATUS_KEY', 'ENABLE_ATATUS', 'IRM_BASE_URL', function config($locationProvider, $routeProvider, $httpProvider, tagsInputConfigProvider, ICM_ASSETS_URL, NEWSWIRE_WEB_URL, ATATUS_KEY, ENABLE_ATATUS, IRM_BASE_URL) {
        $locationProvider.html5Mode(true);
        $.ajaxSetup({ cache: true });

        if (ENABLE_ATATUS === true && window.atatus) {
            window.atatus.config(ATATUS_KEY).install();
        }

        // moment was defaulting to zh-tw without this. unkown why.
        if (window.moment) {
            window.moment.locale('en');
        }

        $routeProvider.when('/outreach/compose/:distributionId?/:state?', {
            templateUrl: 'icm-web/views/outreach_compose',
            controller: 'ContactManagerOutreachComposeController',
            controllerAs: 'outreachComposeController',
            isChromeless: true,
            resolve: {
                setRecipientFromQueryString: ["$route", "InfluencerContactService", "ICMEmailService", function setRecipientFromQueryString($route, InfluencerContactService, ICMEmailService) {
                    var contactId = null;
                    var selectedEmail = null;
                    if ($route && $route.current && $route.current.params) {
                        if ($route.current.params.recipient) {
                            contactId = $route.current.params.recipient.split(' ');
                        } else if ($route.current.params.local) {
                            contactId = JSON.parse(sessionStorage.getItem('contactIds')) || '';
                            sessionStorage.removeItem('contactIds');
                        }
                        if ($route.current.params.email) {
                            selectedEmail = $route.current.params.email;
                        }
                    }
                    if (contactId) {
                        return InfluencerContactService.getContactsById(contactId).then(function (contact) {
                            if (selectedEmail) {
                                // verify the email from the url belongs to the contact
                                var contactSelectedEmail = contact[0].contactInfo.email.find(function (email) {
                                    return email.address === selectedEmail;
                                });
                                if (contactSelectedEmail) {
                                    contact[0].contactInfo.email = [contactSelectedEmail];
                                }
                            }
                            return ICMEmailService.setContactRecipients(contact);
                        }).finally(function () {
                            return;
                        });
                    } else {
                        return;
                    }
                }],
                editorLanguage: ["CoreUserService", function editorLanguage(CoreUserService) {
                    return CoreUserService.getCurrent(true).then(function (currentUser) {
                        return currentUser.language;
                    }).catch(function () {
                        return 'en';
                    });
                }],
                approvedSenderArray: ["ICMEmailService", function getApprovedSender(ICMEmailService) {
                    return ICMEmailService.getIcmApprovedSenders().then(function afterGetApprovedSender(approvedSenderArray) {
                        return approvedSenderArray || [];
                    }).catch(function () {
                        return 'error';
                    });
                }],
                sendgridDomainsArray: ["SendgridService", function getSendgridDomains(SendgridService) {
                    return SendgridService.getCompanyDomains().then(function (domains) {
                        return domains;
                    }).catch(function () {
                        return [];
                    });
                }],
                templatesList: ["EmailTemplateService", function getTemplates(EmailTemplateService) {
                    return EmailTemplateService.getAllTemplates().then(function (response) {
                        if (response && response.data && response.data.templates) {
                            return response.data.templates.map(function (template) {
                                return {
                                    id: template.id,
                                    title: template.name,
                                    body: template.body
                                };
                            });
                        } else {
                            return [];
                        }
                    }).catch(function () {
                        return [];
                    });
                }],
                dialogMode: ["$q", function dialogMode($q) {
                    return $q.when(false);
                }],
                loadEditorLibrary: ["ICM_ASSETS_URL", function loadEditorLibrary(ICM_ASSETS_URL) {
                    angular.element('.tinymceLib').remove();
                    var tiny5 = document.createElement('script');
                    tiny5.setAttribute('class', 'tinymceLib');
                    tiny5.setAttribute('src', ICM_ASSETS_URL + 'client/js/lib/tinymce_v5/tinymce_v5.min.js');
                    document.head.appendChild(tiny5);
                    return true;
                }],
                identity: ["ICMUserService", function identity(ICMUserService) {
                    return ICMUserService.getIdentity(false);
                }]
            },
            reloadOnSearch: false
        }).when('/influencers/lists', {
            templateUrl: 'icm-web/views/media_list',
            activeTab: 'contact_manager',
            controller: 'MediaListController',
            controllerAs: 'listController',
            hideFooter: true,
            reloadOnSearch: false,
            useActionBar: true,
            resolve: {
                emptyStateVisible: ["ContactManagerTagService", function emptyStateVisible(ContactManagerTagService) {
                    return new Promise(function (resolve) {
                        ContactManagerTagService.getAllTags(1, 1).then(function (res) {
                            resolve(res.count <= 0);
                        }).catch(function () {
                            resolve(true);
                        });
                    });
                }]
            }
        }).when('/influencers/contact-list/:listId?', {
            templateUrl: 'icm-web/views/contact_list_v2',
            activeTab: 'contact_manager',
            controller: 'ListViewController',
            controllerAs: 'listController',
            hideFooter: true,
            reloadOnSearch: false,
            useActionBar: true
        }).when('/influencers/contact/landing', {
            templateUrl: 'icm-web/views/contact_landing',
            activeTab: 'contact_manager',
            controller: 'ContactLandingController',
            controllerAs: 'landingController',
            hideFooter: true,
            useActionBar: true,
            resolve: {
                isInfluencerDatabaseEntitled: ["EntitlementService", function getEntitlement(EntitlementService) {
                    return EntitlementService.getIcmCountriesEntitlement().then(function afterGetIcmCountriesEntitlement(countriesList) {
                        return countriesList && countriesList.length > 0 ? true : false;
                    });
                }]
            }
        }).when('/influencers/contact/create', {
            templateUrl: 'icm-web/views/contact_form',
            activeTab: 'contact_manager',
            controller: 'ContactManagerFormController',
            controllerAs: 'formController',
            hideFooter: true,
            resolve: {
                breadcrumbs: ["Breadcrumb", function breadcrumbs(Breadcrumb) {
                    return Breadcrumb.build([{ name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists' }, { name: 'Add Contacts', link: '/influencers/contact/landing' }, { name: 'Create New Contact', link: '/influencers/contact/create' }]);
                }],
                contact: ["Contact", function contact(Contact) {
                    return new Contact();
                }]
            }
        }).when('/influencers/contact/edit/:contactId', {
            templateUrl: 'icm-web/views/contact_form',
            activeTab: 'contact_manager',
            controller: 'ContactManagerFormController',
            controllerAs: 'formController',
            hideFooter: true,
            resolve: {
                breadcrumbs: ["Breadcrumb", "$route", function breadcrumbs(Breadcrumb, $route) {
                    var contactId = $route.current.params.contactId;

                    return Breadcrumb.build([{ name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists' }, { name: 'Edit Contact', link: '/influencers/contact/edit/' + contactId }]);
                }],
                contact: ["$q", "InfluencerContactService", "$route", function contact($q, InfluencerContactService, $route) {
                    var defer = $q.defer(),
                        contactId = $route.current.params.contactId;

                    InfluencerContactService.getCurrentContact(contactId).then(function (contact) {
                        defer.resolve(contact);
                    });

                    return defer.promise;
                }]
            }
        }).when('/influencers/contact/view/:contactId', {
            templateUrl: 'icm-web/views/search_loading',
            activeTab: 'contact_manager',
            controller: 'ProfileSwitcherController',
            hideFooter: true
        }).when('/influencers/contact/v1/:contactId', {
            templateUrl: 'icm-web/views/search_loading',
            activeTab: 'contact_manager',
            controller: 'ProfileSwitcherController',
            hideFooter: true
        }).when('/influencers/contact/showmore/:contactId/:typeVal', {
            templateUrl: 'icm-web/views/partials/contact_historytable_fullview',
            activeTab: 'contact_manager',
            controller: 'ContactHistoryTableController',
            controllerAs: 'historyTableController',
            hideFooter: true,
            resolve: {
                breadcrumbs: ["Breadcrumb", "$route", function breadcrumbs(Breadcrumb, $route) {
                    var contactId = $route.current.params.contactId;
                    return Breadcrumb.build([{ name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists' }, { name: 'Profile', link: '/influencers/contact/view/' + contactId }, { name: 'Contact History' }]);
                }]
            }
        }).when('/influencers/contact/import', {
            templateUrl: 'icm-web/views/contact_import',
            activeTab: 'contact_manager',
            controller: 'ContactManagerImportController',
            controllerAs: 'importController',
            hideFooter: true,
            resolve: {
                breadcrumbs: ["Breadcrumb", function breadcrumbs(Breadcrumb) {
                    return Breadcrumb.build([{ name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists' }, { name: 'Add Contacts', link: '/influencers/contact/landing' }, { name: 'Import Contacts', link: '/influencers/contact/import' }]);
                }],
                companyId: ["CoreCompanyService", function companyId(CoreCompanyService) {
                    return CoreCompanyService.getCurrent(true).then(function (response) {
                        return response._id;
                    });
                }],
                readyTranslations: ["$translate", function readyTranslations($translate) {
                    return $translate.onReady();
                }]
            }
        }).when('/influencers/source/view/:sourceId', {
            templateUrl: 'icm-web/views/search_loading',
            activeTab: 'contact_manager',
            controller: 'SourceSwitcherController',
            hideFooter: true
        }).when('/influencers/contact/influencerdatabase', {
            templateUrl: 'icm-web/views/influencer_database_upsell',
            activeTab: 'contact_manager',
            controller: 'ContactManagerInfluencerDatabaseUpsellController',
            controllerAs: 'influencerDatabaseUpsellController',
            hideFooter: true,
            resolve: {
                isInfluencerAppEntitled: ["EntitlementService", function getEntitlement(EntitlementService) {
                    return EntitlementService.getInfluencerAppEntitlement().then(function getEntitlement(entitlement) {
                        return !!entitlement;
                    });
                }]
            }
        }).when('/influencers/contact/outreach', {
            templateUrl: 'icm-web/views/outreach_list',
            activeTab: 'contact_manager',
            controller: 'ContactManagerOutreachListController',
            controllerAs: 'outreachListController',
            useActionBar: true,
            hideFooter: true,
            useMaterial: true,
            reloadOnSearch: false,
            resolve: {
                breadcrumbs: ["Breadcrumb", function breadcrumbs(Breadcrumb) {
                    return Breadcrumb.build([{ name: 'Outreach', link: '/influencers/contact/outreach/' }]);
                }],
                translationsReady: ["$timeout", "$q", "translationService", function translationsReady($timeout, $q, translationService) {
                    var translationDeferred = $q.defer();
                    var timeoutPromise = $timeout(function () {
                        translationDeferred.resolve();
                    }, 500);

                    translationService.waitForTranslations().then(function () {
                        $timeout.cancel(timeoutPromise);
                        translationDeferred.resolve();
                    });
                    return translationDeferred.promise;
                }],
                identity: ["ICMUserService", function identity(ICMUserService) {
                    return ICMUserService.getIdentity(false);
                }]
            }
        }).when('/email_layout/icm_enquiry', {
            templateUrl: 'icm-web/views/html_icm_enquiry_email_view',
            activeTab: 'contact_manager',
            controller: 'ContactManagerIcmEnquiryController',
            controllerAs: 'icmEnquiryController',
            reloadOnSearch: false,
            hideNavigation: true,
            hideSubTabs: true
        }).when('/influencers/contact/outreach/:sentEmailDistributionId', {
            templateUrl: 'icm-web/views/outreach_stats',
            activeTab: 'contact_manager',
            controller: 'ContactManagerOutreachViewController',
            controllerAs: 'outreachViewController',
            isChromeless: true,
            reloadOnSearch: false,
            hideSubTabs: true,
            resolve: {
                emailId: ["$route", function emailId($route) {
                    return $route.current.params.sentEmailDistributionId;
                }],
                readyTranslations: ["translationService", function readyTranslations(translationService) {
                    return translationService.waitForTranslations();
                }],
                approvedSenders: ["ICMEmailService", function approvedSenders(ICMEmailService) {
                    return ICMEmailService.getIcmApprovedSenders();
                }]
            }
        }).when('/newswire/organizationApprove/:companyId/:uniqueKey/:organizationId', {
            activeTab: 'contact_manager',
            reloadOnSearch: false,
            resolve: {}
        }).when('/newswire/landing/:distributionId?/:action?/:createDistributionModal?/:step?', {
            activeTab: 'contact_manager',
            useActionBar: true,
            reloadOnSearch: false,
            resolve: {
                function: function _function() {
                    window.location.replace(NEWSWIRE_WEB_URL + '/newswire/landing');
                }
            }
        }).when('/influencers/search', {
            templateUrl: 'icm-web/views/search_loading',
            activeTab: 'contact_manager',
            controller: 'SearchSwitcherController',
            hideFooter: true
        }).when('/influencers/search/v1', {
            templateUrl: 'icm-web/views/search_loading',
            activeTab: 'contact_manager',
            controller: 'SearchSwitcherController',
            hideFooter: true
        }).when('/influencers/search/v2', {
            templateUrl: 'icm-web/views/searchV2',
            activeTab: 'contact_manager',
            controller: 'SearchControllerV2',
            controllerAs: 'searchController',
            hideFooter: true,
            reloadOnSearch: false,
            customContainerClass: 'search',
            resolve: {
                readyTranslations: ["$translate", function readyTranslations($translate) {
                    return $translate.onReady();
                }],
                countryMapping: ["$http", function countryMapping($http) {
                    return $http.get(ICM_ASSETS_URL + 'js/countryMapping.json');
                }],
                companyServiceResolved: ["CoreCompanyService", function companyServiceResolved(CoreCompanyService) {
                    return CoreCompanyService.getCurrent(true);
                }],
                userServiceResolved: ["CoreUserService", function userServiceResolved(CoreUserService) {
                    return CoreUserService.getCurrent(true);
                }],
                allContactsCount: ["ContactManagerTagService", function allContactsCount(ContactManagerTagService) {
                    return ContactManagerTagService.getAllContacts({ page: 0, pageSize: 1 }).then(function (response) {
                        return response.count;
                    })
                    // we need to gracefully handle the error scenario, or this route will not load.
                    .catch(function () {
                        return -1;
                    });
                }]
            }
        }).otherwise({
            redirectTo: function redirectTo() {
                window.location.href = IRM_BASE_URL;
            }
        });

        $httpProvider.interceptors.push('AuthTokenHttpInterceptor');

        // set our app's defaults for ngTagsInput, can be overriden inline when using the directive
        tagsInputConfigProvider.setDefaults('tagsInput', {
            removeTagSymbol: '',
            customClass: 'keywordTags',
            placeholder: '',
            minLength: 2,
            addOnEnter: true,
            addOnSpace: false,
            addOnComma: false,
            addOnBlur: true,
            allowedTagsPattern: new RegExp('.*'),
            enableEditingLastTag: false,
            replaceSpacesWithDashes: false,
            immediatelyDeleteOnBackspace: true,
            shouldStripChars: false
        });
    }])
    // register angular material themes
    .config(['$mdThemingProvider', function ($mdThemingProvider) {
        $mdThemingProvider.theme('expansion-panel');
    }]).factory('$exceptionHandler', ['$log', '$window', 'ENABLE_ATATUS', function ($log, $window, ENABLE_ATATUS) {
        return function customExceptionHandler(exception, cause) {
            if (ENABLE_ATATUS === true && $window.atatus) {
                $window.atatus.notify(exception);
            }

            // continue calling log.error, which will output to console
            $log.error(exception, cause);
        };
    }]).config(['$translateProvider', 'TRANSLATION_CONFIG', 'ICM_ASSETS_URL', function ($translateProvider, TRANSLATION_CONFIG, ICM_ASSETS_URL) {
        $translateProvider.translations(TRANSLATION_CONFIG.$locale, TRANSLATION_CONFIG.$translationList).fallbackLanguage('en').preferredLanguage(TRANSLATION_CONFIG.$locale).useSanitizeValueStrategy('escape').statefulFilter(false).useStaticFilesLoader({
            prefix: ICM_ASSETS_URL + 'translations/',
            suffix: '.json?format=flat'
        });
    }]).config(['$mdIconProvider', function ($mdIconProvider) {
        $mdIconProvider.iconSet('icm:influencer-lady', 'https://assets.meltwater.io/icm-web-assets/static/img/influencers.svg');
    }]).run(['$rootScope', 'NotificationsService', 'ICMUserService', 'CoreUserService', 'CoreCompanyService', 'ContactManagerNavigationService', 'EntitlementService', 'ICM_WEB_PROXY_PREFIX', 'PageStateService', '$location', 'DialogService', '$translate', 'AWS_ENV', 'translationService', 'TRANSLATION_CONFIG', 'ActionBarService', 'IdentityService', function ($rootScope, NotificationsService, ICMUserService, CoreUserService, CoreCompanyService, ContactManagerNavigationService, EntitlementService, ICM_WEB_PROXY_PREFIX, PageStateService, $location, DialogService, $translate, AWS_ENV, translationService, TRANSLATION_CONFIG, ActionBarService) {
        var notificationPromises = [];
        var featureBranch = null;
        var isEntitled = true;

        notificationPromises.push(CoreUserService.getCurrent(true));
        notificationPromises.push(CoreCompanyService.getCurrent(true));

        Promise.all(notificationPromises).then(function (results) {
            NotificationsService.init({
                user: results[0],
                company: results[1]
            });
        });

        $rootScope.$on('userUpdateFromNotificationRequired', function (event, args) {
            ICMUserService.updateUser(args.userId, args.settings).then(function () {
                if (args.requiresUserConfirmation) {
                    DialogService.flashSuccess($translate.instant('Settings saved successfully'));
                }
            }).catch(function () {
                if (args.requiresUserConfirmation) {
                    DialogService.flashError($translate.instant('We were unable to update this user.'));
                }
            });
        });

        if (window.AppChrome && window.AppChrome.ready === true) {
            if (window.appContainerPlaceholder) {
                window.appContainerPlaceholder.remove();
            }
        } else {
            window.addEventListener('app-chrome-ready', function () {
                if (window.appContainerPlaceholder) {
                    window.appContainerPlaceholder.remove();
                }
            });
        }

        window.addEventListener('app-chrome-location-change-internal-app', function (event) {
            // This event will fire any time navigation is triggered. It can be canceled to prevent that
            // navigation. Note that you will be responsible for updating the navigation when you navigate. You can do that by
            // calling window.AppChrome.updateActivePage() when navigation occurs.
            event.preventDefault();

            // We need to remove the base path defined in index, otherwise it tries to double up
            var withoutBase = event.detail.location.replace('/icm-web/', '');

            // We also need to look for any query params, it cannot be set on the path using $location, thanks angular
            var qIndex = withoutBase.indexOf('?');
            if (qIndex > -1) {
                // There is a query parameter
                // So remove it
                withoutBase = withoutBase.slice(0, qIndex);

                // Here, I don't bother adding the query parameter back on because it is
                // automatically handled by some other bits of the router

                // It is also important to note that when changing the path using `$location.path()`
                // that the query parameter will not change. So the ?locker=blah will stick around
                // unless we do a $location.search(''), to put it back to an empty string
                // This is all because the angular $location is not the same as native location
            }

            $location.path(withoutBase);
            $rootScope.$apply();
        });

        translationService.setLanguage(TRANSLATION_CONFIG.$locale);
        translationService.registerDictionary(TRANSLATION_CONFIG.$translationList);

        ContactManagerNavigationService.resetIcmLocationHistory();
        $rootScope.$on('$locationChangeSuccess', function (event, current, previous) {
            // This triggers the header and navigation to update the active navigation item as you navigate through your app.
            window.AppChrome.updateActivePage();
            if (previous && current !== previous) {
                ContactManagerNavigationService.setPreviousLocation(previous, ICM_WEB_PROXY_PREFIX + (AWS_ENV ? '/awsEnv/' + AWS_ENV : ''));
            }
        });

        EntitlementService.getInfluencerAppEntitlement().then(function (isICMAppEntitled) {
            isEntitled = isICMAppEntitled === true;
            if (isICMAppEntitled !== true && $location.url().indexOf('/contact/influencerdatabase') === -1) {
                $location.url('/influencers/contact/influencerdatabase');
            }
        });

        $rootScope.$on('$routeChangeStart', function (event, next) {
            if (next && next.$$route && next.$$route.templateUrl) {
                switch (next.$$route.templateUrl) {
                    case 'icm-web/views/outreach_compose':
                        $('body').append('<mw-loader id="loadingState" class="ng-isolate-scope">\n                                                <div class="mw-loader">\n                                                    <div class="mw-loader__drop"></div>\n                                                    <div class="mw-loader__circle1"></div>\n                                                    <div class="mw-loader__circle2"></div>\n                                                </div>\n                                            </mw-loader>');
                        $('.OutreachListPage').remove();
                        $('.contactManagerApp').remove();
                }
            }
        });

        $rootScope.$on('$locationChangeStart', function (event, current) {
            try {
                var dialog = document.querySelector('icm-manage-lists-dialog');
                var alertDialog = document.querySelector('manage-list-limit-warning');
                var miniDialog = document.querySelector('icm-mini-profile-header').shadowRoot.querySelector('icm-manage-lists-dialog');

                dialog ? dialog.close() : ''; // jshint ignore:line
                alertDialog ? alertDialog.close() : ''; // jshint ignore:line
                miniDialog ? miniDialog.close() : ''; // jshint ignore:line
            } catch (e) {
                console.error(e); // jshint ignore:line
            }

            if (window.tinymce && current.indexOf('?createDistributionModal=true') === -1) {
                delete window.tinymce;
                angular.element('.tinymceLib').remove();
            }

            if (featureBranch && !$location.search().branch) {
                $location.search('branch', featureBranch);
            }

            if (!isEntitled) {
                $location.url('/influencers/contact/influencerdatabase');
            }
        });

        $rootScope.$on('$routeChangeError', function (evt, current, previous) {
            ActionBarService.resetState();
            $('mw-loader').remove('#loadingState');

            if (previous && previous.$$route && previous.$$route.originalPath) {
                $location.url(previous.$$route.originalPath);
            } else {
                $location.url('/');
            }
        });

        $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
            $('mw-loader').remove('#loadingState');
            ActionBarService.resetState();

            if (current.$$route && previous && previous.$$route && current.$$route.originalPath.split('?')[0] !== previous.$$route.originalPath.split('?')[0] && window.AppChrome) {
                window.AppChrome.scrollToContentTop();
            }
        });

        if ($location.search() && $location.search().locker) {
            PageStateService.setLockerId('contactListPage', $location.search().locker);
        }

        if ($location.search() && $location.search().branch) {
            featureBranch = $location.search().branch;
        }
    }]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var AccountEngagementWidget = function () {
        function AccountEngagementWidget($window) {
            _classCallCheck(this, AccountEngagementWidget);

            this.$window = $window;
        }

        _createClass(AccountEngagementWidget, [{
            key: 'gotoEmailEngagementHelp',
            value: function gotoEmailEngagementHelp() {
                this.$window.open('https://help.meltwater.com/en/articles/4064606-how-to-improve-low-engagement-rates-for-releases');
            }
        }]);

        return AccountEngagementWidget;
    }();

    angular.module('MW.Influencers.AccountEngagementWidget', []).component('mwAccountEngagementWidget', {
        bindings: {
            distributionCount: '<',
            openRate: '<',
            clickToOpenRate: '<',
            unsubscribedRate: '<'
        },
        controller: ['$window', AccountEngagementWidget],
        template: '\n                <md-card>\n                    <md-card-title>\n                        <span translate>\n                            mw-outreach-collection__engagement-widget-title\n                        </span>\n                        <md-icon class="mw-helpcenter" md-svg-icon="action:ic_info_24px" aria-label="info" ng-click="$ctrl.gotoEmailEngagementHelp()" hide-xs />\n                    </md-card-title>\n                    <md-card-content layout="row" layout-align="space-around">\n                        <div class="stat-card" layout="column">\n                            <span class="stat-value">\n                                {{$ctrl.distributionCount}}\n                            </span>\n                            <span translate class="stat-label">\n                                mw-outreach-collection__header-title\n                            </span>\n                        </div>\n                        <span class="stat-divider"></span>\n                        <div class="stat-card" layout="column">\n                            <span class="stat-value">\n                                {{$ctrl.openRate}}\n                            </span>\n                            <span translate class="stat-label">\n                                mw-outreach-collection__engagement-widget-open-rate\n                            </span>\n                        </div>\n                        <span class="stat-divider"></span>\n                        <div class="stat-card" layout="column">\n                            <span class="stat-value">\n                                {{$ctrl.clickToOpenRate}}\n                            </span>\n                            <span translate class="stat-label">\n                                mw-outreach-collection__engagement-widget-click-rate\n                            </span>\n                        </div>\n                        <span class="stat-divider"></span>\n                        <div class="stat-card" layout="column">\n                            <span class="stat-value">\n                                {{$ctrl.unsubscribedRate}}\n                            </span>\n                            <span translate class="stat-label">\n                                mw-outreach-collection__engagement-widget-unsubscribe-rate\n                            </span>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            '
    });
})(angular);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var ActionBarComponent = function () {
        function ActionBarComponent($mdMenu, $rootScope, ContactManagerNavigationService) {
            _classCallCheck(this, ActionBarComponent);

            this.$mdMenu = $mdMenu;
            this.ContactManagerNavigationService = ContactManagerNavigationService;

            $rootScope.$on('$locationChangeStart', function () {
                $mdMenu.hide();
            });
        }

        _createClass(ActionBarComponent, [{
            key: 'actionClicked',
            value: function actionClicked(ev, action) {
                this.$mdMenu.hide();

                // well. we hit an action that was not a link to another page (see comment below)
                // since we did not reload the page, this code removes all our actions, and they dont get reloaded
                if (!action.doNotDisableActions) {
                    // this will fix actions bleeding between pages,
                    // but if the action is not a link to another page
                    // then this will need to be changed
                    for (var i = 0; i < this.actions.length; i++) {
                        this.actions[i].enabled = false;
                    }
                }

                if (action.onClick) {
                    action.onClick();
                }
            }
        }, {
            key: 'buttonClicked',
            value: function buttonClicked(action) {
                if (!action.doNotDisableActions) {
                    // this will fix actions bleeding between pages,
                    // but if the action is not a link to another page
                    // then this will need to be changed
                    for (var i = 0; i < this.actions.length; i++) {
                        this.actions[i].enabled = false;
                    }
                }

                if (action.onClick) {
                    action.onClick();
                }
            }
        }, {
            key: 'goBack',
            value: function goBack() {
                this.ContactManagerNavigationService.smartBackAction();
            }
        }]);

        return ActionBarComponent;
    }();

    angular.module('MW.Influencers.ActionBarComponent', ['ngMaterial', 'mwAppComponents', 'MW.ContactManager.ContactManagerNavigationService']).component('actionBarComponent', {
        bindings: {
            actions: '<',
            pageTitle: '<',
            isVisible: '<',
            isBackButtonVisible: '<'
        },
        controller: ['$mdMenu', '$rootScope', 'ContactManagerNavigationService', ActionBarComponent],
        template: '\n        <div layout="column" layout-fill ng-if="$ctrl.isVisible">\n            <mw-toolbar>\n                <mw-icon-button ng-if="$ctrl.isBackButtonVisible" ng-click="$ctrl.goBack()" svg-icon="navigation:ic_arrow_back_24px" hover="true"></mw-icon-button>\n                <mw-toolbar-separator ng-if="$ctrl.isBackButtonVisible"></mw-toolbar-separator>\n                <mw-toolbar-title flex class="md-truncate" ng-if="$ctrl.pageTitle">\n                    {{$ctrl.pageTitle}}\n                </mw-toolbar-title>\n                <div flex></div>\n                <md-menu class="mw-menu" md-position-mode="target-left target" md-offset="0 50" ng-if="$ctrl.actions.length > 1">\n                    <mw-menu-trigger-button class="mw-menu-trigger-button--accent" tooltip="{{\'Open Menu\' | translate}}" on-click="$mdMenu.open($event)" icon-size="normal">\n                        {{\'ACTIONS\' | translate}}\n                    </mw-menu-trigger-button>\n                    <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">\n                        <div ng-repeat="action in $ctrl.actions" ng-if="action.tutorialId" data-tutorial-id="{{::action.tutorialId}}" title="{{::action.label}}">\n                            <mw-menu-item ng-if="action.enabled" icon="{{::action.icon}}" aria-label="{{::action.label}}" on-click="$ctrl.actionClicked($event, action)">{{::action.label}}</mw-menu-item>\n                        </div>\n                        <div ng-repeat="action in $ctrl.actions" ng-if="!action.tutorialId" title="{{::action.label}}">\n                            <mw-menu-item ng-if="action.enabled" icon="{{::action.icon}}" aria-label="{{::action.label}}" on-click="$ctrl.actionClicked($event, action)">{{::action.label}}</mw-menu-item>\n                        </div>\n                    </md-menu-content>\n                </md-menu>\n                <md-button ng-if="$ctrl.actions.length === 1 && !$ctrl.actions[0].optInToggle" class="mw-button mw-button--accent md-primary md-raised md-accent action-bar-button" aria-label="{{::$ctrl.actions[0].label}}" ng-click="$ctrl.buttonClicked($ctrl.actions[0])" disabled="disabled" data-tutorial-id="{{$ctrl.actions[0].tutorialId}}">{{::$ctrl.actions[0].label}}</md-button>\n                <md-button ng-if="$ctrl.actions.length === 1 && $ctrl.actions[0].optInToggle" class="opt-in-out-button mw-button" aria-label="{{::$ctrl.actions[0].label}}" ng-click="$ctrl.actions[0].onClick($event)" data-tutorial-id="{{$ctrl.actions[0].tutorialId}}">{{::$ctrl.actions[0].label}}</md-button>\n            </mw-toolbar>\n        </div>\n        '
    });
})(window.angular);
"use strict";
'use strict';

(function () {
    'use strict';

    function MwActivityModal($translate, ActivityService) {
        var _this = this;

        this.$translate = $translate;
        this.ActivityService = ActivityService;
        this.shouldValidateForm = false;
        if (this.createdString) {
            this.dialogTitle = this.$translate.instant('icm-web__contact-profile--activity-title-edit');
        } else {
            this.dialogTitle = this.$translate.instant('icm-web__contact-profile--activity-title-create');
        }
        this.activityTypeTitle = 'icm-web__contact-profile--activity-type-title';
        this.subjectLabelText = 'icm-web__contact-profile--activity-subject-label';
        this.noteLabelText = 'icm-web__contact-profile--activity-note-label';
        this.dateLabelText = 'icm-web__contact-profile--activity-date-label';
        this.okButtonText = this.$translate.instant('Save');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.errorMessages = {
            errorBanner: 'icm-web__contact-profile--activity-error',
            typeRequired: 'icm-web__contact_profile--activity-type-required-error',
            bodyRequired: 'icm-web__contact-profile--activity-note-body-error',
            dateRequired: 'icm-web__contact_profile--activity-date-required-error',
            maxLengthError: 'icm-web__contact_profile--activity-max-length-error'
        };

        this.dateConfig = {
            formInputName: 'date',
            locale: 'en',
            minView: 'month',
            maxView: 'month',
            label: 'Date',
            format: 'L',
            changeDate: function changeDate($event) {
                _this.date = $event.date;
            },
            timezone: 'UTC' // this does not matter since we are not using time, just date. but we need it set or we see errors loading the component
        };

        this.activityTypes = this.ActivityService.getActivityTypes();

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (!this.activityForm.$valid) {
                this.shouldValidateForm = true;
            } else {
                this.shouldValidateForm = false;
                this.okCallback({ selectedType: this.selectedType, subject: this.subject, body: this.body, date: this.date });
            }
        };
    }

    angular.module('MW.ContactManager.MwActivityModal', ['MW.Influencers.ActivityService']).component('mwActivityModal', {
        bindings: {
            cancelCallback: '&',
            okCallback: '&',
            selectedType: '<',
            subject: '<',
            body: '<',
            date: '<',
            createdString: '<',
            updatedString: '<'
        },
        controller: ['$translate', 'ActivityService', MwActivityModal],
        template: '\n                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">\n                    <mw-modal-alert-message layout="column" ng-if="$ctrl.shouldValidateForm">\n                        <div ng-if="$ctrl.shouldValidateForm" translate>{{$ctrl.errorMessages.errorBanner}}</div>\n                    </mw-modal-alert-message>\n                    <mw-modal-content>\n                        <ng-form name="$ctrl.activityForm">\n                            <div layout="column">\n                                <md-input-container class="activity-type" md-is-error="$ctrl.shouldValidateForm && !$ctrl.selectedType">\n                                    <label translate>{{$ctrl.activityTypeTitle}}</label>\n                                    <md-select required="" ng-model="$ctrl.selectedType" md-no-ink>\n                                        <md-option ng-repeat="activityType in $ctrl.activityTypes" value="{{activityType.value}}">{{activityType.display}}</md-option>\n                                    </md-select>\n                                    <!-- very strange issue when combining a md-select with the name attribute + a textarea in a modal. see GYDA-37827 -->\n                                    <div class="md-input-messages-animation" ng-if="$ctrl.shouldValidateForm && !$ctrl.selectedType">\n                                        <div class="md-input-message-animation" translate>{{$ctrl.errorMessages.typeRequired}}</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class="activity-subject" md-is-error="$ctrl.activityForm.subject.$invalid">\n                                    <label translate>{{$ctrl.subjectLabelText}}</label>\n                                    <input name="subject" ng-model="$ctrl.subject" md-maxlength="240"/>\n                                    <div ng-messages="$ctrl.activityForm.subject.$error">\n                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.maxLengthError}}</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class="activity-body" md-is-error="$ctrl.activityForm.body.$error[\'md-maxlength\'] || ($ctrl.shouldValidateForm && $ctrl.activityForm.body.$invalid)">\n                                    <label translate>{{$ctrl.noteLabelText}}</label>\n                                    <textarea required="" name="body" ng-model="$ctrl.body" md-maxlength="10000" rows="3" md-select-on-focus=""></textarea>\n                                    <div ng-messages="$ctrl.activityForm.body.$error">\n                                        <div ng-message="required" translate>{{$ctrl.errorMessages.bodyRequired}}</div>\n                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.maxLengthError}}</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class="activity-date" md-is-error="$ctrl.shouldValidateForm && $ctrl.activityForm.date.$invalid">\n                                    <label translate>{{$ctrl.dateLabelText}}</label>\n                                    <mw-date-picker-dropdown\n                                        form-input-name="$ctrl.dateConfig.formInputName"\n                                        is-required="true"\n                                        date="$ctrl.date"\n                                        locale="$ctrl.dateConfig.locale"\n                                        min-view="$ctrl.dateConfig.minView"\n                                        max-view="$ctrl.dateConfig.maxView"\n                                        format="$ctrl.dateConfig.format"\n                                        timezone="$ctrl.dateConfig.timezone"\n                                        on-date-selection="$ctrl.dateConfig.changeDate($event)"\n                                    > </mw-date-picker-dropdown>\n                                    <div ng-messages="$ctrl.activityForm.date.$error">\n                                        <div ng-message="required" translate>{{$ctrl.errorMessages.dateRequired}}</div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n                        </ng-form>\n                        <div class="activity-timestamps" ng-if="$ctrl.createdString" layout="column">\n                            <span class="created-at">{{$ctrl.createdString}}</span>\n                            <span class="updated-at" ng-if="$ctrl.updatedString">{{$ctrl.updatedString}}</span>\n                        </div>\n                    </mw-modal-content>\n                </mw-mini-modal-dialog>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    function MwBeatsHeaderController($scope, $element) {
        this.clickedBeat = function clickedBeat(beat, indexOfBeat) {
            this.beats.splice(indexOfBeat, 1);

            this.selectedBeat({ beat: beat });
        };

        this.dismiss = function dismiss() {
            $element.hide();
        };
    }

    angular.module('MW.ContactManager.MwBeatsHeader', []).component('mwBeatsHeader', {
        bindings: {
            beats: '<',
            selectedBeat: '&'
        },
        controller: ['$scope', '$element', MwBeatsHeaderController],
        template: '\n                <div ng-if="$ctrl.beats.length" class="wrapper" layout="row" layout-align="space-between center">\n                    <md-icon class="help-icon" md-svg-icon="action:ic_help_24px"></md-icon>\n                    <div class="help-text">\n                        <span translate>icm-search__did-you-mean--beats-message</span>\n                        <span class="beat-name" ng-repeat="$item in $ctrl.beats" ng-click="$ctrl.clickedBeat($item, $index)">{{$item.display}}</span>\n                    </div>\n                    <md-icon class="dismiss-icon" ng-click="$ctrl.dismiss()" md-svg-icon="content:ic_clear_24px"></md-icon>\n                </div>\n            '
    });
})();
'use strict';

(function (angular) {
    'use strict';

    function CardButtonController() {}

    angular.module('MW.Influencers.CardButton', []).component('mwCardButton', {
        bindings: {
            title: '<',
            imageClass: '@',
            text: '<'
        },
        controller: [CardButtonController],
        template: '\n                <md-card class=\'card-button\'>\n                    <md-card-title class=\'card-title\'>\n                        {{$ctrl.title}}\n                    </md-card-title>\n                    <md-card-content>\n                        <div flex layout=\'row\' layout-align=\'center center\' class=\'card-image-container\'>\n                            <div class=\'{{$ctrl.imageClass}}\'></div>\n                        </div>\n                        <div class=\'text-content\'>{{$ctrl.text}}</div>\n                    </md-card-content>\n                </md-card>\n            '
    });
})(angular);
'use strict';

(function () {
    'use strict';

    ContactCardController.$inject = ["$scope", "$translate", "translationService", "MiniProfileService", "IRM_BASE_URL"];
    angular.module('MW.Influencers.ContactCard', ['MW.Framework.TranslationService', 'ngMaterial', 'mwAppComponents', 'MW.Influecners.UnsubscribeBadge', 'MW.Influencers.MiniProfileService']).directive('contactCard', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/contact_card/contact_card',
            scope: {
                contact: '=',
                onClickBody: '&?',
                showRelevantArticles: '&?',
                relevantArticleCount: '@?',
                showMediaList: '@?',
                icmBaseUrl: '@?'
            },
            link: function link(scope, element) {
                // if we have a icmBaseUrl that means we are navigating between apps, need to set the target
                if (scope.icmBaseUrl) {
                    element.find('.contactLink, .sourceLink').attr('target', '_self');
                }
            },
            controller: ContactCardController,
            controllerAs: 'contactCardController'
        };
    }).controller('contactCardController', ['$scope', '$translate', 'translationService', 'MiniProfileService', ContactCardController]);

    function ContactCardController($scope, $translate, translationService, MiniProfileService, IRM_BASE_URL) {
        this.$translate = $translate;
        var baseUrl = $scope.icmBaseUrl ? $scope.icmBaseUrl + '/' : '';

        this.contactUrl = IRM_BASE_URL + '/contact/' + $scope.contact.id;
        if ($scope.contact.automated) {
            this.contactUrl += '?automated=true';
        }

        $scope.$on('$locationChangeStart', function () {
            MiniProfileService.closeMiniProfile();
            MiniProfileService.closeMiniProfileBanner();
        });

        this.sourceBaseUrl = baseUrl + 'influencers/source/view';
        this.mediaListBaseUrl = baseUrl + 'influencers/contact-list';

        this.translationService = translationService;
        this.relevantArticle = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Article', { ArticleCount: $scope.relevantArticleCount });
        this.relevantArticles = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Articles', { ArticleCount: $scope.relevantArticleCount });
        this.mediaListLabel = this.$translate.instant('icm-contactlist__contact-card--media-lists-label');
        this.showMediaList = $scope.showMediaList ? true : false;
        this.hasFacebook = this.hasTwitter = this.hasLinkedIn = false;
        this.facebookUrl = this.twitterUrl = this.linkedinUrl = '';
        $scope.contact.channels.filter(function (obj) {
            if (obj.type.toLowerCase() === 'facebook') {
                this.hasFacebook = true;
                this.facebookUrl = obj.url;
            } else if (obj.type.toLowerCase() === 'twitter') {
                this.hasTwitter = true;
                this.twitterUrl = obj.url;
            } else if (obj.type.toLowerCase() === 'linkedin') {
                this.hasLinkedIn = true;
                this.linkedinUrl = obj.url;
            } else if (obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'facebook') {
                this.hasFacebook = true;
                this.facebookUrl = obj.socialProfile.url;
            } else if (obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'twitter') {
                this.hasTwitter = true;
                this.twitterUrl = obj.socialProfile.url;
            } else if (obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'linked_in') {
                this.hasLinkedIn = true;
                this.linkedinUrl = obj.socialProfile.url;
            }
        }.bind(this));
        this.hasSocial = this.hasFacebook || this.hasTwitter || this.hasLinkedIn;

        // Can be removed after old search pages is removed
        this.getCountry = function getCountry(contactInfo) {
            var address;
            if (contactInfo && contactInfo.address) {
                address = contactInfo.address[0];
                if (address && address.country) {
                    return address.country;
                }
            }
            return null;
        };
        this.country = $scope.contact.contactInfo.address[0].countryName ? $scope.contact.contactInfo.address[0].countryName : this.getCountry($scope.contact.contactInfo);
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.DateTimePicker', ['ngSanitize', 'MW.Framework.TranslationService', 'MW.Framework.CoreUserService', 'MW.Framework.TimeOptionsService', 'MW.Framework.SingleSelectDropdownMenu']).directive('dateTimePicker', ['$document', 'translationService', 'TimeOptionsService', function ($document, translationService, TimeOptionsService) {
        return {
            templateUrl: 'icm-web/views/partials/date_time_picker',
            restrict: 'E',
            scope: {
                selectedDate: '=',
                dateTimeFormat: '=',
                singleDatePickerCallBack: '&',
                selectedTime: '=?',
                showTimePicker: '=?',
                disableSelectDateDropdown: '=?',
                timezone: '=?'
            },
            link: function link(scope, element) {
                scope.datepickerVisible = typeof scope.disableSelectDateDropdown === 'boolean' ? !scope.disableSelectDateDropdown : false;
                scope.disableSelectDateDropdown = scope.disableSelectDateDropdown || false;
                scope.datePickerElement = angular.element('.datepickerVisible');
                scope.placeholderText = translationService.getLocalizedString('Choose Date');

                if (!scope.disableSelectDateDropdown) {

                    /**
                     * listener to hide/close when clicking outside the datepicker container
                     */
                    $document.on('click.dateTimeInlineContainer', function onClick(event) {
                        if (scope.datepickerVisible) {
                            var isClickedElementChildOfPopup = element.find(event.target).length > 0,
                                elementClassName;
                            elementClassName = event.target.parentElement.classList;
                            if (isClickedElementChildOfPopup && elementClassName && (elementClassName.contains('ui-datepicker-header') || elementClassName.contains('datePicker') || elementClassName.contains('ui-datepicker') || elementClassName.contains('date'))) {
                                return;
                                // Checking this condition as the datepicker next/prev icon trigger another event
                                // which adding new attrs & class in the elements
                            } else if (!isClickedElementChildOfPopup && event.target.text === 'Next' && event.target.title === 'Next' || event.target.text === 'Prev' && event.target.title === 'Prev') {
                                return;
                            }

                            scope.datepickerVisible = false;

                            // Re-initialise the datepicker
                            if (scope.selectedDate === '') {
                                scope.datePickerElement.datepicker('destroy');
                            }
                        }
                    });

                    /**
                     * Responsible to remove the click event.
                     */
                    scope.$on('$destroy', function onDestroy() {
                        $document.off('click.dateTimeInlineContainer');
                    });
                }
            },
            controller: ['$scope', 'moment', '$element', '$timeout', function ($scope, moment, $element, $timeout) {
                $scope.singleDatePickerCallBack = $scope.singleDatePickerCallBack !== undefined && typeof $scope.singleDatePickerCallBack === 'function' ? $scope.singleDatePickerCallBack : function () {};

                if ($scope.timezone) {
                    moment.tz.setDefault($scope.timezone);
                }

                var dayMinifiedName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    defaultTimeEntry = {
                    'displayName': translationService.getLocalizedString('Choose Time'),
                    val: 'Choose Time'
                };
                /**
                 * @description Handles the event on changing of date and time when scheduling
                 * @param {}
                 */
                $scope.scheduledDateTimeChangeHandler = function scheduledDateTimeChangeHandler() {
                    var currentDate = moment().format($scope.dateTimeFormat.momentDateFormat);
                    if ($scope.selectedDate && moment($scope.selectedDate, $scope.dateTimeFormat.momentDateFormat).isValid()) {
                        //Check if date + time is in past
                        if (moment($scope.selectedDate, $scope.dateTimeFormat.momentDateFormat).isSame(moment(currentDate, $scope.dateTimeFormat.momentDateFormat))) {
                            if ($scope.showTimePicker) {
                                if ($scope.selectedTime) {
                                    $scope.sendTime = $scope.selectedTime;
                                } else {
                                    $scope.selectedTime = $scope.sendTime;
                                }
                                if (moment().format('HH:mm') > '23:55') {
                                    // Code to check an edge case, if current time is beyond 11PM. Time Dropdown should display Choose Time
                                    $scope.scheduledTimeOptions = [defaultTimeEntry];
                                    $scope.sendTime = defaultTimeEntry;
                                    $scope.selectedTime = defaultTimeEntry;
                                } else {
                                    $scope.scheduledTimeOptions.some(function (timeObj) {
                                        if (moment().format($scope.dateTimeFormat.timeFormat) < timeObj.val) {
                                            $scope.scheduledTimeOptions.splice(0, $scope.scheduledTimeOptions.indexOf(timeObj));
                                            if ($scope.selectedTime.val < timeObj.val) {
                                                $scope.selectedTime = $scope.scheduledTimeOptions[0];
                                                $scope.sendTime = $scope.scheduledTimeOptions[0];
                                            }
                                            return true;
                                        }
                                    });
                                }
                            }
                        } else {
                            if ($scope.showTimePicker) {
                                //Set the time back to default 8 A.M
                                $scope.scheduledTimeOptions = angular.copy($scope.fullScheduledTimeOptions);
                                $scope.selectedTime = $scope.selectedTime && $scope.selectedTime.val !== defaultTimeEntry.val ? $scope.selectedTime : $scope.scheduledTimeOptions[8];
                                $scope.sendTime = $scope.sendTime && $scope.sendTime.val !== defaultTimeEntry.val ? $scope.sendTime : $scope.scheduledTimeOptions[8];
                            }
                        }

                        $scope.singleDatePickerCallBack({
                            'sendDateObj': $scope.selectedDate,
                            'sendTimeObj': $scope.selectedTime
                        });
                    }
                };

                if ($scope.showTimePicker) {
                    /**
                     * Array of scheduled time options
                     * @type {{val: string, displayName: string}[]}
                     */
                    $scope.scheduledTimeOptions = TimeOptionsService.getHourOptions();
                    $scope.fullScheduledTimeOptions = angular.copy($scope.scheduledTimeOptions);
                    /**
                     * Binding that we use for the send time
                     * @type {{val: string, displayName: string}}
                     */
                    $scope.sendTime = $scope.showTimePicker ? $scope.scheduledTimeOptions[8] : defaultTimeEntry;
                    if ($scope.selectedTime && $scope.selectedTime.previousFlag) {
                        $scope.sendTime = $scope.selectedTime;
                        $scope.scheduledDateTimeChangeHandler();
                    }
                }

                /**
                 * Responsible to toggle the visibility of the datepicker.
                 * @param {Boolean} - show/hide the datepicker by passing in a boolean true/false.
                 */
                $scope.openDatepicker = function openDatepicker() {
                    var scheduleStartTomorrow = 0;
                    if (moment().format(this.dateTimeFormat.timeFormat) > '23:55') {
                        scheduleStartTomorrow = 1;
                    }
                    $scope.datePickerElement = $element.find('.datepickerVisible');
                    $scope.datepickerVisible = !$scope.datepickerVisible;

                    //Setup the datepicker
                    $scope.datePickerElement.datepicker({
                        altField: $scope.datePickerElement,
                        altFormat: $scope.dateTimeFormat.dateFormat || 'M d, yy',
                        dateFormat: $scope.dateTimeFormat.dateFormat || 'M d, yy',
                        dayNamesMin: dayMinifiedName,
                        firstDay: 1,
                        minDate: scheduleStartTomorrow,
                        onSelect: function startDateCalendarOnSelect(date) {
                            $scope.$apply(function dateCalendarOnSelectApply() {
                                $scope.selectedDate = date;
                                $scope.scheduledDateTimeChangeHandler();
                                $scope.singleDatePickerCallBack({
                                    'sendDateObj': $scope.selectedDate,
                                    'sendTimeObj': $scope.selectedTime
                                });
                            });
                        }
                    });

                    if ($scope.selectedDate === '' || $scope.selectedDate === null) {
                        $scope.selectedDate = $scope.datePickerElement.val();
                        $scope.scheduledDateTimeChangeHandler();
                    }
                    $scope.datePickerElement.datepicker('setDate', $scope.selectedDate);
                    $scope.scheduledDateTimeChangeHandler();
                    $scope.singleDatePickerCallBack({
                        'sendDateObj': $scope.selectedDate,
                        'sendTimeObj': $scope.selectedTime
                    });
                };

                if ($scope.disableSelectDateDropdown) {
                    $timeout(function () {
                        $scope.openDatepicker();
                    }, 0, false);
                }
            }]
        };
    }]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var DeleteMedialist = function () {
        function DeleteMedialist($translate, $mdDialog) {
            _classCallCheck(this, DeleteMedialist);

            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        _createClass(DeleteMedialist, [{
            key: '$onInit',
            value: function $onInit() {
                this.modalTitle = this.getModalTitle();
                this.okText = this.$translate.instant('action-label__delete');
                this.cancelText = this.$translate.instant('action-label__cancel');
                this.checkboxLabel = this.$translate.instant('icm-web__delete-modal--confirmation-prompt-checkbox');
            }
        }, {
            key: 'getModalTitle',
            value: function getModalTitle() {
                // probably the safest default is to ask if you want to delete selected contacts from the list
                var modalTextKey = 'icm-web__delete-modal--confirmation-prompt-plural';

                if (this.deleteFromAllLists) {
                    modalTextKey = this.plural ? 'icm-web__delete-modal--confirmation-prompt-all-contacts' : 'icm-web__delete-modal--confirmation-prompt-all-contacts-single';
                } else {
                    modalTextKey = this.plural ? 'icm-web__delete-modal--confirmation-prompt-plural' : 'icm-web__delete-modal--confirmation-prompt';
                }

                return this.$translate.instant(modalTextKey);
            }
        }, {
            key: 'handleOk',
            value: function handleOk() {
                this.$mdDialog.hide(this.deleteAll);
            }
        }, {
            key: 'handleCancel',
            value: function handleCancel() {
                this.$mdDialog.cancel();
            }
        }]);

        return DeleteMedialist;
    }();

    angular.module('MW.ContactManager.DeleteMediaList', ['ngMaterial']).component('deleteMedialist', {
        bindings: {
            deleteAll: '<',
            showCheckbox: '<',
            plural: '<',
            deleteFromAllLists: '<'
        },
        controller: ['$translate', '$mdDialog', DeleteMedialist],
        template: '\n        <mw-mini-modal-dialog layout="column" data="$ctrl.deleteAll" dialog-title="" ok="{{$ctrl.okText}}" cancel="{{$ctrl.cancelText}}" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">\n            <mw-modal-content>\n                <div layout="column">\n                    <h2 class="md-title title">\n                        {{$ctrl.modalTitle}}\n                    </h2>\n                    <md-checkbox ng-if="$ctrl.showCheckbox" class="md-primary body" ng-model="$ctrl.deleteAll" aria-label="$ctrl.checkboxLabel">\n                        <span ng-bind-html="$ctrl.checkboxLabel"></span>\n                    </md-checkbox>\n                </div>\n            </mw-modal-content>\n        </mw-mini-modal-dialog>\n        '
    });
})(window.angular);
'use strict';

(function () {
    'use strict';

    function MwExpansionPanelController($scope, $element, $translate, $sce) {
        var MAX_OPTION_COUNT_FOR_CHECKBOX_VIEW = 5,
            contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.searchText = '';
        this.selectedItem = null;
        this.$translate = $translate;
        this.$sce = $sce;
        this.maxOptionCountForCheckboxView = MAX_OPTION_COUNT_FOR_CHECKBOX_VIEW;

        this.getFindBoxPlaceholderText = function getFindBoxPlaceholderText() {
            return this.$translate.instant(this.findBoxPlaceholder);
        }.bind(this);

        this.getNotFindMessage = function getNotFindMessage() {
            return this.$translate.instant('icm-search__expansion-panel--not-found-label', { searchText: this.searchText });
        }.bind(this);

        this.toggle = function toggle() {
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.searchText = '';
            this.selectedItem = null;
            this.currentSelection = {};

            if (this.clearSelection) {
                this.clearSelection();
            }
        };

        this.optionSelected = function optionSelected(item) {
            if (item) {
                return this.isSelected({ option: item });
            }
            return false;
        };

        this.selectedItemChange = function selectedItemChange(item) {
            if (item) {
                if (this.singleSelection) {
                    this.selectedItem = null;
                    this.currentSelection = {};
                    this.clearSelection({ ignoreSearch: true });
                }
                if (!this.optionSelected(item)) {
                    this.searchText = '';
                }
                this.selectionChanged({ selectedItem: item });
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.searchText.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.showSelectAll = function () {
            var show = true;

            if (this.hideShowAll || this.showCheckboxes() || this.singleSelection) {
                show = false;
            }

            return show;
        };

        this.showCheckboxes = function () {
            var show = false;

            if (this.forceCheckboxes === true) {
                show = true;
            } else if (this.filterName && this.filterName === 'sourcesFilter') {
                show = false;
            } else if (Array.isArray(this.currentOptions) && this.currentOptions.length && this.currentOptions.length <= this.maxOptionCountForCheckboxView && !this.singleSelection && !this.disableShortList) {
                show = true;
            }

            return show;
        };

        // need to update topFive whenever the one-way binding for current options is changed
        this.$onChanges = function (changes) {
            // determine if we should bother grabbing the top five
            // also do not want the top-five section if we are already planning on displaying checkboxes
            if ((this.topFive || changes && changes.topFive && changes.topFive.currentValue) && !this.showCheckboxes()) {
                this.topFive = true;
            } else {
                this.topFive = false;
            }

            if (this.topFive && changes && changes.currentOptions && changes.currentOptions.currentValue) {
                // sort by count and grab the top 5
                this.topFiveOptions = _.sortBy(changes.currentOptions.currentValue, 'count').reverse().slice(0, 5);
            }
        };
    }

    angular.module('MW.ContactManager.MwExpansionPanel', []).component('mwExpansionPanel', {
        bindings: {
            autoSuggest: '&',
            clearSelection: '&',
            currentOptions: '<',
            findBoxPlaceholder: '@',
            forceCheckboxes: '<',
            disableShortList: '<',
            hideAutocomplete: '<',
            hideShowAll: '<',
            isSelected: '&',
            seeAll: '&',
            currentSelection: '<',
            singleSelection: '<',
            selectionChanged: '&',
            selectionCount: '&',
            title: '@',
            filterName: '@',
            infoTip: '<',
            topFive: '<'
        },
        controller: ['$scope', '$element', '$translate', '$sce', MwExpansionPanelController],
        template: '\n                <md-card>\n                    <md-card-title ng-click="$ctrl.toggle()">\n                        <md-card-title-text layout="row">\n                            <span flex>\n                                <span class="panel-title">{{$ctrl.title}}</span>\n                                <mw-infotip text-content="{{$ctrl.infoTip}}"></mw-infotip>\n                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>\n                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount()" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>\n                            </span>\n                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>\n                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>\n                        </md-card-title-text>\n                    </md-card-title>\n                    <md-card-content ng-class="{\'with-border\': $ctrl.hideAutocomplete}">\n                        <div class="find-box" ng-if="!$ctrl.showCheckboxes() && !$ctrl.singleSelection" ng-hide="$ctrl.hideAutocomplete">\n                            <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>\n                            <md-autocomplete\n                                    md-no-cache="true"\n                                    md-theme="expansion-panel"\n                                    md-min-length="2"\n                                    md-delay="50"\n                                    md-select-on-match="true"\n                                    md-match-case-insensitive="true"\n                                    placeholder="{{$ctrl.getFindBoxPlaceholderText()}}"\n                                    md-search-text="$ctrl.searchText"\n                                    md-selected-item="$ctrl.selectedItem"\n                                    md-selected-item-change="$ctrl.selectedItemChange(item)"\n                                    ng-focus="$ctrl.onFocus()"\n                                    ng-blur="$ctrl.onBlur()"\n                                    md-items="item in $ctrl.autoSuggest({searchText: $ctrl.searchText})"\n                                    md-item-text="item.display">\n                                <md-item-template>\n                                    <span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.display}}</span>\n                                </md-item-template>\n                                <md-not-found>\n                                    <span>{{$ctrl.getNotFindMessage()}}</span>\n                                </md-not-found>\n                            </md-autocomplete>\n                        </div>\n                        <div class="top-five checkbox-list" ng-if="$ctrl.topFive && $ctrl.topFiveOptions.length">\n                            <div class="checkbox-options flex" layout="column">\n                                <div ng-repeat="option in $ctrl.topFiveOptions">\n                                    <md-checkbox ng-disabled=\'option.nonRelevant ? true : false\' ng-checked="$ctrl.optionSelected(option)" aria-label="{{::option.name}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)">\n                                        <span translate="{{::option.display}}"></span>\n                                        <md-tooltip><span translate="{{::option.display}}"></span></md-tooltip>\n                                    </md-checkbox>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-if="$ctrl.showSelectAll()" class="see-all" ng-click="$ctrl.seeAll()">\n                            <md-icon md-svg-icon="action:ic_list_24px"></md-icon>\n                            <span translate>icm-search__filter--see-all</span>\n                        </div>\n                        <div class="checkbox-list" ng-if="$ctrl.showCheckboxes()">\n                            <div class="checkbox-options flex" layout="column">\n                                <div ng-repeat="option in $ctrl.currentOptions">\n                                    <md-checkbox ng-disabled=\'option.nonRelevant ? true : false\' ng-checked="$ctrl.optionSelected(option)" aria-label="{{::option.name}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)">\n                                        <span>{{::option.display}}</span>\n                                        <md-tooltip><span>{{::option.display}}</span></md-tooltip>\n                                    </md-checkbox>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="checkbox-list" ng-if="$ctrl.singleSelection">\n                            <md-radio-group ng-model="$ctrl.currentSelection" class="checkbox-options flex" layout="column">\n                                <md-radio-button ng-repeat="option in $ctrl.currentOptions" aria-label="{{::option.display}}" class="md-primary" ng-click="$ctrl.selectedItemChange(option)" ng-value="option.key">\n                                    <span>{{::option.display}}</span>\n                                    <md-tooltip>{{::option.display}}</md-tooltip>\n                                </md-radio-button>\n                            </md-radio-group>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    function MwLocationExpansionPanelController($scope, $element, $translate, $mdDialog, MapService, $rootScope) {
        var message,
            contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.searchText = '';
        this.selectedItem = null;
        this.itemCountMessage = 'icm-search__map-filter--result-count';
        this.MapService = MapService;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.itemCount = 0;
        this.active = false;
        this.getMapTabLabel = function getMapTabLabel() {
            return this.$translate.instant('icm-search__map-filter--label');
        }.bind(this);

        this.getListTabLabel = function getListTabLabel() {
            return this.$translate.instant('icm-search__location-filter--label');
        }.bind(this);

        this.getFindBoxPlaceholderText = function getFindBoxPlaceholderText() {
            return this.$translate.instant(this.findBoxPlaceholder);
        }.bind(this);

        this.getNotFindMessage = function getNotFindMessage() {
            return this.$translate.instant('icm-search__expansion-panel--not-found-label', { searchText: this.searchText });
        }.bind(this);

        this.getZeroResultsButtonText = function getZeroResultsButtonText() {
            return this.$translate.instant('icm-search__map-filter--zero-results-button');
        }.bind(this);

        this.toggle = function toggle() {
            this.active = true;
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();
            //See GYDA-37005 for why this event is here
            window.dispatchEvent(new Event('resize'));
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.searchText = '';
            this.selectedItem = null;
            this.MapService.setInteractionState(this.MapService.BLANK);
            this.$rootScope.$broadcast('clearLocationFilter');
        };

        this.optionSelected = function optionSelected(item) {
            if (item) {
                return this.isSelected({ option: item });
            }
            return false;
        };

        this.selectedItemChange = function selectedItemChange(item) {
            if (item) {
                if (!this.optionSelected(item)) {
                    this.searchText = '';
                }
                this.selectionChanged({ selectedItem: item });
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.searchText.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.$onChanges = function $onChanges(changes) {
            if (changes.mapSearchText) {
                this.mapSearchText = changes.mapSearchText.currentValue;
            }
        };

        this.mapViewClicked = function (bool) {
            this.mapView({ bool: bool });
        };

        this.$rootScope.$on('updateTotalCount', function (event, arg) {
            this.itemCount = arg.itemCount;

            message = this.itemCount > 1 || this.itemCount === 0 ? 'icm-search__map-filter--results-count' : 'icm-search__map-filter--result-count';
            if (!this.itemCount) {
                this.itemCount = 0;
            } else if (this.itemCount > 499) {
                this.itemCount = '+500';
            }

            this.itemCountMessage = this.getItemCountMessage(message);
            this.MapService.setInteractionState(this.MapService.RESULTS_COUNT);
        }.bind(this));

        this.getItemCountMessage = function getItemCountMessage(message) {
            return this.$translate.instant(message, { itemCount: '<b>' + this.itemCount + '</b>' }, null, null, null);
        };

        this.updateSearchClicked = function () {
            this.mapActive = true;
            this.MapService.setInteractionState(this.MapService.LOADING_TEXT);
            this.MapService.triggerSearch();
        };

        this.mapNotSupportedDialog = function mapNotSupportedDialog(ev) {
            var title = 'icm-search__map-filter--not-support-dialog-title',
                body = 'icm-search__map-filter--not-support-dialog-body',
                okButton = 'OK';

            this.$mdDialog.show(this.$mdDialog.mwAlert().title(this.$translate.instant(title)).textContent(this.$translate.instant(body)).ok(this.$translate.instant(okButton)).targetEvent(ev));
        };

        this.zeroResultsDialog = function zeroResultsDialog(ev) {
            var title = 'icm-search__map-filter--zero-results-dialog-title',
                body = '<div class="mw-dialog__text-content">' + this.$translate.instant('icm-search__map-filter--zero-results-dialog-body-1') + '<br/><br/>' + this.$translate.instant('icm-search__map-filter--zero-results-dialog-body-2') + '<br/><br/>',
                countryListDisplay = '<div class="double-list"><ul><li>' + this.countryList.join('</li><li>') + '</li></div></div>',
                okButton = 'OK';
            this.$mdDialog.show(this.$mdDialog.mwMiniModal().class('zero-results-modal').title(this.$translate.instant(title)).htmlContent(body + countryListDisplay).ok(this.$translate.instant(okButton)).wide(true).targetEvent(ev));
        };

        this.syncUpState = function () {
            this.interactionState = this.MapService.getInteractionState();
            try {
                this.$rootScope.$digest();
            } catch (err) {} // jshint ignore:line
        };

        this.syncUpState();
        this.MapService.registerUpdateInteractState(this.syncUpState.bind(this));
        this.MapService.setInteractionState(this.MapService.HELPER_TEXT);
    }

    angular.module('MW.ContactManager.MwLocationExpansionPanel', ['ngMaterial', 'mwAppComponents', 'MW.Framework.CoreUserService', 'MW.Framework.ICMUserService', 'MW.Influencers.MapService']).directive('tabWatcher', ['CoreUserService', 'ICMUserService', 'MapService', '$translate', '$mdDialog', '$rootScope', function (CoreUserService, ICMUserService, MapService, $translate, $mdDialog, $rootScope) {
        return {
            require: ['mdTabs'],
            restrict: 'A',
            link: function link(scope, el, attrs, controllers) {
                var _this = this;
                this.CoreUserService = CoreUserService;
                this.ICMUserService = ICMUserService;
                this.MapService = MapService;
                this.$translate = $translate;
                this.$mdDialog = $mdDialog;
                this.titleText = 'icm-search__location-mini-mod--reset-title';
                this.mapBodyText = 'icm-search__location-mini-mod--reset-list-desc';
                this.listBodyText = 'icm-search__location-mini-mod--reset-map-desc';
                this.dontShowAgainText = 'icm-search__location-mini-mod--dont-show-again';
                this.previousTab = 0;
                this.newTab = null;
                this.dontShowAgainChecked = false;
                this.showTabSwitchModal = attrs.showTabSwitchModal || true;
                this.changesHappened = function onChanges() {
                    //Changes on the variable passed in don't propagate, for some reason
                    //Thus, we're using lexical scoping to save us from the headache of finding the real issue.
                    _this.dontShowAgainChecked = !_this.dontShowAgainChecked;
                };

                var mdTabsCtrl = controllers[0],
                    mdTabsCtrlSelect = mdTabsCtrl.select;

                this.getAppSettings = function getAppSettings() {
                    var _this2 = this;

                    return new Promise(function (resolve, reject) {
                        _this2.CoreUserService.getCurrent(true).then(function (currentUser) {
                            resolve(_this2.ICMUserService.getAppSettings('contacts', currentUser._id));
                        }).catch(function (err) {
                            reject(err);
                        });
                    });
                };

                this.showTabSwitchDialog = function showTabSwitchDialog() {
                    var bodyText = !!this.previousTab ? this.mapBodyText : this.listBodyText;
                    this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                        locals: {
                            title: this.$translate.instant(this.titleText),
                            body: this.$translate.instant(bodyText),
                            dontShowAgainText: this.$translate.instant(this.dontShowAgainText),
                            changesHappened: this.changesHappened
                        },
                        templateUrl: 'icm-web/views/search_location_mini_modal',
                        controllerAs: '$ctrl'
                    })).then(function okHandler() {
                        var _this3 = this;

                        mdTabsCtrlSelect(this.newTab);
                        $rootScope.$broadcast('clearLocationFilter');
                        this.previousTab = this.newTab;
                        if (_this.dontShowAgainChecked) {
                            this.getAppSettings().then(function (settings) {
                                var newSettings = Object.assign(settings, { showLocationSwitchTabModal: false });
                                _this3.ICMUserService.setAppSettings('contacts', newSettings);
                            });
                        }
                    }.bind(this), function cancelHandler() {
                        //'You selected cancel'
                    }).catch(function () {});
                };

                this.switchTabs = function switchTabs(tab) {
                    mdTabsCtrlSelect(tab);
                    $rootScope.$broadcast('clearLocationFilter');
                    this.previousTab = tab;
                };

                this.shouldShowModal = function shouldShowModal(settings) {
                    var showLocationSwitchTabModal = settings.showLocationSwitchTabModal === undefined ? true : settings.showLocationSwitchTabModal,
                        mapOrLocationFilterIsDirty = this.MapService.isMapDirty() || this.MapService.isLocationFilterDirty();

                    if (mapOrLocationFilterIsDirty && showLocationSwitchTabModal && this.previousTab !== this.newTab) {
                        // if map isn't supported (ie10) don't show when switching from map to list
                        return this.MapService.isMapSupported || !this.MapService.isMapSupported && this.previousTab === 1 && this.newTab === 0;
                    } else {
                        return false;
                    }
                }.bind(this);

                mdTabsCtrl.select = function (newTab) {
                    var _this4 = this;

                    this.newTab = newTab;
                    this.getAppSettings().then(function (settings) {
                        if (_this4.shouldShowModal(settings)) {
                            _this4.showTabSwitchDialog();
                        } else {
                            _this4.switchTabs(newTab);
                        }
                    });
                }.bind(this);
            }
        };
    }]).component('mwLocationExpansionPanel', {
        bindings: {
            autoSuggest: '&',
            currentOptions: '<',
            findBoxPlaceholder: '@',
            hideAutocomplete: '<',
            infoTip: '<',
            updateButtonText: '<',
            isSelected: '&',
            mapDataPoints: '<',
            seeAll: '&',
            selectionChanged: '&',
            selectionCount: '&',
            title: '@',
            viewport: '<',
            mapView: '&',
            mapSearchText: '<',
            mapFilterSelected: '<',
            showTabSwitchModal: '<',
            mapActive: '=',
            startingBounds: '=',
            countryList: '='
        },
        controller: ['$scope', '$element', '$translate', '$mdDialog', 'MapService', '$rootScope', MwLocationExpansionPanelController],
        template: '\n                <md-card>\n                    <md-card-title ng-click="$ctrl.toggle()">\n                        <md-card-title-text layout="row">\n                            <span flex>\n                                <span class="panel-title">{{$ctrl.title}}</span>\n                                <mw-infotip text-content="{{$ctrl.infoTip}}"></mw-infotip>\n                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>\n                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount() || $ctrl.mapFilterSelected" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>\n                            </span>\n                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>\n                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>\n                        </md-card-title-text>\n                    </md-card-title>\n                    <md-card-content>\n                        <md-tabs tab-watcher show-tab-switch-modal="{{$ctrl.showTabSwitchModal}}" class="location-tabs" md-dynamic-height md-stretch-tabs="always" md-selected="selected">\n                            <md-tab label="{{$ctrl.getMapTabLabel()}}" ng-class="{\'with-border\': $ctrl.hideAutocomplete}">\n                                <md-content ng-if="$ctrl.MapService.isMapSupported && $ctrl.active" ng-class="{\'with-border\': $ctrl.hideAutocomplete}" class="location-tab-content">\n                                    <div class="map-search-placeholder"></div>\n                                    <mw-map\n                                        starting-bounds="$ctrl.startingBounds"\n                                        map-search-text="$ctrl.mapSearchText"\n                                        map-data-points="$ctrl.mapDataPoints"\n                                        viewport="$ctrl.viewport"\n                                        update-search-clicked="$ctrl.updateSearchClicked()"\n                                        />\n                                </md-content>\n                                <md-content ng-if="!$ctrl.MapService.isMapSupported" class="location-tab-content">\n                                    <div class="map-not-supported" style="background-image: url(\'https://assets.meltwater.io/icm-web-assets/static/img/search/map-disabled.png\');">\n                                        <md-button class="md-primary mw-button map-not-supported-button" ng-click="$ctrl.mapNotSupportedDialog($event)">\n                                            <span translate="icm-search__map-filter--map-not-supported"></span>\n                                        </md-button>\n                                    </div>\n                                </md-content>\n                                <md-toolbar ng-if="$ctrl.MapService.isMapSupported" layout="row" layout-align="start center">\n                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.HELPER_TEXT" class="helper-text" translate="icm-search__map-filter--helper-text"></span>\n                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.LOADING_TEXT" class="results-loading-text" translate="icm-search__map-filter--results-loading"></span>\n                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.RESULTS_COUNT" class="results-count">\n                                        <span ng-bind-html="$ctrl.itemCountMessage"></span>\n                                        <span ng-if="$ctrl.itemCount === 0" class="zero-results-button" ng-click="$ctrl.zeroResultsDialog()" aria-label="Why?">{{$ctrl.getZeroResultsButtonText()}}</span>\n                                    </span>\n                                    <md-button ng-if="$ctrl.interactionState===$ctrl.MapService.SHOW_BUTTON" class="md-primary update-bar mw-button md-ink-ripple" ng-click="$ctrl.updateSearchClicked()" aria-label="Update contact results">\n                                        <span class="update-bar" translate="{{$ctrl.updateButtonText}}"></span>\n                                    </md-button>\n                                </md-toolbar>\n                            </md-tab>\n                            <md-tab label="{{$ctrl.getListTabLabel()}}">\n                                <md-content ng-class="{\'with-border\': $ctrl.hideAutocomplete}">\n                                    <div class="find-box" ng-hide="$ctrl.hideAutocomplete">\n                                        <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>\n                                        <md-autocomplete\n                                                md-no-cache="true"\n                                                md-theme="expansion-panel"\n                                                md-min-length="2"\n                                                md-delay="50"\n                                                md-select-on-match="true"\n                                                md-match-case-insensitive="true"\n                                                placeholder="{{$ctrl.getFindBoxPlaceholderText()}}"\n                                                md-search-text="$ctrl.searchText"\n                                                md-selected-item="$ctrl.selectedItem"\n                                                md-selected-item-change="$ctrl.selectedItemChange(item)"\n                                                ng-focus="$ctrl.onFocus()"\n                                                ng-blur="$ctrl.onBlur()"\n                                                md-items="item in $ctrl.autoSuggest({searchText: $ctrl.searchText})"\n                                                md-item-text="item.display">\n                                            <md-item-template>\n                                                <span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.display}}</span>\n                                            </md-item-template>\n                                            <md-not-found>\n                                                <span>{{$ctrl.getNotFindMessage()}}</span>\n                                            </md-not-found>\n                                        </md-autocomplete>\n                                    </div>\n                                    <div class="see-all" ng-click="$ctrl.seeAll()">\n                                        <md-icon md-svg-icon="action:ic_list_24px"></md-icon>\n                                        <span translate>icm-search__filter--see-all</span>\n                                    </div>\n                                </md-content>\n                            </md-tab>\n                        </md-tabs>\n                    <md-card-content>\n                </md-card>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    function MwMapController($window, $timeout, $scope, $compile, MAPBOX_API_TOKEN, $translate, MapService, $rootScope) {
        var _this2 = this;

        var _this = this;
        _this.map = null;

        this.$compile = $compile;
        this.$scope = $scope;
        this.$window = $window;
        this.geoCoder = null;
        this.$translate = $translate;
        this.MapService = MapService;
        this.$rootScope = $rootScope;

        // unique ID so we can use this component multiple times on a page
        _this.mapIdSelector = $scope.$id;
        _this.minZoom = _this.minZoom || 0;
        _this.maxZoom = _this.maxZoom || 12;

        function initializeMap() {
            $window.mapboxgl.accessToken = MAPBOX_API_TOKEN;

            ///
            //  -_-_-_- GeoCoDeR IniT -_-_-_-
            ///
            // We need to users language before we start initializing the geocoder
            _this.MapService.getUsersMBLanguage().then(function weHaveAnMBLanguage(supportedLanguage) {
                var geocoderOptions = { accessToken: $window.mapboxgl.accessToken, flyTo: false, placeholder: _this.getGeocoderPlaceholderText() };

                // Toss on a language if map box supports it
                if (supportedLanguage) {
                    geocoderOptions.language = supportedLanguage;
                }

                // Geocoder initialization!!
                _this.geoCoder = new $window.MapboxGeocoder(geocoderOptions);

                // Handle a result
                _this.geoCoder.on('result', function (ev) {
                    _this.MapService.setGeoCoderText(ev.result.place_name); // jshint ignore:line
                    _this.geoCoder.setInput(ev.result.place_name); // jshint ignore:line
                    if (ev && ev.result && ev.result.bbox) {
                        map.fitBounds(ev.result.bbox, { animate: false });
                        _this.updateSearchClicked();
                    } else if (ev && ev.result && ev.result.geometry && ev.result.geometry.coordinates) {
                        map.flyTo({ speed: 999, center: ev.result.geometry.coordinates, zoom: 13 });
                        _this.updateSearchClicked();
                    }
                });

                // Handle that clear
                _this.geoCoder.on('clear', function () {
                    if (_this.searchUpdated) {
                        _this.MapService.setInteractionState(_this.MapService.SHOW_BUTTON);
                    } else {
                        _this.MapService.setInteractionState(_this.MapService.HELPER_TEXT);
                    }

                    _this.searchUpdated = false;

                    _this.MapService.setGeoCoderText('');
                });
            });

            ///
            //  -_-_-_- mAp IniT -_-_-_-
            ///
            var map = new $window.mapboxgl.Map({
                container: 'map-container-' + _this.mapIdSelector,
                style: 'mapbox://styles/icm-meltwater/cj7uw19np2ow42so4lci9aj5h',
                maxZoom: 12
            });

            _this.MapService.registerMap(map);

            map.on('load', function () {
                // we need to wait until we get the units back before drawing all of the controls
                // units depend on the current company. retrieving that is promise based.
                _this.MapService.getScaleUnits().then(function (scaleUnits) {
                    map.addControl(new $window.mapboxgl.ScaleControl({ unit: scaleUnits }), 'bottom-right');

                    // Add zoom and rotation controls to the map
                    map.addControl(new $window.mapboxgl.NavigationControl(), 'bottom-right');

                    // add the search functionality to the map
                    map.addControl(_this.geoCoder, 'top-left');

                    // sometimes there is a provided callback to further customize the map
                    if (_this.onMapInit && typeof _this.onMapInit === 'function') {
                        _this.onMapInit({ map: map });
                    }

                    if (_this.startingBounds && !_this.MapService.getViewportBounds()) {
                        _this.settingMapDefaultView = true;
                        _this.MapService.boundsSelected(_this.startingBounds);
                        $timeout(function () {
                            map.fitBounds(_this.startingBounds, { animate: false });
                        }, 0);
                    }
                });

                map.on('dragstart', function () {
                    _this.setInteractState();
                });

                map.on('dragend', function (ev) {
                    setBounds(ev);
                });

                map.on('zoomstart', function () {
                    _this.setInteractState();
                });

                map.on('zoomend', function (ev) {
                    if (_this.startingZoom !== ev.target.getZoom()) {
                        _this.setInteractState();
                        setBounds(ev);
                    }

                    _this.settingMapDefaultView = false;
                });

                // disable map rotation using right click + drag
                map.dragRotate.disable();

                // disable map rotation using touch rotation gesture
                map.touchZoomRotate.disableRotation();

                // Set the maps language once its all loaded up
                _this.setLanguage();
            });

            return map;
        }

        function setBounds(e) {
            _this.MapService.boundsSelected(e.target.getBounds());
        }

        function clearGeoCoder(geoCoder) {
            if (geoCoder) {
                geoCoder._clear();
                geoCoder._inputEl.blur();
            }
        }

        this.fitBounds = function fitBounds(bounds) {
            // jshint ignore:line
            if (this.map && bounds && bounds._ne && bounds._ne.lng && bounds._ne.lat && bounds._sw && bounds._sw.lng && bounds._sw.lat) {
                this.map.fitBounds(bounds, { animate: false }); // jshint ignore:line
            }
        };

        this.$onChanges = function $onChanges(changes) {
            if (this.geoCoder && changes.mapSearchText && changes.mapSearchText.currentValue === '') {
                clearGeoCoder(this.geoCoder);
            }
        };

        // this will attach itself to both the expansion map and the modal map
        // need to differentiate between the two
        $rootScope.$on('clearLocationFilter', function () {
            clearGeoCoder(_this2.geoCoder);
            _this2.fitBounds(_this2.startingBounds);
            _this2.MapService.setInteractionState(_this2.MapService.HELPER_TEXT);
        });

        $timeout(function () {
            if ($window.mapboxgl.supported()) {
                _this2.MapService.isMapSupported = true;
                _this.map = initializeMap();

                // Tell map service about the mininap like so...
                _this2.MapService.registerMiniMapBoundsSetter(function (bounds) {
                    _this.fitBounds(bounds);
                }.bind(_this2));
                _this2.MapService.registerMiniMapBoundsGetter(function () {
                    return _this.map.getBounds();
                }.bind(_this2));

                if (_this2.MapService.getViewportBounds()) {
                    _this.fitBounds(_this2.MapService.getViewportBounds().getBounds());
                } else if (_this2.MapService.getCachedViewportBounds()) {
                    _this.fitBounds(_this2.MapService.getCachedViewportBounds());
                }
            } else {
                _this2.MapService.isMapSupported = false;
            }
        }, 0);

        _this.getGeocoderPlaceholderText = function getGeocoderPlaceholderText() {
            return _this.$translate.instant('icm-search__location-filter--placeholder-label');
        };

        // Set maps language based on user
        _this.setLanguage = function () {
            var layersToUpdate = _this.MapService.MAPBOX_LAYERS_TO_UPDATE_LANGUAGE;
            // Set the language of the map based on users language
            this.MapService.getUsersMBLanguage().then(function gotUsersMBLanguage(supportedLanguage) {
                if (supportedLanguage) {
                    layersToUpdate.forEach(function (layer) {
                        _this.map.setLayoutProperty(layer, 'text-field', ['get', 'name_' + supportedLanguage]);
                    });
                }
            });
        };
    }

    MwMapController.prototype.setInteractState = function setInteractState() {
        if (!this.settingMapDefaultView) {
            this.MapService.setInteractionState(this.MapService.SHOW_BUTTON);
        }
    };

    angular.module('MW.ContactManager.MwMap', ['MW.Configuration', 'MW.Influencers.MapService']).component('mwMap', {
        bindings: {
            onMapInit: '&',
            viewport: '<',
            mapSearchText: '<',
            mapBoundsChanged: '&',
            startingBounds: '<',
            updateSearchClicked: '&'
        },
        controller: ['$window', '$timeout', '$scope', '$compile', 'MAPBOX_API_TOKEN', '$translate', 'MapService', '$rootScope', MwMapController],
        template: '\n                <div id="map-container-{{$ctrl.mapIdSelector}}" class="map-container">\n                </div>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';
    // ----------------------------------------------------
    // CONTACT COUNT COMPONENT - Displayed under the search bar
    // ----------------------------------------------------

    var ResultCount = function () {
        function ResultCount($scope, $compile) {
            _classCallCheck(this, ResultCount);

            this.$compile = $compile;
            this.$scope = $scope;
        }

        _createClass(ResultCount, [{
            key: 'onAdd',
            value: function onAdd(map) {
                var innerHtml = angular.element('<span id="mapBrowseText" ng-if="true" ng-bind-html="$ctrl.resultText"></span>');
                this._map = map;
                this._container = document.createElement('div');
                this._container.id = 'mapBrowseCountContainer';
                this._container.className = 'mapboxgl-ctrl-top-left map-browse-count-container mapboxgl-ctrl mapboxgl-ctrl-group hidden';
                this.$compile(innerHtml)(this.$scope);
                this._container.appendChild(innerHtml[0]);

                return this._container;
            }
        }, {
            key: 'onRemove',
            value: function onRemove() {
                this._container.parentNode.removeChild(this._container);
                this._map = undefined;
            }
        }]);

        return ResultCount;
    }();

    var ResultCountLoader = function () {
        function ResultCountLoader($scope, $compile) {
            _classCallCheck(this, ResultCountLoader);

            this.$compile = $compile;
            this.$scope = $scope;
        }

        _createClass(ResultCountLoader, [{
            key: 'onAdd',
            value: function onAdd(map) {
                var innerHtml = angular.element('<md-progress-linear id="mapBrowseLoader" md-mode="indeterminate"></md-progress-linear>');
                this._map = map;
                this._container = document.createElement('div');
                this._container.id = 'mapBrowseCountLoader';
                this._container.className = 'mapboxgl-ctrl-top-left map-browse-count-loader mapboxgl-ctrl mapboxgl-ctrl-group hidden';
                this.$compile(innerHtml)(this.$scope);
                this._container.appendChild(innerHtml[0]);

                return this._container;
            }
        }, {
            key: 'onRemove',
            value: function onRemove() {
                this._container.parentNode.removeChild(this._container);
                this._map = undefined;
            }
        }]);

        return ResultCountLoader;
    }();

    function MwMapModalController($window, MapService, $translate, $timeout, $rootScope, $scope, $compile) {
        var mapboxgl,
            _this = this;

        this.resultCountPromise = null;
        this.MapService = MapService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.resultText = null;

        this.mapSteps = [
        // 4x
        {
            width: 1280,
            height: 720,
            minZoom: 1.9999999999999882,
            maxZoom: 13.999999999959176
        },
        // 3.5x
        {
            width: 1120,
            height: 630,
            minZoom: 1.8073549220575866,
            maxZoom: 13.80735492201458
        },
        // 3x
        {
            width: 960,
            height: 540,
            minZoom: 1.5849625007210946,
            maxZoom: 13.584962500680282
        },
        // 2.5x
        {
            width: 800,
            height: 450,
            minZoom: 1.3219280948873442,
            maxZoom: 13.321928094843784
        },
        // 2x
        {
            width: 640,
            height: 360,
            minZoom: 0.9999999999999382,
            maxZoom: 12.999999999958886
        },
        // 1x
        {
            width: 320,
            height: 180,
            minZoom: 0,
            maxZoom: 12
        }];

        this.getMapModalTitle = function getMapModalTitle() {
            return this.$translate.instant('icm-search__map-filter--modal-title');
        }.bind(this);

        this.$onChanges = function $onChanges(changes) {
            if (changes.viewport && changes.viewport.currentValue && changes.viewport.currentValue.topLeft && changes.viewport.currentValue.bottomRight) {
                this.viewport = changes.viewport.currentValue;
            }
        };

        this.onMapInit = function onMapInit(map) {
            mapboxgl = map;
            resizeModal();

            mapboxgl.addControl(new ResultCount($scope, $compile), 'top-left');
            mapboxgl.addControl(new ResultCountLoader($scope, $compile), 'top-left');

            if (this.resultCount) {
                this.updateResultCount(this.resultCount);
            }
        }.bind(this);

        this.updateResultCount = function updateResultCount(count) {
            var resultBemKey = count === 1 ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';

            count = count > 500 ? '+500' : count;
            count = '<b>' + count + '</b>';

            // need to pass the three trailing nulls, because the final null argument says to skip sanitization
            // otherwise translate service will escape the bold tags, and things just wont look right
            this.resultText = this.$translate.instant(resultBemKey, { itemCount: count }, null, null, null);

            //TODO - call up the loading state somewhere around here

            // return if this element is not loaded yet
            if (count || count === 0) {
                this.showContactCountComponent();
            }
        };

        this.showContactCountComponent = function showContactCountComponent() {
            var resultTextElement = document.querySelector('#mapBrowseCountContainer');
            // return if this element is not loaded yet
            if (resultTextElement) {
                resultTextElement.classList.remove('hidden');
            }
        };

        this.showContactCountLoader = function showContactCountLoader() {
            this.showContactCountComponent();
            var resultLoaderElement = document.querySelector('#mapBrowseCountLoader'),
                resultTextElement = document.querySelector('#mapBrowseCountContainer');
            this.resultText = this.$translate.instant('icm-search__map-filter--results-loading');
            // return if this element is not loaded yet
            if (resultLoaderElement) {
                resultLoaderElement.classList.remove('hidden');
                resultTextElement.classList.add('loading');
            }
        };

        this.hideContactCountLoader = function hideContactCountLoader() {
            var resultLoaderElement = document.querySelector('#mapBrowseCountLoader'),
                resultTextElement = document.querySelector('#mapBrowseCountContainer');
            // return if this element is not loaded yet
            if (resultLoaderElement) {
                resultLoaderElement.classList.add('hidden');
                resultTextElement.classList.remove('loading');
            }
        };

        this.mapMoved = function mapMoved() {
            var _this2 = this;

            if (this.resultCountPromise) {
                this.$timeout.cancel(this.resultCountPromise);
            }

            this.resultCountPromise = this.$timeout(function () {
                _this2.showContactCountLoader();
                _this2.updateCount().then(function (res) {
                    _this2.hideContactCountLoader();
                    _this2.updateResultCount(res.count.toString());
                    _this2.resultCountPromise = null;
                });
            }, 300);
        };

        // ----------------------------------------------------
        // MODAL LOGIC
        // ----------------------------------------------------

        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            this.okCallback();
        }.bind(this);

        // ----------------------------------------------------
        // MODAL RESIZE LOGIC. MAINTAIN 16:9 ASPECT RATIO IN MAP
        // ----------------------------------------------------
        function resizeModal() {
            var windowEle = $(window),
                windowHeight = windowEle.height() * 0.8,
                windowWidth = windowEle.width() * 0.8,
                mapModalEle = $('mw-map-modal'),
                mapContainerEle = $('mw-map-modal .map-container'),
                mapHeaderHeight = $('.map-modal-header').outerHeight(),
                mapFooterHeight = $('.map-modal-footer').outerHeight(),
                bestMapWidth,
                bestMapHeight,
                mapModalHeight,
                mapStep;

            // steps are stored in descending order of size, so we just need to find the first one that
            // fits in our current window
            _this.mapSteps.some(function (step) {
                if (step.width <= windowWidth && step.height <= windowHeight) {
                    mapStep = step;
                    return true;
                } else {
                    return false;
                }
            });

            bestMapWidth = mapStep.width;
            bestMapHeight = mapStep.height;
            mapModalHeight = bestMapHeight + mapHeaderHeight + mapFooterHeight;

            _this.minZoom = mapStep.minZoom;
            _this.maxZoom = mapStep.maxZoom;

            mapModalEle.width(bestMapWidth);
            mapModalEle.height(mapModalHeight);
            mapContainerEle.width(bestMapWidth);
            mapContainerEle.height(bestMapHeight);

            if (mapboxgl) {
                var viewBounds = MapService.getViewportBounds(),
                    bounds;

                // This is where we set the max maps bounds. The minimap has set the folowing value, so we should adopt it.
                if (viewBounds) {
                    bounds = viewBounds.getBounds();
                    mapboxgl.fitBounds(bounds, { animate: false });
                } else {
                    mapboxgl.resize();
                }
                MapService.setShouldUpdateCount(true);
            }
        }

        $timeout(function () {
            resizeModal();
        }, 0);
        // ----------------------------------------------------
        // END MODAL RESIZE LOGIC.
        // ----------------------------------------------------
    }

    angular.module('MW.ContactManager.MwMapModal', ['MW.ContactManager.MwMap', 'MW.Influencers.MapService']).component('mwMapModal', {
        bindings: {
            cancelCallback: '&',
            okCallback: '&',
            viewport: '<',
            resultCount: '<',
            updateCount: '&'
        },
        controller: ['$window', 'MapService', '$translate', '$timeout', '$rootScope', '$scope', '$compile', MwMapModalController],
        template: '\n                <md-dialog aria-label="{{$ctrl.mapModalTitle}}">\n                    <md-dialog-content layout="column">\n                        <div class="map-modal-header">\n                            <span>{{$ctrl.getMapModalTitle()}}</span>\n                        </div>\n                        <div class="map-modal-content">\n                            <mw-map on-map-init="$ctrl.onMapInit(map)" viewport="$ctrl.viewport"  map-bounds-changed="$ctrl.mapMoved()" is-map-modal="true"></mw-map>\n                        </div>\n                    </md-dialog-content>\n                    <md-dialog-actions class="map-modal-footer" layout="row">\n                        <span flex></span>\n                        <button class="mw-mini-modal__cancel-button mw-button md-button md-ink-ripple" type="button" ng-click="$ctrl.cancelModal()" md-autofocus="true">\n                            <span translate>action-label__cancel</span>\n                        </button>\n                        <button class="mw-mini-modal__ok-button mw-button md-button md-ink-ripple" type="button" ng-click="$ctrl.okModal()" md-autofocus="true">\n                            <span translate>OK</span>\n                        </button>\n                    </md-dialog-actions>\n                </md-dialog>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var MediaListCard = function () {
        function MediaListCard(CoreUserService, $translate, $sce, $mdDialog, $mdToast, ContactManagerTagService, DialogService) {
            _classCallCheck(this, MediaListCard);

            this.coreUserService = CoreUserService;
            this.$translate = $translate;
            this.$sce = $sce;
            this.$mdDialog = $mdDialog;
            this.$mdToast = $mdToast;
            this.ContactManagerTagService = ContactManagerTagService;
            this.DialogService = DialogService;
            this.successToastMessage = $translate.instant('icm-web__media-lists--toast-list-updated');
            this.addDescriptionString = this.$translate.instant('icm-web__media-list-engagement--add-description');
        }

        _createClass(MediaListCard, [{
            key: '$onInit',
            value: function $onInit() {
                var _this2 = this;

                this.coreUserService.getCurrent(true).then(function (user) {
                    var userLanguage = user.language || 'en';

                    switch (userLanguage) {
                        case 'zh_CN':
                        case 'zh_TW':
                            userLanguage = 'zh';
                            break;
                    }

                    if (_this2.mediaList.created) {
                        _this2.mediaList.createdOn = _this2._formatDate(new Date(_this2.mediaList.created), userLanguage);
                    }

                    if (_this2.mediaList.createdByFirstName || _this2.mediaList.createdByLastName) {
                        _this2.mediaList.createdBy = [_this2.mediaList.createdByFirstName, _this2.mediaList.createdByLastName].filter(function (name) {
                            return !!name;
                        }).join(' ');
                    }

                    if (_this2.mediaList.updated) {
                        _this2.mediaList.updatedAt = _this2._formatDate(new Date(_this2.mediaList.updated), userLanguage);
                    }
                    if (_this2.mediaList.lastUpdatedByFirstName || _this2.mediaList.lastUpdatedByLastName) {
                        _this2.mediaList.updatedBy = [_this2.mediaList.lastUpdatedByFirstName, _this2.mediaList.lastUpdatedByLastName].filter(function (name) {
                            return !!name;
                        }).join(' ');
                    }
                });
            }
        }, {
            key: '_formatDate',
            value: function _formatDate(dateObj, userLanguage) {
                return dateObj.toLocaleString(userLanguage, { month: 'short' }) + ' ' + dateObj.toLocaleString(userLanguage, { day: 'numeric' }) + ', ' + dateObj.toLocaleString(userLanguage, { year: 'numeric' });
            }
        }, {
            key: 'showDeleteDialog',
            value: function showDeleteDialog(ev, item) {
                var _this3 = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().class('icm-confirmation-modal').title(this.$translate.instant('icm-medialist__delete-medialist--confirm-modal-title')).htmlContent(this.$sce.trustAsHtml('<p class="mw-dialog__text-content">' + this.$translate.instant('icm-medialist__delete-medialist--confirm-modal-content-2') + '</p>')).ok(this.$translate.instant('action-label__delete')).cancel(this.$translate.instant('action-label__cancel')).targetEvent(ev)).then(function () {
                    if (item.id) {
                        _this3.ContactManagerTagService.removeMediaList(item.id).then(function () {
                            _this3.reloadCurrentPage();
                            _this3.$mdToast.show(_this3.$mdToast.mwSimpleTimed().textContent(_this3.$translate.instant('icm-medialist__delete-medialist--success-message')));
                        });
                    }
                }).catch(function () {});
            }
        }, {
            key: 'showEditDialog',
            value: function showEditDialog(event, item) {
                var _this = this;

                this.$mdDialog.show({
                    bindToController: true,
                    targetEvent: event,
                    locals: {
                        mediaList: angular.copy(item),
                        duplicateError: false,
                        cancelDialog: function cancelDialog() {
                            _this.$mdDialog.cancel();
                        },
                        okDialog: function okDialog(updatedMediaList) {
                            var _this4 = this;

                            var mediaListId = updatedMediaList.id;
                            var mediaListName = updatedMediaList.name;
                            var mediaListDescription = updatedMediaList.description;

                            this.duplicateError = false;

                            _this.ContactManagerTagService.updateMediaList(mediaListId, mediaListName, mediaListDescription).then(function () {
                                _this.reloadCurrentPage();
                                _this.$mdDialog.hide();

                                _this.$mdToast.show(_this.$mdToast.mwSimpleTimed().textContent(_this.successToastMessage));
                            }).catch(function (error) {
                                // somewhere along the line we decided error.status just wasn't cutting it, we thought error.data.error.reason just rolled off the tongue
                                if (error.status === 409 || error && error.data && error.data.error && error.data.error.reason === 409) {
                                    _this4.duplicateError = true;
                                } else {
                                    _this.$mdDialog.hide();
                                    _this.DialogService.flashError(_this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                                }
                            });
                        }
                    },
                    template: '\n                    <md-dialog id="icm-media-list-update-modal" class="mw-mini-modal" aria-label="" layout="column">\n                        <mw-media-list-update-modal class="mw-mini-modal-wrapper" layout="column" media-list="$ctrl.mediaList" duplicate-error="$ctrl.duplicateError" ok-callback="$ctrl.okDialog(updatedMediaList)" cancel-callback="$ctrl.cancelDialog()"></mw-media-list-update-modal>\n                    </md-dialog>\n                ',
                    // This is a globally available controller for the purposes of attaching locals for data binding
                    controller: 'MwMiniModalDialogController',
                    controllerAs: '$ctrl'
                });
            }
        }]);

        return MediaListCard;
    }();

    angular.module('MW.ContactManager.MwMediaListCard', ['MW.CoreStream.ContactManagerTagService', 'MW.Influencers.IcmDialogService', 'MW.Framework.CoreUserService']).component('mwMediaListCard', {
        bindings: {
            mediaList: '<',
            reloadCurrentPage: '&'
        },
        controller: ['CoreUserService', '$translate', '$sce', '$mdDialog', '$mdToast', 'ContactManagerTagService', 'DialogService', MediaListCard],
        template: '\n                <div class="md-card">\n                    <div class="md-card-content" layout="column">\n                        <div class="list-header-row" layout="row" layout-align="space-between start">\n                            <a href="influencers/contact-list/{{$ctrl.mediaList.id}}" class="list-name">\n                                {{$ctrl.mediaList.name}}\n                                <md-tooltip md-delay="500">\n                                    {{$ctrl.mediaList.name}}\n                                </md-tooltip>\n                            </a>\n                            <md-menu class="list-action-button" md-position-mode="target-right target" md-offset="0 50">\n                                <mw-menu-trigger-icon-button class="diddly-dot" icon="navigation:ic_more_vert_24px" tooltip="{{::\'mw-collection__tooltip-menu-trigger\' | translate}}" on-click="$mdMenu.open($event)"></mw-menu-trigger-icon-button>\n                                <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">\n                                    <mw-menu-item type="focusdummy"></mw-menu-item>\n                                    <mw-menu-item class="automation-editListOption" icon="editor:ic_mode_edit_24px" on-click="$ctrl.showEditDialog($event, $ctrl.mediaList)">\n                                        <span translate>icm-web__list-of-lists--edit-list</span>\n                                    </mw-menu-item>\n                                    <mw-menu-item class="automation-deleteListOption" icon="action:ic_delete_24px" on-click=\'$ctrl.showDeleteDialog($event, $ctrl.mediaList)\'>\n                                        <span translate>icm-web__list-of-lists--delete-list</span>\n                                    </mw-menu-item>\n                                </md-menu-content>\n                            </md-menu>\n                        </div>\n                        <div class="list-data-row" layout="row" layout-wrap>\n                            <div class="list-details-section" layout="column" layout-align="space-between" flex="100" flex-gt-sm="50">\n                                <div class="list-description-wrapper" layout="row" layout-align="start end">\n                                    <div ng-if="$ctrl.mediaList.description" class="list-description">\n                                        <span>{{$ctrl.mediaList.description}}</span>\n                                    </div>\n                                    <div ng-if="!$ctrl.mediaList.description" class="add-description" ng-click="$ctrl.showEditDialog($event, $ctrl.mediaList)">\n                                        <span class="add-description-plus">+</span>\n                                        <span class="add-description-label">{{$ctrl.addDescriptionString}}</span>\n                                    </div>\n                                </div>\n                                <div>\n                                    <div flex class="list-time" layout="row" layout-align="start end">\n                                        <span translate>icm-web__list-card--created-on</span>\n                                        <b>&nbsp;{{$ctrl.mediaList.createdOn}}</b>\n                                        <span ng-if="$ctrl.mediaList.createdBy">&nbsp;&bull;&nbsp;</span>\n                                        <span ng-if="$ctrl.mediaList.createdBy" translate>icm-web__list-card--created-by</span>\n                                        <b class="modified-name" ng-if="$ctrl.mediaList.createdBy">\n                                            &nbsp;{{$ctrl.mediaList.createdBy}}\n                                            <md-tooltip md-delay="500">\n                                                {{$ctrl.mediaList.createdBy}}\n                                            </md-tooltip>\n                                        </b>\n                                    </div>\n                                    <div flex class="list-time" layout="row" layout-align="start end">\n                                        <span translate>icm-web__list-card--last-updated-on</span>\n                                        <b>&nbsp;{{$ctrl.mediaList.updatedAt}}</b>\n                                        <span ng-if="$ctrl.mediaList.updatedBy">&nbsp;&bull;&nbsp;</span>\n                                        <span ng-if="$ctrl.mediaList.updatedBy" translate>icm-web__list-card--last-updated-by</span>\n                                        <b class="modified-name" ng-if="$ctrl.mediaList.updatedBy">\n                                            &nbsp;{{$ctrl.mediaList.updatedBy}}\n                                            <md-tooltip md-delay="500">\n                                                {{$ctrl.mediaList.updatedBy}}\n                                            </md-tooltip>\n                                        </b>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="list-data-spacer" hide-gt-sm></div>\n                            <div class="list-stats-section" layout="column" layout-align="space-between" flex="100" flex-gt-sm="50">\n                                <div layout="row" layout-align="space-between stretch">\n                                    <div class="stat" layout="column" layout-align="center center" flex="25">\n                                        <span class="stat-value">{{$ctrl.mediaList.distributions}}</span>\n                                        <span class="stat-name" translate>icm-web__media-list-engagement--emails-sent</span>\n                                    </div>\n                                    <div class="stat" layout="column" layout-align="center center" flex="25">\n                                        <span class="stat-value">{{$ctrl.mediaList.openRate}}%</span>\n                                        <span class="stat-name" translate>icm-web__media-list-engagement--open-rate</span>\n                                    </div>\n                                    <div class="stat" layout="column" layout-align="center center" flex="25">\n                                        <span class="stat-value">{{$ctrl.mediaList.clickToOpenRate}}%</span>\n                                        <span class="stat-name" translate>icm-web__media-list-engagement--click-rate</span>\n                                    </div>\n                                    <div class="stat" layout="column" layout-align="center center" flex="25">\n                                        <span class="stat-value">{{$ctrl.mediaList.unsubscribeRate}}%</span>\n                                        <span class="stat-name" translate>icm-web__media-list-engagement--unsubscribe-rate</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var EmptyStateController = function () {
        function EmptyStateController($translate, ContactManagerNavigationService) {
            _classCallCheck(this, EmptyStateController);

            this.$translate = $translate;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.addContactButtonLabel = this.$translate.instant('icm-medialist__empty-state--add-contact-button');
            this.searchContactsButtonLabel = this.$translate.instant('icm-medialist__empty-state--search-contacts-button');
        }

        _createClass(EmptyStateController, [{
            key: 'addContact',
            value: function addContact() {
                this.ContactManagerNavigationService.goToContactAddLanding();
            }
        }, {
            key: 'goToSearchPage',
            value: function goToSearchPage() {
                this.ContactManagerNavigationService.goToSearch();
            }
        }]);

        return EmptyStateController;
    }();

    angular.module('MW.ContactManager.MediaListEmptyState', ['ngMaterial', 'MW.ContactManager.ContactManagerNavigationService']).component('mediaListEmptyState', {
        bindings: {
            text: '@',
            subText: '@',
            includeElevio: '<'
        },
        controller: ['$translate', 'ContactManagerNavigationService', EmptyStateController],
        template: '\n        <md-card class="empty-state-page mw-empty-state__wrapper">\n            <md-card-content class="mw-empty-state-container">\n                <mw-empty-state icon="icm:influencer-lady" icon-size="large" class="empty-state-main">\n                    <mw-empty-state-text translate>{{$ctrl.text}}</mw-empty-state-text>\n                    <mw-empty-state-sub-text class="description" translate>{{$ctrl.subText}}</mw-empty-state-sub-text>\n                    <mw-empty-state-actions>\n                        <md-button class="mw-button mw-button--outlined" ng-click="$ctrl.addContact()">{{$ctrl.addContactButtonLabel}}</md-button>\n                        <md-button class="mw-button md-primary" ng-click="$ctrl.goToSearchPage()">{{$ctrl.searchContactsButtonLabel}}</md-button>\n                    </mw-empty-state-actions>\n                </mw-empty-state>\n                <mw-empty-state ng-if="$ctrl.includeElevio" class="empty-state-footer">\n                    <mw-empty-state-sub-text class="description" translate>media-relations-media-lists-empty-state__subtext</mw-empty-state-sub-text>\n                    <mw-empty-state-sub-text class="guide">\n                        <div>\n                            <a translate href="https://help.meltwater.com/en/collections/7170073-media-relations-distribute-press-releases-organize-campaigns-and-manage-pr-relationships" target="_blank">media-relations-media-lists-empty-state__link</a>\n                        </div>\n                    </mw-empty-state-sub-text>    \n            </md-card-content>\n        </md-card>    \n\n        '
    });
})(window.angular);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var MediaListEngagementWidget = function () {
        function MediaListEngagementWidget(MediaListService, CoreUserService, EmailAnalyticsService, $translate, $timeout) {
            _classCallCheck(this, MediaListEngagementWidget);

            this.mediaListService = MediaListService;
            this.coreUserService = CoreUserService;
            this.emailAnalyticsService = EmailAnalyticsService;
            this.$translate = $translate;
            this.$timeout = $timeout;

            // Left this here as a way to quickly test any layout changes we make along the way.
            // Uncommenting out these stats will show us where we intent to get to, so we can tweak
            //   styles/responsiveness appropriately
            // this.openRate = '72%';
            // this.ctoRate = '30%';
            // this.unsubscribeRate = '1.2%';
        }

        _createClass(MediaListEngagementWidget, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                if (this.mediaListId) {
                    this.emailAnalyticsService.getMediaListAggregations(this.mediaListId).then(function (results) {
                        var sentLabelString = _this.$translate.instant('icm-web__media-list-engagement--emails-sent');
                        _this.emailsSent = results.distributions;
                        _this.emailsSentLabel = sentLabelString;
                        _this.openRate = results.openRate + '%';
                        _this.ctoRate = results.clickRate + '%';
                        _this.unsubscribeRate = results.unsubscribeRate + '%';

                        // re-check the statistics after 2.5 seconds to ensure the up-to-date data.
                        _this.checkStatisticsDelay = _this.$timeout(function () {
                            _this.emailAnalyticsService.getMediaListAggregations(_this.mediaListId).then(function (data) {
                                _this.emailsSent = data.distributions;
                                _this.emailsSentLabel = sentLabelString;
                                _this.openRate = data.openRate + '%';
                                _this.ctoRate = data.clickRate + '%';
                                _this.unsubscribeRate = data.unsubscribeRate + '%';
                            });
                        }, 2500);

                        _this.addDescriptionString = _this.$translate.instant('icm-web__media-list-engagement--add-description');
                    });
                }
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changeObj) {
                var _this2 = this;

                var updatedDate = changeObj.mediaListUpdatedDate,
                    updatedBy = changeObj.mediaListUpdatedBy,
                    createdDate = changeObj.mediaListCreatedDate,
                    createdBy = changeObj.mediaListCreatedBy;

                this.coreUserService.getCurrent(true).then(function (user) {
                    var userLanguage = user.language || 'en';

                    switch (userLanguage) {
                        case 'zh_CN':
                        case 'zh_TW':
                            userLanguage = 'zh';
                            break;
                    }
                    if (updatedDate && updatedDate.currentValue && updatedBy && updatedDate.currentValue !== updatedDate.previousValue && updatedBy.currentValue !== updatedBy.previousValue) {
                        _this2.updatedAt = _this2._formatDate(new Date(updatedDate.currentValue), userLanguage);
                        _this2.updatedAtByText = _this2.$translate.instant('icm-web__media-list-engagement--edited-by', {
                            editedDate: '<b>' + _this2.updatedAt + '</b>',
                            editedPersion: '<b>' + _this2.updatedBy + '</b>'
                        }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                    } else if (updatedDate && updatedDate.currentValue && updatedDate.currentValue !== updatedDate.previousValue) {
                        _this2.updatedAt = _this2._formatDate(new Date(updatedDate.currentValue), userLanguage);
                        _this2.updatedAtText = _this2.$translate.instant('icm-web__media-list-engagement--edited', {
                            editedDate: '<b>' + _this2.updatedAt + '</b>'
                        }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                    }
                    if (createdDate && createdBy) {
                        _this2.createdAt = _this2._formatDate(new Date(createdDate.currentValue), userLanguage);
                        _this2.createdAtByText = _this2.$translate.instant('icm-web__media-list-engagement--created-by', {
                            createdDate: '<b>' + _this2.createdAt + '</b>',
                            createdPerson: '<b>' + _this2.createdBy + '</b>'
                        }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                    } else if (createdDate) {
                        _this2.createdAt = _this2._formatDate(new Date(createdDate.currentValue), userLanguage);
                        _this2.createdAtText = _this2.$translate.instant('icm-web__media-list-engagement--created', {
                            createdDate: '<b>' + _this2.createdAt + '</b>'
                        }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');
                    }
                });
            }
        }, {
            key: '_formatDate',
            value: function _formatDate(dateObj, userLanguage) {
                return dateObj.toLocaleString(userLanguage, { month: 'long' }) + ' ' + dateObj.toLocaleString(userLanguage, { day: 'numeric' }) + ', ' + dateObj.toLocaleString(userLanguage, { year: 'numeric' });
            }
        }, {
            key: 'editListHandler',
            value: function editListHandler() {
                this.editList();
            }
        }]);

        return MediaListEngagementWidget;
    }();

    angular.module('MW.Influencers.MediaListEngagementWidget', ['MW.Influencers.MediaListService', 'MW.Framework.CoreUserService', 'MW.Influencers.EmailAnalyticsService']).component('mwMediaListEngagementWidget', {
        bindings: {
            mediaListId: '<',
            mediaListName: '<',
            mediaListDescription: '<',
            mediaListUpdatedDate: '<',
            editList: '&'
        },
        controller: ['MediaListService', 'CoreUserService', 'EmailAnalyticsService', '$translate', '$timeout', MediaListEngagementWidget],
        template: '\n                <md-card>\n                    <md-card-content layout-wrap layout="row" layout-align="space-between center">\n                        <div class="list-details-section" flex="100" flex-gt-sm="40" layout="column" layout-align="start start">\n                            <span class="list-name" layout="row">\n                                {{$ctrl.mediaListName}}\n                                <md-tooltip md-delay="500">\n                                    {{$ctrl.mediaListName}}\n                                </md-tooltip>\n                            </span>\n                            <span class="list-description" ng-if="$ctrl.mediaListDescription" layout="row">\n                                {{$ctrl.mediaListDescription}}\n                            </span>\n                            <a href ng-click="$ctrl.editListHandler()" class="add-description" ng-if="!$ctrl.mediaListDescription" layout="row" layout-align="start center">\n                                <span class="add-description-plus">+</span>\n                                <span class="add-description-label">{{$ctrl.addDescriptionString}}</span>\n                            </a>\n                            <span ng-bind-html="$ctrl.createdAtByText" class="list-details" ng-show="$ctrl.createdAtByText"></span>\n                            <span ng-bind-html="$ctrl.createdAtText" class="list-details" ng-show="$ctrl.createdAtText"></span>\n                            <span ng-bind-html="$ctrl.updatedAtByText" class="list-details" ng-show="$ctrl.updatedAtByText"></span>\n                            <span ng-bind-html="$ctrl.updatedAtText" class="list-details" ng-show="$ctrl.updatedAtText"></span>\n                        </div>\n                        <div class="list-stats-section" layout-wrap flex="100" flex-gt-sm="60" layout="row" layout-align="end center">\n                            <span class="stat-divider" hide show-gt-sm></span>\n                            <div flex class="stat-card" layout="column">\n                                <span class="stat-value">\n                                    {{$ctrl.emailsSent}}\n                                </span>\n                                <span translate class="stat-label">\n                                    {{$ctrl.emailsSentLabel}}\n                                </span>\n                            </div>\n                            <span ng-if="$ctrl.openRate" class="stat-divider"></span>\n                            <div ng-if="$ctrl.openRate" flex="25" class="stat-card" layout="column">\n                                <span class="stat-value">\n                                    {{$ctrl.openRate}}\n                                </span>\n                                <span translate class="stat-label">\n                                    icm-web__media-list-engagement--open-rate\n                                </span>\n                            </div>\n                            <span ng-if="$ctrl.ctoRate" class="stat-divider"></span>\n                            <div ng-if="$ctrl.ctoRate" flex="25" class="stat-card" layout="column">\n                                <span class="stat-value">\n                                    {{$ctrl.ctoRate}}\n                                </span>\n                                <span translate class="stat-label">\n                                    icm-web__media-list-engagement--click-rate\n                                </span>\n                            </div>\n                            <span ng-if="$ctrl.unsubscribeRate" class="stat-divider"></span>\n                            <div ng-if="$ctrl.unsubscribeRate" flex class="stat-card" layout="column">\n                                <span class="stat-value">\n                                    {{$ctrl.unsubscribeRate}}\n                                </span>\n                                <span translate class="stat-label">\n                                    icm-web__media-list-engagement--unsubscribe-rate\n                                </span>\n                            </div>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            '
    });
})(angular);
'use strict';

(function () {
    'use strict';

    function MwMediaListUpdateModal($translate, $element) {
        var descriptionTextArea = null;
        this.$translate = $translate;

        this.dialogTitle = this.$translate.instant('icm-web__list-of-lists--edit-list');

        this.nameInputLabel = this.$translate.instant('icm-web__media-list-modal--name-label');
        this.descriptionInputLabel = this.$translate.instant('icm-web__media-list-modal--list-description-label');

        this.okButtonText = this.$translate.instant('Save');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.errorMessages = {
            name: {
                required: 'icm-web__media-list-modal--name-required-error',
                maxLengthError: 'icm-web__media-list-modal--name-max-length-error',
                duplicate: 'icm-web__media-list-modal--duplicate-name-error'
            },
            description: {
                maxLengthError: 'icm-web__media-list-modal--description-max-length-error'
            }
        };

        this.duplicateName = '';
        this.setDuplicateNameErrorState = function setDuplicateNameErrorState() {
            this.duplicateName = this.mediaList.name;

            this.mediaListForm.mediaListName.$error['duplicate-name'] = true;
            this.mediaListForm.mediaListName.$invalid = true;
        };
        this.clearDuplicateNameErrorState = function clearDuplicateNameErrorState() {
            if (this.mediaListForm && this.mediaListForm.mediaListName && this.mediaListForm.mediaListName.$error['duplicate-name']) {
                delete this.mediaListForm.mediaListName.$error['duplicate-name'];

                if (Object.keys(this.mediaListForm.mediaListName.$error).length === 0) {
                    this.mediaListForm.mediaListName.$invalid = false;
                }
            }
        };

        this.$postLink = function postLink() {
            descriptionTextArea = $element.find('.media-list-description textarea');

            if (descriptionTextArea) {
                descriptionTextArea.on('keypress', function (event) {
                    // prevent user from entering newlines into textarea
                    if (event.keyCode === 13) {
                        event.preventDefault();
                    }
                });
            }
        };

        this.$onDestroy = function onDestroy() {
            if (descriptionTextArea) {
                descriptionTextArea.off('keypress');
            }
        };

        // watch for changes to the bindings.
        // this is here to capture certain server side errors that we wish to display in the modal.
        this.$onChanges = function onBindingChanges(changes) {
            if (changes.duplicateError) {
                if (changes.duplicateError.currentValue === true) {
                    this.setDuplicateNameErrorState();
                } else {
                    this.clearDuplicateNameErrorState();
                }
            }
        };

        // watch the media list name for changes.
        // we want to do this to manually set/reset server side errors we may have manually set.
        this.onNameChange = function onNameChange() {
            if (this.duplicateError && this.mediaList.name !== this.duplicateName) {
                this.duplicateError = false;
                this.clearDuplicateNameErrorState();
            } else if (this.mediaList.name === this.duplicateName) {
                this.duplicateError = true;
                this.setDuplicateNameErrorState();
            }
        };

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (this.mediaListForm.$valid && !this.mediaListForm.mediaListName.$invalid) {
                this.okCallback({ updatedMediaList: this.mediaList });
            }
        };
    }

    angular.module('MW.ContactManager.MwMediaListUpdateModal', []).component('mwMediaListUpdateModal', {
        bindings: {
            cancelCallback: '&',
            okCallback: '&',
            mediaList: '<',
            duplicateError: '<'
        },
        controller: ['$translate', '$element', MwMediaListUpdateModal],
        template: '\n                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">\n                    <mw-modal-content>\n                        <ng-form name="$ctrl.mediaListForm">\n                            <div layout="column">\n                                <md-input-container class="media-list-name" md-is-error="$ctrl.mediaListForm.mediaListName.$invalid">\n                                    <label>{{$ctrl.nameInputLabel}}</label>\n                                    <input required="" name="mediaListName" md-autofocus="true" ng-model="$ctrl.mediaList.name" ng-change="$ctrl.onNameChange()" md-maxlength="190"/>\n                                    <div ng-messages="$ctrl.mediaListForm.mediaListName.$error">\n                                        <div ng-message="required" translate>{{$ctrl.errorMessages.name.required}}</div>\n                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.name.maxLengthError}}</div>\n                                        <div ng-message="duplicate-name" translate>{{$ctrl.errorMessages.name.duplicate}}</div>\n                                    </div>\n                                </md-input-container>\n                                <md-input-container class="media-list-description" md-is-error="$ctrl.mediaListForm.mediaListDescription.$invalid">\n                                    <label>{{$ctrl.descriptionInputLabel}}</label>\n                                    <textarea name="mediaListDescription" md-autofocus="false" ng-model="$ctrl.mediaList.description" md-maxlength="150" rows="1" wrap="soft"/>\n                                    <div ng-messages="$ctrl.mediaListForm.mediaListDescription.$error">\n                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.description.maxLengthError}}</div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n                        </ng-form>\n                    </mw-modal-content>\n                </mw-mini-modal-dialog>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    function MwOutreachPreviewModal($translate) {
        this.$translate = $translate;

        this.dialogTitle = this.$translate.instant('icm-outreach__email-preview--preview-dialog-header');

        this.recipientLabel = this.$translate.instant('icm-outreach__email-preview--preview-dialog-label');
        this.pluralMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-fields-label');
        this.singularMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-field-label');
        this.firstNameLabel = this.$translate.instant('icm-outreach__email-preview--first-name-label');
        this.lastNameLabel = this.$translate.instant('icm-outreach__email-preview--last-name-label');

        this.okButtonText = this.$translate.instant('Send');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.mergeFieldsLabel = '';
        if (this.showFirstNameField && this.showLastNameField) {
            this.mergeFieldsLabel = this.pluralMergeFieldsLabel;
        } else {
            if (this.showFirstNameField || this.showLastNameField) {
                this.mergeFieldsLabel = this.singularMergeFieldsLabel;
            }
        }

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (this.previewForm.$valid && !this.previewForm.email.$invalid) {
                this.okCallback({ data: this.data });
            }
        };
    }

    angular.module('MW.ContactManager.MwOutreachPreviewModal', []).component('mwOutreachPreviewModal', {
        bindings: {
            cancelCallback: '&',
            okCallback: '&',
            emailPattern: '<',
            showFirstNameField: '<',
            showLastNameField: '<',
            data: '<'
        },
        controller: ['$translate', MwOutreachPreviewModal],
        template: '\n                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">\n                    <mw-modal-content>\n                        <ng-form name="$ctrl.previewForm">\n                            <div layout="column">\n                                <md-input-container class="recipient" md-is-error="$ctrl.previewForm.email.$dirty && $ctrl.previewForm.email.$invalid">\n                                    <label>{{$ctrl.recipientLabel}}</label>\n                                    <input required="" name="email" md-autofocus="true" ng-model="$ctrl.data.email" ng-pattern="$ctrl.emailPattern" />\n                                </md-input-container>\n                                <div layout="row" class="merge-field-description" ng-if="$ctrl.mergeFieldsLabel.length">{{$ctrl.mergeFieldsLabel}}</div>\n                                <div layout="row">\n                                    <md-input-container ng-if="$ctrl.showFirstNameField" class="first-name flex mw-flex-padding">\n                                        <label>{{$ctrl.firstNameLabel}}</label>\n                                        <input name="firstName" ng-model="$ctrl.data.firstName" md-autofocus="false" placeholder="John" />\n                                    </md-input-container>\n                                    <div layout="column" ng-if="$ctrl.showFirstNameField && $ctrl.showLastNameField" class="column-padding mw-flex-padding"></div>\n                                    <md-input-container ng-if="$ctrl.showLastNameField" class="last-name flex mw-flex-padding">\n                                        <label>{{$ctrl.lastNameLabel}}</label>\n                                        <input name="lastName" ng-model="$ctrl.data.lastName" md-autofocus="false" placeholder="Smith" />\n                                    </md-input-container>\n                                </div>\n                            </div>\n                        </ng-form>\n                    </mw-modal-content>\n                </mw-mini-modal-dialog>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var OutreachTemplate = function () {
        function OutreachTemplate($scope, $timeout, $translate, $mdDialog, $mdToast, EmailTemplateService, mwBannerService, mwCustomToastService, VALIDATION_CONSTANTS, ContactManagerNavigationService, CoreUserService, OutreachService, mwCustomBannerService) {
            _classCallCheck(this, OutreachTemplate);

            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
            this.$mdToast = $mdToast;
            this.EmailTemplateService = EmailTemplateService;
            this.mwCustomToastService = mwCustomToastService;
            this.CoreUserService = CoreUserService;
            this.OutreachService = OutreachService;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.mwCustomBannerService = mwCustomBannerService;
            this.mwBannerService = mwBannerService;
            this.template = {};
            this.shouldValidateForm = false;

            this.EMAIL_ADDRESS_REGEX = VALIDATION_CONSTANTS.EMAIL_REGEX;
            this.currentUser = this.CoreUserService.getCurrent();
            this.isSaving = false;
            this.invalidTemplateBody = false;
            this.isBusy = false;
        }

        _createClass(OutreachTemplate, [{
            key: '$onInit',
            value: function $onInit() {
                this.templateTitle = this.templateTitle || '';

                this.templateId = this.templateId || null;
                this.messageBodyText = this.templateBody || '';
                this.modalHeader = this.$translate.instant('icm-outreach__template--create-template-header');
                this.saveButton = this.$translate.instant('icm-outreach__template--save-changes-button');
                this.doneButton = this.$translate.instant('icm-outreach__template--done-button');
                this.previewButton = this.$translate.instant('icm-outreach__template--send-preview-button');

                this.saveToastMessage = this.$translate.instant('icm-outreach__template--save-toast-message');
                this.doneToastMessage = this.$translate.instant('icm-outreach__template--done-toast-message');
                this.closeDialogHeader = this.$translate.instant('icm-outreach__template--close-dialog-header');
                this.closeDialogBody = this.$translate.instant('icm-outreach__template--close-dialog-body');
                this.closeDialogOkButton = this.$translate.instant('icm-outreach__template--close-dialog-ok-button-text');
                this.closeDialogCancelButton = this.$translate.instant('icm-outreach__template--close-dialog-cancel-button-test');

                this.noNameError = this.$translate.instant('icm-outreach__template--no-name-error');
                this.maxLengthNameError = this.$translate.instant('icm-outreach__template--max-length-name-error');
                this.duplicateNameError = this.$translate.instant('icm-outreach__template--duplicate-name-error');
                this.alertBannerText = this.$translate.instant('icm-outreach__template--alert-banner-text');
                this.alertBannerRetry = this.$translate.instant('icm-outreach__template--alert-banner-retry');
                this.noBodyError = this.$translate.instant('icm-outreach__template--no-body-error');

                this.firstNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder');
                this.lastNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder');

                this.editorOptions = {
                    /* jshint camelcase: false */
                    extended_valid_elements: 'first_name,last_name',
                    plugins: 'autolink autoresize image link lists textcolor code noneditable powerpaste',
                    toolbar: 'fontselect | fontsizeselect | bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code',
                    link_assume_external_targets: true
                };
            }
        }, {
            key: 'updateEditorBusy',
            value: function updateEditorBusy(isBusy) {
                this.isBusy = isBusy;

                this.$timeout(function applyChanges() {
                    this.$scope.$apply();
                }.bind(this), 0);
            }
        }, {
            key: 'clearFormErrors',
            value: function clearFormErrors() {
                this.shouldValidateForm = false;
                if (this.$scope.templateForm) {
                    this.$scope.templateForm.templateTitle.$setValidity('duplicate', true);
                }
                this.isSaving = false;
                this.invalidTemplateBody = false;
            }
        }, {
            key: 'showPlainAlertBanner',
            value: function showPlainAlertBanner(alertMessage) {
                this.mwBannerService.open({
                    attachTo: angular.element(document.getElementsByClassName('mw-flexi-modal')[0]),
                    template: '\n                  <mw-banner class="outreach-template-alert-banner" type="\'alert\'" on-close="$ctrl.close()">\n                      {{$ctrl.alertBannerText}}\n                  </mw-banner>\n                ',
                    controller: function () {
                        BannerPanel.$inject = ["mdPanelRef"];
                        function BannerPanel(mdPanelRef) {
                            'ngInject';

                            _classCallCheck(this, BannerPanel);

                            this.alertBannerText = alertMessage;
                            this.mdPanelRef = mdPanelRef;
                        }

                        _createClass(BannerPanel, [{
                            key: 'close',
                            value: function close() {
                                this.mdPanelRef.close();
                            }
                        }]);

                        return BannerPanel;
                    }()
                });
            }
        }, {
            key: 'openAlertBanner',
            value: function openAlertBanner(retryCallback) {
                var outreachTemplateController = this;
                var attachTo = angular.element(document.getElementsByClassName('mw-flexi-modal')[0]);

                this.mwCustomBannerService.alertWithRetry(this.alertBannerText, retryCallback, null, outreachTemplateController, attachTo, true);
            }
        }, {
            key: 'saveTemplateNoCallback',
            value: function saveTemplateNoCallback() {
                var _this2 = this;

                this.shouldValidateForm = true;
                var templateId = this.templateId;
                var templateName = this.templateTitle;
                var templateBody = this.messageBodyText;
                if (this.$scope.templateForm.$invalid) {
                    return Promise.reject();
                } else if (templateBody.length === 0) {
                    this.invalidTemplateBody = true;
                    return Promise.reject();
                } else {
                    if (!templateId) {
                        return this.EmailTemplateService.createTemplate(templateName, templateBody).then(function (result) {
                            return Promise.resolve(result);
                        }).catch(function (error) {
                            _this2.handleError(error, _this2.save);
                            return Promise.reject();
                        });
                    } else {
                        return this.EmailTemplateService.updateTemplate(templateId, templateName, templateBody).then(function (result) {
                            return Promise.resolve(result);
                        }).catch(function (error) {
                            _this2.handleError(error, _this2.save);
                            return Promise.reject();
                        });
                    }
                }
            }
        }, {
            key: 'saveTemplate',
            value: function saveTemplate(retryCallback) {
                var _this3 = this;

                this.shouldValidateForm = true;

                var templateId = this.templateId;
                var templateName = this.templateTitle;
                var templateBody = this.messageBodyText;
                if (this.$scope.templateForm.$invalid) {
                    return Promise.reject();
                } else if (templateBody.length === 0) {
                    this.invalidTemplateBody = true;
                    return Promise.reject();
                } else {
                    if (!templateId) {
                        return this.EmailTemplateService.createTemplate(templateName, templateBody).then(function (result) {
                            _this3.templateId = result.data.templateId;

                            _this3.onCallback();
                            return Promise.resolve(result);
                        }).catch(function (error) {
                            _this3.handleError(error, retryCallback);
                            return Promise.reject();
                        });
                    } else {
                        return this.EmailTemplateService.updateTemplate(templateId, templateName, templateBody).then(function (result) {
                            _this3.onCallback();
                            return Promise.resolve(result);
                        }).catch(function (error) {
                            _this3.handleError(error, retryCallback);
                            return Promise.reject();
                        });
                    }
                }
            }
        }, {
            key: 'previewTemplate',
            value: function previewTemplate() {
                if (this.approvedSenders.length > 0) {
                    this.showPreviewEmailModal();
                } else {
                    this.showNoApprovedSenders();
                }
            }
        }, {
            key: 'showNoApprovedSenders',
            value: function showNoApprovedSenders() {
                var _this4 = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().title(this.$translate.instant('icm-outreach__template--preview-dialog-title')).textContent(this.$translate.instant('You need to set up your email account before you can send email.')).ok(this.$translate.instant('icm-outreach__template--preview-email-config-button')).cancel(this.$translate.instant('Cancel')).multiple(true).parent(angular.element(document.getElementsByClassName('mw-flexi-modal')[0]))).then(function () {
                    _this4.saveTemplateNoCallback().then(function () {
                        this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
                    }.bind(_this4));
                });
            }
        }, {
            key: 'showPreviewEmailModal',
            value: function showPreviewEmailModal() {
                var _this = this;
                this.hasFirstNameMailMergeField = this.messageBodyText.indexOf(this.firstNamePlaceholderText) > -1;
                this.hasLastNameMailMergeField = this.messageBodyText.indexOf(this.lastNamePlaceholderText) > -1;
                this.$mdDialog.show({
                    bindToController: true,
                    targetEvent: event,
                    locals: {
                        EMAIL_ADDRESS_REGEX: this.EMAIL_ADDRESS_REGEX,
                        hasFirstNameMailMergeField: this.hasFirstNameMailMergeField,
                        hasLastNameMailMergeField: this.hasLastNameMailMergeField,
                        data: {
                            email: this.currentUser.email
                        },
                        cancelDialog: function cancelDialog() {
                            _this.$mdDialog.cancel();
                        },
                        approvedSenders: this.approvedSenders,
                        okDialog: function okDialog(data) {
                            _this.sendTemplatePreview(data);
                            _this.$mdDialog.hide();
                        }
                    },
                    template: '\n                    <md-dialog id="icm-outreach-template-preview-modal" class="mw-mini-modal mw-mini-modal--wide" aria-label="" layout="column">\n                        <mw-outreach-template-preview-modal class="mw-mini-modal-wrapper" layout="column" data="$ctrl.data" email-pattern="$ctrl.EMAIL_ADDRESS_REGEX" show-first-name-field="$ctrl.hasFirstNameMailMergeField" show-last-name-field="$ctrl.hasLastNameMailMergeField" ok-callback="$ctrl.okDialog(data)" cancel-callback="$ctrl.cancelDialog()" approved-sender-array="$ctrl.approvedSenders"></mw-outreach-template-preview-modal>\n                    </md-dialog>\n                ',
                    parent: angular.element(document.getElementsByClassName('mw-flexi-modal')[0]),
                    multiple: true,
                    // This is a globally available controller for the purposes of attaching locals for data binding
                    controller: 'MwMiniModalDialogController',
                    controllerAs: '$ctrl'
                });
            }
        }, {
            key: 'sendTemplatePreview',
            value: function sendTemplatePreview(data) {
                var _this5 = this;

                var senderData = JSON.parse(data.sender),
                    sender = senderData.payloadEmail || '',
                    senderId = senderData.id || '',
                    recipient = {
                    private: true,
                    email: data.email,
                    name: data.email,
                    lastName: data.lastName,
                    firstName: data.firstName,
                    id: null
                },
                    payload = {
                    recipients: [recipient],
                    mediaLists: [],
                    subject: this.templateTitle + ' (' + this.$translate.instant('icm-outreach__email-preview--preview-subject-tag') + ')',
                    bodyHtml: this.messageBodyText,
                    fromAddress: sender,
                    userLanguage: this.currentUser.language,
                    approvedSenderId: senderId,
                    firstNamePlaceholder: this.firstNamePlaceholderText,
                    lastNamePlaceholder: this.lastNamePlaceholderText,
                    sendImmediately: true,
                    isPreview: true,
                    attachments: [],
                    templateId: this.templateId || ''
                };

                this.OutreachService.outreach(payload, this.fileUploadList).then(function () {
                    _this5.$mdToast.show(_this5.mwCustomToastService.simpleTimedClosable(_this5.$translate.instant('icm-outreach__template--preview-dialog-success-toast', { recipient: recipient.email })));
                }).catch(function onError() {
                    this.showPlainAlertBanner(this.$translate.instant('icm-outreach__template--alert-preview-banner-text'));
                }.bind(this));
            }
        }, {
            key: 'handleError',
            value: function handleError(error, retryCallback) {
                if (error && error.data && error.data.code) {
                    switch (error.data.code) {
                        case 'ER_DUP_ENTRY':
                            this.$scope.templateForm.templateTitle.$setValidity('duplicate', false);
                            break;
                        default:
                            this.openAlertBanner(retryCallback);
                            break;
                    }
                } else {
                    this.openAlertBanner(retryCallback);
                }
            }
        }, {
            key: 'close',
            value: function close(ev) {
                var _this6 = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().title(this.closeDialogHeader).textContent(this.closeDialogBody).ok(this.closeDialogOkButton).cancel(this.closeDialogCancelButton).targetEvent(ev)).then(function () {
                    _this6.$mdDialog.cancel();
                });
            }
        }, {
            key: 'save',
            value: function save() {
                var _this7 = this;

                var outreachTemplateController = this;
                this.isSaving = true;

                this.saveTemplate(this.save).then(function () {
                    _this7.$mdToast.show(_this7.mwCustomToastService.simpleTimedClosable(outreachTemplateController.saveToastMessage));
                    _this7.isSaving = false;
                });
            }
        }, {
            key: 'saveAndClose',
            value: function saveAndClose() {
                var _this8 = this;

                var outreachTemplateController = this;
                this.isSaving = true;

                this.saveTemplate(this.saveAndClose).then(function () {
                    _this8.$mdDialog.cancel();

                    _this8.$mdToast.show(_this8.mwCustomToastService.simpleTimedClosable(outreachTemplateController.doneToastMessage));
                });
            }
        }]);

        return OutreachTemplate;
    }();

    angular.module('MW.Influencers.OutreachTemplate', ['ngMaterial', 'MW.Influencers.EmailTemplateService', 'mwAppComponents', 'MW.ContactManager.CustomToastService', 'MW.Framework.ValidationConstants', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.CoreUserService', 'MW.ContactManager.OutreachService', 'MW.ContactManager.MwOutreachTemplatePreviewModal', 'MW.ContactManager.CustomBannerService']).component('mwOutreachTemplate', {
        controller: ['$scope', '$timeout', '$translate', '$mdDialog', '$mdToast', 'EmailTemplateService', 'mwBannerService', 'mwCustomToastService', 'VALIDATION_CONSTANTS', 'ContactManagerNavigationService', 'CoreUserService', 'OutreachService', 'mwCustomBannerService', OutreachTemplate],
        bindings: {
            templateId: '<',
            templateTitle: '<',
            templateBody: '<',
            approvedSenders: '<',
            onCallback: '&'
        },
        template: '\n            <md-dialog class="mw-flexi-modal" aria-label="Fleximodal" layout="column">\n                <mw-flexi-modal-header on-close="$ctrl.close()">{{$ctrl.modalHeader}}</mw-flexi-modal-header>\n                <md-dialog-content class="mw-flex-padding" layout="column" flex>\n                    <form name="templateForm">\n                        <input type="text" id="initFocus" style="display: none;" />\n                        <div class="content-wrapper">\n                            <md-card>\n                                <md-card-title>\n                                    <span translate>icm-outreach__template--template-details-header\n                                </md-card-title>\n                                <md-card-content layout="row" layout-align="space-around">\n                                    <md-input-container md-is-error="$ctrl.shouldValidateForm && !templateForm.templateTitle.$valid">\n                                        <label translate>icm-outreach__template--template-name</label>\n                                        <input ng-change="$ctrl.clearFormErrors()" ng-model="$ctrl.templateTitle" name="templateTitle" required="required" md-maxlength="75" />\n                                        <div ng-messages="templateForm.templateTitle.$error">\n                                            <div ng-message="required">{{$ctrl.noNameError}}</div>\n                                            <div ng-message="md-maxlength">{{$ctrl.maxLengthNameError}}</div>\n                                            <div ng-message="duplicate">{{$ctrl.duplicateNameError}}</div>\n                                        </div>\n                                    </md-input-container>\n                                </md-card-content>\n                            </md-card>\n                            <h3 translate>icm-outreach__template--template-content-header</h3>\n                            <div class="textEditor">\n                                <textarea class=\'editor\' tinymce-editor-v5 tinymce-editor-options="$ctrl.editorOptions", ng-model="$ctrl.messageBodyText", stick-to=".application-canvas", busy-callback="$ctrl.updateEditorBusy(isBusy)" ng-change="$ctrl.clearFormErrors()"></textarea>\n                            </div>\n                            <div>\n                                <span class="template-error" ng-if="$ctrl.invalidTemplateBody">{{$ctrl.noBodyError}}</span>\n                                <span flex></span>\n                                <md-button ng-disabled="$ctrl.messageBodyText.length === 0 || $ctrl.templateTitle.length ===0"ng-click="$ctrl.previewTemplate()" class="preview-btn mw-button mw-button--outlined right">{{$ctrl.previewButton}}</md-button>\n                            </div>\n                            <div flex></div>\n                        </div>\n                    </form>\n                </md-dialog-content>\n                <md-dialog-actions layout="row">\n                    <md-button class="mw-button mw-button--outlined" ng-click="$ctrl.save()" ng-disabled="$ctrl.isSaving || $ctrl.isBusy">{{$ctrl.saveButton}}</md-button>\n                    <md-button class="mw-button md-primary" ng-click="$ctrl.saveAndClose()" ng-disabled="$ctrl.isSaving || $ctrl.isBusy">{{$ctrl.doneButton}}</md-button>\n                </md-dialog-actions>\n            </md-dialog>\n            '
    });
})(angular);
'use strict';

(function () {
    'use strict';

    function MwOutreachTemplatePreviewModal($translate) {
        this.$translate = $translate;
        this.dialogTitle = this.$translate.instant('Send Preview');
        this.recipientLabel = this.$translate.instant('icm-outreach__email-preview--preview-dialog-label');
        this.senderLabel = this.$translate.instant('icm-outreach__template--preview-dialog-sender');
        this.pluralMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-fields-label');
        this.singularMergeFieldsLabel = this.$translate.instant('icm-outreach__email-preview--optional-field-label');
        this.firstNameLabel = this.$translate.instant('icm-outreach__email-preview--first-name-label');
        this.lastNameLabel = this.$translate.instant('icm-outreach__email-preview--last-name-label');
        this.validEmailError = this.$translate.instant('icm-outreach__template--preview-email-error');

        this.okButtonText = this.$translate.instant('OK');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.$onInit = function () {
            if (this.approvedSenderArray) {
                this.approvedSenderArray.forEach(function (approveSender) {
                    approveSender.displayEmail = approveSender.name + ' (' + approveSender.email + ')';
                    approveSender.payloadEmail = approveSender.name + ' <' + approveSender.email + '>';
                });
            }

            this.mergeFieldsLabel = '';
            if (this.showFirstNameField && this.showLastNameField) {
                this.mergeFieldsLabel = this.pluralMergeFieldsLabel;
            } else {
                if (this.showFirstNameField || this.showLastNameField) {
                    this.mergeFieldsLabel = this.singularMergeFieldsLabel;
                }
            }

            // --------------
            // Modal Actions
            // --------------
            this.cancelModal = function cancelModal() {
                this.cancelCallback();
            };

            this.okModal = function okModal() {
                if (this.previewForm.$valid && !this.previewForm.email.$invalid) {
                    this.okCallback({ data: this.data });
                }
            };
        };
    }

    angular.module('MW.ContactManager.MwOutreachTemplatePreviewModal', []).component('mwOutreachTemplatePreviewModal', {
        bindings: {
            cancelCallback: '&',
            okCallback: '&',
            emailPattern: '<',
            showFirstNameField: '<',
            showLastNameField: '<',
            approvedSenderArray: '<',
            data: '<'
        },
        controller: ['$translate', MwOutreachTemplatePreviewModal],
        template: '\n                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">\n                    <mw-modal-content>\n                        <ng-form name="$ctrl.previewForm">\n                            <div layout="column">\n                                <md-input-container flex="50" ng-if="$ctrl.approvedSenderArray.length > 0">\n                                    <label>{{$ctrl.senderLabel}}</label>\n                                    <md-select ng-model="$ctrl.data.sender" md-no-ink>\n                                        <md-option class="template-preview-approved-sender-option" ng-repeat="sender in $ctrl.approvedSenderArray" value="{{sender}}" ng-selected="$first" >{{sender.displayEmail}}</md-option>\n                                    </md-select>\n                                </md-input-container>\n                                <md-input-container class="recipient" md-is-error="$ctrl.previewForm.email.$dirty && $ctrl.previewForm.email.$invalid">\n                                    <label>{{$ctrl.recipientLabel}}</label>\n                                    <input required="" name="email" md-autofocus="true" ng-model="$ctrl.data.email" ng-pattern="$ctrl.emailPattern" />\n                                    <div class="md-errors-spacer"></div>\n                                    <div ng-messages="$ctrl.previewForm.email.$error">\n                                        <div ng-message="pattern">{{$ctrl.validEmailError}}</div>\n                                    </div>\n                                </md-input-container>\n                                <div layout="row" class="merge-field-description" ng-if="$ctrl.mergeFieldsLabel.length">{{$ctrl.mergeFieldsLabel}}</div>\n                                <div layout="row">\n                                    <md-input-container ng-if="$ctrl.showFirstNameField" class="first-name flex mw-flex-padding">\n                                        <label>{{$ctrl.firstNameLabel}}</label>\n                                        <input name="firstName" ng-model="$ctrl.data.firstName" md-autofocus="false" placeholder="John" />\n                                    </md-input-container>\n                                    <div layout="column" ng-if="$ctrl.showFirstNameField && $ctrl.showLastNameField" class="column-padding mw-flex-padding"></div>\n                                    <md-input-container ng-if="$ctrl.showLastNameField" class="last-name flex mw-flex-padding">\n                                        <label>{{$ctrl.lastNameLabel}}</label>\n                                        <input name="lastName" ng-model="$ctrl.data.lastName" md-autofocus="false" placeholder="Smith" />\n                                    </md-input-container>\n                                </div>\n                            </div>\n                        </ng-form>\n                    </mw-modal-content>\n                </mw-mini-modal-dialog>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var SearchEmptyState = function () {
        function SearchEmptyState($translate, $mdDialog, $scope, $window, FeedbackService) {
            _classCallCheck(this, SearchEmptyState);

            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
            this.$scope = $scope;
            this.$window = $window;
            this.FeedbackService = FeedbackService;
            this.FeedbackService.initializeMissingContact();
        }

        _createClass(SearchEmptyState, [{
            key: 'clearSearch',
            value: function clearSearch() {
                this.$scope.$emit('clearAll');
            }
        }, {
            key: 'handleOpenHelpCenter',
            value: function handleOpenHelpCenter() {
                this.$window.open('https://help.meltwater.com/');
            }
        }, {
            key: 'handleMediaResearchHelp',
            value: function handleMediaResearchHelp() {
                this.$window.open('https://help.meltwater.com/en/articles/4064620-how-to-do-media-research-in-meltwater-to-discover-relevant-influencers-and-publications');
            }
        }, {
            key: 'submitMissingContact',
            value: function submitMissingContact() {
                this.FeedbackService.initializeMissingContact();
                this.FeedbackService.showFeedbackModal();
            }
        }, {
            key: 'submitMissingSource',
            value: function submitMissingSource() {
                this.FeedbackService.initializeMissingSource();
                this.FeedbackService.showFeedbackModal();
            }
        }]);

        return SearchEmptyState;
    }();

    angular.module('MW.Influencers.SearchEmptyState', ['ngMaterial', 'MW.Influencers.FeedbackService']).component('searchEmptyState', {
        bindings: {
            contactSearch: '=',
            relevantSearch: '='
        },
        controller: ['$translate', '$mdDialog', '$scope', '$window', 'FeedbackService', SearchEmptyState],
        template: '\n            <div class="search-empty-state-container">\n                 <div ng-if="$ctrl.contactSearch"class="empty-state-img empty-contact"></div>\n                 <div ng-if="!$ctrl.contactSearch"class="empty-state-img empty-source"></div>\n                 <div class=\'search-empty-title\', translate>icm-search__empty-state--header</div>\n                 <div class=\'search-empty-description\', translate>icm-search__empty-state--description</div>\n                 <div class=\'search-empty-button-container\'>\n                    <div class=\'search-empty-action-buttons\'>\n                        <md-button ng-if="!$ctrl.relevantSearch && $ctrl.contactSearch", ng-click="$ctrl.submitMissingContact()" class="mw-button mw-button--outlined">\n                            <span translate>icm-search__empty-state--missing-contact-button</span>\n                        </md-button>\n                        <md-button ng-if="!$ctrl.relevantSearch && !$ctrl.contactSearch", ng-click="$ctrl.submitMissingSource()" class="mw-button mw-button--outlined">\n                            <span translate>icm-search__empty-state--missing-source-button</span>\n                        </md-button>\n                        <md-button class="mw-button md-primary", ng-click="$ctrl.clearSearch()">\n                            <span translate>icm-search__empty-state--clear-search-button</span>\n                        </md-button>\n                    </div>\n                    <div class=\'button-divider\'></div>\n                    <div class=\'search-empty-help-buttons\'>\n                        <md-button class="mw-button mw-button--link md-primary", ng-click="$ctrl.handleMediaResearchHelp()">\n                            <span translate>icm-search__empty-state--media-research-help-button</span>\n                        </md-button>\n                        <span class="help-buttons-divider">|</span>\n                        <md-button class="mw-button mw-button--link md-primary", ng-click="$ctrl.handleOpenHelpCenter()">\n                            <span translate>icm-search__empty-state--help-center-button</span>\n                        </md-button>\n                    <div class=\'search-empty-help-buttons\'>\n\n                 </div>\n            </div>\n        '
    });
})(window.angular);
'use strict';

(function () {
    'use strict';

    function MwSearchInputController($scope, $element, ContactManagerNavigationService, InfluencerContactService, $translate, $timeout) {
        var suggestList = $element.find('#suggest-list'),
            SUGGEST_DEBOUNCE_MS = 300,
            COMMA_KEYCODE = 188,
            TAB_KEYCODE = 9,
            ENTER_KEYCODE = 13,
            clickingSuggestList = false;

        this.$onInit = function $onInit() {
            var _this = this;

            this.whiteframe = -1;
            this.$translate = $translate;
            this.searchText = this.searchText || '';
            this.contacts = [];
            this.sources = [];
            this.autoSuggestPromise = null;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.InfluencerContactService = InfluencerContactService;
            this.showAutoSuggestAfterSearch = true;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.lastSearch = undefined;
            this.lastSearchType = undefined;
            this.hideSearchBarLoader = true;
            //chips stuff
            this.readOnly = false;
            this.removable = true;
            this.addOnBlur = false;
            this.customSeparatorKeys = [COMMA_KEYCODE, TAB_KEYCODE, ENTER_KEYCODE];

            // IE does not have event.relatedTarget on 'blur', so we need to track if we are clicking into the autosuggest list in this way.
            suggestList.on('mousedown', function onClick() {
                clickingSuggestList = true;
            });

            suggestList.on('mouseup', function onClick() {
                clickingSuggestList = false;
            });

            this.searchTypeOptions.forEach(function (searchType) {
                if (searchType.selected) {
                    _this.selectedSearchType = searchType.type;
                }
            });

            if (this.searchText.length > 0 && this.searchChips.length > 0) {
                var chipExists = this.searchChips.some(function (searchChipObject) {
                    return searchChipObject.type === 'standard' && searchChipObject.value.toLowerCase() === this.searchText.toLowerCase();
                }.bind(this));
                if (chipExists) {
                    this.searchText = '';
                }
            }
        };

        this.$onDestroy = function onDestroy() {
            suggestList.off('mousedown');
            suggestList.off('mouseup');

            $timeout.cancel(this.autoSuggestPromise);
        };

        this.onFocus = function onFocus() {
            this.whiteframe = 4;
            this.hasFocus = true;

            if (this.searchText && this.searchText.length > 1) {
                this.showAutoSuggestAfterSearch = true;
                this.getByContactAndSourceSuggest(this.searchText);
            }
        };

        this.onBlur = function onBlur() {
            this.whiteframe = -1;

            // if we clicked an auto-suggest option,
            // it will cause triggerSearch.
            // which will hide this after handling the click.
            // otherwise we hide it before the click action & nothing happens...
            if (!clickingSuggestList) {
                if (this.searchText.length > 0) {
                    this.addChip(this.searchText);
                }
                this.hasFocus = false;
                this.hideAutoSuggest();
            }
        };

        this.getByContactAndSourceSuggest = function getByContactAndSourceSuggest(searchText) {
            var searchType = this.isContactSearch ? 'contact' : 'source';

            // cache last query
            if (searchText !== this.lastSearch || searchType !== this.lastSearchType) {
                this.hideSearchBarLoader = false;
                return this.InfluencerContactService.getByContactAndSourceSuggest(searchText).then(function (response) {
                    this.lastSearch = searchText;
                    this.lastSearchType = searchType;
                    this.contacts = [];
                    this.sources = [];

                    if (searchType === 'contact') {
                        for (var i = 0; i < response.contacts.length; i++) {
                            var currentContact = response.contacts[i];
                            if (currentContact.sourceSnippets) {
                                currentContact.sourceList = currentContact.sourceSnippets.map(function (element) {
                                    return element.name;
                                }).join(', ');
                            }
                        }
                        this.contacts = response.contacts;
                    } else if (searchType === 'source') {
                        this.sources = response.sources;
                    }

                    if (this.showAutoSuggestAfterSearch) {
                        this.showAutoSuggest();
                    } else {
                        this.showAutoSuggestAfterSearch = true;
                    }

                    this.hideSearchBarLoader = true;
                }.bind(this));
            } else {
                if (this.showAutoSuggestAfterSearch) {
                    this.showAutoSuggest();
                }
            }
        };

        this.hideAutoSuggest = function hideAutoSuggest() {
            if (!$timeout.cancel(this.autoSuggestPromise)) {
                this.showAutoSuggestAfterSearch = false;
            }

            suggestList.hide();
            this.autoSuggestToggle({ isVisible: false });
        };

        this.showAutoSuggest = function showAutoSuggest() {
            suggestList.show();
            this.autoSuggestToggle({ isVisible: true });
        };

        this.goToSource = function goToSource(sourceId) {
            this.clearAndUpdateSearchText();

            this.ContactManagerNavigationService.goToSourceDetailView(sourceId);
        }.bind(this);

        this.goToContact = function goToContact(contactId) {
            this.clearAndUpdateSearchText();

            this.ContactManagerNavigationService.goToProfileView(contactId);
        }.bind(this);

        this.searchTextChanged = function searchTextChanged(searchText) {
            if (this.onTextChange) {
                this.onTextChange({ searchText: searchText });
            }

            if (searchText) {
                // debounce this in a way that can be cancelled,
                // for when we hide the suggestions (ex. on-enter, blur)
                $timeout.cancel(this.autoSuggestPromise);
                if (searchText.length > 1 && this.searchChips.length === 0) {
                    this.showAutoSuggestAfterSearch = true;
                    this.autoSuggestPromise = $timeout(function () {
                        this.getByContactAndSourceSuggest(searchText);
                    }.bind(this), SUGGEST_DEBOUNCE_MS);
                } else if (searchText.length <= 1) {
                    this.hideSearchBarLoader = true;
                }
            } else {
                // if we have no searchText, but clicked an auto-suggest that means we built a chip.
                // in order to trigger the new search we need to keep auto-suggest open for later events
                if (!clickingSuggestList) {
                    this.hideAutoSuggest();
                }
            }
        };

        this.clickedInfluencers = function clickedInfluencers() {
            this.selectedSearchType = this.searchTypeOptions[0].type;

            this.selectInfluencers();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedRelevantInfluencers = function clickedRelevantInfluencers() {
            this.selectedSearchType = this.searchTypeOptions[1].type;

            this.selectRelevantInfluencers();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedSources = function clickedSources() {
            this.selectedSearchType = this.searchTypeOptions[2].type;

            this.selectSources();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedRelevantSources = function clickedRelevantSources() {
            this.selectedSearchType = this.searchTypeOptions[3].type;

            this.selectRelevantSources();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.addChip = function addChip(chip, executeSearch) {
            var chipExists = this.searchChips.some(function (searchChipObject) {
                return searchChipObject.type === 'standard' && searchChipObject.value.toLowerCase() === chip.toLowerCase();
            });

            if (chipExists) {
                this.searchChips.pop();
            } else {
                // md-chip natually does not add a chip object to the array
                if (this.searchChips[this.searchChips.length - 1] === chip) {
                    this.searchChips.pop();
                }

                this.searchChips[this.searchChips.length] = {
                    type: 'standard',
                    value: chip,
                    display: chip
                };

                if (!this.getSearchType()) {
                    this.setSearchType();
                    this.selectedSearchType = this.searchTypeOptions[0].type;
                }

                if (typeof executeSearch === 'undefined') {
                    executeSearch = true;
                }

                this.addChipCallback({ executeSearch: executeSearch });

                // the call to "clearAndUpdateSearchText" needs to occur after "addChipCallback", due to some dependencies in the search controller
                // otherwise the relevant searches break down, and do not return proper results
                if (this.searchText === chip) {
                    this.clearAndUpdateSearchText();
                }
            }
        };

        this.removeChip = function removeChio(chip) {
            this.removeChipCallback({ removedChip: chip });
        };

        this.clearAndUpdateSearchText = function clearAndUpdateSearchText() {
            this.searchText = '';
            this.searchTextChanged(this.searchText);
        };
    }

    angular.module('MW.ContactManager.MwSearchInput', ['MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.InfluencerContactService']).component('mwSearchInput', {
        bindings: {
            search: '&',
            searchText: '<',
            isContactSearch: '=',
            getSearchType: '&',
            setSearchType: '&',
            searchTypeOptions: '=',
            selectInfluencers: '&',
            selectRelevantInfluencers: '&',
            selectSources: '&',
            selectRelevantSources: '&',
            placeholder: '<',
            sourcePlaceholder: '<',
            secondaryPlaceholder: '<',
            onTextChange: '&',
            autoSuggestToggle: '&',
            addChipCallback: '&',
            removeChipCallback: '&',
            searchChips: '=',
            clearChips: '&',
            isV2: '='
        },
        controller: ['$scope', '$element', 'ContactManagerNavigationService', 'InfluencerContactService', '$translate', '$timeout', MwSearchInputController],
        template: '\n            <div class="search-input-wrapper" md-whiteframe="{{$ctrl.whiteframe}}" ng-class="{borderless: ($ctrl.whiteframe > -1)}">\n            <div class="search-input-container" layout="row">\n                <md-icon ng-if="$ctrl.searchChips.length < 1" class="search" md-svg-icon="action:ic_search_24px"></md-icon>\n                <md-icon ng-if="$ctrl.searchChips.length >= 1" ng-click="$ctrl.clearChips()" class="clear" md-svg-icon="content:ic_clear_24px"></md-icon>\n                <md-chips\n                    secondary-placeholder=""\n                    ng-model="$ctrl.searchChips"\n                    readonly="$ctrl.seachChips.length > $ctrl.maxChips"\n                    md-separator-keys="$ctrl.customSeparatorKeys"\n                    md-removable="$ctrl.removable"\n                    md-on-add="$ctrl.addChip($chip)"\n                    md-add-on-blur=false\n                    md-on-remove="$ctrl.removeChip($chip)"\n                    class="md-primary"\n                    flex="100">\n                    <md-chip-template>\n                      <span>{{$chip.display}}</span>\n                    </md-chip-template>\n                    <input\n                        type="text"\n                        ng-model="$ctrl.searchText"\n                        ng-change="$ctrl.searchTextChanged($ctrl.searchText)"\n                        ng-class="{\'extra-large\': ($ctrl.searchChips.length === 0), \'large\': ($ctrl.searchChips.length === 1)}"\n                        tabindex="0"\n                        placeholder="{{$ctrl.searchChips.length > 1 ? \'\' : ($ctrl.searchChips.length === 0 ? ($ctrl.isContactSearch ? $ctrl.placeholder : $ctrl.sourcePlaceholder) : $ctrl.secondaryPlaceholder)}}"\n                        ng-focus="$ctrl.onFocus()"\n                        ng-blur="$ctrl.onBlur()"\n                        on-enter-action="$ctrl.onEnterAction()">\n                </md-chips>\n            </div>\n            <md-progress-linear md-mode="indeterminate" ng-disabled="$ctrl.hideSearchBarLoader"></md-progress-linear>\n\n            <md-content layout="row" class="list">\n                <md-list flex="100" id="suggest-list" ng-show="(($ctrl.searchText.length > 1 && $ctrl.searchChips.length === 0) && $ctrl.hasFocus)">\n                    <!-- Search shortcuts -->\n                    <md-list-item ng-if="$ctrl.contacts.length && $ctrl.isContactSearch" ng-click="$ctrl.clickedInfluencers()" class="suggestionButton">\n                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>\n                        <span>\n                            <span translate>icm-search__auto-suggest--all-influencers-named</span>\n                            <span class="highlight">{{$ctrl.searchText}}</span>\n                        </span>\n                    </md-list-item>\n                    <md-list-item ng-if="$ctrl.isContactSearch" ng-click="$ctrl.clickedRelevantInfluencers()">\n                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>\n                        <span>\n                            <span translate>icm-search__auto-suggest--all-influencers-who-write-about</span>\n                            <span class="highlight">{{$ctrl.searchText}}</span>\n                        </span>\n                    </md-list-item>\n                    <md-list-item ng-if="$ctrl.sources.length && !$ctrl.isContactSearch" ng-click="$ctrl.clickedSources()" class="suggestionButton">\n                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>\n                        <span>\n                            <span translate>icm-search__auto-suggest--all-sources-named</span>\n                            <span class="highlight">{{$ctrl.searchText}}</span>\n                        </span>\n                    </md-list-item>\n                    <md-list-item ng-if="!$ctrl.isContactSearch" ng-click="$ctrl.clickedRelevantSources()">\n                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>\n                        <span>\n                            <span translate>icm-search__auto-suggest--all-sources-writing-about</span>\n                            <span class="highlight">{{$ctrl.searchText}}</span>\n                        </span>\n                    </md-list-item>\n                    <!-- Separator -->\n                    <md-list-item class="separator" ng-if="$ctrl.contacts.length || $ctrl.sources.length">\n                        <span translate>icm-search__auto-suggest--top-results</span>\n                    </md-list-item>\n\n                    <!-- Contacts -->\n                    <md-list-item ng-repeat="item in $ctrl.contacts" ng-click="$ctrl.goToContact(item.id)" class="md-3-line suggestionButton" ng-if="$ctrl.isContactSearch">\n                        <md-icon class="md-avatar-icon contact" md-svg-icon="meltwater:person"></md-icon>\n                        <div class="md-list-item-text" layout="column" layout-align="center none">\n                            <span class="line-one" md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.firstName}} {{item.middleName}} {{item.lastName}}</span>\n                            <span class="line-two">\n                                <span ng-if="item.title">{{item.title}}</span>\n                                <span ng-if="item.title && item.sourceList">&middot;</span>\n                                <span ng-if="item.sourceList">{{item.sourceList}}</span>\n                            </span>\n                            <span class="line-three">\n                                <span class="line-three" ng-if="item.city.length">{{item.city}}</span><span class="line-three" ng-if="item.stateOrProvince.length"><span class="line-three" ng-if="item.city.length">, </span>{{item.stateOrProvince}}</span><span class="line-three" ng-if="item.country.length"><span class="line-three" ng-if="item.city.length || item.stateOrProvince.length">, </span>{{item.country}}</span>\n                            </span>\n                        </div>\n                        <md-icon class="md-secondary" md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>\n                    </md-list-item>\n\n                    <!-- Sources -->\n                    <md-list-item ng-repeat="item in $ctrl.sources" ng-click="$ctrl.goToSource(item.id)" class="md-3-line suggestionButton" ng-if="$ctrl.isContactSearch===false">\n                        <md-icon class="md-avatar-icon source" md-svg-icon="communication:ic_business_24px"></md-icon>\n                        <div class="md-list-item-text" layout="column">\n                            <span class="line-one" md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.name}}</span>\n                            <span class="line-three">\n                                <span class="line-three" ng-if="item.city.length">{{item.city}}</span><span class="line-three" ng-if="item.stateOrProvince.length"><span class="line-three" ng-if="item.city.length">, </span>{{item.stateOrProvince}}</span><span class="line-three" ng-if="item.country.length"><span class="line-three" ng-if="item.city.length || item.stateOrProvince.length">, </span>{{item.country}}</span>\n                            </span>\n                        </div>\n                        <md-icon class="md-secondary" md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n            </div>\n            '
    });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var ProtectEditedOutreach = function () {
        function ProtectEditedOutreach($translate, $mdDialog) {
            _classCallCheck(this, ProtectEditedOutreach);

            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        _createClass(ProtectEditedOutreach, [{
            key: '$onInit',
            value: function $onInit() {
                this.modalTitle = this.$translate.instant('icm-outreach__protect-edited--modal-title');
                this.okText = this.$translate.instant('action-label__save');
                this.cancelText = this.$translate.instant('action-label__cancel');
                this.content = this.$translate.instant('icm-outreach__protect-edited--modal-content');
                this.optionCopy = this.$translate.instant('icm-outreach__protect-edited--option-copy');
                this.optionOverwrite = this.$translate.instant('icm-outreach__protect-edited--option-overwrite');
                this.selectedOption = 'copy';
                this.subject = this.$translate.instant('mw-outreach-collection__column-header-subject');
                this.subjectDefault = this.$translate.instant('icm-outreach__protect-edited--subject-placeholder', { subject: this.distribution.subject });
            }
        }, {
            key: 'handleOk',
            value: function handleOk() {
                var data = {
                    option: this.selectedOption,
                    subject: this.subjectDefault
                };
                this.$mdDialog.hide(data);
            }
        }, {
            key: 'handleCancel',
            value: function handleCancel() {
                this.$mdDialog.cancel();
            }
        }]);

        return ProtectEditedOutreach;
    }();

    angular.module('MW.ContactManager.ProtectEditedOutreach', ['ngMaterial']).component('protectEditedOutreach', {
        bindings: {
            distribution: '<',
            disallowOverwrite: '<'
        },
        controller: ['$translate', '$mdDialog', ProtectEditedOutreach],
        template: '\n        <mw-mini-modal-dialog layout="column" data="$ctrl.distribution" dialog-title="{{$ctrl.modalTitle}}" ok="{{$ctrl.okText}}" cancel="{{$ctrl.cancelText}}" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">\n            <mw-modal-content>\n                <div layout="column">\n                    <p>\n                    {{$ctrl.content}}\n                    </p>\n                    <div layout="column">\n                        <md-radio-group class="md-primary" ng-model="$ctrl.selectedOption">\n                            <md-radio-button value="copy">{{$ctrl.optionCopy}}</md-radio-button>\n                            <md-input-container flex>\n                                <input name="subject" ng-model="$ctrl.subjectDefault" required />\n                            </md-input-container>\n                            <md-radio-button ng-disabled="$ctrl.disallowOverwrite==true" value="overwrite">{{$ctrl.optionOverwrite}}</md-radio-button>\n                        </md-radio-group>\n                    </div>\n                </div>\n            </mw-modal-content>\n        </mw-mini-modal-dialog>\n        '
    });
})(window.angular);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var SearchTutorialController = function () {
        function SearchTutorialController(CoreUserService, ICMUserService, translationService, $translate, $location, $rootScope) {
            var _this = this;

            _classCallCheck(this, SearchTutorialController);

            this.CoreUserService = CoreUserService;
            this.ICMUserService = ICMUserService;
            this.$translate = $translate;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.renderTutorial = false;
            this.isSearchRoute = false;

            this.$rootScope.$on('$locationChangeSuccess', function () {
                if (_this.$location.path() === '/influencers/search') {
                    _this.isSearchRoute = true;

                    _this.CoreUserService.getCurrent(true).then(function (currentUser) {
                        _this.ICMUserService.getAppSettings('contacts', currentUser._id).then(function (contactSettings) {
                            var showTutorial = true;
                            if (contactSettings && contactSettings.showSearchTutorial === false) {
                                showTutorial = false;
                            }
                            if (showTutorial === true) {
                                translationService.waitForTranslations().then(function () {
                                    _this.renderTutorial = true;
                                    contactSettings.showSearchTutorial = false;
                                    _this.ICMUserService.setAppSettings('contacts', contactSettings);

                                    _this.steps[0].description = _this.$translate.instant('icm-search__tutorial--step-one');
                                    _this.steps[1].description = _this.$translate.instant('icm-search__tutorial--step-two');
                                    _this.steps[2].description = _this.$translate.instant('icm-search__tutorial--step-three');
                                });
                            }
                        });
                    });
                }
            });

            this.steps = [{
                imagePosition: '0px',
                description: 'Welcome to the new Influencers Search. You can enter multiple terms into the search bar. Use a comma or the tab key to create phrases and add additional words.',
                descriptionCss: {
                    'background-color': '#B42E9E'
                }
            }, {
                imagePosition: '1300px',
                description: 'You can use the filters on the left to refine your search and find more relevant results.',
                descriptionCss: {
                    'background-color': '#FF6622;'
                }
            }, {
                imagePosition: '650px',
                description: 'You can switch between Contacts and Sources searches by clicking on the link for the current setting.',
                descriptionCss: {
                    'background-color': '#50BB99'
                }
            }];

            this.currentStep = this.steps[0];
            this.currentStepIndex = 0;
            this.setImagePosition(this.currentStep.imagePosition);
        }

        _createClass(SearchTutorialController, [{
            key: 'isLastStep',
            value: function isLastStep() {
                return this.currentStep === this.steps[this.steps.length - 1];
            }
        }, {
            key: 'toNextStep',
            value: function toNextStep() {
                this.currentStepIndex += 1;
                this.currentStep = this.steps[this.currentStepIndex];
                this.setImagePosition(this.currentStep.imagePosition);
            }
        }, {
            key: 'toPreviousStep',
            value: function toPreviousStep() {
                this.currentStepIndex -= 1;
                this.currentStep = this.steps[this.currentStepIndex];
                this.setImagePosition(this.currentStep.imagePosition);
            }
        }, {
            key: 'setImagePosition',
            value: function setImagePosition(imagePosition) {
                $('.search-tutorial-picture').css('background-position-x', imagePosition);
            }
        }, {
            key: 'hideTutorial',
            value: function hideTutorial() {
                this.renderTutorial = false;
            }
        }]);

        return SearchTutorialController;
    }();

    angular.module('MW.ContactManager.SearchTutorial', ['MW.Framework.CoreUserService', 'MW.Framework.ICMUserService', 'MW.Framework.TranslationService']).component('searchTutorial', {
        bindings: {},
        controller: ['CoreUserService', 'ICMUserService', 'translationService', '$translate', '$location', '$rootScope', SearchTutorialController],
        template: '\n            <div class="search-tutorial-wrapper" ng-show="$ctrl.isSearchRoute && $ctrl.renderTutorial" ng-cloak>\n                <div class="search-tutorial-modal-container" layout="column" layout-align="space-around center">\n                    <div class="top-container" layout="row" layout-align="center center">\n                        <md-button class="mw-fab md-fab" ng-if="$ctrl.currentStepIndex !== 0" aria-label="Previous" ng-click="$ctrl.toPreviousStep()">\n                            <md-icon md-svg-icon="navigation:ic_arrow_back_24px"></md-icon>\n                        </md-button>\n                        <div class="left-placeholder" ng-if="$ctrl.currentStepIndex === 0"></div>\n                        <md-card ng-style="$ctrl.currentStep.descriptionCss">\n                            <div class="search-tutorial-picture" style="background-image: url(\'https://assets.meltwater.io/icm-web-assets/static/img/search_tutorial/all_steps.png\')"></div>\n                            <div class="search-tutorial-text" layout="column" layout-align="center center">\n                                <span class="text-wrap">{{$ctrl.currentStep.description}}</span>\n                            </div>\n                        </md-card>\n\n                        <md-button class="mw-fab md-fab" ng-show="!$ctrl.isLastStep()" ng-click="$ctrl.toNextStep()" aria-label="Next">\n                            <md-icon md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>\n                        </md-button>\n\n                        <md-button class="mw-fab md-fab" ng-show="$ctrl.isLastStep()" aria-label="Hide" ng-click="$ctrl.hideTutorial()">\n                            <md-icon md-svg-icon="navigation:ic_check_24px"></md-icon>\n                        </md-button>\n                    </div>\n\n                    <div class="search-tutorial-dots" layout="row" layout-align="center center">\n                        <span class="dot-wrapper" ng-repeat="step in $ctrl.steps"><div class="dot" ng-class="$ctrl.currentStep === step ? \'active\': \'inactive\'"></div></span>\n                    </div>\n                </div>\n            </div>\n        '
    });
})(angular);
'use strict';

(function () {
    'use strict';

    CsHeaderController.$inject = ["$scope", "$translate", "translationService"];
    angular.module('MW.CoreStream.CsHeader', ['MW.Framework.TranslationService']).directive('csHeader', function () {
        return {
            restrict: 'E',
            scope: {
                itemCount: '=',
                sortField: '=?',
                dateRangeDays: '=?',
                headerText: '<?'
            },
            controllerAs: 'csHeaderController',
            controller: CsHeaderController,
            templateUrl: 'icm-web/views/partials/cs_header'
        };
    }).controller('CsHeaderController', ['$scope', '$translate', 'translationService', CsHeaderController]);

    function CsHeaderController($scope, $translate, translationService) {
        var message;

        this.$translate = $translate;
        this.itemCountMessage = '';
        this.sortFieldMessage = '';
        this.dateRangeMessage = '';

        $scope.$watch('headerText', function (newValue) {
            this.headerText = newValue;
        }.bind(this));

        // getting around a bug in angular 1.2, if we update we can use 'bindToController'
        $scope.$watch('itemCount', function (newValue) {
            if (newValue === -1) {
                return;
            }
            this.itemCount = newValue;

            message = this.itemCount === 1 ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';
            if (!this.itemCount) {
                this.itemCount = 0;
            }

            this.$translate(message, { itemCount: this.itemCount }).then(function (translatedMessage) {
                this.itemCountMessage = translatedMessage;
            }.bind(this)).catch(function () {});
        }.bind(this));

        $scope.$watch('sortField', function (newValue) {
            message = 'sorted by ' + newValue;
            if (newValue === 'alphabetically') {
                message = 'sorted ' + newValue;
            }
            this.sortField = newValue;

            translationService.getLocalizedString(message, '', true).then(function (translatedMessage) {
                this.sortFieldMessage = translatedMessage;
            }.bind(this)).catch(function () {});
        }.bind(this));

        $scope.$watch('dateRangeDays', function (newValue) {
            if (newValue && newValue > -1) {
                newValue = newValue || 14;
                message = 'icm-search__stream-header--' + newValue + '-days';
                this.dateRangeDays = newValue;

                this.$translate(message).then(function (translatedMessage) {
                    this.dateRangeMessage = translatedMessage;
                }.bind(this)).catch(function () {});
            }
        }.bind(this));
    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var TemplateWarning = function () {
        function TemplateWarning($translate, $mdDialog) {
            _classCallCheck(this, TemplateWarning);

            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        _createClass(TemplateWarning, [{
            key: '$onInit',
            value: function $onInit() {
                this.getModalText();
                this.okText = this.$translate.instant('Ok');
            }
        }, {
            key: 'getModalText',
            value: function getModalText() {
                this.showCheckbox = true;
                var modalHeaderKey = 'icm-outreach__template-limits--near-limit-header';
                var modalBodyKey = 'icm-outreach__template-limits--near-limit-body';
                if (this.templateCount === 50) {
                    this.showCheckbox = false;
                    modalHeaderKey = 'icm-outreach__template-limits--limit-reached-header';
                    modalBodyKey = 'icm-outreach__template-limits--limit-reached-body';
                }

                this.checkboxLabel = this.$translate.instant('icm-outreach__template-limits--stop-notification-checkbox-label');
                this.modalTitle = this.$translate.instant(modalHeaderKey, { templateCount: this.templateCount });
                this.modalBody = this.$translate.instant(modalBodyKey, { templateCount: this.templateCount });
            }
        }, {
            key: 'handleOk',
            value: function handleOk() {
                this.$mdDialog.hide({ stopNotification: this.stopNotification });
            }
        }]);

        return TemplateWarning;
    }();

    angular.module('MW.ContactManager.TemplateWarning', ['ngMaterial']).component('templateWarning', {
        bindings: {
            stopNotification: '<',
            templateCount: '<'
        },
        controller: ['$translate', '$mdDialog', TemplateWarning],
        template: '\n        <mw-mini-modal-dialog id="template-warning-mini-modal" layout="column" data="$ctrl.stopNotification" dialog-title="{{$ctrl.modalTitle}}" ok="{{$ctrl.okText}}" cancel="" on-ok="$ctrl.handleOk($event)">\n            <mw-modal-content>\n                <div layout="column">\n                    <p>\n                        {{$ctrl.modalBody}}\n                    </p>\n                    <md-checkbox ng-if="$ctrl.showCheckbox" class="md-primary body" ng-model="$ctrl.stopNotification" aria-label="$ctrl.checkboxLabel">\n                        <span ng-bind-html="$ctrl.checkboxLabel"></span>\n                    </md-checkbox>\n                </div>\n            </mw-modal-content>\n        </mw-mini-modal-dialog>\n        '
    });
})(window.angular);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';

    var UnsubscribeBadge = function UnsubscribeBadge($translate) {
        _classCallCheck(this, UnsubscribeBadge);

        this.badgeText = $translate.instant('Unsubscribed');
        this.tooltipText = $translate.instant('icm-web__unsubscribe-badge--tooltip');
    };

    angular.module('MW.Influecners.UnsubscribeBadge', ['ngMaterial', 'mwAppComponents']).component('unsubscribeBadge', {
        controller: ['$translate', UnsubscribeBadge],
        template: '\n            <span>{{$ctrl.badgeText}}</span>\n            <md-tooltip md-direction="top">\n                {{$ctrl.tooltipText}}\n            </md-tooltip>\n        '
    });
})(window.angular);
'use strict';

(function () {
    'use strict';

    function MwEmailAddressExpansionPanelController($scope, $element, $translate, $sce) {
        var contentElement = $element.find('md-card-content'),
            findBoxInput = $element.find('.find-box input'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.title = 'icm-search__email-filter--title';
        this.generalInfoTip = 'icm-search__email-filter--general-info-tip';
        this.noResultsInfoTip = 'icm-search__email-filter--no-results-info-tip';
        this.findBoxPlaceholder = 'icm-search__email-filter--input-placeholder';
        this.resultsCount = undefined;
        this.resultsCountMessage = 'icm-search__email-filter--result-count';
        this.loading = false;
        this.loadingMessage = 'icm-search__email-filter--loading-message';
        this.emailAddress = '';

        this.$translate = $translate;
        this.$sce = $sce;

        this.toggle = function toggle() {
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();

            // $element[0].scrollIntoView();
        };

        this.emailAddressChanged = function emailAddressChanged(e) {
            // user pressed enter. add the email to the filter
            if (e.keyCode === 13 && this.emailAddress.length) {
                if (!this.isSelected({ emailAddress: this.emailAddress })) {
                    this.loading = true;
                    this.selectionChanged({ selectedItem: this.emailAddress });
                }

                this.emailAddress = '';
            }
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.emailAddress = '';

            if (this.clearSelection) {
                this.clearSelection();
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.emailAddress.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.$onChanges = function $onChanges(changes) {
            if (changes.resultCount) {
                this.resultsCount = changes.resultCount.currentValue;
                this.resultsCountMessage = this.getItemCountMessage(changes.resultCount.currentValue);
            }

            // this component gets a search state told to it. based on that we can determine if our filter is in a "loading" state
            if (changes.searchInProgress) {
                this.loading = changes.searchInProgress.currentValue;
            }
        };

        this.getItemCountMessage = function getItemCountMessage(count) {
            var message = count > 1 || count === 0 ? 'icm-search__email-filter--results-count' : 'icm-search__email-filter--result-count';
            var countString = count >= 500 ? '+500' : count;

            return this.$translate.instant(message, { itemCount: '<b>' + countString + '</b>' }, null, null, null);
        };

        this.clearInput = function clearInput() {
            this.emailAddress = '';
            findBoxInput.focus();
        };
    }

    angular.module('MW.ContactManager.MwEmailAddressExpansionPanel', []).component('mwEmailAddressExpansionPanel', {
        bindings: {
            clearSelection: '&',
            selectionChanged: '&',
            isSelected: '&',
            selectionCount: '&',
            resultCount: '<',
            searchInProgress: '<'
        },
        controller: ['$scope', '$element', '$translate', '$sce', MwEmailAddressExpansionPanelController],
        template: '\n                <md-card>\n                    <md-card-title ng-click="$ctrl.toggle()">\n                        <md-card-title-text layout="row">\n                            <span flex>\n                                <span class="panel-title" translate>{{$ctrl.title}}</span>\n                                <mw-infotip class="title-infotip" text-content="{{$ctrl.generalInfoTip}}"></mw-infotip>\n                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>\n                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount()" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>\n                            </span>\n                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>\n                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>\n                        </md-card-title-text>\n                    </md-card-title>\n                    <md-card-content ng-class="{\'with-border\': $ctrl.hideAutocomplete}">\n                        <div class="find-box">\n                            <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>\n                            <input ng-model="$ctrl.emailAddress" ng-keypress="$ctrl.emailAddressChanged($event)"></input>\n                            <md-icon ng-show="$ctrl.emailAddress" ng-click="$ctrl.clearInput()" class="clear-icon" md-svg-icon="content:ic_clear_24px"></md-icon>\n                        </div>\n                        <md-toolbar class="result-count-toolbar" ng-show="($ctrl.selectionCount() > 0 && ($ctrl.resultsCount >= 0 || $ctrl.isLoading))" layout="row" layout-align="start center">\n                            <span ng-if="!$ctrl.loading" class="results-count">\n                                <span class="item-count-message" ng-bind-html="$ctrl.resultsCountMessage"></span>\n                                <mw-infotip class="no-results-infotip" ng-show="$ctrl.resultsCount === 0" text-content="{{$ctrl.noResultsInfoTip}}"></mw-infotip>\n                            </span>\n                            <span ng-if="$ctrl.loading">\n                                <span class="loading-message" translate>{{$ctrl.loadingMessage}}</span>\n                            </span>\n                        </md-toolbar>\n                    </md-card-content>\n                </md-card>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    function MwListStatusExpansionPanelController($scope, $element, $translate, $sce, LIST_STATUS_FILTER_CONTACT_LIMIT) {
        var contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.title = 'icm-search__list-status-filter--title';
        this.generalInfoTip = 'icm-search__list-status-filter--general-info-tip';

        this.$translate = $translate;
        this.$sce = $sce;

        this.$onInit = function () {
            this.toggle = function toggle() {
                $element.toggleClass('active');
                contentElement.toggle();
                expandIcon.toggle();
                collapseIcon.toggle();
            };

            this.selectedItemChange = function selectedItemChange(value) {
                this.selectionChanged({ selectedItem: value });
            };

            this.optionSelected = function optionSelected(value) {
                return this.isSelected({ option: value });
            };

            this.clickedClear = function clickedClear(e) {
                e.stopPropagation();

                if (this.clearSelection) {
                    this.clearSelection();
                }
            };

            // we set the contact count to -1 when we fail to retrieve the value. the only failure scenario we have run into thus far is that the company has too many contacts, and
            // the request fails. so that would mean they also have too many contacts to use this filter. disable it.
            this.isFilterDisabled = this.listContactCount >= LIST_STATUS_FILTER_CONTACT_LIMIT || this.listContactCount === -1 ? true : false;
            this.isYesOptionDisabled = this.listContactCount <= 0 ? true : false;
        };
    }

    angular.module('MW.ContactManager.MwListStatusExpansionPanel', []).component('mwListStatusExpansionPanel', {
        bindings: {
            clearSelection: '&',
            selectionChanged: '&',
            selectedOption: '<',
            listContactCount: '<'
        },
        controller: ['$scope', '$element', '$translate', '$sce', 'LIST_STATUS_FILTER_CONTACT_LIMIT', MwListStatusExpansionPanelController],
        template: '\n                <md-card ng-class="{\'isDisabled\': $ctrl.isFilterDisabled}">\n                    <md-card-title ng-click="$ctrl.toggle()">\n                        <md-card-title-text layout="row">\n                            <span flex>\n                                <span class="panel-title" translate>{{$ctrl.title}}</span>\n                                <mw-infotip class="title-infotip" text-content="{{$ctrl.generalInfoTip}}"></mw-infotip>\n                                <span class="clear-selection pull-right" ng-if="$ctrl.selectedOption !== null" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>\n                            </span>\n                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>\n                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>\n                        </md-card-title-text>\n                    </md-card-title>\n                    <md-card-content class="with-border">\n                        <div class="radio-wrapper">\n                            <md-radio-group ng-model="$ctrl.selectedOption" layout="column" class="md-primary">\n                                <md-radio-button ng-disabled="$ctrl.isYesOptionDisabled || $ctrl.isFilterDisabled" class="radio-option" value="ON" ng-click="$ctrl.isYesOptionDisabled || $ctrl.isFilterDisabled || $ctrl.selectedItemChange(\'ON\')">\n                                    <span translate>Yes</span>\n                                </md-radio-button>\n                                <md-radio-button ng-disabled="$ctrl.isFilterDisabled" class="radio-option" value="OFF" ng-click="$ctrl.isFilterDisabled || $ctrl.selectedItemChange(\'OFF\')">\n                                    <span translate>No</span>\n                                </md-radio-button>\n                            </md-radio-group>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            '
    });
})();
'use strict';

(function () {
    'use strict';

    ActiveOnController.$inject = ["ContactManagerNavigationService", "$scope"];
    angular.module('MW.ContactManager.ActiveOn', ['MW.ContactManager.ActiveOnRow', 'MW.ContactManager.ActiveOnEmptyRow', 'MW.ContactManager.ContactManagerNavigationService']).directive('activeOn', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/active_on',
            scope: {
                contactId: '@',
                activeOnModel: '=?',
                contact: '=?'
            },
            controller: ActiveOnController,
            controllerAs: 'activeOnController'
        };
    }).controller('ActiveOnController', ['ContactManagerNavigationService', '$scope', ActiveOnController]);

    function ActiveOnController(ContactManagerNavigationService, $scope) {
        this.id = $scope.contactId;
        this.accounts = $scope.contact.channels;
        this.contact = $scope.contact;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.isEmptyAccount = 0 === this.accounts.length ? true : false;
    }

    ActiveOnController.prototype.editContact = function editContact() {
        this.ContactManagerNavigationService.goToEdit(this.id);
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ActiveOnEmptyRow', []).directive('activeOnEmptyRow', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/active_on_empty_row',
            scope: {}
        };
    });
})();
'use strict';

(function (angular) {
    'use strict';

    angular.module('MW.ContactManager.ActiveOnFormDropdown', ['MW.Framework.SingleSelectDropdownMenu']).controller('FormDropdownController', ['$element', '$timeout', FormDropdownController]).directive('activeOnFormDropdown', [function () {
        return {
            restrict: 'E',
            template: '<single-select-dropdown-menu select-options="formDropdownController.selectOptions" selected-option="formDropdownController.selectedOption" dropdown-label="No Selection" selection-changed-callback="formDropdownController.changedCallback(selectedOption)", translate-elements></single-select-dropdown-menu>',
            controllerAs: 'formDropdownController',
            controller: 'FormDropdownController',
            bindToController: true,
            scope: {
                selectOptions: '=',
                selectedOption: '=',
                dropdownLabel: '@',
                selectionChangedCallback: '&'
            }
        };
    }]);

    function FormDropdownController($element, $timeout) {
        this.$timeout = $timeout;
        this.$element = $element;
    }

    FormDropdownController.prototype.changedCallback = function changedCallback(selectedOption) {
        this.selectionChangedCallback({ selectedType: selectedOption });
        this.scrollToElement();
    };

    FormDropdownController.prototype.scrollToElement = function scrollToElement() {
        var offset = angular.copy(this.$element.offset().top);
        this.$timeout(function scroll() {
            angular.element(window).scrollTop(offset);
        }.bind(this), 0);
    };
})(window.angular);
'use strict';

angular.module('MW.ContactManager.ActiveOnIcon', []).directive('activeOnIcon', [function () {
    'use strict';

    return {
        restrict: 'E',
        scope: {
            accountType: '@'
        },
        link: function link(scope) {
            var icons = {
                TWITTER: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/twitter.png',
                FACEBOOK: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/facebook.png',
                BLOG: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/blog-active-on.svg',
                OUTLET: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/news.png',
                LINKEDIN: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/linkedin_icon.png'
            };

            scope.accountType = scope.accountType || '';
            scope.iconSrc = icons[scope.accountType.toUpperCase()] || icons.OUTLET;
        },
        templateUrl: 'icm-web/views/partials/active_on_icon'
    };
}]);
'use strict';

(function () {
    'use strict';

    ActiveOnRowController.$inject = ["$scope", "activeOnTypes", "FairhairChannelTypes"];
    angular.module('MW.ContactManager.ActiveOnRow', ['MW.ContactManager.ActiveOnIcon', 'MW.Framework.InfluencerContactService', 'MW.ContactManager.ContactManagerPropertyTypeService']).directive('activeOnRow', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/active_on_row',
            scope: {
                accounts: '=?'
            },
            controller: ActiveOnRowController,
            controllerAs: 'activeOnRowController'
        };
    }).controller('ActiveOnRowController', ['$scope', 'activeOnTypes', 'FairhairChannelTypes', ActiveOnRowController]);

    function ActiveOnRowController($scope, activeOnTypes, FairhairChannelTypes) {
        this.activeOnTypes = activeOnTypes;
        this.FairhairChannelTypes = FairhairChannelTypes;
        this.accounts = this.sortSourceFirst($scope.accounts.slice());
    }

    ActiveOnRowController.prototype.sortSourceFirst = function sortSourceFirst(accounts) {
        var source;
        if (accounts && accounts.length) {
            accounts.forEach(function (account, index) {
                if (account.type === this.activeOnTypes.SOURCE || account.type === this.FairhairChannelTypes.SOURCE) {
                    source = account;
                    accounts.splice(index, 1);
                    accounts.unshift(source);
                }
            }.bind(this));
        }
        return accounts;
    };

    ActiveOnRowController.prototype.showRowForType = function showRowForType(accountType) {
        var showRow = false;
        switch (accountType) {
            case this.activeOnTypes.FACEBOOK:
            case this.activeOnTypes.TWITTER:
            case this.activeOnTypes.BLOG:
            case this.activeOnTypes.LINKED_IN:
            case this.FairhairChannelTypes.SOURCE:
            case this.activeOnTypes.SOURCE:
                showRow = true;
                break;
            default:
                break;
        }

        return showRow;
    };
})();
'use strict';

angular.module('MW.ContactManager.AutoDownloader', []).directive('autoDownloader', [function () {
    'use strict';

    return {
        restrict: 'E',
        scope: {},
        link: function link(scope, element, attrs) {
            var mimeType = 'text/csv';

            scope.fileName = 'failed_contacts.csv';

            attrs.$observe('toDownload', function (toDownload) {
                if (toDownload && toDownload.length > 0) {
                    var blob = new Blob([toDownload], { type: mimeType }),
                        objectUrl = window.URL.createObjectURL(blob);

                    element.find('.downloadLink').attr('href', objectUrl);
                    element.find('.downloadLink')[0].click();
                }
            });
        },
        templateUrl: 'icm-web/views/partials/auto_downloader'
    };
}]);
'use strict';

(function () {
    'use strict';

    BeatsSelectAccordionController.$inject = ["$scope", "$filter", "translationService"];
    angular.module('MW.ContactManager.BeatsSelectAccordion', ['MW.Framework.TranslationService', 'MW.Framework.orderByDiacritics']).directive('beatsSelectAccordion', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/beats_select_accordion',
            scope: {
                options: '=',
                displayState: '=',
                loadingState: '@'
            },
            controller: BeatsSelectAccordionController,
            controllerAs: 'beatsController',
            bindToController: true
        };
    }).controller('BeatsSelectAccordionController', ['$scope', '$filter', 'translationService', BeatsSelectAccordionController]);

    function BeatsSelectAccordionController($scope, $filter, translationService) {
        var unbindOptionsWatch;

        this.$filter = $filter;

        this.openAccordion = false;
        this.searchText = '';
        this.summaryExpanded = false;
        this.MAX_TAGS_TO_SHOW = 5;
        this.moreItem = '';
        this.LESS_ITEMS_STRING = translationService.getLocalizedString('Less items');
        this.ONE_MORE_ITEM_STRING = translationService.getLocalizedString('1 more item');

        this.currentOptions = [];

        this.history = [];
        this.parent = null;

        this.translationService = translationService;

        this.filteredOptions = [];
        unbindOptionsWatch = $scope.$watch('beatsController.options', function (newVal) {
            if (Array.isArray(newVal) && newVal.length) {
                var orderedOptions = this._orderItems(newVal);

                this.currentOptions = orderedOptions;
                this.filteredOptions = orderedOptions;

                unbindOptionsWatch();
            }
        }.bind(this));

        $scope.$watch('beatsController.searchText', function () {
            this._filterOptions();
        }.bind(this));
    }

    BeatsSelectAccordionController.prototype._orderItems = function _orderItems(items) {
        return this.$filter('orderByDiacritics')(items, 'name');
    };

    BeatsSelectAccordionController.prototype._filterOptions = function _filterOptions() {
        var searchText = this.searchText;

        this.filteredOptions = this.$filter('filter')(this.currentOptions, _nameMatchPredicate);
        this.filteredCounts = {};

        if (searchText && this.filteredOptions.length) {
            this.filteredOptions.forEach(function (option) {
                if (option.children) {
                    var count = this.$filter('filter')(option.children, { name: searchText }).length,
                        matchString = count > 1 ? ' matches' : ' match';

                    if (count > 0) {
                        this.translationService.getLocalizedString([[count]] + matchString, { count: count }, true).then(function (translatedString) {
                            this.filteredCounts[option.id] = translatedString;
                        }.bind(this));
                    }
                }
            }, this);
        }

        function _nameMatchPredicate(element) {
            var foundMatch = false;

            if (element && element.name && element.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
                foundMatch = true;
            } else if (element.children) {
                foundMatch = element.children.some(function (child) {
                    return child.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
                });
            }

            return foundMatch;
        }
    };

    BeatsSelectAccordionController.prototype.toggleAccordion = function toggleAccordion() {
        this.openAccordion = !this.openAccordion;
    };

    BeatsSelectAccordionController.prototype.openChild = function openChild(option) {
        this.history.push({
            options: this.currentOptions,
            parent: this.parent
        });

        this.currentOptions = this._orderItems(option.children);
        this.parent = option;

        // check if the page is fully selected
        this.displayState.allSelected = this.isPageFullySelected();
        this._filterOptions();
    };

    BeatsSelectAccordionController.prototype.openParent = function openParent() {
        var historyObject = this.history.pop();

        // before drilling back up, check children
        // if all children are selected, remove their selections & select the parent
        // if page is partially selected, partially select parent
        if (this.isPageFullySelected()) {
            this.select(this.parent);

            this.currentOptions.forEach(function (currentOption) {
                this.deselect(currentOption);
            }, this);
        } else if (this.isPagePartiallySelected()) {
            this.partiallySelect(this.parent);
        }

        this.currentOptions = this._orderItems(historyObject.options);
        this.parent = historyObject.parent;

        // after drilling up, check if everything at this level is selected
        this.displayState.allSelected = this.isPageFullySelected();
        this._filterOptions();

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype._deselectChildren = function _deselectChildren(parentBeat) {
        if (Array.isArray(parentBeat.children) && parentBeat.children.length) {
            parentBeat.children.forEach(function (child) {
                this.deselect(child);
            }, this);
        }
    };

    BeatsSelectAccordionController.prototype.toggle = function toggle(option) {
        // if the parent was selected & we toggle a child, we want to deslect select the parent
        // the parents new state will be determined when we go back up a level (openParent method)
        if (this.parent && this.isSelected(this.parent)) {
            this.deselect(this.parent);
        }

        if (this.isSelected(option)) {
            this.deselect(option);
            this.displayState.allSelected = false;
        } else {
            this.select(option);
            this.displayState.allSelected = this.isPageFullySelected();

            // when selecting an option with children, we need to deslect them
            this._deselectChildren(option);
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.select = function select(option) {
        if (this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        this.displayState.selected[option.id] = option;
    };

    BeatsSelectAccordionController.prototype.deselect = function deselect(option) {
        if (this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        this._removeSelection(option);
    };

    BeatsSelectAccordionController.prototype._removeSelection = function _removeSelection(option) {
        delete this.displayState.selected[option.id];
    };

    BeatsSelectAccordionController.prototype.summaryDeselect = function summaryDeselect(option) {
        var i, parentObject;

        // when we deselect from the summary, we could be at any level of options
        // we need to then determine what to do with any parent/children
        this.deselect(option);

        // if the option has a parent...
        if (option.parentId) {
            // note: this will only work for options with 2 levels
            for (i = 0; i < this.options.length; i++) {
                if (this.options[i].id === option.parentId) {
                    parentObject = this.options[i];
                    break;
                }
            }

            // if the parent is fully selected & we deselected a child, partially select parent
            // if the parent is partially selected & we deslect a child, we need to determine now if it is fully deselected or still partially selected
            if (this.isSelected(parentObject)) {
                this.partiallySelect(parentObject);
            } else if (this.isPartiallySelected(parentObject)) {
                var allChildrenUnselected = parentObject.children.every(function (child) {
                    return !this.isSelected(child);
                }, this);

                if (allChildrenUnselected) {
                    this.removePartialSelection(parentObject);
                }
            }
        }

        // if the option has children - we need to deselect them all, since we deselected the parent
        if (option.children.length) {
            option.children.forEach(function (child) {
                if (this.isSelected(child)) {
                    this.deselect(child);
                }
            }, this);
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.partiallySelect = function partiallySelect(option) {
        if (this.isSelected(option)) {
            this.deselect(option);
        }

        this.displayState.partiallySelected[option.id] = option;
    };

    BeatsSelectAccordionController.prototype.removePartialSelection = function removePartialSelection(option) {
        delete this.displayState.partiallySelected[option.id];
    };

    BeatsSelectAccordionController.prototype.toggleAllCurrent = function toggleAllCurrent() {
        // if the parent was selected & we toggle current page, we want to deslect select the parent
        // the parents new state will be determined when we go back up a level (openParent method)
        if (this.parent && this.isSelected(this.parent)) {
            this.deselect(this.parent);
        }

        if (this.isPageFullySelected()) {
            this.currentOptions.forEach(function (currentOption) {
                if (this.isSelected(currentOption)) {
                    this.deselect(currentOption);
                }
            }, this);

            this.displayState.allSelected = false;
        } else {
            this.currentOptions.forEach(function (currentOption) {
                if (!this.isSelected(currentOption)) {
                    this.select(currentOption);

                    this._deselectChildren(currentOption);
                }
            }, this);

            this.displayState.allSelected = true;
        }

        this._updateSummaryState();
    };

    BeatsSelectAccordionController.prototype.isSelected = function isSelected(option) {
        return !!this.displayState.selected[option.id];
    };

    BeatsSelectAccordionController.prototype.isPartiallySelected = function isPartiallySelected(option) {
        return !!this.displayState.partiallySelected[option.id];
    };

    BeatsSelectAccordionController.prototype.isPageFullySelected = function isPageFullySelected() {
        if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        return this.currentOptions.every(function (currentOption) {
            return this.isSelected(currentOption);
        }, this);
    };

    BeatsSelectAccordionController.prototype.isPageFullyDeselected = function isPageFullyDeselected() {
        if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return true;
        }

        return this.currentOptions.every(function (currentOption) {
            return !this.isSelected(currentOption);
        }, this);
    };

    BeatsSelectAccordionController.prototype.isPagePartiallySelected = function isPagePartiallySelected() {
        var selectedCount = 0;

        if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        this.currentOptions.forEach(function (currentOption) {
            if (this.isSelected(currentOption)) {
                selectedCount++;
            }
        }, this);

        return selectedCount > 0 && selectedCount < this.currentOptions.length;
    };

    BeatsSelectAccordionController.prototype._updateSummaryState = function _updateSummaryState() {
        if (this.summaryExpanded && this._getSelectedCount() <= this.MAX_TAGS_TO_SHOW) {
            this.summaryExpanded = false;
        }
        this.moreItem = this._getHiddenText();
    };

    BeatsSelectAccordionController.prototype._getSelectedCount = function _getSelectedCount() {
        return Object.keys(this.displayState.selected).length;
    };

    BeatsSelectAccordionController.prototype._getHiddenText = function _getHiddenText() {
        var hiddenText = '',
            numberOfHiddenTags = this._getSelectedCount() - this.MAX_TAGS_TO_SHOW;

        if (this.summaryExpanded) {
            hiddenText = this.LESS_ITEMS_STRING;
        } else {
            if (numberOfHiddenTags === 1) {
                hiddenText = this.ONE_MORE_ITEM_STRING;
            } else if (numberOfHiddenTags > 1) {
                hiddenText = this.translationService.getLocalizedString('[[itemCount]] more items', { itemCount: numberOfHiddenTags });
            }
        }

        return hiddenText;
    };
})();
'use strict';

(function () {
    'use strict';

    ComposeMedialistsController.$inject = ["CoreCompanyService", "DialogService", "DEFAULT_MEDIA_LIST", "$scope"];
    angular.module('MW.CoreStream.ComposeMedialists', ['MW.Framework.CoreCompanyService', 'MW.Influencers.IcmDialogService']).directive('composeMedialists', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/outreach_compose_medialists_dialog',
            scope: {
                allMediaLists: '=?',
                preSelectedMediaLists: '=?',
                recipientsLabel: '=?',
                callbackMethod: '&?'
            },
            controller: ComposeMedialistsController,
            controllerAs: 'composeMedialistsController'
        };
    }).controller('composeMedialistsController', ['CoreCompanyService', 'DialogService', 'DEFAULT_MEDIA_LIST', '$scope', ComposeMedialistsController]);

    function ComposeMedialistsController(CoreCompanyService, DialogService, DEFAULT_MEDIA_LIST, $scope) {
        this.preSelectedMediaLists = $scope.preSelectedMediaLists;
        this.recipientsLabel = $scope.recipientsLabel;
        this.callbackMethod = $scope.callbackMethod;
        this.allMediaLists = $scope.allMediaLists;

        this.DialogService = DialogService;

        this.mediaLists = [];
        this.selectedMediaLists = {};

        //TODO - Remove at some point, since we don't need this list to be here any longer
        this.defaultListName = DEFAULT_MEDIA_LIST + (this.companyId ? this.companyId : CoreCompanyService.getId());
        this.mediaLists = this.allMediaLists;
        this.selectedMediaListsObject = {};
        this.removedMediaListsObject = {};
        this.shouldDisableSave = true;
        this.recipientsLabel = this.recipientsLabel.substring(this.recipientsLabel.lastIndexOf('(') + 1, this.recipientsLabel.lastIndexOf(')')) + '.';

        Object.keys(this.preSelectedMediaLists).forEach(function (key) {
            this.selectedMediaLists[key] = true;
            this.selectedMediaListsObject[key] = this.preSelectedMediaLists[key];
            this.shouldDisableSave = false;
        }.bind(this));
    }

    ComposeMedialistsController.prototype.toggleSelection = function toggleSelection(mediaListId, mediaList) {
        if (this.selectedMediaLists[mediaListId]) {
            delete this.selectedMediaLists[mediaListId];
            delete this.selectedMediaListsObject[mediaListId];
            if (this.preSelectedMediaLists[mediaListId]) {
                this.removedMediaListsObject[mediaListId] = mediaList;
            }
        } else {
            this.selectedMediaLists[mediaListId] = true;
            this.selectedMediaListsObject[mediaListId] = mediaList;
            delete this.removedMediaListsObject[mediaListId];
        }

        if (Object.keys(this.selectedMediaLists).length > 0 || Object.keys(this.preSelectedMediaLists).length > 0) {
            this.shouldDisableSave = false;
        } else {
            this.shouldDisableSave = true;
        }
    };

    ComposeMedialistsController.prototype.save = function save() {
        this.selectedMediaListsObjectArray = [];
        Object.keys(this.selectedMediaListsObject).forEach(function (key) {
            if (!this.preSelectedMediaLists[key]) {
                this.selectedMediaListsObjectArray.push(this.selectedMediaListsObject[key]);
            }
        }.bind(this));
        this.callbackMethod({ selectedMediaListsArray: this.selectedMediaListsObjectArray, removedMediaLists: this.removedMediaListsObject });
        this.DialogService.closeDialog();
    };

    ComposeMedialistsController.prototype.cancel = function cancel() {
        this.DialogService.closeDialog();
    };
})();
'use strict';

(function () {
    'use strict';

    ContactTagsListController.$inject = ["ContactManagerTagService", "CoreUserService", "CoreCompanyService", "AnalyticsService", "ContactManagerFlashService", "DialogService", "DEFAULT_MEDIA_LIST", "$q", "$translate"];
    angular.module('MW.CoreStream.ContactTagsList', ['MW.CoreStream.ContactManagerTagService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Influencers.AnalyticsService', 'MW.ContactManager.ContactManagerFlashService', 'MW.Influencers.IcmDialogService']).directive('contactTagsList', function () {
        return {
            restrict: 'E',
            template: '<div ng-include="getTemplateUrl()"></div>',
            scope: {
                callbackMethod: '&?',
                selectedContacts: '=?',
                searchCriteria: '=?',
                queryType: '=?',
                addContactType: '@?',
                mediaListsSelection: '=?',
                totalContactsCount: '=?',
                companyId: '@?'
            },
            controller: ContactTagsListController,
            controllerAs: 'contactTagsListController',
            bindToController: true,
            link: function link(scope, element, attrs) {
                scope.closeTagListDialog = function () {
                    scope.completed = false;
                    element.parents().find('.dialogContent').trigger('reveal:close.reveal');
                };
                scope.getTemplateUrl = function () {
                    if (attrs.addContactType && attrs.addContactType === 'import') {
                        return 'icm-web/views/partials/import_contact_tags_list';
                    } else {
                        return 'icm-gaf-legacy/views/contact_manager/partials/contact_tags_list';
                    }
                };
            }
        };
    }).controller('contactTagsListController', ['ContactManagerTagService', 'CoreUserService', 'CoreCompanyService', 'AnalyticsService', 'ContactManagerFlashService', 'DialogService', 'DEFAULT_MEDIA_LIST', '$q', '$translate', ContactTagsListController]);

    function ContactTagsListController(ContactManagerTagService, CoreUserService, CoreCompanyService, AnalyticsService, ContactManagerFlashService, DialogService, DEFAULT_MEDIA_LIST, $q, $translate) {
        this.ContactManagerTagService = ContactManagerTagService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.DialogService = DialogService;
        this.selectedContactIds = this.selectedContacts ? Object.keys(this.selectedContacts) : [];
        this.mediaLists = [];
        this.selectedMediaLists = {};
        this.saveDisabled = true;
        //TODO - Remove at some point, since we don't need this list to be here any longer
        this.defaultListName = DEFAULT_MEDIA_LIST + (this.companyId ? this.companyId : CoreCompanyService.getId());
        this.$q = $q;
        this.$translate = $translate;
        this.mediaListManageModalFindTranslation = $translate.instant('icm-media-list__manage-modal--find');
        this.mediaListManageModalAddTranslation = $translate.instant('icm-media-list__manage-modal--add');
        this.importContactFindTranslation = $translate.instant('icm-import-contact__modal--find');
        this.importContactAddTranslation = $translate.instant('icm-import-contact__modal--add');
        this.tagInput = '';

        ContactManagerTagService.getAllTags().then(function (response) {
            this.mediaLists = response;
        }.bind(this));
    }

    ContactTagsListController.prototype.isDuplicateList = function isDuplicateList(tags, tagName) {
        return tags.some(function (value) {
            return value.name && value.name.toLowerCase() === tagName.toLowerCase();
        });
    };

    ContactTagsListController.prototype.toggleSelection = function toggleSelection(mediaListId) {
        if (this.selectedMediaLists[mediaListId]) {
            delete this.selectedMediaLists[mediaListId];
        } else {
            this.selectedMediaLists[mediaListId] = true;
        }

        this.mediaListsSelection = Object.keys(this.selectedMediaLists);
    };

    ContactTagsListController.prototype.getMediaListIdByName = function getMediaListIdByName(mediaLists, tagName) {
        return mediaLists.filter(function (tagListObj) {
            return tagListObj.name.toLowerCase() === tagName.toLowerCase();
        }.bind(this))[0].id;
    };

    ContactTagsListController.prototype.shouldDisableSave = function shouldDisableSave() {
        return this.ContactManagerTagService.isFetching || this.ContactManagerTagService.isSaving || Object.keys(this.selectedMediaLists).length === 0;
    };

    ContactTagsListController.prototype.createNewTag = function createNewTag(event, tagName) {
        var KEY_ENTER = 13;

        if (event.which === KEY_ENTER && tagName !== '' || event === 'createNewSwitch' && tagName) {
            if (this.isDuplicateList(this.mediaLists, tagName)) {
                this.selectedMediaLists[this.getMediaListIdByName(this.mediaLists, tagName)] = true;
                this.mediaListsSelection = Object.keys(this.selectedMediaLists);
                this.tagInput = '';
            } else {
                this.ContactManagerTagService.saveMediaList(tagName).then(function (response) {
                    this.mediaLists.push(response);
                    this.toggleSelection(response.id);
                    this.tagInput = '';
                }.bind(this));
            }
        }
    };

    ContactTagsListController.prototype.save = function save() {

        this.mediaListsSelection = Object.keys(this.selectedMediaLists);
        if (this.mediaListsSelection.length !== 0) {
            this.saveLists(this.selectedMediaLists, this.selectedContactIds);
        } else {
            this.DialogService.closeDialog();
        }
    };

    ContactTagsListController.prototype.saveLists = function saveLists(selectedMediaLists, contactIds) {
        var _this = this,
            _selectedMediaLists = Object.keys(selectedMediaLists),
            contactsCount = contactIds.length,
            tagPromise;

        // determine if we want to add people to the list by a search query, or IDs
        if (this.queryType) {
            tagPromise = this.ContactManagerTagService.updateContactMediaListsWithQuery(this.searchCriteria, _selectedMediaLists, this.queryType);
            contactsCount = this.totalContactsCount;
        } else {
            tagPromise = this.ContactManagerTagService.saveTagWithContact(_selectedMediaLists, contactIds);
        }

        tagPromise.then(function (response) {
            if (response && response.data && Array.isArray(response.data.nonContacts) && response.data.nonContacts.length) {
                var numberOfEmailsToDisplay = 3,
                    nonContactCount = response.data.nonContacts.length,
                    numberNotDisplayed = nonContactCount - numberOfEmailsToDisplay,
                    nonContactList = response.data.nonContacts.map(function (nonContact) {
                    return nonContact.email;
                }).slice(0, numberOfEmailsToDisplay).join(', ');
                contactsCount = contactsCount - nonContactCount;

                if (numberNotDisplayed > 0) {
                    this.ContactManagerFlashService.flashWarning(nonContactCount + ' email address(es) not added: ' + nonContactList + ' and ' + numberNotDisplayed + ' other(s)');
                } else {
                    this.ContactManagerFlashService.flashWarning(nonContactCount + ' email address(es) not added: ' + nonContactList);
                }
            } else {
                this.ContactManagerFlashService.flashSuccess('adding-contacts-influencer-list__flash-message--success');
            }

            var selectedMediaListSnippets = [];
            _selectedMediaLists.forEach(function (_selectedMediaListId) {
                _this.mediaLists.some(function (mediaList) {
                    if (_selectedMediaListId === mediaList.id) {
                        selectedMediaListSnippets.push({
                            key: mediaList.id,
                            name: mediaList.name
                        });

                        return true;
                    }
                });
            });

            this.trackEvent(_selectedMediaLists, contactsCount);
            this.callbackMethod({ contactIds: contactIds, selectedMediaLists: _selectedMediaLists, selectedMediaListSnippets: selectedMediaListSnippets });
            this.DialogService.closeDialog();
        }.bind(this)).catch(function () {
            this.ContactManagerFlashService.flashError('Oops. There was a problem adding this contact. Please try again later.');
        }.bind(this));
    };

    ContactTagsListController.prototype.trackEvent = function trackEvent(mediaLists, contactsCount) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'add_contact',
                contactCount: contactsCount,
                parentType: 'ICM_contact_lists',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            mediaLists.forEach(function (list) {
                trackingData.mediaListId = list;
                this.AnalyticsService.trackMediaListOperation('add_contact', trackingData);
            }.bind(this));
        }.bind(this));
    };
})();
'use strict';

(function () {
    'use strict';

    CsSelectAllHeaderController.$inject = ["$scope", "translationService"];
    angular.module('MW.CoreStream.CsSelectAllHeader', ['MW.Framework.TranslationService']).directive('csSelectAllHeader', function () {
        return {
            restrict: 'E',
            scope: {
                itemType: '@',
                itemCount: '@',
                selectedCount: '@',
                trueAllSelected: '=',
                resetSelections: '&'
            },
            controllerAs: 'csSelectAllHeaderController',
            controller: CsSelectAllHeaderController,
            templateUrl: 'icm-gaf-legacy/views/contact_manager/partials/cs_select_all_header'
        };
    }).controller('CsSelectAllHeaderController', ['$scope', 'translationService', CsSelectAllHeaderController]);

    function CsSelectAllHeaderController($scope, translationService) {
        this.$scope = $scope;
        this.translationService = translationService;
        this.itemType = $scope.itemType || 'document';

        // NOTE: when passing a new item type to the directive we need to make sure it is translated
        this.itemSelectedCountString = this.itemType + '-stream__all-selected-on-page';
        this.totalItemSelectedCountString = this.itemType + '-stream__all-selected-in-list';
        this.trueSelectAllString = this.itemType + '-stream__select-all-in-list';

        this.itemSelectedCountMessage = '';
        this.totalItemSelectedCountMessage = '';
        this.trueSelectAllMessage = '';

        this.$scope.$watch('selectedCount', function () {
            if (!this.$scope.trueAllSelected) {
                this.updateSelectedCountMessage();
            }
        }.bind(this));

        this.$scope.$watch('itemCount', function () {
            translationService.getLocalizedString(this.trueSelectAllString, { totalDocuments: this.$scope.itemCount }, true).then(function successLocalized(translatedMessage) {
                this.trueSelectAllMessage = translatedMessage;
            }.bind(this));
        }.bind(this));
    }

    CsSelectAllHeaderController.prototype.updateSelectedCountMessage = function updateSelectedCountMessage() {
        this.translationService.getLocalizedString(this.itemSelectedCountString, { selectedOnPage: this.$scope.selectedCount }, true).then(function successLocalized(translatedMessage) {
            this.itemSelectedCountMessage = translatedMessage;
        }.bind(this));
        this.translationService.getLocalizedString(this.totalItemSelectedCountString, { selectedOnPage: this.$scope.selectedCount }, true).then(function successLocalized(translatedMessage) {
            this.totalItemSelectedCountMessage = translatedMessage;
        }.bind(this));
    };

    CsSelectAllHeaderController.prototype.setTrueSelectAll = function setTrueSelectAll() {
        this.$scope.selectedCount = this.$scope.itemCount;
        this.updateSelectedCountMessage();
        this.$scope.trueAllSelected = true;
    };

    CsSelectAllHeaderController.prototype.clearSelection = function clearSelection() {
        this.$scope.trueAllSelected = false;
        this.$scope.resetSelections();
    };

    CsSelectAllHeaderController.prototype.isTrueSelectAll = function isTrueSelectAll() {
        if (this.$scope.trueAllSelected) {
            return true;
        } else {
            return this.$scope.selectedCount === this.$scope.itemCount;
        }
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.CoreStream.CsSelectDropDown', []).directive('csSelectDropDown', function () {
        return {
            restrict: 'E',
            scope: {
                toggleSelectAll: '&',
                selectAll: '&',
                deselectAll: '&',
                allSelected: '='
            },
            templateUrl: 'icm-web/views/partials/cs_select_drop_down',
            link: function link(scope) {
                scope.arrowLabel = '<label class="icon-arrow-down"></label>';

                //This will close the dropdown menu once an item is selected.
                scope.sendToggleDropdownEvent = function sendToggleDropdownEvent() {
                    scope.$broadcast('toggleDropdownMenuDirective', {
                        menuName: 'selectAll',
                        bool: false
                    });
                };
            }
        };
    });
})();
'use strict';

angular.module('MW.ContactManager.CsvSelector', []).directive('csvSelector', [function () {
    'use strict';

    return {
        restrict: 'E',
        scope: {
            selectedFileCallback: '&?'
        },
        link: function link(scope, element) {
            var hiddenSelectorElement = element.find('.hiddenSelector'),
                selectedFileElement = element.find('.selectedFile'),
                selectorButtonElement = element.find('.selector');

            selectorButtonElement.on('click', function () {
                hiddenSelectorElement[0].click();
            });

            // when the file changes, update the preview
            hiddenSelectorElement.on('change', function () {
                var selectedFile = hiddenSelectorElement[0].files[0];

                if (selectedFile) {
                    selectedFileElement.val(selectedFile.name);
                }

                // check to see if we have a callback to pass the result to
                if (scope.selectedFileCallback && typeof scope.selectedFileCallback === 'function') {
                    scope.selectedFileCallback({ fileContents: selectedFile });
                }
            });

            scope.$on('$destroy', function onDestroy() {
                selectorButtonElement.off('click');
                hiddenSelectorElement.off('change');
            });
        },
        templateUrl: 'icm-web/views/partials/csv_selector'
    };
}]);
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.OnEnterAction', []).directive('onEnterAction', function () {
        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                element.on('keypress', function (event) {
                    if (event.which === 13) {
                        scope.$eval(attrs.onEnterAction);

                        event.preventDefault();
                    }
                });

                scope.$on('$destroy', function () {
                    element.off('keypress');
                });
            }
        };
    });
})();
'use strict';

(function () {
    'use strict';

    OutreachListComponentController.$inject = ["$window", "$mdMedia", "$location", "$translate", "$document"];
    angular.module('MW.ContactManager.OutreachList', ['ngMaterial', 'pascalprecht.translate']).component('outreachList', {
        templateUrl: 'icm-web/views/partials/outreach_list_component',
        bindings: {
            items: '=',
            isInitializing: '<',
            total: '<',
            pageNumber: '<',
            handlePage: '&',
            onDelete: '&',
            onDuplicate: '&',
            onFilterByStatus: '&',
            loadPromise: '&',
            selectedItems: '<',
            sortField: '<',
            sortOrder: '<',
            onSortChange: '&',
            onFindTextChange: '&',
            findText: '<',
            composeFunction: '&'
        },
        controller: OutreachListComponentController
    }).controller('OutreachListComponentController', ['$window', '$mdMedia', '$location', '$translate', '$document', OutreachListComponentController]);

    function OutreachListComponentController($window, $mdMedia, $location, $translate, $document) {
        var _this = this;
        this.$window = $window;
        this.$mdMedia = $mdMedia;
        this.$location = $location;
        this.selectedItems = [];
        this.isDataLoaded = true;

        this.$onInit = function () {
            this.findText = this.findText || '';
            this.isSearchActive = !!this.findText;

            this.paging = {
                itemsPerPage: 25,
                selectedPage: this.pageNumber || 1,
                totalItems: 0
            };

            this.setSortField = function (sortField, sortOrder) {
                //Default Sorting
                var orderObj = {
                    column: '-scheduledDateStamp',
                    descending: true
                };

                if (sortOrder) {
                    orderObj.descending = sortOrder !== 'ASC';
                }

                if (sortField) {
                    orderObj.column = orderObj.descending ? '-' + sortField : sortField;
                }

                return orderObj;
            };

            this.orderBy = this.setSortField(this.sortField, this.sortOrder);

            this.tablePaginationLabel = {
                of: 'mw-collection__table-pagination-of'
            };

            $translate(this.tablePaginationLabel.of).then(function (message) {
                this.tablePaginationLabel.of = message;
            }.bind(this));

            this.isHeaderTitleVisible = function () {
                return !($mdMedia('xs') && this.isSearchActive);
            };

            this.filterBy = 'All';
            this.setFilterBy = function (status) {
                var state = '';
                switch (status) {
                    case 'draft':
                        this.filterBy = 'Drafts';
                        state = 'draft';
                        break;
                    case 'scheduled':
                        this.filterBy = 'Scheduled';
                        state = 'scheduled';
                        break;
                    case 'sent':
                        this.filterBy = 'Sent';
                        state = 'sent';
                        break;
                    default:
                        this.filterBy = 'All';
                        break;
                }

                if (!this.isInitializing) {
                    this.paging.selectedPage = 1;
                    this.items = [];
                    this.isDataLoaded = false;
                    this.loadPromise = this.onFilterByStatus({
                        filterByType: state
                    }).then(function () {
                        _this.isDataLoaded = true;
                    });
                }
            };
            if (this.$location.search().filterByStatusType) {
                this.setFilterBy(this.$location.search().filterByStatusType);
            }

            this.onSearchToggle = function (isSearchActive) {
                this.isSearchActive = isSearchActive;
            };

            this.isDataLoading = function () {
                return !this.isDataLoaded;
            };

            this.isSearchVisible = function () {
                return true;
            };

            this.isCurrentSortColumn = function (column) {
                return this.orderBy.column.replace('-', '') === column;
            };

            this.isAscending = function () {
                return !this.orderBy.descending;
            };

            this.setColumn = function (column, shouldUpdateOrderBy) {
                if (shouldUpdateOrderBy) {
                    if (column !== _this.orderBy.column.replace('-', '')) {
                        if (!_this.orderBy.descending) {
                            _this.orderBy.column = column;
                        } else {
                            _this.orderBy.column = '-' + column;
                        }
                    }
                } else {
                    if (column.charAt(0) === '-') {
                        _this.orderBy.descending = true;
                    } else {
                        _this.orderBy.descending = false;
                    }
                }
                _this.sortChanged();
            };

            this.shouldSetMaxWidth = function () {
                return this.$mdMedia('md') || this.$mdMedia('sm');
            };

            this.setOrder = function (isDescending) {
                if (isDescending !== this.orderBy.descending) {
                    this.orderBy.descending = isDescending;
                    if (!isDescending) {
                        this.orderBy.column = this.orderBy.column.replace('-', '');
                    } else {
                        this.orderBy.column = '-' + this.orderBy.column;
                    }
                }
                this.sortChanged();
            };

            this.resetPagination = function () {
                if (this.paging.selectedPage !== 1) {
                    this.paging.selectedPage = 1;
                }
            };

            this.sortChanged = function sortChanged() {
                if (!this.isInitializing) {
                    this.resetPagination();
                    this.items = [];
                    this.isDataLoaded = false;
                    this.loadPromise = this.onSortChange({ column: this.orderBy.column, order: this.orderBy.descending }).then(function () {
                        _this.isDataLoaded = true;
                    });
                }
            };

            if (this.$location.search().sortField || this.$location.search().sortOrder) {
                this.setColumn(this.$location.search().sortField, this.$location.search().sortOrder === 'DESC');
            }

            this.onRowClick = function (item) {
                if (item.distributionStatus === 'sent' || item.distributionStatus === 'sending') {
                    this.$location.url(this.getItemPreviewUrl(item._id));
                } else if (this.canEditEmail(item)) {
                    this.$location.url(this.getItemEditUrl(item._id));
                }
            };

            this.search = function (findText) {
                if (!this.isInitializing && (findText.length === 0 || findText.length >= 3)) {
                    this.items = [];
                    this.isDataLoaded = false;
                    this.loadPromise = this.onFindTextChange({ findText: findText }).then(function () {
                        _this.isDataLoaded = true;
                    });

                    this.resetPagination();
                }
            };

            this.canEditEmail = function (item) {
                return item.distributionStatus === 'draft' || item.distributionStatus === 'scheduled' || item.distributionStatus === 'errors';
            };

            this.handleEditEmail = function (item) {
                this.$location.url(this.getItemEditUrl(item._id));
            };

            this.handlePreviewEmail = function (item) {
                this.$location.url(this.getItemPreviewUrl(item._id));
            };

            this.isHeaderDuplicateButtonEnabled = function () {
                return this.selectedItems.length === 1;
            };

            this.isEmptyStateVisible = function () {
                return !this.isDataLoading() && !this.isInitializing && (this.filteredItems && this.filteredItems.length === 0 || this.items.length === 0);
            };

            this.resetSelectedItems = function () {
                this.selectedItems = [];
            };

            this.page = function (e) {
                this.items = [];
                this.resetTableScroll();
                this.isDataLoaded = false;
                this.loadPromise = this.handlePage({ $event: e }).then(function () {
                    _this.isDataLoaded = true;
                });
            }.bind(this);

            this.handleSingleDelete = function (event, item) {
                /* ContactManagerOutreachListController expects an array of ids. This lets us avoid
                    having to change the controller behavior */
                var itemIdArr = [item._id];

                this.loadPromise = this.onDelete({
                    $event: event,
                    itemIdArr: itemIdArr
                });
            };

            this.handleBulkDelete = function (event) {
                this.loadPromise = this.onDelete({
                    $event: event,
                    itemIdArr: this.selectedItems
                });
            };

            this.handleSingleDuplicate = function (event, item) {
                /* ContactManagerOutreachListController expects an array of ids. This lets us avoid
                    having to change the controller behavior */
                var itemObj;

                if (Array.isArray(item)) {
                    this.items.some(function (email) {
                        if (email._id === item[0]) {
                            itemObj = email;
                            return true;
                        }
                    });
                }

                this.onDuplicate({
                    $event: event,
                    item: itemObj ? itemObj : item
                });
            };

            this.resetTableScroll = function () {
                var mdContentWrapperElementSelector = 'div.mi-app-chrome-content__app-content-slot';
                var dashboardTableId = '#mw-newswire-outreach-list__content';
                var tableEl = angular.element($document[0].querySelector(dashboardTableId));
                var mdContentEl = angular.element($document[0].querySelector(mdContentWrapperElementSelector));
                if (tableEl && mdContentEl) {
                    mdContentEl.scrollTop(tableEl[0].offsetTop);
                }
            };

            this.getItemPreviewUrl = function (itemId) {
                return '/influencers/contact/outreach/' + itemId;
            };

            this.getItemEditUrl = function (itemId) {
                return '/outreach/compose/' + itemId;
            };

            this.compose = function compose() {
                this.composeFunction({ distribution: undefined, state: undefined });
            };
        };
    }
})();
'use strict';

(function () {
    'use strict';

    ContactRecentDocumentController.$inject = ["InfluencerContactService", "$scope", "ContentBehaviorService", "$routeParams", "translationService", "AnalyticsService", "ANALYTICS_CONSTANTS"];
    angular.module('MW.ContactManager.RecentDocuments', ['MW.Framework.InfluencerContactService', 'MW.Influencers.AnalyticsService', 'MW.Framework.AnalyticsConstants', 'ngHaakon.components', 'MW.Framework.ContentStreamDocumentRow']).directive('recentDocumentsPublished', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/recent_documents_published',
            replace: true,
            scope: {
                documents: '&?',
                documentsConfig: '=?',
                pendingData: '&?',
                profileType: '@',
                sourceIds: '<'
            },
            controller: ContactRecentDocumentController
        };
    }).controller('ContactRecentDocumentController', ['InfluencerContactService', '$scope', 'ContentBehaviorService', '$routeParams', 'translationService', 'AnalyticsService', 'ANALYTICS_CONSTANTS', ContactRecentDocumentController]);

    function ContactRecentDocumentController(InfluencerContactService, $scope, ContentBehaviorService, $routeParams, translationService, AnalyticsService, ANALYTICS_CONSTANTS) {
        //call to get the recent documents from documentService
        $scope.rowSettings = {};
        $scope.pendingData = true;
        var searchQueryType, ids;

        if ($scope.profileType === 'source') {
            searchQueryType = 'source';
            ids = $scope.sourceIds;
        } else if ($scope.profileType === 'contact') {
            searchQueryType = 'contact';
            ids = [$routeParams.contactId];

            getRecentDocuments();
        }

        $scope.$watch('sourceIds', function (newValue) {
            if (newValue && newValue !== ids) {
                ids = $scope.sourceIds;

                getRecentDocuments();
            }
        });

        function getRecentDocuments() {
            InfluencerContactService.getRecentDocuments(searchQueryType, ids).then(function (response) {
                $scope.pendingData = false;
                $scope.documents = response;
                $scope.documentsConfig = {
                    documentClick: function documentClick(event, document, fullContentDialog, url) {
                        var documentDetail = {
                            document: document,
                            parentType: ANALYTICS_CONSTANTS.RECENT_RESULTS,
                            label: ANALYTICS_CONSTANTS.OPEN,
                            sourceDetail: document.source
                        };
                        event.preventDefault();

                        AnalyticsService.documentOperation(documentDetail);
                        ContentBehaviorService.documentClick(document, url);
                    }
                };
                if ($scope.documents && $scope.documents.documents) {
                    angular.forEach($scope.documents.documents, function (documentObj) {
                        documentObj.redirectUrl = ContentBehaviorService.buildRedirectUrl(documentObj, $scope.documentsConfig);

                        //Key for handling mutual toggle for duplicates
                        documentObj.duplicates = {};
                        if (documentObj.dupDocs && documentObj.dupDocs.length) {
                            documentObj.duplicates.show = false;
                        }
                    });
                } else {
                    $scope.pendingData = true;
                }
            }, function () {
                if ($scope.documents && $scope.documents.documents) {
                    $scope.documents.documents = [];
                }
                $scope.pendingData = true;
            });
        }

        $scope.getDupDocsCountWhen = function getDupDocsCountWhen(document) {
            if (document.dupDocs && document.dupDocs.length) {
                return {
                    1: translationService.getLocalizedString('1 more article'),
                    other: translationService.getLocalizedString('[[numArticles]] more articles', { numArticles: document.dupDocs.length })
                };
            } else {
                return null;
            }
        };

        $scope.documentClick = function documentClick($event, document, url) {
            $event.preventDefault();
            ContentBehaviorService.documentClick(document, url);
        };

        $scope.toggleRecentDuplicateDocs = function toggleRecentDuplicateDocs(document) {
            document.duplicates.show = !document.duplicates.show;
        };
    }
})();
'use strict';

(function () {
    'use strict';

    SourceCardController.$inject = ["$scope", "translationService"];
    angular.module('MW.CoreStream.SourceCard', ['MW.Framework.TranslationService', 'MW.Framework.TextFilters']).directive('sourceCard', function () {
        return {
            restrict: 'E',
            templateUrl: 'icm-web/views/partials/source_card',
            scope: {
                source: '=',
                showRelevantArticles: '&?',
                relevantArticleCount: '@?'
            },
            controller: SourceCardController,
            controllerAs: 'sourceCardController'
        };
    }).controller('sourceCardController', ['$scope', 'translationService', SourceCardController]);
    function SourceCardController($scope, translationService) {
        this.translationService = translationService;
        this.relevantArticle = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Article', { ArticleCount: $scope.relevantArticleCount });
        this.relevantArticles = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Articles', { ArticleCount: $scope.relevantArticleCount });

        // Can be removed after old search pages is removed
        this.getBeatName = function getBeatName(beat) {
            if (typeof beat === 'string') {
                // New CSS
                return beat;
            } else {
                // Old CSS
                return beat.name;
            }
        };

        this.getCity = function getCity(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.city) {
                    return address.city;
                }
            }
            return null;
        };
        this.getStateOrProvince = function getStateOrProvince(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.stateOrProvince) {
                    return address.stateOrProvince;
                }
            }
            return null;
        };
        this.getCountry = function getCountry(contactInfo) {
            var address;
            if (contactInfo && contactInfo.addresses) {
                address = contactInfo.addresses[0];
                if (address && address.countryName) {
                    return address.countryName;
                }
            }
            return null;
        };
        this.city = $scope.source.city ? $scope.source.city : this.getCity($scope.source.contactInfo);
        this.stateOrProvince = $scope.source.stateOrProvince ? $scope.source.stateOrProvince : this.getStateOrProvince($scope.source.contactInfo);
        this.country = $scope.source.country ? $scope.source.country : this.getCountry($scope.source.contactInfo);
    }
})();
'use strict';

(function () {
    'use strict';

    TemplateListComponentController.$inject = ["$scope", "$translate", "$mdDialog", "$mdToast", "EmailTemplateService", "DialogService", "mwCustomToastService", "mwCustomBannerService"];
    angular.module('MW.ContactManager.TemplateList', ['ngMaterial', 'pascalprecht.translate', 'MW.Influencers.EmailTemplateService', 'MW.Influencers.IcmDialogService', 'MW.ContactManager.CustomToastService', 'MW.ContactManager.CustomBannerService', 'MW.Influencers.TextFilters']).component('templateList', {
        templateUrl: 'icm-web/views/partials/template_list_component',
        bindings: {
            editTemplateFn: '&',
            createOutreachFn: '&',
            duplicateTemplateFn: '&',
            createTemplateFn: '&'
        },
        controller: TemplateListComponentController
    }).controller('TemplateListComponentController', ['$scope', '$translate', '$mdDialog', '$mdToast', 'EmailTemplateService', 'DialogService', 'mwCustomToastService', 'mwCustomBannerService', TemplateListComponentController]);

    function TemplateListComponentController($scope, $translate, $mdDialog, $mdToast, EmailTemplateService, DialogService, mwCustomToastService, mwCustomBannerService) {
        this.$scope = $scope;
        this.EmailTemplateService = EmailTemplateService;
        this.DialogService = DialogService;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.$mdToast = $mdToast;
        this.mwCustomToastService = mwCustomToastService;
        this.mwCustomBannerService = mwCustomBannerService;
        this.selectedItems = [];
        this.items = [];
        this.findTemplateText = this.findTemplateText || '';
        this.isSearchActive = !!this.findTemplateText;
        this.paging = {
            itemsPerPage: 50,
            selectedPage: this.pageNumber || 1,
            totalItems: 0
        };

        this.deleteSuccessToastMessage = this.$translate.instant('icm-outreach__template--delete-success-toast');
        this.confirmDeleteTitle = this.$translate.instant('icm-outreach__template--confirm-delete-header');
        this.confirmDeleteBody = this.$translate.instant('icm-outreach__template--confirm-delete-description');
        this.deleteAlertBannerText = this.$translate.instant('icm-outreach__template--delete-alert-banner-text');

        this.bulkDeleteConfirmTitle = this.$translate.instant('icm-outreach__template--bulk-delete-confirm-title');
        this.bulkDeleteConfirmBody = this.$translate.instant('icm-outreach__template--bulk-delete-confirm-body');
        this.bulkDeleteSuccessMessage = this.$translate.instant('icm-outreach__template--bulk-delete-success-message');
        this.bulkDeleteAlertBannerText = this.$translate.instant('icm-outreach__template--bulk-delete-alert-banner-text');

        this.$onInit = function () {
            var _this = this;

            //init the templates
            this.EmailTemplateService.getAllTemplatesByCompany().then(function () {
                _this.items = _this.EmailTemplateService.getTemplates();
            });
            this.orderBy = 'title';
            this.changeOrderBy = function changeOrderBy(column) {
                if (this.isAscending()) {
                    this.orderBy = column;
                } else {
                    this.orderBy = '-' + column;
                }
            };
            this.isOrderedBy = function isOrderedBy(column) {
                var regex = new RegExp('^(?:-?)(?:' + column + ')$');
                var regexMatch = this.orderBy.match(regex);

                return regexMatch === null ? false : true;
            };
            this.sortAscending = function sortAscending() {
                if (this.orderBy.match(/^-/)) {
                    this.orderBy = this.orderBy.replace(/^-/, '');
                }
            };
            this.sortDescending = function sortDescending() {
                if (!this.orderBy.match(/^-/)) {
                    this.orderBy = '-' + this.orderBy;
                }
            };
            this.isAscending = function isAscending() {
                return this.orderBy.match(/^-/) === null ? true : false;
            };

            this.onSearchToggle = function (isSearchActive) {
                this.isSearchActive = isSearchActive;
            };

            this.edit = function edit(event, itemId) {
                this.editTemplateFn({ ev: event, id: itemId });
            };

            this.createEmailWithTemplate = function createEmailWithTemplate(itemId) {
                this.createOutreachFn({ id: itemId });
            };

            this.duplicateTemplate = function duplicateTemplate(event, itemId) {
                this.duplicateTemplateFn({ ev: event, id: itemId });
            };

            this.search = function search(findTemplateText) {
                this.items = this.EmailTemplateService.getTemplates();
                this.findTemplateText = findTemplateText;

                if (findTemplateText.length > 0) {
                    this.templatesList = this.items.filter(function (template) {
                        if (template.title.toLowerCase().indexOf(findTemplateText.toLowerCase()) > -1) {
                            return template;
                        }
                    });

                    this.items = this.templatesList;
                }
            };

            this.deleteTemplate = function (event, id) {
                var _this2 = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().class('icm-confirmation-modal').title(this.confirmDeleteTitle).textContent(this.confirmDeleteBody).ok(this.$translate.instant('Ok')).cancel(this.$translate.instant('Cancel')).targetEvent(event)).then(function () {
                    _this2.$mdDialog.hide();
                    _this2._performDelete(event, id);
                }, function () {
                    _this2.$mdDialog.cancel();
                });
            };

            this._performDelete = function (event, templateId) {
                var _this3 = this;

                this.EmailTemplateService.deleteTemplateById(templateId).then(function () {
                    _this3.refreshTemplates();

                    _this3.$mdToast.show(_this3.mwCustomToastService.simpleTimedClosable(_this3.deleteSuccessToastMessage));
                }).catch(function () {
                    _this3.openAlertBanner(_this3.deleteAlertBannerText, _this3._performDelete, [event, templateId]);
                });
            };

            this._performBulkDelete = function _performBulkDelete(event, templateIds) {
                var _this4 = this;

                this.EmailTemplateService.deleteTemplateByIds(templateIds).then(function () {
                    _this4.resetSelectedItems();
                    _this4.refreshTemplates();

                    _this4.$mdToast.show(_this4.mwCustomToastService.simpleTimedClosable(_this4.bulkDeleteSuccessMessage));
                }).catch(function () {
                    _this4.openAlertBanner(_this4.bulkDeleteAlertBannerText, _this4._performBulkDelete, [event, templateIds]);
                });
            };

            this.bulkDelete = function bulkDelete(event, templateIds) {
                var _this5 = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().class('icm-confirmation-modal').title(this.bulkDeleteConfirmTitle).textContent(this.bulkDeleteConfirmBody).ok(this.$translate.instant('Ok')).cancel(this.$translate.instant('Cancel')).targetEvent(event)).then(function () {
                    _this5.$mdDialog.hide();
                    _this5._performBulkDelete(event, templateIds);
                }, function () {
                    _this5.$mdDialog.cancel();
                });
            };

            this.openAlertBanner = function openAlertBanner(alertBannerText, retryCallback, callbackArgs) {
                var outreachTemplateListController = this;
                this.mwCustomBannerService.alertWithRetry(alertBannerText, retryCallback, callbackArgs, outreachTemplateListController, '.banner-space');
            };

            this.refreshTemplates = function () {
                var _this6 = this;

                this.EmailTemplateService.getAllTemplatesByCompany().then(function () {
                    _this6.search(_this6.findTemplateText);
                });
            };

            this.isEmptyStateVisible = function () {
                var isVisible = false;
                if (this.findTemplateText.length > 0 && this.items.length === 0) {
                    isVisible = true;
                } else {
                    isVisible = !this.EmailTemplateService.getIsLoadingTemplates() && this.EmailTemplateService.getTemplates().length === 0;
                }
                return isVisible;
            };

            this.resetSelectedItems = function () {
                this.selectedItems = [];
            };

            this.$scope.$on('refreshTemplatesSelected', function () {
                _this.resetSelectedItems();
            });

            this.$scope.$on('updateTemplates', function () {
                _this.EmailTemplateService.getAllTemplatesByCompany().then(function () {
                    _this.search(_this.findTemplateText);
                });
            });

            this.createTemplate = function createTemplate(event) {
                this.createTemplateFn({ ev: event });
            };
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Framework.Editor.v4', ['MW.Framework.CoreCompanyService', 'Configuration', 'MW.Framework.CoreUserService', 'MW.Framework.TranslationService', 'MW.Influencers.IcmDialogService']).directive('tinymceEditorV4', ['$timeout', 'CoreCompanyService', 'CoreUserService', 'translationService', 'DialogService', 'FILE_UPLOADER_URL', 'ICM_ASSETS_URL', '$parse', function ($timeout, CoreCompanyService, CoreUserService, translationService, DialogService, FILE_UPLOADER_URL, ICM_ASSETS_URL, $parse) {
        var randomEditorId = Math.ceil(Math.random() * 10000);

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function link(scope, elem, attrs, ngModel) {
                translationService.waitForTranslations().then(function () {
                    var options,
                        customOptions,
                        editorInstance,
                        updateView,
                        setElementAttributes,
                        createFormats,
                        imageUploadHandlerFn,
                        imageUploadAcceptedTypes = 'image/jpeg, image/jpg, image/png, image/gif, image/svg+xml',
                        smallStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-small'),
                        normalStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-normal'),
                        largeStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-large'),
                        hugeStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-huge'),
                        fixedStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-fixed'),
                        wideStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-wide'),
                        narrowStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-narrow'),
                        listTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--list-tooltip'),
                        bullistTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--bullist-tooltip'),
                        numlistTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--numlist-tooltip'),
                        indentTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--indent-tooltip'),
                        firstNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name'),
                        firstNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder'),
                        lastNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name'),
                        lastNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder'),
                        genericErrorMessage = translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'),
                        uploadingImageMessage = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--uploading-image-message'),
                        editorLanguageMap = {
                        da: 'da', // danish
                        de: 'de', // german
                        en: null, // english (default)
                        es: 'es', // spanish
                        fi: 'fi', // finnish
                        fr: 'fr_FR', // french
                        ja: 'ja', // japanese
                        nb: 'nb_NO', // norwegian
                        nl: 'nl', // dutch
                        pt: 'pt_PT', // portuguese
                        sv: 'sv_SE', // swedish
                        /* jshint camelcase: false */
                        zh_CN: 'zh_CN', // chinese (simplified)
                        /* jshint camelcase: false */
                        zh_TW: 'zh_TW' // chinese (traditional)
                    },
                        editorLanguage = editorLanguageMap.hasOwnProperty(CoreUserService.getLanguage()) ? editorLanguageMap[CoreUserService.getLanguage()] : null;

                    //we're now using this Handler for powerPaste and custom imageUpload
                    imageUploadHandlerFn = function imagesUploadHandler(blobInfo, success, failure) {
                        var xhr, formData;
                        xhr = new XMLHttpRequest();
                        xhr.open('POST', FILE_UPLOADER_URL + '/upload');
                        xhr.withCredentials = false;
                        xhr.timeout = 10000; //TODO: move this out to configuration, if we do it now though, won't be able to patch in december

                        function setIsBusy(isBusy) {
                            var callbackFunction;

                            if (attrs.busyCallback) {
                                callbackFunction = $parse(attrs.busyCallback);
                                callbackFunction(scope, { isBusy: isBusy });
                            }
                        }

                        // on start of upload, we are busy
                        setIsBusy(true);

                        function failed(message) {
                            setIsBusy(false);
                            failure(message);
                        }

                        function succeeded(link) {
                            setIsBusy(false);
                            success(link);
                            updateView();
                        }

                        xhr.onload = function () {
                            var json;

                            if (xhr.status !== 200) {
                                failed('HTTP Error: ' + xhr.status);
                                return;
                            }
                            json = JSON.parse(xhr.responseText);

                            if (!json || typeof json.link !== 'string') {
                                failed('Invalid JSON: ' + xhr.responseText);
                                return;
                            }
                            succeeded(json.link);
                        };
                        xhr.ontimeout = function () {
                            failed('HTTP Error: ' + xhr.status);
                        };
                        formData = new FormData();
                        formData.append('file', blobInfo.blob(), blobInfo.filename());
                        formData.append('renameFileWithTimestamp', true);
                        xhr.setRequestHeader('Authorization', CoreCompanyService.getAuthToken());
                        xhr.send(formData);
                    };

                    // assign/replace ID
                    attrs.$set('id', 'editor_' + randomEditorId);

                    // customOptions passed as directive parameters
                    if (attrs.tinymceEditorOptions) {
                        customOptions = scope.$eval(attrs.tinymceEditorOptions);
                    } else {
                        customOptions = {};
                    }
                    options = {
                        // Update model after user actions
                        setup: function setup(editor) {
                            editor.on('init', function () {
                                ngModel.$render();

                                // register method to be called on blur event
                                if (customOptions.onBlurEvent && customOptions.context) {
                                    editor.on('blur', customOptions.onBlurEvent.bind(customOptions.context));
                                }
                            });

                            // Update model on button click, keypress, blur
                            editor.on('ExecCommand KeyUp blur', function () {
                                editor.save();
                                updateView();
                            });
                            // Update model on change, i.e. copy/pasted text, plugins altering content
                            editor.on('SetContent', function (e) {
                                if (!e.initial) {
                                    editor.save();
                                    updateView();
                                }
                            });
                            // action when Image resized
                            editor.on('ObjectResized', function (e) {
                                if (e.target.nodeName === 'IMG') {
                                    $timeout($(e.target).removeAttr('data-mce-style').removeAttr('style'), 0);
                                }
                            });

                            //icm_fontFamilyList button
                            editor.addButton('icm_fontFamilyList', function () {
                                var emailSupportedFontFamilies = 'Sans Serif=arial,helvetica,sans-serif;' + 'Serif=times new roman,serif;' + fixedStr + '=monospace,monospace;' + wideStr + '=arial black,sans-serif;' + narrowStr + '=arial narrow,sans-serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Garamond=garamond,serif;' + 'Georgia=georgia,serif;' + 'Tahoma=tahoma,sans-serif;' + 'Trebuchet MS=trebuchet ms,sans-serif;' + 'Verdana=verdana,sans-serif;',
                                    items = [],
                                    fonts = createFormats(editor.settings.font_formats || emailSupportedFontFamilies); // jshint ignore:line

                                angular.forEach(fonts, function (font) {
                                    items.push({
                                        text: { raw: font[0] },
                                        value: font[1],
                                        textStyle: 'font-family:' + font[1]
                                    });
                                });

                                return {
                                    type: 'listbox',
                                    text: '',
                                    tooltip: 'Font Family',
                                    values: items,
                                    fixedWidth: true,
                                    onselect: function onSelectFontFn(e) {
                                        var newValue = e.control.settings.value ? e.control.settings.value : false,
                                            currentValue = editor.queryCommandValue('FontName');
                                        if (newValue && (currentValue === 0 || newValue !== currentValue)) {
                                            editor.execCommand('FontName', false, newValue);
                                        } else {
                                            editor.focus();
                                        }
                                    }
                                };
                            });

                            //icm_fontSizeList button
                            editor.addButton('icm_fontSizeList', function () {
                                var emailSupportedFontSizes = smallStr + '=10px;' + normalStr + '=13px;' + largeStr + '=18px;' + hugeStr + '=32px;',
                                    items = [],
                                    sizes = createFormats(editor.settings.fontsize_formats || emailSupportedFontSizes); // jshint ignore:line

                                angular.forEach(sizes, function (size) {
                                    items.push({
                                        text: { raw: size[0] },
                                        value: size[1],
                                        textStyle: 'font-size:' + size[1]
                                    });
                                });

                                return {
                                    type: 'listbox',
                                    text: '',
                                    tooltip: 'Font Sizes',
                                    values: items,
                                    fixedWidth: true,
                                    onselect: function onselect(e) {
                                        var newValue = e.control.settings.value ? e.control.settings.value : false,
                                            currentValue = editor.queryCommandValue('FontSize');
                                        if (newValue && (currentValue === 0 || newValue !== currentValue)) {
                                            editor.execCommand('FontSize', false, newValue);
                                        } else {
                                            editor.focus();
                                        }
                                    },
                                    onPostRender: function onPostRender() {
                                        // select NORMAL by default
                                        this.value(items[1].value);
                                    }
                                };
                            });

                            editor.addButton('icm_bullist', {
                                icon: 'bullist',
                                text: '',
                                tooltip: bullistTooltip,
                                onclick: function bulletListFn() {
                                    tinymce.execCommand('InsertUnorderedList');
                                }
                            });

                            editor.addButton('icm_numlist', {
                                icon: 'numlist',
                                text: '',
                                tooltip: numlistTooltip,
                                onclick: function orderedListFn() {
                                    tinymce.execCommand('InsertOrderedList');
                                }
                            });

                            //icm_alignmentList button
                            editor.addButton('icm_alignmentList', {
                                type: 'menubutton',
                                text: '',
                                icon: 'alignleft',
                                tooltip: 'Alignment',
                                menu: [{
                                    icon: 'alignleft',
                                    text: 'Left',
                                    onclick: function alignLeftFn() {
                                        tinymce.execCommand('JustifyLeft');
                                        setElementAttributes(this.parent().parent(), null, 'alignleft', 'JustifyLeft');
                                    }
                                }, {
                                    icon: 'alignright',
                                    text: 'Right',
                                    onclick: function alignRightFn() {
                                        tinymce.execCommand('JustifyRight');
                                        setElementAttributes(this.parent().parent(), null, 'alignright', 'JustifyRight');
                                    }
                                }, {
                                    icon: 'aligncenter',
                                    text: 'Center',
                                    onclick: function alignCenterFn() {
                                        tinymce.execCommand('JustifyCenter');
                                        setElementAttributes(this.parent().parent(), null, 'aligncenter', 'JustifyCenter');
                                    }
                                }, {
                                    icon: 'alignjustify',
                                    text: 'Justify',
                                    onclick: function alignJustifyFn() {
                                        tinymce.execCommand('JustifyFull');
                                        setElementAttributes(this.parent().parent(), null, 'alignjustify', 'JustifyFull');
                                    }
                                }],
                                onPostRender: function onPostRenderAlignmentFn() {
                                    // initial value
                                    this.value = 'JustifyLeft';
                                }
                            });

                            //icm_list button
                            editor.addButton('icm_list', {
                                type: 'menubutton',
                                text: '',
                                tooltip: listTooltip,
                                icon: 'bullist',
                                menu: [{
                                    icon: 'bullist',
                                    text: 'Bullet list',
                                    onclick: function bulletListFn() {
                                        tinymce.execCommand('InsertUnorderedList');
                                    }
                                }, {
                                    icon: 'numlist',
                                    text: 'Numbered list',
                                    onclick: function orderedListFn() {
                                        tinymce.execCommand('InsertOrderedList');
                                    }
                                }],
                                onPostRender: function onPostRenderListFn() {
                                    // initial value
                                    this.value = 'InsertUnorderedList';
                                }
                            });

                            //icm_indentation button
                            editor.addButton('icm_indentation', {
                                type: 'menubutton',
                                text: '',
                                icon: 'outdent',
                                tooltip: indentTooltip,
                                fixedWidth: false,
                                menu: [{
                                    icon: 'outdent',
                                    text: 'Decrease indent',
                                    onclick: function outdentFn() {
                                        tinymce.execCommand('Outdent');
                                    }
                                }, {
                                    icon: 'indent',
                                    text: 'Increase indent',
                                    onclick: function indentFn() {
                                        tinymce.execCommand('Indent');
                                    }
                                }],
                                onPostRender: function onPostRenderIndentationFn() {
                                    // initial value
                                    this.value = 'Outdent';
                                }
                            });

                            //icm_mailMerge button
                            editor.addButton('icm_mailMerge', {
                                type: 'menubutton',
                                text: '',
                                icon: 'person',
                                menu: [{
                                    icon: '',
                                    text: firstNameText,
                                    onclick: function firstNameFn() {
                                        editor.insertContent('<span class="mceNonEditable">' + firstNamePlaceholder + '</span>');
                                    }
                                }, {
                                    icon: '',
                                    text: lastNameText,
                                    onclick: function lastNameFn() {
                                        editor.insertContent('<span class="mceNonEditable">' + lastNamePlaceholder + '</span>');
                                    }
                                }]
                            });

                            //icm_insertImage
                            editor.addButton('icm_imageUpload', function () {
                                var inputFileId = 'file_' + randomEditorId;

                                return {
                                    icon: 'image',
                                    tooltip: 'Insert Image',
                                    onPostRender: function onPostRender() {
                                        //add a form to document.body with a single file input in it
                                        angular.element(document.body).append(angular.element('<form/>').append(angular.element('<input/>').attr('type', 'file').attr('name', inputFileId).attr('accept', imageUploadAcceptedTypes).attr('id', inputFileId).attr('style', 'display: none;') // this was adding a visible file selector on the page
                                        ));

                                        angular.element('#' + inputFileId).on('change', function () {
                                            if (angular.element(this).val().length > 0) {
                                                var imageBlob,
                                                    blobInfo,
                                                    blobObjectUrl,
                                                    image,
                                                    imageId = 'image_' + Math.ceil(Math.random() * 10000 + 1),
                                                    file = $('#' + inputFileId)[0].files[0],
                                                    fileReader = new FileReader();

                                                // use the fileReader to upload a blob and attach the img element to tinyMCE
                                                fileReader.onloadend = function whenFileReaderIsReady(event) {
                                                    imageBlob = new Blob([event.target.result], { type: file.type });
                                                    blobObjectUrl = window.URL.createObjectURL(imageBlob);

                                                    //let's use the blobObjectURL as src temporarily while we upload our image to S3, we'll then replace it with the actual URL
                                                    image = new Image();
                                                    image.addEventListener('load', function () {
                                                        editor.insertContent(angular.element('<img />').attr('id', imageId).attr('width', image.width).attr('height', image.height).attr('style', 'opacity: 0.3;').attr('src', image.src)[0].outerHTML);
                                                        editor.insertContent('<p></p>'); //breakline after inserting image
                                                        image = null;
                                                    }, false);
                                                    image.src = blobObjectUrl;

                                                    //reset the input file for further use
                                                    angular.element('#' + inputFileId).parent().get(0).reset();

                                                    //object used by our handler
                                                    blobInfo = {
                                                        blob: function blob() {
                                                            return imageBlob;
                                                        },
                                                        filename: function filename() {
                                                            return file.name;
                                                        }
                                                    };

                                                    // //set a loading state right after loading image so the user knows there is something going on!
                                                    editor.notificationManager.open({
                                                        text: uploadingImageMessage,
                                                        type: 'info',
                                                        timeout: -1,
                                                        progressBar: false
                                                    });

                                                    //use imageUploadHandlerFn to upload our file
                                                    imageUploadHandlerFn(blobInfo, function success(link) {

                                                        //now let's make a new image to replace scr and remove upload notification once loaded
                                                        image = new Image();
                                                        image.addEventListener('load', function () {
                                                            editor.$('#' + imageId).attr('src', link).removeAttr('style').removeAttr('id');

                                                            editor.notificationManager.close();
                                                            image = null;
                                                        }, false);

                                                        image.src = link;
                                                    }, function failure() {
                                                        //if the upload fails, lets get rid of the image, close notification and display our flash error
                                                        editor.$('#' + imageId).remove();
                                                        editor.notificationManager.close();
                                                        DialogService.flashError(genericErrorMessage);

                                                        $timeout(function () {
                                                            angular.element(document.body).triggerHandler('click');
                                                        });
                                                    });
                                                };

                                                fileReader.readAsArrayBuffer(file);
                                            }
                                        });
                                    },
                                    onclick: function onclick() {
                                        angular.element('#' + inputFileId).click();
                                    }
                                };
                            });

                            if (customOptions.setup) {
                                scope.$eval(customOptions.setup);
                                delete customOptions.setup;
                            }
                        },
                        skin: 'meltwater',
                        base: ICM_ASSETS_URL + 'client/js/lib/tinymce_v4',
                        menubar: false,
                        statusbar: false,
                        mode: 'exact',
                        elements: attrs.id,
                        plugins: 'powerpaste',
                        language: editorLanguage,
                        /* jshint camelcase: false */
                        entity_encoding: 'raw',
                        // Uploads a file to our node-file-uploader and returns the link
                        /* jshint camelcase: false */
                        font_formats: 'Sans Serif=arial,helvetica,sans-serif;Serif=times new roman,serif;' + fixedStr + '=monospace,monospace;' + wideStr + '=arial black,sans-serif;' + narrowStr + '=arial narrow,sans-serif;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,sans-serif;Trebuchet MS=trebuchet ms,sans-serif;Verdana=verdana,sans-serif;',
                        images_upload_handler: imageUploadHandlerFn,
                        //force_br_newlines : false,
                        force_p_newlines: false,
                        forced_root_block: '',
                        /* jshint camelcase: false */
                        init_instance_callback: function init_instance_callback(editor) {
                            if (attrs.stickTo) {
                                var editorContainerElement = angular.element(editor.editorContainer),
                                    toolbarElement = editorContainerElement.find('.mce-toolbar-grp'),
                                    editAreaElement = editorContainerElement.find('.mce-edit-area'),
                                    stickToElement = angular.element(attrs.stickTo),
                                    debounceScroll = _.debounce(function () {
                                    if (editorContainerElement.position().top <= 0) {
                                        toolbarElement.css('top', stickToElement.offset().top);

                                        toolbarElement.addClass('stick');
                                        editAreaElement.addClass('stick');
                                    } else {
                                        toolbarElement.removeClass('stick');
                                        editAreaElement.removeClass('stick');
                                    }

                                    repositionColorPicker();
                                }, 10),

                                // fix the issue with color picker going off screen when header is stuck
                                repositionColorPicker = function repositionColorPicker() {
                                    var colorButton = document.querySelector('.mce-colorbutton');
                                    if (colorButton) {
                                        $('.mce-colorbutton-grid').closest('div').css('top', $('.mce-colorbutton').offset() + $('.mce-colorbutton').height());
                                    }
                                };

                                stickToElement.on('scroll', debounceScroll);

                                // choosing the color picker propagates up to the textEditor. was getting messy trying to trap the event in between, so just handle it here.
                                $('.textEditor').on('click', function () {
                                    repositionColorPicker();
                                });
                            }

                            //set focus on first input
                            $('form *:input[type!=hidden][type!=file]:first').focus();
                        }
                    };

                    var newPlugins = options.plugins + ' ' + customOptions.plugins;
                    angular.extend(options, customOptions);

                    if (customOptions.plugins) {
                        options.plugins = newPlugins;
                    }

                    options.invalid_styles = 'visibility overflow opacity';

                    function initTiny() {
                        $timeout(function initializeEditor() {
                            if (window.tinymce) {
                                window.tinymce.init(options);
                                editorInstance = window.tinymce.get(attrs.id);
                            } else {
                                initTiny();
                            }
                        }, 100);
                    }
                    initTiny();

                    ngModel.$render = function () {
                        if (editorInstance && editorInstance.getDoc() && ngModel) {
                            editorInstance.setContent(ngModel.$viewValue || '');
                        }
                    };

                    scope.$on('$destroy', function () {
                        if (editorInstance) {
                            editorInstance.remove();
                        }

                        if (attrs.stickTo) {
                            angular.element(attrs.stickTo).off('scroll');
                        }

                        $('.textEditor').off('click');
                    });

                    updateView = function updateView() {
                        ngModel.$setViewValue(editorInstance.getContent());

                        $timeout(function applyChanges() {
                            scope.$apply();
                        }, 0);
                    };

                    setElementAttributes = function setElementAttributes(el, text, icon, value) {
                        if (text) {
                            el.text(text);
                        }

                        if (icon) {
                            el.icon(icon);
                        }

                        if (value) {
                            el.value = value;
                        }
                    };

                    createFormats = function createFormats(formats) {
                        formats = formats.replace(/;$/, '').split(';');

                        var i = formats.length;
                        while (i--) {
                            formats[i] = formats[i].split('=');
                        }

                        return formats;
                    };
                });
            }
        };
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Framework.Editor.v5', ['MW.Framework.CoreCompanyService', 'MW.Framework.CoreUserService', 'MW.Framework.TranslationService', 'MW.Influencers.IcmDialogService', 'Configuration']).directive('tinymceEditorV5', ['$timeout', '$parse', 'CoreCompanyService', 'CoreUserService', 'translationService', 'DialogService', 'FILE_UPLOADER_URL', 'ICM_ASSETS_URL', function ($timeout, $parse, CoreCompanyService, CoreUserService, translationService, DialogService, FILE_UPLOADER_URL, ICM_ASSETS_URL) {
        var randomEditorId = Math.ceil(Math.random() * 10000);

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function link(scope, elem, attrs, ngModel) {
                translationService.waitForTranslations().then(function () {
                    var options,
                        customOptions,
                        editorInstance,
                        updateView,
                        imageUploadHandlerFn,
                        imageUploadAcceptedTypes = 'image/jpeg, image/jpg, image/png, image/gif, image/svg+xml',
                        uploadingImageMessage = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--uploading-image-message'),
                        genericErrorMessage = translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'),
                        fixedStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-fixed'),
                        wideStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-wide'),
                        narrowStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-narrow'),
                        firstNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name'),
                        firstNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder'),
                        lastNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name'),
                        lastNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder'),
                        uploading = false,
                        editorLanguageMap = {
                        da: 'da', // danish
                        de: 'de', // german
                        en: null, // english (default)
                        es: 'es', // spanish
                        fi: 'fi', // finnish
                        fr: 'fr_FR', // french
                        ja: 'ja', // japanese
                        nb: 'nb_NO', // norwegian
                        nl: 'nl', // dutch
                        pt: 'pt_PT', // portuguese
                        sv: 'sv_SE', // swedish
                        /* jshint camelcase: false */
                        zh_CN: 'zh_CN', // chinese (simplified)
                        /* jshint camelcase: false */
                        zh_TW: 'zh_TW' // chinese (traditional)
                    },
                        editorColorMap = ['#000000', 'Black', '#993300', 'Burnt orange', '#333300', 'Dark olive', '#003300', 'Dark green', '#003366', 'Dark azure', '#000080', 'Navy Blue', '#333399', 'Indigo', '#333333', 'Very dark gray', '#800000', 'Maroon', '#FF6600', 'Orange', '#808000', 'Olive', '#008000', 'Green', '#008080', 'Teal', '#0000FF', 'Blue', '#666699', 'Grayish blue', '#808080', 'Gray', '#FF0000', 'Red', '#FF9900', 'Amber', '#99CC00', 'Yellow green', '#339966', 'Sea green', '#33CCCC', 'Turquoise', '#3366FF', 'Royal blue', '#800080', 'Purple', '#999999', 'Medium gray', '#FF00FF', 'Magenta', '#FFCC00', 'Gold', '#FFFF00', 'Yellow', '#00FF00', 'Lime', '#00FFFF', 'Aqua', '#00CCFF', 'Sky blue', '#993366', 'Red violet', '#FFFFFF', 'White', '#FF99CC', 'Pink', '#FFCC99', 'Peach', '#FFFF99', 'Light yellow', '#CCFFCC', 'Pale green', '#CCFFFF', 'Pale cyan', '#99CCFF', 'Light sky blue', '#CC99FF', 'Plum'],
                        editorLanguage = editorLanguageMap.hasOwnProperty(CoreUserService.getLanguage()) ? editorLanguageMap[CoreUserService.getLanguage()] : null;

                    //setElementAttributes, createFormats,
                    //we're now using this Handler for powerPaste and custom imageUpload
                    imageUploadHandlerFn = function imagesUploadHandler(blobInfo, success, failure) {
                        var xhr, formData;
                        xhr = new XMLHttpRequest();
                        xhr.open('POST', FILE_UPLOADER_URL + '/upload');
                        xhr.withCredentials = false;
                        xhr.timeout = 60000; //TODO: move this out to configuration, if we do it now though, won't be able to patch in december

                        function setIsBusy(isBusy) {
                            var callbackFunction;

                            if (attrs.busyCallback) {
                                callbackFunction = $parse(attrs.busyCallback);
                                callbackFunction(scope, { isBusy: isBusy });
                            }
                        }

                        // on start of upload, we are busy
                        setIsBusy(true);

                        function failed(message) {
                            setIsBusy(false);
                            failure(message);
                            scope.$broadcast('closeLoading', { remove: true });
                        }

                        function succeeded(link) {
                            setIsBusy(false);
                            success(link);
                            updateView();
                            scope.$broadcast('closeLoading');
                        }

                        xhr.onload = function () {
                            var json;

                            if (xhr.status !== 200) {
                                failed('HTTP Error: ' + xhr.status);
                                return;
                            }
                            json = JSON.parse(xhr.responseText);

                            if (!json || typeof json.link !== 'string') {
                                failed('Invalid JSON: ' + xhr.responseText);
                                return;
                            }
                            succeeded(json.link);
                        };
                        xhr.ontimeout = function () {
                            failed('HTTP Error: ' + xhr.status);
                        };
                        formData = new FormData();
                        formData.append('file', blobInfo.blob(), blobInfo.filename());
                        formData.append('renameFileWithTimestamp', true);
                        xhr.setRequestHeader('Authorization', CoreCompanyService.getAuthToken());
                        xhr.send(formData);
                    };

                    // assign/replace ID
                    attrs.$set('id', 'editor_' + randomEditorId);

                    // customOptions passed as directive parameters
                    if (attrs.tinymceEditorOptions) {
                        customOptions = scope.$eval(attrs.tinymceEditorOptions);
                    } else {
                        customOptions = {};
                    }

                    var tinyBaseUrl = ICM_ASSETS_URL + 'client/js/lib/tinymce_v5';
                    options = {
                        // Update model after user actions
                        setup: function setup(editor) {
                            editor.on('init', function () {
                                ngModel.$render();

                                // register method to be called on blur event
                                if (customOptions.onBlurEvent && customOptions.context) {
                                    editor.on('blur', customOptions.onBlurEvent.bind(customOptions.context));
                                }
                            });

                            // Update model on button click, keypress, blur
                            editor.on('ExecCommand KeyUp blur', function () {
                                editor.save();
                                updateView();
                            });

                            // Update model on change, i.e. copy/pasted text, plugins altering content
                            editor.on('SetContent', function (e) {
                                if (!e.initial) {
                                    editor.save();
                                    updateView();
                                }
                            });

                            // action when Image resized
                            editor.on('ObjectResized', function (e) {
                                if (e.target.nodeName === 'IMG') {
                                    $timeout($(e.target).removeAttr('data-mce-style').removeAttr('style'), 0);
                                }
                            });

                            //icm_mailMerge button
                            editor.ui.registry.addMenuButton('icm_mailMerge', {
                                icon: 'user',
                                fetch: function fetch(callback) {
                                    var items = [{
                                        type: 'menuitem',
                                        text: firstNameText,
                                        onAction: function firstNameFn() {
                                            editor.insertContent('<span class="mceNonEditable">' + firstNamePlaceholder + '</span>');
                                        }
                                    }, {
                                        type: 'menuitem',
                                        text: lastNameText,
                                        onAction: function lastNameFn() {
                                            editor.insertContent('<span class="mceNonEditable">' + lastNamePlaceholder + '</span>');
                                        }
                                    }];

                                    return callback(items);
                                }
                            });

                            var inputFileId = 'file_' + randomEditorId;
                            editor.ui.registry.addButton('icm_imageUploadV5', {
                                icon: 'image',
                                tooltip: 'Insert Image',
                                onAction: function onAction() {
                                    angular.element('#' + inputFileId).click();
                                },
                                onSetup: function onSetup() {
                                    var editorEventCallback = function editorEventCallback() {
                                        //add a form to document.body with a single file input in it
                                        if (angular.element('input#' + inputFileId).length === 0) {
                                            angular.element(document.body).append(angular.element('<form/>').append(angular.element('<input/>').attr('type', 'file').attr('name', inputFileId).attr('accept', imageUploadAcceptedTypes).attr('id', inputFileId).attr('style', 'display: none;') // this was adding a visible file selector on the page
                                            ));
                                        }
                                        angular.element('#' + inputFileId).on('change', function () {
                                            if (angular.element(this).val().length > 0 && uploading === false) {
                                                var imageBlob,
                                                    blobObjectUrl,
                                                    image,
                                                    imageId = 'image_' + Math.ceil(Math.random() * 10000 + 1),
                                                    file = $('#' + inputFileId)[0].files[0],
                                                    fileReader = new FileReader();

                                                uploading = true;
                                                // use the fileReader to upload a blob and attach the img element to tinyMCE
                                                fileReader.onloadend = function whenFileReaderIsReady(event) {
                                                    imageBlob = new Blob([event.target.result], { type: file.type });
                                                    blobObjectUrl = window.URL.createObjectURL(imageBlob);

                                                    //let's use the blobObjectURL as src temporarily while we upload our image to S3, we'll then replace it with the actual URL
                                                    image = new Image();
                                                    image.addEventListener('load', function () {
                                                        editor.insertContent(angular.element('<img />').attr('id', imageId).attr('width', image.width).attr('height', image.height).attr('style', 'opacity: 0.3;').attr('src', image.src)[0].outerHTML);
                                                        editor.insertContent('<p></p>'); //breakline after inserting image
                                                        image = null;
                                                    }, false);
                                                    image.src = blobObjectUrl;

                                                    //reset the input file for further use
                                                    document.querySelector('input#' + inputFileId).value = '';

                                                    // //set a loading state right after loading image so the user knows there is something going on!
                                                    editor.notificationManager.open({
                                                        text: uploadingImageMessage,
                                                        type: 'info',
                                                        timeout: -1,
                                                        progressBar: false
                                                    });

                                                    scope.$on('closeLoading', function (event, args) {
                                                        editor.notificationManager.close();
                                                        uploading = false;
                                                        if (args && args.remove) {
                                                            editor.$('#' + imageId).remove();
                                                            DialogService.flashError(genericErrorMessage);
                                                        }
                                                    });
                                                };

                                                fileReader.readAsArrayBuffer(file);
                                            }
                                        });
                                    };
                                    editor.on('NodeChange', editorEventCallback);
                                    /* onSetup should always return the unbind handlers */
                                    return function () {
                                        editor.off('NodeChange', editorEventCallback);
                                    };
                                }
                            });

                            if (customOptions.setup) {
                                scope.$eval(customOptions.setup);
                                delete customOptions.setup;
                            }
                        },
                        selector: 'textarea.editor',
                        base_url: tinyBaseUrl,
                        suffix: '.min',
                        menubar: false,
                        statusbar: false,
                        toolbar_drawer: 'sliding',
                        contextmenu: false,
                        // elements: attrs.id,
                        language: editorLanguage,
                        entity_encoding: 'raw',
                        /* jshint camelcase: false */
                        font_formats: 'Sans Serif=arial,helvetica,sans-serif;Serif=times new roman,serif;' + fixedStr + '=monospace,monospace;' + wideStr + '=arial black,sans-serif;' + narrowStr + '=arial narrow,sans-serif;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,sans-serif;Trebuchet MS=trebuchet ms,sans-serif;Verdana=verdana,sans-serif;',
                        images_upload_handler: imageUploadHandlerFn,
                        /* jshint camelcase: false */
                        color_cols: 8,
                        color_map: editorColorMap,
                        invalid_styles: 'visibility overflow opacity',
                        init_instance_callback: function init_instance_callback(editor) {
                            //set focus on first input
                            $('form *:input[type!=hidden][type!=file]:first').focus();

                            // we are ignoring the scroll into view event, as it conflicted with our custom sticky header
                            editor.on('ScrollIntoView', function (event) {
                                event.stopPropagation();
                                event.preventDefault();
                            });

                            if (attrs.stickTo) {
                                var editorContainerElement = angular.element(editor.editorContainer),
                                    toolbarElement = editorContainerElement.find('.tox-editor-header'),
                                    stickToElement = angular.element(attrs.stickTo),
                                    debounceScroll = _.debounce(function () {
                                    if (editorContainerElement.position().top <= 0) {
                                        toolbarElement.css('top', stickToElement.offset().top);
                                        toolbarElement.addClass('stick');
                                    } else {
                                        toolbarElement.removeClass('stick');
                                    }
                                }, 10);

                                stickToElement.on('scroll', debounceScroll);
                            }
                        }
                    };

                    angular.extend(options, customOptions);

                    function initTiny() {
                        $timeout(function initializeEditor() {
                            if (window.tinymce) {
                                window.tinymce.init(options);
                                editorInstance = window.tinymce.get(attrs.id);
                            } else {
                                initTiny();
                            }
                        }, 50);
                    }
                    initTiny();

                    ngModel.$render = function () {
                        if (editorInstance && editorInstance.getDoc() && ngModel) {
                            editorInstance.setContent(ngModel.$viewValue || '');
                        }
                    };

                    scope.$on('$destroy', function () {
                        if (editorInstance) {
                            editorInstance.remove();
                        }

                        $('.textEditor').off('click');
                    });

                    updateView = function updateView() {
                        ngModel.$setViewValue(editorInstance.getContent());

                        $timeout(function applyChanges() {
                            scope.$apply();
                        }, 0);
                    };
                });
            }
        };
    }]);
})();
'use strict';

angular.module('MW.ContactManager.ContactManagerContactModel', ['MW.ContactManager.ContactManagerPropertyTypeService']).factory('Contact', ['emailTypes', 'phoneNumberTypes', 'addressTypes', 'activeOnTypes', 'FairhairChannelTypes', 'FairhairSocialProfileTypes', function (emailTypes, phoneNumberTypes, addressTypes, activeOnTypes, FairhairChannelTypes, FairhairSocialProfileTypes) {
    'use strict';

    function Contact(descriptor, sourcesObject) {
        descriptor = descriptor || {};

        // ID
        if (descriptor.id) {
            this.id = descriptor.id;
        }

        // NAME
        this.name = descriptor.name || {
            prefix: undefined,
            firstName: '',
            middleName: '',
            lastName: ''
        };
        this.name.middleName = this.name.middleName || '';
        this.name.fullName = '';
        this.name.fullName += this.name.firstName || '';
        this.name.fullName += this.name.middleName ? ' ' + this.name.middleName : '';
        this.name.fullName += this.name.lastName ? ' ' + this.name.lastName : '';
        this.unsubscribed = false;
        // CONTACT INFO
        this.contactInfo = {};
        descriptor.contactInfo = descriptor.contactInfo || {};

        this.contactInfo.email = Array.isArray(descriptor.contactInfo.email) && descriptor.contactInfo.email.length ? descriptor.contactInfo.email : [{
            type: emailTypes.WORK,
            address: ''
        }];

        this.contactInfo.phone = Array.isArray(descriptor.contactInfo.phone) && descriptor.contactInfo.phone.length ? descriptor.contactInfo.phone : [{
            type: phoneNumberTypes.WORK,
            number: ''
        }];

        // TODO: remove this once the IM changes back to contactInfo.addresses (rather than contactInfo.address)
        // Setting 'addresses' based on 'addresses' OR 'address' to handle current state
        descriptor.contactInfo.address = descriptor.contactInfo.addresses || descriptor.contactInfo.address;

        this.contactInfo.address = Array.isArray(descriptor.contactInfo.address) && descriptor.contactInfo.address.length ? descriptor.contactInfo.address : [{
            type: addressTypes.WORK,
            street: '',
            street2: '',
            city: '',
            zip: '',
            countryName: '',
            stateOrProvince: ''
        }];

        this.contactInfo.address.forEach(function addressLoop(address) {
            this.isAddressEmpty(address);
        }.bind(this));

        // NOTES
        this.notes = Array.isArray(descriptor.notes) && descriptor.notes.length ? descriptor.notes : [''];
        this.channels = descriptor.channels ? descriptor.channels : [];
        var sourceMap = {};

        this.channels.forEach(function (channel) {
            if (channel.sourceId) {
                sourceMap[channel.sourceId] = channel;
            }
        });

        // SOURCES - Populate sources into channels for all contacts and filter out the duplicates
        if (descriptor.sourceSnippets) {
            descriptor.sourceSnippets.forEach(function (source) {
                if (source.sourceType !== 'bureau') {
                    // add the non-bureau into the channels
                    source.type = activeOnTypes.SOURCE;
                    this.channels.push(source);
                    sourceMap[source.id] = source; // update the sourceMap with more sufficient source info
                }
            }.bind(this));
        }

        this.pruneChannelSources(this.channels, sourcesObject);
        if (descriptor.socialProfiles && descriptor.socialProfiles.length) {
            descriptor.socialProfiles.forEach(function (socialProfile) {
                var missingProfile = false;
                this.channels.filter(function (channel) {
                    if (channel.socialProfile && channel.socialProfile.type === socialProfile.type) {
                        missingProfile = true;
                        return false;
                    }
                });
                if (missingProfile === false) {
                    this.channels.push(socialProfile);
                }
            }.bind(this));
        }
        this.addChannelTypes(this.channels, sourcesObject);

        this.title = descriptor.title || [];
        this.description = descriptor.description || '';
        this.beats = descriptor.beats || [];
        this.systemData = descriptor.systemData || [];
        this.mediaLists = descriptor.mediaLists || [];
        this.roles = descriptor.roles || [];
        if (descriptor.contactInfo.email && Array.isArray(descriptor.contactInfo.email) && descriptor.contactInfo.email[0] && descriptor.contactInfo.email[0].unsubscribed) {
            this.contactInfo.email.map(function (value, index) {
                value.unsubscribed = descriptor.contactInfo.email[index].unsubscribed ? descriptor.contactInfo.email[index].unsubscribed : false;
                return value;
            });
        } else {
            this.contactInfo.email.map(function (value) {
                value.unsubscribed = false;
                return value;
            });
        }
        if (descriptor.relevantArticles) {
            this.relevantArticles = descriptor.relevantArticles;
        } else {
            this.relevantArticles = 0;
        }

        this.updated = descriptor.updated || null;

        if (descriptor.lat && descriptor.lon) {
            this.lat = descriptor.lat;
            this.lon = descriptor.lon;
        }

        this.automated = descriptor.automated || false;
    }

    Contact.prototype.addChannelTypes = function addChannelTypes(channels, sources) {
        var sourceObj = {},
            sourceIds = [];
        if (sources) {
            sources.map(function (source) {
                sourceObj[source.id] = source;
            });
        }

        if (channels && channels.length > 0) {
            channels.forEach(function (channel, i, arr) {
                switch (channel.type) {
                    case FairhairChannelTypes.WEBSITE:
                        channel.type = activeOnTypes.BLOG;
                        break;
                    case FairhairChannelTypes.SOCIAL:
                        switch (channel.socialProfile.type) {
                            case FairhairSocialProfileTypes.TWITTER:
                                arr[i] = channel.socialProfile;
                                arr[i].type = activeOnTypes.TWITTER;
                                break;
                            case FairhairSocialProfileTypes.FACEBOOK:
                                arr[i] = channel.socialProfile;
                                arr[i].type = activeOnTypes.FACEBOOK;
                                break;
                            case FairhairSocialProfileTypes.LINKED_IN:
                                arr[i] = channel.socialProfile;
                                arr[i].type = activeOnTypes.LINKED_IN;
                                break;
                            default:
                                break;
                        }
                        break;
                    case FairhairSocialProfileTypes.TWITTER:
                        channel.type = activeOnTypes.TWITTER;
                        break;
                    case FairhairSocialProfileTypes.FACEBOOK:
                        channel.type = activeOnTypes.FACEBOOK;
                        break;
                    case FairhairSocialProfileTypes.LINKED_IN:
                        channel.type = activeOnTypes.LINKED_IN;
                        break;
                    case activeOnTypes.SOURCE:
                        if (sourceObj && sourceObj[channel.id]) {
                            if (sourceIds.indexOf(channel.id) === -1) {
                                arr[i] = sourceObj[channel.id];
                                arr[i].type = activeOnTypes.SOURCE;
                                sourceIds.push(channel.sourceId);
                            } else {
                                arr.splice(i, 1);
                            }
                        }
                        break;
                    case FairhairChannelTypes.SOURCE:
                        if (sourceObj && sourceObj[channel.sourceId]) {
                            if (sourceIds.indexOf(channel.sourceId) === -1) {
                                arr[i] = sourceObj[channel.sourceId];
                                arr[i].type = FairhairChannelTypes.SOURCE;
                                sourceIds.push(channel.sourceId);
                            }
                        } else {
                            // this channel.sourceId does not match any sources.
                            arr[i].type = 'unknown';
                        }
                        break;
                    default:
                        break;
                }
            }, this);
        }
    };

    Contact.prototype.pruneChannelSources = function pruneChannelSources(channels, sources) {
        var channel, index;
        if (sources) {
            sources.forEach(function (source) {
                if (source.parentIds && source.sourceType !== 'bureau') {
                    source.parentIds.forEach(function (id) {
                        channels.forEach(function (channel, index, arr) {
                            if (channel.sourceId && channel.sourceId === id) {
                                arr.splice(index, 1);
                            }
                        });
                    });
                } else {
                    for (index = channels.length - 1; index >= 0; index--) {
                        channel = channels[index];
                        if (channel.sourceId) {
                            if (channel.sourceId === source.id) {
                                channels.splice(index, 1);
                            }
                        }
                    }
                }
            });
        }
    };

    Contact.prototype.isAddressEmpty = function isAddressEmpty(address) {
        var addressFieldArray = ['city', 'countryCode', 'countryName', 'stateOrProvince', 'street', 'street2', 'zip'];
        address.isAddressEmpty = true;
        addressFieldArray.forEach(function fieldLoop(field) {
            if (!!address[field]) {
                address.isAddressEmpty = false;
            }
        });
    };

    Contact.prototype.getEmail = function getEmail() {
        if (this.contactInfo.email[0]) {
            return this.contactInfo.email[0].address;
        } else {
            return null;
        }
    };

    Contact.prototype.getUnsubscribedStatus = function getUnsubscribedStatus() {
        return !!(this.contactInfo.email[0] && this.contactInfo.email[0].unsubscribed);
    };

    Contact.prototype.setUnsubscribedStatus = function setUnsubscribedStatus(email) {
        this.unsubscribed = this.contactInfo.email[0].address.toLowerCase() === email.toLowerCase();
    };

    return Contact;
}]);
'use strict';

(function () {
    'use strict';

    angular.module('AuthTokenHttpInterceptor', ['MW.Configuration']).factory('AuthTokenHttpInterceptor', ['$q', '$cookies', '$window', 'ACCOUNTS_APP_URL', '$location', 'ICM_ASSETS_URL', function ($q, $cookies, $window, ACCOUNTS_APP_URL, $location, ICM_ASSETS_URL) {
        return {
            request: function request(req) {
                var cookie;
                // if we dont have an auth header, try to add one
                if (!req.headers || !req.headers.Authorization) {
                    cookie = $cookies.getObject('gydaToken');

                    // if we dont have a token in the cookie or the query params, logout
                    // else store it & add it to the header
                    if (cookie && cookie.token) {
                        req.headers.Authorization = cookie.token;
                    } else if ($location.search().auth) {
                        req.headers.Authorization = $location.search().auth;
                        $cookies.putObject('gydaToken', { token: $location.search().auth });
                    } else {
                        $window.location.href = ACCOUNTS_APP_URL + '/logout';
                        return req;
                    }
                }

                // workaround for https://github.com/meltwater/gaf-ng-components/issues/608
                // if we include the autho token to assests.io, all requests fail.
                if (req.url.startsWith(ICM_ASSETS_URL) && req.headers || req.skipAuthInterceptor || req.url.startsWith('https://assets.meltwater.io/icm-web-assets/static/img')) {
                    // found a strange case where the auth header comes in lower case, and sneaks by...
                    delete req.headers.Authorization;
                    delete req.headers.authorization;
                }

                return req;
            },

            responseError: function responseError(rejection) {
                if (rejection.status === 401) {
                    $window.location.href = ACCOUNTS_APP_URL + '/logout';
                } else {
                    return $q.reject(rejection);
                }
            }
        };
    }]);
})();
'use strict';

angular.module('MW.ContactManager.ContactDomainModelConverter', ['MW.ContactManager.ContactManagerPropertyTypeService']).factory('ContactDomainModelConverter', ['activeOnTypes', 'FairhairChannelTypes', 'FairhairSocialProfileTypes', function (activeOnTypes, FairhairChannelTypes, FairhairSocialProfileTypes) {
    'use strict';

    return {
        convertToDomainModel: function convertToDomainModel(contact, companyId) {
            // Convert channels from View to Domain types
            if (contact.channels) {
                var domainChannels = [],
                    domainSources = [];

                contact.channels.forEach(function (channel) {
                    var domainChannel = {};

                    switch (channel.type) {
                        case activeOnTypes.BLOG:
                            domainChannel = channel;
                            domainChannel.type = FairhairChannelTypes.WEBSITE;

                            break;
                        case activeOnTypes.FACEBOOK:
                            domainChannel = {
                                type: FairhairChannelTypes.SOCIAL,
                                socialProfile: {
                                    type: FairhairSocialProfileTypes.FACEBOOK,
                                    userName: channel.userName,
                                    url: channel.url
                                }
                            };

                            break;
                        case activeOnTypes.TWITTER:
                            domainChannel = {
                                type: FairhairChannelTypes.SOCIAL,
                                socialProfile: {
                                    type: FairhairSocialProfileTypes.TWITTER,
                                    userName: channel.userName,
                                    url: channel.url
                                }
                            };

                            break;
                        case activeOnTypes.LINKED_IN:
                            domainChannel = {
                                type: FairhairChannelTypes.SOCIAL,
                                socialProfile: {
                                    type: FairhairSocialProfileTypes.LINKED_IN,
                                    userName: channel.userName,
                                    url: channel.url
                                }
                            };
                            break;

                        case activeOnTypes.SOURCE:
                            if (channel.source) {
                                domainSources.push(channel.source.source || { name: channel.source });
                            }

                            break;

                        default:
                            break;
                    }

                    if (Object.keys(domainChannel).length) {
                        domainChannels.push(domainChannel);
                    }
                }, contact);

                contact.channels = domainChannels;
                if (domainSources.length) {
                    contact.sources = domainSources;
                }
            } else {
                contact.channels = [];
            }

            return {
                id: contact.id,
                companyId: companyId,
                name: contact.name,
                title: contact.title,
                contactInfo: {
                    email: contact.contactInfo.email,
                    phone: contact.contactInfo.phone,
                    addresses: contact.contactInfo.address
                },
                notes: contact.notes,
                channels: contact.channels,
                mediaLists: contact.mediaLists,
                sources: contact.sources
            };
        }
    };
}]);
'use strict';

/*jshint camelcase: false */
angular.module('MW.ContactManager.ContactManagerActionBarFactory', ['MW.Framework.TranslationService', 'MW.Framework.InfluencerContactService', 'MW.Framework.ICMEmailService', 'MW.Influencers.IcmDialogService', 'MW.Framework.CoreUserService', 'MW.ContactManager.ContactManagerOutreachComposeController', 'MW.ContactManager.ContactManagerNavigationService', 'Configuration']).factory('ContactManagerActionBarFactory', ['DialogService', 'translationService', 'InfluencerContactService', 'CoreUserService', 'ICMEmailService', '$location', '$controller', '$rootScope', '$q', 'ContactManagerNavigationService', 'EmailTemplateService', 'ICM_ASSETS_URL', function (DialogService, translationService, InfluencerContactService, CoreUserService, ICMEmailService, $location, $controller, $rootScope, $q, ContactManagerNavigationService, EmailTemplateService, ICM_ASSETS_URL) {
    'use strict';

    function ContactManagerActionBarFactory(ContactSelector) {
        if (!ContactSelector) {
            return;
        }

        this.ContactSelector = ContactSelector;
        this.InfluencerContactService = InfluencerContactService;
        this.DialogService = DialogService;
        this.ICM_ASSETS_URL = ICM_ASSETS_URL;
    }

    ContactManagerActionBarFactory.prototype._exportSelectedContacts = function _exportSelectedContacts(csvFileName) {
        var exportPromise,
            contactId,
            pageSize,
            selectedContactData = {
            ids: [],
            emails: []
        };

        for (contactId in this.ContactSelector.selectedItems) {
            if (this.ContactSelector.selectedItems.hasOwnProperty(contactId)) {
                if (contactId.match(/^other_contact_/)) {
                    selectedContactData.emails.push(this.ContactSelector.selectedItems[contactId].contactInfo.email[0].address);
                } else {
                    selectedContactData.ids.push(contactId);
                }
            }
        }

        pageSize = selectedContactData.ids.length + selectedContactData.emails.length;
        exportPromise = this.InfluencerContactService.exportSelected(csvFileName, selectedContactData, pageSize);

        this._performExport(exportPromise);
    };

    ContactManagerActionBarFactory.prototype._performExport = function _performExport(exportPromise) {
        this.DialogService.flashInfo(translationService.getLocalizedString('Downloading the selected contacts...'));

        exportPromise.then(function () {
            this.DialogService.flashSuccess(translationService.getLocalizedString('Success. The selected contacts have been downloaded.'));
        }.bind(this)).catch(function () {
            this.DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
        }.bind(this));
    };

    ContactManagerActionBarFactory.prototype.exportContactsToCSV = function exportContactsToCSV(csvFileName, isAllContacts, selectedMediaListId, pageSize, q) {
        var exportPromise;

        if (this.ContactSelector.trueAllSelected) {
            exportPromise = this.InfluencerContactService.exportByMediaList(csvFileName, isAllContacts, selectedMediaListId, pageSize, q);

            this._performExport(exportPromise);
        } else {
            this._exportSelectedContacts(csvFileName);
        }
    };

    ContactManagerActionBarFactory.prototype.exportContactsByStatToCsv = function exportContactsByStatToCsv(csvFileName, distributionId, pageSize, statType, clickedLink) {
        var exportPromise;

        if (this.ContactSelector.trueAllSelected) {
            exportPromise = this.InfluencerContactService.exportByStat(csvFileName, distributionId, pageSize, statType, clickedLink);

            this._performExport(exportPromise);
        } else {
            this._exportSelectedContacts(csvFileName);
        }
    };

    ContactManagerActionBarFactory.prototype.exportUnsubscribedContactsToCSV = function exportUnsubscribedContactsToCSV(csvFileName, distributionId, pageSize, reason) {
        var exportPromise;

        if (this.ContactSelector.trueAllSelected) {
            exportPromise = this.InfluencerContactService.exportByUnsubscribes(csvFileName, distributionId, pageSize, reason);

            this._performExport(exportPromise);
        } else {
            this._exportSelectedContacts(csvFileName);
        }
    };

    ContactManagerActionBarFactory.prototype.compose = function compose(setRecipientsFunction, dialogMode) {
        function showUnapprovedDialog() {
            var dialogTitle = translationService.getLocalizedString('Compose Email');

            DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
                // currently this is service is only ever called by ICM-WEB, so we always load up F-W. in this ends up being used in FW as well, we will need to revisit this logic.
                ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
            });
        }

        function composeEmail(senderObject) {
            var dialogTitle, dialogTemplate, payload, allTemplates, customDialogCss;

            ICMEmailService.resetRecipients();

            setRecipientsFunction().then(function () {
                ICMEmailService.setSender(senderObject);

                if (dialogMode) {
                    var emailSetupPromises = [CoreUserService.getCurrent(true), EmailTemplateService.getAllTemplates()];

                    $q.all(emailSetupPromises).then(function (response) {
                        if (response[1] && response[1].data && response[1].data.templates) {
                            allTemplates = response[1].data.templates.map(function (template) {
                                return {
                                    id: template.id,
                                    title: template.name,
                                    body: template.body
                                };
                            });
                        } else {
                            allTemplates = [];
                        }
                        var composeControllerScope = $rootScope.$new(),
                            outreachComposeController = $controller('ContactManagerOutreachComposeController', {
                            $scope: composeControllerScope,
                            editorLanguage: response[0].language,
                            approvedSenderArray: senderObject,
                            sendgridDomainsArray: [],
                            templatesList: allTemplates,
                            dialogMode: true,
                            loadEditorLibrary: true
                        }),
                            callback = function callback() {
                            composeControllerScope.$destroy();
                            ICMEmailService.resetRecipients();
                        };

                        customDialogCss = {
                            left: '50%',
                            width: '650px'
                        };

                        dialogTitle = translationService.getLocalizedString('Compose Email');
                        dialogTemplate = 'icm-web/views/partials/outreach_compose_form';

                        payload = {
                            outreachComposeController: outreachComposeController,
                            wrapperTemplate: 'icm-gaf-legacy/views/partials/dialog_manager_content_scroll'
                        };

                        // load tiny v5. need to do this dynamically as we swap between v4 and v5
                        angular.element('.tinymceLib').remove();
                        var tiny5 = document.createElement('script');
                        tiny5.setAttribute('class', 'tinymceLib');
                        tiny5.setAttribute('src', ICM_ASSETS_URL + 'client/js/lib/tinymce_v5/tinymce_v5.min.js');
                        document.head.appendChild(tiny5);

                        DialogService.dialog(dialogTitle, dialogTemplate, payload, callback, undefined, undefined, true, customDialogCss);
                    }).catch(function () {
                        DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                    });
                } else {
                    $location.url('/outreach/compose?step=1');
                }
            });
        }

        ICMEmailService.getIcmApprovedSenders().then(function onGetApprovedSendersSuccess(sendersList) {
            if (sendersList.length) {
                composeEmail(sendersList);
            } else {
                showUnapprovedDialog();
            }
        }).catch(function onGetApprovedSendersFail() {
            DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
        });
    };

    return ContactManagerActionBarFactory;
}]);
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.BeatService', ['Configuration', 'MW.Framework.TranslationService', 'MW.Framework.CoreUserService']).service('BeatService', ['$q', '$http', '$timeout', 'CONTACT_MANAGER_BEATS_URL', 'translationService', 'CoreUserService', function ($q, $http, $timeout, CONTACT_MANAGER_BEATS_URL, translationService, CoreUserService) {
        this.$timeout = $timeout;
        this.CoreUserService = CoreUserService;
        this.cachedContactBeats = [];
        this.cachedSourceBeats = [];
        this.orignalContactBeats = [];
        this.orignalSourceBeats = [];
        this.cachedUserLanguage = {
            'contact': this.CoreUserService.getLanguage(),
            'source': this.CoreUserService.getLanguage()
        };

        var translateBeats = function translateBeats(beatsArray) {
            var returningBeats = angular.copy(beatsArray);
            returningBeats.forEach(function translateParent(beat) {
                beat.name = translationService.getLocalizedString(beat.name);
                if (beat.children && beat.children.length > 0) {
                    beat.children.forEach(function translateChild(childBeat) {
                        childBeat.name = translationService.getLocalizedString(childBeat.name);
                    }.bind(this));
                }
            }.bind(this));

            return returningBeats;
        };

        this.getAllContactBeats = function getAllContactBeats() {
            var deferred = $q.defer();
            if (!this.cachedContactBeats.length) {
                $http.get(CONTACT_MANAGER_BEATS_URL + '/contacts').then(function (response) {
                    this.orignalContactBeats = response.data;
                    this.cachedContactBeats = translateBeats(this.orignalContactBeats);
                    deferred.resolve(this.cachedContactBeats);
                }.bind(this)).catch(function (response) {
                    deferred.reject(response.data);
                });
            } else {
                this.$timeout(function () {
                    if (this.CoreUserService.getLanguage() !== this.cachedUserLanguage.contact) {
                        this.cachedContactBeats = translateBeats(this.orignalContactBeats);
                        this.cachedUserLanguage.contact = this.CoreUserService.getLanguage();
                    }
                    deferred.resolve(this.cachedContactBeats);
                }.bind(this), 0, false);
            }

            return deferred.promise;
        };

        this.getAllSourceBeats = function getAllSourceBeats() {
            var deferred = $q.defer();
            if (this.cachedSourceBeats.length <= 0) {
                $http.get(CONTACT_MANAGER_BEATS_URL + '/sources').then(function (response) {
                    this.orignalSourceBeats = response.data;
                    this.cachedSourceBeats = translateBeats(this.orignalSourceBeats);
                    deferred.resolve(this.cachedSourceBeats);
                }.bind(this)).catch(function (response) {
                    deferred.reject(response.data);
                });
            } else {
                this.$timeout(function () {
                    if (this.CoreUserService.getLanguage() !== this.cachedUserLanguage.source) {
                        this.cachedSourceBeats = translateBeats(this.orignalSourceBeats);
                        this.cachedUserLanguage.source = this.CoreUserService.getLanguage();
                    }
                    deferred.resolve(this.cachedSourceBeats);
                }.bind(this), 0, false);
            }

            return deferred.promise;
        };
    }]);
})();
'use strict';

angular.module('MW.ContactManager.FilterFactory', ['MW.Framework.MEDAppModelBuilder', 'MW.Framework.SelectAccordionItem', 'MW.Framework.TranslationService']).factory('ContactManagerFilterFactory', ['SelectAccordionItem', 'translationService', 'MEDAppModelBuilder', function (SelectAccordionItem, translationService, MEDAppModelBuilder) {
    'use strict';

    function FilterFactory(filterList) {
        this.options = [];

        if (this[filterList.id]) {
            this[filterList.id](filterList);
        } else {
            this.buildOptionItems(filterList.data);
        }

        return this.filter;
    }

    FilterFactory.prototype.location = function location(list) {
        list.data.forEach(function loopItems(item) {
            this.options.push(new SelectAccordionItem({
                id: item.name,
                name: item.name,
                code: item.code
            }));
        }, this);
    };

    FilterFactory.prototype.regions = function regions(list) {
        list.data.forEach(function loopItems(item) {
            this.options.push(new SelectAccordionItem({
                id: item.name,
                name: item.name,
                code: item.name
            }));
        }, this);
    };

    FilterFactory.prototype.subregions = function subRegions(list) {
        list.data.forEach(function loopItems(item) {
            this.options.push(new SelectAccordionItem({
                id: item,
                name: item
            }));
        }, this);
    };

    FilterFactory.prototype.buildOptionItems = function buildOptionItems(data) {
        if (data && Array.isArray(data)) {
            data.forEach(function buildLoop(item) {
                this.options.push(new SelectAccordionItem({
                    id: item.name,
                    name: item.name
                }));
            }, this);
        }
    };

    FilterFactory.build = function build(attributes) {
        attributes = attributes || {};

        return MEDAppModelBuilder.build(attributes, FilterFactory);
    };

    return FilterFactory;
}]);
'use strict';

/*globals _*/
angular.module('MW.ContactManager.ContactManagerFilterService', ['Configuration', 'MW.ContactManager.FilterFactory', 'MW.Framework.EntitlementService']).service('ContactManagerFilterService', ['$http', 'CONTACT_MANAGER_FILTER_URL', '$q', 'ContactManagerFilterFactory', 'EntitlementService', function ($http, CONTACT_MANAGER_FILTER_URL, $q, ContactManagerFilterFactory, EntitlementService) {
    'use strict';

    this.getAllFilterOptions = function getAllFilterOptions() {
        var defer = $q.defer();

        $http.get(CONTACT_MANAGER_FILTER_URL).then(function onGetOptionsSuccess(response) {
            EntitlementService.getIcmCountriesEntitlement().then(function afterGetIcmCountriesEntitlement(entitledCountriesList) {
                var countriesList = [];

                response.data.locations.data.forEach(function loop(location) {
                    if (location.name && entitledCountriesList.indexOf(location.name.toLowerCase()) !== -1) {
                        countriesList.push(location);
                    }
                });

                response.data.locations.data = countriesList;

                defer.resolve(response.data);
            });
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    this.getLocationFilterOptions = function getLocationFilterOptions(type, country, region) {
        var defer = $q.defer(),
            url = CONTACT_MANAGER_FILTER_URL,
            params;

        url = url + '/' + type;
        params = country ? '?country=' + country : '';

        if (region) {
            params = params + (params ? '&' : '?') + 'region=' + region;
        }
        $http.get(url + params).then(function onGetOptionsSuccess(response) {
            var filters = ContactManagerFilterFactory.build(response.data);
            defer.resolve(filters);
        }).catch(function (response) {
            defer.reject(response.data);
        });
        return defer.promise;
    };

    this.getActiveFiltersFromFilters = function getActiveFiltersFromFilters(filters) {
        var finalFilterObject = {},
            filtersWithoutEmptyStrings,
            filterName;

        _.each(filters, function (filter) {
            if (filter.selected) {
                filtersWithoutEmptyStrings = _.filter(filter.selected, function (filterId) {
                    return filterId !== '';
                });
                if (filtersWithoutEmptyStrings && filtersWithoutEmptyStrings.length > 0) {
                    filterName = filter.id;
                    if (filter.id === 'location') {
                        filterName = 'Location';
                    }
                    finalFilterObject[filterName] = {
                        name: filter.id,
                        selected: filtersWithoutEmptyStrings
                    };
                }
            }
        });

        return finalFilterObject;
    };
}]);
'use strict';

angular.module('MW.ContactManager.ContactManagerFlashService', ['MW.Influencers.IcmDialogService', 'MW.Framework.ErrorMessageService', 'MW.Framework.TranslationService']).service('ContactManagerFlashService', ['DialogService', 'ErrorMessageService', 'translationService', function (DialogService, ErrorMessageService, translationService) {
    var flashTimeout = 0; // 0 disables the timeout

    this.flashError = function flashError(err, message, messageParams) {
        var errorStatusCode, errorMessageObject;

        if (message) {
            messageParams = messageParams || false;
            DialogService.flashError(translationService.getLocalizedString(message, messageParams), flashTimeout);
        } else {
            errorStatusCode = err && err.statusCode ? err.statusCode : 500;
            errorMessageObject = ErrorMessageService.getErrorMessageFromStatusCode(errorStatusCode);

            DialogService.flashError(errorMessageObject.message, flashTimeout);
        }
    };

    this.flashSuccess = function flashSuccess(message) {
        DialogService.flashSuccess(translationService.getLocalizedString(message));
    };

    this.flashWarning = function flashWarning(message) {
        DialogService.flashWarning(translationService.getLocalizedString(message));
    };
}]);
'use strict';

angular.module('MW.ContactManager.ContactManagerNavigationService', ['MW.Framework.PageStateService', 'MW.Configuration']).service('ContactManagerNavigationService', ['$location', 'PageStateService', '$window', 'FAIRHAIR_WEB_URL', 'IRM_BASE_URL', 'MR_SEARCH_URL', function ($location, PageStateService, $window, FAIRHAIR_WEB_URL, IRM_BASE_URL, MR_SEARCH_URL) {
    'use strict';

    return {
        previousLocation: null,
        clickedBackButton: false,

        // if you are using this back button & came from within the influencer app you should go back there.
        // if you did not come from within the influencer app (paste url, bookmark, browser back button, etc.), should be sent to the landing page
        smartBackAction: function smartBackAction() {
            var locationHistoryFromSession, previousLocationFromSession;

            this.clickedBackButton = true;
            locationHistoryFromSession = this.getIcmLocationHistoryFromSession();
            if (Array.isArray(locationHistoryFromSession) && locationHistoryFromSession.length && $location.url() !== '/influencers/contact/landing') {
                previousLocationFromSession = locationHistoryFromSession.pop();
                this.setIcmLocationHistoryInSession(locationHistoryFromSession);
                $location.url(previousLocationFromSession);
            } else {
                this.goToIcmLandingPage();
            }
        },

        goToIcmLandingPage: function goToIcmLandingPage() {
            $location.url('/influencers/contact');
        },

        goToList: function goToList() {
            $location.url('/influencers/contact?locker=' + PageStateService.getLockerId('contactListPage'));
        },

        goToAllContactsList: function goToAllContactsList() {
            $location.url('/influencers/contact-list');
        },

        goToContactAddLanding: function goToContactAddLanding() {
            $location.url('/influencers/contact/landing');
        },

        goToCreate: function goToCreate() {
            $location.url('/influencers/contact/create');
        },

        goToImport: function goToImport() {
            $location.url('/influencers/contact/import');
        },

        goToEdit: function goToEdit(contactId) {
            $location.url('/influencers/contact/edit/' + contactId);
        },

        goToProfileView: function goToProfileView(contactId) {
            $window.location.href = IRM_BASE_URL + '/contact/' + contactId;
        },

        goToSourceDetailView: function goToSourceDetailView(sourceId) {
            $location.url('/influencers/source/view/' + sourceId);
        },

        goToKeywordSearch: function goToKeywordSearch() {
            $location.url('/influencers/contact/keywordSearch');
        },

        goToSearch: function goToSearch() {
            window.location.href = MR_SEARCH_URL;
        },

        goToDirectorySearch: function goToDirectorySearch() {
            $location.url('/influencers/contact/search?locker=' + PageStateService.getLockerId('influencerDatabase'));
        },

        goToOutreach: function goToOutreach(mediaListIds) {
            if (mediaListIds) {
                $location.url('/outreach/compose?mediaListIds=' + mediaListIds);
            } else {
                $location.url('/outreach/compose');
            }
        },

        goToUpsellPage: function goToUpsellPage() {
            $location.url('/influencers/contact/influencerdatabase');
        },

        setPreviousLocation: function setPreviousLocation(location, prefixToStrip) {
            //Easy way to just grab the path instead of the full URL
            var el = document.createElement('a'),
                prefixRegEx = prefixToStrip ? new RegExp('^\/?' + prefixToStrip) : '';

            el.href = location;
            this.previousLocation = el.pathname.replace(prefixRegEx, '') + (el.search ? el.search : '');

            if (!this.clickedBackButton) {
                var locationHistory = this.getIcmLocationHistoryFromSession();
                if (Array.isArray(locationHistory)) {
                    locationHistory.push(this.previousLocation);
                    locationHistory = locationHistory.slice(-25);
                } else {
                    locationHistory = [this.previousLocation];
                }

                this.setIcmLocationHistoryInSession(locationHistory);
            } else {
                this.clickedBackButton = false;
            }
        },

        getPreviousLocation: function getPreviousLocation() {
            return this.previousLocation;
        },

        resetIcmLocationHistory: function resetIcmLocationHistory() {
            sessionStorage.removeItem('icmLocationHistory');
        },

        setIcmLocationHistoryInSession: function setIcmLocationHistoryInSession(locationHistory) {
            sessionStorage.setItem('icmLocationHistory', JSON.stringify(locationHistory));
        },

        getIcmLocationHistoryFromSession: function getIcmLocationHistoryFromSession() {
            return JSON.parse(sessionStorage.getItem('icmLocationHistory'));
        },

        redirectToFairhairWeb: function redirectToFairhairWeb(path) {
            $window.location.href = FAIRHAIR_WEB_URL + path;
        }
    };
}]);
'use strict';

angular.module('MW.ContactManager.OutreachListFactory', ['MW.Framework.CoreCompanyService', 'MW.ContactManager.OutreachService', 'MW.Framework.TextFilters', 'MW.Framework.TranslationService', 'MW.Framework.CoreUserService', 'MW.Framework.TimezoneService', 'MW.Framework.ICMUserService']).factory('OutreachListFactory', ['$q', '$filter', 'CoreCompanyService', 'OutreachService', 'translationService', 'CoreUserService', 'TimezoneService', 'moment', 'ICMUserService', function ($q, $filter, CoreCompanyService, OutreachService, translationService, CoreUserService, TimezoneService, moment, ICMUserService) {

    function OutreachListFactory() {
        this.OutreachService = OutreachService;
        this.$q = $q;
        this.$filter = $filter;
        this.outreachEmails = [];
        this.totalEmails = 0;
        this.translationService = translationService;
        this.CoreUserService = CoreUserService;
        this.TimezoneService = TimezoneService;
        this.moment = moment;
        this.ICMUserService = ICMUserService;
    }

    OutreachListFactory.prototype.getAllEmails = function getAllEmails(contactId, emailAddressArray, sortField, sortOrder, page, pageSize, filterByType, findText) {
        var defer = $q.defer(),
            searchCriteria = {};

        if (contactId) {
            searchCriteria.contactId = contactId;
        }

        if (emailAddressArray) {
            searchCriteria.emailAddresses = emailAddressArray;
        }

        if (sortField) {
            searchCriteria.sortField = sortField;
        }

        if (sortOrder) {
            searchCriteria.sortOrder = sortOrder;
        }

        if (page >= 0) {
            searchCriteria.page = page;
        }

        if (pageSize) {
            searchCriteria.pageSize = pageSize;
        }

        if (filterByType) {
            searchCriteria.filterByStatus = filterByType;
        }

        if (findText) {
            searchCriteria.findQ = findText;
        }

        this.OutreachService.getAllEmails(searchCriteria).then(function (response) {
            this.outreachEmails = []; // This is required to populate fresh data
            this.totalEmails = response.total || 0;
            this.populateEmailsList(response.hits); // Creating object for view all outreach emails
            defer.resolve({ hits: this.outreachEmails, total: this.totalEmails });
        }.bind(this), function (error) {
            defer.reject(error);
        }.bind(this));

        return defer.promise;
    };

    OutreachListFactory.prototype.populateEmailsList = function populateEmailsList(emailsList) {
        var statusObject = {
            'sent': this.translationService.getLocalizedString('Sent'),
            'sending': this.translationService.getLocalizedString('Sending'),
            'errors': this.translationService.getLocalizedString('Errors'),
            'draft': this.translationService.getLocalizedString('Draft'),
            'scheduled': this.translationService.getLocalizedString('Scheduled')
        },
            noSubject = this.translationService.getLocalizedString('No Subject'),
            noFrom = this.translationService.getLocalizedString('No Sender'),
            noRecipients = this.translationService.getLocalizedString('No Recipients'),
            notApplicable = this.translationService.getLocalizedString('N/A');

        if (emailsList && emailsList.length > 0) {
            for (var i = 0; i < emailsList.length; i++) {
                var listObject = emailsList[i],
                    emailsListObject = {
                    _id: listObject._id,
                    type: 'email',
                    companyId: listObject.companyId,
                    created: this.$filter('icmTranslateDate')(listObject.created, 'll'),
                    fromAddress: listObject.fromAddress,
                    scheduledDate: this.$filter('icmTranslateDate')(listObject.scheduledDate, 'll'),
                    scheduledTimeStamp: this.$filter('mwConvertDateToUserTimezone')(listObject.scheduledDate, 'mediumDate') + ' ' + this.$filter('mwConvertDateToUserTimezone')(listObject.scheduledDate, 'hh:mm a') + ' ' + this.ICMUserService.getTimezoneName(),
                    scheduledDateStamp: this.moment.utc(listObject.scheduledDate).format('X'),
                    subject: listObject.subject,
                    status: statusObject[listObject.status],
                    distributionStatus: listObject.status,
                    approvedSenderName: listObject.approvedSender ? listObject.approvedSender.name : notApplicable,
                    approvedSenderEmail: listObject.approvedSender ? listObject.approvedSender.email : notApplicable,
                    translatedKeys: {
                        noSubject: noSubject,
                        noFrom: noFrom,
                        noRecipients: noRecipients,
                        noDate: notApplicable
                    },
                    to: {
                        contactRecipients: listObject.recipientsData,
                        mediaListNames: listObject.mediaListNames
                    }
                };

                //delete scheduledTimeStamp form object if scheduledDate is undefined
                if (emailsListObject.scheduledDate === undefined || emailsListObject.scheduledDate === null) {
                    delete emailsListObject.scheduledTimeStamp;
                }

                this.outreachEmails.push(emailsListObject);
            }
        }
    };

    return OutreachListFactory;
}]);
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.OutreachService', ['Configuration']).service('OutreachService', ['$http', '$q', 'EMAIL_DOMAIN_URL', function ($http, $q, EMAIL_DOMAIN_URL) {
        var headerConfig = {
            headers: {
                'X-Client-Name': 'icm-web'
            }
        };

        this.getLastDayCount = function getLastDayCount(date, distributionId) {

            if (distributionId) {
                return $http.get(EMAIL_DOMAIN_URL + '/lastDayCount/' + date + '/' + distributionId, headerConfig).then(function (response) {
                    return response.data.count;
                });
            } else {
                return $http.get(EMAIL_DOMAIN_URL + '/lastDayCount/' + date, headerConfig).then(function (response) {
                    return response.data.count;
                });
            }
        };

        this.getEmailById = function getEmailById(emailId) {

            return $http.get(EMAIL_DOMAIN_URL + '/' + emailId, headerConfig).then(function (response) {
                return response.data[0];
            });
        };

        this.getOutreachStatsById = function getOutreachStatsById(distributionId) {

            return $http.get(EMAIL_DOMAIN_URL + '/stats/' + distributionId, headerConfig).then(function (response) {
                return response.data;
            });
        };

        this.outreach = function outreach(payload, fileArray) {
            var config = {
                headers: {
                    'X-Client-Name': 'icm-web',
                    'Content-Type': undefined
                }
            };

            var formData = new FormData(),
                defer = $q.defer();

            formData.append('model', angular.toJson(payload));

            if (fileArray && fileArray.length) {
                for (var i = 0; i < fileArray.length; i++) {
                    //add each file to the form data and iteratively name them
                    formData.append('file' + i, fileArray[i]);
                }
            }

            $http.post(EMAIL_DOMAIN_URL + '/send', formData, config).then(function (response) {
                defer.resolve(response.data);
            }).catch(function (response) {
                defer.reject(response.data);
            });

            return defer.promise;
        };

        this.getAllEmails = function getAllEmails(payload) {
            var defer = $q.defer();

            $http.post(EMAIL_DOMAIN_URL + '/v2/getAllEmails', payload, headerConfig).then(function (response) {
                defer.resolve(response.data);
            }).catch(function (response) {
                defer.reject(response.data);
            });

            return defer.promise;
        };

        this.deleteOutreachEmail = function deleteOutreachEmail(distributionIdArray) {
            var defer = $q.defer(),
                payload = {
                distributionIdArray: distributionIdArray
            };

            $http.post(EMAIL_DOMAIN_URL + '/deleteOutreachEmail', payload, headerConfig).then(function (response) {
                defer.resolve(response.data);
            }).catch(function (response) {
                defer.reject(response.data);
            });

            return defer.promise;
        };

        this.outreachUpdate = function outreachUpdate(payload, fileArray) {
            var formData = new FormData(),
                defer = $q.defer(),
                config = {
                headers: {
                    'X-Client-Name': 'icm-web',
                    'Content-Type': undefined
                }
            };

            formData.append('model', angular.toJson(payload));

            if (fileArray && fileArray.length) {
                for (var i = 0; i < fileArray.length; i++) {
                    //add each file to the form data and iteratively name them
                    formData.append('file' + i, fileArray[i]);
                }
            }

            $http.put(EMAIL_DOMAIN_URL + '/updateOutreachEmail', formData, config).then(function (response) {
                defer.resolve(response.data);
            }).catch(function (response) {
                defer.reject(response.data);
            });

            return defer.promise;
        };
    }]);
})();
'use strict';

angular.module('MW.ContactManager.ContactManagerPropertyTypeService', []).factory('emailTypes', ['FairhairAddressTypes', function (FairhairAddressTypes) {
    return {
        PERSONAL: FairhairAddressTypes.PERSONAL,
        WORK: FairhairAddressTypes.WORK,
        OTHER: FairhairAddressTypes.OTHER
    };
}]).factory('phoneNumberTypes', ['FairhairAddressTypes', function (FairhairAddressTypes) {
    return {
        MOBILE: FairhairAddressTypes.MOBILE,
        HOME: FairhairAddressTypes.HOME,
        WORK: FairhairAddressTypes.WORK,
        FAX: FairhairAddressTypes.FAX,
        OTHER: FairhairAddressTypes.OTHER
    };
}]).factory('addressTypes', ['FairhairAddressTypes', function (FairhairAddressTypes) {
    return {
        HOME: FairhairAddressTypes.HOME,
        WORK: FairhairAddressTypes.WORK,
        OTHER: FairhairAddressTypes.OTHER
    };
}]).value('salutationTypes', {
    MR: 'Mr',
    MS: 'Ms',
    HERR: 'Herr',
    FRAU: 'Frau',
    DR: 'Dr',
    PROF: 'Prof'
}).value('activeOnTypes', {
    TWITTER: 'Twitter',
    FACEBOOK: 'Facebook',
    LINKED_IN: 'LinkedIn',
    BLOG: 'Blog',
    SOURCE: 'Source'
}).value('activeOnUrls', {
    TWITTER: 'https://www.twitter.com/',
    FACEBOOK: 'https://www.facebook.com/'
}).value('activeOnUrlPartials', {
    LINKEDIN: 'linkedin.com'
}).constant('FairhairAddressTypes', {
    PERSONAL: 'personal',
    WORK: 'work',
    HOME: 'home',
    MOBILE: 'mobile',
    FAX: 'fax',
    OTHER: 'other'
}).constant('FairhairChannelTypes', {
    WEBSITE: 'website',
    SOURCE: 'source',
    SOCIAL: 'social'
}).constant('FairhairSocialProfileTypes', {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    LINKED_IN: 'linked_in',
    XING: 'xing'
}).constant('Meridiem', {
    AM: 'AM',
    PM: 'PM'
});
'use strict';

angular.module('MW.ContactManager.ContactManagerSourceService', ['Configuration', 'MW.ContactManager.ContactManagerContactModel']).service('ContactManagerSourceService', ['$http', 'CONTACT_MANAGER_SOURCE_URL', 'CONTACT_MANAGER_CONTACT_URL', '$q', 'Contact', function ($http, CONTACT_MANAGER_SOURCE_URL, CONTACT_MANAGER_CONTACT_URL, $q, Contact) {
    'use strict';

    this.searchSources = function searchSources(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_SOURCE_URL + '/search', query).then(function (response) {
            if (response.data.httpStatus && response.data.httpStatus !== 200) {
                defer.reject(response.data);
            } else {
                defer.resolve(response.data);
            }
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    this.getSourceById = function getSourceById(sourceId) {
        var defer = $q.defer();

        $http.get(CONTACT_MANAGER_SOURCE_URL + '/' + sourceId).then(function (response) {
            defer.resolve(response.data);
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    this.getSourcesByIds = function getSourcesByIds(sourceIds) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_SOURCE_URL + '/search/ids', sourceIds).then(function (response) {
            defer.resolve(response.data.hits);
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    this.getContactBasedOnSource = function getContactBasedOnSource(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/sources', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                });
            }

            defer.resolve(response.data);
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };
}]);
'use strict';

angular.module('MW.CoreStream.ContactManagerTagService', ['MW.Influencers.IcmDialogService', 'MW.Framework.TranslationService', 'MW.Influencers.AnalyticsService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.ContactManager.ContactManagerContactModel']).service('ContactManagerTagService', ['$http', '$q', 'CONTACT_MANAGER_MEDIA_LIST_URL', 'ICM_CSS_MEDIA_LIST_URL', 'CONTACT_MANAGER_CONTACT_URL', 'DialogService', 'translationService', '$translate', 'AnalyticsService', 'CoreUserService', 'CoreCompanyService', 'Contact', function ($http, $q, CONTACT_MANAGER_MEDIA_LIST_URL, ICM_CSS_MEDIA_LIST_URL, CONTACT_MANAGER_CONTACT_URL, DialogService, translationService, $translate, AnalyticsService, CoreUserService, CoreCompanyService, Contact) {
    'use strict';

    this.isSaving = false;
    this.isFetching = false;
    this.selectedContactIdForTags = [];
    this.DialogService = DialogService;
    this.translationService = translationService;
    this.$translate = $translate;
    this.Contact = Contact;
    this.selectdLists = [];
    this.mediaListArray = [];
    this.commonMediaList = [];
    this.$q = $q;
    this.AnalyticsService = AnalyticsService;
    this.CoreUserService = CoreUserService;
    this.CoreCompanyService = CoreCompanyService;

    this.updateMediaList = function updateMediaList(mediaListId, mediaListName, mediaListDescription) {
        var payload,
            url = CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId;

        return this.CoreUserService.getCurrent(true).then(function (current) {
            payload = {
                mediaListName: mediaListName,
                mediaListDescription: mediaListDescription,
                lastUpdatedByUserId: current._id,
                lastUpdatedByFirstName: current.firstName,
                lastUpdatedByLastName: current.lastName
            };

            return $http.put(url, payload);
        });
    };

    this.saveMediaList = function saveMediaList(tagName) {
        var _this = this;

        this.isSaving = true;

        return this.CoreUserService.getCurrent(true).then(function (current) {
            var payload = {
                mediaListName: tagName,
                createdById: current._id,
                createdByFirstName: current.firstName,
                createdByLastName: current.lastName
            };
            return new Promise(function (resolve, reject) {
                return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL, payload).then(function (response) {
                    resolve(response.data);
                }).catch(function (err) {
                    reject(err.data);
                }).finally(function () {
                    _this.isSaving = false;
                });
            });
        });
    };

    this.getAllTags = function getAllTags(page, size, sort, q) {
        var _this2 = this;

        this.isFetching = true;
        var query = {
            sort: sort,
            page: page,
            size: size
        };

        if (q && q.length > 0) {
            query.q = q;
        }

        return new Promise(function (resolve, reject) {
            return $http.get(CONTACT_MANAGER_MEDIA_LIST_URL, { params: query }).then(function (response) {
                resolve(response.data);
            }).catch(function (err) {
                reject(err.data);
            }).finally(function () {
                _this2.isFetching = false;
            });
        });
    };

    this.getMediaListById = function getMediaListById(mediaListId) {
        var _this3 = this;

        this.isFetching = true;

        return new Promise(function (resolve, reject) {
            $http.get(CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId).then(function (response) {
                resolve(response.data);
            }).catch(function (err) {
                reject(err.data);
            }).finally(function () {
                _this3.isFetching = false;
            });
        });
    };

    this.saveTagWithContact = function saveTagWithContact(mediaListIds, contactIds) {
        var _this4 = this;

        this.isSaving = true;
        var payload;

        return this.CoreUserService.getCurrent(true).then(function (current) {
            payload = {
                contactIds: contactIds,
                mediaListIds: mediaListIds,
                lastUpdatedByUserId: current._id,
                lastUpdatedByFirstName: current.firstName,
                lastUpdatedByLastName: current.lastName
            };

            return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/addBulkContacts', payload).finally(function afterAll() {
                this.isSaving = false;
            }.bind(_this4));
        });
    };

    this.addToMediaListModal = function addToMediaListModal(query, selectedContactIds) {
        var manageListDialog = document.querySelector('icm-manage-lists-dialog');

        if (query) {
            manageListDialog.openLoading();

            $http(query).then(function (response) {
                manageListDialog.open(response.data);
            }).catch(function (err) {
                manageListDialog.showLoadingErrorState();
                reject(err.data); // jshint ignore:line
            });
        } else {
            manageListDialog.open(selectedContactIds);
        }
    };

    this.addToListDialog = function addToListDialog(selectedContacts, callback, criteria, queryType, totalContactsCount) {

        var dialogTitle = this.$translate.instant('icm-medialist__add-to-medialist--dialog-header'),
            dialogTemplate = 'icm-gaf-legacy/views/contact_manager/partials/contact_tag_selector',
            dialogCss = 'mainTagsListDialog',
            _callback = typeof callback === 'function' ? callback : function () {},
            payload = {
            selectedContacts: selectedContacts,
            totalContactsCount: totalContactsCount,
            listDialogCallback: callback,
            criteria: criteria || null,
            queryType: queryType
        };

        this.DialogService.dialog(dialogTitle, dialogTemplate, payload, _callback, undefined, undefined, undefined, dialogCss);
    };

    this.bulkRemoveContactsFromTags = function bulkRemoveContactsFromTags(mediaListIds, contactIds) {
        var _this5 = this;

        this.isSaving = true;

        return this.CoreUserService.getCurrent(true).then(function (current) {
            var payload = {
                mediaListIds: mediaListIds,
                contactIds: contactIds,
                lastUpdatedByUserId: current._id,
                lastUpdatedByFirstName: current.firstName,
                lastUpdatedByLastName: current.lastName
            };

            return new Promise(function (resolve, reject) {
                return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/removeContacts', payload).then(function () {
                    resolve();
                }).catch(function (error) {
                    reject(error.data);
                }).finally(function () {
                    _this5.isSaving = false;
                });
            });
        });
    };

    this.removeContactsFromTags = function removeContactsFromTags(contactIds) {
        this.isSaving = true;
        var defer = $q.defer();
        if (contactIds.length > 0) {
            this._trackEvent(contactIds);
            $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/removeBulkContacts', contactIds).then(function (response) {
                defer.resolve(response.data);
            }).catch(function (err) {
                defer.reject(err.data);
            }).finally(function () {
                this.isSaving = false;
            }.bind(this));
        } else {
            this.isSaving = false;
            defer.resolve();
        }

        return defer.promise;
    };

    this.removeMediaList = function removeMediaList(mediaListId) {
        var defer = $q.defer();

        if (!mediaListId) {
            defer.reject({ message: 'Invalid Medialist' });
            return defer.promise;
        }

        $http.delete(CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId).then(function () {
            defer.resolve({ message: 'Success' });
        }).catch(function () {
            defer.reject({ message: 'Error removing medialist' });
        });

        return defer.promise;
    };

    this.getMediaListEmails = function getMediaListEmails(mediaListId, pageSize) {
        this.isFetching = true;
        var defer = $q.defer(),
            payload = {
            mediaListIds: [mediaListId],
            pageSize: pageSize
        };

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', payload).then(function (response) {
            defer.resolve(response.data);
        }).catch(function (err) {
            defer.reject(err.data);
        }).finally(function afterAll() {
            this.isFetching = false;
        }.bind(this));

        return defer.promise;
    };

    this.setSelectedMedialist = function setSelectedMedialist(selectdListObj) {
        this.selectdLists = selectdListObj;
    };

    this.getSelectedMedialist = function getSelectedMedialist() {
        return this.selectdLists;
    };

    this.set = function set(tagsArr, commonMediaList) {
        this.mediaListArray = tagsArr;
        this.commonMediaList = commonMediaList;
    };

    this.getTagsArr = function getTagsArr() {
        return this.mediaListArray;
    };

    this.getCommonMediaList = function getCommonMediaList() {
        return this.commonMediaList;
    };

    this.updateContactMediaLists = function updateContactMediaLists(contactArray, contactIds, selectedMediaLists, listsToRemove, selectedMediaListSnippets) {
        contactArray.forEach(function mapContacts(contact) {
            if (contactIds.indexOf(contact.id) !== -1) {
                if (selectedMediaListSnippets && selectedMediaListSnippets.length > 0) {
                    selectedMediaListSnippets.forEach(function (mediaListSnippet) {
                        var duplicateList = false;
                        contact.mediaLists.some(function (mediaList) {
                            if (mediaList.key === mediaListSnippet.key) {
                                duplicateList = true;
                                return true;
                            }
                        });

                        if (!duplicateList) {
                            contact.mediaLists.push(mediaListSnippet);
                        }
                    });
                } else {
                    selectedMediaLists.forEach(function (listId) {
                        if (contact.mediaLists.indexOf(listId) === -1) {
                            contact.mediaLists.push(listId);
                        }
                    });
                }

                // TODO: This block needs to be cleaned up when all selectAll media list stories are done since listsToRemove should be removed.
                if (listsToRemove && Array.isArray(listsToRemove)) {
                    listsToRemove.forEach(function (listId) {
                        var index = contact.mediaLists.indexOf(listId);

                        if (index !== -1) {
                            contact.mediaLists.splice(index, 1);
                        }
                    });
                }
            }
        });
    };

    this.updateContactMediaListsWithQuery = function updateContactMediaListsWithQuery(documentQuery, selectedMediaLists, queryType) {
        var _this6 = this;

        this.isSaving = true;

        return this.CoreUserService.getCurrent(true).then(function (current) {
            var payload = {
                query: documentQuery,
                mediaLists: selectedMediaLists,
                lastUpdatedByUserId: current._id,
                lastUpdatedByFirstName: current.firstName,
                lastUpdatedByLastName: current.lastName
            };
            if (queryType === 'searchContact' || queryType === 'searchRelevantContact') {
                return $http.post(ICM_CSS_MEDIA_LIST_URL + '/addByQuery/' + queryType, payload).finally(function () {
                    _this6.isSaving = false;
                });
            } else {
                return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/addByQuery/' + queryType, payload).finally(function () {
                    _this6.isSaving = false;
                });
            }
        });
    };

    this.updatePreselectedContactsMediaLists = function updatePreselectedContactsMediaLists(preSelectedContacts, selectedMediaListIds) {
        var contactIdArray = Object.keys(preSelectedContacts),
            defer = $q.defer();

        for (var i = 0; i < contactIdArray.length; i++) {
            preSelectedContacts[contactIdArray[i]].mediaLists = [];
            for (var j = 0; j < selectedMediaListIds.length; j++) {
                if (preSelectedContacts[contactIdArray[i]].mediaLists.indexOf(selectedMediaListIds[j]) === -1) {
                    preSelectedContacts[contactIdArray[i]].mediaLists.push(selectedMediaListIds[j]);
                }
            }
        }
        defer.resolve(preSelectedContacts);
        return defer.promise;
    };

    this.getAllContacts = function getAllContacts(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/getAllContacts', query).then(function (response) {
            if (response.data && response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit, response.data.sources);
                }.bind(this));

                defer.resolve(response.data);
            } else {
                defer.resolve({ data: { hits: [] } });
            }
        }).catch(function (err) {
            defer.reject(err.data);
        });

        return defer.promise;
    };

    this.getContactsByMediaListIds = function getContactsByMediaListIds(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/getContactsByMediaListIds', query).then(function (response) {
            if (response.data && response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit, response.data.sources);
                }.bind(this));

                defer.resolve(response.data);
            } else {
                defer.resolve({ data: { hits: [] } });
            }
        }).catch(function (err) {
            defer.reject(err.data);
        });

        return defer.promise;
    };

    this.getAllMediaListsForContactId = function getAllMediaListsForContactId(contactId) {
        var defer = $q.defer();
        $http.get(CONTACT_MANAGER_CONTACT_URL + '/medialists/' + contactId).then(function (data) {
            if (!angular.isArray(data.data)) {
                data.data = [];
            }
            defer.resolve(data.data);
        }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    this.addToComposeMediaListsDialog = function addToComposeMediaListsDialog(allMediaLists, preSelectedMediaLists, recipientsLabel, callback) {
        var dialogTitle = this.translationService.getLocalizedString('Recipients'),
            dialogTemplate = 'icm-web/views/partials/compose_medialists_selector',
            dialogCss = 'composeMedialistDialog',
            _callback = typeof callback === 'function' ? callback : function () {},
            payload = {
            wrapperTemplate: 'icm-gaf-legacy/views/partials/dialog_manager_content_scroll',
            allMediaLists: allMediaLists,
            preSelectedMediaLists: preSelectedMediaLists,
            recipientsLabel: recipientsLabel,
            listDialogCallback: callback
        };
        this.DialogService.dialog(dialogTitle, dialogTemplate, payload, _callback, undefined, undefined, undefined, dialogCss);
    };

    this._trackEvent = function _trackEvent(tagsArr) {
        var promises = [],
            currentUser,
            currentCompany,
            currentMediaListId = '',
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'remove_contact',
                contactCount: tagsArr.length,
                parentType: 'ICM_contacts_list',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            tagsArr.forEach(function (list) {
                if (list.mediaListId !== currentMediaListId) {
                    trackingData.mediaListId = list.mediaListId;
                    this.AnalyticsService.trackMediaListOperation('remove_contact', trackingData);
                    currentMediaListId = list.mediaListId;
                }
            }.bind(this));
        }.bind(this));
    };
}]);
'use strict';

angular.module('MW.ContactManager.TransformOutreachStatsChart', ['DashboardChartConfigService', 'CoreColorService']).service('TransformOutreachStatsChartService', ['DashboardChartConfigService', 'CoreColorService', '$translate', 'RECIPIENT_TRACKING_CHECKS', function (DashboardChartConfigService, CoreColorService, $translate, RECIPIENT_TRACKING_CHECKS) {
    var serviceObj = {};

    serviceObj.readyChartUnsubscribeData = function readyChartUnsubscribeData(data, drilldownFunction) {
        var chartData;

        chartData = {
            chart: {
                height: 314
            },
            plotOptions: {
                pie: {
                    center: ['50%', '50%'],
                    animation: true,
                    dataLabels: {
                        distance: 5
                    }
                },
                series: {
                    point: {
                        events: {
                            click: function click() {
                                drilldownFunction(this);
                            }
                        }
                    }
                }
            },
            series: [{
                data: data,
                innerSize: '47%',
                size: '86%',
                type: 'pie',
                dataLabels: {
                    formatter: function formatter() {
                        var dataLabel;
                        if (this.point.name.length >= 23) {
                            dataLabel = this.point.name.substr(0, 23) + '...';
                        }
                        return dataLabel || this.point.name;
                    }
                }
            }],
            tooltip: {
                hideDelay: 0
            }
        };

        return chartData;
    };

    serviceObj.readyChartCTORData = function readyChartCTORData(data, drilldownFunction) {
        var chartData;

        chartData = {
            chart: {
                height: 314
            },
            xAxis: {
                labels: {
                    useHTML: true,
                    align: 'left',
                    x: 6,
                    y: 5,
                    style: {
                        color: CoreColorService.colors.grey80,
                        whiteSpace: 'nowrap'
                    },
                    formatter: function formatter() {
                        var chartWidth = this.chart.clipBox.height,
                            ourWidth = 0.75 * chartWidth,
                            value;

                        value = DashboardChartConfigService.getTruncatedText(this.value, ourWidth, this.chart.userOptions.xAxis.labels.style);
                        return '<div style="font-size: 11px; text-align: left; min-width: 300px;">' + value + '</div>';
                    }
                }
            },
            yAxis: {
                gridLineWidth: 1,
                title: {
                    text: ''
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    },
                    pointWidth: 28
                },
                series: {
                    point: {
                        events: {
                            click: function click() {
                                drilldownFunction(this);
                            }
                        }
                    }
                }
            }
        };

        return chartData;
    };

    serviceObj.readyChartOpenRateStatsData = function readyChartOpenRateStatsData(data, tooltipFunction, drilldownFunction) {
        var chartData;

        tooltipFunction = tooltipFunction || function () {};
        drilldownFunction = drilldownFunction || function () {};

        if (RECIPIENT_TRACKING_CHECKS === true) {
            chartData = {
                chart: {
                    height: 304
                },
                yAxis: {
                    min: 0
                },
                xAxis: {
                    categories: [$translate.instant('Bounced'), $translate.instant('icm-outreach-stats__open-rate--unopened'), $translate.instant('icm-outreach-stats__open-rate--opened'), $translate.instant('icm-outreach-stats__open-rate--untracked')]
                },
                plotOptions: {
                    series: {
                        colorByPoint: true,
                        dataLabels: {
                            enabled: true,
                            formatter: function formatter() {
                                return this.y;
                            }
                        },
                        point: {
                            events: {
                                click: function click() {
                                    drilldownFunction(this);
                                }
                            }
                        }
                    },
                    column: {
                        colors: ['#3399ff', '#3399ff', '#3399ff', '#d1cece']
                    }
                },
                tooltip: {
                    formatter: function formatter() {
                        return tooltipFunction(this.point);
                    },
                    hideDelay: 0
                },
                series: [{
                    data: [{ y: data.bounces, type: 'bounces' }, { y: data.unopened, type: 'unopened' }, { y: data.opened, type: 'opened' }, { y: data.untracked, type: 'untracked' }]
                }]
            };
        } else {
            chartData = {
                chart: {
                    height: 304
                },
                yAxis: {
                    min: 0
                },
                xAxis: {
                    categories: [$translate.instant('Bounced'), $translate.instant('icm-outreach-stats__open-rate--unopened'), $translate.instant('icm-outreach-stats__open-rate--opened')]
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            formatter: function formatter() {
                                return this.y;
                            }
                        },
                        point: {
                            events: {
                                click: function click() {
                                    drilldownFunction(this);
                                }
                            }
                        }
                    }
                },
                tooltip: {
                    formatter: function formatter() {
                        return tooltipFunction(this.point);
                    },
                    hideDelay: 0
                },
                series: [{
                    data: [{ y: data.bounces, type: 'bounce' }, { y: data.unopened, type: 'unopened' }, { y: data.opened, type: 'opened' }]
                }]
            };
        }

        return chartData;
    };

    return serviceObj;
}]);
'use strict';

angular.module('MW.CustomValidation.ContactManagerUsernameService', []).service('ContactManagerUsernameService', [function () {
    'use strict';

    /**
     * This regular expression will validate any URL matching ://(or www.)facebook.com/(username)
     * The output array should have at least 4 results, if it's less than that it is invalid.
     */

    var FACEBOOK_URL_REGEX = /(:\/\/facebook\.com\/|www\.facebook\.com\/|facebook\.com\/)(profile\.php\?id\=([0-9]*)|[A-Za-z0-9\.]*)/,
        FACEBOOK_USER_NAME_REGEX = /([A-Za-z0-9\.]{5,})/,
        FACEBOOK_PROFILE_ID_REGEX = /[0-9]*/,
        TWITTER_URL_REGEX = /(:\/\/twitter\.com\/|www\.twitter\.com\/|twitter\.com\/)([A-Za-z0-9_]*)/,
        TWITTER_USER_NAME_REGEX = /@?[a-zA-Z0-9_]{1,15}/;

    this.isValidUrl = function isValidUrl(url) {
        var regExMatches,
            URL_REGEX = /((https?):\/\/|(mailto:)[A-Za-z0-9._%+-]+@|www\.([^\s.;,(){}<>"]+\.)+|([^\s.;,(){}<>"]+\.)+[^\s.;,(){}<>"0-9]+\/)[A-Za-z-._~:\/?#\[\]@!$&'()*+,;=<>]*[^\s.;,(){}<>"]*/i,
            filteredRegExList;

        regExMatches = url.match(URL_REGEX);

        filteredRegExList = this.searchRegExResults(url, regExMatches);
        return filteredRegExList.length > 0;
    };

    this.searchRegExResults = function searchRegExResults(needle, haystack) {
        var resultList;
        if (haystack === null) {
            return false;
        } else if (haystack.length > 0) {
            resultList = haystack.filter(function (value) {
                return value === needle;
            });
        }
        return resultList;
    };
    this.twitterValidation = function twitterValidation(input) {
        if (this.isValidUrl(input)) {
            return matchTwitterUrl(input);
        } else {
            return validateTwitterUsername(input);
        }
    };

    function matchTwitterUrl(input) {
        try {
            var matches = input.match(TWITTER_URL_REGEX);

            return validateTwitterUsername(matches[2]);
        } catch (e) {
            return false;
        }
    }

    function validateTwitterUsername(input) {
        var regExResult = input.match(TWITTER_USER_NAME_REGEX);
        return !!regExResult && regExResult[0].length === input.length;
    }

    this.facebookValidation = function facebookValidation(input) {
        if (this.isValidUrl(input)) {
            return matchFacebookUrl(input);
        } else {
            return validateFacebookUsername(input) || validateFacebookProfileID(input);
        }
    };

    function matchFacebookUrl(input) {
        try {
            var matches = input.match(FACEBOOK_URL_REGEX);
            if (matches[3]) {
                return validateFacebookProfileID(matches[3]);
            } else if (matches[2]) {
                return validateFacebookUsername(matches[2]);
            } else {
                throw 'Invalid input';
            }
        } catch (e) {
            //default to false
            return false;
        }
    }

    function validateFacebookProfileID(input) {
        var m = input.match(FACEBOOK_PROFILE_ID_REGEX);
        return !!m && m[0].length === input.length;
    }

    function validateFacebookUsername(input) {
        var m = input.match(FACEBOOK_USER_NAME_REGEX);
        return !!m && m[1].length === input.length;
    }

    this.getTwitterUsername = function getTwitterUsername(input) {
        var valid = this.twitterValidation(input),
            m;

        if (!valid) {
            return null;
        }

        if (this.isValidUrl(input)) {
            m = input.match(TWITTER_URL_REGEX);
            return m[2];
        } else {
            return input.match(TWITTER_USER_NAME_REGEX)[0];
        }
    };

    this.getFacebookUsername = function getFacebookUsername(input) {
        var valid = this.facebookValidation(input),
            m;

        if (!valid) {
            return null;
        }

        if (this.isValidUrl(input)) {
            m = input.match(FACEBOOK_URL_REGEX);
            return m[3] || m[2];
        } else {
            return input.match(FACEBOOK_USER_NAME_REGEX) ? input.match(FACEBOOK_USER_NAME_REGEX)[1] : input.match(FACEBOOK_PROFILE_ID_REGEX)[0];
        }
    };
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    angular.module('MW.ContactManager.CustomBannerService', []).service('mwCustomBannerService', ['$translate', 'mwBannerService', function ($translate, mwBannerService) {
        var alertBannerRetry = $translate.instant('icm-outreach__template--alert-banner-retry');
        var openBanners = [];

        this.alertWithRetry = function alertWithRetry(alertBannerText, retryCallback, callbackArgs, callbackThis, attachTo, onModal, allowMulti) {
            var bannerConfig = {
                template: '\n                            <mw-banner type="\'alert\'" on-close="$ctrl.close($event)">\n                                {{$ctrl.alertBannerText}}\n                                <mw-banner-actions>\n                                    <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.retry()">{{$ctrl.alertBannerRetry}}</md-button>\n                                </mw-banner-actions>\n                            </mw-banner>\n                        ',
                controller: function () {
                    BannerPanel.$inject = ["mdPanelRef"];
                    function BannerPanel(mdPanelRef) {
                        'ngInject';

                        _classCallCheck(this, BannerPanel);

                        this.mdPanelRef = mdPanelRef;
                        this.alertBannerText = alertBannerText;
                        this.alertBannerRetry = alertBannerRetry;
                        this.onModal = onModal;
                    }

                    _createClass(BannerPanel, [{
                        key: 'retry',
                        value: function retry() {
                            this.mdPanelRef.close();

                            retryCallback.apply(callbackThis, callbackArgs);
                        }
                    }, {
                        key: 'close',
                        value: function close() {
                            this.mdPanelRef.close();
                        }
                    }]);

                    return BannerPanel;
                }()
            };

            if (attachTo) {
                bannerConfig.attachTo = attachTo;
            }

            if (!allowMulti) {
                openBanners.forEach(function (banner) {
                    banner.close();
                });

                openBanners = [];
            }

            mwBannerService.open(bannerConfig).then(function (banner) {
                openBanners.push(banner);
            });
        };
    }]);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    angular.module('MW.ContactManager.CustomToastService', []).service('mwCustomToastService', [function () {
        this.simpleTimedClosable = function simpleTimedClosable(textContent) {
            return {
                template: '\n                            <md-toast class="custom-simple-timed-closable-toast">\n                                <div class="md-toast-content">\n                                    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">\n                                        {{ $ctrl.saveToastMessage }}\n                                    </span>\n                                    <mw-icon-button ng-click="$ctrl.$mdToast.hide()" svg-icon="navigation:ic_close_24px" hover="false" aria-label="close"></mw-icon-button>\n                                </div>\n                            </md-toast>\n                        ',
                hideDelay: 4000,
                bindToController: true,
                controllerAs: '$ctrl',
                controller: ["$mdToast", function ToastController($mdToast) {
                    'ngInject';

                    _classCallCheck(this, ToastController);

                    this.$mdToast = $mdToast;
                    this.saveToastMessage = textContent;
                }]
            };
        };
    }]);
})();
'use strict';

angular.module('MW.Framework.ICMEntitlementService', ['MW.Influencers.IcmDialogService', 'MW.Framework.TranslationService', 'MW.Framework.ErrorMessageService', 'Configuration', 'MW.Framework.LimitEntitlement', 'MW.Framework.ToggleEntitlement', 'MW.Influencers.AnalyticsService', 'MW.Framework.CoreCompanyService']).service('ICMEntitlementService', ['$http', '$log', '$q', 'DialogService', 'translationService', '$window', '$injector', 'LimitEntitlement', 'ToggleEntitlement', 'ErrorMessageService', 'AnalyticsService', 'ENTITLEMENT_MGR_URL', 'ENTITLEMENTS_SERVICE_URI_V6', 'MAX_EXPORT_LIMIT', 'DEFAULT_EXPORT_LIMIT', function ($http, $log, $q, DialogService, translationService, $window, $injector, LimitEntitlement, ToggleEntitlement, ErrorMessageService, AnalyticsService, ENTITLEMENT_MGR_URL, ENTITLEMENTS_SERVICE_URI_V6, MAX_EXPORT_LIMIT, DEFAULT_EXPORT_LIMIT) {
    var entitlements = {},
        toggleType = 'toggle',
        limitType = 'limit',
        icmRecipientsPerDay,
        icmRecipientsPerDistribution,
        icmContactExportLimit,
        influencerApp,
        icmCountries,


    // methods
    registerEntitlement,
        getEntitlements,
        showEntitlementError,
        showUpgradeMessage,
        setDefaultOptions;

    //
    // Internal
    //
    showEntitlementError = function showEntitlementError(err) {
        var error = ErrorMessageService.getErrorMessage('errorProcessingByFairhair');
        $log.error('Error with entitlement service: ' + err);
        DialogService.flashError(translationService.getLocalizedString(error.message), error.timeout);
    };

    showUpgradeMessage = function showUpgradeMessage(entitlementId) {
        var scope,
            payload,
            entitlement = entitlements[entitlementId];

        scope = entitlement.upgradeMessageScope;
        scope.name = translationService.getLocalizedString(entitlement.name);

        payload = {
            content: translationService.getLocalizedString(entitlement.upgradeMessage, scope),
            okText: 'OK',
            cancelText: 'Upgrade Now'
        };

        //This dialog is slightly different in behavior of hiding and success value
        //success will be false for confirm, true for reject, and false when the user clicks outside of the dialog
        DialogService.dialog({
            title: translationService.getLocalizedString('Alert'),
            template: 'icm-gaf-legacy/views/partials/dialog_confirm',
            payload: payload,
            callback: function callback(result) {
                if (!result.success) {
                    $window.open('/settings/account', '_blank');
                }
            },
            callbackOnCancel: true,
            closeOnBackgroundClick: false
        });
    };

    /**
     * Registers a new entitlement.
     *
     * @param name
     * @param options
     */
    registerEntitlement = function registerEntitlement(type, id, name, options) {
        if (id in entitlements) {
            $log.error('Cannot register the "' + id + '" entitlement twice');
            return;
        }

        options = options || {};
        setDefaultOptions(options);

        if (type === limitType) {
            entitlements[id] = new LimitEntitlement(id, name, options);
        } else if (type === toggleType) {
            entitlements[id] = new ToggleEntitlement(id, name, options);
        }

        return entitlements[id];
    };

    /**
     * Sets default options for a new entitlement.  Mainly just sets up callbacks
     * for entitlement violation actions
     *
     * @param options
     * @returns {{TOGGLE_TYPE: string, LIMIT_TYPE: string, getEntitlement: getEntitlement, getEntitlements: getEntitlements, registerEntitlement: registerEntitlement}}
     */
    setDefaultOptions = function setDefaultOptions(options) {
        if (!options.onViolated) {
            options.onViolated = function onViolatedCallback(callbackOptions) {
                callbackOptions = angular.extend(angular.copy(this.options), callbackOptions || {});
                if (!callbackOptions.suppressUpgradeMessage) {
                    showUpgradeMessage(this.id);
                }
            };
        }

        if (!options.onError) {
            options.onError = function onErrorCallback() {
                showEntitlementError();
            };
        }
    };

    /**
     * Retrieves the list of all registered entitlements.  
     *
     * @returns {{}}
     */
    getEntitlements = function getEntitlements() {
        var CoreCompanyService = $injector.get('CoreCompanyService');
        return CoreCompanyService.getCurrent(true).then(function afterCompany(company) {
            return $http({ url: ENTITLEMENTS_SERVICE_URI_V6 + '/company/' + company._id + '/entitlements/all', headers: { 'x-client-name': 'icm-web' } });
        }).then(function afterEntitlement(response) {
            var entitlementList = {},
                entitlements = {};
            if (response.data) {
                angular.forEach(response.data, function (data, key) {
                    if (response.data[key]) {
                        entitlements[key] = data.value;
                    }
                    entitlementList[key] = entitlements[key];
                });
            }
            return entitlementList;
        });
    };

    function fetchV6Entitlement(entitlementMatch) {
        return $q(function (resolve, reject) {
            var CoreCompanyService = $injector.get('CoreCompanyService');

            return CoreCompanyService.getCurrent(true).then(function afterCompany(company) {
                return $http({ url: ENTITLEMENTS_SERVICE_URI_V6 + '/company/' + company._id + '/' + entitlementMatch, headers: { 'x-client-name': 'icm-web' } });
            }).then(function afterEntitlement(response) {
                resolve(response.data);
            }).catch(function onError(error) {
                if (error.data) {
                    reject(error.data);
                } else {
                    reject(error);
                }
            });
        });
    }

    function getInfluencerAppEntitlement() {
        return $q(function (resolve, reject) {
            if (!influencerApp) {
                return fetchV6Entitlement('influencerApp').then(function afterFetchEntitlement(entitlement) {
                    influencerApp = entitlement && entitlement.influencerApp && entitlement.influencerApp.value ? entitlement.influencerApp.value : false;
                    resolve(influencerApp);
                }).catch(function onError(error) {
                    reject(error);
                });
            }
            resolve(influencerApp);
        });
    }

    /**
     * Responsible for getting list of Influencer Database entitled countries for a company
     * @returns {Promise|*|!webdriver.promise.Promise}
     */
    function getIcmCountriesEntitlement() {
        return $q(function (resolve, reject) {
            if (!icmCountries) {
                return fetchV6Entitlement('icm-').then(function afterFetchEntitlement(list) {
                    icmCountries = list;
                    resolve(icmCountries);
                }).catch(function onError(error) {
                    reject(error);
                });
            }
            resolve(icmCountries);
        });
    }

    function getIcmContactExportLimit() {
        return $q(function (resolve) {
            if (!icmContactExportLimit) {
                return fetchV6Entitlement('icmContactExportLimit').then(function afterFetchEntitlement(entitlement) {
                    if (entitlement.icmContactExportLimit && entitlement.icmContactExportLimit.value > MAX_EXPORT_LIMIT) {
                        icmContactExportLimit = MAX_EXPORT_LIMIT;
                    } else if (entitlement.icmContactExportLimit && entitlement.icmContactExportLimit.value < DEFAULT_EXPORT_LIMIT) {
                        icmContactExportLimit = DEFAULT_EXPORT_LIMIT;
                    } else {
                        icmContactExportLimit = entitlement.icmContactExportLimit.value;
                    }
                    resolve(icmContactExportLimit);
                }).catch(function onError() {
                    resolve(DEFAULT_EXPORT_LIMIT);
                });
            }
            resolve(icmContactExportLimit);
        });
    }

    /**
     * Responsible for getting the limit of a single distributions recipients
     * @returns {Promise|*|!webdriver.promise.Promise}
     */
    function getIcmRecipientsPerDistribution(defaultValue) {
        return $q(function (resolve, reject) {
            if (!icmRecipientsPerDistribution) {
                return fetchV6Entitlement('icmRecipientsPerDistribution').then(function afterFetchEntitlement(entitlement) {
                    icmRecipientsPerDistribution = entitlement && entitlement.icmRecipientsPerDistribution && entitlement.icmRecipientsPerDistribution.value ? entitlement.icmRecipientsPerDistribution.value : defaultValue;
                    resolve(icmRecipientsPerDistribution);
                }).catch(function onError(error) {
                    reject(error);
                });
            }
            resolve(icmRecipientsPerDistribution);
        });
    }

    function getIcmRecipientsPerDayLimit(defaultValue) {
        return $q(function (resolve, reject) {
            if (!icmRecipientsPerDay) {
                return fetchV6Entitlement('icmRecipientsPerDay').then(function afterFetchEntitlement(entitlement) {
                    icmRecipientsPerDay = entitlement && entitlement.icmRecipientsPerDay && entitlement.icmRecipientsPerDay.value ? entitlement.icmRecipientsPerDay.value : defaultValue;
                    resolve(icmRecipientsPerDay);
                }).catch(function onError(error) {
                    reject(error);
                });
            }
            resolve(icmRecipientsPerDay);
        });
    }

    return {
        TOGGLE_TYPE: toggleType,
        LIMIT_TYPE: limitType,
        getEntitlements: getEntitlements,
        registerEntitlement: registerEntitlement,
        getIcmCountriesEntitlement: getIcmCountriesEntitlement,
        getIcmRecipientsPerDayLimit: getIcmRecipientsPerDayLimit,
        getIcmRecipientsPerDistribution: getIcmRecipientsPerDistribution,
        getInfluencerAppEntitlement: getInfluencerAppEntitlement,
        getIcmContactExportLimit: getIcmContactExportLimit
    };
}]);
'use strict';

angular.module('MW.Framework.InfluencerContactService', ['Configuration', 'MW.Configuration', 'MW.ContactManager.ContactManagerPropertyTypeService', 'MW.ContactManager.ContactManagerContactModel', 'MW.ContactManager.ContactManagerSourceService', 'MW.CustomValidation.ContactManagerUsernameService', 'MW.Framework.DateRangeHelper', 'MW.Framework.CoreUserService', 'MW.Framework.ICMUserService', 'MW.ContactManager.ContactDomainModelConverter']).service('InfluencerContactService', ['$http', 'CONTACT_MANAGER_CONTACT_URL', 'ICM_CSS_URL', 'ICM_CONTACT_SERVICE_URL', 'ICM_CONTACTS_URL', 'ICM_DOCUMENT_SERVICE_URL', 'CONTACT_MANAGER_EXPORT_URL', 'CONTACT_MANAGER_DOCUMENTS_URL', 'CONTACT_MANAGER_NOTES_URL', 'INFLUENCERS_URL', 'ICM_SOURCE_SERVICE_URL', 'ICM_CONTACT_SOURCE_SERVICE_API_KEY', '$q', 'activeOnUrls', 'activeOnTypes', 'Contact', 'ContactManagerSourceService', 'ContactManagerUsernameService', 'DOCUMENT_SEARCH_SERVICE_URL', 'DateRangeHelper', 'CoreUserService', 'ICMUserService', 'ICM_EMAIL_API_URL', 'ContactDomainModelConverter', function ($http, CONTACT_MANAGER_CONTACT_URL, ICM_CSS_URL, ICM_CONTACT_SERVICE_URL, ICM_CONTACTS_URL, ICM_DOCUMENT_SERVICE_URL, CONTACT_MANAGER_EXPORT_URL, CONTACT_MANAGER_DOCUMENTS_URL, CONTACT_MANAGER_NOTES_URL, INFLUENCERS_URL, ICM_SOURCE_SERVICE_URL, ICM_CONTACT_SOURCE_SERVICE_API_KEY, $q, activeOnUrls, activeOnTypes, Contact, ContactManagerSourceService, ContactManagerUsernameService, DOCUMENT_SEARCH_SERVICE_URL, DateRangeHelper, CoreUserService, ICMUserService, ICM_EMAIL_API_URL, ContactDomainModelConverter) {
    'use strict';

    function _formatActiveOnUrls(channel, appendToUrl) {
        var channelType = channel.type.toUpperCase();

        if (activeOnUrls[channelType]) {
            channel.url = activeOnUrls[channelType] + appendToUrl;
        }
    }

    function _formatUserName(channel) {
        if (channel.type === activeOnTypes.TWITTER) {
            channel.userName = ContactManagerUsernameService.getTwitterUsername(channel.userName);
            if (channel.userName[0] === '@') {
                channel.userName = channel.userName.substr(1);
            }
        } else if (channel.type === activeOnTypes.FACEBOOK) {
            channel.userName = ContactManagerUsernameService.getFacebookUsername(channel.userName);
        }
    }

    function _formatActiveOn(contact) {
        var userNameChannels = [activeOnTypes.FACEBOOK.toLowerCase(), activeOnTypes.TWITTER.toLowerCase()],
            urlChannels = [activeOnTypes.BLOG.toLowerCase(), activeOnTypes.LINKED_IN.toLowerCase()],
            channels = contact.channels,
            i = channels.length,
            channel,
            channelType;

        function _removeChannel(contact) {
            contact.channels.splice(i, 1);
        }

        function _isPropertyEmpty(channel, property) {
            return channel[property] === undefined || channel[property] === '';
        }

        while (i--) {
            channel = channels[i];

            // disregard channel if it has no type
            if (channel.type === undefined) {
                _removeChannel(contact);
            } else {
                channelType = channel.type.toLowerCase();

                // handle channels that are built based on User Names
                if (userNameChannels.indexOf(channelType) > -1) {
                    if (_isPropertyEmpty(channel, 'userName')) {
                        _removeChannel(contact);
                    } else {
                        _formatUserName(channel);
                        _formatActiveOnUrls(channel, channel.userName);
                    }
                }
                // handle channels that are built based on URLs
                else if (urlChannels.indexOf(channelType) > -1) {
                        if (_isPropertyEmpty(channel, 'url')) {
                            _removeChannel(contact);
                        } else {
                            _formatActiveOnUrls(channel, channel.url);
                        }
                    }
            }
        }
    }

    var InfluencerContactService = {};
    //containing the total no. of contact present in contact list.
    InfluencerContactService.contactItemCount = 0;

    function _formatContactInfo(contact) {
        var contactInfo = contact.contactInfo,
            checkContactInfoEmpty,
            i;

        checkContactInfoEmpty = function checkEmailEmpty(contactObj, infoType) {
            switch (infoType) {
                case 'email':
                    return !contactObj.address;
                case 'phone':
                    return !contactObj.number;
                case 'address':
                    return !(contactObj.zip || contactObj.street || contactObj.city || contactObj.street2 || contactObj.stateOrProvince || contactObj.countryCode || contactObj.countryName);
            }
        };

        for (i = 0; i < contactInfo.email.length; i++) {
            if (checkContactInfoEmpty(contactInfo.email[i], 'email')) {
                contactInfo.email.splice(i, 1);
                i--;
            }
        }

        for (i = 0; i < contactInfo.phone.length; i++) {
            if (checkContactInfoEmpty(contactInfo.phone[i], 'phone')) {
                contactInfo.phone.splice(i, 1);
                i--;
            }
        }

        for (i = 0; i < contactInfo.address.length; i++) {
            if (checkContactInfoEmpty(contactInfo.address[i], 'address')) {
                contactInfo.address.splice(i, 1);
                i--;
            }
        }
    }

    InfluencerContactService.saveContact = function saveContact(contact) {
        var successMessage,
            httpRequest,
            deferred = $q.defer(),
            self = this;
        ICMUserService.getIdentity().then(function (identity) {
            var formattedContact = JSON.parse(JSON.stringify(contact));
            if (formattedContact.channels) {
                // determine ActiveOn Account URLs
                _formatActiveOn(formattedContact);
            }

            if (formattedContact.contactInfo) {
                _formatContactInfo(formattedContact);
            }
            // determine if we are Creating or Updating
            if (formattedContact.id) {
                successMessage = 'Success. Your contact has been updated.';
                httpRequest = $http.put(CONTACT_MANAGER_CONTACT_URL + '/' + formattedContact.id, ContactDomainModelConverter.convertToDomainModel(formattedContact, identity.company._id));
            } else {
                successMessage = 'Success. Your new contact has been created.';
                httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL, ContactDomainModelConverter.convertToDomainModel(formattedContact, identity.company._id));
                // httpRequest = $q.when('test')
            }

            httpRequest.then(function (response) {
                var contact = response.data;
                var contactViewModel = new Contact(contact, []);

                self.setCurrentContact(contactViewModel);
                deferred.resolve({ contact: contactViewModel, message: successMessage });
                deferred.resolve();
            }).catch(function (response) {
                deferred.reject(response.data);
            });
        }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    InfluencerContactService.importCsv = function importCsv(fileContents, selectedMediaListArray) {
        var deferred = $q.defer(),
            formData = new FormData(),
            payload = { 'mediaLists': selectedMediaListArray };

        formData.append('model', angular.toJson(payload));
        formData.append('file1', fileContents);
        $http.post(CONTACT_MANAGER_CONTACT_URL + '/import', formData, { headers: { 'Content-Type': undefined }
        }).then(function (response) {
            deferred.resolve({ payload: response.data, message: 'Success. Your contacts have been created.' });
        }).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.exportSelected = function exportSelected(csvFileName, selectedContactData, pageSize) {
        var payload = {
            selectedContactData: selectedContactData,
            fileName: csvFileName,
            pageSize: pageSize
        };

        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv', payload).then(function (response) {
                InfluencerContactService.downloadCsv(response.data);

                resolve({ success: true });
            }).catch(function (response) {
                reject(response.data);
            });
        }).catch(function () {});
    };

    InfluencerContactService.exportByMediaList = function exportByMediaList(csvFileName, isAllContacts, selectedMediaListId, pageSize, q) {
        var payload = {
            fileName: csvFileName,
            mediaListIds: isAllContacts ? [] : [selectedMediaListId],
            isAllContacts: isAllContacts,
            pageSize: pageSize
        };

        if (q !== '') {
            payload.q = q;
        }

        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/medialist', payload).then(function (response) {
                InfluencerContactService.downloadCsv(response.data);

                resolve({ success: true });
            }).catch(function (response) {
                reject(response.data);
            });
        }).catch(function () {});
    };

    InfluencerContactService.exportByStat = function exportByStat(csvFileName, distributionId, pageSize, statType, clickedLink) {
        var payload = {
            fileName: csvFileName,
            sourceId: distributionId,
            pageSize: pageSize,
            clickedLink: clickedLink
        };

        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/' + statType, payload).then(function (response) {
                InfluencerContactService.downloadCsv(response.data);

                resolve({ success: true });
            }).catch(function (response) {
                reject(response.data);
            });
        });
    };

    InfluencerContactService.exportByUnsubscribes = function exportByUnsubscribes(csvFileName, distributionId, pageSize, reason) {
        var payload = {
            fileName: csvFileName,
            sourceId: distributionId,
            pageSize: pageSize,
            reason: reason,
            appIds: 'ICM'
        };

        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/unsubscribed', payload).then(function (response) {
                InfluencerContactService.downloadCsv(response.data);

                resolve({ success: true });
            }).catch(function (response) {
                reject(response.data);
            });
        });
    };

    InfluencerContactService.downloadCsv = function downloadCsv(fileName) {
        var link, ev;
        link = document.createElement('a');
        link.href = CONTACT_MANAGER_EXPORT_URL + '/contacts/' + encodeURIComponent(fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        ev = document.createEvent('MouseEvents');
        ev.initMouseEvent('click', false, /* bubble */
        false, /* cancelable */
        window, 0, 0, 0, 1, 1, false, false, false, false, 0, null /*Rest initMouseEventArguments*/
        );
        link.dispatchEvent(ev);
        document.body.removeChild(link);
    };

    InfluencerContactService.deletePrivateContacts = function deletePrivateContacts(contactIds) {
        var payload = { contactIds: contactIds };

        return $http.post(CONTACT_MANAGER_CONTACT_URL + '/delete', payload);
    };

    InfluencerContactService.deleteContact = function deleteContact(contactId) {
        var defer = $q.defer();

        $http.delete(CONTACT_MANAGER_CONTACT_URL + '/' + contactId).then(function () {
            defer.resolve({ message: 'Success. Your contact has been deleted.' });
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.getContactById = function getContactById(contactId) {
        var defer = $q.defer();

        ICMUserService.getIdentity().then(function (identity) {
            $http.get(ICM_CONTACTS_URL + '/contacts/' + identity.company._id + '/' + contactId).then(function (response) {
                //extract sourceIds from the sourceSnippets to load source objects
                var sourceIds = [],
                    contact = response.data,
                    sources = contact.sourceSnippets;

                (sources || []).forEach(function (source) {
                    if (source.id) {
                        sourceIds.push(source.id);
                    }
                });

                if (sourceIds.length > 0) {
                    ContactManagerSourceService.getSourcesByIds(sourceIds).then(function (sources) {
                        defer.resolve(new Contact(contact, sources));
                    });
                } else {
                    defer.resolve(new Contact(contact, []));
                }
            }).catch(function (response) {
                defer.reject(response.data);
            });
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    InfluencerContactService.getContactsById = function getContactById(contactIds) {
        var defer = $q.defer();

        var req = {
            method: 'POST',
            url: ICM_CONTACTS_URL + '/contacts',
            headers: {
                'Content-Type': 'application/json'
            },
            data: { contactIds: contactIds }
        };

        $http(req).then(function (response) {
            var contacts = response.data.hits;

            for (var i = 0; i < contacts.length; i++) {
                contacts[i] = new Contact(contacts[i], []);
            }

            defer.resolve(contacts);
        }).catch(function (response) {
            defer.reject(response.data);
        });
        return defer.promise;
    };

    InfluencerContactService.searchContacts = function searchContacts(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                }.bind(this));
            }
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.aggregateContactSearch = function aggregateContactSearch(query) {
        var defer = $q.defer();

        $http.post(ICM_CSS_URL + '/search/contacts', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit);
                });
            }
            defer.resolve(response.data);
        }).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.aggregateSourceSearch = function aggregateSourceSearch(query) {
        var defer = $q.defer();

        $http.post(ICM_CSS_URL + '/search/sources', query).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.aggregateRelevantContacts = function aggregateRelevantContacts(query) {
        var defer = $q.defer();

        $http.post(ICM_CSS_URL + '/v2/search/relevantContacts', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit);
                }.bind(this));
            }
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.aggregateRelevantSources = function aggregateRelevantSources(query) {
        var defer = $q.defer();

        $http.post(ICM_CSS_URL + '/v2/search/relevantSources', query).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.getBySourceSuggest = function getBySourceSuggest(query, size) {
        var suggestUrl = ICM_CSS_URL + '/search/suggest',
            payload = {
            q: query,
            size: size || 3
        },
            defer = $q.defer();

        $http.post(suggestUrl, payload).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        }.bind(this));

        return defer.promise;
    };

    InfluencerContactService.setCurrentContact = function setCurrentContact(contact) {
        InfluencerContactService.currentContact = new Contact(contact);
    };

    InfluencerContactService.getCurrentContact = function getCurrentContact(contactId) {
        var defer = $q.defer();

        //make sure we don't display the wrong contact
        if (InfluencerContactService.currentContact && InfluencerContactService.currentContact.id === contactId) {
            defer.resolve(InfluencerContactService.currentContact);
        } else {
            InfluencerContactService.getContactById(contactId).then(function (newContact) {
                defer.resolve(newContact);
            });
        }

        return defer.promise;
    };

    InfluencerContactService.getMasterList = function getMasterList(query) {
        var defer = $q.defer();

        query.isMasterList = true;

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                }.bind(this));
            }
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.getByMediaListIds = function getByMediaListIds(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                }.bind(this));
            }
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    // can remove this function when we get rid of the XXX split
    InfluencerContactService.addNote = function addNote(contactId, note) {
        var deferred = $q.defer(),
            payload = {
            contactId: contactId,
            note: note
        };

        $http.post(CONTACT_MANAGER_NOTES_URL, payload).then(function () {
            deferred.resolve({ message: 'Success. Your contact has been updated.' });
        }).catch(function () {
            deferred.reject({ message: 'Add faild' });
        });

        return deferred.promise;
    };

    // can remove this function when we get rid of the XXX split
    InfluencerContactService.editNote = function editNote(contactId, noteId, note) {
        var deferred = $q.defer(),
            payload = {
            note: note
        };

        $http.put(CONTACT_MANAGER_NOTES_URL + '/' + noteId, payload).then(function () {
            deferred.resolve({ message: 'Success. Your contact has been updated.' });
        }).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.addActivity = function addActivity(contactId, type, subject, body, date, author) {
        var deferred = $q.defer(),
            payload = {
            contactId: contactId,
            type: type,
            subject: subject,
            body: body,
            date: date,
            author: author
        };
        $http.post(INFLUENCERS_URL + '/activities', payload).then(function () {
            deferred.resolve({ message: 'Success. Your contact has been updated.' });
        }).catch(function () {
            deferred.reject({ message: 'Add failed' });
        });

        return deferred.promise;
    };

    InfluencerContactService.editActivity = function editActivity(activityId, contactId, type, subject, body, date, author) {
        var deferred = $q.defer(),
            payload = {
            contactId: contactId,
            type: type,
            subject: subject,
            body: body,
            date: date,
            author: author
        };

        $http.put(INFLUENCERS_URL + '/activities/' + activityId, payload).then(function () {
            deferred.resolve({ message: 'Success. Your contact has been updated.' });
        }).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.deleteNotes = function deleteNotes(contactId, noteIds) {
        var deferred = $q.defer(),
            payload = {
            noteIds: noteIds
        };

        $http.post(CONTACT_MANAGER_NOTES_URL + '/bulkDelete', payload).then(function () {
            deferred.resolve({ message: 'Success. Your contact has been updated.' });
        }).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.getNotes = function getNotes(contactId) {
        var deferred = $q.defer();

        $http.get(CONTACT_MANAGER_NOTES_URL + '?contactId=' + contactId).then(function (response) {
            deferred.resolve(response.data);
        }).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.relevantContactsCount = function relevantContactsCount(query) {
        var httpRequest,
            deferred = $q.defer(),
            _query = angular.copy(query);

        _query.pageSize = 500;
        _query.page = 0;
        _query.groupOption = 'none';

        httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/documents/count', _query);

        httpRequest.then(function (response) {
            var count = response.data > 499 ? '+500' : response.data;
            deferred.resolve(count);
        }.bind(this)).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.relevantContacts = function relevantContacts(query) {
        var httpRequest,
            deferred = $q.defer();

        httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/documents', query);

        httpRequest.then(function (response) {
            var formattedResponse = {
                count: 0,
                hits: [],
                articleCountMapping: {}
            };

            if (response.data.contacts) {
                formattedResponse.count = response.data.contacts.length;

                response.data.contacts.forEach(function (contact) {
                    var contactViewModel = new Contact(contact.contact, contact.sources);

                    formattedResponse.hits.push(contactViewModel);
                    formattedResponse.articleCountMapping[contactViewModel.id] = contact.authoredArticlesCount || 0;
                }, this);
            }
            deferred.resolve(formattedResponse);
        }.bind(this)).catch(function (response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.relevantArticles = function relevantArticles(query, additionalQueryParams) {
        var deferred = $q.defer(),
            payload = {
            query: query,
            contactId: additionalQueryParams.contactId,
            numDups: 20
        };

        $http.post(ICM_DOCUMENT_SERVICE_URL + '/documents/relevant/contact', payload).then(function onSuccess(response) {
            var formatDocs = this.InfluencerContactService.formatRelevantArticlesBySourceResponse(response.data, query);
            deferred.resolve(formatDocs);
        }.bind(this)).catch(function onError(response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.relevantArticlesBySource = function relevantArticlesBySource(query, additionalQueryParams) {
        var deferred = $q.defer(),
            payload = {
            query: query,
            sourceIds: [additionalQueryParams.sourceId],
            numDups: 20
        };

        if (query.childIds) {
            payload.sourceIds = payload.sourceIds.concat(query.childIds);
            delete query.childIds;
        }

        $http.post(ICM_DOCUMENT_SERVICE_URL + '/documents/relevant/source', payload).then(function onSuccess(response) {
            var formatDocs = this.InfluencerContactService.formatRelevantArticlesBySourceResponse(response.data, query);
            deferred.resolve(formatDocs);
        }.bind(this)).catch(function onError(response) {
            deferred.reject(response.data);
        });

        return deferred.promise;
    };

    InfluencerContactService.formatRelevantArticlesBySourceResponse = function formatRelevantArticlesBySourceResponse(response, initialQuery) {
        var formattedResponse = {
            documents: [],
            totalDocuments: 0,
            totalPages: 0,
            totalGroups: 0
        };
        try {
            if (response && response.views) {
                if (response.views.count && response.views.count.totalCount) {
                    formattedResponse.totalDocuments = response.views.count.totalCount;
                    formattedResponse.totalPages = Math.ceil(formattedResponse.totalDocuments / initialQuery.pageSize);
                }
                if (response.views.list && response.views.list.groupCount) {
                    formattedResponse.totalGroups = response.views.list.groupCount;
                }

                if (response.views.list && response.views.list.results) {
                    // handle duplicate documents, putting them into the expected format
                    response.views.list.results.forEach(function (documentGroup) {
                        var parentDocument = documentGroup.documents[0].gyda;
                        parentDocument.dupDocsCount = documentGroup.count > 1 ? documentGroup.count - 1 : 0;
                        parentDocument.dupDocs = [];
                        parentDocument.remainingDocIds = documentGroup.remainingDupDocsIds;
                        for (var i = 1; i < documentGroup.documents.length; i++) {
                            parentDocument.dupDocs.push(documentGroup.documents[i].gyda);
                        }
                        formattedResponse.documents.push(parentDocument);
                    });
                }
            }
            return formattedResponse;
        } catch (error) {
            throw error;
        }
    };

    InfluencerContactService.pruneChannelSources = function pruneChannelSources(contact, sources) {
        sources.forEach(function (source) {
            if (source.parentIds && source.sourceType !== 'bureau') {
                source.parentIds.forEach(function (id) {
                    contact.channels.forEach(function (channel, index, arr) {
                        if (channel.sourceId && channel.sourceId === id) {
                            arr.splice(index, 1);
                        }
                    });
                });
            } else if (source.sourceType === 'bureau') {
                contact.channels.forEach(function (channel, index, arr) {
                    if (channel.sourceId && channel.sourceId === source.id) {
                        arr.splice(index, 1);
                    }
                });
            }
        });
    };

    InfluencerContactService.getContactsByStat = function getContactsByStat(query) {
        var _this = this;

        var analyticsApiPayload = JSON.parse(JSON.stringify(query));
        delete analyticsApiPayload.pathParams;
        var distributionId = query.pathParams.distributionId;
        var statType = query.pathParams.statType;
        var analyticsUrl = ICM_EMAIL_API_URL + '/analytics/distributions/' + distributionId + '/' + statType + '/recipients';

        function formatContactResponse(contactEmailsArray, contacts, totalCount) {
            var bFound = false;
            var contactObject = {};

            if (contactEmailsArray && contacts.length < contactEmailsArray.length) {
                // display email addresses for missing contacts (from CSS)
                contactEmailsArray.forEach(function (emailAddress) {
                    bFound = false;
                    contactObject = {
                        id: 'other_contact_' + emailAddress,
                        name: {
                            firstName: emailAddress,
                            middleName: '',
                            lastName: ''
                        },
                        contactInfo: {
                            email: [{
                                address: emailAddress,
                                type: 'work'
                            }]
                        }
                    };

                    bFound = contacts.find(function (contact) {
                        return contact.contactInfo.email[0].address === emailAddress;
                    });

                    if (typeof bFound === 'undefined') {
                        contacts.push(new Contact(contactObject, []));
                    }
                });
            }

            return {
                count: totalCount,
                hits: contacts
            };
        }

        return $http.post(analyticsUrl, analyticsApiPayload).then(function (response) {
            var contacts = response.data.contacts;
            var count = response.data.count;

            var contactIdsArray = contacts.map(function (a) {
                return a.contactIds[0];
            });
            var contactEmailsArray = contacts.map(function (a) {
                return a.emailAddress;
            });
            var cssQuery = {
                page: 0,
                pageSize: 25,
                anyKeywords: contactIdsArray
            };

            if (contactIdsArray.length === 0) {
                return formatContactResponse(contactEmailsArray, []);
            } else {
                return _this.InfluencerContactService.getByContactIds(cssQuery).then(function (response) {
                    return formatContactResponse(contactEmailsArray, response.hits, count);
                });
            }
        }).catch(function () {
            return [];
        });
    };

    InfluencerContactService.getContactIdsByStat = function getContactsByStat(query) {
        var analyticsApiPayload = JSON.parse(JSON.stringify(query));
        delete analyticsApiPayload.pathParams;
        var distributionId = query.pathParams.distributionId;
        var statType = query.pathParams.statType;
        var analyticsUrl = ICM_EMAIL_API_URL + '/analytics/distributions/' + distributionId + '/' + statType + '/recipients';

        return $http.post(analyticsUrl, analyticsApiPayload).then(function (response) {
            return response.data.contacts;
        }).catch(function () {
            return [];
        });
    };

    InfluencerContactService.getByContactIds = function getByContactIds(query) {
        var defer = $q.defer();

        if (query.anyKeywords) {
            query.anyKeywords = query.anyKeywords.filter(Boolean);
        }

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/Ids', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                }.bind(this));
            }

            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.getUnsubscribed = function getUnsubscribed(query) {
        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_CONTACT_URL + '/unsubscribed/' + query.distributionId, query).then(function (response) {
                if (response.data.hits) {
                    response.data.hits = response.data.hits.map(function (hit) {
                        return new Contact(hit.quiddity, response.data.sources);
                    }.bind(this));
                }

                resolve(response.data);
            }.bind(this)).catch(function (response) {
                reject(response.data);
            });
        });
    };

    InfluencerContactService.getUnsubscribedByEmail = function getUnsubscribedByEmail(payload) {
        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_CONTACT_URL + '/unsubscribed/search', payload).then(function (response) {
                resolve(response.data);
            }).catch(function (response) {
                reject(response.data);
            });
        });
    };

    InfluencerContactService.getOpenRate = function getOpenRate(query) {
        var payload = {
            stat: query.type,
            distributionId: query.distributionId,
            page: query.page,
            pageSize: query.pageSize,
            clickedLink: query.clickedLink
        };

        return $q(function (resolve, reject) {
            $http.post(CONTACT_MANAGER_CONTACT_URL + '/email/stats', payload).then(function (response) {
                if (response.data.hits) {
                    response.data.hits = response.data.hits.map(function (hit) {
                        return new Contact(hit.quiddity, response.data.sources);
                    }.bind(this));
                }

                resolve(response.data);
            }.bind(this)).catch(function (response) {
                reject(response.data);
            });
        });
    };

    InfluencerContactService.autocomplete = function autocomplete(query) {
        var defer = $q.defer();

        $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/autocomplete', query).then(function (response) {
            if (response.data.hits) {
                response.data.hits = response.data.hits.map(function (hit) {
                    return new Contact(hit.quiddity, response.data.sources);
                }.bind(this));
            }
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        });

        return defer.promise;
    };

    InfluencerContactService.INFLUENCER_APP = 'influencerApp';

    InfluencerContactService.getRecentDocuments = function getRecentDocuments(searchQueryType, ids) {
        if (searchQueryType.toLowerCase() === 'contact') {
            return this.getRecentDocumentsForContact(ids[0]);
        } else if (searchQueryType.toLowerCase() === 'source') {
            return this.getRecentDocumentsForSource(ids);
        }
    };

    InfluencerContactService.getRecentDocumentsForSource = function getRecentDocumentsForSource(sourceIds) {
        var httpOptions = {
            method: 'POST',
            url: ICM_DOCUMENT_SERVICE_URL + '/documents/recent/source',
            data: {
                sourceIds: sourceIds
            }
        };

        return $q(function (resolve, reject) {
            $http(httpOptions).then(function (response) {
                var transformedResponse = {
                    totalDocuments: 0,
                    documents: []
                },
                    responseViews;

                if (response && response.data && response.data.views) {
                    responseViews = response.data.views;

                    if (responseViews.documentCount && responseViews.documentCount.totalCount) {
                        transformedResponse.totalDocuments = responseViews.documentCount.totalCount;
                    }

                    if (responseViews.searchResults && responseViews.searchResults.results && Array.isArray(responseViews.searchResults.results)) {
                        responseViews.searchResults.results.forEach(function (result) {
                            if (result.gyda) {
                                transformedResponse.documents.push(result.gyda);
                            }
                        });
                    }
                }

                resolve(transformedResponse);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    InfluencerContactService.getRecentDocumentsForContact = function getRecentDocumentsForContact(contactId) {
        var defaultDates = DateRangeHelper.getDateRange(14),
            jsonObj = {
            'dateStart': defaultDates.dateStart,
            'dateEnd': defaultDates.dateEnd,
            'pageSize': 10,
            'page': 0,
            'sortOrder': 'DESC',
            'sortField': 'date',
            'groupOption': 'none',
            'searchRequestId': 0,
            'caseSensitive': 'no',
            'sourceSelectionId': 1,
            'informationTypes': [],
            'allKeywords': [''],
            'anyKeywords': [],
            'notKeywords': [],
            'keyphraseHistogram': 100,
            'searchQueryType': 'contact',
            'authorId': contactId
        };

        return $q(function (resolve, reject) {
            CoreUserService.getCurrent(true).then(function (currentUser) {
                ICMUserService.getAppSettings('search', currentUser._id).then(function (appSettings) {
                    if (appSettings && appSettings.groupOption) {
                        jsonObj.groupOption = appSettings.groupOption;
                    }
                }).then(function () {
                    $http.post(DOCUMENT_SEARCH_SERVICE_URL + '/recentDocuments', jsonObj, { headers: { 'x-client-name': 'icm-web-assets' } }).then(function (response) {
                        resolve(response.data);
                    }).catch(function (err) {
                        reject(err);
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }).catch(function () {});
    };

    InfluencerContactService.getByContactAndSourceSuggest = function getByContactAndSourceSuggest(query, size) {
        var suggestUrl = ICM_CSS_URL + '/search/suggest',
            payload = {
            q: query,
            size: size || 3
        },
            defer = $q.defer();

        $http.post(suggestUrl, payload).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        }.bind(this));
        return defer.promise;
    };

    InfluencerContactService.getRecentSearches = function getRecentSearches(page, pageSize) {
        var url = ICM_CSS_URL + '/search/getRecentSearches',
            defer = $q.defer(),
            payload = {
            page: page || 0,
            pageSize: pageSize || 5
        };

        $http.post(url, payload).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        }.bind(this));
        return defer.promise;
    };

    InfluencerContactService.saveRecentSearch = function saveRecentSearch(payload) {
        var url = ICM_CSS_URL + '/search/recentSearches',
            defer = $q.defer();

        $http.post(url, payload).then(function (response) {
            defer.resolve(response.data);
        }.bind(this)).catch(function (response) {
            defer.reject(response.data);
        }.bind(this));
        return defer.promise;
    };

    InfluencerContactService.submitContactCreateFeedback = function submitContactCreateFeedback(payload) {
        var url = ICM_CONTACT_SERVICE_URL + '/contacts/feedback/missing',
            defer = $q.defer();

        $http.post(url, payload).then(function (response) {
            defer.resolve(response.data);
        }).catch(function (error) {
            defer.reject(error);
        });
        return defer.promise;
    };

    InfluencerContactService.submitSourceCreateFeedback = function submitSourceCreateFeedback(payload) {
        var url = ICM_SOURCE_SERVICE_URL + '/sources/feedback/missing',
            config = {
            headers: {
                'x-client-name': 'media-relations'
            }
        },
            defer = $q.defer();

        $http.post(url, payload, config).then(function (response) {
            defer.resolve(response.data);
        }).catch(function (error) {
            defer.reject(error);
        });
        return defer.promise;
    };

    return InfluencerContactService;
}]);
'use strict';

angular.module('MW.ContactManager.SelectionFactory', ['MW.Framework.InfluencerContactService', 'MW.Framework.ICMUserService']).factory('FilterSelectionFactory', ['$q', 'ICMUserService', 'moment', function ($q, ICMUserService, moment) {
    'use strict';

    function FilterSelectionFactory(name) {
        this.init(name);
    }

    FilterSelectionFactory.prototype.init = function init(name) {
        this.ICMUserService = ICMUserService;
        this.moment = moment;
        this.currentOptions = [];
        this.displayState = {
            selected: {},
            selectionDisplay: '',
            selectedCount: 0,
            partiallySelected: {},
            allSelected: false
        };
        this.name = name;
        this.history = [];
        this.parent = null;

        this.previousState = {};
    };

    FilterSelectionFactory.prototype.getSelection = function getSelection() {
        return this.displayState.selected;
    };

    FilterSelectionFactory.prototype.toggle = function toggle(option, updateAncestors) {
        if (this.isSelected(option)) {
            this.deselect(option, updateAncestors);
            this.displayState.allSelected = false;
        } else {
            this.select(option, updateAncestors);
            this.displayState.allSelected = this.isPageFullySelected();
        }
    };

    FilterSelectionFactory.prototype.toggleAllCurrent = function toggleAllCurrent() {
        if (this.isPageFullySelected()) {
            this.currentOptions.forEach(function (currentOption) {
                if (this.isSelected(currentOption)) {
                    this.deselect(currentOption);
                }
            }, this);

            this.displayState.allSelected = false;
        } else {
            this.currentOptions.forEach(function (currentOption) {
                if (!this.isSelected(currentOption)) {
                    this.select(currentOption);
                }
            }, this);

            this.displayState.allSelected = true;
        }
    };

    FilterSelectionFactory.prototype.isSelected = function isSelected(option) {
        return !!this.displayState.selected[option.key];
    };

    FilterSelectionFactory.prototype.isPageFullySelected = function isPageFullySelected() {
        if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        return this.currentOptions.every(function (currentOption) {
            return this.isSelected(currentOption);
        }, this);
    };

    FilterSelectionFactory.prototype.reset = function reset() {
        this.init();
    };

    FilterSelectionFactory.prototype.snapshotState = function snapshotState() {
        this.previousState = angular.copy(this.displayState);
    };

    FilterSelectionFactory.prototype.rollback = function rollback() {
        this.displayState = this.previousState;
        this.previousState = {};
    };

    FilterSelectionFactory.prototype.select = function select(option, updateAncestors) {
        if (this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        if (this.parent) {
            option.parentKey = this.parent.key;
        }

        this.displayState.selected[option.key] = option;

        this.updateAllSelected();

        if (option.children) {
            option.children.forEach(function (childOption) {
                childOption.parentKey = option.key;
                this.displayState.selected[childOption.key] = childOption;
            }, this);
        }

        if (updateAncestors) {
            this.updateAncestors(option);
        }

        this.updateRecentDisplay();
    };

    FilterSelectionFactory.prototype.selectByKey = function selectByKey(key) {
        var option = this.currentOptions.filter(function (obj) {
            return obj.key === key;
        });
        if (option[0]) {
            this.select(option[0]);
        }
    };

    FilterSelectionFactory.prototype.deselectAll = function deselectAll() {
        this.currentOptions.forEach(function (currentOption) {
            if (this.isSelected(currentOption) || this.isPartiallySelected(currentOption)) {
                this.deselect(currentOption);
            }
        }, this);
        this.updateRecentDisplay();
    };

    FilterSelectionFactory.prototype.deselect = function deselect(option, updateAncestors) {
        if (this.isPartiallySelected(option)) {
            this.removePartialSelection(option);
        }

        delete this.displayState.selected[option.key];

        this.displayState.allSelected = false;

        if (option.children) {
            option.children.forEach(function (childOption) {
                delete this.displayState.selected[childOption.key];
            }, this);
        }

        if (updateAncestors) {
            this.updateAncestors(option);
        }

        this.updateRecentDisplay();
    };

    FilterSelectionFactory.prototype.updateRecentDisplay = function updateRecentDisplay() {
        this.displayState.selectedCount = this.selectedCurrentOptionCount();
        if (this.displayState.selectedCount === 0) {
            this.displayState.selectionDisplay = '';
        } else if (this.displayState.selectedCount === 1) {
            this.displayState.selectionDisplay = this.displayState.selected[this.getSelectedValues()[0]].display;
        } else {
            this.displayState.selectionDisplay = this.name;
        }
    };

    FilterSelectionFactory.prototype.updateAncestors = function updateAncestors(option) {
        if (option.parentKey) {
            this.updateParent(option);
        }
    };

    FilterSelectionFactory.prototype.updateCurrentOptions = function updateCurrentOptions(relevantOptions) {
        this.currentOptions = relevantOptions;

        // if nothing is selected no need to update
        if (Object.keys(this.displayState.selected).length) {
            // this call will always be made when we are at the parent level, so just update parent display states
            // also this should only be called with new beats that cannot yet be selected
            this.currentOptions.forEach(function (parentOption) {
                if (this.isSelected(parentOption) || this.isPartiallySelected(parentOption)) {
                    this.updateParent(null, parentOption);
                }
            }, this);
        }

        this.displayState.allSelected = this.isPageFullySelected();
    };

    FilterSelectionFactory.prototype.partiallySelect = function partiallySelect(option) {
        if (this.isSelected(option)) {
            delete this.displayState.selected[option.key];
            this.displayState.allSelected = false;
        }

        this.displayState.partiallySelected[option.key] = option;
    };

    FilterSelectionFactory.prototype.isPartiallySelected = function isPartiallySelected(option) {
        return !!this.displayState.partiallySelected[option.key];
    };

    FilterSelectionFactory.prototype.openChild = function openChild(option) {
        return $q(function (resolve) {
            if (!option.children.length) {
                return;
            }

            this.history.push({
                options: this.currentOptions,
                parent: this.parent
            });

            this.currentOptions = option.children;
            this.parent = option;

            if (this.isSelected(this.parent)) {
                this.currentOptions.forEach(function (option) {
                    this.select(option);
                }, this);

                this.displayState.allSelected = true;
            } else if (this.isPartiallySelected(this.parent)) {
                this.displayState.allSelected = false;
            } else {
                this.currentOptions.forEach(function (option) {
                    this.deselect(option);
                }, this);

                this.displayState.allSelected = false;
            }

            resolve();
        }.bind(this));
    };

    FilterSelectionFactory.prototype.openParent = function openParent() {
        if (!this.history.length) {
            return;
        }

        var historyObject = this.history.pop();

        // before drilling back up, check children
        // if all children are selected, select the parent
        // if page is partially selected, partially select parent
        if (this.isPageFullySelected()) {
            this.select(this.parent);
        } else if (this.isPagePartiallySelected()) {
            this.partiallySelect(this.parent);
        } else {
            this.deselect(this.parent);
        }

        this.currentOptions = historyObject.options;
        this.parent = historyObject.parent;

        // after drilling up, check if everything at this level is selected
        this.displayState.allSelected = this.isPageFullySelected();
    };

    FilterSelectionFactory.prototype.getParent = function getParent(option) {
        var parent = null;

        if (this.parent) {
            // then we are on the child view
            parent = this.parent;
        } else {
            // we are on the parent view
            this.currentOptions.some(function (parentOption) {
                if (parentOption.key === option.parentKey) {
                    parent = parentOption;
                    return true;
                }
            });
        }

        return parent;
    };

    FilterSelectionFactory.prototype.updateParent = function updateParent(child, parent) {
        var numberOfChildren = 0,
            numberOfSelectedChildren = 0;

        parent = parent || this.getParent(child);

        if (parent.children) {
            // get the count of children selected
            numberOfChildren = parent.children.length;
            parent.children.forEach(function (child) {
                if (this.isSelected(child)) {
                    numberOfSelectedChildren++;
                }
            }, this);

            // set the parent's display state, based on the number of children selected
            if (numberOfSelectedChildren === 0) {
                delete this.displayState.selected[parent.key];
                delete this.displayState.partiallySelected[parent.key];
            } else if (numberOfSelectedChildren === numberOfChildren) {
                this.displayState.selected[parent.key] = parent;
                delete this.displayState.partiallySelected[parent.key];
            } else {
                delete this.displayState.selected[parent.key];
                this.displayState.partiallySelected[parent.key] = parent;
            }
        }
    };

    FilterSelectionFactory.prototype.updateAllSelected = function updateAllSelected() {
        var isAllSelected = false;

        if (Object.keys(this.displayState.selected).length) {
            isAllSelected = this.currentOptions.every(function (option) {
                return this.isSelected(option);
            }, this);
        }

        this.displayState.allSelected = isAllSelected;
    };

    FilterSelectionFactory.prototype.removePartialSelection = function removePartialSelection(option) {
        delete this.displayState.partiallySelected[option.key];
    };

    FilterSelectionFactory.prototype.getSelectedChildren = function getSelectedChildren() {
        var selectedChildren = [];

        if (!_.isEmpty(this.displayState.selected)) {
            Object.keys(this.displayState.selected).forEach(function (key) {
                if (!this.displayState.selected[key].children) {
                    selectedChildren.push(this.displayState.selected[key]);
                }
            }, this);
        }

        return selectedChildren;
    };

    FilterSelectionFactory.prototype.isPagePartiallySelected = function isPagePartiallySelected() {
        var selectedCount = 0,
            partiallySelectedCount = 0;

        if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
            return false;
        }

        this.currentOptions.forEach(function (currentOption) {
            if (this.isSelected(currentOption)) {
                selectedCount++;
            } else if (this.isPartiallySelected(currentOption)) {
                partiallySelectedCount++;
            }
        }, this);

        return partiallySelectedCount > 0 || selectedCount > 0 && selectedCount < this.currentOptions.length;
    };

    FilterSelectionFactory.prototype.selectedCurrentOptionCount = function selectedCurrentOptionCount() {
        var selectedCount = 0;

        this.currentOptions.forEach(function (currentOption) {
            if (currentOption.children) {
                currentOption.children.forEach(function (childOption) {
                    if (this.isSelected(childOption)) {
                        selectedCount++;
                    }
                }, this);
            } else if (this.isSelected(currentOption)) {
                selectedCount++;
            }
        }, this);

        return selectedCount;
    };

    FilterSelectionFactory.prototype.resetDepth = function resetDepth() {
        if (this.history.length > 0) {
            this.openParent();
            this.resetDepth();
        }
    };

    FilterSelectionFactory.prototype.hasChildren = function hasChildren(option) {
        return Array.isArray(option.children) && option.children.length;
    };

    FilterSelectionFactory.prototype.getSelectedChildCount = function getSelectedChildCount(parent) {
        var childCount = 0;

        Object.keys(this.displayState.selected).forEach(function (selectedKey) {
            var selectedOption = this.displayState.selected[selectedKey];

            if (selectedOption.parentKey === parent.key) {
                childCount++;
            }
        }, this);

        return childCount;
    };

    FilterSelectionFactory.prototype.getSelectedValues = function getSelectedValues() {
        return Object.keys(this.displayState.selected);
    };

    return FilterSelectionFactory;
}]).factory('LocationSelectionFactory', ['FilterSelectionFactory', 'InfluencerContactService', '$q', function (FilterSelectionFactory, InfluencerContactService, $q) {
    'use strict';

    function LocationSelectionFactory(name) {
        FilterSelectionFactory.call(this, name);

        this.InfluencerContactService = InfluencerContactService;
        this.querySelections = [];

        this.levels = {
            COUNTRY: 'country',
            REGION: 'region',
            CITY: 'city'
        };

        this.getQuerySelections = function getQuerySelections() {
            return this.querySelections;
        };

        this.getQuerySelectionCount = function getQuerySelectionCount() {
            return this.querySelections.length;
        };

        this.hasChildren = function locationHasChildren(option) {
            switch (option.level.toLowerCase()) {
                case this.levels.COUNTRY:
                case this.levels.REGION:
                    return true;
                default:
                    return false;
            }
        };

        this.updateQuery = function updateQuery(queryString, filters, searchType, chips, dateRangeDays, language) {
            this.queryString = queryString;
            this.filters = filters;
            this.searchType = searchType;
            this.chips = chips;
            this.dateRangeDays = dateRangeDays || 14;
            this.language = language;
        };

        this.openChild = function openChild(option, cb) {
            var _this = this;

            return $q(function (resolve, reject) {
                if (option.level.toLowerCase() === _this.levels.REGION) {
                    var searchTypeFunction,
                        allSearchTypeFunction,
                        query = {
                        aggregations: [{
                            type: 'cities',
                            country: option.country,
                            region: option.key
                        }],
                        filters: _this.filters || [],
                        page: 0,
                        pageSize: 0,
                        q: _this.queryString || '',
                        orQ: _this.chips || [],
                        language: _this.language
                    },
                        promises = [];

                    if (_this.searchType === 'source' || _this.searchType === 'relevantSource' && query.orQ.length === 0) {
                        _this.searchType = 'source';
                        searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateSourceSearch;
                    } else if (_this.searchType === 'relevantContact' && query.orQ.length === 0) {
                        _this.searchType = 'contact';
                        searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateContactSearch;
                    } else if (_this.searchType === 'relevantContact') {
                        searchTypeFunction = _this.InfluencerContactService.aggregateRelevantContacts;
                        allSearchTypeFunction = _this.InfluencerContactService.aggregateContactSearch;
                        query.relevantQ = query.q;
                        delete query.q;
                    } else if (_this.searchType === 'relevantSource') {
                        searchTypeFunction = _this.InfluencerContactService.aggregateRelevantSources;
                        allSearchTypeFunction = _this.InfluencerContactService.aggregateSourceSearch;
                        query.relevantQ = query.q;
                        delete query.q;
                    } else {
                        _this.searchType = 'contact';
                        searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateContactSearch;
                    }

                    if (_this.searchType.indexOf('relevant') === 0) {
                        query.docQuery = {
                            dateStart: _this.moment().tz(_this.ICMUserService.getTimezone()).subtract(_this.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                            dateEnd: _this.moment().tz(_this.ICMUserService.getTimezone()).endOf('day').toISOString()
                        };
                    }

                    // query for all cities as well as relevant cities
                    var queryNoFilters = angular.copy(query);
                    queryNoFilters.filters = [];
                    queryNoFilters.q = '';
                    delete queryNoFilters.relevantQ;
                    delete queryNoFilters.orQ;
                    delete queryNoFilters.docQuery;
                    promises.push(allSearchTypeFunction(queryNoFilters));
                    promises.push(searchTypeFunction(query));
                    $q.all(promises).then(function successAggregateSearch(resolvedPromises) {

                        function makeHash(array, boolIsOkay) {
                            var hashMap = {};
                            array.forEach(function (option) {
                                hashMap[option.key] = boolIsOkay ? true : option;
                            });
                            return hashMap;
                        }

                        var noFilterResponse = resolvedPromises[0],
                            relevantResponse = resolvedPromises[1],
                            finalList = [];

                        if (noFilterResponse.aggs && noFilterResponse.aggs.cities && relevantResponse.aggs && relevantResponse.aggs.cities) {
                            var allHash = makeHash(noFilterResponse.aggs.cities),
                                relevantHash = makeHash(relevantResponse.aggs.cities);

                            // for every avail options, see if it is relevant
                            Object.keys(allHash).forEach(function (allKey) {
                                allHash[allKey].count = relevantHash[allKey] ? relevantHash[allKey].count : 0;
                                if (!relevantHash[allKey]) {
                                    allHash[allKey].nonRelevant = true;
                                }
                            });

                            // convert back to array
                            Object.keys(allHash).forEach(function (tempKey) {
                                finalList.push(allHash[tempKey]);
                            });
                        }

                        option.children = finalList;
                    }).catch(function failedAggregateSearch(error) {
                        reject(error);
                    }).finally(function finallyAggregateSearch() {
                        _openChild();
                        if (cb && typeof cb === 'function') {
                            cb();
                        }
                    });
                } else {
                    _openChild();
                    if (cb && typeof cb === 'function') {
                        cb();
                    }
                }

                function _openChild() {
                    if (!option.children.length) {
                        return;
                    }

                    _this.history.push({
                        options: _this.currentOptions,
                        parent: _this.parent
                    });

                    _this.currentOptions = option.children;
                    _this.parent = option;

                    if (_this.isSelected(_this.parent)) {
                        _this.currentOptions.forEach(function (option) {
                            _this.addQuerySelection(option, true);
                            _this.addToDisplay(option);
                        });

                        _this.displayState.allSelected = true;
                    } else if (_this.isPartiallySelected(_this.parent)) {
                        _this.displayState.allSelected = false;

                        if (_this.parent.level.toLowerCase() === _this.levels.COUNTRY) {
                            _this.currentOptions.forEach(function (regionOption) {
                                if (!_this.isSelected(regionOption) && !_this.isPartiallySelected(regionOption)) {
                                    _this.querySelections.some(function (querySelection) {
                                        if (regionOption.key === querySelection.region && querySelection.level.toLowerCase() === _this.levels.CITY) {
                                            _this.partiallySelect(regionOption);

                                            return true;
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        _this.currentOptions.forEach(function (option) {
                            _this.removeFromDisplay(option);
                        });

                        _this.displayState.allSelected = false;
                    }

                    resolve();
                }
            });
        };

        this.openParent = function openParent() {
            if (!this.history.length) {
                return;
            }

            var historyObject = this.history.pop();

            // before drilling back up, check children
            // if all children are selected, select the parent
            // if page is partially selected, partially select parent
            if (this.isPageFullySelected()) {
                this.addToDisplay(this.parent);
            } else if (this.isPagePartiallySelected()) {
                this.partiallySelect(this.parent);
            } else {
                this.removeFromDisplay(this.parent);
            }

            this.currentOptions = historyObject.options;
            this.parent = historyObject.parent;

            // after drilling up, check if everything at this level is selected
            this.displayState.allSelected = this.isPageFullySelected();
        };

        this.partiallySelect = function partiallySelect(option) {
            if (this.isSelected(option)) {
                this.removeFromDisplay(option);
            }

            this.displayState.partiallySelected[option.key] = option;
        };

        this.addToDisplay = function addToDisplay(option) {
            if (this.isPartiallySelected(option)) {
                this.removePartialSelection(option);
            }

            this.displayState.selected[option.key] = option;
            this.updateAllSelected();
        };

        this.removeFromDisplay = function removeFromDisplay(option) {
            if (this.isPartiallySelected(option)) {
                this.removePartialSelection(option);
            }

            // for city, the option.key is an UUID. it is not the same as the key in the selected list.
            delete this.displayState.selected[option.name];
            delete this.displayState.selected[option.key];
            this.displayState.allSelected = false;
        };

        this.updateRecentDisplay = function updateRecentDisplay() {
            this.displayState.selectedCount = this.getQuerySelectionCount();
            if (this.displayState.selectedCount === 0) {
                this.displayState.selectionDisplay = '';
            } else if (this.displayState.selectedCount === 1) {
                this.displayState.selectionDisplay = this.getQuerySelections()[0].display;
            } else {
                this.displayState.selectionDisplay = this.name;
            }
        };

        this.select = function select(option) {
            this.addQuerySelection(option);
            this.addToDisplay(option);
            this.updateRecentDisplay();
        };

        this.deselect = function deselect(option) {
            this.removeQuerySelection(option);
            this.removeFromDisplay(option);
            this.updateRecentDisplay();
        };

        this.findQuerySelection = function findQuerySelection(option) {
            var found = -1;

            this.querySelections.some(function (querySelection, index) {
                if ((querySelection.key === option.key || querySelection.key === option.name) && querySelection.level === option.level) {
                    found = index;
                    return true;
                }
            });

            return found;
        };

        this.addQuerySelection = function addQuerySelection(option, forceAdd) {
            var alreadySelectedAt = -1,
                ancestorSelected = false;

            ancestorSelected = this.querySelections.some(function (querySelection, index) {
                if (querySelection.key === option.key && querySelection.level === option.level) {
                    alreadySelectedAt = index;
                }

                if (querySelection.key === option[querySelection.level]) {
                    return true;
                }
            });

            // only add if not already selected & ancestor not selected
            if (alreadySelectedAt < 0 && !ancestorSelected) {
                this.querySelections.push(option);
            }

            // trying to add the children when drilling down the tree
            if (forceAdd && !this.isSelected(option)) {
                this.querySelections.push(option);
            }

            // deselect any descendants
            this.querySelections = this.querySelections.filter(function (querySelection) {
                return querySelection[option.level] !== option.key;
            });
        };

        this.removeQuerySelection = function removeQuerySelection(option) {
            var foundAt;

            // strip all desendants & ancestors
            this.querySelections = this.querySelections.filter(function (querySelection) {
                // deselect any descendants
                if (querySelection[option.level] === option.key) {
                    return false;
                }

                // deselect parent regions
                if (option.region === querySelection.key) {
                    return false;
                }

                // deselect parent countries
                if (option.country === querySelection.key) {
                    return false;
                }

                return true;
            });

            // if this page was fully selected, add all current options
            if (this.isPageFullySelected()) {
                this.currentOptions.forEach(function (option) {
                    this.addQuerySelection(option);
                }, this);
            }

            // strip out the deselected option
            foundAt = this.findQuerySelection(option);
            if (foundAt >= 0) {
                this.querySelections.splice(foundAt, 1);
            }
        };

        this.snapshotState = function snapshotState() {
            this.previousState = {
                display: angular.copy(this.displayState),
                selection: angular.copy(this.querySelections)
            };
        };

        this.rollback = function rollback() {
            this.displayState = this.previousState.display;
            this.querySelections = this.previousState.selection;
            this.previousState = {};
        };

        this.reset = function reset() {
            this.querySelections = [];
            this.init();
        };

        this.getSelectedChildCount = function getSelectedChildCount(parent) {
            var parentKey = parent.key,
                parentLevel = parent.level,
                childCount = 0;

            this.querySelections.forEach(function (querySelection) {
                if (querySelection[parentLevel] === parentKey) {
                    childCount++;
                }
            });

            return childCount;
        };

        this.updateCurrentOptions = function updateCurrentOptions(options) {
            var childCounts = {};

            this.currentOptions = options;

            function _createChildCountObject(country) {
                childCounts[country] = {
                    selectedRegions: 0,
                    selectedCities: 0
                };
            }

            if (this.querySelections.length) {
                this.querySelections.forEach(function (querySelection) {
                    switch (querySelection.level.toLowerCase()) {
                        case 'region':
                            if (!childCounts[querySelection.country]) {
                                _createChildCountObject(querySelection.country);
                            }

                            childCounts[querySelection.country].selectedRegions++;
                            break;
                        case 'city':
                            if (!childCounts[querySelection.country]) {
                                _createChildCountObject(querySelection.country);
                            }

                            childCounts[querySelection.country].selectedCities++;
                            break;
                        default:
                            break;
                    }
                });

                this.currentOptions.forEach(function (countryOption) {
                    var countryKey = countryOption.key;

                    if (!this.isSelected(countryOption) && childCounts[countryKey]) {
                        if (childCounts[countryKey].selectedRegions >= countryOption.children.length) {
                            this.addToDisplay(countryOption);
                        } else if (childCounts[countryKey].selectedRegions > 0) {
                            this.partiallySelect(countryOption);
                        } else if (childCounts[countryKey].selectedCities > 0) {
                            this.partiallySelect(countryOption);
                        }
                    }
                }, this);
            }
        };

        this.isSelected = function isSelected(option) {
            if (this.displayState.selected[option.key]) {
                if (option.parentKey) {
                    return this.displayState.selected[option.key].parentKey === option.parentKey;
                }
                return true;
            } else if (this.displayState.selected[option.name]) {
                if (option.parentKey) {
                    return this.displayState.selected[option.name].parentKey === option.parentKey;
                }
                return true;
            }
            return false;
        };
    }

    LocationSelectionFactory.prototype = Object.create(FilterSelectionFactory.prototype);

    return LocationSelectionFactory;
}]).factory('BeatSelectionFactory', ['FilterSelectionFactory', function (FilterSelectionFactory) {
    'use strict';

    function BeatSelectionFactory(name) {
        FilterSelectionFactory.call(this, name);

        this.keyScheme = function keyScheme(option) {
            var key = option.key;
            if (option.parentKey) {
                key += option.parentKey;
            }
            return key;
        };

        this.isSelected = function isSelected(option) {
            return !!this.displayState.selected[this.keyScheme(option)];
        };

        this.updateRecentDisplay = function updateRecentDisplay() {
            var selection;

            this.displayState.selectedCount = this.selectedCurrentOptionCount();
            if (this.displayState.selectedCount === 0) {
                this.displayState.selectionDisplay = '';
            } else if (this.displayState.selectedCount === 1) {
                // the count will come back with 1, but the array may have parent and child
                // need to loop through to display only the child
                selection = Object.values(this.displayState.selected);
                for (var i = 0; i < selection.length; i++) {
                    if (!this.hasChildren(selection[i])) {
                        this.displayState.selectionDisplay = selection[i].display;
                    }
                }
            } else {
                this.displayState.selectionDisplay = this.name;
            }
        };

        this.select = function select(option, updateAncestors) {
            if (this.isPartiallySelected(option)) {
                this.removePartialSelection(option);
            }

            this.displayState.selected[this.keyScheme(option)] = option;

            this.updateAllSelected();

            if (option.children) {
                option.children.forEach(function (childOption) {
                    this.displayState.selected[this.keyScheme(childOption)] = childOption;
                }, this);
            }

            if (updateAncestors) {
                this.updateAncestors(option);
            }
            this.updateRecentDisplay();
        };

        this.deselect = function deselect(option, updateAncestors) {
            if (this.isPartiallySelected(option)) {
                this.removePartialSelection(option);
            }

            delete this.displayState.selected[this.keyScheme(option)];

            this.displayState.allSelected = false;

            if (option.children) {
                option.children.forEach(function (childOption) {
                    delete this.displayState.selected[this.keyScheme(childOption)];
                }, this);
            }

            if (updateAncestors) {
                this.updateAncestors(option);
            }
            this.updateRecentDisplay();
        };
    }

    BeatSelectionFactory.prototype = Object.create(FilterSelectionFactory.prototype);

    return BeatSelectionFactory;
}]);
'use strict';

angular.module('MW.Influencers.AlertController', ['MW.Influencers.IcmDialogService', 'MW.Framework.AppChromeService', 'ngCookies']).controller('AlertCtrl', ['$location', '$scope', 'DialogService', '$timeout', '$sce', 'AppChromeService', '$cookies', function ($location, $scope, DialogService, $timeout, $sce, AppChromeService, $cookies) {
    $scope.alerts = DialogService.flashMessages;

    $scope.$watch('alerts', function scopeWatchAlerts() {
        angular.forEach($scope.alerts, function (alert) {
            if (typeof alert.html !== 'undefined') {
                return;
            }

            alert.html = alert.text;

            if (alert.timeout > 0) {
                alert.timeoutId = $timeout(function onTimeout() {
                    $scope.removeAlert(alert);
                }, alert.timeout * 1000);
            }
        });
    }, true);

    $scope.appChromeService = AppChromeService.getCurrentModel();

    $scope.removeAlert = function (alert) {
        var idx = $.inArray(alert, $scope.alerts);
        if (idx > -1) {
            if (alert.persistDismissInSession) {
                $cookies.put('mw_' + alert.uniqueId, 1);
            }
            $scope.alerts.splice(idx, 1);
        }
    };

    $scope.$on('$routeChangeSuccess', function ($event, newRoute) {
        angular.forEach($scope.alerts, function (alert, index) {
            if (alert.hideOnPageChange) {
                $scope.alerts.splice(index, 1);
                if (typeof alert.timeoutId !== 'undefined') {
                    $timeout.cancel(alert.timeoutId);
                }
            }
        });

        $scope.isPageChromeless = newRoute && newRoute.$$route && newRoute.$$route.isChromeless ? true : false;
    });
}]).directive('compile', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(function (scope) {
            // watch the 'compile' expression for changes
            return scope.$eval(attrs.compile);
        }, function (value) {
            // when the 'compile' expression changes
            // assign it into the current DOM
            element.html(value);

            // compile the new DOM and link it to the current
            // scope.
            // NOTE: we only compile .childNodes so that
            // we don't get into infinite loop compiling ourselves
            $compile(element.contents())(scope);
        });
    };
}]);
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactLandingController', ['MW.ContactManager.ContactManagerNavigationService', 'MW.Influencers.CardButton', 'MW.Influencers.ActionBarService', 'ngMaterial']).controller('ContactLandingController', ['$scope', '$translate', 'ContactManagerNavigationService', 'ActionBarService', ContactLandingController]);

    function ContactLandingController($scope, $translate, ContactManagerNavigationService, ActionBarService) {
        this.$translate = $translate;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.ActionBarService = ActionBarService;
        this.title = this.$translate.instant('icm-contact-add-landing__title');
        this.importContactCardTitle = this.$translate.instant('icm-contact-add-landing__import-contact--title');
        this.importContactCardBody = this.$translate.instant('icm-contact-add-landing__import-contact--body');
        this.createContactCardTitle = this.$translate.instant('icm-contact-add-landing__create-contact--title');
        this.createContactCardBody = this.$translate.instant('icm-contact-add-landing__create-contact--body');

        this.ActionBarService.registerTitle(this.$translate.instant('icm-contact-add-landing__breadcrumb-title'));
        this.ActionBarService.setBackButtonVisibility(true);

        this.setCardTooltips = function setCardTooltips() {
            angular.element('mw-card-button#importContact > md-card').attr('title', this.importContactCardTitle);
            angular.element('mw-card-button#createContact > md-card').attr('title', this.createContactCardTitle);
        };
        this.setCardTooltips();
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerAddController', ['MW.ContactManager.ContactManagerNavigationService']).controller('ContactManagerAddController', ['ContactManagerNavigationService', 'breadcrumbs', 'isInfluencerDatabaseEntitled', ContactManagerAddController]);

    function ContactManagerAddController(ContactManagerNavigationService, breadcrumbs, isInfluencerDatabaseEntitled) {
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.breadcrumbs = breadcrumbs;
        this.isInfluencerDatabaseEntitled = isInfluencerDatabaseEntitled;
    }

    ContactManagerAddController.prototype.importContacts = function importContacts() {
        this.ContactManagerNavigationService.goToImport();
    };

    ContactManagerAddController.prototype.manuallyCreate = function manuallyCreate() {
        this.ContactManagerNavigationService.goToCreate();
    };

    ContactManagerAddController.prototype.goToSearch = function goToSearch() {
        this.ContactManagerNavigationService.goToSearch();
    };

    ContactManagerAddController.prototype.searchByKeywordForContacts = function searchByKeywordForContacts() {
        this.ContactManagerNavigationService.goToKeywordSearch();
    };

    ContactManagerAddController.prototype.searchDirectoryForContacts = function searchDirectoryForContacts() {
        this.ContactManagerNavigationService.goToDirectorySearch();
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerFormController', ['MW.Framework.InfluencerContactService', 'MW.ContactManager.ContactManagerNavigationService', 'MW.ContactManager.ContactManagerPropertyTypeService', 'MW.Framework.inputCancel', 'MW.ContactManager.ContactManagerFlashService', 'MW.Influencers.IcmDialogService', 'MW.Framework.TranslationService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Influencers.AnalyticsService', 'MW.CustomValidation', 'MW.ContactManager.ActiveOnFormDropdown', 'MW.Framework.PageStateService', 'MW.Framework.ValidationConstants', 'MW.Framework.ContentStreamDataFactory', 'ui.bootstrap']).controller('ContactManagerFormController', ['InfluencerContactService', 'ContactManagerNavigationService', 'salutationTypes', 'emailTypes', 'phoneNumberTypes', 'addressTypes', 'activeOnTypes', 'breadcrumbs', 'contact', 'ContactManagerFlashService', 'ContactManagerUsernameService', 'DialogService', 'translationService', 'CoreUserService', 'CoreCompanyService', 'AnalyticsService', '$rootScope', '$scope', '$location', '$timeout', '$window', '$mdDialog', '$translate', '$q', 'PageStateService', 'VALIDATION_CONSTANTS', 'SourceStreamDataFactory', ContactManagerFormController]);

    function ContactManagerFormController(InfluencerContactService, ContactManagerNavigationService, salutationTypes, emailTypes, phoneNumberTypes, addressTypes, activeOnTypes, breadcrumbs, contact, ContactManagerFlashService, FormValidationService, DialogService, translationService, CoreUserService, CoreCompanyService, AnalyticsService, $rootScope, $scope, $location, $timeout, $window, $mdDialog, $translate, $q, PageStateService, VALIDATION_CONSTANTS, SourceStreamDataFactory) {

        this.contact = contact;
        this.breadcrumbs = breadcrumbs;
        this.isSaving = false;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.salutationTypes = salutationTypes;
        this.emailTypes = emailTypes;
        this.phoneNumberTypes = phoneNumberTypes;
        this.addressTypes = addressTypes;
        this.activeOnTypes = activeOnTypes;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.PageStateService = PageStateService;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$scope = $scope;
        this.$q = $q;
        this.DialogService = DialogService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.validateEmailRegex = VALIDATION_CONSTANTS.EMAIL_REGEX;
        this.validatePhoneNumberRegex = VALIDATION_CONSTANTS.PHONE_NUMBER_REGEX;
        this.validateUrlRegex = VALIDATION_CONSTANTS.URL_REGEX;
        this.$window = $window;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.activeonChannelCount = 0;

        this.SourceStreamDataFactory = new SourceStreamDataFactory();

        if (this.contact) {
            if (this.contact.channels && 0 === this.contact.channels.length) {
                this.contact.channels.push({ type: translationService.getLocalizedString('Twitter') });
            } else {
                this.contact.channels = this.extractSources(this.contact.channels);
            }
            if (this.contact.title && 0 === this.contact.title.length) {
                this.contact.title.push('');
            }
        }

        // Preventing Navigation during editing
        this.onRouteChangeOff = $rootScope.$on('$locationChangeStart', function routeChangeStartEvent(event, nextUrl, prevUrl) {
            var dialogTitle = translationService.getLocalizedString('Leave Page?'),
                dialogContent = translationService.getLocalizedString('You are about to leave the page. Any unsaved changes will be lost.');
            // need to handle navigating within & outside of application
            function continueNavigation() {
                var previousURI = URI(prevUrl),
                    navigateToURI = URI(nextUrl);
                if (previousURI.host() === navigateToURI.host()) {
                    $location.path(navigateToURI.path());
                } else {
                    $window.location.href = navigateToURI.toString();
                }
            }
            if ($scope && $scope.contactForm && $scope.contactForm.$dirty) {
                event.preventDefault();
                if ($scope.contactForm.$invalid) {
                    this.DialogService.confirm(dialogContent, dialogTitle, function confirmLeavePageCallback(result) {
                        // Page leaving with invalid form should not have the save button.
                        if (result.success) {
                            this.onRouteChangeOff();
                            continueNavigation();
                        }
                    }.bind(this));
                } else {
                    this.DialogService.confirmExit(null, null, function confirmExitLeavePageCallback(result) {
                        if (result.success) {
                            if (result.successDetail !== 'abandon') {
                                this.confirmAdd(false, null).then(function () {
                                    this.onRouteChangeOff();
                                    continueNavigation();
                                }.bind(this)).catch(function () {});
                            } else {
                                this.onRouteChangeOff();
                                continueNavigation();
                            }
                        }
                    }.bind(this));
                }
            }
        }.bind(this));

        $scope.$on('toggleDropdownMenuDirective', function () {
            $scope.contactForm.$setDirty();
        });
    }

    ContactManagerFormController.prototype.extractSources = function extractSources(channels) {
        var channelList = [];

        (channels || []).forEach(function (channel) {
            if (channel.type === this.activeOnTypes.SOURCE) {
                channelList.push({
                    'type': channel.type,
                    'source': !channel.id ? channel.name : { 'source': channel, 'id': channel.id, 'name': channel.name }
                });
            } else {
                channelList.push(channel);
            }
        }.bind(this));

        return channelList;
    };

    ContactManagerFormController.prototype.watchSourceInput = function watchSourceInput(index) {
        this.$scope.$watch(angular.bind(this, function () {
            return this.contact.channels[index].source;
        }), this.getSources);
    };

    ContactManagerFormController.prototype.getSources = function getSources(query) {
        var searchQuery = { q: query, filters: [{ 'type': 'sourceType', 'values': ['edition'] }], aggregations: [], pageSize: 20, page: 0 };
        return this.SourceStreamDataFactory.aggregateSearch(searchQuery).then(function (response) {
            this.sourceAutocompleteList = [];
            (response.hits || []).forEach(function (source) {
                this.sourceAutocompleteList.push({
                    id: source.id,
                    name: source.name,
                    source: source
                });
            }, this);
            return this.sourceAutocompleteList;
        }.bind(this)).catch(function () {});
    };

    ContactManagerFormController.prototype.cancel = function cancel() {
        this.onRouteChangeOff();

        if (this.$location.path().indexOf('/influencers/contact/create') > -1) {
            this.ContactManagerNavigationService.goToContactAddLanding();
        } else if (this.$location.path().indexOf('/influencers/contact/edit') > -1) {
            var pathArray = this.$location.path().split('/');
            this.ContactManagerNavigationService.goToProfileView(pathArray[pathArray.length - 1]);
        } else {
            this.ContactManagerNavigationService.goToList();
        }
    };

    ContactManagerFormController.prototype.confirmAdd = function confirmAdd(saveSubmittedForm, ev) {
        if (this.contact.id) {
            // skip for editing contact
            return this.$q.when(this.saveContact(saveSubmittedForm));
        } else {
            var confirmMessage = this.$translate.instant('icm-web__data-controller--add-contact-msg'),
                okButton = this.$translate.instant('Ok'),
                cancelButton = this.$translate.instant('Cancel');

            return this.$q(function (resolve) {
                var _this = this;

                this.$mdDialog.show(this.$mdDialog.mwConfirm().textContent(confirmMessage).ok(okButton).cancel(cancelButton).targetEvent(ev)).then(function () {
                    return resolve(_this.saveContact(saveSubmittedForm));
                }, function () {
                    return resolve();
                });
            }.bind(this));
        }
    };

    ContactManagerFormController.prototype.saveContact = function saveContact(saveSubmittedForm) {
        var defer = this.$q.defer();
        this.isSaving = true;
        this.InfluencerContactService.saveContact(this.contact).then(function (contactResponse) {
            contactResponse.contact.notes = this.contact.notes;
            this.ContactManagerFlashService.flashSuccess(contactResponse.message);
            this.trackEvent('add_contact');
            if (saveSubmittedForm === true) {
                this.InfluencerContactService.setCurrentContact(contactResponse.contact);
                this.ContactManagerNavigationService.goToProfileView(contactResponse.contact.id);
            }
            defer.resolve();
        }.bind(this)).catch(function (err) {
            var _this2 = this;

            if (err && err.error && err.error.reason && err.error.reason === 'MISMATCH_COMPANIES') {
                this.$mdDialog.show(this.$mdDialog.mwAlert().title(this.$translate.instant('icm-contact__create-multi-company-warning-modal--header')).htmlContent(this.$translate.instant('icm-contact__create-multi-company-warning-modal--body-string-1') + '<br><br>' + this.$translate.instant('icm-contact__create-multi-company-warning-modal--body-string-2')).ok('OK')).then(function () {
                    _this2.status = 'Alert Closed';
                });
            } else {
                this.ContactManagerFlashService.flashError(err);
            }
            this.isSaving = false;
            defer.resolve(err);
        }.bind(this)).finally(function () {
            this.onRouteChangeOff();
        }.bind(this));
        return defer.promise;
    };

    ContactManagerFormController.prototype.deleteContact = function deleteContact() {
        var self = this;

        this.DialogService.confirm('Are you sure you want to delete the current Contact?', 'Delete Contact?', {
            callback: function deleteContactCallback(details) {
                // only attempt to delete if user accepted the warning
                if (details.success) {
                    self.InfluencerContactService.deleteContact(self.contact.id).then(function (response) {
                        self.ContactManagerFlashService.flashSuccess(response.message);
                        self.ContactManagerNavigationService.goToList();
                        self.trackEvent('remove_contact');
                    }).catch(function (err) {
                        self.ContactManagerFlashService.flashError(err);
                    });
                }
            }
        });
    };

    ContactManagerFormController.prototype.profilePicChanged = function profilePicChanged(profilePic) {
        this.contact.profilePic = profilePic;
    };

    ContactManagerFormController.prototype.addNewRow = function (type, collection) {
        collection.push({ type: type });

        if (typeof type === 'undefined') {
            //A case where activeOn row is added
            this.$timeout(function () {
                this.$window.scrollTo(0, document.body.scrollHeight);
            }.bind(this), 0);
        }
    };

    ContactManagerFormController.prototype.addNewEntryRow = function (collection) {
        collection.push('');
    };

    ContactManagerFormController.prototype.removeItemFromCollection = function removeItemFromCollection(index, collection) {
        collection.splice(index, 1);
        //making form dirty implicitly on deletion of collection
        this.$scope.contactForm.$dirty = true;
    };

    ContactManagerFormController.prototype.activeOnChanged = function activeOnChanged(index, selectedType) {
        this.contact.channels[index] = {
            type: selectedType
        };
    };

    ContactManagerFormController.prototype.trackEvent = function trackEvent(eventName) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: eventName,
                mediaListId: 'All Contacts',
                contactCount: 1,
                parentType: 'ICM_contact_lists',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            this.AnalyticsService.trackMediaListOperation(eventName, trackingData);
        }.bind(this));
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactHistoryTableController', ['MW.Framework.InfluencerContactService', 'MW.Framework.CoreGridDefinition', 'MW.Framework.CoreGridSelectableService', 'MW.ContactManager.ContactManagerFlashService', 'MW.Influencers.IcmDialogService', 'MW.ContactManager.OutreachListFactory', 'MW.Framework.MomentService', 'MW.Framework.ICMEmailService', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Influencers.ActivityService']).controller('ContactHistoryTableController', ['breadcrumbs', 'InfluencerContactService', 'CoreGridDefinition', '$routeParams', 'CoreGridSelectableService', 'DialogService', '$translate', 'ContactManagerFlashService', 'ICMEmailService', 'OutreachListFactory', '$location', '$filter', 'moment', 'ContactManagerNavigationService', 'ActivityService', ContactHistoryTableController]);

    function ContactHistoryTableController(breadcrumbs, InfluencerContactService, CoreGridDefinition, $routeParams, CoreGridSelectableService, DialogService, $translate, ContactManagerFlashService, ICMEmailService, OutreachListFactory, $location, $filter, moment, ContactManagerNavigationService, ActivityService) {
        this.ActivityService = ActivityService;

        this.$filter = $filter;
        this.moment = moment;
        this.$translate = $translate;
        this.breadcrumbs = breadcrumbs;
        this.$routeParams = $routeParams;
        this.CoreGridDefinition = CoreGridDefinition;
        this.InfluencerContactService = InfluencerContactService;
        this.CoreGridSelectableService = CoreGridSelectableService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.ICMEmailService = ICMEmailService;
        this.OutreachListFactory = new OutreachListFactory();
        this.DialogService = DialogService;
        this.$location = $location;
        this.emailEmptyStateVisible = false;
        this.defaultErrorMessage = this.$translate.instant('Something has gone wrong behind the scenes. Please try again later.');
        this.ContactManagerNavigationService = ContactManagerNavigationService;

        this.coreGridNotesConfig = {}; // Notes grid definition
        this.contactEmailCollection = []; // Email collection
        this.coreGridEmailConfig = {}; // Email grid definition

        if ($routeParams.typeVal && $routeParams.typeVal.toLowerCase() === 'notes') {
            this.isNotesView = true;
            this.isEmailView = false;
        } else if ($routeParams.typeVal && $routeParams.typeVal.toLowerCase() === 'email') {
            this.isNotesView = false;
            this.isEmailView = true;
        }

        InfluencerContactService.getContactById($routeParams.contactId).then(function (response) {
            var contactName;
            this.contactNotesCollection = [];
            this.contact = response;
            this.getNotes(this.contact.id);
            if (this.contact.name && this.contact.name.middleName && this.contact.name.middleName !== 'undefined') {
                contactName = this.contact.name.firstName + ' ' + this.contact.name.middleName + ' ' + this.contact.name.lastName;
            } else {
                contactName = this.contact.name.firstName + ' ' + this.contact.name.lastName;
            }
            this.tableTitle = this.$translate.instant('Contact History with') + ' ' + contactName;
            // Loading outreach emails for current contact
            this.contactEmailAddress = this.contact.contactInfo.email[0].address; // This is required to fetch outreach emails only for this contact
            this.getAllEmails();
        }.bind(this)).catch(function () {
            this.DialogService.flashError(this.defaultErrorMessage);
        }.bind(this));

        this.isButtonDisabled = function isButtonDisabled() {
            var isDisabled = true;
            if (this.contact !== undefined && this.contact.notes !== undefined) {
                isDisabled = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)).length > 0 && this.isNotesView ? false : true;
            }
            return isDisabled;
        }.bind(this);

        // Define the core grid configuration for the ICM Notes list.
        var historyTableCoreGridConfig = {
            dataItemIdProperty: 'notesId',
            headerTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'created',
                descending: true,
                conditionalSort: function conditionalSort(sortField) {
                    if (sortField === 'created') {
                        return 'modifiedTimeStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [{
                name: 'Delete',
                isDisabled: this.isButtonDisabled,
                callback: function () {
                    this.deleteNotesHandler();
                }.bind(this)
            }],
            columnDefinitions: [{
                name: 'Type',
                dataKey: 'typeDisplay',
                options: {
                    defaultValue: 'note',
                    class: 'collectionType',
                    sortable: true,
                    searchable: true
                }
            }, {
                name: 'SUBJECT',
                dataKey: 'subjectBackup',
                options: {
                    class: 'collectionSubject',
                    columnDataTemplateUrl: 'icm-web/views/partials/notes_subject_column',
                    clickable: true,
                    onClick: function (dataItem) {
                        this.editActivity(dataItem);
                    }.bind(this)
                }
            }, {
                name: 'DATE',
                dataKey: 'created',
                options: {
                    class: 'collectionDate',
                    sortable: true
                }
            }],
            selectable: {
                singleSelect: false,
                enabled: true,
                selected: []
            },
            searchable: {
                enabled: false
            }
        };

        // change the class to change the width of the column
        historyTableCoreGridConfig.columnDefinitions[1].options.class = 'activityCollectionSubject';
        historyTableCoreGridConfig.columnDefinitions.push({
            name: 'icm-web__contact-profile--activity-table-column-author',
            dataKey: 'authorName',
            options: {
                defaultValue: '',
                class: 'activityAuthor',
                sortable: true,
                searchable: true
            }
        });
        // this injects the author into the 3rd position of the array (before date)
        historyTableCoreGridConfig.columnDefinitions.splice(2, 0, historyTableCoreGridConfig.columnDefinitions.splice(3, 1)[0]);

        // Load the core grid configuration for notes on Contact History page
        this.coreGridNotesConfig = this.CoreGridDefinition.build(historyTableCoreGridConfig);

        // Define the core grid configuration for the outreach list.
        var historyTableEmailCoreGridConfig = {
            dataItemIdProperty: '_id',
            headerTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'name',
                descending: false,
                backendSorting: false,
                conditionalSort: function conditionalSort(sortField) {
                    if (sortField === 'scheduledDate') {
                        return 'scheduledDateStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [],
            columnDefinitions: [{
                name: 'TYPE',
                dataKey: 'type',
                options: {
                    defaultValue: 'email',
                    class: 'collectionType',
                    sortable: false
                }
            }, {
                name: 'SUBJECT',
                dataKey: 'subject',
                options: {
                    class: 'collectionSubject',
                    clickable: false,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_subject_column',
                    defaultValue: this.$translate.instant('No Recipients'),
                    clickCallback: function clickCallback(route) {
                        this.ICMEmailService.getIcmApprovedSenders().then(function () {
                            this.$location.url(route);
                        }.bind(this)).catch(function (error) {
                            if (error) {
                                this.showUnapprovedDialog();
                            } else {
                                this.DialogService.flashError(this.defaultErrorMessage);
                            }
                        }.bind(this));
                    }.bind(this)
                }
            }, {
                name: 'From',
                dataKey: 'approvedSender.name',
                options: {
                    class: 'collectionFrom',
                    sortable: true,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_from_column'
                }
            }, {
                name: 'STATUS',
                dataKey: 'status',
                options: {
                    class: 'collectionStatus',
                    sortable: true,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_status_column'
                }
            }, {
                name: 'Date', //This is lower case to match en.json
                dataKey: 'scheduledDate',
                options: {
                    class: 'collectionDate',
                    sortable: true,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_date_column',
                    defaultValue: this.$translate.instant('N/A')
                }
            }],
            selectable: {
                enabled: false,
                selected: [],
                singleSelect: false
            },
            searchable: {
                enabled: false,
                predictionFields: [],
                searchTerms: []
            }
        };
        // Load the core grid configuration for emails on Contact History page to use
        this.coreGridEmailConfig = this.CoreGridDefinition.build(historyTableEmailCoreGridConfig);
    }

    ContactHistoryTableController.prototype.toggleNotesEmailView = function toggleNotesEmailView() {
        this.isNotesView = !this.isNotesView;
        this.isEmailView = !this.isEmailView;
    };

    ContactHistoryTableController.prototype.getAllEmails = function getAllEmails(sortField, sortOrder) {
        var contactId = this.contact && this.contact.id ? this.contact.id : null,
            emailAddressArray = [];

        if (this.contact && this.contact.contactInfo && Array.isArray(this.contact.contactInfo.email) && this.contact.contactInfo.email.length) {
            this.contact.contactInfo.email.forEach(function (emailAddressObject) {
                if (emailAddressObject.address && typeof emailAddressObject.address === 'string' && emailAddressObject.address.length) {
                    emailAddressArray.push(emailAddressObject.address);
                }
            });
        }

        // Get all outreach emails list
        if (contactId || emailAddressArray.length) {
            this.OutreachListFactory.getAllEmails(contactId, emailAddressArray, sortField, sortOrder).then(function getAllEmailsSuccess(response) {
                if (response) {
                    this.contactEmailCollection = response.hits;
                    this.emailEmptyStateVisible = this.contactEmailCollection.length > 0 ? false : true;
                }
            }.bind(this));
        } else {
            this.emailEmptyStateVisible = true;
        }
    };

    ContactHistoryTableController.prototype.formatNotes = function formatNotes(notes) {
        var newNotesArray = [],
            sortedNotes;

        if (Array.isArray(notes) && notes.length) {
            sortedNotes = this.$filter('orderBy')(notes, 'modifiedAt', 'desc');
            sortedNotes.forEach(function (note) {
                if (typeof note.note === 'string' && note.note.length) {
                    if (typeof note.subject !== 'string') {
                        note.subject = '';
                    }

                    newNotesArray.push({
                        notesId: note.id,
                        typeDisplay: note.type ? this.ActivityService.translateActivityType(note.type) : this.ActivityService.translateActivityType('note'),
                        type: note.type || 'note',
                        subject: note.subject,
                        subjectBackup: note.subject || note.note.substring(0, 240),
                        note: note.note,
                        date: note.date,
                        authorName: note.createdBy && note.createdBy.firstName && note.createdBy.lastName ? note.createdBy.firstName + ' ' + note.createdBy.lastName : '',
                        createdBy: note.createdBy,
                        updatedBy: note.updatedBy,
                        created: this.$filter('mwConvertDateToUserTimezone')(note.modifiedAt, 'mediumDate'),
                        createdAt: note.createdAt,
                        modifiedAt: note.modifiedAt,
                        modifiedTimeStamp: this.moment.utc(note.modifiedAt).format('X')
                    });
                }
            }.bind(this));
        }

        return newNotesArray;
    };

    ContactHistoryTableController.prototype.onNotesUpdated = function onNotesUpdated(notePromise) {
        notePromise.then(function () {
            this.InfluencerContactService.getContactById(this.contact.id).then(function (response) {
                this.contact = response;
                this.getNotes(this.contact.id);
                this.ContactManagerFlashService.flashSuccess('Success. Your contact has been updated.');
            }.bind(this));
        }.bind(this)).catch(function (error) {
            if (error.message === 'Add failed') {
                this.contactNotesCollection.shift();
            }
            this.ContactManagerFlashService.flashError(error);
        }.bind(this));
    };

    ContactHistoryTableController.prototype.getNotes = function getNotes(contactId) {
        // retrieve notes for the contact. since we dont return them for list views they dont get cached in the InfluencerContactService
        this.InfluencerContactService.getNotes(contactId).then(function (notes) {
            this.contact.notes = notes;
            this.contactNotesCollection = this.formatNotes(notes);
        }.bind(this)).catch(function () {
            this.DialogService.flashError('Failed retrieving notes');
        }.bind(this));
    };

    ContactHistoryTableController.prototype.addActivity = function addActivity() {
        var createActivityPromise = this.ActivityService.createActivity(this.contact.id);
        this.onNotesUpdated(createActivityPromise);
    };

    ContactHistoryTableController.prototype.editActivity = function editActivity(oldNote) {
        var updateActivityPromise = this.ActivityService.updateActivity(this.contact.id, oldNote);
        this.onNotesUpdated(updateActivityPromise);
    };

    ContactHistoryTableController.prototype.deleteNotesHandler = function deleteNotesHandler() {
        var confirmMessageText = this.$translate.instant('Are you sure you want to delete the selected note(s)?'),
            confirmMessageTitle = this.$translate.instant('Delete note(s)?');

        this.DialogService.confirm(confirmMessageText, confirmMessageTitle, function (payload) {
            if (payload.success) {
                var selectedNotes = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)),
                    notesToDelete = [];

                if (selectedNotes.length > 0) {
                    this.CoreGridSelectableService.deleteAllInSelected(this.coreGridNotesConfig);

                    notesToDelete = selectedNotes.map(function (selectedNote) {
                        return selectedNote.notesId;
                    });

                    this.onNotesUpdated(this.InfluencerContactService.deleteNotes(this.contact.id, notesToDelete));
                }
            }
        }.bind(this));
    };

    ContactHistoryTableController.prototype.showUnapprovedDialog = function () {
        var dialogTitle = this.$translate.instant('Compose Email'),
            callback = function callback() {
            this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
        }.bind(this);
        this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, callback);
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerIcmEnquiryController', ['MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService']).controller('ContactManagerIcmEnquiryController', ['CoreUserService', 'CoreCompanyService', ContactManagerIcmEnquiryController]);

    function ContactManagerIcmEnquiryController(CoreUserService, CoreCompanyService) {
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.CoreUserService.getCurrent(true).then(function afterGetCurrent(currentUser) {
            var userFirstName = currentUser.firstName ? currentUser.firstName.charAt(0).toUpperCase() + currentUser.firstName.substr(1) : '',
                userLastName = currentUser.lastName ? currentUser.lastName.charAt(0).toUpperCase() : '',
                currentCompanyName = this.CoreCompanyService.getName();
            this.user = {
                name: userFirstName + ' ' + userLastName + '.',
                activeCompanyName: currentCompanyName,
                email: currentUser.email
            };
        }.bind(this));
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerImportController', ['MW.ContactManager.CsvSelector', 'MW.ContactManager.AutoDownloader', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.InfluencerContactService', 'MW.ContactManager.ContactManagerFlashService', 'MW.CoreStream.ContactManagerTagService', 'MW.CoreStream.ContactTagsList', 'MW.Influencers.AnalyticsService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'Configuration', 'ngMaterial']).controller('ContactManagerImportController', ['$scope', '$translate', '$mdDialog', 'breadcrumbs', 'ContactManagerNavigationService', 'InfluencerContactService', 'CONTACT_MANAGER_TEMPLATE_URL', 'ContactManagerFlashService', 'companyId', 'ContactManagerTagService', 'AnalyticsService', 'CoreUserService', 'CoreCompanyService', '$q', ContactManagerImportController]);

    function ContactManagerImportController($scope, $translate, $mdDialog, breadcrumbs, ContactManagerNavigationService, InfluencerContactService, CONTACT_MANAGER_TEMPLATE_URL, ContactManagerFlashService, companyId, ContactManagerTagService, AnalyticsService, CoreUserService, CoreCompanyService, $q) {
        this.$scope = $scope;
        this.$q = $q;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.breadcrumbs = breadcrumbs;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.fileContents = '';
        this.templateUrl = CONTACT_MANAGER_TEMPLATE_URL + '/contact/csv/comma';
        this.failedCsv = '';
        this.selectedMediaLists = [];
        this.companyId = companyId;
        this.enableImportButton = false;
        this.ContactManagerTagService = ContactManagerTagService;
        this.AnalyticsService = AnalyticsService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;

        this.setDescription(CONTACT_MANAGER_TEMPLATE_URL);
    }

    ContactManagerImportController.prototype.setDescription = function setDescription(templateRoot) {
        this.templateUrl1 = templateRoot + '/contact/csv/comma';
        this.templateUrl2 = templateRoot + '/contact/csv/semicolon';
        this.exampleUrl1 = 'https://en.wikipedia.org/wiki/Decimal_mark#Countries_using_Arabic_numerals_with_decimal_point';
        this.exampleUrl2 = 'https://en.wikipedia.org/wiki/Decimal_mark#Countries_using_Arabic_numerals_with_decimal_comma';
    };

    ContactManagerImportController.prototype.fileSelected = function fileSelected(fileContents) {
        this.fileContents = fileContents;
        this.$scope.$apply(); //re render this.fileContents to DOM
    };

    ContactManagerImportController.prototype.cancelImport = function cancelImport() {
        this.ContactManagerNavigationService.goToContactAddLanding();
    };

    ContactManagerImportController.prototype.confirmImport = function confirmImport(ev) {
        var _this = this;

        var confirmMessage = this.$translate.instant('icm-web__data-controller--import-contacts-msg'),
            okButton = this.$translate.instant('Ok'),
            cancelButton = this.$translate.instant('Cancel');

        this.$mdDialog.show(this.$mdDialog.mwConfirm().textContent(confirmMessage).ok(okButton).cancel(cancelButton).targetEvent(ev)).then(function () {
            _this.importCsv();
        }, function () {});
    };

    ContactManagerImportController.prototype.importCsv = function importCsv() {
        var self = this;
        this.enableImportButton = true;

        this.InfluencerContactService.importCsv(this.fileContents, this.selectedMediaLists).then(function (response) {
            self.ContactManagerFlashService.flashSuccess(response.message);
            self.ContactManagerNavigationService.goToList();
            self.trackEvent(response.payload);
        }).catch(function (response) {
            var error = response.error;
            // handle various error cases
            switch (error.reason) {
                case 'FAILED_CREATE':
                    self.ContactManagerFlashService.flashWarning('One or more contacts failed to import.');
                    // on a partial import we need to return a csv to the user
                    self.failedCsv = error.data;
                    self.ContactManagerNavigationService.goToList();
                    break;
                case 'INVALID_TEMPLATE':
                    var errorMessage = 'The CSV file does not appear to be valid. Please check that you are using our standard [[templateLink]].',
                        messageParams = {
                        templateLink: '<a class="flashErrorLink" target="_self" href="' + self.templateUrl + '">template</a>'
                    };

                    self.enableImportButton = false;
                    self.ContactManagerFlashService.flashError(null, errorMessage, messageParams);
                    break;
                default:
                    self.enableImportButton = false;
                    self.ContactManagerFlashService.flashError(null, 'Oops. Something went wrong. Please try importing your contacts again later.');
                    break;
            }
        });
    };

    ContactManagerImportController.prototype.trackEvent = function trackEvent(payload) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'import_contact',
                mediaListId: 'All Contacts',
                contactCount: payload.length,
                parentType: 'ICM_import_contacts',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            if (this.selectedMediaLists.length === 0) {
                this.AnalyticsService.trackMediaListOperation('import_contact', trackingData);
            } else {
                this.selectedMediaLists.forEach(function (list) {
                    trackingData.mediaListId = list;
                    this.AnalyticsService.trackMediaListOperation('import_contact', trackingData);
                }.bind(this));
            }
        }.bind(this));
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerInfluencerDatabaseUpsellController', []).controller('ContactManagerInfluencerDatabaseUpsellController', ['$translate', '$location', 'isInfluencerAppEntitled', ContactManagerInfluencerDatabaseUpsellController]);

    function ContactManagerInfluencerDatabaseUpsellController($translate, $location, isInfluencerAppEntitled) {
        this.$translate = $translate;
        this.$location = $location;

        this.pageTitle = this.$translate.instant('icm-web__upsell-page--title');
        this.pageDescription = this.$translate.instant('icm-web__upsell-page--description');
        this.pageFooter = this.$translate.instant('icm-web__upsell-page--footer').replace(/&gt;/g, '>').replace(/&lt;/g, '<');

        if (isInfluencerAppEntitled === true) {
            this.$location.url('/influencers/lists');
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerOutreachComposeController', ['MW.Framework.TranslationService', 'ngTagsInput', 'MW.Framework.ContentStreamDataFactory', 'MW.ContactManager.OutreachService', 'MW.Influencers.IcmUnsubscribeService', 'MW.Framework.TextFilters', 'MW.CoreStream.ContactManagerTagService', 'MW.Framework.FileModel', 'MW.Influencers.IcmDialogService', 'ngSanitize', 'MW.Framework.ICMEmailService', 'MW.Framework.FileUploadSelector', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Influencers.AnalyticsService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.ContactManager.ContactAutocompleteFilter', 'MW.Framework.InfluencerContactService', 'MW.Framework.ValidationConstants', 'MW.Framework.EntitlementService', 'ngRoute', 'Configuration', 'MW.Influencers.DateTimePicker', 'MW.Framework.EntitlementService', 'MW.ContactManager.MwOutreachPreviewModal', 'MW.Influencers.OutreachBannerService', 'MW.Influencers.EmailTemplateService', 'MW.Framework.ICMUserService', 'MW.Influencers.ManifestService', 'MW.Influencers.MrCompanyService']).controller('ContactManagerOutreachComposeController', ['$scope', '$timeout', '$translate', 'translationService', 'ContactStreamDataFactory', 'OutreachService', 'IcmUnsubscribeService', 'ContactManagerTagService', 'DialogService', '$sanitize', 'ICMEmailService', '$location', '$window', 'ContactManagerNavigationService', '$filter', '$q', '$mdDialog', 'editorLanguage', 'approvedSenderArray', 'dialogMode', 'DEFAULT_MEDIA_LIST', 'FILE_UPLOADER_URL', '$routeParams', 'AnalyticsService', 'CoreUserService', 'CoreCompanyService', 'InfluencerContactService', 'moment', 'MOMENT_MEDIUM_DATE', 'VALIDATION_CONSTANTS', 'EntitlementService', 'ICM_RECIPIENTS_PER_DISTRIBUTION', 'ICM_RECIPIENTS_PER_DAY', 'ICM_ASSETS_URL', 'IRM_BASE_URL', 'ICM_BASE_URL', 'OutreachBannerService', 'sendgridDomainsArray', 'EmailTemplateService', 'templatesList', 'ICMUserService', 'ManifestService', 'MrCompanyService', '$sce', ContactManagerOutreachComposeController]);

    function ContactManagerOutreachComposeController($scope, $timeout, $translate, translationService, ContactStreamDataFactory, OutreachService, IcmUnsubscribeService, ContactManagerTagService, DialogService, $sanitize, ICMEmailService, $location, $window, ContactManagerNavigationService, $filter, $q, $mdDialog, editorLanguage, approvedSenderArray, dialogMode, DEFAULT_MEDIA_LIST, FILE_UPLOADER_URL, $routeParams, AnalyticsService, CoreUserService, CoreCompanyService, InfluencerContactService, moment, MOMENT_MEDIUM_DATE, VALIDATION_CONSTANTS, EntitlementService, ICM_RECIPIENTS_PER_DISTRIBUTION, ICM_RECIPIENTS_PER_DAY, ICM_ASSETS_URL, IRM_BASE_URL, ICM_BASE_URL, OutreachBannerService, sendgridDomainsArray, EmailTemplateService, templatesList, ICMUserService, ManifestService, MrCompanyService, $sce) {
        var _this2 = this;

        var toolbarButtons,
            dailyLimitErrorMessage = 'You cannot send to more than [[limits]] recipients in a 24 hour period. Reduce the number of recipients or send this email on a later date.';

        this.$sce = $sce;
        this.ManifestService = ManifestService;
        this.MrCompanyService = MrCompanyService;
        this.outreachComposeFormTemplate = 'icm-web/views/partials/outreach_compose_form';
        this.previousPage = ContactManagerNavigationService.getPreviousLocation();
        this.$q = $q;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.MOMENT_MEDIUM_DATE = MOMENT_MEDIUM_DATE;
        this.DEFAULT_MEDIA_LIST = DEFAULT_MEDIA_LIST;
        this.ICM_ASSETS_URL = ICM_ASSETS_URL;
        this.IRM_BASE_URL = IRM_BASE_URL;
        this.ICM_BASE_URL = ICM_BASE_URL;
        this.moment = moment;
        this.$sanitize = $sanitize;
        this.perDayLimitExceeded = false;
        this.perScheduledDayLimitExceeded = false;
        this.ContactStreamDataFactory = new ContactStreamDataFactory();
        this.OutreachService = OutreachService;
        this.UnsubscribeService = IcmUnsubscribeService;
        this.CoreUserService = CoreUserService;
        this.ICMUserService = ICMUserService;
        this.pendingQueryTimeout = null;
        this.ContactManagerTagService = ContactManagerTagService;
        this.translationService = translationService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.InfluencerContactService = InfluencerContactService;
        this.ICMEmailService = ICMEmailService;
        this.$location = $location;
        this.$window = $window;
        this.editorLanguage = editorLanguage;
        this.dialogMode = dialogMode;
        this.OutreachBannerService = OutreachBannerService;
        this.sendgridDomainsArray = sendgridDomainsArray;
        this.EmailTemplateService = EmailTemplateService;
        this.messageBodyText = '';
        this.selectedContactListModel = [];
        this.selectedContactMailObj = {};
        this.contactListArray = [];
        this.mediaListArray = [];
        this.newTagModel = '';
        this.showDropDown = false;
        this.clickSelect = false;
        this.enableDuplicates = true;
        this.customTagCss = 'customEmailTag';
        this.tagCustomClassApply = [];
        this.tagEmailArray = [];
        this.contactMailArray = [];
        this.mediaListMailArray = [];
        this.subject = '';
        this.modified = null;
        this.composeFormError = false;
        this.isComposeValid = false;
        this.attachment = undefined;
        this.fileUploadList = [];
        this.formHolder = {
            composeForm: {}
        };
        this.attachments = [];
        this.totalFileAttachedSize = 0;
        this.totalFileSizeLimit = 10485760; //10 MB in bytes
        this.cachedMediaLists = {};
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };
        this.attachmentContentConfig = {
            fileInputClass: 'fileInputClass_outreach'
        };
        this.composeStep = true;
        this.schedulingOption = 'SAVE_DRAFT';
        this.userTimeZone = this.ICMUserService.getTimezoneName();
        this.userTimezoneString = this.ICMUserService.getTimezone();
        this.showDateTimePicker = false;
        this.dailyLimitForDateReached = false;
        this.defaultTimeoutForFlashMessage = 5;
        this.currentFlashInfoIndex = null;
        this.$routeParams = $routeParams;
        this.scheduledDateModel = null;
        this.dateTimeFormat = {
            dateFormat: 'M d, yy',
            timeFormat: 'HH:mm',
            momentDateFormat: 'll' // this is format used by moment which is equivalent to Datepicker(M d, yy) format
        };
        this.hour = '08';
        this.minute = '00';
        this.meridiem = 'AM';
        this.schedulingTimeError = false;
        this.hourOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        this.minuteOptions = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
        this.meridiemValues = ['AM', 'PM'];
        this.userLanguage = this.CoreUserService.getLanguage().replace('_', '-');
        this.schedulingErrorMessage = '';
        this.schedulingErrorMessages = {
            TIME_TOO_EARLY: this.translationService.getLocalizedString('icm-outreach__email-compose--schedule-time-error'),
            NO_RECIPIENT: this.translationService.getLocalizedString('To schedule delivery, please specify at least one recipient.'),
            NO_SUBJECT: this.translationService.getLocalizedString('To schedule delivery, please specify a subject line for your email.'),
            NO_BODY: this.translationService.getLocalizedString('To schedule delivery, please provide text in the body of your email.'),
            MULTI_MISSING_ELEMENTS: this.translationService.getLocalizedString('To schedule delivery, please make sure that your email has at least one recipient, a subject line and text in the body.'),
            DAY_EMAIL_LIMIT_EXCEEDED: this.translationService.getLocalizedString(dailyLimitErrorMessage, { limits: ICM_RECIPIENTS_PER_DAY.toLocaleString(this.userLanguage) }),
            DISTRIBUTION_EMAIL_LIMIT_EXCEEDED: this.$translate.instant('icm-outreach__email-compose--recipient-limit-error', { limits: ICM_RECIPIENTS_PER_DISTRIBUTION.toLocaleString(this.userLanguage) }),
            NO_SENDER: this.translationService.getLocalizedString('Please select at least one sender'),
            SCHEDULED_DAILY_EMAIL_LIMIT_EXCEEDED: ''
        };
        this.firstNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder');
        this.lastNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder');

        this.preSelectedMediaLists = {};
        this.recipientsPerDistributionLimit = ICM_RECIPIENTS_PER_DISTRIBUTION;
        EntitlementService.getIcmRecipientsPerDistribution(this.recipientsPerDistributionLimit).then(function (distributionLimit) {
            _this2.recipientsPerDistributionLimit = distributionLimit;
            _this2.schedulingErrorMessages.DISTRIBUTION_EMAIL_LIMIT_EXCEEDED = _this2.$translate.instant('icm-outreach__email-compose--recipient-limit-error', { limits: distributionLimit.toLocaleString(_this2.userLanguage) });
        }).catch(function () {
            var errorMessage = 'Unable to send outreach at this time. Please try again later.';
            _this2.showErrorMessage(_this2.translationService.getLocalizedString(errorMessage));
            _this2.closeCompose();
        });

        this.recipientsLabel = this.translationService.getLocalizedString('Recipients');
        this.MAX_RECIPIENTS_PER_DAY = ICM_RECIPIENTS_PER_DAY;
        this.emailSentToday = 0;
        EntitlementService.getIcmRecipientsPerDayLimit(ICM_RECIPIENTS_PER_DAY).then(function (result) {
            _this2.MAX_RECIPIENTS_PER_DAY = result;
            _this2.schedulingErrorMessages.DAY_EMAIL_LIMIT_EXCEEDED = _this2.translationService.getLocalizedString(dailyLimitErrorMessage, { limits: result.toLocaleString(_this2.userLanguage) });
            _this2.updateRecipientsLabel(_this2.MAX_RECIPIENTS_PER_DAY);
        }).catch(function () {});

        this.disableSendNow = false;
        this.shouldSkipConfirmation = false;
        this.formChanged = false;

        this.selectedApprovedSender = {};
        this.approvedSenderArray = approvedSenderArray;
        this.genericErrorMsg = this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.');
        this.EMAIL_ADDRESS_REGEX = VALIDATION_CONSTANTS.EMAIL_REGEX;

        this.closeDialogInlineMessages();

        this.outreachBodyLimit = this.translationService.getLocalizedString('outreach-body__limit--reached-warning');

        /**
         * @description Fetch basepath and queryparams out of a url
         *
         * @param {string} url
         */
        var getRequestParams = function getRequestparams(url) {
            var params = {},
                pathStr = url.split('?')[0],
                searchStr = url.split('?')[1];

            if (searchStr !== undefined) {
                var paramsStr = searchStr.split('&');
                for (var key in paramsStr) {
                    if (paramsStr.hasOwnProperty(key)) {
                        params[paramsStr[key].split('=')[0]] = paramsStr[key].split('=')[1];
                    }
                }
            }
            return {
                path: pathStr,
                params: params
            };
        };

        this.$scope.$on('$locationChangeSuccess', function ($event, newUrl, oldUrl) {
            var newLocationObject = getRequestParams(newUrl),
                oldLocationObject = getRequestParams(oldUrl);

            if (newLocationObject.path === oldLocationObject.path) {
                if (!newLocationObject.params.step || newLocationObject.params.step !== '2') {
                    _this2.composeStep = true;
                    _this2.schedulingOption = 'SAVE_DRAFT';
                    _this2.resetComposeFormErrors();
                    _this2.showDateTimePicker = false;
                    if (_this2.isValidComposeForm()) {
                        _this2.disableSendNow = false;
                    }
                } else if (newLocationObject.params.step === '2') {
                    _this2.composeStep = false;
                    if (!_this2.isValidComposeForm() && _this2.schedulingOption === 'SCHEDULE') {
                        _this2.scheduledDateModel = null;
                        _this2.schedulingOption = 'SAVE_DRAFT';
                        _this2.scheduledDate = null;
                        _this2.showDateTimePicker = false;
                    }
                }
            }
        });

        this.totalRecipientCount = 0;
        this.validFileTypes = ['.DOC', '.DOCX', '.PPT', '.PPTX', '.XLS', '.XLSX', '.CSV', '.PDF', '.JPG', '.JPEG', '.PNG', '.TIFF', '.GIF'];

        toolbarButtons = 'fontselect | fontsizeselect | bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code';
        if (this.dialogMode) {
            toolbarButtons = 'bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code';
        }

        this.editorOptions = {
            /* jshint camelcase: false */
            extended_valid_elements: 'first_name,last_name',
            plugins: 'autolink autoresize image link lists textcolor code noneditable powerpaste',
            toolbar: toolbarButtons,
            link_assume_external_targets: true
        };

        // recipients variables
        this.currentTagInput = '';
        this.recipientTags = [];
        this.CONTACT_TYPE = 'contact';
        this.MEDIA_LIST_TYPE = 'mediaList';

        this.allowedTagsPattern = VALIDATION_CONSTANTS.EMAIL_REGEX_STRING;

        this.contactIcon = 'icon-user';
        this.mediaListIcon = 'icon-users2';
        this.manualEmailTagStyle = 'customEmailTag';
        this.approvedSendersListDropDown = [];
        // end reciepient variables

        // tag any existing recipients
        this.tagExistingRecipients();

        // load all of the media lists to use for the autocomplete search/drodown
        // add media lists present in the url to recipients
        this.mediaListArray = [];
        this.ContactManagerTagService.getAllTags().then(function (response) {
            _this2.mediaListArray = response;

            if (_this2.$location.search().mediaListIds) {
                var mediaLists = _this2.$location.search().mediaListIds.split(',');

                mediaLists.forEach(function (mediaListId) {
                    _this2.mediaListArray.forEach(function (list) {
                        if (list.id === mediaListId) {
                            _this2.addMediaListToRecipients(list);
                        }
                    });
                });
            }
        }).catch(function () {});

        this.contactAutocompleteList = [];
        $scope.$watch(angular.bind(this, function () {
            return this.currentTagInput;
        }), function (newModel, oldModel) {
            var searchMailIdChanged = newModel.toLowerCase() !== oldModel.toLowerCase(),
                previousSearchSubsetOfNewSearch = false,
                query = {};

            // if the new search meets our min requirements, then get us some sources
            if (newModel.length && searchMailIdChanged && newModel.length >= 2) {

                // filter our media lists for autocomplete dropdown
                this.mediaListAutocompleteList = $filter('filter')(this.mediaListArray, { name: newModel });
                previousSearchSubsetOfNewSearch = newModel.toLowerCase().indexOf(oldModel.toLowerCase()) >= 0;
                if (!previousSearchSubsetOfNewSearch || previousSearchSubsetOfNewSearch && this.ContactStreamDataFactory.totalContacts > 200 || this.ContactStreamDataFactory.totalContacts < 0) {
                    if (this.pendingQueryTimeout !== null) {
                        $timeout.cancel(this.pendingQueryTimeout);
                        this.pendingQueryTimeout = null;

                        // if we are clearing out a query timeout then we should disregard the oldModel,
                        // since it was never actually queried on
                        oldModel = '';
                    }

                    this.pendingQueryTimeout = $timeout(function () {
                        // clear out our timeout variable so we can continue tracking them correctly
                        this.pendingQueryTimeout = null;
                        query = {
                            anyKeywords: [newModel],
                            page: 0,
                            pageSize: 200
                        };

                        this.ContactStreamDataFactory.autocomplete(query).then(function () {
                            this.contactAutocompleteList = [];
                            this.ContactStreamDataFactory.contactArray.forEach(function (contact) {
                                contact.contactInfo.email.forEach(function (contactEmailObject) {
                                    if (typeof contactEmailObject.address === 'string' && contactEmailObject.address.length) {
                                        this.contactAutocompleteList.push({
                                            id: contact.id,
                                            name: contact.name.fullName,
                                            firstName: contact.name.firstName,
                                            lastName: contact.name.lastName,
                                            email: contactEmailObject.address,
                                            private: contact.systemData.policies.storage.private
                                        });
                                    }
                                }, this);
                            }, this);
                        }.bind(this)).catch(function () {});
                    }.bind(this), 300);
                }
            } else if (newModel.length < 2) {
                this.contactAutocompleteList = [];
                this.mediaListAutocompleteList = [];
                this.ContactStreamDataFactory.resetSearch();
            }
        }.bind(this));
        // setup the approved sender for composing
        if (approvedSenderArray !== 'error') {
            if (Array.isArray(approvedSenderArray) && approvedSenderArray.length) {
                if (approvedSenderArray.length === 1) {
                    this.selectedApprovedSender = {
                        displayEmail: approvedSenderArray[0].name + ' (' + approvedSenderArray[0].email + ')',
                        payloadEmail: approvedSenderArray[0].name + ' <' + approvedSenderArray[0].email + '>',
                        id: approvedSenderArray[0].id
                    };
                    if (this.isVerifiedDomain(approvedSenderArray[0].email)) {
                        this.selectedApprovedSender.displayEmail = this.selectedApprovedSender.displayEmail + ' - ' + this.$translate.instant('icm-outreach__email-from--verify-sender');
                    }

                    this.approvedSendersListDropDown.push(this.selectedApprovedSender);
                    this.isApprovedSenderReady = true;
                } else {
                    for (var i = 0; i < approvedSenderArray.length; i++) {
                        var sender = {
                            displayEmail: approvedSenderArray[i].name + ' (' + approvedSenderArray[i].email + ')',
                            payloadEmail: approvedSenderArray[i].name + ' <' + approvedSenderArray[i].email + '>',
                            id: approvedSenderArray[i].id
                        };
                        if (this.isVerifiedDomain(approvedSenderArray[i].email)) {
                            sender.displayEmail = sender.displayEmail + ' - ' + this.$translate.instant('icm-outreach__email-from--verify-sender');
                        }
                        this.approvedSendersListDropDown.push(sender);
                    }
                    this.selectedApprovedSender = this.approvedSendersListDropDown[0];
                    this.isApprovedSenderReady = true;
                }
            } else {
                this.$location.url('/settings/email');
            }
        } else {
            // on error we should close the compose screen
            this.showErrorMessage(this.translationService.getLocalizedString('Unknown Sender'));
            this.shouldSkipConfirmation = true;
            this.closeCompose();
            this.shouldSkipConfirmation = false;
        }

        this.templateDropDownLabel = this.$translate.instant('icm-web-influencers-outreach-compose__template--default-label');
        this.templatesListDropDown = [{ id: 0, title: this.templateDropDownLabel }];
        this.selectedTemplate = {};
        this.templatesList = templatesList;
        if (Array.isArray(this.templatesList) && this.templatesList.length > 0) {
            this.templatesListDropDown = this.templatesListDropDown.concat(this.templatesList);
        }
        this.selectedTemplate = this.templatesListDropDown[0];

        //Populate email distribution's
        this.populateDistribution(this.$routeParams.distributionId, this.$routeParams.state);

        var domainNames = [];
        if (Array.isArray(approvedSenderArray) && approvedSenderArray.length > 0) {
            domainNames = _.chain(approvedSenderArray).filter(function (sender) {
                return sender.is_approved;
            }).map(function (sender) {
                return sender.email.split('@').pop();
            }).uniq().value();
        }
        if (!this.dialogMode) {
            this.OutreachBannerService.checkVerifiedDomains(domainNames, {
                attachTo: '.banner-space'
            }, this.sendgridDomainsArray);
        }
    }

    ContactManagerOutreachComposeController.prototype.templateChanged = function templateChanged(ev, selectedOption) {
        var _this3 = this;

        var currentTemplate = this.selectedTemplate,
            dialogHeader = this.$translate.instant('icm-outreach__template--confirm-load-header'),
            dialogDescription = this.$translate.instant('icm-outreach__template--confirm-load-description'),
            dialogOk = this.$translate.instant('icm-outreach__template--confirm-load-ok'),
            dialogCancel = this.$translate.instant('icm-outreach__template--confirm-load-cancel'),
            displayDialog = true;

        if (currentTemplate.body && this.messageBodyText === currentTemplate.body || this.messageBodyText.length === 0) {
            displayDialog = false;
        }

        if (displayDialog) {
            this.$mdDialog.show(this.$mdDialog.mwConfirm().class('icm-confirmation-modal').title(dialogHeader).textContent(dialogDescription).ok(dialogOk).cancel(dialogCancel).targetEvent(ev)).then(function () {
                // replace
                _this3.replaceWithTemplate(selectedOption);
            }, function () {
                // cancel
                _this3.selectedTemplate = currentTemplate;
            });
        } else {
            this.replaceWithTemplate(selectedOption);
        }
    };

    ContactManagerOutreachComposeController.prototype.replaceWithTemplate = function replaceWithTemplate(selectedOption) {
        this.setFormDirty();
        this.closeDialogInlineMessages();

        this.selectedTemplate = selectedOption;
        this.messageBodyText = selectedOption.body;
        this.templateId = selectedOption.id;
    };

    ContactManagerOutreachComposeController.prototype.isVerifiedDomain = function (emailAddress) {
        var isVerifiedDomain = false;
        var senderDomain = void 0;

        var emailRegexMatch = emailAddress.match(/@(.+)$/);

        if (emailRegexMatch) {
            senderDomain = emailRegexMatch[1];

            if (Array.isArray(this.sendgridDomainsArray) && this.sendgridDomainsArray.length) {
                isVerifiedDomain = this.sendgridDomainsArray.some(function (sendgridDomainObject) {
                    if (sendgridDomainObject.domain) {
                        if (sendgridDomainObject.domain.toLowerCase() === senderDomain.toLowerCase()) {
                            return sendgridDomainObject.isVerified === true;
                        }
                    }

                    return false;
                });
            }
        }

        return isVerifiedDomain;
    };

    ContactManagerOutreachComposeController.prototype.updateRecipientsLabel = function updateRecipientsLabel(perDayLimit) {
        var translateScope,
            endOfDayToday = this.adjustDateToEndOfDay(this.moment.utc()),
            relevantMsg,
            hoursUntilReset = this.getTotalHoursBetweenDates(this.moment.utc(), endOfDayToday);

        this.OutreachService.getLastDayCount(endOfDayToday.toISOString(), this.$routeParams.distributionId).then(function getLastDayCountSuccess(lastDayCount) {
            if (isNaN(lastDayCount)) {
                lastDayCount = 0;
            }
            this.emailSentToday = lastDayCount;

            if (lastDayCount === 0) {
                relevantMsg = 'icm-web-influencers-outreach__toast-usage-message--daily-limit';
                translateScope = {
                    perDayLimit: perDayLimit
                };
            } else {
                relevantMsg = 'icm-web-influencers-outreach__toast-usage-message--available-before-reset';
                translateScope = {
                    available: perDayLimit - lastDayCount,
                    hoursLeft: hoursUntilReset,
                    perDayLimit: perDayLimit
                };
            }

            this.translationService.getLocalizedString(relevantMsg, translateScope, true).then(function (translatedText) {
                this.recipientsLabel = translatedText;
            }.bind(this)).catch(function () {});
        }.bind(this)).catch(function () {});
    };

    /**
     * @description Show error message
     *
     * @param {String} error message
     */
    ContactManagerOutreachComposeController.prototype.showErrorMessage = function showErrorMessage(message) {
        if (!message) {
            return;
        }
        if (this.dialogMode) {
            this.errorOnDialog = true;
            this.inlineErrorMessage = message;
        } else {
            this.DialogService.flashError(message);
        }
    };

    ContactManagerOutreachComposeController.prototype.timeSelectionChanged = function timeSelectionChanged() {
        this.schedulingTimeError = false;
        this.perScheduledDayLimitExceeded = false;
        this.disableSendNow = false;
    };

    ContactManagerOutreachComposeController.prototype._convertDateTimeStringToUtc = function _convertDateTimeStringToUtc(dateString, timeString) {
        var userTimezone = this.ICMUserService.getTimezone(),
            formattedDateString = this.moment(dateString, 'MMM DD, YYYY').format('YYYY-MM-DD'),
            formattedDateTimeString = formattedDateString + 'T' + timeString,
            userDateTimeObject = this.moment.tz(formattedDateTimeString, userTimezone),
            utcTimezoneString = userDateTimeObject.toISOString();

        return utcTimezoneString;
    };

    /**
     * @description Handles the click event when scheduling option is changed
     *
     * @param {string} scheduling option
     */
    ContactManagerOutreachComposeController.prototype.schedulingOptionClickHandler = function schedulingOptionClickHandler(scheduleOption) {
        this.schedulingOption = scheduleOption;

        if (scheduleOption === 'SAVE_DRAFT') {
            this.showDateTimePicker = false;
        } else {
            this.showDateTimePicker = true;
            this.datePickerElement = angular.element('.datepickerVisible');
            this.dateInput = angular.element('.dateInput');

            if (this.scheduledDateModel === null) {
                this.scheduledDateModel = this.moment.tz(this.dateInput.val(), this.MOMENT_MEDIUM_DATE, this.ICMUserService.getTimezone()).format(this.dateTimeFormat.dateFormat);
            } else if (this.perScheduledDayLimitExceeded) {
                var displayDate = this.moment(this.scheduledDateModel);
                this.datePickerElement.datepicker('option', 'minDate', new Date(displayDate));
            } else {
                this.datePickerElement.datepicker('setDate', new Date(this.scheduledDateModel));
            }
        }
    };

    /**
     * @description Fetches distribution and populate messageBodyText and subject to duplicate distribution (in case of duplicate action)
     *              Fetches distribution and populate messageBodyText and subject and recipients to draft and scheduled email distribution (in case of draft and scheduled mails)
     *
     * @param {string} distributionId - unique Id of distribution
     * @param {string} state - state 'duplicate' of distribution
     */

    ContactManagerOutreachComposeController.prototype.populateDistribution = function populateDistribution(distributionId, state) {
        var _this4 = this;

        var sanitizeAttachment;

        if (distributionId) {
            this.OutreachService.getEmailById(distributionId).then(function (response) {
                if (response) {
                    _this4.preSavedDistribution = response;
                    _this4.messageBodyText = response.bodyHtml;
                    _this4.subject = response.subject;
                    _this4.modified = response.modified;

                    if (response.templateId) {
                        _this4.templateId = response.templateId;
                        _this4.selectedTemplate = _this4.templatesList.find(function (x) {
                            return x.id === response.templateId;
                        });
                    }

                    //load attachments
                    if (response.attachments && response.attachments.length) {
                        response.attachments.forEach(function (attachment) {
                            _this4.attachments.push(sanitizeAttachment(attachment));
                        });
                    }

                    if (state !== 'duplicate') {
                        // load up recipients and mediaLists
                        var contactRecipients = response.recipientsMetaData.recipients,
                            mediaListRecipients = response.recipientsMetaData.mediaLists,
                            contactRecipientsEmails = [];

                        if (Array.isArray(contactRecipients) && contactRecipients.length) {
                            contactRecipients.forEach(function (contactRecipient) {
                                contactRecipientsEmails.push(contactRecipient.email);
                            }, _this4);
                        }

                        _this4.checkForUnsubscribedContacts(contactRecipientsEmails).then(function (response) {
                            contactRecipients.forEach(function (contactRecipient) {
                                this.addContactToRecipients(contactRecipient, response.to);
                            }, _this4);
                        }).catch(function () {
                            _this4.showErrorMessage(_this4.genericErrorMsg);
                        });

                        if (Array.isArray(mediaListRecipients) && mediaListRecipients.length) {
                            mediaListRecipients.forEach(function (mediaListRecipient) {
                                this.addMediaListToRecipients(mediaListRecipient);
                            }, _this4);
                        }
                    }

                    if (response.status === 'scheduled' && state !== 'duplicate') {
                        //load schedule date
                        if (response.scheduledDate !== null && !response.sendImmediately) {
                            _this4.schedulingOption = 'SCHEDULE';
                            _this4.showDateTimePicker = true;
                            _this4.scheduledDateModel = _this4.moment(response.scheduledDate).tz(_this4.userTimezoneString).format(_this4.dateTimeFormat.momentDateFormat);
                            _this4.scheduledTimeModel = _this4.moment(response.scheduledDate).tz(_this4.userTimezoneString).format(_this4.dateTimeFormat.timeFormat);

                            _this4.scheduledDate = response.scheduledDate;

                            var twelveHourTimeObj = _this4._convert24hourTo12hourTime(_this4.scheduledTimeModel);
                            _this4.hour = twelveHourTimeObj.hour;
                            _this4.minute = twelveHourTimeObj.minute;
                            _this4.meridiem = twelveHourTimeObj.amPm.toUpperCase();
                        }
                    }
                    var distributionSender = _this4.approvedSendersListDropDown.filter(function (approveSender) {
                        return approveSender.id === response.approvedSender.id;
                    });

                    if (distributionSender.length > 0) {
                        _this4.selectedApprovedSender = distributionSender[0];
                    }
                }
            }).catch(function () {
                var errorMessage = 'Unable to retrieve email';
                _this4.showErrorMessage(_this4.translationService.getLocalizedString(errorMessage));
            });
        }

        if (this.$location.search().templateId) {
            this.templateId = parseInt(this.$location.search().templateId);
            this.selectedTemplate = this.templatesList.find(function (x) {
                return x.id === _this4.templateId;
            });
            if (this.selectedTemplate) {
                this.messageBodyText = this.selectedTemplate.body;
            }
        }

        sanitizeAttachment = function sanitizeAttachment(attachment) {
            var displayFileName, displayFileSize, displayFileExt;

            displayFileSize = this.validateFileSize(attachment.size);
            displayFileExt = attachment.fileLink.substr(attachment.fileLink.lastIndexOf('.')).toUpperCase();

            if (!displayFileSize || displayFileExt === 'invalid file type') {
                return false;
            }

            this.totalFileAttachedSize += attachment.size;
            displayFileName = attachment.fileLink.substr(attachment.fileLink.lastIndexOf('/') + 1, attachment.fileLink.lastIndexOf('.') - attachment.fileLink.lastIndexOf('/') - 1);

            attachment.displayFileName = decodeURIComponent(displayFileName);
            attachment.displayFileExt = displayFileExt;
            attachment.displayFileSize = displayFileSize;

            return attachment;
        }.bind(this);
    };

    /** @description Function deep compares the object by angular.equals (stripping off $$hashKey in objects in this.approvedSendersListDropdown populated from backend call)
     *
     * @param {Array} Array of objects to be compared into
     *        {Object} Object to be searched in array
     *
     * @returns {Number} Index in Array, else -1
     */
    ContactManagerOutreachComposeController.prototype.indexOfObject = function indexOfObject(arr, obj) {
        for (var i = 0; i < arr.length; i++) {
            if (angular.equals(arr[i], obj)) {
                return i;
            }
        }
        return -1;
    };

    ContactManagerOutreachComposeController.prototype.checkCanSend = function checkCanSend() {
        var _this5 = this;

        var showTermsPrompt = false;
        var mrShowUpdatedTerms0923 = 'mrShowUpdatedTerms0923';

        var translatedTitle = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--title');
        var translatedContent = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--content', { openingTag: '{{openingTag}}', closingTag: '{{closingTag}}' }).replace('{{openingTag}}', '<a style="color: #2795b6;" href="https://www.meltwater.com/en/product-specific-terms" target="_blank">').replace('{{closingTag}}', '</a>');

        var translatedOkButton = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--ok-button');
        var translatedCancelButton = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--cancel-button');

        var deferred = this.$q.defer();

        this.ManifestService.getCompanyOverrides().then(function (overrides) {
            if (overrides && overrides[mrShowUpdatedTerms0923] === true) {
                showTermsPrompt = true;
            }
        }).finally(function () {
            if (showTermsPrompt) {
                _this5.$mdDialog.show(_this5.$mdDialog.mwConfirm().title(translatedTitle).htmlContent(_this5.$sce.trustAsHtml(translatedContent)).ok(translatedOkButton).cancel(translatedCancelButton)).then(function () {
                    _this5.ManifestService.setOverride(mrShowUpdatedTerms0923, false); // override the manifest in browser so we don't need to wait for the call & manifest refresh
                    _this5.MrCompanyService.setAcceptedTerms();
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            } else {
                deferred.resolve();
            }
        });

        return deferred.promise;
    };

    /**
     * @description Handles click of send later button and takes to step two of compose modal
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.sendLater = function sendLater() {
        var _this6 = this;

        this.checkCanSend().then(function () {
            _this6.$location.search('step', '2');
            _this6.composeStep = false;
            _this6.perDayLimitExceeded = false;
            _this6.disableSendNow = false;
            _this6.getComposeFormErrors();

            if (_this6.schedulingOption === 'SCHEDULE') {
                _this6.schedulingOptionClickHandler('SCHEDULE');
            }
        });
    };

    /**
     * @description Handles the event of tagging existing recipients
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.tagExistingRecipients = function tagExistingRecipients() {
        var contactRecipients = this.ICMEmailService.getContactRecipients(),
            contactRecipientsQuery = this.ICMEmailService.getContactRecipientsQuery(),
            mediaListRecipients = this.ICMEmailService.getMediaListRecipients(),
            contactRecipientsEmails = [];

        if (Array.isArray(contactRecipients) && 'string' === typeof contactRecipientsQuery.q) {
            this.getRecipientsFromQuery(contactRecipientsQuery).then(function () {
                contactRecipients = Array.concat(contactRecipients, this.ICMEmailService.getContactRecipients());
                this.finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails);
            }.bind(this)).catch(function () {});
        } else {
            this.finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails);
        }
    };

    ContactManagerOutreachComposeController.prototype.finishTagging = function finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails) {
        // load up any existing recipients
        if (Array.isArray(contactRecipients) && contactRecipients.length) {
            contactRecipients.forEach(function (contactRecipient) {
                if (contactRecipient.email !== '') {
                    contactRecipientsEmails.push(contactRecipient.email);
                }
            }, this);
        }

        if (contactRecipientsEmails.length) {
            this.checkForUnsubscribedContacts(contactRecipientsEmails).then(function (response) {
                contactRecipients.forEach(function (contactRecipient) {
                    if (contactRecipient.email) {
                        this.addContactToRecipients(contactRecipient, response.to);
                    }
                }, this);
            }.bind(this)).catch(function () {
                this.showErrorMessage(this.genericErrorMsg);
            }.bind(this));
        }

        if (Array.isArray(mediaListRecipients) && mediaListRecipients.length) {
            mediaListRecipients.forEach(function (mediaListRecipient) {
                this.addMediaListToRecipients(mediaListRecipient);
            }, this);
        }
    };

    /**
     * @description Converting language code to editorLanguage
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.convertLanguageCode = function convertLanguageCode() {
        var lang = this.editorLanguage.toLowerCase();
        return lang === 'pt' ? 'pt_pt' : lang;
    };

    /**
     * Callback for when manually adding a tag to ngInputs
     * Current implementation only allows email addresses added manually
     *
     * @param {string} tag - value that was just tagged
     */
    ContactManagerOutreachComposeController.prototype.onTagAdded = function onTagAdded(tag) {
        var contactExisted = false;
        this.contactAutocompleteList.some(function (contact) {
            if (contact.email.toLowerCase() === tag.display.toLowerCase()) {
                this.recipientTags.pop();
                this.recipientTags.push({
                    class: '',
                    display: contact.name || contact.email,
                    icon: this.contactIcon,
                    trackBy: contact.email,
                    metaData: {
                        type: this.CONTACT_TYPE,
                        contact: contact
                    }
                });
                this.currentTagInput = false;
                this.addContactToRecipients(contact);
                contactExisted = true;
                return true;
            }
        }.bind(this));
        // update the added tag to match our expected object structure
        if (!contactExisted) {
            var tagObj = {
                class: this.manualEmailTagStyle,
                display: tag.display,
                icon: this.contactIcon,
                title: '',
                trackBy: tag.display,
                metaData: {
                    type: this.CONTACT_TYPE,
                    contact: {
                        id: null,
                        name: tag.display,
                        email: tag.display,
                        private: true
                    }
                }
            };
            this.recipientTags.pop();
            this.recipientTags.push(tagObj);
            this.checkForUnsubscribedContacts([tag.display]).then(function (response) {
                var result = response.to[tag.display.trim().toLowerCase()];
                tagObj.title = result ? tag.display : this.translationService.getLocalizedString('Contact unsubscribed. Email will not be sent.');
            }.bind(this)).catch(function () {
                this.showErrorMessage(this.genericErrorMsg);
            }.bind(this));
        }

        // update counts
        this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
    };

    /**
     * @description adding contacts to recipients array
     *
     * @param {object} contact object
     * @param {object} unsubscribed emails Object
     */
    ContactManagerOutreachComposeController.prototype.addContactToRecipients = function addContactToRecipients(contact, unsubscribedObject) {
        this.resetAutocomplete();
        if (contact && !unsubscribedObject) {
            this.checkForUnsubscribedContacts([contact.email]).then(function (response) {
                unsubscribedObject = response.to;
                this.addTagToRecipients(contact, unsubscribedObject);
            }.bind(this)).catch(function () {
                this.showErrorMessage();
            }.bind(this));
        } else {
            this.addTagToRecipients(contact, unsubscribedObject);
        }
    };

    ContactManagerOutreachComposeController.prototype.getRecipientsFromQuery = function addQueryToRecipients(query) {
        if (!query.mediaListIds) {
            return this.ContactStreamDataFactory.getMasterList(query).then(function (response) {
                this.ICMEmailService.setContactRecipients(response.hits);
            }.bind(this)).catch(function () {});
        } else {
            return this.ContactStreamDataFactory.getByMediaListIds(query).then(function (response) {
                this.ICMEmailService.setContactRecipients(response.hits);
            }.bind(this)).catch(function () {});
        }
    };

    /**
     * @description Adding medialists to recipients array
     *
     * @param {object} medialist object
     */
    ContactManagerOutreachComposeController.prototype.addMediaListToRecipients = function addMediaListToRecipients(mediaList) {
        this.resetAutocomplete();
        if (this.shouldAddTag(mediaList.name)) {
            this.cacheMediaList(mediaList).then(function () {
                var mediaListRecipients = [],
                    recipientsInMediaList = [],
                    comparator,
                    len;
                // gather up relevant info from the media lists
                this.cachedMediaLists[mediaList.id].hits.map(function (contactQuiddity) {
                    var contact = contactQuiddity,
                        contactName = '',
                        contactEmail = '';

                    if (contact.name) {
                        contactName = [contact.name.firstName, contact.name.middleInitial, contact.name.lastName].join(' ');
                    }

                    if (contact.contactInfo && Array.isArray(contact.contactInfo.email) && contact.contactInfo.email.length) {
                        var primary = contact.contactInfo.email.sort(function (a, b) {
                            if (a.overlayMetadata && b.overlayMetadata || !a.overlayMetadata && !b.overlayMetadata) {
                                if (!a.primary && b.primary) {
                                    return 1;
                                } else if (a.primary && !b.primary) {
                                    return -1;
                                }
                            } else if (!a.overlayMetadata && b.overlayMetadata) {
                                return 1;
                            } else if (a.overlayMetadata && !b.overlayMetadata) {
                                return -1;
                            }
                            return 0;
                        });
                        contactEmail = primary[0].address;
                    }
                    mediaListRecipients.push({
                        id: contact.id,
                        name: contactName,
                        firstName: contact.name.firstName,
                        lastName: contact.name.lastName,
                        email: contactEmail,
                        private: contact.systemData.policies.storage.private
                    });
                });

                // collect recipients within mediaList to show on hover
                len = mediaListRecipients.length;
                comparator = len <= 5 ? len : 5;
                for (var i = 0; i < comparator; i++) {
                    recipientsInMediaList.push(mediaListRecipients[i].email);
                }

                recipientsInMediaList = recipientsInMediaList.toString().replace(/,/g, '\n');

                if (len > 5) {
                    recipientsInMediaList += '\n' + (len - 5) + ' ' + this.translationService.getLocalizedString('more recipients...');
                }
                // tag the media list
                this.recipientTags.push({
                    class: '',
                    display: mediaList.name + ' (' + this.cachedMediaLists[mediaList.id].count + ')',
                    icon: this.mediaListIcon,
                    title: recipientsInMediaList,
                    trackBy: mediaList.name,
                    metaData: {
                        type: this.MEDIA_LIST_TYPE,
                        mediaList: {
                            id: mediaList.id,
                            name: mediaList.name,
                            recipients: mediaListRecipients,
                            count: this.cachedMediaLists[mediaList.id].count
                        }
                    }
                });
                this.preSelectedMediaLists[mediaList.id] = mediaList;
                // update counts
                this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
            }.bind(this)).catch(function () {});
        }
    };

    ContactManagerOutreachComposeController.prototype.getDedupCountOfRecipientEmails = function getDedupCountOfRecipientEmails() {
        var _this7 = this;

        var allRecipientEmails = {};
        // use object keys to keep track of what emails are dups so we don't have to iterate through an array
        this.recipientTags.forEach(function (tag) {
            if (tag.metaData.type === _this7.MEDIA_LIST_TYPE) {
                tag.metaData.mediaList.recipients.forEach(function (recipient) {
                    if (recipient.email && !allRecipientEmails[recipient.email]) {
                        // only really need the keys just set it to something value doesn't matter
                        allRecipientEmails[recipient.email] = true;
                    }
                });
            } else if (tag.metaData.type === _this7.CONTACT_TYPE) {
                if (tag.metaData.contact.email && !allRecipientEmails[tag.metaData.contact.email]) {
                    // only really need the keys just set it to something value doesn't matter
                    allRecipientEmails[tag.metaData.contact.email] = true;
                }
            }
        });
        //return actual count of recipients after deduping and removing no email contacts
        return Object.keys(allRecipientEmails).length;
    };

    /**
     * @description Handling removal of recipient tag callback
     *
     * @param {object} tag object
     */
    ContactManagerOutreachComposeController.prototype.onTagRemoved = function onTagRemoved(tag) {
        var maxRecipientsPerDay = this.MAX_RECIPIENTS_PER_DAY;

        if (tag.metaData.type === this.MEDIA_LIST_TYPE) {
            delete this.preSelectedMediaLists[tag.metaData[this.MEDIA_LIST_TYPE].id];
        }

        this.setFormDirty();
        this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
        if (this.totalRecipientCount <= maxRecipientsPerDay) {
            this.perDayLimitExceeded = false;
            this.disableSendNow = false;
        }
    };

    /**
     * @description reset autocomplete list
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.resetAutocomplete = function resetAutocomplete() {
        this.currentTagInput = '';
        this.contactAutocompleteList = [];
        this.mediaListAutocompleteList = [];
    };

    /**
     * @description check if new tag entered is valid to add a new tag
     *
     * @param {string}
     */
    ContactManagerOutreachComposeController.prototype.shouldAddTag = function shouldAddTag(newTrackByValue) {
        return this.recipientTags.every(function (recipientTag) {
            return recipientTag.trackBy !== newTrackByValue;
        });
    };

    /**
     * @description cache media list
     *
     * @param {Object} medialist object
     */
    ContactManagerOutreachComposeController.prototype.cacheMediaList = function (mediaList) {
        var deferred = this.$q.defer(),
            query;

        if (!this.cachedMediaLists[mediaList.id]) {
            query = {
                mediaListIds: [mediaList.id],
                page: 0,
                pageSize: this.recipientsPerDistributionLimit,
                contactsForReceipientList: true
            };
            this.ContactManagerTagService.getContactsByMediaListIds(query).then(function (response) {
                // media list count can be -1 in certain scenarios. we should treat that as 0 for UI
                if (response.count < 0) {
                    response.count = 0;
                }

                this.cachedMediaLists[mediaList.id] = response;
                deferred.resolve();
            }.bind(this)).catch(function (error) {
                deferred.reject(error);
            });
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    };

    /**
     * @description reset autocomplete onblur from tagging
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onBlurFromTagging = function onBlurFromTagging() {
        // TODO: need to refocus!
        this.resetAutocomplete();
    };

    /**
     * @description close inline messages on dialog onfocus of recipients dialog
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onFocusRecipientsField = function onFocusRecipientsField() {
        this.closeDialogInlineMessages();
    };

    /**
     * @description close inline messages on dialog
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.closeDialogInlineMessages = function closeDialogInlineMessages() {
        if (!this.dialogMode) {
            return;
        }
        this.errorOnDialog = false;
        this.inlineErrorMessage = '';
    };

    ContactManagerOutreachComposeController.prototype.generateSchedulingTimeErrorMessage = function generateSchedulingTimeErrorMessage() {
        var _this = this,
            scheduledDailyLimitErrorMessage = 'icm-outreach__email-schedule--limit-error';

        _this.schedulingErrorMessages.SCHEDULED_DAILY_EMAIL_LIMIT_EXCEEDED = _this.$translate.instant(scheduledDailyLimitErrorMessage, {
            selectedDate: _this.moment(_this.scheduledDate).format(_this.dateTimeFormat.momentDateFormat),
            limits: _this.MAX_RECIPIENTS_PER_DAY.toLocaleString(_this.userLanguage)
        });
    };

    ContactManagerOutreachComposeController.prototype.resetComposeFormErrors = function resetComposeFormErrors() {
        this.composeFormError = false;
        this.multipleFormErrors = false;
        this.missinRecipientsError = false;
        this.missingSubjectError = false;
        this.missingBodyError = false;
        this.missingSenderError = false;
        this.distroLimitError = false;
    };

    /**
     * @description Binds schedulingError states to layout
     *
     * @param {}
     * @return String (if error)
     *         false (if no error)
     */
    ContactManagerOutreachComposeController.prototype.getComposeFormErrors = function getComposeFormErrors() {
        this.resetComposeFormErrors();

        var formErrorCount = 0;
        if (!this.recipientTags.length) {
            formErrorCount++;
            this.missinRecipientsError = true;
            this.composeFormError = true;
        }
        if (this.subject === '') {
            formErrorCount++;
            this.missingSubjectError = true;
            this.composeFormError = true;
        }
        if (this.messageBodyText === '') {
            formErrorCount++;
            this.missingBodyError = true;
            this.composeFormError = true;
        }

        if (formErrorCount > 1) {
            this.multipleFormErrors = true;
        }

        if (this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) === -1) {
            this.missingSenderError = true;
            this.composeFormError = true;
        }

        if (this.totalRecipientCount > this.recipientsPerDistributionLimit) {
            this.distroLimitError = true;
            this.composeFormError = true;
        }
    };

    /**
     * @description get LastDay Email recipient count
     *
     * @param date
     * @param schedulingOption
     * @param distributionId
     * @param state
     * @returns {Promise}
     */
    ContactManagerOutreachComposeController.prototype.getLastDayCount = function getLastDayCount(date, schedulingOption, distributionId, state) {
        var deferred = this.$q.defer();

        if (schedulingOption === 'SAVE_DRAFT') {
            //No need to check in case of draft email
            deferred.resolve(0);
        } else {
            if (distributionId && state === undefined) {
                this.OutreachService.getLastDayCount(date, distributionId).then(function (count) {
                    count = count + this.totalRecipientCount;
                    deferred.resolve(count);
                }.bind(this)).catch(function (error) {
                    deferred.reject(error);
                });
            } else {
                this.OutreachService.getLastDayCount(date).then(function (count) {
                    count = count + this.totalRecipientCount;
                    deferred.resolve(count);
                }.bind(this)).catch(function (error) {
                    deferred.reject(error);
                });
            }
        }
        return deferred.promise;
    };

    /**
     * @description display preview email modal
     *
     */
    ContactManagerOutreachComposeController.prototype.showPreviewEmailModal = function showPreviewEmailModal() {
        var _this8 = this;

        this.checkCanSend().then(function () {
            var _this = _this8;

            _this8.hasFirstNameMailMergeField = _this8.messageBodyText.indexOf(_this8.firstNamePlaceholderText) > -1;
            _this8.hasLastNameMailMergeField = _this8.messageBodyText.indexOf(_this8.lastNamePlaceholderText) > -1;
            _this8.$mdDialog.show({
                bindToController: true,
                targetEvent: event,
                locals: {
                    EMAIL_ADDRESS_REGEX: _this8.EMAIL_ADDRESS_REGEX,
                    hasFirstNameMailMergeField: _this8.hasFirstNameMailMergeField,
                    hasLastNameMailMergeField: _this8.hasLastNameMailMergeField,
                    data: {},
                    cancelDialog: function cancelDialog() {
                        _this.$mdDialog.cancel();
                    },
                    okDialog: function okDialog(data) {
                        _this.sendPreviewDistribution(data);
                        _this.$mdDialog.hide();
                    }
                },
                template: '\n                    <md-dialog id="icm-outreach-preview-modal" class="mw-mini-modal mw-mini-modal--wide" aria-label="" layout="column">\n                        <mw-outreach-preview-modal class="mw-mini-modal-wrapper" layout="column" email-pattern="$ctrl.EMAIL_ADDRESS_REGEX" show-first-name-field="$ctrl.hasFirstNameMailMergeField" show-last-name-field="$ctrl.hasLastNameMailMergeField" ok-callback="$ctrl.okDialog(data)" cancel-callback="$ctrl.cancelDialog()"></mw-outreach-preview-modal>\n                    </md-dialog>\n                ',
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl'
            });
        });
    };

    /**
     * @description method for sending preview email.
     *
     * @param recipientObject
     */
    ContactManagerOutreachComposeController.prototype.sendPreviewDistribution = function sendPreviewDistribution(recipientObject) {
        var attachmentObject,
            sender = this.selectedApprovedSender.payloadEmail || '',
            senderId = this.selectedApprovedSender.id || '',
            recipient = {
            private: true,
            email: recipientObject.email,
            name: recipientObject.email,
            lastName: recipientObject.lastName,
            firstName: recipientObject.firstName,
            id: null
        },
            payload = {
            recipients: [recipient],
            mediaLists: [],
            subject: this.subject + ' (' + this.$translate.instant('icm-outreach__email-preview--preview-subject-tag') + ')',
            bodyHtml: this.messageBodyText,
            fromAddress: sender,
            userLanguage: this.editorLanguage,
            approvedSenderId: senderId,
            firstNamePlaceholder: this.firstNamePlaceholderText,
            lastNamePlaceholder: this.lastNamePlaceholderText,
            sendImmediately: true,
            isPreview: true,
            attachments: []
        };

        if (this.templateId) {
            payload.templateId = this.templateId;
        }

        this.attachments.forEach(function addAttachment(attachment) {
            attachmentObject = {
                fileLink: attachment.fileLink,
                size: attachment.size
            };
            payload.attachments.push(attachmentObject);
        }.bind(this));

        this.trackEvent('preview', payload.recipients.length);
        this.OutreachService.outreach(payload, this.fileUploadList).catch(function onError() {
            this.showErrorMessage(this.genericErrorMsg);
        }.bind(this));
    };

    /**
     * @description method for checking email body content for Base64 encoded images
     *
     * @param htmlInput
     */
    ContactManagerOutreachComposeController.prototype.containsInvalidImage = function containsInvalidImage(htmlInput) {
        var base64Regex = /src=\"data:image\/([a-zA-Z]*);base64,([^\"]*)\"/g;
        var blobRegex = /src\=\"blob\:[a-zA-Z]{3,5}\:\/\/[\S]*\"/g;

        return !!(base64Regex.test(htmlInput) || blobRegex.test(htmlInput));
    };

    ContactManagerOutreachComposeController.prototype.bodyLimitExceeded = function bodyLimitExceeded() {
        // check byte count is less than 10 mb (1024 X 1024 X 10)
        return this.messageBodyText.length >= 200000;
    };

    /**
     * @description method for sending email now.
     *
     * @param sendNow
     */
    ContactManagerOutreachComposeController.prototype.saveMail = function saveMail(sendNow) {
        var _this9 = this;

        this.checkCanSend().then(function () {
            _this9.disableSendNow = true;
            var sendingPriority;

            // Recall function if the user hits the send button too early
            if (_this9.containsInvalidImage(_this9.messageBodyText)) {
                _this9.$timeout(function () {
                    _this9.saveMail(sendNow);
                }, 500);

                return;
            }

            if (sendNow) {
                sendingPriority = {
                    prio: 'send now',
                    date: _this9.adjustDateToEndOfDay(_this9.moment.utc()).toISOString()
                };
            } else if (!sendNow) {
                if (_this9.schedulingOption === 'SCHEDULE') {
                    // for scheduled emails we need to define the "scheduledDate" so that the API request to fetch the "last day count", will calculate based on scheduled day & not today
                    _this9.scheduledDate = _this9.setScheduledDate();

                    // the setScheduledDate method call sets the schedulingTimeError flag. if there is a time error, then dont continue to make more requests.
                    if (_this9.schedulingTimeError) {
                        _this9.disableSendNow = false;
                        return;
                    }
                }

                sendingPriority = {
                    prio: _this9.schedulingOption,
                    date: _this9.adjustDateToEndOfDay(_this9.scheduledDate).toISOString()
                };
            }

            _this9.getLastDayCount(sendingPriority.date, sendingPriority.prio, _this9.$routeParams.distributionId, _this9.$routeParams.state).then(function (count) {
                var mailType,
                    maxRecipientsPerDay = this.MAX_RECIPIENTS_PER_DAY,
                    sender = this.selectedApprovedSender.payloadEmail || '',
                    senderId = this.selectedApprovedSender.id || '',
                    payload = {
                    recipients: [],
                    mediaLists: [],
                    subject: this.subject,
                    modified: this.modified,
                    bodyHtml: this.messageBodyText,
                    fromAddress: sender,
                    userLanguage: this.editorLanguage,
                    approvedSenderId: senderId,
                    firstNamePlaceholder: this.firstNamePlaceholderText,
                    lastNamePlaceholder: this.lastNamePlaceholderText,
                    //This is for stat tracking purposes
                    usedPlaceholders: this.messageBodyText.indexOf(this.firstNamePlaceholderText) > -1 || this.messageBodyText.indexOf(this.lastNamePlaceholderText) > -1
                };

                if (this.templateId) {
                    payload.templateId = this.templateId;
                }

                if (sendNow) {
                    payload.sendImmediately = true;
                    if (count <= maxRecipientsPerDay) {
                        mailType = 'sent';
                    }
                } else {
                    payload.sendImmediately = false;

                    if (this.schedulingOption === 'SAVE_DRAFT') {
                        this.scheduledDate = this.scheduledDateModal = null;
                        payload.scheduledDate = null;
                        mailType = 'draft';
                    } else {
                        payload.scheduledDate = this.scheduledDate;
                        mailType = 'scheduled';
                    }
                }

                // Check for max recipient error case
                if (count > maxRecipientsPerDay) {
                    // if the user was attempting to schedule an outreach and hit a num of recipient issue. need to dynamially build the error message to display.
                    if (this.schedulingOption === 'SCHEDULE' && payload.sendImmediately === false) {
                        this.perScheduledDayLimitExceeded = true;
                        this.perDayLimitExceeded = false;
                        this.generateSchedulingTimeErrorMessage();
                    } else if (this.schedulingOption !== 'SCHEDULE' || payload.sendImmediately === true) {
                        this.perDayLimitExceeded = true;
                    }
                } // check that body limit is not exceeded
                else if (this.bodyLimitExceeded()) {
                        this.bodySizeLimitExceeded = true;
                    } else {
                        this.perDayLimitExceeded = false;
                        this.perScheduledDayLimitExceeded = false;

                        this.recipientTags.forEach(function (recipientTag) {
                            switch (recipientTag.metaData.type) {
                                case this.CONTACT_TYPE:
                                    payload.recipients.push(recipientTag.metaData[this.CONTACT_TYPE]);
                                    break;
                                case this.MEDIA_LIST_TYPE:
                                    payload.mediaLists.push(recipientTag.metaData[this.MEDIA_LIST_TYPE]);
                                    break;
                                default:
                                    break;
                            }
                        }, this);

                        if (!payload.attachments && this.attachments.length > 0) {
                            payload.attachments = [];

                            this.attachments.forEach(function (attachment) {
                                payload.attachments.push({ 'size': attachment.size, 'fileLink': attachment.fileLink });
                            }.bind(this));
                        }

                        if (this.$routeParams.distributionId && this.$routeParams.state === undefined) {
                            payload.id = this.$routeParams.distributionId;

                            this.OutreachService.outreachUpdate(payload, this.fileUploadList).then(function () {
                                this.shouldSkipConfirmation = true;
                                this.closeCompose();
                            }.bind(this)).catch(function (error) {
                                if (error.statusCode === 409) {
                                    this.showProtectOverwriteModal(payload, error.error.reason);
                                } else if (error.statusCode === 400 && error.error && error.error.reason === 'failedToSaveAttachments') {
                                    this.notifyAttachmentFailed(error.error.data.file);
                                } else {
                                    this.showErrorMessage(this.genericErrorMsg);
                                }
                            }.bind(this));
                        } else {
                            this.OutreachService.outreach(payload, this.fileUploadList).then(function () {
                                this.shouldSkipConfirmation = true;
                                this.closeCompose();
                            }.bind(this)).catch(function (error) {
                                var _this10 = this;

                                if (error.statusCode === 409) {
                                    this.showProtectOverwriteModal(payload, error.error.reason);
                                } else if (error.statusCode === 400 && error.error && error.error.reason === 'failedToSaveAttachments') {
                                    this.notifyAttachmentFailed(error.error.data.file);
                                } else if (error.statusCode === 500 && error.error && error.error.message === 'Mismatched Company on Approved Sender') {
                                    this.$mdDialog.show(this.$mdDialog.mwAlert().title(this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--header')).htmlContent(this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--body-string-1') + '<br><br>' + this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--body-string-2')).ok('OK')).then(function () {
                                        _this10.status = 'Alert Closed';
                                    });
                                    this.disableSendNow = false;
                                } else {
                                    this.disableSendNow = false;
                                    this.showErrorMessage(this.genericErrorMsg);
                                }
                            }.bind(this));
                        }
                        if (mailType) {
                            this.trackEvent(mailType, payload.recipients.length);
                        }
                    }
            }.bind(_this9)).catch(function () {
                this.showErrorMessage(this.translationService.getLocalizedString('Fail to retrieve email history'));
            }.bind(_this9));

            _this9.ICMEmailService.resetRecipients();
        });
    };

    ContactManagerOutreachComposeController.prototype.showProtectOverwriteModal = function showProtectOverwriteModal(distribution, errorType) {
        var _this11 = this;

        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                distribution: distribution,
                disallowOverwrite: errorType === 'outreachEmailSentConflict'
            },
            template: '<md-dialog id="protect-outreach-mini-modal" class="mw-mini-modal" aria-label="" layout="column">\n                        <protect-edited-outreach class="mw-mini-modal-wrapper" distribution="$ctrl.distribution" disallow-overwrite="$ctrl.disallowOverwrite" layout="column"></protect-edited-outreach>\n                    </md-dialog>',
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then(function (data) {
            if (data && data.option === 'copy') {
                // option === 'copy', allow to update the subject
                distribution.subject = data.subject;
                distribution.scheduledDate = null;
                _this11.OutreachService.outreach(distribution, _this11.fileUploadList).then(function () {
                    this.shouldSkipConfirmation = true;
                    this.closeCompose();
                }.bind(_this11)).catch(function () {
                    this.disableSendNow = false;
                    this.showErrorMessage(this.genericErrorMsg);
                }.bind(_this11));
            } else {
                // option === 'overwrite', does not allow to update anything
                distribution.ignoreConflict = true;
                _this11.OutreachService.outreachUpdate(distribution, _this11.fileUploadList).then(function () {
                    this.shouldSkipConfirmation = true;
                    this.closeCompose();
                }.bind(_this11)).catch(function () {
                    this.showErrorMessage(this.genericErrorMsg);
                }.bind(_this11));
            }
        }, function () {
            //on cancel
            _this11.disableSendNow = false;
        });
    };

    ContactManagerOutreachComposeController.prototype.notifyAttachmentFailed = function notifyAttachmentFailed(attachment) {
        if (!this.dialogMode && this.attachmentError.errorState === false) {
            this.disableSendNow = false;

            // remove attachment from the upload list
            if (attachment) {
                var index = this.fileUploadList.findIndex(function (file) {
                    return file.name === attachment.name;
                });

                if (index !== -1) {
                    this.removeAttachedFile(attachment, index);
                }
            }

            // open alert banner
            this.OutreachBannerService.openAttachmentAlertBanner({
                attachTo: '.banner-space'
            });
        }
    };

    /**
     * @description Method to invoke and handle confirmation to leave compose email page
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.confirmCloseCompose = function confirmCloseCompose() {
        var dialogTitle,
            dialogContent,
            dialogOptions,
            payload,
            defer = this.$q.defer();

        if (this.schedulingOption !== 'SAVE_DRAFT' && this.isValidComposeForm()) {
            dialogTitle = this.translationService.getLocalizedString('Save changes?');
            dialogContent = this.translationService.getLocalizedString('Do you want to save the changes you\'ve made to this scheduled email before you close?');
        } else {
            this.schedulingOption = 'SAVE_DRAFT';
            dialogTitle = this.translationService.getLocalizedString('Save draft?');
            dialogContent = this.translationService.getLocalizedString('Do you want to save this email before you close?');
        }

        dialogOptions = {
            title: dialogTitle,
            customDialogCss: {
                executeBefore: {
                    left: '50%'
                }
            }
        };
        payload = {
            content: dialogContent
        };

        if (!this.formHolder.composeForm.$dirty) {
            this.closeCompose();
            defer.resolve();
            return defer.promise;
        }

        dialogOptions.callbackOnCancel = function callbackOnCancel() {
            defer.reject();
        };

        this.DialogService.confirmExit(dialogOptions, payload, function confirmLeavePageCallback(response) {
            if (response.successDetail === 'abandon') {
                this.closeCompose();
            } else {
                this.saveMail();
            }
            defer.resolve();
        }.bind(this));

        return defer.promise;
    };

    /**
     * @description Method to handle closing compose email page
     *
     * @param {boolean} waitToConfirm to confirm (confirmation box will appear)
     */
    ContactManagerOutreachComposeController.prototype.closeCompose = function closeCompose(waitToConfirm) {
        this.ICMEmailService.resetRecipients();

        if (waitToConfirm) {
            this.confirmCloseCompose();
        } else {
            if (this.dialogMode) {
                this.DialogService.closeDialog();
            } else {
                //Hide animation before moving to next page
                angular.element('.composeEmailContainer').addClass('hideContainer');

                //Let the animation complete for 0.5 seconds
                this.$timeout(function () {
                    //if opened compose in a new tab, return to landing page on close
                    //if opened from landing page, return to outreach page on close
                    // else navigate back to where compose was opened. this logic was done because the compose page is not a modal
                    if (this.previousPage && this.previousPage.includes('/influencers/contact/outreach')) {
                        // redirect to outreach landing page
                        window.location.href = this.ICM_BASE_URL + '/influencers/contact/outreach';
                    } else if (history.length === 1 || history.length === 2 && window.location.href.includes('step=2')) {
                        //if open in a new tab, redirect to MR landing page
                        window.location.href = this.IRM_BASE_URL;
                    } else {
                        if (this.$routeParams.contact) {
                            window.location.href = this.IRM_BASE_URL + '/contact/' + this.$routeParams.contact + '?view=interactions';
                        } else if (window.location.href.includes('step=2')) {
                            history.go(-2);
                        } else {
                            history.back();
                        }
                    }
                }.bind(this), 500);
            }
        }
    };

    /**
     * @description Handle attachment of a file to email
     *              Validations for the sameincluded
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onFileAttachmentAdd = function onFileAttachmentAdd() {
        var validateFileType,
            sanitizeFileObject,
            fullFileObject,
            foundInvalidUpload = false;

        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        validateFileType = function validateFileType(fileType) {
            if (this.validFileTypes.indexOf(fileType) > -1) {
                return fileType;
            } else {
                this.attachmentError.errorState = this.attachmentError.invalidFileType = true;
                return 'invalid file type';
            }
        }.bind(this);

        sanitizeFileObject = function sanitizeFileObject(fileObject) {
            var displayFileName, displayFileSize, displayFileExt;

            displayFileSize = this.validateFileSize(fileObject.size);
            displayFileExt = fileObject.name.lastIndexOf('.') > -1 ? validateFileType(fileObject.name.substr(fileObject.name.lastIndexOf('.')).toUpperCase()) : validateFileType();

            if (!displayFileSize || displayFileExt === 'invalid file type') {
                return false;
            }

            this.totalFileAttachedSize += fileObject.size;
            displayFileName = fileObject.name.substr(0, fileObject.name.lastIndexOf('.'));

            fileObject.displayFileName = decodeURIComponent(displayFileName);
            fileObject.displayFileExt = displayFileExt;
            fileObject.displayFileSize = displayFileSize;

            return fileObject;
        }.bind(this);
        this.$timeout(function () {
            if (this.attachment.length) {
                angular.forEach(this.attachment, function (fileObject) {
                    fullFileObject = sanitizeFileObject(fileObject);
                    if (fullFileObject) {
                        this.$scope.$apply(function () {
                            this.fileUploadList.push(fileObject);
                        }.bind(this));
                    } else {
                        foundInvalidUpload = true;
                    }
                }.bind(this));
                if (foundInvalidUpload) {
                    this.$scope.$apply();
                }
            }
        }.bind(this), 0);

        this.setFormDirty();
    };

    /**
     * @description Handling removal of an attached file
     *
     * @param {object} fileObject
     *        {index number} index position of file in array
     */
    ContactManagerOutreachComposeController.prototype.removeAttachedFile = function removeAttachedFile(fileObject, index) {
        this.fileUploadList.splice(index, 1);
        this.totalFileAttachedSize -= fileObject.size;
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        this.setFormDirty();
    };

    /**
     * @description Handling removal of attachment during update flow
     *
     * @param {object} fileObject
     *        {index number} index position of file in array
     */
    ContactManagerOutreachComposeController.prototype.removeAttachment = function removeAttachment(fileObject, index) {
        this.attachments.splice(index, 1);
        this.totalFileAttachedSize -= fileObject.size;
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        this.setFormDirty();
    };

    /**
     * @description checks for validation of compose form
     *
     * @param {}
     * @returns {boolean}
     */
    ContactManagerOutreachComposeController.prototype.isValidComposeForm = function isValidComposeForm() {
        var isValid;
        if (this.schedulingOption === 'SCHEDULE') {
            isValid = !!(this.recipientTags.length && this.subject && this.messageBodyText && this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded && !this.perScheduledDayLimitExceeded && !this.bodyLimitExceeded() && this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) > -1);
        } else {
            isValid = !!(this.recipientTags.length && this.subject && this.messageBodyText && this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded && !this.bodyLimitExceeded() && this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) > -1);
        }
        return isValid;
    };

    /**
     * @description checks for validation of recipients field
     *
     * @param {}
     * @returns {boolean}
     */
    ContactManagerOutreachComposeController.prototype.isValidRecipientsField = function isValidRecipientsField() {
        return !!(this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded);
    };

    /**
     * @description validates file size
     *
     * @param {Number} fileSize in Bytes.
     * @returns {Boolean}
     */
    ContactManagerOutreachComposeController.prototype.validateFileSize = function validateFileSize(fileSize) {
        var displayFileSize = '',
            mb = ' ' + this.translationService.getLocalizedString('MB'),
            kb = ' ' + this.translationService.getLocalizedString('KB'),
            bytes = ' ' + this.translationService.getLocalizedString('Bytes');

        if (this.totalFileAttachedSize + fileSize > this.totalFileSizeLimit) {
            this.attachmentError.errorState = true;
            if (this.totalFileAttachedSize + fileSize > this.totalFileSizeLimit) {
                this.attachmentError.invalidTotalFileSize = true;
            }
            return false;
        } else if (parseInt(fileSize) === 0) {
            this.attachmentError.errorState = true;
            this.attachmentError.zeroFileSize = true;
            return false;
        }

        if (fileSize >= 1024 * 1024) {
            displayFileSize = (fileSize / (1024 * 1024)).toFixed(2) + mb;
        } else {
            if (fileSize > 1024) {
                displayFileSize += (fileSize / 1024).toFixed(2) + kb;
            } else {
                displayFileSize += fileSize + bytes;
            }
        }

        return displayFileSize;
    };

    /**
     * @description called when approved sender selected from dropdown is changed
     *
     * @param approvedSenderObj
     * @returns {}
     */
    ContactManagerOutreachComposeController.prototype.approvedSenderChanged = function approvedSenderChanged() {
        this.setFormDirty();
        this.closeDialogInlineMessages();
    };

    /**
     * @description sets the form state as $dirty
     *
     * @param {}
     * @returns {}
     */
    ContactManagerOutreachComposeController.prototype.setFormDirty = function setFormDirty() {
        if (!this.formHolder.composeForm.$dirty) {
            this.formHolder.composeForm.$setDirty();
        }
    };

    /**
     * @description Checking for unsubscribed contacts
     *
     * @param [array] contactsEmailArray Email Array
     * @returns promise
     */
    ContactManagerOutreachComposeController.prototype.checkForUnsubscribedContacts = function checkForUnsubscribedContacts(contactsEmailArray) {
        contactsEmailArray = contactsEmailArray.filter(function (e) {
            return e;
        });

        return this.UnsubscribeService.unsubscribedContactStatus(contactsEmailArray);
    };

    /**
     * @description adding contacts to recipients array
     *
     * @param {object} contact object
     * @param {object} unsubscribed email object
     */
    ContactManagerOutreachComposeController.prototype.addTagToRecipients = function addTagToRecipients(contact, unsubscribedObject) {
        var result = unsubscribedObject[contact.email.trim().toLowerCase()],
            tagStyleProp = contact.id && contact.id !== null ? '' : this.manualEmailTagStyle;

        contact.title = result ? contact.email : this.translationService.getLocalizedString('Contact unsubscribed. Email will not be sent.');

        if (this.recipientTags) {
            for (var i = 0; i < this.recipientTags.length; i++) {
                if (contact.email === this.recipientTags[i].trackBy) {
                    this.recipientTags[i].title = contact.title;
                }
            }
        }

        if (this.shouldAddTag(contact.email)) {
            // tag contact
            this.recipientTags.push({
                class: tagStyleProp,
                display: contact.name || contact.email,
                icon: this.contactIcon,
                title: contact.title,
                trackBy: contact.email,
                metaData: {
                    type: this.CONTACT_TYPE,
                    contact: contact,
                    private: contact.private
                }
            });

            // update counts
            this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
        }
    };

    ContactManagerOutreachComposeController.prototype.openMediaListDialog = function openMediaListDialog() {
        this.ContactManagerTagService.addToComposeMediaListsDialog(this.mediaListArray, this.preSelectedMediaLists, this.recipientsLabel, function dialogSuccessCallBack(selectedMediaListsArray, removedMediaLists) {
            for (var i = 0; i < this.recipientTags.length; i++) {
                if (this.recipientTags[i].metaData.mediaList) {
                    if (removedMediaLists[this.recipientTags[i].metaData.mediaList.id]) {
                        this.onTagRemoved(this.recipientTags[i]);
                        this.recipientTags.splice(i--, 1);
                    }
                }
            }
            for (var j = 0; j < selectedMediaListsArray.length; j++) {
                this.addMediaListToRecipients(selectedMediaListsArray[j]);
            }
        }.bind(this));
    };

    ContactManagerOutreachComposeController.prototype.updateEditorBusy = function updateEditorBusy(isBusy) {
        this.disableSendNow = isBusy;

        this.$timeout(function applyChanges() {
            this.$scope.$apply();
        }.bind(this), 0);
    };

    ContactManagerOutreachComposeController.prototype.trackEvent = function trackEvent(type, recepientCount) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'outreach_email',
                contactCount: recepientCount,
                parentType: 'email',
                subType: type,
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            this.AnalyticsService.trackMediaListOperation('outreach_email', trackingData);
        }.bind(this));
    };

    ContactManagerOutreachComposeController.prototype._convert24hourTo12hourTime = function _convert24hourTo12hourTime(twentyFourHourString) {
        twentyFourHourString = twentyFourHourString.toString();

        var hourMinuteArray = twentyFourHourString.split(':'),
            hour = hourMinuteArray[0],
            minute = hourMinuteArray[1],
            twentyFourHourTimeObject = {
            hour: null,
            minute: minute,
            amPm: null
        };

        if (!twentyFourHourString.match(/..:../)) {
            throw 'invalid twenty four hour format';
        }

        if (hour < 0 || hour > 23) {
            throw 'invalid hour';
        }

        if (minute < 0 || minute > 59) {
            throw 'invalid minute';
        }

        if (hour === '00') {
            twentyFourHourTimeObject.hour = '12';
            twentyFourHourTimeObject.amPm = 'AM';
        } else if (hour === '12') {
            twentyFourHourTimeObject.hour = '12';
            twentyFourHourTimeObject.amPm = 'PM';
        } else {
            if (hour < 12) {
                twentyFourHourTimeObject.hour = hour;
                twentyFourHourTimeObject.amPm = 'AM';
            } else {
                twentyFourHourTimeObject.hour = (hour - 12).toString();
                twentyFourHourTimeObject.amPm = 'PM';
            }
        }

        twentyFourHourTimeObject.hour = twentyFourHourTimeObject.hour.padStart(2, '0');
        return twentyFourHourTimeObject;
    };

    ContactManagerOutreachComposeController.prototype._convert12hourTo24hour = function _convert12hourTo24hour(hour, amPm) {
        hour = parseInt(hour);
        amPm = amPm.toString().toUpperCase();

        var twentyFourHourString;

        if (hour < 0 || hour > 12 || isNaN(hour)) {
            throw 'invalid hour';
        }

        if (amPm !== 'AM' && amPm !== 'PM') {
            throw 'invalid meridiem';
        }

        if (hour === 12) {
            twentyFourHourString = amPm === 'AM' ? '00' : '12';
        } else {
            twentyFourHourString = amPm === 'AM' ? hour.toString() : (hour + 12).toString();
        }

        twentyFourHourString = twentyFourHourString.padStart(2, '0');
        return twentyFourHourString;
    };

    ContactManagerOutreachComposeController.prototype.setScheduledDate = function () {
        var hour = parseInt(this.hour),
            minute = this.minute.toString(),
            timeString = this._convert12hourTo24hour(hour, this.meridiem) + ':' + minute,
            utcString = this._convertDateTimeStringToUtc(this.scheduledDateModel, timeString);
        if (this.moment(utcString).isAfter(this.moment())) {
            return utcString;
        } else {
            this.schedulingTimeError = true;
        }
    };

    ContactManagerOutreachComposeController.prototype.adjustDateToEndOfDay = function adjustDateToEndOfDay(date) {
        var rightNow = this.moment.tz(date, this.ICMUserService.getTimezone()),
            endOfDayToday = rightNow.clone().endOf('day').utc();

        return endOfDayToday;
    };

    ContactManagerOutreachComposeController.prototype.getTotalHoursBetweenDates = function getTotalHoursBetweenDates(now, later) {
        var rightNow = this.moment.tz(now, this.ICMUserService.getTimezone());
        return Math.ceil(this.moment.duration(later.diff(rightNow)).asHours());
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerOutreachListController', ['MW.Influencers.IcmDialogService', 'MW.Framework.TranslationService', 'MW.Framework.ICMUserService', 'MW.Framework.ICMEmailService', 'MW.ContactManager.OutreachListFactory', 'MW.Framework.CoreUserService', 'MW.ContactManager.OutreachService', 'MW.ContactManager.ContactManagerNavigationService', 'MW.ContactManager.OutreachList', 'MW.ContactManager.TemplateList', 'MW.Influencers.EmailAnalyticsService', 'MW.Influencers.AccountEngagementWidget', 'MW.Configuration', 'MW.Influencers.OutreachBannerService', 'MW.Influencers.ActionBarService', 'MW.Influencers.OutreachTemplate', 'MW.Influencers.EmailTemplateService', 'mwAppComponents', 'MW.Influencers.UserActivityService']).controller('ContactManagerOutreachListController', ['$scope', 'DialogService', 'translationService', 'ICMUserService', 'ICMEmailService', '$location', '$translate', '$mdDialog', 'OutreachListFactory', 'CoreUserService', 'OutreachService', '$q', 'ContactManagerNavigationService', 'EmailAnalyticsService', 'OutreachBannerService', 'ActionBarService', 'ICM_ASSETS_URL', 'EmailTemplateService', 'mwBannerService', 'UserActivityService', ContactManagerOutreachListController]);

    function ContactManagerOutreachListController($scope, DialogService, translationService, ICMUserService, ICMEmailService, $location, $translate, $mdDialog, OutreachListFactory, CoreUserService, OutreachService, $q, ContactManagerNavigationService, EmailAnalyticsService, OutreachBannerService, ActionBarService, ICM_ASSETS_URL, EmailTemplateService, mwBannerService, UserActivityService) {
        var _this = this;

        this.mwBannerService = mwBannerService;
        this.$scope = $scope;
        this.ICM_ASSETS_URL = ICM_ASSETS_URL;
        this.DialogService = DialogService;
        this.translationService = translationService;
        this.ICMUserService = ICMUserService;
        this.ICMEmailService = ICMEmailService;
        this.EmailTemplateService = EmailTemplateService;
        this.OutreachListFactory = new OutreachListFactory();
        this.$location = $location;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.emptyStateVisible = false;
        this.isPermissions = false;
        this.OutreachService = OutreachService;
        this.$q = $q;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.CoreUserService = CoreUserService;
        this.OutreachBannerService = OutreachBannerService;
        this.ActionBarService = ActionBarService;
        this.selectedItems = [];
        this.outreachEmailQueryPageSize = 25;
        this.totalEmails = 0;
        this.sortFieldMap = {
            subject: 'subject',
            approvedSenderName: 'approvedSender.name',
            scheduledDateStamp: 'scheduledDate',
            status: 'status'
        };
        this.EmailAnalyticsService = EmailAnalyticsService;
        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
            this._enableComposeButton();
        }.bind(this));

        /**
         * Initialize the Array of emails.  This will be populated under getEmails() in this file.
         * @type {Array}
         */
        this.outreachEmails = [];
        this.activeTab = 'outreaches';
        this.outreachTab = 'outreaches';
        this.templateTab = 'templates';
        this.outreachTabString = this.$translate.instant('icm-outreach__template--outreaches-tab');
        this.templateTabString = this.$translate.instant('icm-outreach__template--templates-tab');
        this.pageNumber = this.$location.search().page ? parseInt(this.$location.search().page) : 0;
        this.sortField = this.$location.search().sortField;
        this.sortOrder = this.$location.search().sortOrder;
        this.filterByStatusType = this.$location.search().filterByStatusType || undefined;
        this.findText = this.$location.search().findText || undefined;
        this.isInitializing = true;
        this.getEmails(this.pageNumber, this.sortOrder, this.sortField, this.filterByStatusType, this.findText).then(function () {
            this.isInitializing = false;
        }.bind(this)); // Initiating call to get all outreach emails list

        this.$scope.$on('$locationChangeStart', function () {
            this.DialogService.removeFlashMessageByClassName('relevantMessage');
        }.bind(this));

        this._getCompanyAggregations();

        this.approveSenderLoading = true;
        this.approvedSenderList = [];
        this.getApprovedSenders().then(function (approvedSendersList) {
            this.approvedSenderList = approvedSendersList;
            if (this.approvedSenderList.length > 0) {
                //Getting unique domains from the approvedSendersList
                var domainNames = _.chain(approvedSendersList).map(function (sender) {
                    return sender.email.split('@').pop();
                }).uniq().value();
                this.OutreachBannerService.checkVerifiedDomains(domainNames, { attachTo: '.banner-space' });
            }
        }.bind(this)).catch(function (error) {
            // shouldn't show an error if it unapproved or request is pending
            if (error !== 'unapproved' && error !== 'request_pending') {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        }.bind(this));

        // For the action bar
        this.actions = [{
            label: this.$translate.instant('icm-outreach__email-list--compose-email-button'),
            doNotDisableActions: true,
            tutorialId: 'icm-outreach__email-list--compose-email-button',
            onClick: function onClick() {
                _this.compose();
            },
            enabled: true
        }];

        this.actions = [{
            label: this.$translate.instant('icm-outreach__email-list--compose-email-button'),
            doNotDisableActions: true,
            tutorialId: 'icm-outreach__email-list--compose-email-button',
            onClick: function onClick() {
                _this.compose();
            },
            enabled: true
        }, {
            label: this.$translate.instant('icm-outreach__email-list--create-template-button'),
            doNotDisableActions: true,
            onClick: function onClick($event) {
                _this.preCreateTemplate($event);
            },
            enabled: true
        }];

        angular.element('.tinymceLib').remove();
        var tiny5 = document.createElement('script');
        tiny5.setAttribute('class', 'tinymceLib');
        tiny5.setAttribute('src', this.ICM_ASSETS_URL + 'client/js/lib/tinymce_v5/tinymce_v5.min.js');
        document.head.appendChild(tiny5);

        this.ActionBarService.registerActions(this.actions);

        // handle linking directly to the outreach page with the create template modal opened
        if (this.$location.hash() === 'createTemplate') {
            this.preCreateTemplate();
        }
        // handle linking directly into icm-web app with the fake compose modal open
        //   using this redirect approach so that when closing the modal it takes you back to the
        //   outreach list page. otherwise, since we came from outside of the app, it takes the
        //   user back to the icm landing page
        if (this.$location.hash() === 'composeEmail') {
            this.$location.url('/outreach/compose');
        }

        UserActivityService.trackOutreachListPage();
    }

    ContactManagerOutreachListController.prototype.translatedTemplateTabString = function translatedTemplateTabString() {
        this.templateCount = this.EmailTemplateService.getTemplates().length;
        if (this.templateCount) {
            return this.templateTabString + ' (' + this.templateCount + '/50)';
        }
        return this.templateTabString;
    };

    ContactManagerOutreachListController.prototype.showTemplateLimitModel = function showTemplateLimitModel(action, ev, id, state) {
        var _this2 = this;

        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                stopNotification: false,
                templateCount: this.templateCount
            },
            template: '<md-dialog id="template-warnings-mini-modal" class="mw-mini-modal" aria-label="" layout="column">\n                        <template-warning class="mw-mini-modal-wrapper" stop-notification="$ctrl.stopNotification" template-count="$ctrl.templateCount" layout="column"></delete-medialist>\n                    </md-dialog>',
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then(function (data) {
            if (data && data.stopNotification === true) {
                _this2._getAppSettings().then(function (contactSettings) {
                    var newSettings = Object.assign(contactSettings, { showTemplateWarning: false });
                    _this2.ICMUserService.setAppSettings('contacts', newSettings);
                });
            }

            if (action) {
                switch (action) {
                    case 'create':
                        _this2.createTemplate(ev);
                        break;
                    case 'update':
                        _this2.updateTemplate(ev, id, state);
                        break;
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.showTemplateLimitWarning = function showTemplateLimitWarning(action, ev, id, state) {
        var _this3 = this;

        this._getAppSettings().then(function (contactSettings) {
            var showTemplateWarning = true;
            if (contactSettings && contactSettings.showTemplateWarning === false) {
                showTemplateWarning = false;
            }
            if (showTemplateWarning) {
                _this3.showTemplateLimitModel(action, ev, id, state);
            } else {
                switch (action) {
                    case 'create':
                        _this3.createTemplate(ev);
                        break;
                    case 'update':
                        _this3.updateTemplate(ev, id, state);
                        break;
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype._getAppSettings = function _getAppSettings() {
        var _this4 = this;

        return new Promise(function (resolve, reject) {
            _this4.CoreUserService.getCurrent(true).then(function (currentUser) {
                resolve(_this4.ICMUserService.getAppSettings('contacts', currentUser._id));
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    ContactManagerOutreachListController.prototype._enableComposeButton = function _enableComposeButton() {
        if (this.isPermissions && !this.approveSenderLoading) {
            angular.element('.action-bar-button').removeAttr('disabled');
        }
    };

    ContactManagerOutreachListController.prototype._getCompanyAggregations = function _getCompanyAggregations() {
        var _this5 = this;

        // Get our splits while they're hot.
        var emptyStatDisplay = '--';

        this.distributionCount = emptyStatDisplay;
        this.openRate = emptyStatDisplay;
        this.clickToOpenRate = emptyStatDisplay;
        this.unsubscribedRate = emptyStatDisplay;

        this.EmailAnalyticsService.getCompanyAggregations().then(function (results) {
            if (results) {
                if (Number.isFinite(results.distributions)) {
                    _this5.distributionCount = results.distributions.toString();
                }

                if (Number.isFinite(results.openRate)) {
                    _this5.openRate = results.openRate + '%';
                }

                if (Number.isFinite(results.clickRate)) {
                    _this5.clickToOpenRate = results.clickRate + '%';
                }

                if (Number.isFinite(results.unsubscribeRate)) {
                    _this5.unsubscribedRate = results.unsubscribeRate + '%';
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.onPage = function onPage(page) {
        return this.getEmails(page - 1, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
    };

    ContactManagerOutreachListController.prototype.getEmails = function getEmails(page, sortOrder, sortField, filterByType, findText) {
        var that = this,
            step = 0;
        sortField = this.sortFieldMap[sortField] || sortField;

        if (page && page > 0) {
            this.$location.search('page', page); //for back button support, if it's 0, we don't set the query param
            step = page;
        } else {
            this.$location.search('page', null);
        }
        return this.OutreachListFactory.getAllEmails(undefined, undefined, sortField, sortOrder, page, this.outreachEmailQueryPageSize, filterByType, findText).then(function (res) {
            if (res.hits && res.hits.length > 0) {
                that.outreachEmails = res.hits;
                if (res.total && res.total > 0) {
                    that.totalEmails = res.total;
                }
            } else {
                that.emptyStateVisible = true;
                that.outreachEmails = [];
                that.totalEmails = 0;
            }
        });
    };

    ContactManagerOutreachListController.prototype.onFilterByStatus = function onFilterByStatus(filterByType) {
        if (filterByType === '') {
            filterByType = undefined;
        }
        if (filterByType) {
            this.$location.search('filterByStatusType', filterByType); //for back button support, if it's 0, we don't set the query param
            this.filterByStatusType = filterByType;
        } else {
            this.filterByStatusType = null;
            this.$location.search('filterByStatusType', null);
        }

        if (!this.isInitializing) {
            return this.getEmails(0, this.sortOrder, this.sortField, filterByType, this.findText);
        } else {
            return this.$q.when('done');
        }
    };

    ContactManagerOutreachListController.prototype.onFindTextChange = function onFindTextChange(findText) {
        if (typeof findText !== 'string') {
            return;
        }

        if (findText.length >= 3) {
            this.$location.search('findText', findText); //for back button support, if it's 0, we don't set the query param
            this.findText = findText;
            return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
        } else if (findText.length === 0) {
            this.$location.search('findText', null);
            this.findText = null;
            return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
        }
    };

    ContactManagerOutreachListController.prototype.onDelete = function (event, itemIdArr) {
        var deleteEmailDialogTitle = this.translationService.getLocalizedString('Delete Email?'),
            template = 'icm-web/views/partials/delete_email_distribution_dialog',
            payload = {
            data: {}
        };

        this.DialogService.dialog(deleteEmailDialogTitle, template, payload, function () {
            if (itemIdArr.length) {
                this.OutreachService.deleteOutreachEmail(itemIdArr).then(function () {
                    this.selectedItems = [];
                    this.pageNumber = 0;
                    this.getEmails(this.pageNumber, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
                }.bind(this)).catch(function () {
                    this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                }.bind(this));
            }
        }.bind(this));
    };

    ContactManagerOutreachListController.prototype.onDuplicate = function (event, item) {
        if (Object.prototype.toString.call(item) === '[object Object]' && item !== null) {
            this.compose(item, 'duplicate');
        }
    };

    ContactManagerOutreachListController.prototype.duplicateTemplate = function duplicateTemplate(ev, id) {
        if (this.templateCount === 50) {
            return this.showTemplateLimitModel();
        } else if (this.templateCount > 44) {
            return this.showTemplateLimitWarning('update', ev, id, 'duplicate');
        } else {
            return this.updateTemplate(ev, id, 'duplicate');
        }
    };

    ContactManagerOutreachListController.prototype.updateTemplate = function updateTemplate(ev, id, state) {
        var _this6 = this;

        this.EmailTemplateService.getTemplateById(id).then(function (response) {
            var data = _this6.EmailTemplateService.populateTemplate(response.data);
            _this6.$mdDialog.show({
                template: '<mw-outreach-template on-callback="$ctrl.onCallback()" approved-senders="$ctrl.approvedSenderList" template-id="$ctrl.templateId" template-title="$ctrl.templateTitle" template-body="$ctrl.templateBody"></mw-outreach-template>',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl',
                bindToController: true,
                locals: {
                    approvedSenderList: _this6.approvedSenderList,
                    templateId: state === 'duplicate' ? '' : data.id,
                    templateTitle: state === 'duplicate' ? '' : data.title,
                    templateBody: data.body,
                    onCallback: function onCallback() {
                        _this6.$scope.$broadcast('updateTemplates');
                    }
                }
            });
        }).catch(function (error) {
            if (error.data === 'Template not found') {
                _this6.deletedTemplateWarning();
            } else {
                _this6.DialogService.flashError(_this6.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        });
    };

    ContactManagerOutreachListController.prototype.preCreateTemplate = function preCreateTemplate(ev) {
        if (this.templateCount === 50) {
            return this.showTemplateLimitModel();
        } else if (this.templateCount > 44) {
            return this.showTemplateLimitWarning('create', ev);
        } else {
            return this.createTemplate(ev);
        }
    };

    ContactManagerOutreachListController.prototype.createTemplate = function createTemplate(ev) {
        var _this7 = this;

        this.$mdDialog.show({
            template: '<mw-outreach-template on-callback="$ctrl.onCallback()" approved-senders="$ctrl.approvedSenderList"></mw-outreach-template>',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl',
            bindToController: true,
            locals: {
                approvedSenderList: this.approvedSenderList,
                onCallback: function onCallback() {
                    _this7.$scope.$broadcast('updateTemplates');
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.deletedTemplateWarning = function () {
        var _this8 = this;

        this.$mdDialog.show(this.$mdDialog.mwConfirm().title(this.$translate.instant('icm-outreach__template-deleted-warning--header')).textContent(this.$translate.instant('icm-outreach__template-deleted-warning--body')).ok(this.$translate.instant('OK')).cancel(this.$translate.instant('Cancel'))).then(function () {
            _this8.$mdDialog.hide();
            _this8.$scope.$broadcast('refreshTemplatesSelected');
            _this8.preCreateTemplate();
        }, function () {
            _this8.$mdDialog.cancel();
        });
    };

    ContactManagerOutreachListController.prototype.composeWithTemplate = function composeWithTemplate(templateId) {
        var _this9 = this;

        this.EmailTemplateService.getTemplateById(templateId).then(function () {
            if (Array.isArray(_this9.approvedSenderList) && _this9.approvedSenderList.length) {
                _this9.$location.url('/outreach/compose?templateId=' + templateId);
                _this9.$scope.$apply();
            } else {
                _this9.showEmailUnApprovedDialog();
            }
        }).catch(function (error) {
            if (error.data === 'Template not found') {
                _this9.deletedTemplateWarning();
            } else {
                _this9.DialogService.flashError(_this9.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        });
    };

    ContactManagerOutreachListController.prototype.compose = function compose(distribution, state) {
        if (Array.isArray(this.approvedSenderList) && this.approvedSenderList.length) {
            this.composeEmail(this.approvedSenderList, distribution, state);
        } else {
            this.showEmailUnApprovedDialog();
        }
    };

    ContactManagerOutreachListController.prototype.getApprovedSenders = function getApprovedSenders() {
        var defer = this.$q.defer();

        this.ICMEmailService.getIcmApprovedSenders().then(function afterSuccess(sendersList) {
            var approvedSenderList = [];
            this.approveSenderLoading = false;
            this._enableComposeButton();
            if (sendersList.length) {
                for (var i = 0; i < sendersList.length; i++) {
                    /*jshint camelcase:false*/
                    if (sendersList[i].is_approved) {
                        approvedSenderList.push(sendersList[i]);
                    }
                }

                if (approvedSenderList.length) {
                    defer.resolve(approvedSenderList);
                } else {
                    defer.reject('request_pending');
                }
            } else {
                defer.reject('unapproved');
            }
        }.bind(this)).catch(function afterFail() {
            defer.reject();
        }.bind(this));

        return defer.promise;
    };

    ContactManagerOutreachListController.prototype.showEmailUnApprovedDialog = function showEmailUnApprovedDialog() {
        var dialogTitle = this.translationService.getLocalizedString('Compose Email');

        this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
            this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
        }.bind(this));
    };

    ContactManagerOutreachListController.prototype.composeEmail = function composeEmail(senderObjects, distribution, state) {
        var distributionParam = '';
        this.ICMEmailService.resetRecipients();
        this.ICMEmailService.setSender(senderObjects);
        distributionParam += distribution && distribution._id ? '/' + distribution._id : '';
        distributionParam += state ? '/' + state : '';

        this.$location.path('/outreach/compose' + distributionParam);
    };

    ContactManagerOutreachListController.prototype.onSortChange = function onSortChange(sortField, sortOrder) {
        var sortFieldKey = sortField.replace('-', '');
        this.sortField = this.sortFieldMap[sortFieldKey];
        this.sortOrder = sortOrder ? 'DESC' : 'ASC';
        this.$location.search('sortField', sortFieldKey);
        this.$location.search('sortOrder', this.sortOrder);

        return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
    };

    ContactManagerOutreachListController.prototype.changeActiveTab = function changeActiveTab(tab) {
        if (tab === this.templateTab) {
            this.$scope.$broadcast('updateTemplates');
        }
        this.activeTab = tab;
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerOutreachStatsAnalyticsController', ['MW.Framework.TranslationService', 'MW.Framework.PredictionPanelService', 'MW.Framework.ContentStreamSelectionDecorator', 'MW.ContactManager.ContactManagerActionBarFactory', 'MW.Framework.ICMEmailService', 'MW.Framework.GenericHighchart', 'CoreChartObject', 'MW.Framework.CoreCommon', 'MW.ContactManager.TransformOutreachStatsChart', 'ngSanitize', 'CoreColorService', 'MW.Configuration', 'MW.CoreStream.CsSelectAllHeader', 'MW.Influencers.IcmDialogService']).controller('ContactManagerOutreachStatsAnalyticsController', ['translationService', 'PredictionPanelService', 'ContactManagerActionBarFactory', 'ICMEmailService', 'DialogService', 'Contact', 'ContentStreamSelectionDecorator', 'CoreChartObject', 'CoreCommon', 'TransformOutreachStatsChartService', 'CoreColorService', '$sce', ContactManagerOutreachStatsAnalyticsController]);

    function ContactManagerOutreachStatsAnalyticsController(translationService, PredictionPanelService, ContactManagerActionBarFactory, ICMEmailService, DialogService, Contact, ContentStreamSelectionDecorator, CoreChartObject, CoreCommon, TransformOutreachStatsChartService, CoreColorService, $sce) {
        var prepareContactData;

        this.translationService = translationService;
        this.PredictionPanelService = PredictionPanelService;
        this.CoreChartObject = CoreChartObject;
        this.CoreCommon = CoreCommon;
        this.TransformOutreachStatsChartService = TransformOutreachStatsChartService;
        this.CoreColorService = CoreColorService;
        this.$sce = $sce;
        this.DialogService = DialogService;

        this.ContactSelector = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });

        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);
        this.ICMEmailService = ICMEmailService;

        this.sortField = 'alphabetically';
        this.predictionContactFilter = {};
        this.predictionContactValues = [];
        this.contactPredictionPanelExpanded = false;
        this.enableAddtoList = false;
        this.Contact = Contact;
        this.allText = this.translationService.getLocalizedString('All');

        this._setupContactPredictionValues = function _setupContactPredictionValues() {
            this.predictionContactValues = this.PredictionPanelService.buildContactPredictionValues(this.ContactStreamData.contactArray);
        };

        this.showActionButtons = function showActionButtons() {
            var keys = Object.keys(this.ContactSelector.selectedItems);
            return keys.length > 0;
        };

        /**
         * @description Processing Query to get response for contactIds
         *
         * @param [array] Contact Ids Array
         * @param [array] Email Address Array
         * @param {object} recipientsMap object
         */
        this.processQuery = function processQuery(contactIdsArray, emailAddressArray, recipientsMap) {
            var query = {},
                processQueryPayload = {},

            // if you have a list over this size you're not going to have a good time - GYDA-25723
            amountToDisplayProperlySize = 1000;

            query = { 'anyKeywords': contactIdsArray, 'page': 0, 'pageSize': amountToDisplayProperlySize };
            processQueryPayload = { 'contactIdsArray': contactIdsArray, 'emailAddressArray': emailAddressArray, 'recipientsMap': recipientsMap };

            this.ContactStreamData.getByContactIds(query).then(function (response) {
                this.processContactArray(response, processQueryPayload);
                this._setupContactPredictionValues();
            }.bind(this));
        };

        /**
         * @description Processing Contact Array on the basis of response of contactIds and QueryPayload
         *
         * @param [array] contact Result Array is hits array
         * @param {object} Query Payload object
         */
        this.processContactArray = function processContactArray(contactResultArray, queryPayload) {
            var contactObjMap = {},
                removedContactIds = [],
                i;

            //creating contact object map, passing whole contact object mapping to contact id
            for (i = 0; i < contactResultArray.hits.length; i++) {
                contactObjMap[contactResultArray.hits[i].id] = contactResultArray.hits[i];
            }

            //checking of contact in contactObjMap and pushing in removedContactIds if undefined
            for (i = 0; i < queryPayload.contactIdsArray.length; i++) {
                if (!contactObjMap[queryPayload.contactIdsArray[i]]) {
                    removedContactIds.push(queryPayload.contactIdsArray[i]);
                }
            }

            // pushing emailAddress of removed contact id to emailAddressArray
            if (removedContactIds && queryPayload.recipientsMap) {
                for (i = 0; i < removedContactIds.length; i++) {
                    if (queryPayload.recipientsMap[removedContactIds[i]]) {
                        queryPayload.emailAddressArray.push(queryPayload.recipientsMap[removedContactIds[i]]);
                    }
                }
            }

            queryPayload.emailAddressArray.sort();

            //call addOtherContactsToArray function to create particuler contact with email
            if (queryPayload.emailAddressArray) {
                for (i = 0; i < queryPayload.emailAddressArray.length; i++) {
                    this.addOtherContactsToArray(contactResultArray, queryPayload.emailAddressArray[i]);
                }
            }

            //setting final created contactArray to ContactStreamData.contactArray
            if (contactResultArray.hits) {
                this.ContactStreamData.contactArray = contactResultArray.hits;
            }
        };

        /**
         * @description adding Other type Contacts To Array
         *
         * @param [array] contact Result Array is hits array
         * @param {string} Email Address string
         */
        this.addOtherContactsToArray = function addOtherContactsToArray(contactResultArray, emailAddress) {
            contactResultArray.hits.push(new this.Contact({
                contactInfo: {
                    email: [{
                        address: emailAddress,
                        _quiddityType: 'common.Email',
                        type: 'work'
                    }]
                },
                id: 'other_contact_' + this.ContactStreamData.totalContacts,
                systemData: {}
            }));
            this.ContactStreamData.totalContacts++;
        };

        this.resetSelections = function resetSelections() {
            this.ContactSelector.deselectAll();
        };

        /**
         * @description Prepareing contactIdsArray, recipientsMap and emailAddressArray
         *
         * @param {object} contact object
         * @param [array] existingContactIds Array
         * @param [array] existingEmailAddress Array
         */
        prepareContactData = function prepareContactData(contactObj, existingContactIds, existingEmailAddress) {
            var contactIdsArray = existingContactIds || [],
                emailAddressArray = existingEmailAddress || [],
                recipientsMap = {};
            if (contactObj.contactId) {
                contactIdsArray.push(contactObj.contactId);
                recipientsMap[contactObj.contactId] = contactObj.emailAddress;
            } else {
                emailAddressArray.push(contactObj.emailAddress);
            }

            return {
                contactIdsArray: contactIdsArray,
                emailAddressArray: emailAddressArray,
                recipientsMap: recipientsMap
            };
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerOutreachViewController', ['MW.ContactManager.OutreachService', 'MW.Framework.ContentStreamDataFactory', 'MW.Influencers.IcmDialogService', 'MW.Framework.CoreUserService', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.MomentService', 'MW.ContactManager.ContactManagerActionBarFactory', 'MW.ContactManager.ContactManagerOutreachStatsAnalyticsController', 'ngRoute', 'ngMaterial', 'MW.Configuration', 'MW.CoreStream.CsSelectAllHeader', 'CoreChartObject', 'CoreColorService', 'MW.CoreStream.ContactManagerTagService', 'MW.Framework.InfluencerContactService', 'MW.Influencers.SegmentTrackingService', 'MW.Influencers.EmailAnalyticsService', 'MW.Influencers.IcmUnsubscribeService', 'MW.Framework.ICMEmailService', 'MW.Framework.ICMEntitlementService']).controller('ContactManagerOutreachViewController', ['$rootScope', '$scope', 'emailId', 'approvedSenders', 'OutreachService', 'DialogService', '$sce', '$location', 'moment', '$routeParams', 'ContactStreamDataFactory', 'CoreUserService', 'ContactManagerActionBarFactory', 'ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS', '$controller', '$timeout', 'ContactManagerNavigationService', 'ICM_WEB_PROXY_PREFIX', 'CoreChartObject', 'CoreColorService', 'MAX_MEDIALIST_LIMIT', '$translate', 'ContactManagerTagService', '$q', '$mdDialog', 'InfluencerContactService', 'SegmentTrackingService', 'EmailAnalyticsService', 'IcmUnsubscribeService', 'ICMEmailService', 'ICMEntitlementService', 'RECIPIENT_TRACKING_CHECKS', 'IRM_BASE_URL', ContactManagerOutreachViewController]);

    function ContactManagerOutreachViewController($rootScope, $scope, emailId, approvedSenders, OutreachService, DialogService, $sce, $location, moment, $routeParams, ContactStreamDataFactory, CoreUserService, ContactManagerActionBarFactory, ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS, $controller, $timeout, ContactManagerNavigationService, ICM_WEB_PROXY_PREFIX, CoreChartObject, CoreColorService, MAX_MEDIALIST_LIMIT, $translate, ContactManagerTagService, $q, $mdDialog, InfluencerContactService, SegmentTrackingService, EmailAnalyticsService, IcmUnsubscribeService, ICMEmailService, ICMEntitlementService, RECIPIENT_TRACKING_CHECKS, IRM_BASE_URL) {
        var _this2 = this;

        var getRequestParams, ContactManagerOutreachStatsAnalyticsController;

        ContactManagerOutreachStatsAnalyticsController = $controller('ContactManagerOutreachStatsAnalyticsController', {});

        angular.extend(this, ContactManagerOutreachStatsAnalyticsController);

        this.shouldTrack = approvedSenders.some(function (sender) {
            return sender.shouldTrack === true;
        });

        this.previousPage = ContactManagerNavigationService.getPreviousLocation();
        this.SegmentTrackingService = SegmentTrackingService;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$routeParams = $routeParams;
        this.$location = $location;
        this.$timeout = $timeout;
        this.OutreachService = OutreachService;
        this.EmailAnalyticsService = EmailAnalyticsService;
        this.UnsubscribeService = IcmUnsubscribeService;
        this.DialogService = DialogService;
        this.$sce = $sce;
        this.moment = moment;
        this.elevioIdsObj = ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS;
        this.CoreChartObject = CoreChartObject;
        this.distributionId = emailId;
        this.CoreColorService = CoreColorService;
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.$translate = $translate;
        this.ContactManagerTagService = ContactManagerTagService;
        this.InfluencerContactService = InfluencerContactService;
        this.ICMEmailService = ICMEmailService;
        this.ICMEntitlementService = ICMEntitlementService;
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.CoreUserService = CoreUserService;
        this.RECIPIENT_TRACKING_CHECKS = RECIPIENT_TRACKING_CHECKS;
        this.IRM_BASE_URL = IRM_BASE_URL;

        this.unsubscribeDropDownOptions = [{ id: 'all', name: this.$translate.instant('All') }, { id: 'frequency', name: this.$translate.instant('Emails come too frequently') }, { id: 'irrelevant', name: this.$translate.instant('Emails are not relevant') }, { id: 'spam', name: this.$translate.instant('Emails are spam') }, { id: 'none', name: this.$translate.instant('No specific reason') }, { id: 'other', name: this.$translate.instant('Other') }];
        this.selectedUnsubscribeOption = this.unsubscribeDropDownOptions[0];

        this.clickToOpenDropDownOptions = [];
        this.selectedClickToOpenOption = {};

        // translations
        this.previewText = this.$translate.instant('Preview');
        this.allText = this.$translate.instant('All');
        this.openRateText = this.$translate.instant('Open Rate');
        this.clickToOpenRateText = this.$translate.instant('Click to Open Rate');
        this.unsubscribeRateText = this.$translate.instant('mw-outreach-collection__engagement-widget-unsubscribe-rate');
        this.unsubscribeText = this.$translate.instant('Unsubscribe');

        this.firstFourtyEightText = this.$translate.instant('icm-outreach-stats__first-fourty-eight');
        this.moreRecipientsText = this.$translate.instant('more recipients...');
        this.errorMessageText = this.$translate.instant('Unable to retrieve email');
        this.notAvailableText = this.$translate.instant('N/A');
        this.lastActivityText = this.$translate.instant('Last activity');

        this.emailInfo = '';
        this.scheduledMomentDate = '';
        this.countLabel = '';
        this.pageTitle = 'Sent Email';
        this.isFirstFourtyEight = true;
        this.failedRetrievingStats = false;
        this.readyToLoadView = false;
        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);

        this.ContactStreamData = new ContactStreamDataFactory();

        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this));

        this.isInfluencerAppEntitled = false;
        if (this.CoreUserService.isInfluencerAppEntitled === '') {
            this.ICMEntitlementService.getInfluencerAppEntitlement().then(function getAccountEntitlementThen(entitlement) {
                if (entitlement) {
                    this.isInfluencerAppEntitled = true;
                }
            }.bind(this));
        } else if (this.CoreUserService.isInfluencerAppEntitled) {
            this.isInfluencerAppEntitled = true;
        }

        this.subNavItems = [{
            name: this.previewText,
            route: 'preview',
            data: ''
        }, {
            name: this.openRateText,
            route: 'open_rate',
            data: ''
        }, {
            name: this.clickToOpenRateText,
            route: 'click_to_open_rate',
            data: ''
        }, {
            name: this.unsubscribeText,
            route: 'unsubscribe',
            data: ''
        }];

        /*jshint camelcase:false*/
        this.viewPartials = {
            preview: 'icm-web/views/partials/outreach_stats_preview',
            open_rate: 'icm-web/views/partials/outreach_stats_open_rate',
            click_to_open_rate: 'icm-web/views/partials/outreach_stats_click_to_open_rate',
            unsubscribe: 'icm-web/views/partials/outreach_stats_unsubscribe'
        };

        this.outreachStats = {
            openRate: '--',
            clickToOpenRate: '--',
            unsubscribeRate: '--',
            open: 0,
            click: 0,
            unsubscribe: 0,
            delivered: 0
        };
        this.toField = [];

        if (!this.$routeParams.view || !this.subNavItems.some(function (navItem) {
            return navItem.route === this.$routeParams.view;
        }.bind(this))) {
            $timeout(function () {
                this.$location.search('view', 'preview');
                this.loadView(this.$routeParams.view);
            }.bind(this), 500);
        } else {
            this.loadView(this.$routeParams.view);
        }

        getRequestParams = function getRequestparams(url) {
            var params = {},
                pathStr = url.split('?')[0],
                searchStr = url.split('?')[1],
                pathWithoutHost = url.replace($location.protocol() + '://' + location.host, ''),
                prefixRegEx = ICM_WEB_PROXY_PREFIX ? new RegExp('^\/?' + ICM_WEB_PROXY_PREFIX) : '';

            if (searchStr !== undefined) {
                var paramsStr = searchStr.split('&');
                for (var key in paramsStr) {
                    if (paramsStr.hasOwnProperty(key)) {
                        params[paramsStr[key].split('=')[0]] = paramsStr[key].split('=')[1];
                    }
                }
            }
            return {
                path: pathStr,
                params: params,
                pathWithoutHost: pathWithoutHost,
                url: pathWithoutHost.replace(prefixRegEx, '')
            };
        };

        this.$scope.$on('$locationChangeStart', function (event, newLocation, oldLocation) {
            var newLocationObject = getRequestParams(newLocation),
                oldLocationObject = getRequestParams(oldLocation);

            // when paths are the same, it means we are switching "sub-nav" views within the full screen email preview
            if (newLocationObject.path === oldLocationObject.path) {
                this.ContactSelector.deselectAll();
                this.loadView(newLocationObject.params.view);
            }
            // else - means we should have attempted to close the preview and head back to the outreach page. this should be handled by the closeStats method attached to the "X" button on the preview page
        }.bind(this));
        this.ICMEntitlementService.getIcmContactExportLimit().then(function (entitlementLimit) {
            _this2.exportLimit = entitlementLimit;
        });

        this._prepareOpenRateDropdown();
        this.getEmailById(emailId);
        this.getOutreachStatsById(emailId);
    }

    ContactManagerOutreachViewController.prototype.getEmailById = function getEmailById(emailId) {
        this.OutreachService.getEmailById(emailId).then(function (response) {
            var _contactLabel = response.recipients.length === 1 ? 'icm-outreach__emails--single-contact' : 'icm-outreach__emails--multiple-contacts',
                medialistsArray = [],
                recipientsArray = [],
                recipients = [],
                mediaListKeysArray = [],
                medialistName;

            this.emailInfo = response;
            this.scheduledMomentDate = this.moment(this.emailInfo.scheduledDate).format('ddd, D MMM YYYY') + ' ' + new Date(this.emailInfo.scheduledDate).toTimeString().replace(/GMT/ig, '');
            this.previewBodyHtml = this.$sce.trustAsHtml(this.emailInfo.bodyHtml);
            this.dateRangeFromCreation = this.moment(this.emailInfo.created).format('MMMM D, YYYY') + ' - ' + this.moment().format('MMMM D, YYYY');
            this.countLabel = this.$translate.instant(_contactLabel, { recipientCount: this.emailInfo.recipients.length });
            // To fetch medialists name
            if (this.emailInfo && this.emailInfo.recipientsMetaData && this.emailInfo.recipientsMetaData.mediaLists) {
                medialistName = this.emailInfo.recipientsMetaData.mediaLists;
                mediaListKeysArray = Object.keys(medialistName);
                for (var j = 0; j < mediaListKeysArray.length; j++) {
                    var len,
                        mediaListRecipients = [],
                        comparator;
                    if (medialistName[mediaListKeysArray[j]].recipients) {
                        len = medialistName[mediaListKeysArray[j]].recipients.length;
                        comparator = len <= 5 ? len : 5;
                        for (var val = 0; val < comparator; val++) {
                            mediaListRecipients.push(medialistName[mediaListKeysArray[j]].recipients[val].email);
                        }
                    }
                    mediaListRecipients = mediaListRecipients.toString().replace(/,/g, '\n');
                    if (len > 5) {
                        mediaListRecipients += '\n' + (len - 5) + ' ' + this.moreRecipientsText;
                    }
                    medialistsArray.push({
                        name: medialistName[mediaListKeysArray[j]].name + ' (' + len + ')',
                        recipients: mediaListRecipients
                    });
                }
                this.toField.mediaListNames = medialistsArray;
            }

            // To fetch recipients name
            if (this.emailInfo && this.emailInfo.recipientsMetaData && this.emailInfo.recipientsMetaData.recipients) {
                recipients = this.emailInfo.recipientsMetaData.recipients;
                for (var k = 0; k < recipients.length; k++) {
                    recipientsArray.push({
                        name: recipients[k].name,
                        email: recipients[k].email
                    });
                }
                this.toField.contactRecipients = recipientsArray;
            }

            if (!this.outreachStatsDetailToggle) {
                this.isFirstFourtyEight = this.moment(response.scheduledDate) > this.moment().subtract(48, 'hours');
            }
        }.bind(this)).catch(function () {
            this.DialogService.flashError(this.errorMessageText);
        }.bind(this));
    };

    ContactManagerOutreachViewController.prototype.getOutreachStatsById = function getOutreachStatsById(distributionId) {
        var _this3 = this;

        var promises = [],
            statsObject = void 0;

        promises.push(this.EmailAnalyticsService.getStatsCount(distributionId, 'all'));
        promises.push(this.UnsubscribeService.getDistributionUnsubscribeTotal(distributionId));

        var _formatRate = function _formatRate(dividend, divisor) {
            return Math.min(Number((dividend / divisor * 100).toFixed(2)), 100);
        };

        return new Promise(function (resolve, reject) {
            Promise.all(promises).then(function (objects) {
                var stats = objects[0],
                    unsubscribe = objects[1],
                    open = stats.open || 0,
                    delivered = stats.delivered || 0,
                    click = stats.click || 0,
                    openRate = stats.openRate,
                    ctoRate = stats.ctoRate,
                    unsubscribeRate = 0;

                if (delivered > 0) {
                    unsubscribeRate = _formatRate(unsubscribe, delivered);
                }

                statsObject = {
                    openRate: openRate,
                    ctoRate: ctoRate,
                    unsubscribeRate: unsubscribeRate,
                    open: open,
                    click: click,
                    unsubscribe: unsubscribe,
                    delivered: delivered
                };
                return _this3.setEmailAnalytics(statsObject);
            }).then(function () {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    };

    ContactManagerOutreachViewController.prototype.setEmailAnalytics = function setEmailAnalytics(stats) {
        var _this4 = this;

        return new Promise(function (resolve) {
            _this4.outreachStats = stats;
            _this4.subNavItems[1].data = '(' + _this4.outreachStats.openRate + '%)';
            _this4.subNavItems[2].data = '(' + _this4.outreachStats.ctoRate + '%)';
            _this4.subNavItems[3].data = '(' + _this4.outreachStats.unsubscribeRate + '%)';

            _this4.readyToLoadView = true;
            _this4.loadView(_this4.view);
            resolve();
        });
    };

    /**
     * Redirect to outreach page on stats close
     */
    ContactManagerOutreachViewController.prototype.closeStats = function closeStats() {
        angular.element('.outreachStatsContainer').addClass('hideContainer');

        // if the ref was "cp" that means we need to navigate back to Media Relations Contact Profile. since this is a separate web app
        //   the previous page logic doesn't work here. we'll grab the ID and redirect
        var shouldGoBackToMrContactProfile = this.$location.search().ref === 'cp' && this.$location.search().id;

        //Let the animation complete
        this.$timeout(function () {
            // if we came from an app page, go back there
            // else go home
            if (shouldGoBackToMrContactProfile) {
                window.location.href = this.IRM_BASE_URL + '/contact/' + this.$location.search().id;
            } else if (this.previousPage && this.previousPage.indexOf('/login/success') === -1) {
                this.$location.url(this.previousPage);
            } else {
                this.$location.url('/');
            }
        }.bind(this), 300);
    };

    ContactManagerOutreachViewController.prototype.loadView = function loadView(view) {
        var _this5 = this;

        this.view = view;
        this.currentView = this.viewPartials[view];

        if (this.readyToLoadView) {
            if (view === 'open_rate') {
                this.EmailAnalyticsService.getStatsCount(this.distributionId, 'open').then(function (openData) {
                    _this5._buildOpenRateChartAnalytics(openData);
                });
            } else if (view === 'click_to_open_rate') {
                this.EmailAnalyticsService.getStatsCount(this.distributionId, 'click').then(function (clickData) {
                    _this5._buildClickToOpenRateChartAnalytics(clickData);
                });
            } else if (view === 'unsubscribe') {
                this._buildUnsubscribeChartAnalytics();
            }
        }
    };

    ContactManagerOutreachViewController.prototype.loadUnsubscribedContacts = function loadUnsubscribedContacts(reason) {
        var query = {
            distributionId: this.distributionId,
            appIds: 'ICM'
        };

        if (reason && reason.id && reason.id !== 'all') {
            query.reason = reason.id;
            this.selectedUnsubscribeOption = reason;
        }

        this.ContactSelector.deselectAll();
        this.ContactStreamData.getUnsubscribed(query).then(function () {
            this._setupContactPredictionValues();
        }.bind(this));
    };

    ContactManagerOutreachViewController.prototype._prepareClickToOpenDropdown = function _prepareClickToOpenDropdown(linkArray) {
        this.clickToOpenDropDownOptions = linkArray.map(function (link) {
            return { name: link };
        });

        this.clickToOpenDropDownOptions.unshift({ name: 'All' });
        this.selectedClickToOpenOption = this.clickToOpenDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype.loadClickToOpenRateContacts = function loadClickToOpenRateContacts(link) {
        var query = {
            page: 0,
            pageSize: 25,
            pathParams: {
                statType: 'click',
                distributionId: this.distributionId
            }
        };

        if (link && link.name && link.name.toLowerCase() !== 'all') {
            query.clickLink = link.name;
        }

        this.ContactSelector.deselectAll();
        this.ContactStreamData.getContactsByStat(query);
    };

    ContactManagerOutreachViewController.prototype._prepareOpenRateDropdown = function _prepareOpenRateDropdown() {
        this.uniqueOpenRateDropDownOptions = [{ id: 'all', name: this.allText }, { id: 'opened', name: this.$translate.instant('icm-outreach-stats__open-rate--opened') }, { id: 'unopened', name: this.$translate.instant('icm-outreach-stats__open-rate--unopened') }, { id: 'bounces', name: this.$translate.instant('Bounced') }];

        if (this.RECIPIENT_TRACKING_CHECKS) {
            this.uniqueOpenRateDropDownOptions.push({ id: 'untracked', name: this.$translate.instant('icm-outreach-stats__open-rate--untracked') });
        }
        this.selectedOpenRateOption = this.uniqueOpenRateDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype.loadOpenRateContacts = function loadOpenRateContacts(type) {
        var translationScope = void 0;
        var query = {
            page: 0,
            pageSize: 25,
            pathParams: {
                statType: 'open',
                distributionId: this.distributionId
            }
        };

        if (type && type.id && type.id.toLowerCase() !== 'all') {
            query.stat = type.id;
            this.selectedOpenRateOption = type;
        }

        if (this.selectedOpenRateOption.id === this.uniqueOpenRateDropDownOptions[0].id) {
            // all open types
            this.noContactsMessage = this.$translate.instant('No Contacts');
        } else {
            // specified open type
            translationScope = {
                type: this.selectedOpenRateOption.id
            };

            this.noContactsMessage = this.$translate.instant('icm-outreach__stats--no-emails-msg', translationScope);
        }
        this.ContactSelector.deselectAll();
        this.ContactStreamData.getContactsByStat(query);
    };

    ContactManagerOutreachViewController.prototype._decodeHTML = function _decodeHTML(encodedHTMLString) {
        // new $translate.instant return encoded HTML
        var div = document.createElement('div');
        div.innerHTML = encodedHTMLString;
        return div.textContent;
    };

    ContactManagerOutreachViewController.prototype._buildOpenRateChartAnalytics = function _buildOpenRateChartAnalytics(openStatsObject) {
        var openRate = this.openRateText,
            translatePayload = {
            openRateText: '<span data-elevio-inline=\'' + this.elevioIdsObj.openRateArticle + '\'>' + openRate + '</span>',
            openRatePercent: this.outreachStats.openRate,
            totalOpened: this.outreachStats.open || 0,
            deliveredMails: this.outreachStats.delivered
        },
            openRateSummary = this.$translate.instant('icm-outreach__stats--openRate-summary', translatePayload),
            chartDataObject = new this.CoreChartObject({
            type: 'column',
            view: 'max',
            percent: false,
            animate: true,
            yAxisTitle: 'Recipients'
        }),
            drilldownFunction,
            tooltipFunction;

        this.openStatsObject = openStatsObject;
        this.openRateSummary = this.$sce.trustAsHtml(this._decodeHTML(openRateSummary));

        this.openRateChartData = {};

        tooltipFunction = function tooltipFunction(categoryObj) {
            var tooltipText = '',
                translationScope = {};

            switch (categoryObj.type) {
                case 'bounces':
                    translationScope = {
                        uniqueSoftBounces: this.openStatsObject.softBounces,
                        uniqueHardBounces: this.openStatsObject.hardBounces,
                        uniqueOtherBouncesCount: this.openStatsObject.otherBounces
                    };

                    tooltipText += this.$translate.instant('icm-outreach__stats--undeliverable-summary', translationScope);

                    break;
                case 'unopened':
                case 'unread':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--unopened-text');
                    break;
                case 'opened':
                case 'seen':
                case 'skimmed':
                case 'read':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--opened-text');
                    break;
                case 'untracked':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--untracked-text');
                    break;
            }

            return tooltipText;
        }.bind(this);

        drilldownFunction = function drilldownFunction(chartDataObject) {
            var type = chartDataObject.type.toLowerCase();

            this.uniqueOpenRateDropDownOptions.some(function (openRateOption) {
                if (openRateOption.id === type) {
                    this.selectedOpenRateOption = openRateOption;
                    return true;
                }
            }.bind(this));

            this.loadOpenRateContacts(this.selectedOpenRateOption);
        }.bind(this);

        // build the graph
        this.openRateChartData = this.CoreCommon.mergeRecursive(chartDataObject, this.TransformOutreachStatsChartService.readyChartOpenRateStatsData(openStatsObject, tooltipFunction, drilldownFunction));

        // build the contact stream
        this.openRateSortField = 'date';
        this.loadOpenRateContacts();
        this.selectedOpenRateOption = this.uniqueOpenRateDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype._buildClickToOpenRateChartAnalytics = function _buildClickToOpenRateChartAnalytics(clickData) {
        var _this6 = this;

        this.ctorData = true;
        if (!clickData.length) {
            this.ctorData = false;
            return;
        }

        var clickToOpenRate = this.clickToOpenRateText,
            clickToOpenRateSummary = 'icm-outreach__stats--clickToOpen-summary',
            translationScope = {
            clickToOpenRateText: '<span data-elevio-inline=\'' + this.elevioIdsObj.clickToOpenRateArticle + '\'>' + clickToOpenRate + '</span>',
            ctor: this.outreachStats.ctoRate,
            uniqueClickEmailsCount: this.outreachStats.click,
            uniqueOpensCount: this.outreachStats.open
        },
            chartDataObject = new this.CoreChartObject({
            type: 'bar',
            view: 'max',
            percent: false
        }),
            dataFormatter = {
            xAxis: {
                categories: []
            },
            series: [{
                data: []
            }]
        },
            clickedLinkArray = clickData.map(function (click) {
            return click.clickLink;
        });

        function _prepareTopTenClicks(stats, chartData) {
            var descSortedClicks, i, numOfIterations;

            descSortedClicks = stats.sort(function (a, b) {
                if (a.count > b.count) {
                    return -1;
                }

                if (a.count < b.count) {
                    return 1;
                }

                return 0;
            });

            numOfIterations = descSortedClicks.length > 10 ? 10 : descSortedClicks.length;

            for (i = 0; i < numOfIterations; i++) {
                chartData.xAxis.categories.push(descSortedClicks[i].clickLink);
                chartData.series[0].data.push({ y: descSortedClicks[i].count });
            }

            return chartData;
        }

        dataFormatter = _prepareTopTenClicks(clickData, dataFormatter);
        chartDataObject = this.CoreCommon.mergeRecursive(chartDataObject, dataFormatter);
        this.clickToOpenRateSummary = this.$sce.trustAsHtml(this._decodeHTML(this.$translate.instant(clickToOpenRateSummary, translationScope)));

        this.ctorChartData = {};

        // build the graph
        this.ctorChartData = this.CoreCommon.mergeRecursive(chartDataObject, this.TransformOutreachStatsChartService.readyChartCTORData(this.outreachStats, function (chartDataObject) {
            var link = chartDataObject.category;

            _this6.clickToOpenDropDownOptions.some(function (clickToOpenOption) {
                if (clickToOpenOption.name === link) {
                    this.selectedClickToOpenOption = clickToOpenOption;
                    return true;
                }
            }, _this6);

            _this6.loadClickToOpenRateContacts({ name: link });
        }));

        // build the contact stream
        this.clickToOpenSortField = 'date';
        this._prepareClickToOpenDropdown(clickedLinkArray);
        this.loadClickToOpenRateContacts({ name: 'all' });
    };

    ContactManagerOutreachViewController.prototype._formatUnsubscribeData = function _formatUnsubscribeData(unsubscribes) {
        var unsubscribesObj = {
            reasons: {
                frequency: 0,
                irrelevant: 0,
                spam: 0,
                none: 0,
                other: 0
            }
        };

        for (var i = 0; i < unsubscribes.length; i++) {
            if (unsubscribesObj.reasons[unsubscribes[i].reason] !== undefined) {
                unsubscribesObj.reasons[unsubscribes[i].reason] += 1;
            }
        }

        return unsubscribesObj;
    };

    ContactManagerOutreachViewController.prototype._buildUnsubscribeChartAnalytics = function _buildUnsubscribeChartAnalytics() {
        var _this7 = this;

        this.unsubscribeData = true;
        if ((!this.outreachStats.unsubscribe || !this.outreachStats.delivered) && this.shouldTrack) {
            this.unsubscribeData = false;
            return;
        }

        if (!this.outreachStats.unsubscribe && !this.shouldTrack) {
            this.unsubscribeData = false;
            return;
        }

        this.UnsubscribeService.getDistributionUnsubscribes(this.distributionId).then(function (results) {
            _this7.unsubscribesObj = _this7._formatUnsubscribeData(results.unsubscribes);

            var unsubscribeRateSummary = 'icm-outreach__stats--unsubscribeRate-summary',
                translationScope = {
                unsubscribeRateText: '<span data-elevio-inline=\'' + _this7.elevioIdsObj.unsubscribeArticle + '\'>' + _this7.unsubscribeRateText + '</span>',
                unsubscribeRate: _this7.outreachStats.unsubscribeRate,
                unsubscribeRateCount: _this7.outreachStats.unsubscribe,
                uniqueDeliverdCount: _this7.outreachStats.delivered
            },
                chartDataObject = new _this7.CoreChartObject({
                type: 'pie',
                view: 'max',
                percent: false
            }),
                reasonArray = Object.keys(_this7.unsubscribesObj.reasons),
                donutChartData = [],
                colorSet = _this7.CoreColorService.getColors(),
                drilldownFunction;

            _this7.unsubscribeRateSummary = _this7.$sce.trustAsHtml(_this7._decodeHTML(_this7.$translate.instant(unsubscribeRateSummary, translationScope)));

            for (var i = 0; i < reasonArray.length; i++) {
                var translatedReason,
                    count = _this7.unsubscribesObj.reasons[reasonArray[i]];

                for (var j = 0; j < _this7.unsubscribeDropDownOptions.length; j++) {
                    if (reasonArray[i] === _this7.unsubscribeDropDownOptions[j].id) {
                        translatedReason = _this7.unsubscribeDropDownOptions[j].name;
                    }
                }
                if (count > 0) {
                    donutChartData.push({
                        name: translatedReason,
                        color: colorSet[i],
                        y: count
                    });
                }
            }

            drilldownFunction = function drilldownFunction(reason) {
                var reasonObj = void 0;

                if (reason && reason.name) {
                    for (var _i = 0; _i < this.unsubscribeDropDownOptions.length; _i++) {
                        if (reason.name === this.unsubscribeDropDownOptions[_i].name && this.unsubscribeDropDownOptions[_i].id !== 'all') {
                            this.selectedUnsubscribeOption = this.unsubscribeDropDownOptions[_i];
                            reasonObj = { id: this.unsubscribeDropDownOptions[_i].id, name: reason.name };
                        }
                    }
                }

                this.loadUnsubscribedContacts(reasonObj);
            }.bind(_this7);

            // build the graph
            _this7.unsubscribeChartData = _this7.CoreCommon.mergeRecursive(chartDataObject, _this7.TransformOutreachStatsChartService.readyChartUnsubscribeData(donutChartData, drilldownFunction));

            // build the contact stream
            _this7.unsubscribeSortField = 'date';
            _this7.loadUnsubscribedContacts();
            _this7.selectedUnsubscribeOption = _this7.unsubscribeDropDownOptions[0];
        }).catch(function () {});
    };

    ContactManagerOutreachViewController.prototype.changeView = function changeView(subNavItem) {
        if (subNavItem) {
            this.$location.search('view', subNavItem);
        }
    };

    ContactManagerOutreachViewController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        return Object.keys(selectedItems).length;
    };

    ContactManagerOutreachViewController.prototype.nextContactPage = function nextContactPage() {
        this.ContactStreamData.nextPage().then(function () {
            if (this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray, null, null, this.predictionContactFilter);
            }
        }.bind(this));
    };

    ContactManagerOutreachViewController.prototype.addSelectedContactsByClicksToMediaList = function addSelectedContactsByClicksToMediaList(link) {
        var criteria = {
            pageSize: this.MAX_MEDIALIST_LIMIT,
            page: 0,
            pathParams: {
                distributionId: this.distributionId,
                statType: 'click'
            }

        };

        if (link && link.toLowerCase() !== 'all') {
            criteria.clickLink = link;
        }

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedContactsByOpensToMediaList = function addSelectedContactsByOpensToMediaList(statType) {
        var criteria = {
            stat: statType || '',
            pageSize: this.MAX_MEDIALIST_LIMIT,
            page: 0,
            pathParams: {
                distributionId: this.distributionId,
                statType: 'open'
            }
        };

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedUnsubscribesToMediaList = function addSelectedUnsubscribesToMediaList() {
        var criteria = {
            distributionId: this.distributionId,
            appIds: 'ICM',
            reason: this.selectedUnsubscribeOption.id === 'all' ? undefined : this.selectedUnsubscribeOption.id,
            pageSize: this.MAX_MEDIALIST_LIMIT,
            page: 0
        };

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedToMediaList = function addSelectedToMediaList(criteria) {
        var _this8 = this;

        criteria = criteria || {};
        if (this._checkIfOverSelectionLimit(this.MAX_MEDIALIST_LIMIT)) {
            var manageListLimitWarning = document.querySelector('manage-list-limit-warning');
            manageListLimitWarning.open();
        } else {
            window.addEventListener('icm-lists-updated', this.resetSelectedStats, { once: true });
            if (this.ContactSelector.trueAllSelected) {
                var getContactByStats = void 0;

                if (criteria && criteria.appIds) {
                    getContactByStats = this.getContactIdsForUnsubscribeStats.bind(this);
                } else {
                    getContactByStats = this.getContactIdsForStats.bind(this);
                }

                getContactByStats(criteria).then(function (results) {
                    _this8.openManageListModal(results);
                });
            } else {
                var validIds = [],
                    invalidEmails = [];

                Object.keys(this.ContactSelector.selectedItems).forEach(function (key) {
                    if (key.indexOf('other_contact') === -1) {
                        validIds.push(key);
                    } else {
                        invalidEmails.push(key.replace('other_contact_', ''));
                    }
                });
                this.openManageListModal({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }
        }
    };

    ContactManagerOutreachViewController.prototype.getContactIdsForUnsubscribeStats = function getContactIdsForUnsubscribeStats(criteria) {
        var _this9 = this;

        return new Promise(function (resolve, reject) {
            _this9.InfluencerContactService.getUnsubscribed(criteria).then(function (results) {
                var validIds = [],
                    invalidEmails = [];

                results.hits.forEach(function (contact) {
                    contact && contact.id && contact.id.indexOf('other_contact') === -1 ? validIds.push(contact.id) : invalidEmails.push(contact.id.replace('other_contact_', '')); // jshint ignore:line
                });

                resolve({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    ContactManagerOutreachViewController.prototype.getContactIdsForStats = function getContactIdsForStats(criteria) {
        var _this10 = this;

        return new Promise(function (resolve, reject) {
            _this10.InfluencerContactService.getContactIdsByStat(criteria).then(function (results) {
                var validIds = [],
                    invalidEmails = [];

                results.forEach(function (contact) {
                    contact && contact.contactIds && contact.contactIds.length > 0 ? validIds.push(contact.contactIds[0]) : invalidEmails.push(contact.emailAddress); // jshint ignore:line
                });

                resolve({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    ContactManagerOutreachViewController.prototype.warningNonValidContacts = function warningNonValidContacts(nonValidContacts, validContactCount) {
        return this.$mdDialog.show(this.$mdDialog.mwConfirm().title(this.$translate.instant('icm-outreach__stats--add-to-list-warning-title', { contactCount: validContactCount })).textContent(this.$translate.instant('icm-outreach__stats--add-to-list-warning-text', { emailList: nonValidContacts.join(', ') })).ok('OK').cancel('cancel').multiple(true).parent(angular.element(document.getElementsByClassName('mw-flexi-modal')[0])));
    };

    ContactManagerOutreachViewController.prototype.openManageListModal = function openManageListModal(contacts) {
        var manageListDialog = document.querySelector('icm-manage-lists-dialog');
        if (contacts.invalidEmails.length > 0) {
            this.warningNonValidContacts(contacts.invalidEmails, contacts.validIds.length).then(function () {
                if (contacts.validIds.length > 0) {
                    manageListDialog.open(contacts.validIds);
                }
            });
        } else {
            manageListDialog.open(contacts.validIds);
        }
    };

    ContactManagerOutreachViewController.prototype.resetSelectedStats = function resetSelectedStats() {
        var _this = angular.element(document.getElementsByClassName('outreachStatsContainer')).scope().outreachViewController;
        _this.ContactSelector.deselectAll();
        _this.predictionContactFilter = {};
        _this.$scope.$apply();
    };

    ContactManagerOutreachViewController.prototype.exportClickToOpenRateContactsToCSV = function exportClickToOpenRateContactsToCSV(clickedLink, ev) {
        if (clickedLink && clickedLink.toLowerCase() !== 'all') {
            this.exportContactsToCSV('clicks', ev, clickedLink);
        } else {
            this.exportContactsToCSV('clicks', ev);
        }
    };

    ContactManagerOutreachViewController.prototype.exportOpenRateContactsToCSV = function exportOpenRateContactsToCSV(stat, ev) {
        this.exportContactsToCSV(stat, ev);
    };

    ContactManagerOutreachViewController.prototype.exportUnsubscribedContactsToCSV = function exportUnsubscribedContactsToCSV(ev) {
        this.exportContactsToCSV('unsubscribes', ev);
    };

    ContactManagerOutreachViewController.prototype.exportContactsToCSV = function exportContactsToCSV(type, ev, clickedLink) {
        var _this11 = this;

        var pageSize = this.exportLimit,

        // limit the file name to 200 because whose going to want a name longer than that? Also it errors on export if the file name is too long...
        fileName = this.emailInfo.subject.substring(0, 200);

        type = type || '';
        if (this._checkIfOverSelectionLimit(this.exportLimit)) {
            this.DialogService.alert(this.$translate.instant('icm-export__exceed-limit-message', { limit: this.exportLimit }), this.$translate.instant('Selection Too Large'));
        } else {
            this.$mdDialog.show(this.$mdDialog.mwAlert().class('legal-message').textContent(this.$translate.instant('icm-export__legal-message')).ok(this.$translate.instant('OK')).targetEvent(ev)).then(function () {
                switch (type.toLowerCase()) {
                    case 'unsubscribes':
                        var reason = _this11.selectedUnsubscribeOption.id === 'all' ? undefined : _this11.selectedUnsubscribeOption.id;

                        _this11.ContactManagerActionBarFactory.exportUnsubscribedContactsToCSV(fileName, _this11.distributionId, pageSize, reason);
                        break;
                    case 'delivered':
                    case 'bounces':
                    case 'unread':
                    case 'seen':
                    case 'skimmed':
                    case 'read':
                    case 'opened':
                    case 'unopened':
                    case 'untracked':
                        _this11.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, _this11.distributionId, pageSize, type);
                        break;
                    case 'clicks':
                        _this11.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, _this11.distributionId, pageSize, type, clickedLink);
                        break;
                    default:
                        _this11.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, _this11.distributionId, pageSize, 'all');
                        break;
                }

                _this11.trackSegmentEvent(type);
            });
        }
    };

    ContactManagerOutreachViewController.prototype.trackSegmentEvent = function trackSegmentEvent(type) {
        var parentType = this.mapTypeToSegmentParentType(type),
            numberOfContacts = this.ContactSelector.trueAllSelected ? this.ContactStreamData.totalContacts : this.getSelectedCount(this.ContactSelector.selectedItems);
        this.SegmentTrackingService.trackEvent('export_contact', null, numberOfContacts, parentType, type);
    };

    ContactManagerOutreachViewController.prototype.mapTypeToSegmentParentType = function mapTypeToSegmentParentType(type) {
        var parentType = '';

        switch (type.toLowerCase()) {
            case 'unsubscribes':
                parentType = 'ICM_analytics_unsubscribe';
                break;
            case 'delivered':
            case 'bounces':
            case 'unread':
            case 'seen':
            case 'skimmed':
            case 'read':
                parentType = 'ICM_analytics_open_rate';
                break;
            case 'clicks':
                parentType = 'ICM_analytics_CTOR';
                break;
            default:
                parentType = 'all';
                break;
        }

        return parentType;
    };

    ContactManagerOutreachViewController.prototype.openRateCompose = function openRateCompose(statType) {
        statType = statType || 'all';

        this.compose(statType);
    };

    ContactManagerOutreachViewController.prototype.clickToOpenRateCompose = function clickToOpenRateCompose(link) {
        var clickedLink = null;

        if (link && link.toLowerCase() !== 'all') {
            clickedLink = link;
        }

        this.compose('clicks', clickedLink);
    };

    ContactManagerOutreachViewController.prototype.compose = function compose(stat, clickedLink) {
        var setRecipients = function setRecipients() {
            return this.$q(function (resolve) {
                var selectedContacts,
                    selectedContactArray = [],
                    query;

                if (this.ContactSelector.trueAllSelected) {
                    query = {
                        distributionId: this.distributionId,
                        type: stat,
                        page: 0,
                        pageSize: 1000
                    };

                    if (clickedLink) {
                        query.clickedLink = clickedLink;
                    }

                    this.InfluencerContactService.getOpenRate(query).then(function (results) {
                        results.hits.forEach(function (contactObject) {
                            if (contactObject.id.indexOf('other_contact_') > -1) {
                                contactObject.id = null;
                                contactObject.name.fullName = contactObject.contactInfo.email[0].address;
                            }

                            selectedContactArray.push(contactObject);
                        });

                        this.ICMEmailService.setContactRecipients(selectedContactArray);
                        resolve(selectedContactArray);
                    }.bind(this));
                } else {
                    selectedContacts = angular.copy(this.ContactSelector.selectedItems);

                    selectedContactArray = Object.keys(selectedContacts).map(function (selectedContactKey) {
                        if (selectedContacts[selectedContactKey].id.indexOf('other_contact_') > -1) {
                            selectedContacts[selectedContactKey].id = null;
                            selectedContacts[selectedContactKey].name.fullName = selectedContacts[selectedContactKey].contactInfo.email[0].address;
                        }

                        return selectedContacts[selectedContactKey];
                    });

                    this.ICMEmailService.setContactRecipients(selectedContactArray);
                    resolve(selectedContactArray);
                }
            }.bind(this));
        },
            dialogMode = true;

        this.ContactManagerActionBarFactory.compose(setRecipients.bind(this), dialogMode);
    };

    ContactManagerOutreachViewController.prototype._checkIfOverSelectionLimit = function _checkIfOverSelectionLimit(limit) {
        return this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > limit || this.getSelectedCount(this.ContactSelector.selectedItems) > limit;
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerProfileController', ['MW.ContactManager.ActiveOn', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.InfluencerContactService', 'MW.ContactManager.ContactManagerFlashService', 'MW.Framework.TranslationService', 'MW.ContactManager.ContactManagerPropertyTypeService', 'MW.CoreStream.ContactManagerTagService', 'MW.Influencers.IcmDialogService', 'MW.Framework.ICMEmailService', 'MW.Framework.CoreGridDefinition', 'MW.Framework.CoreGridSearchService', 'MW.Framework.CoreGridSelectableService', 'MW.ContactManager.OutreachListFactory', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Framework.TextFilters', 'MW.Framework.MomentService', 'MW.Framework.PageStateService', 'Configuration', 'MW.Framework.EntitlementService', 'MW.Influencers.AnalyticsService', 'MW.Influencers.FeedbackService', 'ngMaterial', 'mwAppComponents', 'MW.Influencers.ActivityService', 'MW.Influencers.IcmUnsubscribeService', 'MW.Influecners.UnsubscribeBadge']).controller('ContactManagerProfileController', ['ContactManagerNavigationService', 'InfluencerContactService', 'ContactManagerFlashService', 'translationService', 'ContactManagerTagService', 'DialogService', 'ICMEmailService', '$location', '$translate', '$filter', 'activeOnTypes', 'breadcrumbs', 'contact', 'CoreGridDefinition', 'CoreGridSearchService', 'CoreGridSelectableService', 'OutreachListFactory', 'CoreUserService', 'CoreCompanyService', 'moment', 'DEFAULT_MEDIA_LIST', 'companyId', 'PageStateService', 'EntitlementService', 'AnalyticsService', 'FeedbackService', '$q', '$mdDialog', '$timeout', '$scope', 'ActivityService', 'IcmUnsubscribeService', ContactManagerProfileController]);

    function ContactManagerProfileController(ContactManagerNavigationService, InfluencerContactService, ContactManagerFlashService, translationService, ContactManagerTagService, DialogService, ICMEmailService, $location, $translate, $filter, activeOnTypes, breadcrumbs, contact, CoreGridDefinition, CoreGridSearchService, CoreGridSelectableService, OutreachListFactory, CoreUserService, CoreCompanyService, moment, DEFAULT_MEDIA_LIST, companyId, PageStateService, EntitlementService, AnalyticsService, FeedbackService, $q, $mdDialog, $timeout, $scope, ActivityService, UnsubscribeService) {
        this.contact = contact;

        this.ActivityService = ActivityService;
        this.AnalyticsService = AnalyticsService;
        this.FeedbackService = FeedbackService;
        this.CoreGridSearchService = CoreGridSearchService;
        this.CoreGridSelectableService = CoreGridSelectableService;
        this.CoreGridDefinition = CoreGridDefinition;
        this.isPermissions = false;
        this.emailEmptyStateVisible = true;
        this.$translate = $translate;
        this.mediaListTranslation = this.$translate.instant('icm-web-contact-profile__media-lists--label');
        this.$filter = $filter;
        this.moment = moment;
        this.companyId = companyId;
        this.PageStateService = PageStateService;
        this.$mdDialog = $mdDialog;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$scope = $scope;

        this.UnsubscribeService = UnsubscribeService;

        CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this)).catch(function () {});

        this.breadcrumbs = breadcrumbs;
        this.activeOnTypes = activeOnTypes;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.OutreachListFactory = new OutreachListFactory();

        // keep track of what our saved notes are
        this.translationService = translationService;

        this.ContactManagerTagService = ContactManagerTagService;
        this.DialogService = DialogService;
        this.ICMEmailService = ICMEmailService;
        this.isNotesView = true;
        this.isEmailView = false;
        this.coreGridEmailConfig = {};
        this.$location = $location;
        this.isContactOnMediaList = false;
        this.canSendEmail = false;
        var primaryEmail = this.contact.contactInfo.email[0] && this.contact.contactInfo.email[0].address ? this.contact.contactInfo.email[0].address : null;

        if (primaryEmail !== null) {
            this.UnsubscribeService.didEmailUnsubscribeFromICM(primaryEmail).then(function unsubscribedRes(response) {
                if (response === true) {
                    this.contact.setUnsubscribedStatus(primaryEmail);
                    this.canSendEmail = false;
                } else {
                    this.canSendEmail = true;
                }
            }.bind(this)).catch(function () {});
        }

        /**
         * Responsible for determining if a button should be disabled or not.
         * @returns {boolean} Returns true if the button should be disabled.  Returns false if the button should not be disabled.
         */
        this.isButtonDisabled = function isButtonDisabled() {
            var isDisabled = true;
            if (this.contact !== undefined && this.contact.notes !== undefined) {
                isDisabled = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)).length > 0 && this.isNotesView ? false : true;
            }
            return isDisabled;
        }.bind(this);

        /**
         * Initialize the coreGridNotesConfig.  This will be populated later in this file.
         * @type {{}}
         */
        this.coreGridNotesConfig = {};
        this.contactNotesCollection = [];
        this.isInfluencerAppEntitled = false;
        if (CoreUserService.isInfluencerAppEntitled === '') {
            EntitlementService.registerEntitlement('toggle', 'influencerApp', 'Influencers');
            EntitlementService.getInfluencerAppEntitlement().then(function getAccountEntitlementThen(entitlement) {
                if (entitlement) {
                    this.isInfluencerAppEntitled = true;
                }
            }.bind(this));
        } else if (CoreUserService.isInfluencerAppEntitled) {
            this.isInfluencerAppEntitled = true;
        }

        // Define the core grid configuration for the ICM Notes list.
        var historyTableCoreGridConfig = {
            dataItemIdProperty: 'notesId',
            headerTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'created',
                descending: true,
                conditionalSort: function conditionalSort(sortField) {
                    if (sortField === 'created') {
                        return 'modifiedTimeStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [{
                name: 'Delete',
                isDisabled: this.isButtonDisabled,
                callback: function () {
                    this.deleteNotesHandler();
                }.bind(this)
            }],
            columnDefinitions: [{
                name: 'Type',
                dataKey: 'typeDisplay',
                options: {
                    defaultValue: 'note',
                    class: 'notesCollectionType',
                    sortable: true,
                    searchable: true
                }
            }, {
                name: 'SUBJECT',
                dataKey: 'subjectBackup',
                options: {
                    class: 'notesCollectionSubject',
                    columnDataTemplateUrl: 'icm-web/views/partials/notes_subject_column',
                    clickable: true,
                    onClick: function (dataItem) {
                        this.editActivity(dataItem);
                    }.bind(this)
                }
            }, {
                name: 'DATE',
                dataKey: 'created',
                options: {
                    class: 'notesCollectionDate',
                    sortable: true
                }
            }],
            selectable: {
                singleSelect: false,
                enabled: true,
                selected: []
            },
            searchable: {
                enabled: false
            }
        };

        // change the class to change the width of the column
        historyTableCoreGridConfig.columnDefinitions[1].options.class = 'activityCollectionSubject';
        historyTableCoreGridConfig.columnDefinitions.push({
            name: 'icm-web__contact-profile--activity-table-column-author',
            dataKey: 'authorName',
            options: {
                defaultValue: '',
                class: 'activityAuthor',
                sortable: true,
                searchable: true
            }
        });
        // this injects the author into the 3rd position of the array (before date)
        historyTableCoreGridConfig.columnDefinitions.splice(2, 0, historyTableCoreGridConfig.columnDefinitions.splice(3, 1)[0]);

        // Load the core grid configuration for this page to use
        this.coreGridNotesConfig = this.CoreGridDefinition.build(historyTableCoreGridConfig);

        /**
         * Initialize the coreGridEmailConfig.  This will be populated later in this file.
         * @type {{}}
         */
        this.coreGridEmailConfig = {};
        this.contactEmailCollection = [];
        this.contactEmailArray = [];

        // Define the core grid configuration for the Emails list.
        var historyTableEmailCoreGridConfig = {
            dataItemIdProperty: '_id',
            headerTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'name',
                descending: false,
                backendSorting: false,
                conditionalSort: function conditionalSort(sortField) {
                    if (sortField === 'scheduledDate') {
                        return 'scheduledDateStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [],
            columnDefinitions: [{
                name: 'TYPE',
                dataKey: 'type',
                options: {
                    defaultValue: 'email',
                    class: 'collectionType',
                    sortable: false,
                    searchable: true
                }
            }, {
                name: 'SUBJECT',
                dataKey: 'subject',
                options: {
                    class: 'collectionSubject',
                    clickable: false,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_subject_column',
                    defaultValue: this.translationService.getLocalizedString('No Recipients'),
                    clickCallback: function clickCallback(route) {
                        this.ICMEmailService.getIcmApprovedSenders().then(function () {
                            this.$location.url(route);
                        }.bind(this)).catch(function (error) {
                            if (error) {
                                this.showUnapprovedDialog();
                            } else {
                                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                            }
                        }.bind(this));
                    }.bind(this)
                }
            }, {
                name: 'STATUS',
                dataKey: 'status',
                options: {
                    class: 'collectionStatus',
                    sortable: true,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_status_column'
                }
            }, {
                name: 'Date', //This is lower case to match en.json
                dataKey: 'scheduledDate',
                options: {
                    class: 'collectionType',
                    sortable: true,
                    columnDataTemplateUrl: 'icm-web/views/partials/outreach_date_column',
                    defaultValue: this.translationService.getLocalizedString('N/A')
                }
            }],
            selectable: {
                enabled: false,
                selected: [],
                singleSelect: false
            },
            searchable: {
                enabled: false,
                predictionFields: [],
                searchTerms: []
            }
        };

        // Load the core grid configuration for this page to use
        this.coreGridEmailConfig = this.CoreGridDefinition.build(historyTableEmailCoreGridConfig);
        this.getAllEmails(); // Initializing call to load outreach emails for contact profile page
        if (this.contact.notes) {
            this.contactNotesCollection = this.formatNotes(this.contact.notes).slice(0, 10);
        }

        this.toggleText = {
            more: this.translationService.getLocalizedString('Show More') + ' ',
            less: this.translationService.getLocalizedString('Show Less') + ' '
        };
        this.toggleShowMoreLessText = this.toggleText.more;
        this.showAllMedialist = false;
        this.showLimit = 20;
        this.medialistItems = [];
        this.mediaListsArray = [];
        this.lockerData = [];
        this.defaultMasterListName = DEFAULT_MEDIA_LIST + this.companyId;

        ContactManagerTagService.getAllMediaListsForContactId(contact.id).then(function afterGetMediaLists(data) {
            this.contact.mediaLists = data || [];
            this.isContactOnMediaList = this.contact.mediaLists.length === 0 ? false : true;
            this.showInfluencersList();
        }.bind(this)).catch(function afterFail() {
            this.contact.mediaLists = contact.mediaLists || [];
            this.isContactOnMediaList = this.contact.mediaLists.length === 0 ? false : true;
        }.bind(this));

        this.lastUpdatedString = '';
        this.lastUpdatedValues = '';
        this.formatLastUpdatedString(contact);
        this.FeedbackService.initializeContact(this.contact);
    }

    ContactManagerProfileController.prototype.showInfluencersList = function showInfluencersList() {
        //getting all mediaLists to display names of Media Lists that contact associated with
        if (this.contact.mediaLists.length) {
            this.ContactManagerTagService.getAllTags().then(function (response) {
                this.medialistItems = response;
                for (var i = 0; i < this.medialistItems.length; i++) {
                    if (this.contact.mediaLists && this.contact.mediaLists.indexOf(this.medialistItems[i].id) > -1) {
                        if (this.defaultMasterListName !== this.medialistItems[i].name) {
                            this.mediaListsArray.push({
                                name: this.medialistItems[i].name,
                                lockerData: {
                                    name: this.medialistItems[i].name,
                                    id: this.medialistItems[i].id
                                }
                            });
                        }
                    }
                }
            }.bind(this)).catch(function () {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }.bind(this));
        }
    };

    ContactManagerProfileController.prototype.editContact = function editContact() {
        this.ContactManagerNavigationService.goToEdit(this.contact.id);
    };

    ContactManagerProfileController.prototype.addThisContactToList = function addThisContactToList() {
        var manageListDialog = document.querySelector('icm-manage-lists-dialog');
        manageListDialog.open([this.contact.id]);
        window.addEventListener('icm-lists-updated', this.refreshLists, { once: true });
    };

    ContactManagerProfileController.prototype.refreshLists = function refreshLists(event) {
        var _this = angular.element(document.getElementsByClassName('contactProfileWrapper')).scope().profileController;
        var newMediaListArray = [];

        if (event && event.detail.updatedLists) {
            var updatedLists = event.detail.updatedLists;
            for (var x in updatedLists) {
                // jshint ignore:line
                var list = updatedLists[x];

                newMediaListArray.push({
                    name: list.listName,
                    lockerData: {
                        name: list.listName,
                        id: list.id
                    }
                });
            }
            _this.mediaListsArray = newMediaListArray;

            _this.$scope.$apply();

            if (_this.mediaListsArray.length > 0) {
                _this.isContactOnMediaList = true;
            } else {
                _this.isContactOnMediaList = false;
            }
        }
    };

    ContactManagerProfileController.prototype.removeThisContact = function removeThisContact() {
        var contactTagArray = [];

        function _onSuccess(controller) {
            controller.isContactOnMediaList = false;

            //set contact to null so that it is loaded during next call.
            controller.InfluencerContactService.setCurrentContact(null);

            controller.ContactManagerFlashService.flashSuccess('Success. This contact has been removed from your contacts.');
            controller.ContactManagerNavigationService.smartBackAction();
        }

        function _onFailure(controller) {
            controller.ContactManagerFlashService.flashError('Oops. There was a problem removing this contact. Please try again later.');
        }

        // private contacts should be deleted
        // public contacts should be removed from all media lists
        if (this.contact.systemData.policies.storage.private === true) {
            this.InfluencerContactService.deleteContact(this.contact.id).then(function () {
                _onSuccess(this);
            }.bind(this)).catch(function () {
                _onFailure(this);
            }.bind(this));
        } else {
            contactTagArray = this.mediaListsArray.map(function (mediaList) {
                return {
                    mediaListId: mediaList.lockerData.id,
                    contactId: this.contact.id
                };
            }, this);

            this.ContactManagerTagService.removeContactsFromTags(contactTagArray).then(function () {
                _onSuccess(this);
            }.bind(this)).catch(function () {
                _onFailure(this);
            }.bind(this));
        }
    };

    ContactManagerProfileController.prototype.compose = function compose() {
        this.ICMEmailService.getIcmApprovedSenders().then(function onSuccess(sendersList) {
            if (sendersList.length) {
                this.composeEmail(sendersList);
            } else {
                this.showUnapprovedDialog();
            }
        }.bind(this), function onFailure() {
            this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
        }.bind(this));
    };

    ContactManagerProfileController.prototype.showUnapprovedDialog = function () {
        var dialogTitle = this.translationService.getLocalizedString('Compose Email'),
            callback = function callback() {
            this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
        }.bind(this);

        this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, callback);
    };

    ContactManagerProfileController.prototype.composeEmail = function composeEmail(senderObject) {
        this.ICMEmailService.resetRecipients();

        this.ICMEmailService.setContactRecipients([this.contact]);
        this.ICMEmailService.setSender(senderObject);

        this.$location.path('/outreach/compose').search('step', '1');
    };

    ContactManagerProfileController.prototype.showMore = function showMore(type) {
        this.$location.url('/influencers/contact/showmore/' + this.contact.id + '/' + type);
    };

    ContactManagerProfileController.prototype.toggleNotesEmailView = function toggleNotesEmailView() {
        this.isNotesView = !this.isNotesView;
        this.isEmailView = !this.isEmailView;
    };

    ContactManagerProfileController.prototype.getAllEmails = function getAllEmails(sortField, sortOrder) {
        var contactId = this.contact && this.contact.id ? this.contact.id : null,
            emailAddressArray = [],
            i;
        if (this.contact && this.contact.contactInfo && Array.isArray(this.contact.contactInfo.email) && this.contact.contactInfo.email.length) {
            this.contact.contactInfo.email.forEach(function (emailAddressObject) {
                if (emailAddressObject.address && typeof emailAddressObject.address === 'string' && emailAddressObject.address.length) {
                    emailAddressArray.push(emailAddressObject.address);
                }
            });
        }

        // Get all outreach emails list
        if (contactId || emailAddressArray.length) {
            this.OutreachListFactory.getAllEmails(contactId, emailAddressArray, sortField, sortOrder, 0, 11).then(function getAllEmailsSuccess(response) {
                if (response && response.hits) {
                    this.contactEmailCollection = [];
                    this.contactEmailArray = response.hits;
                    var length = this.contactEmailArray.length > 10 ? 10 : this.contactEmailArray.length;
                    for (i = 0; i < length; i++) {
                        this.contactEmailCollection.push(this.contactEmailArray[i]);
                        this.emailEmptyStateVisible = this.contactEmailCollection.length <= 0;
                    }
                }
            }.bind(this));
        } else {
            this.emailEmptyStateVisible = true;
        }
    };

    ContactManagerProfileController.prototype.formatNotes = function formatNotes(notes) {
        var newNotesArray = [],
            sortedNotes;

        if (Array.isArray(notes) && notes.length) {
            sortedNotes = this.$filter('orderBy')(notes, 'modifiedAt', 'desc');
            sortedNotes.forEach(function (note) {
                if (typeof note.note === 'string' && note.note.length) {
                    if (typeof note.subject !== 'string') {
                        note.subject = '';
                    }

                    newNotesArray.push({
                        notesId: note.id,
                        typeDisplay: note.type ? this.ActivityService.translateActivityType(note.type) : this.ActivityService.translateActivityType('note'),
                        type: note.type || 'note',
                        subject: note.subject,
                        subjectBackup: note.subject || note.note.substring(0, 240),
                        note: note.note,
                        date: note.date,
                        authorName: note.createdBy && note.createdBy.firstName && note.createdBy.lastName ? note.createdBy.firstName + ' ' + note.createdBy.lastName : '',
                        createdBy: note.createdBy,
                        updatedBy: note.updatedBy,
                        created: this.$filter('mwConvertDateToUserTimezone')(note.modifiedAt, 'mediumDate'),
                        createdAt: note.createdAt,
                        modifiedAt: note.modifiedAt,
                        modifiedTimeStamp: this.moment.utc(note.modifiedAt).format('X')
                    });
                }
            }.bind(this));
        }

        return newNotesArray;
    };

    ContactManagerProfileController.prototype.onNotesUpdated = function onNotesUpdated(notePromise) {
        notePromise.then(function onSuccess() {
            this.InfluencerContactService.getContactById(this.contact.id).then(function onGetContactSuccess(response) {
                this.contact = response;
                this.getNotes(this.contact.id);
                this.ContactManagerFlashService.flashSuccess('Success. Your contact has been updated.');
            }.bind(this));
        }.bind(this)).catch(function onFail(error) {
            if (error.message === 'Add faild') {
                this.contactNotesCollection.shift();
            }
            this.ContactManagerFlashService.flashError(error);
        }.bind(this));
    };

    ContactManagerProfileController.prototype.getNotes = function getNotes(contactId) {
        // retrieve notes for the contact. since we dont return them for list views they dont get cached in the InfluencerContactService
        this.InfluencerContactService.getNotes(contactId).then(function (notes) {
            this.contact.notes = notes;
            this.contactNotesCollection = this.formatNotes(notes).slice(0, 10);
        }.bind(this)).catch(function () {
            this.DialogService.flashError('Failed retrieving notes');
        }.bind(this));
    };

    ContactManagerProfileController.prototype.addActivity = function addActivity() {
        var createActivityPromise = this.ActivityService.createActivity(this.contact.id);
        this.onNotesUpdated(createActivityPromise);
    };

    ContactManagerProfileController.prototype.editActivity = function editActivity(oldNote) {
        var updateActivityPromise = this.ActivityService.updateActivity(this.contact.id, oldNote);
        this.onNotesUpdated(updateActivityPromise);
    };

    ContactManagerProfileController.prototype.deleteNotesHandler = function deleteNotesHandler() {
        var confirmMessageText = this.translationService.getLocalizedString('Are you sure you want to delete the selected note(s)?'),
            confirmMessageTitle = this.translationService.getLocalizedString('Delete note(s)?');

        this.DialogService.confirm(confirmMessageText, confirmMessageTitle, function (payload) {
            if (payload.success) {
                var selectedNotes = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)),
                    notesToDelete = [];

                if (selectedNotes.length > 0) {
                    this.CoreGridSelectableService.deleteAllInSelected(this.coreGridNotesConfig);

                    notesToDelete = selectedNotes.map(function (selectedNote) {
                        return selectedNote.notesId;
                    });

                    this.onNotesUpdated(this.InfluencerContactService.deleteNotes(this.contact.id, notesToDelete));
                }
            }
        }.bind(this));
    };

    ContactManagerProfileController.prototype.toggleMedialistView = function toggleMedialistView() {
        if (!this.showAllMedialist) {
            this.showLimit = this.mediaListsArray.length;
            this.toggleShowMoreLessText = this.toggleText.less;
        } else {
            this.showLimit = 20;
            this.toggleShowMoreLessText = this.toggleText.more;
        }
        this.showAllMedialist = !this.showAllMedialist;
    };

    ContactManagerProfileController.prototype.clickOnMediaList = function clickOnMediaList(lockerData) {
        this.$location.url('influencers/contact-list/' + lockerData.id);
    };

    ContactManagerProfileController.prototype.formatLastUpdatedString = function formatLastUpdatedString(contact) {
        var now = null,
            lastUpdated = null;

        if (contact.updated) {
            now = this.moment().utc();
            lastUpdated = this.moment(contact.updated).utc();

            if (now.diff(lastUpdated, 'months') >= 3) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--months';
                this.lastUpdatedValues = '';
            } else if (now.diff(lastUpdated, 'days') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--day';
                this.lastUpdatedValues = now.diff(lastUpdated, 'days');
            } else if (now.diff(lastUpdated, 'days') > 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--days';
                this.lastUpdatedValues = now.diff(lastUpdated, 'days');
            } else if (now.diff(lastUpdated, 'hours') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--hour';
                this.lastUpdatedValues = now.diff(lastUpdated, 'hours');
            } else if (now.diff(lastUpdated, 'hours') > 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--hours';
                this.lastUpdatedValues = now.diff(lastUpdated, 'hours');
            } else if (now.diff(lastUpdated, 'minutes') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--minute';
                this.lastUpdatedValues = now.diff(lastUpdated, 'minutes');
            } else {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--minutes';
                this.lastUpdatedValues = now.diff(lastUpdated, 'minutes');
            }
        }
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactManagerSourceProfileController', ['MW.ContactManager.ContactManagerSourceService', 'MW.ContactManager.ContactManagerFlashService', 'MW.ContactManager.RecentDocuments', 'MW.CoreStream', 'MW.Framework.ContentStreamSelectionDecorator', 'MW.Framework.ContactFilter', 'MW.Framework.InfluencerContactService', 'MW.Framework.PredictionPanelService', 'MW.Framework.ContentStreamDataFactory', 'MW.CoreStream.ContactManagerTagService', 'MW.Framework.PageStateService', 'MW.Influencers.IcmDialogService', 'MW.CoreStream.CsSelectAllHeader', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'ngMaterial', 'MW.Influencers.AnalyticsService', 'MW.Influencers.FeedbackService', 'angular-inview', 'MW.Influencers.MiniProfileService']).controller('ContactManagerSourceProfileController', ['ContactManagerSourceService', 'breadcrumbs', '$routeParams', 'ContactManagerFlashService', 'InfluencerContactService', 'ContentStreamSelectionDecorator', 'PredictionPanelService', 'ContactManagerTagService', 'PageStateService', 'DialogService', 'MAX_MEDIALIST_LIMIT', 'ContactStreamDataFactory', 'CoreUserService', 'CoreCompanyService', 'AnalyticsService', 'FeedbackService', '$mdDialog', '$q', '$http', '$translate', '$timeout', '$location', '$rootScope', '$scope', 'ICM_CSS_URL', 'MiniProfileService', ContactManagerSourceProfileController]);

    function ContactManagerSourceProfileController(ContactManagerSourceService, breadcrumbs, $routeParams, ContactManagerFlashService, InfluencerContactService, ContentStreamSelectionDecorator, PredictionPanelService, ContactManagerTagService, PageStateService, DialogService, MAX_MEDIALIST_LIMIT, ContactStreamDataFactory, CoreUserService, CoreCompanyService, AnalyticsService, FeedbackService, $mdDialog, $q, $http, $translate, $timeout, $location, $rootScope, $scope, ICM_CSS_URL, MiniProfileService) {
        this.$location = $location;
        this.$timeout = $timeout;
        this.$routeParams = $routeParams;
        this.breadcrumbs = breadcrumbs;
        this.ContactManagerSourceService = ContactManagerSourceService;
        this.InfluencerContactService = InfluencerContactService;
        this.PredictionPanelService = PredictionPanelService;
        this.ContactManagerTagService = ContactManagerTagService;
        this.PageStateService = PageStateService;
        this.DialogService = DialogService;
        this.$mdDialog = $mdDialog;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.FeedbackService = FeedbackService;
        this.MiniProfileService = MiniProfileService;
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$q = $q;
        this.$http = $http;

        this.ICM_CSS_URL = ICM_CSS_URL;
        this.source = {};
        this.parentChildIds = [];
        this.contactPredictionPanelExpanded = false;
        this.predictionContactFilter = {};
        this.sortField = 'alphabetically';

        this.ContactSelector = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });

        this.ContactStreamData = new ContactStreamDataFactory();

        ContactManagerSourceService.getSourceById($routeParams.sourceId).then(function (response) {
            this.source = response;

            this.parentChildIds = [response.id];
            if (Array.isArray(response.childIds) && response.childIds.length > 0) {
                this.parentChildIds = this.parentChildIds.concat(response.childIds);
            }

            if (this.source.contactInfo && this.source.contactInfo.addresses && this.source.contactInfo.addresses.length > 0) {
                for (var i = 0; i < this.source.contactInfo.addresses.length; i++) {
                    var addressFieldArray = ['city', 'countryCode', 'countryName', 'stateOrProvince', 'street', 'street2', 'zip'];
                    this.source.contactInfo.addresses[i].isAddressEmpty = true;

                    for (var field in addressFieldArray) {
                        if (this.source.contactInfo.addresses[i][addressFieldArray[field]] !== '') {
                            this.source.contactInfo.addresses[i].isAddressEmpty = false;
                            break;
                        }
                    }
                }
            }
            this.FeedbackService.initializeSource(this.source);
        }.bind(this)).catch(function (err) {
            ContactManagerFlashService.flashError(err);
        });

        this.query = {};

        this.findFilterPromise = null; //promise for find filter debounce

        this.pageState = {};
        if (Object.keys(this.$location.search()).length === 0) {
            this.PageStateService.initializeSaveState();
            this.PageStateService.set(this.$location.search().locker, this.pageState, 'sourceProfile');
            this.$location.replace();
        }

        var possiblePageState = this.PageStateService.get('sourceProfile');
        if (possiblePageState && Object.keys(possiblePageState).length > 0 && possiblePageState.constructor === Object) {
            this.pageState = possiblePageState;
            this.findFilterExpanded = this.pageState.findString ? true : false;
        }

        window.addEventListener('app-chrome-drawer-closed', closeMini, false);
        this.$scope.$on('$locationChangeStart', function (event, next) {
            // PAGE CHANGE
            if (!next.includes('/source')) {
                window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
            }
        }.bind(this));

        this.scrollToTop();
        this.search();

        this.ContactSelector.deselectAll();
    }

    ContactManagerSourceProfileController.prototype.search = function search() {

        this.query.filters = [];
        this.query.filters.push({
            type: 'sources',
            sourceIds: [this.$routeParams.sourceId]
        });

        if (this.pageState.findString) {
            this.query.filters.push({
                type: 'freeTextContact',
                q: this.pageState.findString
            });
        }
        this.ContactStreamData.aggregateSearch(this.query);
    };

    ContactManagerSourceProfileController.prototype.findFilterSearch = function findfilterSearch(searchTerm) {
        var _this2 = this;

        if (this.findFilterPromise) {
            this.$timeout.cancel(this.findFilterPromise);
        }

        this.pageState.findString = searchTerm || '';
        this.setPageState();

        //Only search if we have at least two characters, or reset if the filter text is gone
        if (this.pageState.findString.length > 2 || this.pageState.findString.length === 0) {
            this.findFilterPromise = this.$timeout(function () {
                _this2.search();
            }, 300);
        }
    };

    function closeMini() {
        var _this = angular.element(document.getElementsByClassName('sourceProfilePage')).scope().sourceController;
        _this.MiniProfileService.closeMiniProfile();
        _this.$scope.$apply();
    }

    ContactManagerSourceProfileController.prototype.highlightSelectedContact = function selectedContact(cardContactID) {
        return cardContactID === this.MiniProfileService.miniProfileId;
    };

    ContactManagerSourceProfileController.prototype.setPageState = function setPageState() {
        this.PageStateService.set('sourceProfile', this.pageState);
    };

    ContactManagerSourceProfileController.prototype.showActionButtons = function showActionButtons() {
        return Object.keys(this.ContactSelector.selectedItems).length > 0;
    };

    ContactManagerSourceProfileController.prototype.viewContact = function viewContact(contact) {
        this.InfluencerContactService.setCurrentContact(contact);
        this.MiniProfileService.openMiniProfile(contact.id, true);
    };

    ContactManagerSourceProfileController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        return Object.keys(selectedItems).length;
    };

    ContactManagerSourceProfileController.prototype.resetSelections = function resetSelections() {
        this.ContactSelector.deselectAll();
    };

    ContactManagerSourceProfileController.prototype.tagSelectedContacts = function tagSelectedContacts() {
        var selectedContactIds = Object.keys(this.ContactSelector.selectedItems);

        if (this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.MAX_MEDIALIST_LIMIT || selectedContactIds.length > this.MAX_MEDIALIST_LIMIT) {
            var manageListLimitWarning = document.querySelector('manage-list-limit-warning');
            manageListLimitWarning.open();
        } else {
            window.addEventListener('icm-lists-updated', this.refreshMediaList, { once: true });
            this.addToMediaListModal(selectedContactIds);
        }
    };

    ContactManagerSourceProfileController.prototype.addToMediaListModal = function (selectedContactIds) {
        var manageListDialog = document.querySelector('icm-manage-lists-dialog');

        if (this.ContactSelector.trueAllSelected === true) {
            manageListDialog.openLoading();

            var query = JSON.parse(JSON.stringify(this.query));
            query.pageSize = this.MAX_MEDIALIST_LIMIT;
            query.page = 0;
            this.InfluencerContactService.aggregateContactSearch(query).then(function (response) {
                var contactIds = response.hits.map(function (contact) {
                    return contact.id;
                });
                manageListDialog.open(contactIds);
            }).catch(function (err) {
                manageListDialog.showLoadingErrorState();
                console.err(err);
            });
        } else {
            manageListDialog.open(selectedContactIds);
        }
    };

    ContactManagerSourceProfileController.prototype.refreshMediaList = function refreshMediaList() {
        var _this = angular.element(document.getElementsByClassName('sourceProfilePage')).scope().sourceController;
        _this.ContactSelector.deselectAll();
        _this.$scope.$digest();
    };

    ContactManagerSourceProfileController.prototype.nextPageContacts = function nextPageContacts() {
        this.ContactStreamData.nextPage().then(function () {
            if (this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray, null, null, this.predictionContactFilter);
            }

            this.PageStateService.set('ContactArray', this.ContactStreamData.contactArray);
        }.bind(this));
    };

    ContactManagerSourceProfileController.prototype.scrollToTop = function scrollToTop() {
        this.$rootScope.$broadcast('resetScroll', { duration: 400 });
    };
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ListViewController', ['angular-inview', 'MW.CoreStream', 'MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.InfluencerContactService', 'MW.Framework.TranslationService', 'MW.Framework.ContactFilter', 'MW.Framework.ContentStreamSelectionDecorator', 'MW.Influencers.IcmDialogService', 'MW.ContactManager.ContactManagerFlashService', 'MW.CoreStream.ContactManagerTagService', 'MW.Framework.ContentStreamDataFactory', 'MW.Framework.CoreUserService', 'MW.Framework.ICMEmailService', 'MW.Framework.AppBarTitleService', 'MW.ContactManager.ContactManagerActionBarFactory', 'MW.CoreStream.CsSelectAllHeader', 'MW.Influencers.SegmentTrackingService', 'MW.Influencers.ActionBarService', 'MW.Configuration', 'ngMaterial', 'MW.Influencers.MediaListEngagementWidget', 'MW.ContactManager.MwMediaListUpdateModal', 'MW.Framework.ICMEntitlementService', 'MW.Influencers.MiniProfileService']).controller('ListViewController', ['$q', 'ContactManagerNavigationService', 'InfluencerContactService', 'translationService', 'DialogService', 'ContactManagerFlashService', 'ContactManagerTagService', 'ContentStreamSelectionDecorator', 'ContactStreamDataFactory', 'DEFAULT_MEDIA_LIST', 'CoreUserService', 'ICMEmailService', '$location', 'AppBarTitleService', 'ContactManagerActionBarFactory', 'ICM_RECIPIENTS_PER_DISTRIBUTION', 'MAX_MEDIALIST_LIMIT', '$translate', '$timeout', '$mdDialog', '$mdToast', '$scope', 'SegmentTrackingService', 'ActionBarService', '$routeParams', 'ICMEntitlementService', 'ICM_CONTACT_SOURCE_SERVICE_API_KEY', 'ICM_CONTACT_SERVICE_URL', 'CONTACT_MANAGER_MEDIA_LIST_URL', 'MiniProfileService', ListViewController]);

    function ListViewController($q, ContactManagerNavigationService, InfluencerContactService, translationService, DialogService, ContactManagerFlashService, ContactManagerTagService, ContentStreamSelectionDecorator, ContactStreamDataFactory, DEFAULT_MEDIA_LIST, CoreUserService, ICMEmailService, $location, AppBarTitleService, ContactManagerActionBarFactory, ICM_RECIPIENTS_PER_DISTRIBUTION, MAX_MEDIALIST_LIMIT, $translate, $timeout, $mdDialog, $mdToast, $scope, SegmentTrackingService, ActionBarService, $routeParams, ICMEntitlementService, ICM_CONTACT_SOURCE_SERVICE_API_KEY, ICM_CONTACT_SERVICE_URL, CONTACT_MANAGER_MEDIA_LIST_URL, MiniProfileService) {
        var _this2 = this;

        this.ICM_RECIPIENTS_PER_DISTRIBUTION = ICM_RECIPIENTS_PER_DISTRIBUTION;
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.SegmentTrackingService = SegmentTrackingService;
        this.ActionBarService = ActionBarService;
        this.$mdToast = $mdToast;
        this.ICM_CONTACT_SOURCE_SERVICE_API_KEY = ICM_CONTACT_SOURCE_SERVICE_API_KEY;
        this.ICM_CONTACT_SERVICE_URL = ICM_CONTACT_SERVICE_URL;
        this.CONTACT_MANAGER_MEDIA_LIST_URL = CONTACT_MANAGER_MEDIA_LIST_URL;
        this.MiniProfileService = MiniProfileService;
        this.$scope = $scope;

        var pageTitle = 'Influencers';
        translationService.getLocalizedString(pageTitle, null, true).then(function setLocalizedTitle(localizedString) {
            pageTitle = localizedString;
        }).catch(function () {}).finally(function () {
            AppBarTitleService.setCurrentTitle(pageTitle);
        });

        this.DEFAULT_MEDIA_LIST = DEFAULT_MEDIA_LIST;
        this.$q = $q;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.translationService = translationService;
        this.DialogService = DialogService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.ContactManagerTagService = ContactManagerTagService;
        this.InfluencerContactService = InfluencerContactService;
        this.CoreUserService = CoreUserService;
        this.ICMEmailService = ICMEmailService;
        this.$location = $location;
        this.ContactSelector = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });
        this.ICMEntitlementService = ICMEntitlementService;
        this.ICMEntitlementService.getIcmContactExportLimit().then(function (entitlementLimit) {
            _this2.exportLimit = entitlementLimit;
        });

        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);

        this.ContactStreamData = new ContactStreamDataFactory();

        this.findString = '';
        this.findFilterExpanded = false;
        this.findFilterPromise = null; //promise for find filter debounce

        this.filters = {
            unsubscribe: false
        };
        this.filterOptionsHeader = this.$translate.instant('Filters');
        this.filterOptionsUnsubscribed = this.$translate.instant('Unsubscribed');
        this.filterEmptyText = this.$translate.instant('icm-web__empty-state--empty-filter');
        this.clearFilterOption = this.$translate.instant('icm-web__empty-state--clear-filter');

        this.streamHeaderTextValues = {
            filteredByUnsubscribeSortedByLastName: this.$translate.instant('icm-search__stream-header-text--filter-unsubscribed-and-sort-last-name'),
            sortedByLastName: this.$translate.instant('icm-search__stream-header-text--sort-last-name'),
            filteredByUnsubscribeSortedBySource: this.$translate.instant('icm-search__stream-header-text--filter-unsubscribed-and-sort-source'),
            sortedBySource: this.$translate.instant('icm-search__stream-header-text--sort-source')
        };

        this.successEditListToastMessage = this.$translate.instant('icm-web__media-lists--toast-list-updated');

        this.streamHeaderText = this.streamHeaderTextValues.sortedByLastName;
        this.sortMenuSubHeader = this.$translate.instant('icm-search__menu-header--sort-by');
        this.sortByOptions = {
            lastName: {
                display: this.$translate.instant('icm-search__sort-by--last-name'),
                value: 'lastName'
            },
            source: {
                display: this.$translate.instant('icm-search__sort-by--source'),
                value: 'source'
            }
        };
        this.selectedSortBy = this.sortByOptions.lastName.value;
        this.sortOrderOptions = {
            ascending: {
                display: this.$translate.instant('icm-search__sort-order--ascending'),
                value: 'ascending'
            },
            descending: {
                display: this.$translate.instant('icm-search__sort-order--descending'),
                value: 'descending'
            }
        };
        this.selectedSortOrder = this.sortOrderOptions.ascending.value;

        this.anyKeywords = '';

        this.defaultMasterListId = '';
        this.defaultMasterListName = 'All Contacts';
        this.totalMediaListContacts = 0;
        this.isLoadingContacts = true;

        //Code to show/hide Welcome Module
        CoreUserService.getCurrent(true).then(function () {
            entitlementPromises.push(this.ICMEntitlementService.getIcmCountriesEntitlement());
            entitlementPromises.push(this.ICMEntitlementService.getInfluencerAppEntitlement());

            $q.all(entitlementPromises).then(function (results) {
                this.isInfluencerDatabaseEntitled = results[0] && results[0].length > 0;
                this.isInfluencerAppEntitled = results[1];
            }.bind(this)).finally(function () {
                this.checkingActionPanelEntitlements = false;
            }.bind(this));
        }.bind(this));

        // CHECK ALL ENTITLEMENTS FOR THE SIDE ACTION PANEL
        // do some waiting to reduce flicker
        var entitlementPromises = [];
        this.checkingActionPanelEntitlements = true;
        this.isInfluencerDatabaseEntitled = false;
        this.isInfluencerAppEntitled = false;

        this.selectedMediaList = false;
        this.allContacts = false;

        this.translationService.getLocalizedString('All Contacts', null, true).then(function setLocalizedAllContacts(localizedString) {
            this.allContactsLabel = localizedString;
        }.bind(this)).catch(function () {});

        this.isPermissions = false;
        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this)).catch(function () {});

        this.selectedMediaListId = $routeParams.listId;
        this.setMediaList(this.selectedMediaListId);

        this.actions = [{
            name: 'edit_list',
            label: this.$translate.instant('icm-web__action-bar--edit-list'),
            icon: 'meltwater:edit',
            onClick: function onClick() {
                _this2.showEditDialog();
            },
            enabled: this.selectedMediaListId, // do not show this on all contacts
            doNotDisableActions: true
        }, {
            name: 'outreach',
            label: this.$translate.instant('icm-web__action-bar--send-outreach'),
            icon: 'communication:ic_email_24px',
            onClick: function onClick() {
                _this2.composeEmailToList(_this2.selectedMediaListId);
            },
            enabled: this.isOutreachActionEnabled(),
            doNotDisableActions: true
        }, {
            name: 'add_contact',
            label: this.$translate.instant('icm-contact-add-landing__breadcrumb-title'),
            icon: 'social:ic_person_add_24px',
            onClick: function onClick() {
                _this2.ContactManagerNavigationService.goToContactAddLanding('influencers/contact/landing');
            },
            enabled: true
        }, {
            name: 'search',
            label: this.$translate.instant('icm-contact-add-landing__action-search-contacts--action'),
            icon: 'action:ic_search_24px',
            onClick: function onClick() {
                _this2.ContactManagerNavigationService.goToSearch();
            },
            enabled: true
        }, {
            label: this.$translate.instant('icm-web__action-bar--all-contacts'),
            icon: 'social:ic_group_24px',
            onClick: function onClick() {
                _this2.ContactManagerNavigationService.goToAllContactsList();
            },
            enabled: !!this.selectedMediaListId
        }];
        this.ActionBarService.registerActions(this.actions);

        function closeMini() {
            var _this = angular.element(document.getElementsByClassName('contactListPage')).scope().listController;
            _this.MiniProfileService.closeMiniProfile();
            _this.$scope.$apply();
        }

        window.addEventListener('app-chrome-drawer-closed', closeMini, false);
        this.$scope.$on('$locationChangeStart', function (event, next) {
            // PAGE CHANGE
            if (!next.includes('/contact-list')) {
                window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
            }
        }.bind(this));
    }

    ListViewController.prototype.isListFiltered = function isListFiltered() {
        return this.filters.unsubscribe === true || this.findString.length > 0;
    };

    ListViewController.prototype.isEmptyStateVisible = function isEmptyStateVisible() {
        return !this.isLoadingContacts && this.totalMediaListContacts < 1 && !this.isListFiltered();
    };

    ListViewController.prototype.clearFilters = function clearFilters() {
        this.findString = '';
        this.findFilterExpanded = false;
        this.filters.unsubscribe = false;

        if (this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.selectedUnsubscribeFilter = function selectedUnsubscribeFilter() {
        // need to make sure we toggle this setting before calling to retrieve the contacts
        // the methods to get the contacts depend on this setting
        this.filters.unsubscribe = !this.filters.unsubscribe;

        if (this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.updateSort = function updateSort(sortBy, sortOrder) {
        if (sortBy && sortBy.value) {
            this.selectedSortBy = sortBy.value;
        }

        if (sortOrder && sortOrder.value) {
            this.selectedSortOrder = sortOrder.value;
        }

        if (this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.updateStreamHeaderText = function updateStreamHeaderText() {
        if (this.selectedSortBy === this.sortByOptions.lastName.value) {
            this.streamHeaderText = this.filters.unsubscribe ? this.streamHeaderTextValues.filteredByUnsubscribeSortedByLastName : this.streamHeaderTextValues.sortedByLastName;
        } else if (this.selectedSortBy === this.sortByOptions.source.value) {
            this.streamHeaderText = this.filters.unsubscribe ? this.streamHeaderTextValues.filteredByUnsubscribeSortedBySource : this.streamHeaderTextValues.sortedBySource;
        }
    };

    ListViewController.prototype.isOutreachActionEnabled = function isOutreachActionEnabled() {
        return !!this.selectedMediaListId && this.totalMediaListContacts <= this.ICM_RECIPIENTS_PER_DISTRIBUTION;
    };

    ListViewController.prototype.setMediaList = function setMediaList(mediaListId) {
        var _this3 = this;

        if (mediaListId) {
            this.ContactManagerTagService.getMediaListById(this.selectedMediaListId).then(function (medialistObject) {
                _this3.mediaListName = medialistObject.name;
                _this3.mediaListDescription = medialistObject.description;
                _this3.mediaListUpdatedDate = medialistObject.updated;
                _this3.mediaListCreatedDate = medialistObject.created;

                _this3.ActionBarService.registerTitle(medialistObject.name);
                _this3.ActionBarService.setBackButtonVisibility(true);
                _this3.getContactsByMediaListId(mediaListId);
            });
        } else {
            this.allContacts = true;
            this.mediaListName = this.$translate.instant('All Contacts');
            this.ActionBarService.registerTitle(this.mediaListName);
            this.ActionBarService.setBackButtonVisibility(true);
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.addContact = function addContact() {
        this.ContactManagerNavigationService.goToAdd();
    };

    ListViewController.prototype.showActionButtons = function showActionButtons() {
        return Object.keys(this.ContactSelector.selectedItems).length > 0;
    };

    ListViewController.prototype.deleteContacts = function deleteContacts() {
        var contactIds = Object.keys(this.ContactSelector.selectedItems);
        if (this.ContactSelector.trueAllSelected) {
            contactIds = [];
        }

        this.openDeleteContactsConfirmDialog(contactIds, this.selectedMediaListId, this.findString);
    };

    ListViewController.prototype.exportContactsToCSV = function exportContactsToCSV(ev) {
        var _this4 = this;

        var isAllContacts = this.mediaListName === this.defaultMasterListName,
            csvFileName = this.ContactSelector.isAllSelected() ? isAllContacts ? this.allContactsLabel : this.mediaListName : 'contacts',
            numberOfContacts = this.ContactSelector.trueAllSelected ? this.ContactStreamData.totalContacts : Object.keys(this.ContactSelector.selectedItems).length;

        csvFileName = csvFileName.replace(/[#%&\{\}\\<>\*\?\/\$!'":@\+`\|=]/g, '-');
        if (this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.exportLimit || Object.keys(this.ContactSelector.selectedItems).length > this.exportLimit) {
            this.$translate('icm-export__exceed-limit-message', { limit: this.exportLimit }).then(function (tooLargeMessage) {
                this.$translate('Selection Too Large').then(function (tooLargeTitle) {
                    this.DialogService.alert(tooLargeMessage, tooLargeTitle);
                }.bind(this)).catch(function () {});
            }.bind(this)).catch(function () {});
        } else {
            this.$mdDialog.show(this.$mdDialog.mwAlert().class('legal-message').textContent(this.$translate.instant('icm-export__legal-message')).ok(this.$translate.instant('OK')).targetEvent(ev)).then(function () {
                _this4.ContactManagerActionBarFactory.exportContactsToCSV(csvFileName, isAllContacts, _this4.selectedMediaListId, _this4.exportLimit, _this4.findString);
                _this4.SegmentTrackingService.trackEvent('export_contact', _this4.selectedMediaListId || 'All Contacts', numberOfContacts, 'ICM_contact_lists');
            });
        }
    };

    ListViewController.prototype.openDeleteContactsConfirmDialog = function openDeleteContactsConfirmDialog(contactIds, selectedMediaListId, findString) {
        var _this5 = this;

        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                deleteAll: false,
                showCheckbox: !this.allContacts && !this.ContactSelector.trueAllSelected,
                plural: contactIds.length > 1 || this.ContactSelector.trueAllSelected,
                deleteFromAllLists: this.allContacts
            },
            template: '<md-dialog id="delete-medialist-mini-modal" class="mw-mini-modal" aria-label="" layout="column">\n                        <delete-medialist class="mw-mini-modal-wrapper" delete-from-all-lists="$ctrl.deleteFromAllLists" plural="$ctrl.plural" show-checkbox="$ctrl.showCheckbox" layout="column"></delete-medialist>\n                    </md-dialog>',
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then(function (shouldDeleteAll) {
            if (contactIds.length > 0 && !_this5.ContactSelector.trueAllSelected) {
                _this5.removeContactsFromLists(contactIds, selectedMediaListId, shouldDeleteAll);
            } else {
                _this5.retrieveContactsForDeletion(selectedMediaListId, findString).then(function (idsToDelete) {
                    _this5.removeContactsFromLists(idsToDelete, selectedMediaListId, shouldDeleteAll);
                });
            }
        });
    };

    ListViewController.prototype.removeContactFromList = function removeContactFromList(contactId) {
        this.ContactStreamData.removeContactById(contactId);
        this.ContactSelector.deselectItemById(contactId);
    };

    ListViewController.prototype.viewContact = function viewContact(contact) {
        this.InfluencerContactService.setCurrentContact(contact);
        this.MiniProfileService.openMiniProfile(contact.id, true);
    };

    ListViewController.prototype.findfilterSearch = function findfilterSearch(searchTerm) {
        var _this6 = this;

        if (this.findFilterPromise) {
            this.$timeout.cancel(this.findFilterPromise);
        }

        this.findString = searchTerm || '';

        //Only search if we have at least two characters, or reset if the filter text is gone
        if (this.findString.length > 2 || this.findString.length === 0) {

            // if we are clearing the filter, there is a split second where we show the incorrect empty state
            // we should anticipate that we are going to search to prevent this issue
            if (this.findString.length === 0) {
                this.ContactStreamData.isSearching = true;
            }

            this.findFilterPromise = this.$timeout(function () {
                if (_this6.allContacts) {
                    _this6.getMasterListOfContacts();
                } else {
                    _this6.getContactsByMediaListId(_this6.selectedMediaListId);
                }
            }, 300);
        }
    };

    ListViewController.prototype.resetFindFilter = function resetFindFilter() {
        this.findFilterExpanded = false;
    };

    ListViewController.prototype.getContactsByMediaListId = function getContactsByMediaListId(mediaListId) {
        var _this7 = this;

        var query = {
            mediaListIds: [mediaListId],
            q: this.findString,
            sortBy: this.selectedSortBy,
            sortOrder: this.selectedSortOrder
        };
        this.isLoadingContacts = true;

        if (this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        this.updateStreamHeaderText();
        this.ContactSelector.deselectAll();

        this.ContactStreamData.getByMediaListIds(query).then(function () {
            if (!query.q) {
                _this7.totalMediaListContacts = _this7.ContactStreamData.totalContacts;
                _this7.isLoadingContacts = false;
                for (var i = 0; i < _this7.actions.length; i++) {
                    if (_this7.actions[i].name === 'outreach') {
                        _this7.actions[i].enabled = _this7.isOutreachActionEnabled();
                    }
                }
                _this7.ActionBarService.registerActions(_this7.actions);
            }
        });
    };

    ListViewController.prototype.getMasterListOfContacts = function getMasterListOfContacts() {
        var _this8 = this;

        var query = {
            q: this.findString,
            sortBy: this.selectedSortBy,
            sortOrder: this.selectedSortOrder
        };
        this.isLoadingContacts = true;

        if (this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        this.updateStreamHeaderText();
        this.ContactSelector.deselectAll();
        this.ContactStreamData.getMasterList(query).then(function () {
            _this8.totalMediaListContacts = _this8.ContactStreamData.totalContacts;
            _this8.isLoadingContacts = false;
        });
    };

    ListViewController.prototype.retrieveContactsForDeletion = function retrieveContactsForDeletion(selectedMediaListId, findString) {
        var contactIds = [],
            dataRetrievalPromise = selectedMediaListId === '' || !selectedMediaListId ? this.ContactManagerTagService.getAllContacts : this.ContactManagerTagService.getContactsByMediaListIds,
            query = {
            mediaListIds: selectedMediaListId === '' || !selectedMediaListId ? false : [selectedMediaListId],
            q: findString || '',
            pageSize: this.ContactSelector.allSelected ? this.ContactStreamData.totalContacts : 25
        };

        if (this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        return new Promise(function (resolve, reject) {
            dataRetrievalPromise(query).then(function (results) {
                if (results.hits && results.hits.length > 0) {
                    contactIds = results.hits.map(function (record) {
                        return record.id;
                    });
                }

                resolve(contactIds);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    ListViewController.prototype.removeContactsFromLists = function removeContactsFromLists() {
        var contactIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var _this9 = this;

        var selectedMediaListId = arguments[1];
        var deleteFromAll = arguments[2];

        var privateContacts = this.getPrivateContacts(contactIds),
            getAllTagsPromise = deleteFromAll || this.allContacts ? this.ContactManagerTagService.getAllTags() : Promise.resolve([{ id: selectedMediaListId }]),
            afterRemovePromise = (this.allContacts || deleteFromAll) && privateContacts.length !== 0 ? this.InfluencerContactService.deletePrivateContacts(privateContacts) : Promise.resolve();

        return getAllTagsPromise.then(function (mediaLists) {
            return _this9.ContactManagerTagService.bulkRemoveContactsFromTags(mediaLists.map(function (list) {
                return list.id;
            }), contactIds);
        }).then(function () {
            return afterRemovePromise.then(function () {
                _this9.showToastMessage(_this9.$translate.instant('icm-web__delete-modal--success-message'));

                if (_this9.allContacts) {
                    _this9.getMasterListOfContacts();
                } else {
                    _this9.getContactsByMediaListId(selectedMediaListId);
                }
            });
        }).catch(function () {
            _this9.ContactManagerFlashService.flashError('Failure. Your contacts have not been deleted.');
        });
    };

    ListViewController.prototype.highlightSelectedContact = function highlightSelectedContact(cardContactID) {
        return cardContactID === this.MiniProfileService.miniProfileId;
    };

    ListViewController.prototype.getPrivateContacts = function getPrivateContacts(contactIds) {
        var privateContacts = [];

        this.ContactStreamData.contactArray.forEach(function (contactObj) {
            if (contactIds.indexOf(contactObj.id) > -1 && contactObj.systemData.policies.storage.private) {
                privateContacts.push(contactObj.id);
            }
        });

        return privateContacts;
    };

    ListViewController.prototype.compose = function compose() {
        this.ContactManagerActionBarFactory.compose(this.setRecipients.bind(this));
    };

    ListViewController.prototype.setRecipients = function setRecipients() {
        return this.$q(function (resolve) {
            var selectedContacts = this.ContactSelector.selectedItems,
                mediaListId = this.mediaListName.indexOf(this.DEFAULT_MEDIA_LIST) === 0 ? '' : this.selectedMediaListId,
                findString = !this.findString || this.findString.length <= 2 ? '' : this.findString,
                totalContactsSelected = Object.keys(this.ContactSelector.selectedItems).length,
                query;

            if (this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts === this.totalMediaListContacts || !this.ContactSelector.trueAllSelected && totalContactsSelected === this.totalMediaListContacts) {
                query = {
                    id: mediaListId,
                    name: this.mediaListName
                };

                this.ICMEmailService.setMediaListRecipients([query]);
            } else if (this.ContactSelector.trueAllSelected) {
                query = {
                    mediaListIds: mediaListId === '' ? false : [mediaListId],
                    q: findString,
                    pageSize: this.ContactSelector.allSelected ? this.ContactStreamData.totalContacts : 25
                };

                this.ICMEmailService.setContactRecipientsQuery(query);
            } else {
                var selectedContactArray = Object.keys(selectedContacts).map(function (selectedContactKey) {
                    return selectedContacts[selectedContactKey];
                });

                this.ICMEmailService.setContactRecipients(selectedContactArray);
            }

            resolve();
        }.bind(this));
    };

    ListViewController.prototype.goToSearchPage = function goToSearchPage() {
        this.ContactManagerNavigationService.goToSearch();
    };

    ListViewController.prototype.goToKeywordSearchPage = function goToKeywordSearchPage() {
        this.ContactManagerNavigationService.goToKeywordSearch();
    };

    ListViewController.prototype.goToDirectorySearchPage = function goToDirectorySearchPage() {
        this.ContactManagerNavigationService.goToDirectorySearch();
    };

    ListViewController.prototype.goToUpsellPage = function goToUpsellPage() {
        this.ContactManagerNavigationService.goToUpsellPage();
    };

    ListViewController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        return Object.keys(selectedItems).length;
    };

    ListViewController.prototype.resetSelections = function resetSelections() {
        this.ContactSelector.deselectAll();
    };

    ListViewController.prototype.refreshMediaList = function refreshMediaList() {
        var _this = angular.element(document.getElementsByClassName('contactListPage')).scope().listController;
        _this.ContactSelector.deselectAll();
        _this.setMediaList(_this.selectedMediaListId);
        _this.ContactManagerTagService.updateContactMediaLists(_this.ContactStreamData.contactArray, [_this.ContactSelector.selectedItems], [_this.selectedMediaListId]);
    };
    function getCriteria(query, pageSize, findString) {
        // jshint ignore:line
        var criteria = {};
        angular.extend(criteria, query, {
            page: 0,
            pageSize: pageSize,
            q: findString
        });

        return criteria;
    }

    ListViewController.prototype.tagSelectedContacts = function tagSelectedContacts() {
        var selectedContactIds = Object.keys(this.ContactSelector.selectedItems);

        if (this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.MAX_MEDIALIST_LIMIT || selectedContactIds.length > this.MAX_MEDIALIST_LIMIT) {
            this.openLimitWarningModal();
        } else {
            window.addEventListener('icm-lists-updated', this.refreshMediaList, { once: true });
            var request;
            if (this.ContactSelector.trueAllSelected === true) {
                if (this.selectedMediaListId) {
                    //opens modal when true Selecting All from a media list
                    request = {
                        method: 'POST',
                        url: this.ICM_CONTACT_SERVICE_URL + '/v2/contacts/medialist/' + this.selectedMediaListId,
                        headers: {
                            'x-api-key': this.ICM_CONTACT_SOURCE_SERVICE_API_KEY
                        },
                        data: {
                            'textFilter': this.ContactStreamData.query.q
                        }
                    };
                } else {
                    //opens modal when true Selecting All in "View all Contacts"
                    request = {
                        method: 'POST',
                        url: this.CONTACT_MANAGER_MEDIA_LIST_URL + '/getAllContacts',
                        data: {
                            'q': this.ContactStreamData.query.q,
                            'page': 0,
                            'pageSize': this.MAX_MEDIALIST_LIMIT,
                            'onlyIds': true
                        }

                    };
                }
            }
            this.ContactManagerTagService.addToMediaListModal(request, selectedContactIds);
        }
    };

    ListViewController.prototype.openLimitWarningModal = function () {
        var manageListLimitWarning = document.querySelector('manage-list-limit-warning');
        manageListLimitWarning.open();
    };

    ListViewController.prototype.nextPageContacts = function nextPageContacts() {
        this.ContactStreamData.nextPage().then(function () {
            if (this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray, null, null, this.predictionContactFilter);
            }
        }.bind(this)).catch(function () {});
    };

    ListViewController.prototype.showToastMessage = function (msg) {
        this.$mdToast.show(this.$mdToast.mwSimpleTimed().textContent(msg));
    };

    ListViewController.prototype.composeEmailToList = function (mediaListId) {
        var _this = this;

        _this.ICMEmailService.getIcmApprovedSenders().then(function onGetApprovedSendersSuccess(sendersList) {
            if (sendersList.length > 0) {
                _this.ContactManagerNavigationService.goToOutreach(mediaListId);
            } else {
                var dialogTitle = _this.translationService.getLocalizedString('Compose Email');

                _this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
                    // currently this is service is only ever called by ICM-WEB, so we always load up F-W. in this ends up being used in FW as well, we will need to revisit this logic.
                    _this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
                });
            }
        }).catch(function onGetApprovedSendersFail() {
            _this.DialogService.flashError(_this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
        });
    };

    ListViewController.prototype.showEditDialog = function showEditDialog() {
        var _this = this;

        this.$mdDialog.show({
            bindToController: true,
            locals: {
                mediaList: {
                    id: this.selectedMediaListId,
                    name: this.mediaListName,
                    description: this.mediaListDescription
                },
                duplicateError: false,
                cancelDialog: function cancelDialog() {
                    _this.$mdDialog.cancel();
                },
                okDialog: function okDialog(updatedMediaList) {
                    var _this10 = this;

                    var mediaListId = updatedMediaList.id;
                    var mediaListName = updatedMediaList.name;
                    var mediaListDescription = updatedMediaList.description;

                    this.duplicateError = false;

                    _this.ContactManagerTagService.updateMediaList(mediaListId, mediaListName, mediaListDescription).then(function () {
                        _this.setMediaList(mediaListId);
                        _this.$mdDialog.hide();

                        _this.$mdToast.show(_this.$mdToast.mwSimpleTimed().textContent(_this.successEditListToastMessage));
                    }).catch(function (error) {
                        // somewhere along the line we decided error.status just wasn't cutting it, we thought error.data.error.reason just rolled off the tongue
                        if (error.status === 409 || error && error.data && error.data.error && error.data.error.reason === 409) {
                            _this10.duplicateError = true;
                        } else {
                            _this.$mdDialog.hide();
                            _this.DialogService.flashError(_this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                        }
                    });
                }
            },
            template: '\n                <md-dialog id="icm-media-list-update-modal" class="mw-mini-modal" aria-label="" layout="column">\n                    <mw-media-list-update-modal class="mw-mini-modal-wrapper" layout="column" media-list="$ctrl.mediaList" duplicate-error="$ctrl.duplicateError" ok-callback="$ctrl.okDialog(updatedMediaList)" cancel-callback="$ctrl.cancelDialog()"></mw-media-list-update-modal>\n                </md-dialog>\n            ',
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        });
    };
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    'use strict';
    /**
     * The following will seem ugly and weird, but we need it
     * to remedy a bug with md table where functions passed to it
     * somehow inherit it's context for "this"
     * */

    var mlcContext = null;

    var MediaListController = function () {
        function MediaListController($translate, $filter, $sce, $location, $scope, ContactManagerTagService, ContactManagerNavigationService, $mdDialog, ActionBarService, emptyStateVisible, DialogService, $mdToast, EmailAnalyticsService) {
            var _this = this;

            _classCallCheck(this, MediaListController);

            mlcContext = this;

            this.$mdToast = $mdToast;
            this.successToastMessage = $translate.instant('icm-web__media-lists--toast-list-updated');
            this.$scope = $scope;
            this.EmailAnalyticsService = EmailAnalyticsService;
            this.DialogService = DialogService;
            this.emptyStateVisible = emptyStateVisible;
            this.ActionBarService = ActionBarService;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.$filter = $filter;
            this.$location = $location;
            this.$sce = $sce;
            this.mediaListItems = [];
            this.ContactManagerTagService = ContactManagerTagService;
            this.title = this.$translate.instant('icm-web__media-lists--page-title');
            this.tableTitle = this.$translate.instant('icm-web__media-lists--table-title');
            this.updatedTableTitle = '';
            this.sortByInfoTitle = {
                sortOrderStr: this.$translate.instant('mw-content-stream-sort-menu__sort-order--ascending'),
                orderByStr: this.$translate.instant('icm-web__list-of-lists--sort-by-name')
            };
            this.nameHeaderTitle = this.$translate.instant('icm-web__media-lists--name-header-title');
            this.emailsSentHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--emails-sent');
            this.unsubscribeRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--unsubscribe-rate');
            this.openRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--open-rate');
            this.clickRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--click-rate');
            this.lastUpdatedHeaderTitle = this.$translate.instant('icm-web__media-lists--date-header-title');
            this.lastUpdatedByHeaderTitle = this.$translate.instant('icm-web__media-lists--updated-by-header-title');
            this.createdHeaderTitle = this.$translate.instant('icm-web__media-lists--created-on-header-title');
            this.createdByHeaderTitle = this.$translate.instant('icm-web__media-lists--created-by-header-title');
            this.tablePaginationLabel = this.$translate.instant('mw-collection__table-pagination-of');
            this.sortToolTip = this.$translate.instant('mw-collection__tooltip-sort');
            this.selectedItems = 0;
            this.isSearchActive = false;
            this.findText = '';
            this.paging = {
                itemsPerPage: 25,
                selectedPage: 1,
                orderBy: 'name',
                sortOrder: 'asc'
                //default sorting
            };
            this.pageStart = 1;
            this.pageEnd = 25;

            this.mediaListTotal = 0;
            this.selectedItems = [];
            this.getMediaLists();
            this.preserveScroll = '';
            this.loadPromise = null;
            this.actions = [{
                label: this.$translate.instant('icm-contact-add-landing__breadcrumb-title'),
                icon: 'social:ic_person_add_24px',
                onClick: function onClick() {
                    _this.navigateToUrl('influencers/contact/landing');
                },
                enabled: true
            }, {
                label: this.$translate.instant('icm-contact-add-landing__action-search-contacts--action'),
                icon: 'action:ic_search_24px',
                onClick: function onClick() {
                    ContactManagerNavigationService.goToSearch();
                },
                enabled: true
            }, {
                label: this.$translate.instant('icm-web__action-bar--all-contacts'),
                icon: 'social:ic_group_24px',
                onClick: function onClick() {
                    _this.navigateToUrl('influencers/contact-list');
                },
                enabled: true
            }];

            this.ActionBarService.registerActions(this.actions);
            this.loading = true;
        }

        _createClass(MediaListController, [{
            key: 'reloadCurrentPage',
            value: function reloadCurrentPage() {
                var _this2 = this;

                var mdElements = angular.element('md-content');

                for (var key in mdElements) {
                    if (mdElements && mdElements[key].className && mdElements[key].className === 'mw-flex-padding _md flex') {
                        this.preserveScroll = mdElements[key].scrollTop;
                        break;
                    }
                }

                this.getMediaLists(mlcContext.paging.selectedPage, mlcContext.paging.itemsPerPage, this.getSortOrder(), mlcContext.findText).then(function () {
                    if (_this2.mediaListItems === 0) {
                        _this2.emptyStateVisible = true;
                    } else {
                        for (var _key in mdElements) {
                            if (mdElements && mdElements[_key].className && mdElements[_key].className === 'mw-flex-padding _md flex') {
                                mdElements[_key].scrollTop = _this2.preserveScroll;
                                break;
                            }
                        }
                    }
                });
            }
        }, {
            key: 'getMediaLists',
            value: function getMediaLists() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

                var _this3 = this;

                var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'NAME_ASC';
                var q = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                this.loading = true;
                if (!this.loadPromise) {
                    this.loadPromise = new Promise(function (resolve, reject) {
                        _this3.ContactManagerTagService.getAllTags(page, size, sort, q).then(function (response) {
                            _this3.loadPromise = null;
                            _this3.mediaListItems = response.mediaLists;
                            _this3.mediaListTotal = response.count;
                            _this3.updatePageInfo();
                            _this3.updatedTableTitle = _this3.mediaListTotal + ' ' + _this3.tableTitle;
                            _this3.loading = false;
                            _this3.$scope.$digest();
                            resolve(_this3.mediaListItems);
                        }).catch(function (error) {
                            _this3.medialistItems = [];
                            _this3.updatedTableTitle = _this3.mediaListItems.length + ' ' + _this3.tableTitle;
                            _this3.loading = false;
                            reject(error);
                        });
                    });
                }
                return this.loadPromise;
            }
        }, {
            key: 'isHeaderTitleVisible',
            value: function isHeaderTitleVisible() {
                return true;
            }
        }, {
            key: 'isSearchVisible',
            value: function isSearchVisible() {
                return true;
            }
        }, {
            key: 'onSearchToggle',
            value: function onSearchToggle(isSearchActive) {
                this.isSearchActive = isSearchActive;
            }
        }, {
            key: 'search',
            value: function search(findText) {
                if (findText.length === 0 || findText.length >= 3) {
                    this.findText = findText;
                    this.page(1);
                }
            }
        }, {
            key: 'cannotFindList',
            value: function cannotFindList() {
                return !this.loading && this.mediaListTotal === 0 && this.findText.length >= 3;
            }
        }, {
            key: '_scrollTableIntoView',
            value: function _scrollTableIntoView() {
                // when paging through the table, put it back into view
                document.getElementById('mediaListManagement').scrollIntoView();
            }
        }, {
            key: 'nextPage',
            value: function nextPage() {
                var nextPageNumber = mlcContext.paging.selectedPage + 1;
                mlcContext.page(nextPageNumber);
            }
        }, {
            key: 'previousPage',
            value: function previousPage() {
                var previousPageNumber = mlcContext.paging.selectedPage - 1;
                mlcContext.page(previousPageNumber);
            }
        }, {
            key: 'page',
            value: function page(pageNumber) {
                mlcContext._scrollTableIntoView();

                mlcContext.isDataLoaded = false;
                mlcContext.paging.selectedPage = pageNumber;

                mlcContext.getMediaLists(pageNumber, 25, mlcContext.getSortOrder(), mlcContext.findText);
            }
        }, {
            key: 'updatePageInfo',
            value: function updatePageInfo() {
                mlcContext.pageStart = mlcContext.paging.itemsPerPage * (mlcContext.paging.selectedPage - 1) + 1;
                mlcContext.pageEnd = Math.min(mlcContext.paging.itemsPerPage * mlcContext.paging.selectedPage, mlcContext.mediaListTotal);
                if (mlcContext.mediaListTotal === 0) {
                    mlcContext.pageEnd = 0;
                    mlcContext.pageStart = 0;
                } else if (mlcContext.mediaListTotal < mlcContext.pageEnd) {
                    mlcContext.pageEnd = mlcContext.mediaListTotal;
                }
            }
        }, {
            key: 'getSortOrder',
            value: function getSortOrder() {
                return mlcContext.paging.orderBy.toUpperCase() + '_' + mlcContext.paging.sortOrder.toUpperCase();
            }
        }, {
            key: 'isCurrentSort',
            value: function isCurrentSort(orderBy) {
                return mlcContext.paging.orderBy === orderBy;
            }
        }, {
            key: 'setOrderBy',
            value: function setOrderBy(orderBy) {
                mlcContext.paging.orderBy = orderBy;
                mlcContext.page(1);
                this.setSortOrderInfoString();
            }
        }, {
            key: 'setOrdering',
            value: function setOrdering(order) {
                mlcContext.paging.sortOrder = order;
                mlcContext.page(1);
                this.setSortOrderInfoString();
            }
        }, {
            key: 'isAscending',
            value: function isAscending() {
                return mlcContext.paging.sortOrder === 'asc';
            }
        }, {
            key: 'setSortOrderInfoString',
            value: function setSortOrderInfoString() {
                switch (mlcContext.paging.orderBy) {
                    case 'name':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-name');
                        break;
                    case 'updated':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-updated');
                        break;
                    case 'lastUpdatedBy':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-updated-by');
                        break;
                    case 'created':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-created');
                        break;
                    case 'createdBy':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-created-by');
                        break;
                    case 'distributions':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-distributions');
                        break;
                    case 'openRate':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-openRate');
                        break;
                    case 'clickToOpenRate':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-clickToOpenRate');
                        break;
                    case 'unsubscribeRate':
                        this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-unsubscribeRate');
                        break;
                    default:
                        break;
                }

                this.sortByInfoTitle.sortOrderStr = mlcContext.paging.sortOrder === 'asc' ? this.$translate.instant('mw-content-stream-sort-menu__sort-order--ascending') : this.$translate.instant('mw-content-stream-sort-menu__sort-order--descending');
            }
        }, {
            key: 'navigateToMediaList',
            value: function navigateToMediaList(mediaListId) {
                this.navigateToUrl('influencers/contact-list/' + mediaListId);
            }
        }, {
            key: 'navigateToUrl',
            value: function navigateToUrl(url) {
                this.$location.url(url);
            }
        }]);

        return MediaListController;
    }();

    angular.module('MW.ContactManager.MediaListController', ['ngMaterial', 'MW.CoreStream.ContactManagerTagService', 'MW.Influencers.ActionBarService', 'MW.ContactManager.MwMediaListUpdateModal', 'MW.Influencers.IcmDialogService', 'MW.Influencers.EmailAnalyticsService', 'MW.ContactManager.MwMediaListCard', 'MW.ContactManager.ContactManagerNavigationService']).controller('MediaListController', ['$translate', '$filter', '$sce', '$location', '$scope', 'ContactManagerTagService', 'ContactManagerNavigationService', '$mdDialog', 'ActionBarService', 'emptyStateVisible', 'DialogService', '$mdToast', 'EmailAnalyticsService', MediaListController]);
})(window.angular);
'use strict';

(function (appContainerPlaceholder) {
    'use strict';

    angular.module('navigationController', ['MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Configuration', 'MW.Influencers.AnalyticsService', 'MW.Influencers.ActionBarService']).controller('navigationController', ['$location', '$window', '$mdDialog', '$mdMedia', '$q', '$translate', 'CoreUserService', 'CoreCompanyService', '$rootScope', 'FAIRHAIR_WEB_URL', 'ACCOUNTS_APP_URL', 'ENV', 'AnalyticsService', 'ActionBarService', NavigationController]);

    function NavigationController($location, $window, $mdDialog, $mdMedia, $q, $translate, CoreUserService, CoreCompanyService, $rootScope, FAIRHAIR_WEB_URL, ACCOUNTS_APP_URL, ENV, AnalyticsService, ActionBarService) {

        this.actionBarService = ActionBarService;
        this.FAIRHAIR_WEB_URL = FAIRHAIR_WEB_URL;
        this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
        this.ENV = ENV;
        this.AnalyticsService = AnalyticsService;
        this.CoreCompanyService = CoreCompanyService;
        this.CoreUserService = CoreUserService;
        // this entitlement needs to be true to get from fairhair-web to icm-web. so set it.
        CoreUserService.isIcmCountriesEntitlement = true;
        this.$location = $location;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$mdDialog = $mdDialog;
        this.$mdMedia = $mdMedia;
        this.$q = $q;
        this.$translate = $translate;
        this.currentTab = null;
        this.tabItems = [];
        this.headerText = 'Influencers';
        this.height = '500px';
        this.hideChrome = false;
        this.customAppContainerClass = '';
        this.navModuleEnvironment = 'production';

        this.$onInit = function () {
            var _this = this;

            this.isFullScreenEnabled = this.$location.absUrl().indexOf('fullscreen=true') > 0 ? true : false;

            if (this.ENV !== 'production') {
                this.navModuleEnvironment = 'staging';
            }

            CoreUserService.getCurrent(true).then(function (user) {
                _this.user = user;
            });
            CoreCompanyService.getCurrent(true).then(function (selectedAccount) {
                _this.company = selectedAccount;
                _this.initSelectedAccount = selectedAccount;
            });

            $rootScope.$on('$routeChangeStart', function onRouteChangeStart($event, newRoute) {
                $mdDialog.hide();
                this.hideChrome = this.isRouteChromeless(newRoute);
                this.customAppContainerClass = this.getAppContainerClass(newRoute);
            }.bind(this));

            $rootScope.$on('$routeChangeSuccess', function onRouteChangeSuccess($event, currentRoute) {
                this.hideChrome = this.isRouteChromeless(currentRoute);
                this.customAppContainerClass = this.getAppContainerClass(currentRoute);
                this.resetContentScroll();
                this.syncSubNavWithRoute();

                if (this.cachedTabItems) {
                    this.cachedTabItems.some(function (item, index) {
                        if (currentRoute && item.link === currentRoute.$$route.originalPath) {
                            this.currentTab = this.cachedTabItems[index];
                        } else if (this.cachedTabItems.length - 1 === index) {
                            this.currentTab = {};
                        }
                    }, this);
                }

                if (currentRoute.$$route && currentRoute.$$route.useActionBar) {
                    this.useActionBar = true;
                } else {
                    this.useActionBar = false;
                }

                // if we are hiding the chrome (aka navigation header & sidebar), then we never load the nav module
                // which means we never resolve the miIaNavigationService.navItemsPromise.promise. we depend on that
                // promise resolving to remove the app container placeholder in the constructor of this controller.
                // ...so we need to clean up after the hideChrome route is ready
                if (this.hideChrome && appContainerPlaceholder) {
                    appContainerPlaceholder.remove();
                }
            }.bind(this));
        };
    }

    NavigationController.prototype.getScreenSize = function getScreenSize() {
        if (this.$mdMedia('xs')) {
            return 'xs';
        }
        if (this.$mdMedia('sm')) {
            return 'sm';
        }
        if (this.$mdMedia('md')) {
            return 'md';
        }
        if (this.$mdMedia('lg')) {
            return 'lg';
        }
        if (this.$mdMedia('xl')) {
            return 'xl';
        }
    };

    NavigationController.prototype.isSubLinkActive = function isSubLinkActive(itemPath) {
        return this.$location.path().indexOf(itemPath) !== -1;
    };

    NavigationController.prototype.resetContentScroll = function resetContentScroll(scrollParams) {
        var scrollContainerElement = $('md-content.mw-flex-padding');

        if (scrollContainerElement.length) {
            scrollContainerElement.animate({
                scrollTop: 0
            }, {
                duration: scrollParams && scrollParams.duration ? scrollParams.duration : 0
            });
        }
    };

    NavigationController.prototype.userMenuHeaderClick = function userMenuHeaderClick() {
        this.$window.location.href = this.FAIRHAIR_WEB_URL + '/settings/personal';
    };

    NavigationController.prototype.logout = function logout() {
        this.$window.location.href = this.ACCOUNTS_APP_URL + '/logout';
    };

    NavigationController.prototype.selectAccount = function selectAccount(account) {
        var currentAccountId = this.CoreCompanyService.getId();

        if (currentAccountId !== account._id) {
            this.AnalyticsService.trackNavigation('switch_account', {
                type: 'primary',
                label: 'Influencers',
                url: '/influencers',
                sourceUrl: this.$location.url(),
                pinStatus: 'open',
                language: this.user.language
            });

            this.showCompanySwitchProgress();
            this.$window.location.href = this.ACCOUNTS_APP_URL + '/switchingCompany/' + account._id;
        }
    };

    NavigationController.prototype.showCompanySwitchProgress = function showCompanySwitchProgress() {
        this.$mdDialog.show({
            template: '<md-dialog style="background:transparent;box-shadow:none;">' + '    <div style="margin:auto;" class="spinner"></div>' + '</md-dialog>',
            parent: angular.element(document.body),
            fullscreen: false,
            disableParentScroll: true
        });
    };

    NavigationController.prototype.selectNavItem = function selectNavItem(navItem) {
        if (navItem.title !== 'Help') {
            this.AnalyticsService.trackNavigation('click_nav', {
                type: 'primary',
                label: 'Influencers',
                url: '/influencers',
                sourceUrl: this.$location.url(),
                pinStatus: 'open',
                language: this.user.language
            });
        }

        // the contact form has an event handler for navigating away from an incomplete form, trigger it
        // ...this probably isn't the best way, should revisit this as this list of custom handlers grows
        if (this.$location.url().match(/contact\/(create|edit)/)) {
            // prevent us from updating the icon state before we know if location change is successful
            this.navItems.forEach(function (navItem) {
                navItem.isActive = navItem.title === 'Influencers' ? true : false;
            });

            this.$rootScope.$broadcast('$locationChangeStart', navItem.link, this.$location.url());
        } else {
            // navigate within app, or reload page/app
            if (navItem.link.match('/influencers') || navItem.link.match('/newswire')) {
                this.$location.url(navItem.link);
            } else {
                this.$window.location.href = navItem.link;
            }
        }
    };

    NavigationController.prototype.selectTabItem = function selectTabItem(tabItem) {
        //For now, we only want to do this for the search route, search controller listens to 'currentTabSelected'
        if (this.currentTab && this.currentTab.link && this.currentTab.title === 'influencers-subtabs__search' && tabItem.link === this.currentTab.link) {
            this.$rootScope.$broadcast('currentTabSelected');
        } else {
            this.tabItems.forEach(function (item) {
                if (item.link === tabItem.link) {
                    item.isActive = true;
                } else {
                    item.isActive = false;
                }
            });
            this.selectNavItem(tabItem);
        }
    };

    NavigationController.prototype.getAppContainerClass = function getAppContainerClass(route) {
        if (route && route.$$route && route.$$route.customContainerClass) {
            return route.$$route.customContainerClass;
        } else {
            return '';
        }
    };

    NavigationController.prototype.isRouteChromeless = function isRouteChromeless(route) {
        return route && route.$$route && (route.$$route.hideNavigation === true || route.$$route.isChromeless === true);
    };

    NavigationController.prototype.help = function help() {
        if (this.$window._elev && this.$window._elev.open) {
            this.$window._elev.open();
        }
    };

    NavigationController.prototype.syncSubNavWithRoute = function syncSubNavWithRoute() {
        this.CoreUserService.getInfluencersSubTabs().then(function (subNav) {
            this.iterateSubNavWithRoute(subNav);
        }.bind(this)).catch(function (subNav) {
            this.iterateSubNavWithRoute(subNav);
        }.bind(this));
    };

    NavigationController.prototype.hasTabItems = function hasTabItems() {
        return Array.isArray(this.tabItems) && this.tabItems.length > 0;
    };

    NavigationController.prototype.iterateSubNavWithRoute = function iterateSubNavWithRoute(result) {
        this.cachedTabItems = result.slice();
        this.tabItems = result;

        this.tabItems.some(function (tabItem, index) {
            var isActive = false;
            if (typeof tabItem.customIsActive === 'function') {
                isActive = tabItem.customIsActive();
            } else {
                isActive = tabItem.link === this.$location.path();
            }
            tabItem.isActive = isActive;

            if (isActive) {
                this.cachedTabItems[index].isActive = true;
                this.currentTab = this.cachedTabItems[index];
            }

            return isActive;
        }, this);
    };
})(window.appContainerPlaceholder);
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.ProfileSwitcherController', ['Configuration']).controller('ProfileSwitcherController', ['$window', '$timeout', '$route', 'IRM_BASE_URL', ProfileSwitcherController]);

    function ProfileSwitcherController($window, $timeout, $route, IRM_BASE_URL) {
        var contactId = $route.current.params.contactId;

        $timeout(function () {
            $window.location.replace(IRM_BASE_URL + '/contact/' + contactId + '?' + $window.location.search);
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.SearchV2', ['angular-inview', 'MW.CoreStream.CsSelectAllHeader', 'MW.ContactManager.OnEnterAction', 'MW.ContactManager.MwSearchInput', 'MW.Framework.ContentStreamDataFactory', 'MW.Framework.ContentStreamSelectionDecorator', 'MW.Framework.InfluencerContactService', 'MW.CoreStream.ContactManagerTagService', 'ngRoute', 'ngMaterial', 'mwAppComponents', 'MW.ContactManager.MwExpansionPanel', 'MW.ContactManager.MwLocationExpansionPanel', 'MW.ContactManager.MwEmailAddressExpansionPanel', 'MW.ContactManager.MwListStatusExpansionPanel', 'LanguageService', 'MW.Influencers.IcmLanguageService', 'MW.Influencers.IcmDialogService', 'MW.Framework.RelevantArticlesDialogService', 'MW.Influencers.FilterFactory', 'MW.Framework.PageStateService', 'MW.Framework.ICMUserService', 'MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.ContactManager.SelectionFactory', 'MW.ContactManager.MwBeatsHeader', 'MW.Framework.EntitlementService', 'MW.Influencers.MiniProfileService', 'MW.ContactManager.MwMapModal', 'MW.Influencers.AnalyticsService', 'MW.Influencers.MapService', 'MW.Influencers.CloudwatchService', 'MW.Framework.MomentService']).controller('SearchControllerV2', ['$window', '$route', '$location', '$rootScope', '$scope', '$translate', '$mdDialog', '$mdToast', '$timeout', '$http', 'ContactStreamDataFactory', 'SourceStreamDataFactory', 'ContentStreamSelectionDecorator', 'InfluencerContactService', 'ContactManagerTagService', 'IcmLanguageService', 'DialogService', 'RelevantArticlesDialogService', '$q', 'FilterFactory', 'LocationFilter', 'PageStateService', 'ICMUserService', 'CoreUserService', 'CoreCompanyService', 'BeatFilter', 'SourceFilter', 'EmailFilter', 'ListStatusFilter', 'MAX_MEDIALIST_LIMIT', 'EntitlementService', 'MiniProfileService', 'AnalyticsService', 'MapService', 'CloudwatchService', 'moment', 'countryMapping', '$sce', 'allContactsCount', 'ICM_CSS_URL', SearchControllerV2]);

    function SearchControllerV2($window, $route, $location, $rootScope, $scope, $translate, $mdDialog, $mdToast, $timeout, $http, ContactStreamDataFactory, SourceStreamDataFactory, ContentStreamSelectionDecorator, InfluencerContactService, ContactManagerTagService, IcmLanguageService, DialogService, RelevantArticlesDialogService, $q, FilterFactory, LocationFilter, PageStateService, ICMUserService, CoreUserService, CoreCompanyService, BeatFilter, SourceFilter, EmailFilter, ListStatusFilter, MAX_MEDIALIST_LIMIT, EntitlementService, MiniProfileService, AnalyticsService, MapService, CloudwatchService, moment, countryMapping, $sce, allContactsCount, ICM_CSS_URL) {
        var _this2 = this;

        $rootScope.$on('currentTabSelected', function () {
            _this2.resetPageState();
        });

        $rootScope.$on('clearAll', function () {
            _this2.clearAll();
        });

        this.allContactsCount = allContactsCount;
        this.MiniProfileService = MiniProfileService;
        this.CloudwatchService = CloudwatchService;
        this.moment = moment;
        this.countryMapping = countryMapping.data;
        this.$window = $window;
        this.$route = $route;
        this.$location = $location;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$q = $q;
        this.$sce = $sce;
        this.previousQuery = {};
        this.PageStateService = PageStateService;
        this.ICMUserService = ICMUserService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.IcmLanguageService = IcmLanguageService;
        this.DialogService = DialogService;
        this.RelevantArticlesDialogService = RelevantArticlesDialogService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerTagService = ContactManagerTagService;
        this.ContactStreamDataForRelevant = new ContactStreamDataFactory();
        this.SourceStreamDataForNames = new SourceStreamDataFactory();
        this.ContactStreamDataForNames = new ContactStreamDataFactory();
        this.SourceStreamDataForRelevant = new SourceStreamDataFactory();
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.LOCKER_NAMESPACE = 'searchState';
        this.expansionTabs = [1, 2];
        this.MapService = MapService;
        this.EntitlementService = EntitlementService;
        this.AnalyticsService = AnalyticsService;
        this.showLocationSuggest = false;
        this.autoProfilesSplitIo = false;
        this.improvedKeyWordSplit = false;
        this.translatedCountryList = [];
        this.userLanguage = false;
        this.relevantSearchLoading = false;
        this.nameSearchLoading = false;
        this.relevantQuery = {};
        this.ICM_CSS_URL = ICM_CSS_URL;

        // Get AppSettings for the page
        this.contactSettings = null;
        this.contentStreamSettings = null;
        this.CoreUserService.getCurrent(true).then(function getUser(currentUser) {
            if (currentUser._id) {
                this.ICMUserService.getAppSettings('contacts', currentUser._id).then(function (contactSettings) {
                    if (contactSettings) {
                        this.contactSettings = contactSettings;
                    }
                }.bind(this));

                this.ICMUserService.getAppSettings('sharedContentStreamSettings', currentUser._id).then(function (contentStreamSettings) {
                    if (contentStreamSettings) {
                        this.contentStreamSettings = contentStreamSettings;
                    }
                }.bind(this));
            }
        }.bind(this));

        this.viewport = {
            topLeft: null,
            bottomRight: null
        };
        this.mapView = true;
        this.updateMapSearch = false;

        this.detectedBeats = [];
        this.datePickerOptions = [{
            display: this.$translate.instant('icm-search__date-picker--14-days'),
            loadingText: 'icm-search__loading-text--14-days',
            value: 14,
            materialSyntax: {
                name: 'Last 14 days',
                type: 'last14Days'
            }
        }, {
            display: this.$translate.instant('icm-search__date-picker--30-days'),
            loadingText: 'icm-search__loading-text--30-days',
            value: 30,
            materialSyntax: {
                name: 'Last 30 days',
                type: 'last30Days'
            }
        }, {
            display: this.$translate.instant('icm-search__date-picker--90-days'),
            loadingText: 'icm-search__loading-text--90-days',
            value: 90,
            materialSyntax: {
                name: 'Last 90 days',
                type: 'last90Days'
            }
        }];
        this.dateRangeTypes = this.datePickerOptions.map(function (datePickerOption) {
            return datePickerOption.materialSyntax.type;
        });

        this.ContactSelectorForRelevant = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactRelevantFilter'
        });
        this.ContactSelectorForNames = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });
        // filters
        this.beatsFilter = new BeatFilter('icm-search__beats-filter--title', this.refreshBeatSearch.bind(this));
        this.reachesFilter = new FilterFactory('icm-search__reach-filter--title', this.refreshSearch.bind(this));
        this.rolesFilter = new FilterFactory('icm-search__role-filter--title', this.refreshSearch.bind(this));
        this.mediaChannelsFilter = new FilterFactory('icm-search__mediaChannel-filter--title', this.refreshSearch.bind(this));
        this.newsFocusesFilter = new FilterFactory('icm-search__geographicRegion-filter--title', this.refreshSearch.bind(this));
        this.frequenciesFilter = new FilterFactory('icm-search__frequency-filter--title', this.refreshSearch.bind(this));
        this.languagesFilter = new FilterFactory('icm-search__language-filter--title', this.refreshSearch.bind(this));
        this.locationsFilter = new LocationFilter('icm-search__location-filter--title', this.refreshSearch.bind(this));
        this.sourcesFilter = new SourceFilter('icm-search__sourceName-filter--title', this.refreshSearch.bind(this));
        this.emailsFilter = new EmailFilter('Email Filter Title', this.refreshSearch.bind(this));
        this.listStatusFilter = new ListStatusFilter('icm-search__list-status-filter--title', this.refreshSearch.bind(this));
        this.scrollDiv = 'mi-app-chrome-content-slot';
        // debounce promises
        this.findFilterPromise = null;
        this.filterChangePromise = null;

        this.initializeDefaultAggs();

        // page state stuff
        this.pageState = {};

        this.pageState.searchText = '';
        this.pageState.searchChips = [];
        this.pageState.findStringRelevant = '';
        this.pageState.findStringNamed = '';
        this.pageState.sortField = 'relevance';
        this.pageState.searchPlaceholder = 'icm-search__default-search-placeholder';
        this.pageState.sourceSearchPlaceholder = 'icm-search__source-search-placeholder';
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.pageState.miniProfileContactId = '';
        this.resetMaterialDatePicker();

        this.pageState.hideStream = true;
        this.pageState.emptyState = true;
        this.pageState.noResults = false;
        this.pageState.showFilters = true;
        this.pageState.forceShowFilters = false;
        this.pageState.isContactSearch = true;
        this.pageState.isRelevantSelected = false;
        this.pageState.pageRefresh = false;
        //Map Stuff - before page state
        this.pageState.mapFilterCheckbox = false;
        this.showLocationTabSwitchModal = true;
        this.pageState.mapActive = false;

        $scope.$on('$locationChangeStart', function (event, next) {
            // PAGE CHANGE
            if (!next.includes('icm-web/influencers/search/v2')) {
                this.pageState.pageRefresh = true;
                this.setPageState();
                window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
            }
        }.bind(this));

        window.addEventListener('beforeunload', function () {
            // PAGE REFRESH
            this.pageState.pageRefresh = true;
            this.setPageState();
        }.bind(this));

        window.addEventListener('app-chrome-drawer-closed', closeMini, false);

        function closeMini() {
            var _this = angular.element(document.getElementsByClassName('searchPage')).scope().searchController;
            if (_this.pageState.pageRefresh === false) {
                _this.MiniProfileService.closeMiniProfile();
                _this.pageState.miniProfileContactId = '';
                _this.setPageState();
                _this.$scope.$apply();
            }
        }

        this.initializeSearchTypeOptions();

        this.userLanguage = this.CoreUserService.getLanguage();
        this.cachedAllAggs = this.PageStateService.getItem('allAggs', null, this.LOCKER_NAMESPACE);
        if (this.cachedAllAggs && this.cachedAllAggs.userLanguage !== this.userLanguage) {
            this.cachedAllAggs = null;
        }
        if (this.$location.search().locker && this.PageStateService.get(this.$location.search().locker, null, this.LOCKER_NAMESPACE) !== null) {
            this.pageState = this.PageStateService.get(this.$location.search().locker, null, this.LOCKER_NAMESPACE);
            // Get all the possible filter options beforehand
            this.searchForNonRelevantFilterOptions().then(function () {
                _this2.insertNonRelevantFilterOptions();
            }).catch(function () {});

            // the bounds object should have the mapboxgl class of LngLatBounds
            // it gets changed to raw json in the pagestate, so need to re-add the class
            if (this.pageState.viewportBounds && this.pageState.viewportBounds.bounds && this.pageState.viewportBounds.bounds._ne && this.pageState.viewportBounds.bounds._sw) {
                this.pageState.viewportBounds.bounds = new $window.mapboxgl.LngLatBounds(this.pageState.viewportBounds.bounds._sw, this.pageState.viewportBounds.bounds._ne);
            }
            this.MapService.initialize(this.pageState.viewportBounds);
            this.initializePageFromState();
        } else {
            this.initializeLockerState();

            // load up the initial filter options here
            this.loadAggsOnly().then(function () {
                // Get all the possible filter options beforehand
                _this2.searchForNonRelevantFilterOptions().then(function (allAggs) {
                    _this2.insertNonRelevantFilterOptions(allAggs);
                }).catch(function () {});
            });
        }

        //Map Stuff - after page state
        this.MapService.registerRefreshSearch(this.refreshSearch.bind(this));
        this.MapService.registerLocationFilter(this.locationsFilter.selectionFactory);

        this.pageState.mapFilterCheckboxCopy = this.pageState.mapFilterCheckbox;

        this.findFilterExpandedRelevant = !!this.pageState.findStringRelevant;
        this.findFilterExpandedNamed = !!this.pageState.findStringNamed;
        this.showSearchDropDown = false;

        this.$rootScope.$on('clearLocationFilter', function () {
            this.clearLocationFilter();
        }.bind(this));

        this.NAME_SEARCH_TAB = 'nameSearchTab';
        this.RELEVANT_SEARCH_TAB = 'relevantSearchTab';

        this.activeSearchTab = this.pageState.isRelevantSelected ? this.RELEVANT_SEARCH_TAB : this.NAME_SEARCH_TAB;

        this.isNameSearchFilterActive = this.pageState.findStringNamed.length > 0 ? true : false;
        this.isKeywordSearchFilterActive = this.pageState.findStringRelevant.length > 0 ? true : false;
    }

    // SEARCH_VERSION_TOGGLE
    SearchControllerV2.prototype.openOptOutModal = function openOptOutModal() {
        var _this = this;

        _this.$mdDialog.show(_this.$mdDialog.mwMiniModal({
            templateUrl: 'icm-web/views/opt_out_modal',
            locals: {
                reason: ''
            },
            clickOutsideToClose: true
        })).then(function okHandler(reason) {
            var redirectUrl = '/influencers/search?searchVersion=v1';
            if (_this.$location.search().locker) {
                redirectUrl += '&locker=' + _this.$location.search().locker;
            }

            sessionStorage.setItem('icm.search.optout.reeason', reason);
            _this.$location.url(redirectUrl);
        }, function cancelHandler() {
            _this.$mdDialog.hide();
        }).catch(function () {});
    };

    SearchControllerV2.prototype.getTranslatedResultString = function getTranslatedResultString(count) {
        var itemCount = Math.max(0, count);
        var message = itemCount === 1 ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';

        return this.$translate.instant(message, { itemCount: itemCount });
    };

    SearchControllerV2.prototype.toggleSearchFilter = function toggleSearchFilter() {
        if (this.pageState.isRelevantSelected) {
            if (this.isKeywordSearchFilterActive === true) {
                this.isKeywordSearchFilterActive = false;
                this.findfilterSearchRelevant('');
            } else {
                this.isKeywordSearchFilterActive = true;
            }
        } else {
            if (this.isNameSearchFilterActive === true) {
                this.isNameSearchFilterActive = false;
                this.findfilterSearchNamed('');
            } else {
                this.isNameSearchFilterActive = true;
            }
        }
    };

    SearchControllerV2.prototype.resetPageState = function resetPageState() {
        var _this3 = this;

        this.setSearchType();

        // page state stuff
        this.clearAll();
        this.pageState = {};
        this.initializeDefaultAggs();
        this.pageState.searchText = '';
        this.pageState.searchChips = [];
        this.pageState.findStringRelevant = '';
        this.pageState.findStringNamed = '';
        this.pageState.sortField = 'relevance';
        this.pageState.searchPlaceholder = 'icm-search__default-search-placeholder';
        this.pageState.sourceSearchPlaceholder = 'icm-search__source-search-placeholder';
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();
        this.PageStateService.miniProfileContactId = '';
        this.pageState.hideStream = true;
        this.pageState.emptyState = true;
        this.pageState.noResults = false;
        this.pageState.showFilters = true;
        this.pageState.forceShowFilters = false;
        this.pageState.isContactSearch = true;
        this.pageState.mapFilterCheckbox = false;

        this.initializeSearchTypeOptions();
        this.setPageState();
        this.searchForNonRelevantFilterOptions().then(function () {
            _this3.insertNonRelevantFilterOptions();
        }).catch(function () {});
    };

    SearchControllerV2.prototype.initializeSearchTypeOptions = function initializeSearchTypeOptions() {
        this.pageState.searchTypeOptions = [{
            title: 'icm-search__type--influencers',
            type: 'contact',
            selected: false,
            placeholder: this.$translate.instant('icm-search__influencers-placeholder')
        }, {
            title: 'icm-search__type--influencers-who-write-about',
            type: 'relevantContact',
            selected: false,
            placeholder: this.$translate.instant('icm-search__relevant-influencers-placeholder')
        }, {
            title: 'icm-search__type--sources',
            type: 'source',
            selected: false,
            placeholder: this.$translate.instant('icm-search__sources-placeholder')
        }, {
            title: 'icm-search__type--sources-who-write-about',
            type: 'relevantSource',
            selected: false,
            placeholder: this.$translate.instant('icm-search__relevant-sources-placeholder')
        }];
    };

    SearchControllerV2.prototype.initializeDefaultAggs = function initializeDefaultAggs() {
        var defaultContactAggs = [{ type: 'countriesAndRegions' }, { type: 'beats' }, { type: 'roles' }, { type: 'sourcesReachTiers' }, { type: 'languages' }, { type: 'sourcesMediaChannels' }, { type: 'sourcesNewsFocuses' }, { type: 'sourcesFrequencies' }, { type: 'sources', size: 1 }],
            defaultSourceAggs = [{ type: 'countriesAndRegions' }, { type: 'beats' }, { type: 'reachTiers' }, { type: 'mediaChannels' }, { type: 'newsFocuses' }, { type: 'frequencies' }, { type: 'languages' }];

        this.defaultAggs = {
            contact: defaultContactAggs,
            relevantContact: defaultContactAggs,
            source: defaultSourceAggs,
            relevantSource: defaultSourceAggs
        };
    };
    SearchControllerV2.prototype.getUpdateButtonText = function getUpdateButtonText() {
        if (this.pageState.isContactSearch) {
            return 'icm-search__map-filter--reload-result';
        } else {
            return 'icm-search__map-filter--reload-result-sources';
        }
    };

    SearchControllerV2.prototype.initializeLockerState = function initializeLockerState() {
        if (this.PageStateService.lockerId.searchState) {
            delete this.PageStateService.lockerId.searchState;
        }

        if (this.$location.search().locker) {
            delete this.$location.search().locker;
        }

        this.PageStateService.initializeSaveState('searchState');
        this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
    };

    SearchControllerV2.prototype.initializePageFromState = function initializePageFromState() {
        if (this.pageState.pageRefresh && this.pageState.miniProfileContactId) {
            this.MiniProfileService.openMiniProfile(this.pageState.miniProfileContactId, false); // False is used to match refresh state to stop prevent default from running since the user didnt click anything
        }
        this.pageState.pageRefresh = false;

        if (this.pageState.aggs) {
            this.updateFiltersBasedOnAggs(this.pageState.aggs);
        }
        this.updateFilterSelection();
        this.pageState.findStringRelevant = this.pageState.findStringRelevant || ''; //for Find Filter Search
        this.pageState.findStringNamed = this.pageState.findStringNamed || ''; //for Find Filter Search
        this.previousQuery = this.pageState.previousQuery || {};
        this.searchForBoth(true);
        this.setPageState();
    };

    /*
     ----------------------------------
     -------- View Functions ---------
     ----------------------------------
     */
    SearchControllerV2.prototype.getDateRangeForContentHeader = function getDateRangeForContentHeader() {
        if (this.pageState.isRelevantSelected && (!!this.pageState.searchText.length || !!this.pageState.searchChips.length)) {
            return this.pageState.dateRangeDays;
        } else {
            return -1;
        }
    };

    SearchControllerV2.prototype.getLoadingText = function getLoadingText() {
        var currentIndex, localizedString;
        this.datePickerOptions.some(function (obj, i) {
            return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
        }.bind(this));

        if (currentIndex === undefined) {
            return '';
        }

        localizedString = this.datePickerOptions[currentIndex].loadingText;
        return this.$translate.instant(localizedString);
    };

    SearchControllerV2.prototype.getInfoTip = function getInfoTip(filterName) {
        var searchType = this.getSelectedSearchType(),
            localizedString = 'icm-search__';

        if (searchType === 'contact' || searchType === 'relevantContact') {
            localizedString += 'influencer-filters--';
            if (filterName === 'location') {
                localizedString += 'map-';
            }
            localizedString += filterName + '-infoTip';
        } else {
            localizedString += 'source-filters--';
            if (filterName === 'location') {
                localizedString += 'map-';
            }
            localizedString += filterName + '-infoTip';
        }
        return this.$translate.instant(localizedString);
    };

    SearchControllerV2.prototype.viewContact = function viewContact(contact) {
        this.pageState.miniProfileContactId = contact.id;
        this.MiniProfileService.openMiniProfile(this.pageState.miniProfileContactId, true);
        this.setPageState();
        this.InfluencerContactService.setCurrentContact(contact);
    };

    SearchControllerV2.prototype.highlightSelectedContact = function selectedContact(cardContactID) {
        return cardContactID === this.MiniProfileService.miniProfileId;
    };

    SearchControllerV2.prototype.showActionButtons = function showActionButtons(selectedItems) {
        return Object.keys(selectedItems).length > 0;
    };

    SearchControllerV2.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        if (selectedItems) {
            return Object.keys(selectedItems).length;
        }
        return 0;
    };

    SearchControllerV2.prototype.getSelectedCountFromSelector = function getSelectedCountFromSelector(selector, totalContacts) {
        var selectedCount;

        if (selector.trueAllSelected) {
            selectedCount = totalContacts;
        } else {
            selectedCount = Object.keys(selector.selectedItems).length;
        }

        return selectedCount;
    };

    // this function will determine when to grey-out the background. if auto-suggest menu (includes suggestions) is visible, grey-out the background
    SearchControllerV2.prototype.setAutoSuggestVisibility = function setAutoSuggestVisibility(isVisible) {
        if (isVisible) {
            if (this.pageState.searchText && this.pageState.searchText.length >= 2 && this.pageState.searchChips.length === 0) {
                this.autoSuggestVisible = true;
            }
        } else {
            this.autoSuggestVisible = false;
            $('.contentWrapper').show();
            this.pageState.showFilters = true;
            //Need to trigger a scroll event on the containing element
            //so that the content stream sticky header will render correctly
            $('md-content.mw-flex-padding').trigger('scroll');
        }
    };

    SearchControllerV2.prototype.updateBeatChips = function updateBeatChips(searchChips) {
        return searchChips.filter(function (searchChip) {
            if (searchChip.beat) {
                return this.beatsFilter.selectionFactory.isSelected(searchChip.beat);
            } else {
                return true;
            }
        }, this);
    };

    SearchControllerV2.prototype.refreshBeatSearch = function refreshBeatSearch() {
        this.pageState.searchChips = this.updateBeatChips(this.pageState.searchChips);

        this.refreshSearch();
    };

    SearchControllerV2.prototype.refreshSearch = function refreshSearch() {
        var _this4 = this;

        if (this.filterChangePromise) {
            this.$timeout.cancel(this.filterChangePromise);
        }
        this.filterChangePromise = this.$timeout(function () {
            _this4.searchForBoth();
        }, 600);
    };

    /*
        -----------------------------------------
        -------- AutoSuggest Functions ----------
        -----------------------------------------
    */
    SearchControllerV2.prototype.autoSuggestSourceNames = function autoSuggestSourceNames(searchText) {
        var _this5 = this;

        return this.$q(function (resolve) {
            return _this5.buildSearchQuery(_this5.pageState.searchText, _this5.pageState.searchChips, [{
                type: 'sources',
                q: searchText
            }], 0).then(function (query) {
                query.page = 0;
                var promiseArray = [_this5.InfluencerContactService.aggregateContactSearch(query)];
                var relevantQuery = JSON.parse(JSON.stringify(query));
                if (relevantQuery.orQ.length !== 0 || relevantQuery.relevantQ && relevantQuery.relevantQ.length !== 0) {
                    relevantQuery.docQuery = {
                        dateStart: _this5.moment().tz(_this5.ICMUserService.getTimezone()).subtract(_this5.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                        dateEnd: _this5.moment().tz(_this5.ICMUserService.getTimezone()).endOf('day').toISOString()
                    };
                    promiseArray.push(_this5.InfluencerContactService.aggregateRelevantContacts(relevantQuery));
                }
                return _this5.$q.all(promiseArray);
            }).then(function (response) {
                var sourceNameAggregations = [],
                    combinedAggs,
                    selectedSources,
                    nameAggs = response[0] && response[0].aggs ? response[0].aggs : '',
                    relevantAggs = response[1] && response[1].aggs ? response[1].aggs : '';

                combinedAggs = _this5.combineAggregations(nameAggs, relevantAggs);

                if (Object.keys(combinedAggs).length !== 0) {
                    _this5.updateFiltersBasedOnAggs(combinedAggs);
                    selectedSources = _this5.sourcesFilter.getSelectedValues();
                    sourceNameAggregations = combinedAggs.sources.map(function (sourceNameObject) {
                        return sourceNameObject;
                    }).filter(function (option) {
                        return !selectedSources.some(function (selectedOption) {
                            return option.key === selectedOption;
                        }.bind(this));
                    }.bind(_this5));
                }

                resolve(sourceNameAggregations);
            });
        });
    };

    function combineAggregationsChildren(nameAggChild, relevantAggChild) {
        var allChildren = [];
        if (nameAggChild.length && !relevantAggChild.length) {
            return nameAggChild;
        } else if (!nameAggChild.length && relevantAggChild.length) {
            return relevantAggChild;
        } else if (nameAggChild.length && relevantAggChild.length) {
            allChildren = JSON.parse(JSON.stringify(nameAggChild));
            _.forEach(relevantAggChild, function (relChild) {
                var matchIndex = _.findIndex(allChildren, function (matchChild) {
                    return matchChild.key === relChild.key;
                });
                if (matchIndex === -1) {
                    allChildren.push(relChild);
                } else {
                    allChildren[matchIndex].count += relChild.count;
                }
            });
        } else {
            return [];
        }
        return allChildren;
    }

    SearchControllerV2.prototype.combineAggregations = function (nameAggs, relevantAggs) {
        var allAggs = {};
        if (nameAggs && !relevantAggs) {
            return nameAggs;
        } else if (!nameAggs && relevantAggs) {
            return relevantAggs;
        } else if (nameAggs && relevantAggs) {
            allAggs = JSON.parse(JSON.stringify(nameAggs));
            _.forEach(relevantAggs, function (agg, key) {
                if (allAggs[key]) {
                    relevantAggs[key].forEach(function (relAgg) {
                        var matchIndex = _.findIndex(allAggs[key], function (matchAgg) {
                            return matchAgg.key === relAgg.key;
                        });
                        if (matchIndex === -1) {
                            allAggs[key].push(relAgg);
                        } else {
                            allAggs[key][matchIndex].count += relAgg.count;

                            if (allAggs[key][matchIndex].children || relAgg.children) {
                                allAggs[key][matchIndex].children = combineAggregationsChildren(allAggs[key][matchIndex].children, relAgg.children);
                            }
                        }
                    });
                } else {
                    allAggs[key] = agg;
                }
            });
        } else {
            return {};
        }
        return allAggs;
    };

    /*
     ----------------------------------
     -------- Filter Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.updateFilterSelection = function updateFilterSelection() {
        if (this.pageState.beatsFilter) {
            this.beatsFilter.selectionFactory.displayState = this.pageState.beatsFilter;
        }
        if (this.pageState.locationsFilter) {
            this.locationsFilter.selectionFactory.displayState = this.pageState.locationsFilter.selectionFactory.displayState;
            Object.values(this.locationsFilter.selectionFactory.displayState.selected).forEach(function (option) {
                this.locationsFilter.selectionFactory.select(option);
            }.bind(this));
        }
        if (this.pageState.rolesFilter) {
            this.rolesFilter.selectionFactory.displayState = this.pageState.rolesFilter.selectionFactory.displayState;
        }
        if (this.pageState.reachesFilter) {
            this.reachesFilter.selectionFactory.displayState = this.pageState.reachesFilter;
        }
        if (this.pageState.mediaChannelsFilter) {
            this.mediaChannelsFilter.selectionFactory.displayState = this.pageState.mediaChannelsFilter;
        }
        if (this.pageState.newsFocusesFilter) {
            this.newsFocusesFilter.selectionFactory.displayState = this.pageState.newsFocusesFilter;
        }
        if (this.pageState.frequenciesFilter) {
            this.frequenciesFilter.selectionFactory.displayState = this.pageState.frequenciesFilter;
        }
        if (this.pageState.languagesFilter) {
            this.languagesFilter.selectionFactory.displayState = this.pageState.languagesFilter.selectionFactory.displayState;
        }
        if (this.pageState.sourcesFilter) {
            this.sourcesFilter.selectionFactory.displayState = this.pageState.sourcesFilter;
        }
        if (this.pageState.emailsFilter) {
            this.emailsFilter.selectedEmails = this.pageState.emailsFilter;
        }
        if (this.pageState.listStatusFilter) {
            this.listStatusFilter.selectedOption = this.pageState.listStatusFilter;
        }
    };

    SearchControllerV2.prototype.resetSelections = function resetSelections() {
        this.ContactSelectorForNames.deselectAll();
        this.ContactSelectorForRelevant.deselectAll();
    };

    SearchControllerV2.prototype.searchInputChanged = function searchInputChanged(searchText) {
        this.pageState.searchText = searchText;
        this.setPageState();

        if (searchText === '' && this.pageState.searchChips.length === 0 && this.isRelevantSearch()) {
            this.clearAll();
        }
    };

    SearchControllerV2.prototype.isRelevantSearch = function isRelevantSearch() {
        return this.getSelectedSearchType() === 'relevantContact' || this.getSelectedSearchType() === 'relevantSource';
    };

    SearchControllerV2.prototype.resetMaterialDatePicker = function resetMaterialDatePicker() {
        this.pageState.selectedDateRange = {
            name: 'Last 14 days',
            type: 'last14Days'
        };
    };

    SearchControllerV2.prototype.selectDatePicker = function selectDatePicker(option) {
        var _this6 = this;

        this.pageState.selectedDateRange = option;

        this.datePickerOptions.some(function (datePickerOption) {
            if (datePickerOption.materialSyntax.type === option.type) {
                _this6.pageState.dateRangeDays = datePickerOption.value;
                return true;
            }
        });

        this.MiniProfileService.closeMiniProfile();
        this.pageState.pageRefresh = false;
        this.pageState.miniProfileContactId = '';
        this.setPageState();

        if (this.pageState.isContactSearch) {
            this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[1].type, true);
        } else {
            this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[3].type, true);
        }
    };

    SearchControllerV2.prototype.initializeContactSampleSearch = function initializeContactSampleSearch() {
        this.resetChipSummary();
        this.selectInfluencers();
        if (this.beatsFilter.selectionFactory.currentOptions.length === 0) {
            this.updateFiltersBasedOnAggs(this.cachedAllAggs.contact);
        }

        this.beatsFilter.selectionFactory.selectByKey('494c9425-5727-4ec3-95f0-33cd2778d8ba');
        this.reachesFilter.selectionFactory.selectByKey('tier_1');
        this.searchForBoth();
    };

    SearchControllerV2.prototype.initializeSourceSampleSearch = function initializeSourceSampleSearch() {
        this.resetChipSummary();
        this.selectSources();
        if (this.beatsFilter.selectionFactory.currentOptions.length === 0) {
            this.updateFiltersBasedOnAggs(this.cachedAllAggs.source);
        }

        this.beatsFilter.selectionFactory.selectByKey('78ed275a-a2cf-4067-abfd-7ef00f35eeff');
        this.reachesFilter.selectionFactory.selectByKey('tier_1');
        this.searchForBoth();
    };

    /*
     ----------------------------------
     -------- Clear Functions ---------
     ----------------------------------
     */

    // cleared from the expansion panel
    SearchControllerV2.prototype.clearSourcesFilter = function clearSourcesFilter(ignoreSearch) {

        this.sourcesFilter.clearAll();
        this.pageState.sourcesFilter = null;

        if (!ignoreSearch) {
            this.sourcesFilter.waitOnSearch();
            //        this.search(this.pageState.searchText, this.pageState.searchChips);
            this.searchForBoth();
        }
    };

    SearchControllerV2.prototype.clearLocationFilter = function clearLocationFilter() {
        var _this7 = this;

        // if were clearing it, we need to wait on the search
        this.isSwitchingLocationFilters = true;
        this.clearMapsViewportBounds();
        this.locationsFilter.waitOnSearch();
        this.locationsFilter.clearAll();
        this.pageState.mapFilterCheckbox = false;
        this.pageState.locationsFilter = null;
        this.totalContacts = undefined;
        this.MapService.boundsSelected(this.startingBounds);
        this.pageState.mapActive = false;
        // this.search(this.pageState.searchText, this.pageState.searchChips).finally(() => {
        this.searchForBoth().finally(function () {
            _this7.isSwitchingLocationFilters = false;
        });
    };

    SearchControllerV2.prototype.clearBeatsFilter = function clearBeatsFilter() {
        // if were clearing it, we need to wait on the search
        this.beatsFilter.waitOnSearch();
        this.beatsFilter.clearAll();
        this.pageState.beatsFilter = null;

        // need to call this AFTER beatsFilter.clearAll
        this.pageState.searchChips = this.updateBeatChips(this.pageState.searchChips);

        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearRolesFilter = function clearRolesFilter() {
        // if were clearing it, we need to wait on the search
        this.rolesFilter.waitOnSearch();
        this.rolesFilter.clearAll();
        this.pageState.rolesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearReachesFilter = function clearReachesFilter(ignoreSearch) {
        // if were clearing it, we need to wait on the search
        this.reachesFilter.waitOnSearch();
        this.reachesFilter.clearAll();
        this.pageState.reachesFilter = null;
        if (!ignoreSearch) {
            this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
        }
    };

    SearchControllerV2.prototype.clearMediaChannelsFilter = function clearMediaChannelsFilter() {
        // if were clearing it, we need to wait on the search
        this.mediaChannelsFilter.waitOnSearch();
        this.mediaChannelsFilter.clearAll();
        this.pageState.mediaChannelsFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearNewsFocusesFilter = function clearNewsFocusesFilter() {
        // if were clearing it, we need to wait on the search
        this.newsFocusesFilter.waitOnSearch();
        this.newsFocusesFilter.clearAll();
        this.pageState.newsFocusesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearFrequenciesFilter = function clearFrequenciesFilter() {
        // if were clearing it, we need to wait on the search
        this.frequenciesFilter.waitOnSearch();
        this.frequenciesFilter.clearAll();
        this.pageState.frequenciesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearLanguagesFilter = function clearLanguagesFilter() {
        // if were clearing it, we need to wait on the search
        this.languagesFilter.waitOnSearch();
        this.languagesFilter.clearAll();
        this.pageState.frequenciesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearEmailsFilter = function clearEmailsFilter() {
        // if we're clearing it, we need to wait on the search
        this.emailsFilter.waitOnSearch();
        this.emailsFilter.clearAll();
        this.pageState.emailsFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearListStatusFilter = function clearListStatusFilter() {
        // if we're clearing it, we need to wait on the search
        this.listStatusFilter.waitOnSearch();
        this.listStatusFilter.clearAll();
        this.pageState.listStatusFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearAll = function clearAll(clickedAutoSuggest) {
        var _this8 = this;

        this.MiniProfileService.closeMiniProfile();

        var searchType = this.getSelectedSearchType();
        clickedAutoSuggest = clickedAutoSuggest || false;
        //This DOM update was taking too long, so... let's use animation frames instead
        window.requestAnimationFrame(function () {
            _this8.MapService.setInteractionState(_this8.MapService.HELPER_TEXT);
        });
        this.$rootScope.$broadcast('clearLocationFilter');
        this.beatsFilter.clearAll();
        this.rolesFilter.clearAll();
        this.reachesFilter.clearAll();
        this.mediaChannelsFilter.clearAll();
        this.newsFocusesFilter.clearAll();
        this.frequenciesFilter.clearAll();
        this.languagesFilter.clearAll();
        this.emailsFilter.clearAll();
        this.listStatusFilter.clearAll();
        this.clearSourcesFilter(true);
        this.mapSearchText = '';
        this.MapService.cachedViewportBounds = this.setDefaultMapView(this.getCountriesList(), this.countryMapping);
        this.totalContacts = undefined;
        this.pageState.isRelevantSelected = false;

        this.ContactStreamDataForRelevant.resetSearch();
        this.ContactStreamDataForNames.resetSearch();
        this.SourceStreamDataForRelevant.resetSearch();
        this.SourceStreamDataForNames.resetSearch();

        this.findFilterExpandedRelevant = false;
        this.findFilterExpandedNamed = false;
        this.pageState.mapFilterCheckbox = false;
        this.pageState.locationsFilter = null;
        this.pageState.beatsFilter = null;
        this.pageState.rolesFilter = null;
        this.pageState.reachesFilter = null;
        this.pageState.mediaChannelsFilter = null;
        this.pageState.newsFocusesFilter = null;
        this.pageState.frequenciesFilter = null;
        this.pageState.languagesFilter = null;
        this.pageState.sourcesFilter = null;
        this.pageState.emailsFilter = null;
        this.pageState.listStatusFilter = null;
        this.pageState.miniProfileContactId = '';
        this.pageState.pageRefresh = false;
        this.pageState.searchText = '';
        this.pageState.findStringRelevant = ''; //for Find Filter Search
        this.pageState.findStringNamed = ''; //for Find Filter Search
        this.pageState.namedAggs = {};
        this.pageState.relevantAggs = {};
        if (!clickedAutoSuggest) {
            this.pageState.searchText = '';
            this.pageState.searchChips.length = 0;
        }

        collapseAllFilters();

        this.resetChipSummary();
        this.locationsFilter.updateQuery('', [], searchType, [], this.pageState.dateRangeDays);

        if (!clickedAutoSuggest) {
            // Use cached default aggs (if there) instead of searching for them
            if (!this.pageState.searchText && this.pageState.searchChips.length === 0 && this.cachedAllAggs) {
                var emptyStateAggs;
                if (this.pageState.isContactSearch) {
                    emptyStateAggs = this.cachedAllAggs.contact;
                } else {
                    emptyStateAggs = this.cachedAllAggs.source;
                }
                this.updateFiltersBasedOnAggs(emptyStateAggs);

                // reset the empty state
                this.pageState.noResults = false;
                this.pageState.hideStream = true;
                this.pageState.emptyState = true;

                this.setPageState();
            }
            this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
        }

        this.activeSearchTab = this.NAME_SEARCH_TAB;
        this.isNameSearchFilterActive = false;
        this.isKeywordSearchFilterActive = false;
    };

    SearchControllerV2.prototype.allFiltersWaitOnSearch = function allFiltersWaitOnSearch() {
        this.locationsFilter.waitOnSearch();
        this.beatsFilter.waitOnSearch();
        this.rolesFilter.waitOnSearch();
        this.reachesFilter.waitOnSearch();
        this.mediaChannelsFilter.waitOnSearch();
        this.newsFocusesFilter.waitOnSearch();
        this.frequenciesFilter.waitOnSearch();
        this.languagesFilter.waitOnSearch();
        this.emailsFilter.waitOnSearch();
        this.listStatusFilter.waitOnSearch();
    };

    /*
        ----------------------------------
        -------- Find Filter Functions ---------
        ----------------------------------
    */

    SearchControllerV2.prototype.buildFindFilterQuery = function buildFindFilterQuery(searchType, query) {
        var findQuery = {};
        findQuery.type = searchType === 'contact' || searchType === 'relevantContact' ? 'freeTextContact' : 'freeTextSource';
        if (searchType.indexOf('relevant') > -1) {
            if (this.pageState.findStringRelevant.length) {
                findQuery.q = this.pageState.findStringRelevant;
                query.filters.push(findQuery);
            }
        } else {
            if (this.pageState.findStringNamed.length) {
                findQuery.q = this.pageState.findStringNamed;
                query.filters.push(findQuery);
            }
        }
        return query;
    };

    /*
     ----------------------------------
     -------- Search Functions ---------
     ----------------------------------
     */

    // Insert the non relevant options into a filter
    SearchControllerV2.prototype.insertNonRelevantFilterOptions = function insertNonRelevantFilterOptions(allAggsObj) {
        var searchType = this.getSelectedSearchType(),
            filterNames,
            allAggs;

        // return if a search type is not selected
        if (!searchType) {
            return;
        }

        // new Stuff
        if (this.pageState.isContactSearch) {
            // stop if we already did this
            if (this.previousSearchType === 'contact' && !allAggsObj) {
                return;
            } else {
                this.previousSearchType = 'contact';
            }

            filterNames = [{
                filter: 'locationsFilter',
                optionsField: 'countriesAndRegions'
            }, {
                filter: 'beatsFilter',
                optionsField: 'beats'
            }, {
                filter: 'languagesFilter',
                optionsField: 'languages'
            }, {
                filter: 'newsFocusesFilter',
                optionsField: 'sourcesNewsFocuses'
            }, {
                filter: 'frequenciesFilter',
                optionsField: 'sourcesFrequencies'
            }, {
                filter: 'reachesFilter',
                optionsField: 'sourcesReachTiers'
            }, {
                filter: 'mediaChannelsFilter',
                optionsField: 'sourcesMediaChannels'
            }, {
                filter: 'rolesFilter',
                optionsField: 'roles'
            }];
            if (this.cachedAllAggs) {
                allAggs = this.cachedAllAggs.contact;
            }
        } else {
            // cache
            if (this.previousSearchType === 'source' && !allAggsObj) {
                return;
            } else {
                this.previousSearchType = 'source';
            }

            filterNames = [{
                filter: 'locationsFilter',
                optionsField: 'countriesAndRegions'
            }, {
                filter: 'beatsFilter',
                optionsField: 'beats'
            }, {
                filter: 'languagesFilter',
                optionsField: 'languages'
            }, {
                filter: 'newsFocusesFilter',
                optionsField: 'newsFocuses'
            }, {
                filter: 'frequenciesFilter',
                optionsField: 'frequencies'
            }, {
                filter: 'reachesFilter',
                optionsField: 'reachTiers'
            }, {
                filter: 'mediaChannelsFilter',
                optionsField: 'mediaChannels'
            }];
            if (this.cachedAllAggs) {
                allAggs = this.cachedAllAggs.source;
            }
        }
        if (this.cachedAllAggs) {
            filterNames.forEach(function (filterName) {
                this[filterName.filter].setAllOptions(allAggs[filterName.optionsField]);
            }.bind(this));
        }
        this.getTranslatedCountriesList();
    };

    // Update filters based on aggs of search response
    SearchControllerV2.prototype.updateFiltersBasedOnAggs = function updateFiltersBasedOnAggs(aggs) {
        var freshAggs;

        if (aggs.countriesAndRegions) {
            aggs.countriesAndRegions = aggs.countriesAndRegions.map(function (location) {
                location.name = location.key;
                return location;
            });
            this.locationsFilter.updateOptions(aggs.countriesAndRegions);
        }

        if (aggs.beats) {
            this.childBeats = getChildBeats(aggs.beats);
            this.autoSuggestBeats = aggs.beats.concat(this.childBeats);
            this.beatsFilter.updateOptions(aggs.beats);
        }
        if (aggs.languages) {
            this.languages = this.mapLanguage(aggs.languages);
            this.languagesFilter.updateOptions(this.languages);
        }

        if (aggs.sourcesNewsFocuses) {
            freshAggs = aggs.sourcesNewsFocuses;
            this.newsFocusesFilter.updateOptions(freshAggs);
        } else if (aggs.newsFocuses) {
            freshAggs = aggs.newsFocuses;
            this.newsFocusesFilter.updateOptions(aggs.newsFocuses);
        }

        if (aggs.sourcesFrequencies) {
            freshAggs = aggs.sourcesFrequencies;
            this.frequenciesFilter.updateOptions(freshAggs);
        } else if (aggs.frequencies) {
            freshAggs = aggs.frequencies;
            this.frequenciesFilter.updateOptions(freshAggs);
        }

        if (aggs.roles) {
            this.rolesFilter.updateOptions(aggs.roles);
        }

        if (aggs.reachTiers || aggs.sourcesReachTiers) {
            var reachAggs = aggs.reachTiers || aggs.sourcesReachTiers;
            this.reachTiers = this.mapReaches(reachAggs);
            this.reachesFilter.updateOptions(this.reachTiers);
        }

        if (aggs.sourcesMediaChannels) {
            freshAggs = aggs.sourcesMediaChannels;
            this.mediaChannelsFilter.updateOptions(aggs.sourcesMediaChannels);
        } else if (aggs.mediaChannels) {
            freshAggs = aggs.mediaChannels;
            this.mediaChannelsFilter.updateOptions(aggs.mediaChannels);
        }

        if (aggs.sources) {
            this.sourcesFilter.updateOptions(aggs.sources);
        }

        if (aggs.viewport) {
            this.viewport.topLeft = aggs.viewport.topLeft;
            this.viewport.bottomRight = aggs.viewport.bottomRight;
        }

        this.setPageState();
    };

    SearchControllerV2.prototype.buildSearchQuery = function buildSearchQuery(searchText, searchChips, aggregations, contactPageSize, searchType) {
        var _this9 = this;

        return this.$q(function (resolve) {
            return _this9.CoreUserService.getCurrent(true).then(function () {
                var query = {
                    pageSize: isNaN(contactPageSize) ? 25 : contactPageSize,
                    filters: _this9.buildSearchFilters(),
                    aggregations: _this9.buildSearchAggregations(aggregations),
                    orQ: [],
                    language: _this9.CoreUserService.getLanguage()
                },
                    trimmedSearchText = searchText ? searchText.trim() : '';

                // Set the search query
                if (searchType && searchType.startsWith('relevant')) {
                    query.relevantQ = trimmedSearchText;
                } else {
                    query.q = trimmedSearchText;
                }

                //making chips and searchText mutually exclusive
                if (trimmedSearchText === '' && searchChips && searchChips.length > 0) {
                    query.orQ = getSearchChipValues(searchChips);
                }

                if (!searchText && query.orQ.length === 0 && !(Array.isArray(query.filters) && query.filters.length) && !!query.listStatus) {
                    query.pageSize = 0;
                }

                if (_this9.listStatusFilter.selectedOption !== null) {
                    query.listStatus = _this9.listStatusFilter.selectedOption;
                    _this9.pageState.listStatusFilter = _this9.listStatusFilter.selectedOption;
                }
                resolve(query);
            });
        });
    };

    SearchControllerV2.prototype.buildSearchAggregations = function buildSearchAggregations(aggregations) {
        var aggs = [];

        if (aggregations) {
            aggs = aggregations;
        } else if (this.getSelectedSearchType() !== false) {
            aggs = this.defaultAggs[this.getSelectedSearchType()];
        }

        return aggs;
    };

    /*
     ----------------------------------
     -------- Map Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.mapViewSelected = function (bool) {
        this.mapView = bool;
    };

    SearchControllerV2.prototype.setDefaultMapView = function setDefaultMapView(countries, countryMapping) {
        countries = countries.map(function (text) {
            if (typeof text === 'string') {
                return text.toLowerCase();
            } else {
                return text;
            }
        });

        var bounds = this.MapService.DEFAULT_VIEWPORT_BOUNDS.bounds;
        var defaultBounds = [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]];
        if (countries.length === 1) {
            var bbox = [];

            countryMapping.forEach(function (country) {
                if (country.name && countries.indexOf(country.name.toLowerCase()) > -1) {
                    bbox.push([country.bbox[0], country.bbox[1]]);
                    bbox.push([country.bbox[2], country.bbox[3]]);
                }
            });

            this.startingBounds = bbox.length === 2 ? bbox : defaultBounds;
        } else {
            this.startingBounds = defaultBounds;
        }

        return this.startingBounds;
    };

    SearchControllerV2.prototype.clearMapsViewportBounds = function () {
        this.pageState.viewportBounds = undefined;
        this.viewport = {
            bottomRight: null,
            topLeft: null
        };
        this.MapService.clear();
    };

    SearchControllerV2.prototype.browseGeoHash = function browseGeoHash() {
        var _this10 = this;

        if (this.mapChangePromise) {
            this.$timeout.cancel(this.mapChangePromise);
        }

        return this.$q(function (resolve, reject) {
            var aggs = [],
                searchType = _this10.getSelectedSearchType(),
                searchChips = _this10.pageState.searchChips;

            _this10.mapChangePromise = _this10.$timeout(function () {
                return _this10.buildSearchQuery(null, searchChips, aggs, 0).then(function (query) {
                    query.page = 0;
                    query.pageSize = 1;
                    switch (searchType) {
                        case 'contact':
                            _this10.InfluencerContactService.aggregateContactSearch(query).then(function (res) {
                                resolve(res);
                            });
                            break;
                        case 'relevantContact':
                            _this10.InfluencerContactService.aggregateRelevantContacts(query).then(function (res) {
                                resolve(res);
                            });
                            break;
                        case 'source':
                            _this10.InfluencerContactService.aggregateSourceSearch(query).then(function (res) {
                                resolve(res);
                            });
                            break;
                        case 'relevantSource':
                            _this10.InfluencerContactService.aggregateRelevantSources(query).then(function (res) {
                                resolve(res);
                            });
                            break;
                        default:
                            reject('Invalid searchType');
                            break;
                    }
                });
            }, 600);
        });
    };

    /*
     ----------------------------------
     -------- Search Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.buildSearchFilters = function buildSearchFilters() {
        var filters = [],
            selectedLocations = this.locationsFilter.selectionFactory.getQuerySelections(),
            selectedViewportBounds = this.MapService.getViewportBounds(),
            selectedChildBeats = this.beatsFilter.selectionFactory.getSelectedChildren(),
            type;

        // get selected beats to filter
        if (selectedChildBeats.length > 0) {
            this.pageState.beatsFilter = this.beatsFilter.selectionFactory.displayState;
            var filter = {
                type: 'beats',
                values: []
            },
                sortingHat = {};

            // Get the children into the right objects
            selectedChildBeats.forEach(function (childBeat) {
                return sortingHat[childBeat.parentKey] ? sortingHat[childBeat.parentKey].push(childBeat.key) : sortingHat[childBeat.parentKey] = [childBeat.key];
            });

            Object.keys(sortingHat).forEach(function (parentKey) {
                filter.values.push({
                    parent: parentKey,
                    children: sortingHat[parentKey]
                });
            });

            filters.push(filter);
        }

        if (this.mapView && selectedViewportBounds && this.pageState.mapActive) {
            this.pageState.viewportBounds = selectedViewportBounds;
            filters.push({
                type: 'viewport',
                topLeft: selectedViewportBounds.getViewport().topLeft,
                bottomRight: selectedViewportBounds.getViewport().bottomRight
            });
        } else if (selectedLocations.length > 0) {
            this.pageState.locationsFilter = this.locationsFilter;
            filters.push({
                type: 'locations',
                values: selectedLocations.map(function (location) {
                    var locationQueryObject = {};

                    switch (location.level.toLowerCase()) {
                        case 'country':
                            locationQueryObject.country = location.key;
                            break;
                        case 'region':
                            locationQueryObject.country = location.country;
                            locationQueryObject.region = location.key;
                            break;
                        case 'city':
                            locationQueryObject.country = location.country;
                            locationQueryObject.region = location.region;
                            locationQueryObject.city = location.city || location.name;
                            break;
                        default:
                            break;
                    }

                    return locationQueryObject;
                })
            });
        }

        if (this.newsFocusesFilter.getSelectedCount() > 0) {
            this.pageState.newsFocusesFilter = this.newsFocusesFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesNewsFocuses' : 'newsFocuses';
            filters.push({
                type: type,
                values: this.newsFocusesFilter.getSelectedValues()
            });
        }

        if (this.reachesFilter.getSelectedCount() > 0) {
            type = this.pageState.isContactSearch ? 'sourcesReachTiers' : 'reachTiers';
            this.pageState.reachesFilter = this.reachesFilter.selectionFactory.displayState;

            filters.push({
                type: type,
                values: this.reachesFilter.getSelectedValues()
            });
        }

        if (this.frequenciesFilter.getSelectedCount() > 0) {
            this.pageState.frequenciesFilter = this.frequenciesFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesFrequencies' : 'frequencies';
            filters.push({
                type: type,
                values: this.frequenciesFilter.getSelectedValues()
            });
        }

        if (this.mediaChannelsFilter.getSelectedCount() > 0) {
            this.pageState.mediaChannelsFilter = this.mediaChannelsFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesMediaChannels' : 'mediaChannels';
            filters.push({
                type: type,
                values: this.mediaChannelsFilter.getSelectedValues()
            });
        }

        ['languages', 'roles'].forEach(function (filterType) {
            var filterName = filterType + 'Filter';

            if (this[filterName].getSelectedCount() > 0) {
                this.pageState[filterName] = this[filterName];
                filters.push({
                    type: filterType,
                    values: this[filterName].getSelectedValues()
                });
            }
        }, this);

        // filter by source name
        if (this.sourcesFilter.getSelectedCount() > 0) {
            this.pageState.sourcesFilter = this.sourcesFilter.selectionFactory.displayState;
            filters.push({
                type: 'sources',
                sourceIds: this.sourcesFilter.getSelectedValues()
            });
        }

        // filter by email address
        if (this.emailsFilter.getSelectedCount() > 0) {
            this.pageState.emailsFilter = this.emailsFilter.selectedEmails;
            filters.push({
                type: 'emails',
                values: this.emailsFilter.selectedEmails
            });
        }

        return filters;
    };

    SearchControllerV2.prototype.findfilterSearchRelevant = function findfilterSearchRelevant(searchTerm) {
        var _this11 = this;

        // do nothing if attempting to search on the same filter term
        if (this.pageState.findStringRelevant === searchTerm) {
            return;
        }

        if (this.findFilterPromise) {
            this.$timeout.cancel(this.findFilterPromise);
        }

        var searchPromise = void 0;
        this.pageState.findStringRelevant = searchTerm || '';
        this.setPageState();

        this.findFilterPromise = this.$timeout(function () {
            if (_this11.pageState.isContactSearch) {
                searchPromise = _this11.searchDifferent(_this11.pageState.searchText, _this11.pageState.searchChips, null, _this11.pageState.searchTypeOptions[1].type, true);
            } else {
                searchPromise = _this11.searchDifferent(_this11.pageState.searchText, _this11.pageState.searchChips, null, _this11.pageState.searchTypeOptions[3].type, true);
            }
        }, 300);
    };

    SearchControllerV2.prototype.findfilterSearchNamed = function findfilterSearch(searchTerm) {
        var _this12 = this;

        // do nothing if attempting to search on the same filter term
        if (this.pageState.findStringNamed === searchTerm) {
            return;
        }

        if (this.findFilterPromise) {
            this.$timeout.cancel(this.findFilterPromise);
        }

        this.pageState.findStringNamed = searchTerm || '';
        this.setPageState();

        this.findFilterPromise = this.$timeout(function () {
            if (_this12.pageState.isContactSearch) {
                _this12.searchDifferent(_this12.pageState.searchText, _this12.pageState.searchChips, null, _this12.pageState.searchTypeOptions[0].type, true);
            } else {
                _this12.searchDifferent(_this12.pageState.searchText, _this12.pageState.searchChips, null, _this12.pageState.searchTypeOptions[2].type, true);
            }
        }, 300);
    };

    SearchControllerV2.prototype.searchTextHasChanged = function searchTextHasChanged(searchType, searchText) {
        if (searchType === 'contact' || searchType === 'source') {
            return this.previousQuery.q !== searchText;
        } else if (searchType === 'relevantContact' || searchType === 'relevantSource') {
            return this.previousQuery.relevantQ !== searchText;
        }
        return false;
    };

    SearchControllerV2.prototype.getCountriesList = function getCountriesList() {
        var countries = [];
        if (this.cachedAllAggs && this.cachedAllAggs.contact && this.cachedAllAggs.contact.countriesAndRegions) {

            this.cachedAllAggs.contact.countriesAndRegions.forEach(function (country) {
                countries.push(country.key.toLowerCase());
            });
        }

        return countries;
    };

    SearchControllerV2.prototype.getTranslatedCountriesList = function getTranslatedCountriesList() {
        var _this13 = this;

        if (this.cachedAllAggs && this.cachedAllAggs.contact && this.cachedAllAggs.contact.countriesAndRegions) {
            this.translatedCountryList = [];
            this.cachedAllAggs.contact.countriesAndRegions.forEach(function (country) {
                _this13.translatedCountryList.push(country.display);
            });
        }
    };

    SearchControllerV2.prototype.searchForNonRelevantFilterOptions = function () {
        var _this14 = this;

        var promises = [];

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        return new Promise(function (resolve, reject) {
            _this14.$q.all(promises).then(function (res) {
                var companyId = res[1]._id;

                var blandQuery = {
                    filters: [],
                    q: '',
                    page: 0,
                    pageSize: 0,
                    language: _this14.CoreUserService.getLanguage()
                },
                    queryForAllContacts = angular.copy(blandQuery),
                    queryForAllSources = angular.copy(blandQuery),
                    promises = [];

                // Stop if we've already got a cached all aggs from the same company
                if (_this14.cachedAllAggs && _this14.cachedAllAggs.companyId && _this14.cachedAllAggs.companyId === companyId) {

                    _this14.setDefaultMapView(_this14.getCountriesList(), _this14.countryMapping);
                    resolve(_this14.cachedAllAggs);
                    return;
                }

                queryForAllContacts.aggregations = _this14.defaultAggs.contact;
                queryForAllSources.aggregations = _this14.defaultAggs.source;

                promises.push(_this14.InfluencerContactService.aggregateContactSearch(queryForAllContacts));
                promises.push(_this14.InfluencerContactService.aggregateSourceSearch(queryForAllSources));

                _this14.$q.all(promises).then(function (result) {
                    var contactsResponse = result[0],
                        sourcesResponse = result[1];

                    // setup the languages
                    if (contactsResponse.aggs && contactsResponse.aggs.languages) {
                        contactsResponse.aggs.languages = _this14.mapLanguage(contactsResponse.aggs.languages);
                    }
                    if (sourcesResponse.aggs && sourcesResponse.aggs.languages) {
                        sourcesResponse.aggs.languages = _this14.mapLanguage(sourcesResponse.aggs.languages);
                    }

                    // setup the reaches
                    if (contactsResponse.aggs && contactsResponse.aggs.sourcesReachTiers) {
                        contactsResponse.aggs.sourcesReachTiers = _this14.mapReaches(contactsResponse.aggs.sourcesReachTiers);
                    }
                    if (sourcesResponse.aggs && sourcesResponse.aggs.reachTiers) {
                        sourcesResponse.aggs.reachTiers = _this14.mapReaches(sourcesResponse.aggs.reachTiers);
                    }

                    _this14.cachedAllAggs = {
                        contact: contactsResponse.aggs,
                        source: sourcesResponse.aggs,
                        companyId: companyId,
                        userLanguage: _this14.userLanguage
                    };
                    _this14.PageStateService.setItem('allAggs', _this14.cachedAllAggs, _this14.LOCKER_NAMESPACE);
                    _this14.setDefaultMapView(_this14.getCountriesList(), _this14.countryMapping);
                    resolve(_this14.cachedAllAggs);
                }).catch(function (error) {
                    return reject(error);
                });
            });
        });
    };

    // Only load the aggs. Good for initial load and searchType change
    SearchControllerV2.prototype.loadAggsOnly = function loadAggsOnly() {
        return this.$q(function (resolve) {
            var _this15 = this;

            // we dont want the content stream to flash
            this.pageState.hideStream = true;

            this.searchForNonRelevantFilterOptions().then(function (allAggs) {
                if (!_this15.pageState.isContactSearch) {
                    _this15.updateFiltersBasedOnAggs(allAggs.source);
                    resolve(allAggs.source);
                } else {
                    _this15.updateFiltersBasedOnAggs(allAggs.contact);
                    resolve(allAggs.contact);
                }
            }).catch(function () {});
        }.bind(this));
    };

    SearchControllerV2.prototype.mapLanguage = function mapLanguage(languages) {
        return languages.map(function (language) {
            var languageObject = this.IcmLanguageService.getLanguage(language.key);
            if (languageObject) {
                language.name = languageObject.name;
            } else {
                language.name = language.key;
            }
            return language;
        }.bind(this));
    };

    SearchControllerV2.prototype.mapReaches = function mapReaches(reaches) {
        return reaches.map(function (reachTier) {
            reachTier.name = reachTier.display;
            return reachTier;
        }.bind(this));
    };

    SearchControllerV2.prototype.updatePageView = function updatePageView(searchText, searchChipsLength, filterLength, listStatusFilterActive, totalResults) {
        totalResults = totalResults > -1 ? totalResults : 0;

        if (_.findIndex(this.queryFilters, { type: 'viewport' }) > -1) {
            this.$rootScope.$broadcast('updateTotalCount', { itemCount: totalResults });
        }
    };

    SearchControllerV2.prototype.searchRelevantContactsUntilResults = function searchRelevantContactsUntilResults(query, resolve) {
        var currentIndex,
            arrayLength,
            _this = this;

        var searchStartTime = this.moment.utc();
        this.relevantSearchLoading = true;
        this.ContactStreamDataForRelevant.aggregateRelevantContacts(query).then(function (response) {
            // update filters if there are aggs
            if (response) {
                if (response.aggs) {
                    this.pageState.relevantAggs = response.aggs;
                    this.updateAllAggs();
                }

                var totalContacts = response.hits && response.hits.length ? this.ContactStreamDataForRelevant.totalContacts : 0;

                this.trackSearch('relevantContact', query, totalContacts);
                this.trackSearchSuccessCloudwatch('relevantContact', searchStartTime);
            } else {
                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
            }

            arrayLength = this.datePickerOptions.length;
            if (this.ContactStreamDataForRelevant.totalContacts > 0 || this.datePickerOptions[arrayLength - 1].value === this.pageState.dateRangeDays) {
                if (this.ContactStreamDataForRelevant.totalContacts < 1) {
                    this.ContactStreamDataForRelevant.resetSearch();
                }
                this.relevantSearchLoading = false;
                this.setPageState();
                resolve();
            } else {
                this.datePickerOptions.some(function (obj, i) {
                    return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
                }.bind(this));

                var selectDateWithIndex = !!this.datePickerOptions[currentIndex + 1] ? currentIndex + 1 : currentIndex;

                this.pageState.dateRangeDays = this.datePickerOptions[selectDateWithIndex].value;
                this.pageState.selectedDateRange = this.datePickerOptions[selectDateWithIndex].materialSyntax;

                query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                this.locationsFilter.updateQuery(this.pageState.searchText, query.filters, this.pageState.currentSearchType, query.orQ, this.pageState.dateRangeDays);
                this.searchRelevantContactsUntilResults(query, resolve);
            }
        }.bind(this)).catch(function () {
            _this.trackSearchFailedCloudwatch('relevantContact', searchStartTime);
        });
    };

    SearchControllerV2.prototype.searchRelevantSourcesUntilResults = function searchRelevantSourcesUntilResults(query, resolve) {
        var currentIndex,
            arrayLength,
            _this = this;

        var searchStartTime = this.moment.utc();
        this.relevantSearchLoading = true;
        this.SourceStreamDataForRelevant.aggregateRelevantSources(query).then(function (response) {
            // update filters if there are aggs
            if (response) {
                if (response.aggs) {
                    this.pageState.relevantAggs = response.aggs;
                    this.updateAllAggs();
                }

                var totalSources = response.hits && response.hits.length ? this.SourceStreamDataForRelevant.totalSources : 0;

                this.trackSearch('relevantSource', query, totalSources);
                this.trackSearchSuccessCloudwatch('relevantSource', searchStartTime);
            } else {
                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
            }

            arrayLength = this.datePickerOptions.length;
            if (this.SourceStreamDataForRelevant.totalSources > 0 || this.datePickerOptions[arrayLength - 1].value === this.pageState.dateRangeDays) {
                if (this.SourceStreamDataForRelevant.totalSources < 1) {
                    this.SourceStreamDataForRelevant.resetSearch();
                }
                this.relevantSearchLoading = false;
                this.setPageState();
                resolve();
            } else {
                this.datePickerOptions.some(function (obj, i) {
                    return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
                }.bind(this));
                this.pageState.dateRangeDays = this.datePickerOptions[currentIndex + 1].value;
                query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                this.locationsFilter.updateQuery(this.pageState.searchText, query.filters, this.pageState.currentSearchType, query.orQ, this.pageState.dateRangeDays);
                this.searchRelevantSourcesUntilResults(query, resolve);
            }
        }.bind(this)).catch(function () {
            _this.trackSearchFailureCloudwatch('relevantSource', searchStartTime);
        });
    };

    SearchControllerV2.prototype.scrollToTop = function scrollToTop() {
        var scrollContainerElement = angular.element('md-content.mw-flex-padding'),
            y = scrollContainerElement.scrollTop();
        if (y > 308) {
            this.$timeout(function () {
                if (scrollContainerElement.length) {
                    scrollContainerElement.animate({ scrollTop: 308 }, { duration: 600 });
                }
            }, 0);
        }
    };

    SearchControllerV2.prototype.searchNamed = function () {
        if (this.pageState.isRelevantSelected === true) {
            this.scrollToTop();
        }

        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';

        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;

        this.updateChipSummary(this.pageState.searchChips);
        if (this.pageState.isContactSearch) {
            this.setSearchType(this.pageState.searchTypeOptions[0]);
        } else if (!this.pageState.isContactSearch) {
            this.setSearchType(this.pageState.searchTypeOptions[2]);
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchWritingAbout = function () {
        if (this.pageState.isRelevantSelected === false) {
            this.scrollToTop();
        }

        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;

        this.updateChipSummary(this.pageState.searchChips);
        if (this.pageState.isContactSearch) {
            this.setSearchType(this.pageState.searchTypeOptions[1]);
        } else if (!this.pageState.isContactSearch) {
            this.setSearchType(this.pageState.searchTypeOptions[3]);
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchForBoth = function () {
        var _this16 = this;

        var keepMiniOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!keepMiniOpen) {
            this.MiniProfileService.closeMiniProfile();
            this.pageState.pageRefresh = false;
            this.pageState.miniProfileContactId = '';
        }
        this.setPageState();

        var promiseArray = [];
        return this.$q(function (resolve) {
            if (_this16.pageState.isContactSearch) {
                promiseArray.push(_this16.searchDifferent(_this16.pageState.searchText, _this16.pageState.searchChips, null, _this16.pageState.searchTypeOptions[0].type));
                promiseArray.push(_this16.searchDifferent(_this16.pageState.searchText, _this16.pageState.searchChips, null, _this16.pageState.searchTypeOptions[1].type));
            } else {
                promiseArray.push(_this16.searchDifferent(_this16.pageState.searchText, _this16.pageState.searchChips, null, _this16.pageState.searchTypeOptions[2].type));
                promiseArray.push(_this16.searchDifferent(_this16.pageState.searchText, _this16.pageState.searchChips, null, _this16.pageState.searchTypeOptions[3].type));
            }

            _this16.$q.all(promiseArray).then(function () {
                // check to make sure we didn't overlap relevant searches with no search text searches resulting in the writing about tab having results when it shouldn't
                if (!_this16.relevantQuery.relevantQ.length && !_this16.relevantQuery.orQ.length) {
                    if (_this16.pageState.isContactSearch) {
                        _this16.ContactStreamDataForRelevant.resetSearch();
                    } else {
                        _this16.SourceStreamDataForRelevant.resetSearch();
                    }
                }
                _this16.totalContacts = (_this16.ContactStreamDataForNames.totalContacts > -1 ? _this16.ContactStreamDataForNames.totalContacts : 0) + (_this16.ContactStreamDataForRelevant.totalContacts > -1 ? _this16.ContactStreamDataForRelevant.totalContacts : 0);
                var totalSources = (_this16.SourceStreamDataForNames.totalSources > -1 ? _this16.SourceStreamDataForNames.totalSources : 0) + (_this16.SourceStreamDataForRelevant.totalSources > -1 ? _this16.SourceStreamDataForRelevant.totalSources : 0);

                if (_this16.pageState.isContactSearch && !_this16.pageState.hideStream) {
                    _this16.updatePageView(_this16.pageState.searchText, _this16.pageState.searchChips.length, [], false, _this16.totalContacts);
                } else {
                    _this16.updatePageView(_this16.pageState.searchText, _this16.pageState.searchChips.length, [], false, totalSources);
                }

                resolve();
            });
        });
    };

    SearchControllerV2.prototype.updateAllAggs = function () {
        var allAggs = this.combineAggregations(this.pageState.namedAggs, this.pageState.relevantAggs);
        this.updateFiltersBasedOnAggs(allAggs);
    };

    // loading logic for synced streams and independent searches
    SearchControllerV2.prototype.loadingContentStreams = function () {
        if (this.pageState.isContactSearch) {
            if (!this.pageState.isRelevantSelected) {
                if (this.ContactStreamDataForNames.isSearching && this.independentSearch) {
                    return true;
                } else {
                    return !this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching);
                }
            } else if (this.pageState.isRelevantSelected) {
                if (this.ContactStreamDataForRelevant.isSearching && this.independentSearch) {
                    return true;
                } else {
                    return !this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching);
                }
            }
        } else if (!this.pageState.isContactSearch) {
            if (!this.pageState.isRelevantSelected) {
                if (this.SourceStreamDataForNames.isSearching && this.independentSearch) {
                    return true;
                } else {
                    return !this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching);
                }
            } else if (this.pageState.isRelevantSelected) {
                if (this.SourceStreamDataForRelevant.isSearching && this.independentSearch) {
                    return true;
                } else {
                    return !this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching);
                }
            }
        }
        return false;
    };

    SearchControllerV2.prototype.showContentStreamHeader = function () {
        if (this.pageState.isContactSearch) {
            if (!this.pageState.isRelevantSelected && this.ContactStreamDataForNames.isSearching && this.independentSearch || this.pageState.isRelevantSelected && this.ContactStreamDataForRelevant.isSearching && this.independentSearch) {
                return true;
            } else if (!this.independentSearch && (this.ContactStreamDataForNames.isSearching || this.ContactStreamDataForRelevant.isSearching)) {
                return false;
            }
        } else if (!this.pageState.isContactSearch) {
            if (!this.pageState.isRelevantSelected && this.SourceStreamDataForNames.isSearching && this.independentSearch || this.pageState.isRelevantSelected && this.SourceStreamDataForRelevant.isSearching && this.independentSearch) {
                return true;
            } else if (!this.independentSearch && (this.SourceStreamDataForNames.isSearching || this.SourceStreamDataForRelevant.isSearching)) {
                return false;
            }
        }
        return true;
    };

    SearchControllerV2.prototype.showNamedTabCount = function () {
        if (this.pageState.isContactSearch) {
            if (this.ContactStreamDataForNames.isSearching && this.independentSearch) {
                return true;
            } else {
                return !this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching);
            }
        } else if (!this.pageState.isContactSearch) {
            if (this.SourceStreamDataForNames.isSearching && this.independentSearch) {
                return true;
            } else {
                return !this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching);
            }
        }
    };

    SearchControllerV2.prototype.showRelevantTabCount = function () {
        if (this.pageState.isContactSearch) {
            if (this.ContactStreamDataForRelevant.isSearching && this.independentSearch) {
                return true;
            } else {
                return !this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching);
            }
        } else if (!this.pageState.isContactSearch) {
            if (this.SourceStreamDataForRelevant.isSearching && this.independentSearch) {
                return true;
            } else {
                return !this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching);
            }
        }
    };

    SearchControllerV2.prototype.showContactStream = function () {
        var show = false;
        if (!this.pageState.hideStream && this.pageState.isContactSearch) {
            show = this.pageState.isRelevantSelected ? this.ContactStreamDataForRelevant.totalContacts > 0 || this.loadingContentStreams() : this.ContactStreamDataForNames.totalContacts > 0 || this.loadingContentStreams();
        }
        return show;
    };

    SearchControllerV2.prototype.showSourceStream = function () {
        var show = false;
        if (!this.pageState.hideStream && !this.pageState.isContactSearch) {

            show = this.pageState.isRelevantSelected ? this.SourceStreamDataForRelevant.totalSources > 0 || this.loadingContentStreams() : this.SourceStreamDataForNames.totalSources > 0 || this.loadingContentStreams();
        }
        return show;
    };

    SearchControllerV2.prototype.searchDifferent = function search(searchText, searchChips, aggregations, searchType, independent) {
        var _this17 = this;

        var _this = this;
        this.pageState.forceShowFilters = true;
        this.allFiltersWaitOnSearch();
        if (!searchChips) {
            searchChips = [];
        }
        this.independentSearch = independent || false;
        this.clearDetectedBeats();
        return this.$q(function (resolve) {
            _this17.buildSearchQuery(searchText, searchChips, aggregations, undefined, searchType).then(function (query) {
                _this17.resetSelections();
                _this17.locationsFilter.updateQuery(searchText, query.filters, searchType, getSearchChipValues(searchChips), _this17.pageState.dateRangeDays);

                // Add the find filter content from the prediction panel and modify the query accordingly
                query = _this17.buildFindFilterQuery(searchType, query);
                _this17.queryFilters = query.filters;
                _this17.pageState.hideStream = !searchText && !query.filters.length && !query.listStatus && searchChips && searchChips.length === 0;
                _this17.pageState.emptyState = _this17.pageState.hideStream;

                if (searchType === 'source') {
                    _this17.nameSearchLoading = true;
                    _this17.pageState.sourceSearchTerms = query.q;

                    var searchStartTime = _this17.moment.utc();
                    _this17.SourceStreamDataForNames.aggregateSearch(query).then(function (response) {
                        if (response) {
                            // check named searches to make sure the count and hits are in sync when the search returns nothing
                            if (this.SourceStreamDataForNames.totalSources === 0) {
                                this.SourceStreamDataForNames.resetSearch();
                            }
                            resolve(response);
                            if (response.aggs) {
                                this.pageState.namedAggs = response.aggs;
                                this.updateAllAggs();
                            }
                            this.trackSearch(searchType, query, this.SourceStreamDataForNames.totalSources);
                            this.trackSearchSuccessCloudwatch(searchType, searchStartTime);
                        } else {
                            this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                            resolve();
                        }
                        this.nameSearchLoading = false;
                        this.setPageState();
                        resolve();
                    }.bind(_this17)).catch(function () {
                        _this.trackSearchFailureCloudwatch(searchType, searchStartTime);
                    });
                } else if (searchType === 'contact') {
                    _this17.nameSearchLoading = true;
                    _this17.pageState.searchText = query.q;

                    var _searchStartTime = _this17.moment.utc();
                    _this17.ContactStreamDataForNames.aggregateSearch(query).then(function (response) {
                        if (response) {
                            // check named searches to make sure the count and hits are in sync when the search returns nothing
                            if (this.ContactStreamDataForNames.totalContacts === 0) {
                                this.ContactStreamDataForNames.resetSearch();
                            }
                            resolve(response);
                            if (response.aggs) {
                                this.pageState.namedAggs = response.aggs;
                                this.updateAllAggs();
                            }
                            this.trackSearch(searchType, query, this.ContactStreamDataForNames.totalContacts);
                            this.trackSearchSuccessCloudwatch(searchType, _searchStartTime);
                        } else {
                            this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                            resolve();
                        }
                        this.nameSearchLoading = false;
                        this.setPageState();
                        resolve();
                    }.bind(_this17)).catch(function () {
                        _this.trackSearchFailureCloudwatch(searchType, _searchStartTime);
                    });
                } else if (searchType === 'relevantContact') {
                    _this17.pageState.searchText = query.relevantQ;
                    query.docQuery = {};
                    query.docQuery.dateStart = _this17.moment().tz(_this17.ICMUserService.getTimezone()).subtract(_this17.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                    query.docQuery.dateEnd = _this17.moment().tz(_this17.ICMUserService.getTimezone()).endOf('day').toISOString();
                    _this17.relevantQuery = query;
                    if ((query.relevantQ.length || query.orQ.length) && !(query.relevantQ.length === 1 && query.relevantQ[0].length < 3 || query.orQ.length === 1 && query.orQ[0].length < 3)) {
                        _this17.searchRelevantContactsUntilResults(query, resolve);
                    } else {
                        _this17.ContactStreamDataForRelevant.resetSearch();
                        _this17.pageState.noResults = false;
                        if (!searchText && !query.filters.length && !query.listStatus && searchChips && searchChips.length === 0) {
                            _this17.pageState.emptyState = true;
                        }
                        _this17.setPageState();
                        resolve();
                    }
                } else if (searchType === 'relevantSource') {
                    _this17.pageState.sourceSearchTerms = query.relevantQ;
                    query.docQuery = {};
                    query.docQuery.dateStart = _this17.moment().tz(_this17.ICMUserService.getTimezone()).subtract(_this17.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                    query.docQuery.dateEnd = _this17.moment().tz(_this17.ICMUserService.getTimezone()).endOf('day').toISOString();
                    _this17.relevantQuery = query;
                    if ((query.relevantQ.length || query.orQ.length) && !(query.relevantQ.length === 1 && query.relevantQ[0].length < 3 || query.orQ.length === 1 && query.orQ[0].length < 3)) {
                        _this17.searchRelevantSourcesUntilResults(query, resolve);
                    } else {
                        _this17.SourceStreamDataForRelevant.resetSearch();
                        _this17.pageState.noResults = false;
                        if (!searchText && !query.filters.length && !query.listStatus && searchChips && searchChips.length === 0) {
                            _this17.pageState.emptyState = true;
                        }
                        _this17.setPageState();
                        resolve();
                    }
                }
                _this17.pageState.previousQuery = _this17.previousQuery = query;
                _this17.pageState.searchText = searchText;
            });
        });
    };

    /*
     ----------------------------------
     -------- Page Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.setPageState = function setPageState() {
        try {
            this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
        } catch (e) {
            //Clean the namespace up when we're full and try again.
            this.PageStateService.cleanLockerNamespace(this.LOCKER_NAMESPACE);
            this.PageStateService.setItem('allAggs', this.cachedAllAggs, this.LOCKER_NAMESPACE);
            this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
        }
    };

    SearchControllerV2.prototype.nextPageContacts = function nextPageContacts(contentStream) {
        contentStream.nextPage().then(function () {
            if (this.ContactSelectorForNames.allSelected && contentStream.contactArray.length > 25) {
                this.ContactSelectorForNames.selectAllForNextPage(contentStream.contactArray);
            }

            if (this.ContactSelectorForRelevant.allSelected && contentStream.contactArray.length > 25) {
                this.ContactSelectorForRelevant.selectAllForNextPage(contentStream.contactArray);
            }
        }.bind(this)).catch(function () {});
    };

    SearchControllerV2.prototype.nextPageSources = function nextPageSources(stream) {
        stream.nextPage();
    };

    /*
     ---------------------------------------------
     -------- Search Type Card Functions ---------
     ---------------------------------------------
     */
    SearchControllerV2.prototype.setSearchType = function setSearchType(newlySelected) {
        // find the already selected one and set it to be unselected
        if (!newlySelected) {
            newlySelected = this.pageState.searchTypeOptions[0];
        } else if (this.pageState.searchTypeOptions[indexOf('selected', true, this.pageState.searchTypeOptions)]) {
            var previouslySelected = this.pageState.searchTypeOptions[indexOf('selected', true, this.pageState.searchTypeOptions)];

            // set it to unselected
            previouslySelected.selected = false;
        }

        // set the newly selected search type
        newlySelected.selected = true;

        if (newlySelected.type.toLowerCase().indexOf('contact') >= 0) {
            this.pageState.isContactSearch = true;
        } else {
            this.pageState.isContactSearch = false;
        }

        // Kick this off for each search type change,
        this.insertNonRelevantFilterOptions();

        this.updateChipSummary(this.pageState.searchChips);
    };

    SearchControllerV2.prototype.selectInfluencers = function selectInfluencers() {
        this.setSearchType(this.pageState.searchTypeOptions[0]);
        this.showSearchDropDown = false;

        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectRelevantInfluencers = function selectRelevantInfluencers() {
        this.setSearchType(this.pageState.searchTypeOptions[1]);
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectSources = function selectSources() {
        this.setSearchType(this.pageState.searchTypeOptions[2]);
        this.showSearchDropDown = false;

        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectRelevantSources = function selectRelevantSources() {
        this.setSearchType(this.pageState.searchTypeOptions[3]);
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;
    };

    SearchControllerV2.prototype.getSelectedSearchType = function getSelectedSearchType() {
        if (this.pageState.isRelevantSelected) {
            if (this.pageState.isContactSearch) {
                return this.pageState.searchTypeOptions[1].type;
            } else {
                return this.pageState.searchTypeOptions[3].type;
            }
        } else {
            if (this.pageState.isContactSearch) {
                return this.pageState.searchTypeOptions[0].type;
            } else {
                return this.pageState.searchTypeOptions[2].type;
            }
        }
    };

    SearchControllerV2.prototype.showSwitchSearchTypeModal = function showSwitchSearchTypeModal(event) {
        var titleText = this.$translate.instant('icm-search__switch-to-source-search--confirm-box-title'),
            bodyText = this.$translate.instant('icm-search__switch-to-source-search--confirm-box-body');
        if (!this.pageState.isContactSearch) {
            titleText = this.$translate.instant('icm-search__switch-to-contact-search--confirm-box-title');
            bodyText = this.$translate.instant('icm-search__switch-to-contact-search--confirm-box-body');
        }

        this.$mdDialog.show(this.$mdDialog.mwMiniModal().class('switch-search-type-modal').title(titleText).textContent(bodyText).ok(this.$translate.instant('OK')).cancel(this.$translate.instant('action-label__cancel')).targetEvent(event)).then(function okHandler() {
            if (!this.pageState.isContactSearch) {
                this.selectInfluencers();
            } else {
                this.selectSources();
            }
            this.clearAll();
        }.bind(this), function cancelHandler() {}).finally(function () {
            var settings = {};
            if (this.contactSettings) {
                settings = this.contactSettings;
            }
            settings.showSearchSwitchModal = false;
            this.ICMUserService.setAppSettings('contacts', settings);
        }.bind(this));
    };

    SearchControllerV2.prototype.switchSearchTypeShortCut = function switchSearchTypeShortCut(event) {
        var showSearchModal = true;
        this.activeSearchTab = this.NAME_SEARCH_TAB;

        if (this.contactSettings && this.contactSettings.showSearchSwitchModal === false) {
            showSearchModal = false;
        }

        if (showSearchModal) {
            this.showSwitchSearchTypeModal(event);
        } else {
            if (this.pageState.isContactSearch) {
                this.selectSources();
            } else {
                this.selectInfluencers();
            }
            this.clearAll();
        }
    };

    SearchControllerV2.prototype.switchSearchTypeDropDown = function switchSearchTypeDropDown(event) {
        var showSearchModal = true;

        if (this.contactSettings && this.contactSettings.showSearchSwitchModal === false) {
            showSearchModal = false;
        }

        if (showSearchModal) {
            this.showSwitchSearchTypeModal(event);
        } else {
            // setup to detect drop down goes blur
            angular.element(document).click(function ($event) {
                if (this.showSearchDropDown) {
                    this.showSearchDropDown = false;
                }
                this.$timeout(function () {
                    angular.element(document).off('click');
                }, 100);
                $event.stopPropagation();
            }.bind(this));

            // toggle drop down
            this.showSearchDropDown = !this.showSearchDropDown;
            event.stopPropagation();
        }
    };

    SearchControllerV2.prototype.openSampleMiniModal = function openSampleMiniModal(event) {
        var titleText = this.$translate.instant('icm-search__sample-miniModal--title'),
            bodyText = this.$translate.instant('icm-search__sample-miniModal--contact-search-msg');
        if (!this.pageState.isContactSearch) {
            bodyText = this.$translate.instant('icm-search__sample-miniModal--source-search-msg');
        }

        this.$mdDialog.show(this.$mdDialog.mwMiniModal({
            locals: {
                title: titleText,
                body: bodyText
            },
            templateUrl: 'icm-web/views/search_sample_mini_modal',
            controllerAs: '$ctrl'
        }).targetEvent(event)).then(function okHandler() {
            if (!this.pageState.isContactSearch) {
                this.initializeSourceSampleSearch();
            } else {
                this.initializeContactSampleSearch();
            }
        }.bind(this), function cancelHandler() {
            //'You selected cancel'
        }).catch(function () {});
    };

    SearchControllerV2.prototype.openHelpCenter = function openHelpCenter() {
        this.$window.open('https://help.meltwater.com/');
    };

    SearchControllerV2.prototype.gotoMediaResearchHelp = function gotoMediaResearchHelp() {
        this.$window.open('https://help.meltwater.com/en/articles/4064620-how-to-do-media-research-in-meltwater-to-discover-relevant-influencers-and-publications');
    };

    SearchControllerV2.prototype.getAllSelectedFilterOptionsForTracking = function getAllSelectedFilterOptionsForTracking(searchType) {
        var filterNames,
            filterSelection,
            realNames = [],
            selectedOptions = [];

        if (!searchType) {
            return [];
        }

        if (this.pageState.isContactSearch) {
            filterNames = ['locationsFilter', 'sourcesFilter', 'beatsFilter', 'languagesFilter', 'newsFocusesFilter', 'frequenciesFilter', 'reachesFilter', 'mediaChannelsFilter', 'rolesFilter', 'emailsFilter', 'listStatusFilter'];
        } else {
            filterNames = ['locationsFilter', 'beatsFilter', 'languagesFilter', 'newsFocusesFilter', 'frequenciesFilter', 'reachesFilter', 'mediaChannelsFilter'];
        }

        filterNames.forEach(function (filterName) {
            if (this[filterName].getSelectedCount() > 0) {
                filterSelection = this[filterName].selectionFactory.getSelection();
                for (var selection in filterSelection) {
                    if (filterSelection.hasOwnProperty(selection)) {
                        if (filterSelection[selection].name) {
                            realNames.push(filterSelection[selection].name);
                        } else {
                            realNames.push(filterSelection[selection].display);
                        }
                    }
                }
                selectedOptions.push(filterName.replace('Filter', '') + ':' + realNames.join(','));
                realNames = [];
            }
        }.bind(this));

        if (this.mapView && this.MapService.getViewportBounds() && this.pageState.mapActive) {
            selectedOptions.push('mapZoom:' + this.MapService.map.getZoom());
        }

        return selectedOptions.join('|');
    };

    /*
     ----------------------------------
     -------- Relevant Articles ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.showRelevantArticles = function showRelevantArticles(type, itemObject, event) {
        var relevantArticlesSettings = {},
            userSearchSettings = this.contentStreamSettings,
            defaultSettings = {
            avatar: true,
            displayTags: true,
            groupOption: 'none',
            hitSentence: true,
            images: true,
            keywords: true,
            openingText: true
        },
            query = {
            'name': null,
            'allKeywords': this.pageState.searchText.length > 0 ? [this.pageState.searchText] : getSearchChipValues(this.pageState.searchChips),
            'anyKeywords': [],
            'notKeywords': [],
            'booleanQuery': null,
            'informationTypes': ['news', 'tender'],
            'dateStart': this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
            'dateEnd': this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString(),
            'searchQueryType': 'keyword',
            'page': 1,
            'pageSize': 25,
            'groupOption': 'none',
            'caseSensitive': 'no',
            'sortField': 'date',
            'sortOrder': 'DESC',
            'useDateQueryStart': true,
            'showHiddenDocuments': false,
            'listStart': 0,
            'listSize': 0,
            'usePageAsOffset': false,
            'groupFrom': 0,
            'dateQueryStart': this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString(),
            'searchQueryId': null,
            'childIds': itemObject.childIds || []
        };

        // setting default values if not exists
        angular.extend(relevantArticlesSettings, defaultSettings, userSearchSettings);

        this.RelevantArticlesDialogService.showDialog(query, itemObject, '', relevantArticlesSettings, type, event);
    };

    /*
        ----------------------------------
        ------ Media List Functions ------
        ----------------------------------
    */
    SearchControllerV2.prototype.tagSelectedContacts = function tagSelectedContacts(contactSelector, contactStream) {
        var _this18 = this;

        var queryType = null,
            searchType = this.getSelectedSearchType();

        // need to build a search query w/the find filter
        if (contactSelector.trueAllSelected) {
            queryType = searchType === 'relevantContact' && this.pageState.chipsHaveSearchTerms ? 'searchRelevantContact' : 'searchContact';

            return this.buildSearchQuery(this.pageState.searchText, this.pageState.searchChips, [], contactStream.totalContacts).then(function (query) {
                query = _this18.buildFindFilterQuery(searchType, query);

                if (queryType === 'searchRelevantContact') {
                    query.docQuery = {
                        dateStart: _this18.moment().tz(_this18.ICMUserService.getTimezone()).subtract(_this18.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                        dateEnd: _this18.moment().tz(_this18.ICMUserService.getTimezone()).endOf('day').toISOString()
                    };
                }
                return query;
            }).then(function (query) {
                _this18.openTagDialog(query, queryType, contactSelector, searchType, contactStream);
            });
        } else {
            this.openTagDialog(null, null, contactSelector, searchType, contactStream);
        }
    };

    function refreshContactStream() {
        window.removeEventListener('icm-list-dialog-on-close', removeDialogEventListeners, { once: true });

        var _this = angular.element(document.getElementsByClassName('searchPage')).scope().searchController;
        _this.resetSelections();
        _this.$scope.$apply();
    }

    function removeDialogEventListeners() {
        window.removeEventListener('icm-lists-updated', refreshContactStream, { once: true });
    }

    SearchControllerV2.prototype.openTagDialog = function openTagDialog() {
        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var queryType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var contactSelector = arguments[2];
        var searchType = arguments[3];
        var contactStream = arguments[4];

        window.addEventListener('icm-lists-updated', refreshContactStream, { once: true });
        window.addEventListener('icm-list-dialog-on-close', removeDialogEventListeners, { once: true });

        var selectedContactIds = Object.keys(contactSelector.selectedItems);
        var manageListDialog = document.querySelector('icm-manage-lists-dialog');

        if (contactSelector.trueAllSelected && contactStream.totalContacts > this.MAX_MEDIALIST_LIMIT || contactSelector.selectedItems > this.MAX_MEDIALIST_LIMIT) {
            var manageListLimitWarning = document.querySelector('manage-list-limit-warning');
            manageListLimitWarning.open();
        } else if (contactSelector.trueAllSelected) {
            query.page = 0;
            query.pageSize = this.MAX_MEDIALIST_LIMIT;
            query.onlyIds = true;
            var request = {
                method: 'POST',
                url: '',
                data: query
            };
            if (searchType.includes('relevant')) {
                request.url = this.ICM_CSS_URL + '/search/relevantContacts';
            } else {
                request.url = this.ICM_CSS_URL + '/search/contacts';
            }
            manageListDialog.openLoading();

            this.$http(request).then(function (response) {
                manageListDialog.open(response.data);
            }).catch(function (err) {
                manageListDialog.showLoadingErrorState();
                this.reject(err.data);
            });
        } else {
            manageListDialog.open(selectedContactIds);
        }
    };

    SearchControllerV2.prototype.resetChipSummary = function resetChipSummary() {
        this.pageState.relevantChipSummary = '';
        this.pageState.namedChipSummary = '';
        this.pageState.chipsHaveSearchTerms = false;
    };

    SearchControllerV2.prototype.updateChipSummary = function updateChipSummary(searchChips) {
        var relevantJoinText = '',
            nameJoinText = '';

        this.pageState.chipsHaveSearchTerms = getSearchChipValues(searchChips).length > 0 ? true : false;

        if (searchChips.length > 0) {
            relevantJoinText = this.$translate.instant('icm-search__search-summary--and-query-separator');
            nameJoinText = this.$translate.instant('icm-search__search-summary--or-query-separator');

            this.pageState.relevantChipSummary = searchChips.filter(function (searchChip) {
                return searchChip.type === 'standard';
            }).map(function (standardSearchChip) {
                return ' "' + standardSearchChip.display + '" ';
            }).join(relevantJoinText).trim();

            this.pageState.namedChipSummary = searchChips.filter(function (searchChip) {
                return searchChip.type === 'standard';
            }).map(function (standardSearchChip) {
                return ' "' + standardSearchChip.display + '" ';
            }).join(nameJoinText).trim();
        } else {
            this.resetChipSummary();
        }
    };

    SearchControllerV2.prototype.translateNamedSearchSummary = function translateSearchSummary() {
        if (this.pageState.isContactSearch) {
            return this.$translate.instant('icm-search__duel-streams--named-label', { count: this.ContactStreamDataForNames.totalContacts > 0 && !this.showNamedTabCount() ? this.ContactStreamDataForNames.totalContacts : 0 });
        } else {
            return this.$translate.instant('icm-search__duel-streams--named-label', { count: this.SourceStreamDataForNames.totalSources > 0 && !this.showNamedTabCount() ? this.SourceStreamDataForNames.totalSources : 0 });
        }
    };

    SearchControllerV2.prototype.translateRelevantSearchSummary = function translateSearchSummary() {
        if (this.pageState.isContactSearch) {
            return this.$translate.instant('icm-search__duel-streams--writing-label', { count: this.ContactStreamDataForRelevant.totalContacts > 0 && !this.showRelevantTabCount() ? this.ContactStreamDataForRelevant.totalContacts : 0 });
        } else {
            return this.$translate.instant('icm-search__duel-streams--writing-label', { count: this.SourceStreamDataForRelevant.totalSources > 0 && !this.showRelevantTabCount() ? this.SourceStreamDataForRelevant.totalSources : 0 });
        }
    };

    SearchControllerV2.prototype.searchOnChipChange = function searchOnChipChange(searchChips) {
        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';
        this.setPageState();

        return this.$q(function (resolve) {
            var _this19 = this;

            if (searchChips.length > 0 || this.buildSearchFilters().length > 0 || this.listStatusFilter.getSelectedOption() !== null) {
                if (this.currentSearchPromise) {
                    this.$timeout.cancel(this.currentSearchPromise);
                }

                this.currentSearchPromise = this.$timeout(function () {
                    _this19.searchForBoth().then(function () {
                        resolve();
                    }).catch(function () {});
                }, 300);
            } else {
                this.loadAggsOnly();
                resolve();
            }
        }.bind(this));
    };

    SearchControllerV2.prototype.searchChipAdded = function searchChipAdded(executeSearch) {
        this.updateChipSummary(this.pageState.searchChips);

        if (executeSearch) {
            this.searchOnChipChange(this.pageState.searchChips).then(function () {
                this.detectBeats(this.pageState.searchChips);
            }.bind(this)).catch(function () {});
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchChipRemoved = function searchChipRemoved(removedChip) {
        this.updateChipSummary(this.pageState.searchChips);

        this.searchOnChipChange(this.pageState.searchChips);

        if (removedChip.beat) {
            this.beatsFilter.selectionFactory.deselect(removedChip.beat, true);
        }
    };

    /*
       ----------------------------------
       ------ Did You Mean Functions ------
       ----------------------------------
     */
    SearchControllerV2.prototype.detectBeats = function detectBeats(chipObjects) {
        var _this = this;

        _this.detectedBeats = [];

        function matchBeat(term, beats) {
            beats.some(function (beat) {
                if (beat.display.toLowerCase() === term.toLowerCase()) {
                    _this.detectedBeats.push(beat);
                    return true;
                } else {
                    if (Array.isArray(beat.children) && beat.children.length) {
                        return matchBeat(term, beat.children);
                    } else {
                        return false;
                    }
                }
            });
        }

        if (chipObjects.length) {
            chipObjects.forEach(function (chipObject) {
                if (chipObject.type === 'standard') {
                    matchBeat(chipObject.value, _this.beatsFilter.currentOptions);
                }
            });
        }
    };

    SearchControllerV2.prototype.convertToBeat = function convertToBeat(beat) {
        var standardChipMatchingBeat = -1,
            beatChipAlreadyExists = false;

        this.pageState.searchText = this.pageState.searchText.replace(new RegExp(beat.display, 'gi'), '');
        this.pageState.searchChips.some(function (chipObject, index) {
            if (!chipObject.beat && chipObject.value.toLowerCase() === beat.display.toLowerCase()) {
                standardChipMatchingBeat = index;
                return true;
            } else {
                return false;
            }
        });

        if (standardChipMatchingBeat >= 0) {
            beatChipAlreadyExists = this.pageState.searchChips.some(function (searchChipObject) {
                return searchChipObject.beat && searchChipObject.beat.display.toLowerCase() === beat.display.toLowerCase();
            });

            if (beatChipAlreadyExists) {
                this.pageState.searchChips.splice(standardChipMatchingBeat, 1);

                this.$mdToast.show(this.$mdToast.mwSimpleTimed().textContent('The beat ' + beat.display + ' was already selected as a filter'));
            } else {
                this.pageState.searchChips[standardChipMatchingBeat].type = 'beat';
                this.pageState.searchChips[standardChipMatchingBeat].beat = beat;
                this.pageState.searchChips[standardChipMatchingBeat].display = 'Beat: ' + this.pageState.searchChips[standardChipMatchingBeat].display;

                this.$mdToast.show(this.$mdToast.mwSimpleTimed().textContent('The beat ' + beat.display + ' was added to your filters'));

                this.beatsFilter.selectionFactory.select(beat, true);

                this.updateChipSummary(this.pageState.searchChips);
                this.refreshSearch();
            }
        }

        this.focusOnInput();
    };

    SearchControllerV2.prototype.focusOnInput = function focusOnInput() {
        $('md-chips input')[0].focus();
    };

    SearchControllerV2.prototype.clearDetectedBeats = function clearDetectedBeats() {
        this.detectedBeats = [];
    };

    SearchControllerV2.prototype.clearChips = function clearChips() {
        this.pageState.searchText = '';
        this.pageState.searchChips = [];

        this.updateChipSummary(this.pageState.searchChips);
        this.searchOnChipChange(this.pageState.searchChips);
    };

    SearchControllerV2.prototype._trackSearchCloudwatch = function _trackSearchCloudwatch(searchType, searchStartTime, success) {
        var searchTiming = this.moment.utc().diff(searchStartTime, 'milliseconds');

        var metricTimingName = success ? 'SearchSuccessTiming' : 'SearchFailureTiming';
        var metricCountName = success ? 'SearchSuccessCount' : 'SearchFailureCount';

        var listStatusRange = 'NA';
        if (this.listStatusFilter.selectedOption !== null) {
            listStatusRange = 'unknown';

            if (this.allContactsCount > 2500) {
                listStatusRange = '2501+';
            } else if (this.allContactsCount > 2000) {
                listStatusRange = '2001-2500';
            } else if (this.allContactsCount > 1500) {
                listStatusRange = '1501-2000';
            } else if (this.allContactsCount > 1000) {
                listStatusRange = '1001-1500';
            } else if (this.allContactsCount > 500) {
                listStatusRange = '501-1000';
            } else if (this.allContactsCount >= 0) {
                listStatusRange = '0-500';
            }
        }

        var searchTypeDimension = {
            Name: 'SearchType',
            Value: searchType
        };
        var listStatusDimensions = [searchTypeDimension, {
            Name: 'ListStatusRange',
            Value: listStatusRange
        }];

        var cloudWatchParameters = {
            Namespace: 'icm-web',
            MetricData: [
            // metric to track search timing, excluding list status dimension
            {
                MetricName: metricTimingName,
                Value: searchTiming,
                Unit: 'Milliseconds',
                Dimensions: [searchTypeDimension]
            },
            // metric to track search count, excluding list status dimension
            {
                MetricName: metricCountName,
                Value: 1,
                Unit: 'Count',
                Dimensions: [searchTypeDimension]
            },
            // metric to track search timing, including list status dimension
            {
                MetricName: metricTimingName,
                Value: searchTiming,
                Unit: 'Milliseconds',
                Dimensions: listStatusDimensions
            },
            // metric to track search count, including list status dimension
            {
                MetricName: metricCountName,
                Value: 1,
                Unit: 'Count',
                Dimensions: listStatusDimensions
            }]
        };

        this.CloudwatchService.cloudwatch.putMetricData(cloudWatchParameters, function (error) {
            if (error) {
                console.error('putMetricData error', error); // jshint ignore:line
            }
        });
    };

    SearchControllerV2.prototype.trackSearchSuccessCloudwatch = function trackSearchSuccessCloudwatch(searchType, searchStartTime) {
        this._trackSearchCloudwatch(searchType, searchStartTime, true);
    };

    SearchControllerV2.prototype.trackSearchFailureCloudwatch = function trackSearchFailureCloudwatch(searchType, searchStartTime) {
        this._trackSearchCloudwatch(searchType, searchStartTime, false);
    };

    SearchControllerV2.prototype.trackSearch = function trackSearch(searchType, query, numberOfResults) {
        // jshint ignore:line
        var promises = [],
            currentUser,
            currentCompany,
            trackingData = {
            source: 'webapp',
            label: 'icm_search',
            /* jshint ignore:start */
            icm_search_type: searchType,
            icm_search_terms: query.orQ.join('|'),
            icm_search_filter: this.getAllSelectedFilterOptionsForTracking(searchType),
            results_nbr: numberOfResults
            /* jshint ignore: end */
        };

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            if (query.docQuery && query.docQuery.dateStart && query.docQuery.dateEnd) {
                // jshint ignore:line
                /* jshint ignore:start */
                trackingData.from_date = query.docQuery.dateStart;
                trackingData.to_date = query.docQuery.dateEnd;
                /* jshint ignore:end */
            }

            /* jshint ignore:start */
            trackingData.user_id = currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name;
            /* jshint ignore:end */

            this.AnalyticsService.trackIcmSearchOperation(trackingData);
        }.bind(this));
    };

    /*
        ----------------------------------
        -------- Local Functions ---------
        ----------------------------------
    */
    function getChildBeats(beats) {
        var childBeats = [];

        for (var i = 0; i < beats.length; i++) {
            for (var j = 0; j < beats[i].children.length; j++) {
                // Autocomplete for beats requires parentKey
                var beatToDisplay = JSON.parse(JSON.stringify(beats[i].children[j]));
                beatToDisplay.parentKey = beats[i].key;
                beatToDisplay.parentName = beats[i].name;
                childBeats.push(beatToDisplay);
            }
        }

        return childBeats;
    }

    // Finds the index of a given "value" on a "list" of objects at the specified "field"
    function indexOf(field, value, list) {
        var index = -1;
        for (var i = 0, len = list.length; i < len; i++) {
            if (list[i][field] === value) {
                index = i;
                break;
            }
        }
        return index;
    }

    function collapseAllFilters() {
        var panelObject,
            i,
            panels = angular.element.find('mw-expansion-panel, mw-location-expansion-panel, mw-email-address-expansion-panel, mw-list-status-expansion-panel');

        if (panels.length) {
            for (i = 0; i < panels.length; i++) {
                panelObject = $(panels[i]);
                if (panelObject.hasClass('active')) {
                    panelObject.find('.expand-icon').css('display', 'inline-block');
                    panelObject.find('.collapse-icon').css('display', 'none');
                    panelObject.find('md-card-content').css('display', 'none');
                    panelObject.removeClass('active');
                }
            }
        }
    }

    function getSearchChipValues(searchChips) {
        var searchChipDisplayValues = [];

        if (Array.isArray(searchChips) && searchChips.length) {
            searchChips.forEach(function (searchChip) {
                if (searchChip.type.toLowerCase() === 'standard') {
                    searchChipDisplayValues.push(searchChip.value);
                }
            });
        }

        return searchChipDisplayValues;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.SearchSwitcherController', ['MW.Configuration']).controller('SearchSwitcherController', ['$location', 'MR_SEARCH_URL', SearchSwitcherController]);

    function SearchSwitcherController($location, MR_SEARCH_URL) {
        window.location.href = MR_SEARCH_URL;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.SourceSwitcherController', ['Configuration']).controller('SourceSwitcherController', ['$window', '$timeout', '$route', 'IRM_BASE_URL', SourceSwitcherController]);

    function SourceSwitcherController($window, $timeout, $route, IRM_BASE_URL) {
        var sourceId = $route.current.params.sourceId;

        $timeout(function () {
            $window.location.replace(IRM_BASE_URL + '/source/' + sourceId + $window.location.search);
        });
    }
})();
'use strict';

angular.module('MW.Framework.CoreStaticPageController', []).controller('CoreStaticPageController', ['$scope', function ($scope) {
    'use strict';

    $scope.isPageChromeless = false;
    $scope.useMaterial = false;
    $scope.useActionBar = false;
    $scope.staticPageData = {
        isStaticPage: false,
        staticPage: null
    };
    $scope.isSubTabsBarVisible = false;
    $scope.subTabsConfig = {
        activeTab: ''
    };

    $scope.$on('$routeChangeStart', function onRouteChangeStart($event, newRoute) {

        /*Toggle between flex padding and generic app margin if route uses Material*/
        if (newRoute.$$route && newRoute.$$route.useMaterial) {
            $scope.useMaterial = true;
        } else {
            $scope.useMaterial = false;
        }

        /*Need to process this before route change success if new route is chromeless*/
        if (newRoute.$$route && newRoute.$$route.isChromeless) {
            $scope.isPageChromeless = newRoute && newRoute.$$route && newRoute.$$route.isChromeless ? true : false;
            $scope.subTabsConfig.activeTab = newRoute.$$route.activeTab;
            $scope.subTabsConfig.hideSubTabs = newRoute.$$route.hideSubTabs || false;
        }
    });

    $scope.$on('$routeChangeSuccess', function onRouteChangeStart($event, newRoute) {
        $scope.isPageChromeless = newRoute && newRoute.$$route && newRoute.$$route.isChromeless ? true : false;

        if (typeof newRoute.$$route !== 'undefined' && newRoute.$$route.isStaticPage) {
            $scope.staticPageData.isStaticPage = true;
            $scope.staticPageData.staticPage = newRoute.$$route.staticPage;
        } else {
            $scope.staticPageData.isStaticPage = false;
            $scope.staticPageData.staticPage = null;

            if (newRoute.$$route && !newRoute.$$route.isChromeless) {
                $scope.subTabsConfig.activeTab = newRoute.$$route.activeTab;
                $scope.subTabsConfig.hideSubTabs = newRoute.$$route.hideSubTabs || false;
            }
        }
    });

    $scope.$watch('subTabsConfig', function scopeWatchAlerts(newValue) {
        $scope.$broadcast('subTabsConfig', newValue);
    }, true);

    $scope.$on('isIcmCountriesEntitlement', function isIcmCountriesEntitlement() {
        $scope.$broadcast('subTabsConfig', $scope.subTabsConfig);
    });
}]);
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.ContactAutocompleteFilter', []).filter('ContactAutocompleteFilter', function () {
        return function (contacts, filter) {
            var matchingContacts = [];

            if (!Array.isArray(contacts)) {
                return contacts;
            }

            if (filter.length <= 0) {
                return contacts;
            }

            contacts.forEach(function (contact) {
                if (contact.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || contact.email.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                    matchingContacts.push(contact);
                }
            });

            return matchingContacts;
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.ContactManager.SourceFilter', []).filter('sourceFilter', function () {
        return function (sources, predictionFilter) {
            var matchingSources = [];

            // if we do not have data in the correct format, don\'t attempt to filter
            if (!Array.isArray(sources)) {
                return sources;
            }

            // if we aren't filtering, return all sources
            if (Object.keys(predictionFilter).length <= 0) {
                return sources;
            }

            // check each source to find ones that match the filter
            sources.forEach(function (source) {
                var matchesFilter = false;

                // check each Filter Key/Category until we find one that matches this source
                matchesFilter = Object.keys(predictionFilter).some(function (predictionKey) {
                    if (predictionFilter[predictionKey] !== null) {
                        var sourceValueArray = [];

                        switch (predictionKey.toLowerCase()) {
                            case 'name':
                                sourceValueArray = [source.name];
                                break;
                            case 'address':
                                sourceValueArray = source.contactInfo.addresses.map(function (addressObject) {
                                    var addressFields = [addressObject.street, addressObject.street2, addressObject.city, addressObject.stateOrProvince, addressObject.zip, addressObject.countryName],
                                        addressArray = [];

                                    addressFields.forEach(function (addressValue) {
                                        if (addressValue) {
                                            addressArray.push(addressValue);
                                        }
                                    });

                                    return addressArray.join(' ');
                                });
                                break;
                            case 'emailaddress':
                                sourceValueArray = source.contactInfo.email.map(function (emailObject) {
                                    return emailObject.address;
                                });
                                break;
                            case 'phonenumber':
                                sourceValueArray = source.contactInfo.phone.map(function (phoneObject) {
                                    return phoneObject.number;
                                });
                                break;
                            case 'socialprofile':
                                sourceValueArray = source.socialProfiles.map(function (socialProfileObject) {
                                    return socialProfileObject.userName;
                                });
                                break;
                            case 'beat':
                                if (source.beats) {
                                    sourceValueArray = source.beats.map(function (beatObject) {
                                        return beatObject.name;
                                    });
                                } else {
                                    return false;
                                }
                                break;
                            default:
                                // can\'t match what we don\'t know
                                return false;
                        }

                        return sourceValueArray.some(function (sourceValue) {
                            return sourceValue && sourceValue.toLowerCase().indexOf(predictionFilter[predictionKey].toLowerCase()) >= 0;
                        });
                    }
                });

                if (matchesFilter) {
                    matchingSources.push(source);
                }
            });

            return matchingSources;
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.TextFilters', ['MW.Framework.TextServices', 'MW.Framework.CoreCommon']).filter('icmTranslateDate', ['user', 'moment', 'MOMENT_MEDIUM_DATE', 'MOMENT_FULL_DATE', function (user, moment, MOMENT_MEDIUM_DATE, MOMENT_FULL_DATE) {
        return function (date, format) {
            if (date) {
                var userTimezone = user.getTimezone(),
                    userLanguage = user.getLanguage() || 'en',
                    utcDate = moment.utc(date);

                if (format) {
                    switch (format) {
                        case 'mediumDate':
                            return utcDate.tz(userTimezone).locale(userLanguage).format(MOMENT_MEDIUM_DATE);
                        case 'fullDate':
                            return utcDate.tz(userTimezone).locale(userLanguage).format(MOMENT_FULL_DATE);
                        default:
                            return utcDate.tz(userTimezone).locale(userLanguage).format(format);
                    }
                } else {
                    return utcDate.tz(userTimezone).locale(userLanguage).format();
                }
            } else {
                return '';
            }
        };
    }]);
})();
'use strict';

(function () {
  'use strict';

  angular.module('MW.ContactManager.TrustFilter', []).filter('trusted', ["$sce", function ($sce) {
    return function (html) {
      return $sce.trustAsHtml(html);
    };
  }]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionBarService = function () {
    function ActionBarService() {
        _classCallCheck(this, ActionBarService);

        this.actions = [];
        this.pageTitle = '';
        this.isVisible = true;
        this.isBackButtonVisible = false;
    }

    _createClass(ActionBarService, [{
        key: 'resetState',
        value: function resetState() {
            this.actions = [];
            this.pageTitle = '';
            this.isVisible = true;
            this.isBackButtonVisible = false;
        }
    }, {
        key: 'registerActions',
        value: function registerActions(newActions) {
            var _this = this;

            if (!Array.isArray(newActions)) {
                throw new Error('Actions must be an Array');
            }

            this.actions = newActions.filter(function (action) {
                return _this.isValidAction(action);
            });
        }
    }, {
        key: 'registerTitle',
        value: function registerTitle(title) {
            this.pageTitle = title || '';
        }
    }, {
        key: 'setAction',
        value: function setAction(index, action) {
            if (this.isValidAction(action) && this.actions[index]) {
                this.actions[index] = action;
            }
        }
    }, {
        key: 'isValidAction',
        value: function isValidAction(action) {
            return !!(action.label && action.onClick && action.hasOwnProperty('enabled'));
        }
    }, {
        key: 'setVisibility',
        value: function setVisibility(toggle) {
            this.isVisible = !!toggle; //convert to boolean
        }
    }, {
        key: 'setBackButtonVisibility',
        value: function setBackButtonVisibility(show) {
            this.isBackButtonVisible = show;
        }
    }]);

    return ActionBarService;
}();

angular.module('MW.Influencers.ActionBarService', []).service('ActionBarService', [ActionBarService]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var ActivityService = function () {
        function ActivityService($q, $mdDialog, $translate, moment, CoreUserService, InfluencerContactService) {
            _classCallCheck(this, ActivityService);

            this.$q = $q;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.moment = moment;
            this.CoreUserService = CoreUserService;
            this.InfluencerContactService = InfluencerContactService;
        }

        _createClass(ActivityService, [{
            key: '_openActivityModal',
            value: function _openActivityModal(callback, activity) {
                var _this = this,
                    createdString,
                    updatedString;

                activity = activity || {};
                activity.date = activity.date ? _this.moment(activity.date) : _this.moment();

                function createTimeString(action, author, datetime) {
                    var date = _this.moment(datetime).format('MMMM Do YYYY'),
                        time = _this.moment(datetime).format('h:mm a'),
                        bemKey,
                        stamp;

                    if (author && author.firstName && author.lastName) {
                        bemKey = action === 'created' ? 'icm-web__contact-profile--activity-created' : 'icm-web__contact-profile--activity-updated';

                        stamp = _this.$translate.instant(bemKey, { firstName: author.firstName, lastName: author.lastName, date: date, time: time });
                    } else {
                        bemKey = action === 'created' ? 'icm-web__contact-profile--activity-created-noname' : 'icm-web__contact-profile--activity-updated-noname';

                        stamp = _this.$translate.instant(bemKey, { date: date, time: time });
                    }

                    return stamp;
                }

                if (activity.createdAt) {
                    createdString = createTimeString('created', activity.createdBy, activity.createdAt);

                    if (activity.modifiedAt && activity.modifiedAt !== activity.createdAt) {
                        updatedString = createTimeString('updated', activity.updatedBy, activity.modifiedAt);
                    }
                }

                this.$mdDialog.show({
                    autoWrap: false,
                    bindToController: true,
                    fullscreen: true,
                    locals: {
                        selectedType: activity.type,
                        subject: activity.subject,
                        body: activity.note,
                        date: activity.date,
                        createdString: createdString || null,
                        updatedString: updatedString || null,
                        cancelDialog: function cancelDialog() {
                            _this.$mdDialog.cancel();
                        },
                        okDialog: function okDialog(selectedType, subject, body, date) {
                            date = date.format('L');
                            callback(selectedType, subject, body, date);

                            _this.$mdDialog.hide();
                        }
                    },
                    template: '\n                    <md-dialog id="icm-activity-modal" class="mw-mini-modal" aria-label="" layout="column">\n                        <mw-activity-modal class="mw-mini-modal-wrapper" layout="column" created-string="$ctrl.createdString" updated-string="$ctrl.updatedString" selected-type="$ctrl.selectedType" subject="$ctrl.subject" body="$ctrl.body" date="$ctrl.date" cancel-callback="$ctrl.cancelDialog()" ok-callback="$ctrl.okDialog(selectedType, subject, body, date)"></mw-activity-modal>\n                    </md-dialog>\n               ',
                    // This is a globally available controller for the purposes of attaching locals for data binding
                    controller: 'MwMiniModalDialogController',
                    controllerAs: '$ctrl'
                });
            }
        }, {
            key: 'createActivity',
            value: function createActivity(contactId) {
                var _this = this;

                return _this.$q(function (resolve) {
                    function performAdd(selectedType, subject, body, date) {
                        _this.CoreUserService.getCurrent(true).then(function (user) {
                            var author = {
                                id: user._id,
                                firstName: user.firstName,
                                lastName: user.lastName,
                                email: user.email
                            };

                            var createPromise = _this.InfluencerContactService.addActivity(contactId, selectedType, subject, body, date, author);
                            resolve(createPromise);
                        });
                    }

                    _this._openActivityModal(performAdd);
                });
            }
        }, {
            key: 'updateActivity',
            value: function updateActivity(contactId, oldActivity) {
                var _this = this;

                return _this.$q(function (resolve) {
                    function performUpdate(selectedType, subject, body, date) {
                        _this.CoreUserService.getCurrent(true).then(function (user) {
                            var author = {
                                id: user._id,
                                firstName: user.firstName,
                                lastName: user.lastName,
                                email: user.email
                            },
                                activityId = oldActivity.notesId;

                            var updatePromise = _this.InfluencerContactService.editActivity(activityId, contactId, selectedType, subject, body, date, author);
                            resolve(updatePromise);
                        });
                    }

                    _this._openActivityModal(performUpdate, oldActivity);
                });
            }
        }, {
            key: 'getActivityTypes',
            value: function getActivityTypes() {
                return [{
                    value: 'email',
                    display: this.translateActivityType('email')
                }, {
                    value: 'phone_call',
                    display: this.translateActivityType('phone_call')
                }, {
                    value: 'note',
                    display: this.translateActivityType('note')
                }, {
                    value: 'meeting',
                    display: this.translateActivityType('meeting')
                }, {
                    value: 'other',
                    display: this.translateActivityType('other')
                }];
            }
        }, {
            key: 'translateActivityType',
            value: function translateActivityType(type) {
                var translation;
                switch (type) {
                    case 'note':
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-note');
                        break;
                    case 'phone_call':
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-phone');
                        break;
                    case 'meeting':
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-meeting');
                        break;
                    case 'other':
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-other');
                        break;
                    case 'email':
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-email');
                        break;
                    default:
                        translation = this.$translate.instant('icm-web__contact-profile--activity-type-note');
                        break;
                }
                return translation;
            }
        }]);

        return ActivityService;
    }();

    angular.module('MW.Influencers.ActivityService', ['ngMaterial', 'mwAppComponents', 'MW.Framework.CoreUserService', 'MW.Framework.InfluencerContactService', 'MW.ContactManager.MwActivityModal']).service('ActivityService', ['$q', '$mdDialog', '$translate', 'moment', 'CoreUserService', 'InfluencerContactService', ActivityService]);
})();
'use strict';

angular.module('ICMAnalyticsHelperService', ['MW.Framework.ICMEntitlementService']).provider('ICMAnalyticsHelperService', [function () {

    var defaultProperties = {
        isInternalUser: false
    },
        userIdentity = null,
        userRole = 'Anonymous User',
        product = 'Desktop',
        eventQueue = [],
        isInitialized = false,
        userIdentitySet = false,
        provider = this,
        pageList = [{ val: 'Inbox', pattern: '/inbox' }, { val: 'Dashboards', pattern: '/dashboard/collections' }, { val: 'Dashboards', pattern: '/dashboard/viewer' }, { val: 'Maximized Widget', pattern: '/widget_' }, { val: 'Search', pattern: '/search/list' }, { val: 'Search', pattern: '/search/results' }, { val: 'Search Update', pattern: '/search/edit' }, { val: 'Tags', pattern: '/tag' }, { val: 'Personal Settings', pattern: '/settings/personal' }, { val: 'Report Settings', pattern: '/settings/report' }, { val: 'RSS Feed', pattern: '/settings/rss' }, { val: 'Manage Users', pattern: '/settings/users' }, { val: 'Account Information', pattern: '/settings/account' }, { val: 'Home', pattern: '/dashboard/index' }, { val: 'Output Manager', pattern: '/output' }, { val: 'Influencers', pattern: '/influencers' }, { val: 'Influencers', pattern: '/outreach' }];

    // Basic stuff available both on the provider, and on the actual service it provides.    
    this.getDefaultProperties = function () {
        return defaultProperties;
    };

    this.getUserIdentity = function () {
        return userIdentity;
    };

    this.getUserRole = function () {
        return userRole;
    };

    this.getProduct = function () {
        return product;
    };

    this.getAnalyticsDetail = function ($injector, $q) {
        var userObject = this.getUserDetail($injector, false),
            companyObject = this.getCompanyDetail($injector, false),
            promises = [],
            trackingUserCompanyDetail = {},
            role,
            defer = $q.defer(),
            ICMEntitlementService = $injector.get('ICMEntitlementService');

        promises.push(userObject);
        promises.push(ICMEntitlementService.getEntitlements());

        $q.all(promises).then(function (results) {
            var user = results[0].user,
                entitlements = results[1];

            if (user && companyObject) {
                role = results[0].companyMembership.role;
                trackingUserCompanyDetail = {
                    companyId: companyObject._id,
                    companyCountry: companyObject.country,
                    companyCreationDate: companyObject.created,
                    loginUserId: user._id,
                    userName: user.username,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    userTimezone: user.timezone,
                    userType: user.isInternal ? 'Internal' : 'External',
                    userRole: role,
                    createdAt: user.created
                };
                if (companyObject.accountId) {
                    trackingUserCompanyDetail.companyAccountId = companyObject.accountId;
                }
                if (companyObject.opportunityId) {
                    trackingUserCompanyDetail.companyOpportunityId = companyObject.opportunityId;
                }
                if (entitlements) {
                    trackingUserCompanyDetail.entitlements = entitlements;
                }
            }
            defer.resolve(trackingUserCompanyDetail);
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    this.getUserDetail = function ($injector, wait) {
        var ICMUserService = $injector.get('ICMUserService'),
            completeUserIdentity = ICMUserService.getIdentity(wait);
        return completeUserIdentity;
    };

    this.getCompanyDetail = function ($injector, wait) {
        var CoreCompanyService = $injector.get('CoreCompanyService'),
            completeCompanyIdentity = CoreCompanyService.getCurrent(wait);
        return completeCompanyIdentity;
    };

    this.getPageName = function (url) {
        var pageName = '';
        angular.forEach(pageList, function (pageListObj) {
            if (url.match(pageListObj.pattern)) {
                pageName = pageListObj.val;
            }
        });
        return pageName;
    };

    this.runWhenReady = function (fn) {
        if (isInitialized) {
            fn();
        } else {
            eventQueue.push(fn);
        }
    };

    var executeQueue = function executeQueue() {
        while (eventQueue.length > 0) {
            // Yes, this looks silly. It pops the last function off of eventQueue and runs it immediately.
            eventQueue.pop()();
        }
    };

    // Provider object to serve up the service.
    // Getter method for the service.
    this.$get = ['$rootScope', '$injector', function ($rootScope, $injector) {

        // Helper method that we call on events, or we can call manually to trigger an update if needed.
        var updateLocalData = function updateLocalData() {
            var ICMUserService = $injector.get('ICMUserService'),
                CoreCompanyService = $injector.get('CoreCompanyService'),
                identity = ICMUserService.getIdentity();
            identity.then(function (id) {
                userIdentity = id.user.email + ' (' + id.user._id + ') ' + (CoreCompanyService.getName() || 'Unknown Company');
                userRole = (id.user.isInternal ? 'Internal ' : '') + ICMUserService.getRoleName();

                defaultProperties.isInternalUser = id.user.isInternal;
                defaultProperties.userRole = userRole;
                isInitialized = true;

                if (userIdentitySet === false) {
                    $rootScope.$broadcast('analyticsUpdate');
                    userIdentitySet = true;
                }

                executeQueue();
            });
        };

        // Here's our service definition!
        return {
            getDefaultProperties: provider.getDefaultProperties,
            getUserIdentity: provider.getUserIdentity,
            getUserRole: provider.getUserRole,
            getProduct: provider.getProduct,
            runWhenReady: provider.runWhenReady,
            updateLocalData: updateLocalData,
            getUserDetail: provider.getUserDetail,
            getCompanyDetail: provider.getCompanyDetail,
            getAnalyticsDetail: provider.getAnalyticsDetail
        };
    }];

    return this;
}]).run(['$rootScope', 'ICMAnalyticsHelperService', function ($rootScope, ICMAnalyticsHelperService) {
    $rootScope.$on('companyChanged', ICMAnalyticsHelperService.updateLocalData);
}]);
'use strict';

angular.module('MW.Influencers.AnalyticsService', ['MW.Framework.MomentService', 'MW.Framework.AnalyticsConstants', 'angulartics', 'angulartics.segment.io', 'MW.Configuration']).factory('AnalyticsService', ['$analytics', '$location', 'ANALYTICS_CONSTANTS', 'moment', function ($analytics, $location, ANALYTICS_CONSTANTS, moment) {
    'use strict';

    var analyticsServiceObj = {},
        sentiment = {
        'P': ANALYTICS_CONSTANTS.POSITIVE,
        'V': ANALYTICS_CONSTANTS.NEGATIVE,
        'N': ANALYTICS_CONSTANTS.NEUTRAL,
        'U': ANALYTICS_CONSTANTS.NOT_RATED
    },
        mailSources = [ANALYTICS_CONSTANTS.SOURCE_MAIL, ANALYTICS_CONSTANTS.SOURCE_MAIL_DIGEST, ANALYTICS_CONSTANTS.SOURCE_MAIL_DASHBOARD, ANALYTICS_CONSTANTS.SOURCE_MAIL_NOTIFICATION, ANALYTICS_CONSTANTS.SOURCE_MAIL_SHARE, ANALYTICS_CONSTANTS.SOURCE_MAIL_NEWSLETTER, ANALYTICS_CONSTANTS.SOURCE_OUTPUT_NEWSFEED],
        source,
        IS_FIRST_DOCUMENT_OPERATION_TRACKING = true;

    /**
     * (Public)
     * Makes a call to analytics services to update the tracking
     * tracking status for the email dashboard/invite collaborators.
     * @param label
     * @param category
     */
    analyticsServiceObj.registerAnalytic = function registerAnalytic(label, category) {
        var properties = {};

        if (category) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = category;
        }
        properties[ANALYTICS_CONSTANTS.LABEL] = label;

        $analytics.eventTrack('Share Dashboard Button Clicked', properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics services to update the tracking
     * tracking status for the date range selector.
     *
     * @param parent, range
     * @returns {date_range properties}
     */
    analyticsServiceObj.dateRangeTrack = function dateRangeTrack(parent, range) {
        var properties = {};
        properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.UPDATE_DATE_RANGE;
        if (parent && parent.dashboard && parent.dashboardId) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.DASHBOARDS;
            properties[ANALYTICS_CONSTANTS.DASHBOARD_ID] = parent.dashboardId;
        }

        if (parent && parent.$parent && parent.$parent.inboxItemToDisplay) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.INBOX;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.inboxItemToDisplay;
        }

        if (parent && parent.$parent && parent.$parent.savedSearchData && parent.$parent.savedSearchData.name) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_SEARCHES;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.savedSearchData.name;
        }

        if (parent && parent.$parent && parent.$parent.tagName) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_TAG;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.tagName;
        }

        if (range && range.absoluteStartDate && range.absoluteEndDate) {
            properties[ANALYTICS_CONSTANTS.START_DATE] = range.absoluteStartDate._d;
            properties[ANALYTICS_CONSTANTS.END_DATE] = range.absoluteEndDate._d;
        }

        $analytics.eventTrack(ANALYTICS_CONSTANTS.PERSONAL_SETTING_OPERATION, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics services to update the tracking
     * tracking status for the comparison date range selector.
     *
     * @param parent, range
     * @returns {date_range properties}
     */
    analyticsServiceObj.previousDateRangeTrack = function previousDateRangeTrack(parent, previousRange) {
        var properties = {};
        properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.UPDATE_DATE_RANGE;
        if (parent && parent.dashboard && parent.dashboardId) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.DASHBOARDS;
            properties[ANALYTICS_CONSTANTS.DASHBOARD_ID] = parent.dashboardId;
        }

        if (parent && parent.$parent && parent.$parent.inboxItemToDisplay) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.INBOX;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.inboxItemToDisplay;
        }

        if (parent && parent.$parent && parent.$parent.savedSearchData && parent.$parent.savedSearchData.name) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_SEARCHES;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.savedSearchData.name;
        }

        if (parent && parent.$parent && parent.$parent.tagName) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.SELECTED_TAG;
            properties[ANALYTICS_CONSTANTS.NAME] = parent.$parent.tagName;
        }

        if (previousRange && previousRange.relativeDate) {
            properties[ANALYTICS_CONSTANTS.DATE_RANGE_SECONDARY_INPUT] = previousRange.relativeDate;
        }

        $analytics.eventTrack(ANALYTICS_CONSTANTS.PERSONAL_SETTING_OPERATION, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics services to update the tracking
     * tracking status for the Entitlement Limit
     *
     * @param action
     */
    analyticsServiceObj.showEntitlementLimit = function showEntitlementLimit(action) {
        var properties = {};

        properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.ENTITLEMENT;
        properties[ANALYTICS_CONSTANTS.LABEL] = action;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.ENTITLEMENT_LIMIT, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics services to update the tracking
     * tracking status for the document.
     *
     * @param event
     * @param payload
     * @param documentId
     * @param searchId
     * @param action
     */
    analyticsServiceObj.trackDocumentList = function trackDocumentList(event, payload, documentId, searchId, action) {
        var properties = {},
            documentUrl = payload.url,
            savedSearchName = payload.name,
            source = payload.s,
            type = payload.type;
        if (!source) {
            source = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
        }
        properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.MAIL_REPORT_ACTION;
        properties[ANALYTICS_CONSTANTS.LABEL] = documentUrl;
        properties[ANALYTICS_CONSTANTS.NAME] = savedSearchName;
        properties[ANALYTICS_CONSTANTS.SOURCE] = source;
        properties[ANALYTICS_CONSTANTS.TYPE] = type;
        properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = documentId;
        properties[ANALYTICS_CONSTANTS.ID] = searchId;

        if (action === 'open') {
            properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = 'true';
        }

        $analytics.eventTrack(event, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics services to update the tracking
     * tracking status for the find option.
     */
    analyticsServiceObj.findOption = function findOption() {
        var properties = {},
            path = $location.path(),
            type = '',
            typeArray = {
            0: ANALYTICS_CONSTANTS.INBOX,
            1: ANALYTICS_CONSTANTS.DASHBOARD,
            2: ANALYTICS_CONSTANTS.SEARCH,
            3: ANALYTICS_CONSTANTS.TAG,
            4: ANALYTICS_CONSTANTS.OUTPUT,
            5: ANALYTICS_CONSTANTS.REPORT,
            6: ANALYTICS_CONSTANTS.RSS
        };

        angular.forEach(typeArray, function (val) {
            val = val.toLowerCase();
            if (path.indexOf(val) > -1) {
                type = val;
                return type;
            }
        });

        properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.CONTENT_STREAM;
        properties[ANALYTICS_CONSTANTS.TYPE] = type;
        properties[ANALYTICS_CONSTANTS.SOURCE] = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.FIND_DOCUMENT, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics tracking when a user clicks an item in the navigation
     *
     * @param event
     * @param eventData
     */
    analyticsServiceObj.trackNavigation = function (event, eventData) {
        var properties = {};

        properties[ANALYTICS_CONSTANTS.LABEL] = event;
        properties[ANALYTICS_CONSTANTS.SOURCE] = mailSources.indexOf(source) !== -1 ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
        properties[ANALYTICS_CONSTANTS.SOURCE_PAGE] = eventData.sourceUrl;
        properties[ANALYTICS_CONSTANTS.NAVIGATION_TYPE] = eventData.type;
        properties[ANALYTICS_CONSTANTS.DESTINATION_PAGE] = eventData.url;
        properties[ANALYTICS_CONSTANTS.PIN_STATUS] = eventData.pinStatus;
        properties[ANALYTICS_CONSTANTS.DESTINATION_PAGE_TYPE] = eventData.label;
        properties[ANALYTICS_CONSTANTS.LANGUAGE] = eventData.language;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.CLICK_NAVIGATION, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics tracking when a user views content stream results
     *
     * @param data
     */
    analyticsServiceObj.trackViewContentStream = function trackViewContentStream(data) {
        if (window.location && window.location.href && (window.location.href.indexOf('pdf_layout') > 0 || window.location.href.indexOf('email_layout') > 0)) {
            return null;
        }

        var properties = {},
            inputId = null,
            inputName = null,
            openingText = null,
            totalDocuments = null,
            findFilter = null,
            eventData = data.eventData,
            parentType = data.parentType,
            tagName = null,
            sortBy = eventData.query.sortField;

        if (parentType === 'Search') {
            inputId = eventData.savedSearchData.savedSearchId;
            inputName = eventData.savedSearchData.name;
            openingText = eventData.rowDisplaySettings.openingText;
            totalDocuments = eventData.DocumentStreamData.totalDocuments;
        } else if (parentType === 'inbox') {
            inputName = data.sourceDetail.name;
            inputId = data.sourceDetail.id;
            openingText = eventData.rowDisplaySettings.openingText;
            totalDocuments = eventData.documentStreamData.totalDocuments;
        } else if (parentType === 'Tag') {
            totalDocuments = eventData.DocumentStreamData.totalDocuments;
            openingText = eventData.rowDisplaySettings.openingText;
            tagName = eventData.tagName;
        }
        if (sortBy === 'country') {
            sortBy = 'geo';
        }

        properties[ANALYTICS_CONSTANTS.LABEL] = ANALYTICS_CONSTANTS.VIEW;
        properties[ANALYTICS_CONSTANTS.SOURCE] = mailSources.indexOf(source) !== -1 ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
        properties[ANALYTICS_CONSTANTS.INPUT_ID] = inputId;
        properties[ANALYTICS_CONSTANTS.INPUT_NAME] = inputName;
        properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = parentType;
        properties[ANALYTICS_CONSTANTS.TAG_NAME] = tagName;
        properties[ANALYTICS_CONSTANTS.FIND_FILTER] = findFilter;
        properties[ANALYTICS_CONSTANTS.SORT_BY] = sortBy;
        properties[ANALYTICS_CONSTANTS.SORT_DIRECTION] = eventData.query.sortOrder;
        properties[ANALYTICS_CONSTANTS.OPENING_TEXT_FLAG] = openingText;
        properties[ANALYTICS_CONSTANTS.HIT_SENTENCE_FLAG] = eventData.rowDisplaySettings.hitSentence;
        properties[ANALYTICS_CONSTANTS.TAG_FLAG] = eventData.rowDisplaySettings.displayTags;
        properties[ANALYTICS_CONSTANTS.IMAGE_FLAG] = eventData.rowDisplaySettings.images;
        properties[ANALYTICS_CONSTANTS.GROUPING] = eventData.query.groupOption;
        properties[ANALYTICS_CONSTANTS.START_DATE] = moment(eventData.query.dateStart).format('YYYY-MM-DD');
        properties[ANALYTICS_CONSTANTS.END_DATE] = moment(eventData.query.dateEnd).format('YYYY-MM-DD');
        properties[ANALYTICS_CONSTANTS.STREAM_TYPE] = data.streamType;
        properties[ANALYTICS_CONSTANTS.NUMBER_OF_RESULTS_SHOWN] = totalDocuments;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.CONTENT_STREAM, properties);
    };

    analyticsServiceObj.applyOverlaySentiment = function applyOverlaySentiment(eventData) {
        var documents = eventData.documentDetails,
            properties = {};

        angular.forEach(documents, function (document) {
            properties = {};
            properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = eventData.savedSearchId ? eventData.savedSearchId : null;
            properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = eventData.savedSearchName ? eventData.savedSearchName : null;
            properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event.toLowerCase();
            properties[ANALYTICS_CONSTANTS.SOURCE] = mailSources.indexOf(source) !== -1 ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
            properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
            properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
            properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
            properties[ANALYTICS_CONSTANTS.TAG_NAME] = document.tags && document.tags.length > 0 ? document.tags.join('|') : null;
            properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = mailSources.indexOf(source) !== -1 ? ANALYTICS_CONSTANTS.EMAIL : eventData.parentType.toLowerCase();
            properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = null;
            properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = null;
            properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = null;
            properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
            properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
            properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
            properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
            properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
            properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[eventData.sentiment];
            properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = null;

            $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
        });
    };

    /**
     * (Public)
     *
     * Makes a call to analytics tracking when a user clicks on get more results button.
     *
     * @param documentsConfig
     */
    analyticsServiceObj.getMoreResultsEventTrack = function getMoreResultsEventTrack(documentsConfig) {
        var searchCriteria = '',
            properties = {};

        if (documentsConfig && documentsConfig.searches && documentsConfig.searches.length > 0) {
            searchCriteria = documentsConfig.searches[0].searchQuery;
            if (documentsConfig.searches[0].name && documentsConfig.searches[0].savedSearchId) {
                properties[ANALYTICS_CONSTANTS.LABEL] = documentsConfig.searches[0].name;
                properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = documentsConfig.searches[0].savedSearchId;
            }
        } else if (documentsConfig && documentsConfig.savedSearchData && typeof documentsConfig.savedSearchData !== 'undefined') {
            searchCriteria = documentsConfig.savedSearchData.searchQuery;
            if (documentsConfig.savedSearchData.name && documentsConfig.savedSearchData.savedSearchId) {
                properties[ANALYTICS_CONSTANTS.LABEL] = documentsConfig.savedSearchData.name;
                properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = documentsConfig.savedSearchData.savedSearchId;
            }
        }

        if (searchCriteria) {
            properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.CONTENT_STREAM;

            properties[ANALYTICS_CONSTANTS.SEARCH_TYPE] = searchCriteria.searchQueryType;

            if (searchCriteria.allKeywords && searchCriteria.allKeywords.length > 0) {
                properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_ALL] = searchCriteria.allKeywords;
            }

            if (searchCriteria.anyKeywords && searchCriteria.anyKeywords.length > 0) {
                properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_ANY] = searchCriteria.anyKeywords;
            }

            if (searchCriteria.notKeywords && searchCriteria.notKeywords.length > 0) {
                properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_NONE] = searchCriteria.notKeywords;
            }

            if (searchCriteria.booleanQuery && searchCriteria.booleanQuery.length > 0) {
                properties[ANALYTICS_CONSTANTS.SEARCH_QUERY_BOOLEAN] = searchCriteria.booleanQuery;
            }

            properties[ANALYTICS_CONSTANTS.SOURCE_SELECTION_ID] = searchCriteria.sourceSelectionId;
            properties[ANALYTICS_CONSTANTS.SOURCE] = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

            $analytics.eventTrack(ANALYTICS_CONSTANTS.VIEW_MORE_RESULTS, properties);
        }
    };

    /**
     * (Public)
     *
     * Makes a call to analytics tracking when a user share,translate & open a Document.
     *
     * @param data
     */
    analyticsServiceObj.documentOperation = function documentOperation(data) {
        var properties;

        // GYDA-18623 - Action taken from mailSources should only be tracked under mailSources and
        // other actions taken within the web-app should be tracked under source web-app.
        if (IS_FIRST_DOCUMENT_OPERATION_TRACKING) {
            if ($location.url().indexOf('/open/documents/') >= 0) {
                source = $location.search().s ? $location.search().s : $location.search().source;
            }
            IS_FIRST_DOCUMENT_OPERATION_TRACKING = false;
        }

        properties = this.buildPropertiesForDocumentOperation(data);

        $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
    };

    analyticsServiceObj.buildPropertiesForDocumentOperation = function buildPropertiesForDocumentOperation(data) {
        var document = data.document,
            sourceDetail,
            properties = {},
            tags = [],
            label = data.label;

        if (data.sourceDetail) {
            if (data.sourceDetail.name && data.sourceDetail.id) {
                sourceDetail = data.sourceDetail;
            } else {
                sourceDetail = null;
            }
        }
        if (document.tags && document.tags.length > 0) {
            for (var key in document.tags) {
                if (document.tags[key].name !== undefined) {
                    tags.push(document.tags[key].name);
                } else {
                    tags.push(document.tags[key]);
                }
            }
            tags = tags.join('|');
        } else {
            tags = null;
        }

        properties[ANALYTICS_CONSTANTS.LABEL] = label;

        properties[ANALYTICS_CONSTANTS.SOURCE] = mailSources.indexOf(source) !== -1 ? source : data.source ? data.source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

        properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
        properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
        properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = sourceDetail ? sourceDetail.id : null;
        properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = sourceDetail ? sourceDetail.name : null;
        properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
        properties[ANALYTICS_CONSTANTS.TAG_NAME] = tags;
        properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = mailSources.indexOf(source) !== -1 ? ANALYTICS_CONSTANTS.EMAIL : data.parentType.toLowerCase();
        properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = data.socialType ? data.socialType : null;
        properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = data.translateApi ? data.translateApi : null;
        properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = data.languagePair ? data.languagePair : null;
        properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
        properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
        properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
        properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
        properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
        properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[document.sentiment];
        properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = label === ANALYTICS_CONSTANTS.EXPORT ? ANALYTICS_CONSTANTS.EXCEL : null;

        properties[ANALYTICS_CONSTANTS.COMPANY_ID] = data.cId ? data.cId : null;
        properties[ANALYTICS_CONSTANTS.USER_ID] = data.uId ? data.uId : null;

        // reset the source property to SOURCE_WEBAPP
        source = ANALYTICS_CONSTANTS.SOURCE_WEBAPP;

        return properties;
    };

    /**
     * (Public)
     *
     * Makes a general call to analytics tracking passing the parameter as the label
     *  for example: used when the contact us link is clicked, passes 'contact us'
     *
     * @param event
     */
    analyticsServiceObj.trackGeneralOperation = function (event) {
        var properties = {};

        properties[ANALYTICS_CONSTANTS.LABEL] = event;
        properties[ANALYTICS_CONSTANTS.CATEGORY] = ANALYTICS_CONSTANTS.GENERAL_CATEGORY;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.GENERAL_OPERATION, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics tracking for every document hidden/unhidden
     *
     * @param eventData
     *
     * eventData = {
     *      event: 'hide' || 'unhide',
     *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
     *      documentDetails: {},
     *      searchSaveId: savedSearchId || null,
     *      savedSearchName: savedSearchName || null,
     *      parentType: 'inbox' | 'search' | 'dashboard' | 'tag'
     * }
     *
     */
    analyticsServiceObj.trackHideUnhideDocumentOperation = function trackHideUnhideDocumentOperation(eventData) {
        var documents = eventData.documentDetails,
            properties = {};

        angular.forEach(documents, function (document) {
            properties = {};
            properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event ? eventData.event.toLowerCase() : null;
            properties[ANALYTICS_CONSTANTS.SOURCE] = eventData.source ? eventData.source.toLowerCase() : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
            properties[ANALYTICS_CONSTANTS.DOCUMENT_URL] = document.url;
            properties[ANALYTICS_CONSTANTS.DOCUMENT_ID] = document.documentId;
            properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_ID] = eventData.inputId ? eventData.inputId : null;
            properties[ANALYTICS_CONSTANTS.SAVED_SEARCH_NAME] = eventData.inputName ? eventData.inputName : null;
            properties[ANALYTICS_CONSTANTS.IS_PREMIUM] = document.isHosted;
            properties[ANALYTICS_CONSTANTS.TAG_NAME] = document.tags && document.tags.length > 0 ? document.tags.join('|') : null;
            properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = eventData.parentType ? eventData.parentType.toLowerCase() : null;
            properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = null;
            properties[ANALYTICS_CONSTANTS.TRANSLATE_API] = null;
            properties[ANALYTICS_CONSTANTS.LANGUAGE_PAIR] = null;
            properties[ANALYTICS_CONSTANTS.RECIPIENTS] = null;
            properties[ANALYTICS_CONSTANTS.SUBJECT_LINE] = null;
            properties[ANALYTICS_CONSTANTS.INCLUDE_OPENING_FLAG] = null;
            properties[ANALYTICS_CONSTANTS.INCLUDE_HIT_FLAG] = null;
            properties[ANALYTICS_CONSTANTS.ADDITIONAL_COMMENT] = null;
            properties[ANALYTICS_CONSTANTS.SENTIMENT] = sentiment[document.sentiment];
            properties[ANALYTICS_CONSTANTS.EXPORT_FORMAT] = null;

            $analytics.eventTrack(ANALYTICS_CONSTANTS.DOCUMENT_OPERATION, properties);
        });
    };

    /**
     * (Public)
     *
     * Makes a call to analytics to track a Content Stream Event triggered by a user
     *
     * @param eventData
     *
     * eventData = {
     *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
     *      streamType: 'content' || 'hidden' || 'influencer' || 'influencer_source',
     *      parentType: 'dashboard' || 'inbox' || 'search' || 'tag' || 'influencer_search',
     *      inputId: savedSearchId || null,
     *      inputName: savedSearchName || null,
     *      tagName: (only in tags view),
     *      findFilter: optional,
     *      query: {},
     *      rowDisplaySettings: {},
     *      numberOfResultsShown: int
     *      event: 'hide' | 'unhide',
     *      actionLimitReachedFlag: true || false,
     *      inlineSelectAllFlag: true || false,
     *      exportStatus: 'success' || 'failure' || null,
     *      numberOfArticlesSelected: int || null
     * }
     *
     */
    analyticsServiceObj.trackContentStreamEvent = function trackContentStreamEvent(eventData) {
        if (window.location && window.location.href && (window.location.href.indexOf('pdf_layout') > 0 || window.location.href.indexOf('email_layout') > 0)) {
            return null;
        }

        var properties = {},
            sortBy = eventData.query && eventData.query.sortField ? eventData.query.sortField.toLowerCase() : null;

        sortBy = sortBy === 'country' ? 'geo' : sortBy;

        properties[ANALYTICS_CONSTANTS.SOURCE] = mailSources.indexOf(source) !== -1 ? source : ANALYTICS_CONSTANTS.SOURCE_WEBAPP;
        properties[ANALYTICS_CONSTANTS.STREAM_TYPE] = eventData.streamType ? eventData.streamType.toLowerCase() : null;
        properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = eventData.parentType ? eventData.parentType.toLowerCase() : null;
        properties[ANALYTICS_CONSTANTS.INPUT_ID] = eventData.inputId ? eventData.inputId : null;
        properties[ANALYTICS_CONSTANTS.INPUT_NAME] = eventData.inputName ? eventData.inputName.toLowerCase() : null;
        properties[ANALYTICS_CONSTANTS.TAG_NAME] = eventData.parentType === ANALYTICS_CONSTANTS.TAG && eventData.tagName ? eventData.tagName.toLowerCase() : null;
        properties[ANALYTICS_CONSTANTS.FIND_FILTER] = eventData.findFilter ? eventData.findFilter : null;
        properties[ANALYTICS_CONSTANTS.SORT_BY] = sortBy;
        properties[ANALYTICS_CONSTANTS.SORT_DIRECTION] = eventData.query && eventData.query.sortOrder ? eventData.query.sortOrder : null;
        properties[ANALYTICS_CONSTANTS.OPENING_TEXT_FLAG] = eventData.rowDisplaySettings.openingText;
        properties[ANALYTICS_CONSTANTS.HIT_SENTENCE_FLAG] = eventData.rowDisplaySettings.hitSentence;
        properties[ANALYTICS_CONSTANTS.TAG_FLAG] = eventData.rowDisplaySettings.displayTags;
        properties[ANALYTICS_CONSTANTS.IMAGE_FLAG] = eventData.rowDisplaySettings.images;
        properties[ANALYTICS_CONSTANTS.GROUPING] = eventData.rowDisplaySettings && eventData.rowDisplaySettings.groupOption ? eventData.rowDisplaySettings.groupOption : null;
        properties[ANALYTICS_CONSTANTS.START_DATE] = moment(eventData.query.dateStart).format('YYYY-MM-DD');
        properties[ANALYTICS_CONSTANTS.END_DATE] = moment(eventData.query.dateEnd).format('YYYY-MM-DD');
        properties[ANALYTICS_CONSTANTS.NUMBER_OF_RESULTS_SHOWN] = eventData.numberOfResultsShown ? eventData.numberOfResultsShown : null;
        properties[ANALYTICS_CONSTANTS.NUMBER_OF_ARTICLES_SELECTED] = eventData.numberOfArticlesSelected ? eventData.numberOfArticlesSelected : null;

        properties[ANALYTICS_CONSTANTS.LABEL] = eventData.event ? eventData.event.toLowerCase() : null;
        properties[ANALYTICS_CONSTANTS.ACTION_LIMIT_REACHED_FLAG] = eventData.actionLimitReachedFlag ? eventData.actionLimitReachedFlag : null;
        properties[ANALYTICS_CONSTANTS.INLINE_SELECT_ALL_FLAG] = eventData.inlineSelectAllFlag ? eventData.inlineSelectAllFlag : null;
        properties[ANALYTICS_CONSTANTS.SHARE_MECHANISM] = eventData.shareMechanism ? eventData.shareMechanism : null;
        properties[ANALYTICS_CONSTANTS.EXPORT_STATUS] = eventData.exportStatus ? eventData.exportStatus : null;

        $analytics.eventTrack(ANALYTICS_CONSTANTS.CONTENT_STREAM, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics to track ICM Profile Feedback Actions
     *
     * @param eventName
     * @param data
     * @param feedbackData (optional)
     *
     * data = {
     *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
     *      label: 'icm_contact_feedback_started' || 'icm_contact_feedback_completed',
     *      contact_id: Kermit uuid,
     *      user_id: user email (user FH id) user company name
     * }
     *
     * feedbackData = {
     *      type: incorrect_information | request_for_more_info | other
     *      description: optional string
     * }
     */
    analyticsServiceObj.trackFeedbackLoop = function trackFeedbackLoop(eventName, data, feedbackData) {
        var properties = {},
            icmResource = 'contact',
            feedbackTypeProperty,
            feedbackDescProperty,
            thisEvent;

        if (data.label.indexOf('icm_source') > -1) {
            icmResource = 'source';
        }

        if (icmResource === 'contact') {
            thisEvent = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_COMPLETED;
            if (eventName === 'started') {
                thisEvent = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_STARTED;
            }
            feedbackTypeProperty = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_TYPE;
            feedbackDescProperty = ANALYTICS_CONSTANTS.ICM_CONTACT_FEEDBACK_DESC;
        } else {
            thisEvent = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_COMPLETED;
            if (eventName === 'started') {
                thisEvent = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_STARTED;
            }
            feedbackTypeProperty = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_TYPE;
            feedbackDescProperty = ANALYTICS_CONSTANTS.ICM_SOURCE_FEEDBACK_DESC;
        }

        properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
        properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
        properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.userId;
        if (icmResource === 'contact') {
            properties[ANALYTICS_CONSTANTS.ICM_CONTACT_ID] = data.contactId;
        } else {
            properties[ANALYTICS_CONSTANTS.ICM_SOURCE_ID] = data.sourceId;
        }

        if (feedbackData) {
            switch (feedbackData.type) {
                case 'incorrect':
                    properties[feedbackTypeProperty] = 'incorrect_information';
                    break;
                case 'missing':
                    properties[feedbackTypeProperty] = 'request_for_more_info';
                    break;
                case 'missingContact':
                    properties[feedbackTypeProperty] = 'missing_contact';
                    break;
                default:
                    properties[feedbackTypeProperty] = feedbackData.type;
            }

            if (feedbackData.description) {
                properties[feedbackDescProperty] = feedbackData.description;
            }
        }

        $analytics.eventTrack(thisEvent, properties);
    };

    /**
     * (Public)
     *
     * Makes a call to analytics to track ICM Media list Operation Actions
     *
     * @param eventName
     * @param data
     *
     * data = {
     *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
     *      label: 'add_contact' || 'remove_contact' || 'export_contact' || 'outreach_email' || 'import_contact',
     *      media_list_id: media list identifier used by ICM
     *      nbr_of_contacts: Number of contacts included in the action
     *      parent_type: ICM_contact_lists, ICM_import_contacts (used for import_contact only)
     *      sub_type: a child type of the event
     *      user_id: user email (user FH id) user company name
     * }
     */
    analyticsServiceObj.trackMediaListOperation = function trackMediaListOperation(eventName, data) {
        var properties = {},
            thisEvent;

        switch (eventName) {
            case 'add_contact':
                thisEvent = ANALYTICS_CONSTANTS.ICM_ADD_CONTACT;
                break;
            case 'remove_contact':
                thisEvent = ANALYTICS_CONSTANTS.ICM_REMOVE_CONTACT;
                break;
            case 'export_contact':
                thisEvent = ANALYTICS_CONSTANTS.ICM_EXPORT_CONTACT;
                break;
            case 'outreach_email':
                thisEvent = ANALYTICS_CONSTANTS.ICM_OUTREACH_EMAIL;
                break;
            case 'import_contact':
                thisEvent = ANALYTICS_CONSTANTS.ICM_IMPORT_CONTACT;
                break;
            default:
                thisEvent = null;
                break;
        }

        if (thisEvent) {
            properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
            properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
            properties[ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = data.mediaListId;
            properties[ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = data.contactCount;
            properties[ANALYTICS_CONSTANTS.PARENT_TYPE] = data.parentType;
            properties[ANALYTICS_CONSTANTS.SUB_TYPE] = data.subType;
            properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.userId;

            $analytics.eventTrack(thisEvent, properties);
        }
    };

    /**
     * (Public)
     *
     * Makes a call to analytics to track ICM Search Operations
     *
     * @param data
     *
     * data = {
     *      source: 'webapp' || 'iOS' || 'android' || 'mail-digest' || 'mail-dashboard' || 'mail-newsletter' || 'output-newsfeed' || 'mail-notification' || 'mail-last5',
     *      label: 'icm_search',
     *      icm_search_type: 'contact' || 'source' || 'relevantContact' || 'relevantSource'
     *      icm_search_terms: string list of search terms delimited by pipes
     *      icm_search_filter: string list of filters used delimited by pipes
     *      results_nbr: integer of number of contacts returned from the search
     *      from_date: string date for relevant search
     *      to_date: string date for relevant search
     *      user_id: string 'email (userId) companyName'
     * }
     */
    analyticsServiceObj.trackIcmSearchOperation = function trackIcmSearchOperation(data) {
        var properties = {},
            thisEvent = ANALYTICS_CONSTANTS.ICM_SEARCH;

        properties[ANALYTICS_CONSTANTS.SOURCE] = data.source;
        properties[ANALYTICS_CONSTANTS.LABEL] = data.label;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_TYPE] = data.icm_search_type;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_TERMS] = data.icm_search_terms;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_FILTER] = data.icm_search_filter;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_NUMBER_OF_RESULTS] = data.results_nbr;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_START_DATE] = data.from_date;
        properties[ANALYTICS_CONSTANTS.ICM_SEARCH_END_DATE] = data.to_date;
        properties[ANALYTICS_CONSTANTS.ICM_USER_ID] = data.user_id;

        $analytics.eventTrack(thisEvent, properties);
    };

    return analyticsServiceObj;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular, jwtDecode) {
    'use strict';

    var AuthTokenService = function () {
        function AuthTokenService() {
            _classCallCheck(this, AuthTokenService);
        }

        _createClass(AuthTokenService, [{
            key: 'getCookie',
            value: function getCookie(cname) {
                var name = cname + '=';
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) === 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            }
        }, {
            key: 'getDecodedJWT',
            value: function getDecodedJWT() {
                var decodedGydaToken = null,
                    gydaToken = void 0;

                try {
                    gydaToken = JSON.parse(this.getCookie('gydaToken'));
                    decodedGydaToken = jwtDecode(gydaToken.token);
                } catch (e) {} finally {
                    return decodedGydaToken;
                }
            }
        }, {
            key: 'isTokenExpired',
            value: function isTokenExpired() {
                var now = void 0,
                    decodedGydaToken = void 0,
                    isExpired = false;

                try {
                    decodedGydaToken = this.getDecodedJWT();

                    now = new Date().getTime();
                    if (decodedGydaToken === null || decodedGydaToken && decodedGydaToken.exp && decodedGydaToken.exp < now) {
                        isExpired = true;
                    }
                } catch (e) {
                    isExpired = true;
                } finally {
                    return isExpired;
                }
            }
        }]);

        return AuthTokenService;
    }();

    angular.module('MW.influencers.AuthTokenService', []).service('AuthTokenService', [AuthTokenService]);
})(window.angular, window.jwtDecode);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var CloudwatchService = function () {
        function CloudwatchService(CLOUDWATCH_LOGS_REGION, CLOUDWATCH_LOGS_IDENTITY_POOL_ID, CLOUDWATCH_LOG_GROUP_NAME, CLOUDWATCH_LOG_STREAM_NAME, $cookies) {
            _classCallCheck(this, CloudwatchService);

            if (window.AWS) {
                this.AWS = window.AWS;
                this.AWS.config.region = CLOUDWATCH_LOGS_REGION;
                this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
                    IdentityPoolId: CLOUDWATCH_LOGS_IDENTITY_POOL_ID
                });

                this.cloudwatchlogs = new this.AWS.CloudWatchLogs();
                this.cloudwatch = new this.AWS.CloudWatch();
            }

            this.nextSequenceId = null;

            this.logGroupName = CLOUDWATCH_LOG_GROUP_NAME;
            this.logStreamName = CLOUDWATCH_LOG_STREAM_NAME;

            this.createLogGroup = true;
            this.createLogStream = true;

            this.$cookies = $cookies;
            this.companyId = null;
            this.companyName = null;
            this.userId = null;
            this.userEmail = null;

            this.LOG_MESSAGES_TO_CAPTURE_DURING_TIMEOUT = 100;
            this.SET_TIMEOUT_MILLISECONDS = 5000;
            this.logEvents = [];
            this.currentTimeout = null;

            this._extractUserCompanyFromToken();
        }

        /* jshint ignore:start */


        _createClass(CloudwatchService, [{
            key: '_extractUserCompanyFromToken',
            value: function _extractUserCompanyFromToken() {
                var gydaTokenCookie = this.$cookies.get('gydaToken');
                if (gydaTokenCookie && window.jwt_decode) {
                    var gydaTokenObject = JSON.parse(gydaTokenCookie);
                    var gydaTokenString = gydaTokenObject.token;
                    var decodedGydaToken = window.jwt_decode(gydaTokenString);
                    if (decodedGydaToken.company) {
                        this.companyId = decodedGydaToken.company._id;
                        this.companyName = decodedGydaToken.company.name;
                    }

                    if (decodedGydaToken.user) {
                        this.userId = decodedGydaToken.user._id;
                        this.userEmail = decodedGydaToken.user.email;
                    }
                }
            }
            /* jshint ignore:end */

        }, {
            key: 'sendLogsToCloudwatch',
            value: function sendLogsToCloudwatch(logMessage, logStack) {
                var _this = this;

                // bail if AWS was not successfully loaded
                if (!this.AWS) {
                    return;
                }

                var logObject = {
                    browser: window.navigator.userAgent,
                    url: window.location.href,
                    language: window.navigator.language,
                    message: logMessage,
                    stack: logStack,
                    fhAccountInfo: {
                        company: {
                            id: this.companyId,
                            name: this.companyName
                        },
                        user: {
                            id: this.userId,
                            email: this.userEmail
                        }
                    }
                };

                var logEvent = {
                    message: JSON.stringify(logObject),
                    timestamp: Date.now()
                };

                // we will only capture N messages within our timeout interval.
                // we feel this sample will still give us a great indication of something gone wrong, while not overwhelming the API
                // initially set this to 100 messages in 5 seconds, which seems like it would be a total failure to hit this limit anyways
                if (this.logEvents.length <= this.LOG_MESSAGES_TO_CAPTURE_DURING_TIMEOUT) {
                    this.logEvents.push(logEvent);
                }

                // we want to bundle up the log messages every SET_TIMEOUT_MILLISECONDS
                // so that we hit the API less, and also to synchronize the sequential IDs needed for cloudwatch
                clearTimeout(this.currentTimeout);
                this.currentTimeout = setTimeout(function () {
                    var logEventsToPush = angular.copy(_this.logEvents);
                    _this.logEvents = [];

                    _this._putLogEvents(logEventsToPush);
                }, this.SET_TIMEOUT_MILLISECONDS);
            }
        }, {
            key: '_putLogEvents',
            value: function _putLogEvents(logEventsToPush) {
                var _this2 = this;

                var parameters = {
                    logEvents: logEventsToPush,
                    logGroupName: this.logGroupName,
                    logStreamName: this.logStreamName
                };

                this._createLogGroup().then(this._createLogStream.bind(this)).then(this._getNextSequenceToken.bind(this)).then(function (nextSequenceId) {
                    parameters.sequenceToken = nextSequenceId;

                    _this2.cloudwatchlogs.putLogEvents(parameters, function (error) {
                        if (error) {
                            console.error('putLogEvents error', error);
                        }
                    });
                });
            }
        }, {
            key: '_createLogGroup',
            value: function _createLogGroup() {
                var _this3 = this;

                // if this has already been created, don't bother trying to recreate it
                if (!this.createLogGroup) {
                    return Promise.resolve();
                }

                var parameters = {
                    logGroupName: this.logGroupName
                };

                return new Promise(function (resolve, reject) {
                    _this3.cloudwatchlogs.createLogGroup(parameters, function (error, data) {
                        if (error) {
                            // fail silently if we have already created this log group
                            if (error.code === 'ResourceAlreadyExistsException') {
                                _this3.createLogGroup = false;
                                resolve();
                            } else {
                                console.error('_createLogGroup error', error);
                                _this3.createLogGroup = true;
                                reject(error);
                            }
                        } else {
                            _this3.createLogGroup = false;
                            resolve(data);
                        }
                    });
                });
            }
        }, {
            key: '_createLogStream',
            value: function _createLogStream() {
                var _this4 = this;

                // if this has already been created, don't bother trying to recreate it
                if (!this.createLogStream) {
                    return Promise.resolve();
                }

                var parameters = {
                    logGroupName: this.logGroupName,
                    logStreamName: this.logStreamName
                };

                return new Promise(function (resolve, reject) {
                    _this4.cloudwatchlogs.createLogStream(parameters, function (error, data) {
                        if (error) {
                            // fail silently if we have already created this log group
                            if (error.code === 'ResourceAlreadyExistsException') {
                                _this4.createLogStream = false;
                                resolve();
                            } else {
                                console.error('_createLogStream error', error);
                                _this4.createLogStream = true;
                                reject(error);
                            }
                        } else {
                            _this4.createLogStream = false;
                            resolve(data);
                        }
                    });
                });
            }
        }, {
            key: '_getNextSequenceToken',
            value: function _getNextSequenceToken() {
                var _this5 = this;

                var nextSequenceId = null;

                return this._describeLogStreams().then(function (results) {
                    if (results.logStreams) {
                        results.logStreams.some(function (logStream) {
                            if (logStream.logStreamName === _this5.logStreamName) {
                                nextSequenceId = logStream.uploadSequenceToken;
                                return true;
                            }
                        });
                    }

                    return nextSequenceId;
                });
            }
        }, {
            key: '_describeLogStreams',
            value: function _describeLogStreams() {
                var _this6 = this;

                var parameters = {
                    logGroupName: this.logGroupName,
                    logStreamNamePrefix: this.logStreamName
                };

                return new Promise(function (resolve, reject) {
                    _this6.cloudwatchlogs.describeLogStreams(parameters, function (error, data) {
                        if (error) {
                            console.error('describeLogStreams error', error);
                            reject(error);
                        } else {
                            resolve(data);
                        }
                    });
                });
            }
        }]);

        return CloudwatchService;
    }();

    angular.module('MW.Influencers.CloudwatchService', ['Configuration']).service('CloudwatchService', ['CLOUDWATCH_LOGS_REGION', 'CLOUDWATCH_LOGS_IDENTITY_POOL_ID', 'CLOUDWATCH_LOG_GROUP_NAME', 'CLOUDWATCH_LOG_STREAM_NAME', '$cookies', CloudwatchService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailAnalyticsService = function () {
    function EmailAnalyticsService($q, $http, ICM_EMAIL_API_URL) {
        _classCallCheck(this, EmailAnalyticsService);

        this.$q = $q;
        this.$http = $http;

        this.aggregationUrl = ICM_EMAIL_API_URL + '/engagement/aggregation';
        this.analyticsUrl = ICM_EMAIL_API_URL + '/analytics';
    }

    _createClass(EmailAnalyticsService, [{
        key: 'getCompanyAggregations',
        value: function getCompanyAggregations() {
            return this.$http.get(this.aggregationUrl).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'getMediaListAggregations',
        value: function getMediaListAggregations(mediaListId) {
            return this.getMediaListsAggregations([mediaListId]).then(function (response) {
                return response[mediaListId];
            });
        }
    }, {
        key: 'getMediaListsAggregations',
        value: function getMediaListsAggregations(mediaListIds) {
            var payload = {
                mediaListIds: mediaListIds
            };

            return this.$http.post(this.aggregationUrl + '/mediaLists', payload).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'getStatsCount',
        value: function getStatsCount(distributionId, statisticsType) {
            return this.$http.get(this.analyticsUrl + '/distributions/' + distributionId + '/' + statisticsType + '/count').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'getStatsContacts',
        value: function getStatsContacts(distributionId, statisticsType, subType) {
            var query = {
                page: 0,
                pageSize: 25,
                stat: subType ? subType : 'all'
            };
            return this.$http.post(this.analyticsUrl + '/distributions/' + distributionId + '/' + statisticsType + '/recipients', query).then(function (response) {
                return response.data;
            }).catch(function () {
                return [];
            });
        }
    }]);

    return EmailAnalyticsService;
}();

angular.module('MW.Influencers.EmailAnalyticsService', ['Configuration']).service('EmailAnalyticsService', ['$q', '$http', 'ICM_EMAIL_API_URL', EmailAnalyticsService]);
'use strict';

angular.module('MW.Framework.ICMEmailService', ['Configuration']).service('ICMEmailService', ['$q', '$http', 'EMAIL_DOMAIN', function ($q, $http, EMAIL_DOMAIN) {

    var emailServiceObj = {},
        contactRecipients = [],
        contactRecipientsQuery = {},
        mediaListRecipients = [];

    emailServiceObj.sender = {};
    function setSender(senderObject) {
        emailServiceObj.sender = senderObject;
    }
    function getSender() {
        return emailServiceObj.sender;
    }

    function resetRecipients() {
        contactRecipients = [];
        mediaListRecipients = [];
        contactRecipientsQuery = {};
    }

    function setContactRecipients(contacts) {
        contactRecipients = contacts.map(function (contact) {
            var email;
            var primary = contact.contactInfo.email.sort(function (a, b) {
                if (a.overlayMetadata && b.overlayMetadata || !a.overlayMetadata && !b.overlayMetadata) {
                    if (!a.primary && b.primary) {
                        return 1;
                    } else if (a.primary && !b.primary) {
                        return -1;
                    }
                } else if (!a.overlayMetadata && b.overlayMetadata) {
                    return 1;
                } else if (a.overlayMetadata && !b.overlayMetadata) {
                    return -1;
                }
                return 0;
            });
            email = primary[0];
            return {
                id: contact.id,
                name: contact.name.fullName,
                firstName: contact.name.firstName,
                lastName: contact.name.lastName,
                email: email ? email.address : '',
                private: contact.systemData.policies ? contact.systemData.policies.storage.private : true
            };
        });
    }

    function getContactRecipients() {
        return contactRecipients;
    }

    function setContactRecipientsQuery(query) {
        contactRecipientsQuery = {
            mediaListIds: query.mediaListIds,
            q: query.q,
            pageSize: query.pageSize
        };
    }

    function getContactRecipientsQuery() {
        return contactRecipientsQuery;
    }

    function setMediaListRecipients(mediaLists) {
        mediaListRecipients = mediaLists.map(function (mediaList) {
            return {
                id: mediaList.id,
                name: mediaList.name
            };
        });
    }

    function getMediaListRecipients() {
        return mediaListRecipients;
    }

    function getIcmApprovedSenders() {
        var defer = $q.defer(),
            config = {
            headers: {
                'X-Client-Name': 'icm-web'
            }
        };

        $http.get(EMAIL_DOMAIN + '/email/approvedSender?getCombinedStatus=false', config).then(function (response) {
            var senders = response.data;
            if (Array.isArray(senders) && senders.length) {
                var isApproved = senders.filter(function (sender) {
                    return sender.is_approved;
                });
                defer.resolve(isApproved);
            } else {
                defer.resolve([]);
            }
        }).catch(function () {
            defer.reject();
        });
        return defer.promise;
    }

    return {
        setSender: setSender,
        getSender: getSender,
        resetRecipients: resetRecipients,
        setContactRecipients: setContactRecipients,
        getContactRecipients: getContactRecipients,
        setContactRecipientsQuery: setContactRecipientsQuery,
        getContactRecipientsQuery: getContactRecipientsQuery,
        setMediaListRecipients: setMediaListRecipients,
        getMediaListRecipients: getMediaListRecipients,
        getIcmApprovedSenders: getIcmApprovedSenders
    };
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailTemplateService = function () {
    function EmailTemplateService($http, ICM_EMAIL_TEMPLATE_SERVICE_URL) {
        var _this = this;

        _classCallCheck(this, EmailTemplateService);

        this.$http = $http;

        this.ICM_EMAIL_TEMPLATE_SERVICE_URL = ICM_EMAIL_TEMPLATE_SERVICE_URL;
        // we hold the templates here so we can communicate between the modal/other services and the table we also have to keep track of loading/empty states this way
        this.templates = [];
        // isLoadingTemplates for the empty state
        this.isLoadingTemplates = false;
        // loadingTemplatesPromise is for the table loader
        this.loadingTemplatesPromise = '';
        //call a functions to return things because you won't get updated values just referencing the variable (feel free to retest this though!)
        this.getIsLoadingTemplates = function () {
            return _this.isLoadingTemplates;
        };
        this.getIsLoadingTemplatesPromise = function () {
            return _this.loadingTemplatesPromise;
        };
        this.getTemplates = function () {
            return _this.templates;
        };
    }

    _createClass(EmailTemplateService, [{
        key: 'createTemplate',
        value: function createTemplate(templateName, templateBody) {
            var payload = {
                templateName: templateName || null,
                templateBody: templateBody || null
            };
            var url = this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates';

            return this.$http.post(url, payload);
        }
    }, {
        key: 'updateTemplate',
        value: function updateTemplate(templateId, templateName, templateBody) {
            var payload = {
                templateName: templateName,
                templateBody: templateBody
            };

            return this.$http.put(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + templateId, payload);
        }
    }, {
        key: 'getAllTemplatesByCompany',
        value: function getAllTemplatesByCompany() {
            var _this2 = this;

            this.isLoadingTemplates = true;
            this.loadingTemplatesPromise = new Promise(function (resolve, reject) {
                _this2.getAllTemplates().then(function (response) {
                    _this2.templates = _this2.populateTemplateList(response.data.templates);
                    _this2.isLoadingTemplates = false;
                    resolve();
                }).catch(function (error) {
                    _this2.isLoadingTemplates = false;
                    reject(error);
                });
            });
            return this.loadingTemplatesPromise;
        }
    }, {
        key: 'getAllTemplates',
        value: function getAllTemplates() {
            return this.$http.get(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates');
        }
    }, {
        key: 'populateTemplateList',
        value: function populateTemplateList(templateList) {
            return templateList.map(function (template) {
                return {
                    id: template.id,
                    title: template.name,
                    createdOn: template.created_at,
                    createdBy: template.created_by_first_name + ' ' + template.created_by_last_name,
                    updatedOn: template.updated_at,
                    lastSent: template.last_sent_at
                };
            });
        }
    }, {
        key: 'getTemplateById',
        value: function getTemplateById(id) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                _this3.$http.get(_this3.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + id).then(function (response) {
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }, {
        key: 'populateTemplate',
        value: function populateTemplate(data) {
            return {
                id: data.id,
                title: data.name,
                body: data.body
            };
        }
    }, {
        key: 'deleteTemplateById',
        value: function deleteTemplateById(id) {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                _this4.$http.delete(_this4.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + id).then(function (response) {
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }, {
        key: 'deleteTemplateByIds',
        value: function deleteTemplateByIds(templateIds) {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                _this5.$http.post(_this5.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/bulkDelete', { templateIds: templateIds }).then(function (response) {
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }]);

    return EmailTemplateService;
}();

angular.module('MW.Influencers.EmailTemplateService', ['Configuration']).service('EmailTemplateService', ['$http', 'ICM_EMAIL_TEMPLATE_SERVICE_URL', EmailTemplateService]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var FeedbackRequestDialogService = function () {
        function FeedbackRequestDialogService($mdDialog, $translate) {
            _classCallCheck(this, FeedbackRequestDialogService);

            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.feedbackDescription = '';
        }

        _createClass(FeedbackRequestDialogService, [{
            key: 'feedbackRequstController',
            value: function feedbackRequstController() {
                this.requestPending = false;
                this.requestSuccess = false;
                this.requestModalHeader = this.$translate.instant('icm-web__profile-feedback--request-research-modal-header', {
                    contactName: this.contactName
                });

                this.submitFeedback = function () {
                    var payload = this.getContactPayload();
                    this.requestPending = true;
                    this.requestRejected = false;

                    this.InfluencerContactService.submitFeedback(payload).then(function onSuccess() {
                        this.requestPending = false;
                        this.requestSuccess = true;
                    }.bind(this)).catch(function onError() {
                        this.feedbackSubmissionError();
                    }.bind(this)).finally(function afterAll() {
                        this.trackContactFeedbackCompleted();
                    }.bind(this));
                };

                this.getContactPayload = function getContactPayload() {
                    var payload = {
                        update_request: {
                            type: 'other',
                            // contact being updated
                            resource_uuid: this.contact.id,
                            // company doing the update
                            company_name: this.currentCompany.name,
                            company_id: this.currentCompany._id,
                            account_id: this.currentCompany.accountId,
                            opportunity_id: this.currentCompany.opportunityId,

                            // user doing the update
                            customer_email: this.currentUser.email,
                            user_id: this.currentUser._id,
                            language: this.currentUser.language
                        }
                    };

                    if (this.feedbackDescription.length > 0) {
                        payload.update_request.description = this.feedbackDescription;
                    }

                    return payload;
                };

                this.trackContactFeedbackCompleted = function trackContactFeedbackCompleted() {
                    var data = {
                        source: 'webapp',
                        label: 'icm_contact_feedback_completed',
                        contactId: this.contact.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                        feedbackData = {
                        type: 'incorrect',
                        description: this.feedbackDescription || 'No description'
                    };
                    this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
                }.bind(this);

                this.feedbackSubmissionError = function feedbackSubmissionError() {
                    this.errorMessage = this.$translate.instant('icm-web__profile-feedback--error-text');
                    this.requestPending = false;
                    this.requestRejected = true;
                }.bind(this);
            }
        }, {
            key: 'showRequestDialog',
            value: function showRequestDialog(vars) {
                this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                    locals: vars,
                    controller: this.feedbackRequstController,
                    templateUrl: 'icm-web/views/feedback_request_modal',
                    controllerAs: '$ctrl'
                }));
            }
        }]);

        return FeedbackRequestDialogService;
    }();

    angular.module('MW.Influencers.FeedbackRequestDialogService', ['ngMaterial', 'ngMessages', 'mwAppComponents']).service('FeedbackRequestDialogService', ['$mdDialog', '$translate', FeedbackRequestDialogService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var FeedbackService = function () {
        function FeedbackService(InfluencerContactService, AnalyticsService, CoreCompanyService, CoreUserService, $q, $mdDialog, $translate, FeedbackRequestDialogService, FeedbackShareDialogService, VALIDATION_CONSTANTS) {
            var _this2 = this;

            _classCallCheck(this, FeedbackService);

            this.InfluencerContactService = InfluencerContactService;
            this.AnalyticsService = AnalyticsService;
            this.CoreCompanyService = CoreCompanyService;
            this.CoreUserService = CoreUserService;
            this.$q = $q;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.shouldValidateForm = false;
            this.FeedbackRequestDialogService = FeedbackRequestDialogService;
            this.FeedbackShareDialogService = FeedbackShareDialogService;
            this.VALIDATION_CONSTANTS = VALIDATION_CONSTANTS;
            this.validCountries = ['United States', 'United Kingdom', 'Canada', 'Australia', 'New Zealand', 'Germany', 'Switzerland', 'Sweden', 'Denmark', 'Netherlands', 'Austria', 'Finland', 'Norway', 'Ireland', 'Malaysia', 'Singapore', 'India', 'France', 'Belgium', 'UAE', 'South Africa', 'Kenya', 'Qatar', 'Saudi Arabia', 'Hong Kong SAR China', 'Liechtenstein', 'Mexico', 'Brazil', 'Mainland China', 'Puerto Rico', 'Guam', 'American Samoa', 'Micronesia', 'Marshall Islands', 'Palau', 'Northern Mariana Islands', 'U.S. Virgin Islands', 'Guadeloupe', 'Guyana', 'Reunion', 'Martinique', 'Mayotte', 'Aland Islands', 'Greenland', 'Faroe Islands'];
            this.initializeCountries();
            var promises = [];

            promises.push(this.CoreUserService.getCurrent(true));
            promises.push(this.CoreCompanyService.getCurrent(true));

            this.$q.all(promises).then(function (responses) {
                _this2.currentUser = responses[0];
                _this2.currentCompany = responses[1];
            });
        }

        _createClass(FeedbackService, [{
            key: 'initializeContact',
            value: function initializeContact(contact) {
                this.contact = contact;
                this.type = 'contact';
            }
        }, {
            key: 'initializeSource',
            value: function initializeSource(source) {
                this.source = source;
                this.type = 'source';
            }
        }, {
            key: 'initializeMissingSource',
            value: function initializeMissingSource() {
                this.type = 'missing_source';
            }
        }, {
            key: 'initializeMissingContact',
            value: function initializeMissingContact() {
                this.type = 'missing_contact';
            }
        }, {
            key: 'initializeCountries',
            value: function initializeCountries() {
                this.countries = [];
                for (var i = 0; i < this.validCountries.length; i++) {
                    if (this.validCountries[i] === 'UAE') {
                        this.countries.push({
                            name: this.$translate.instant('icm-search__filter--united-arab-emirates'),
                            value: this.validCountries[i]
                        });
                    } else {
                        var localizedString = 'icm-search__filter--' + this.validCountries[i].toLowerCase().replace(/ /g, '-');
                        this.countries.push({
                            name: this.$translate.instant(localizedString),
                            value: this.validCountries[i]
                        });
                    }
                }
                this.countries = _.sortBy(this.countries, 'name');
            }

            // starting tracking functions

        }, {
            key: 'trackFeedbackStarted',
            value: function trackFeedbackStarted() {
                switch (this.type) {
                    case 'source':
                        this.trackSourceFeedbackStarted();
                        break;
                    case 'missing_contact':
                        this.trackMissingContactFeedbackStarted();
                        break;
                }
            }
        }, {
            key: 'trackSourceFeedbackStarted',
            value: function trackSourceFeedbackStarted() {
                var data = {
                    source: 'webapp',
                    label: 'icm_source_feedback_started',
                    sourceId: this.source.id,
                    userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                };
                this.AnalyticsService.trackFeedbackLoop('started', data);
            }
        }, {
            key: 'trackMissingContactFeedbackStarted',
            value: function trackMissingContactFeedbackStarted() {
                var data = {
                    source: 'webapp',
                    label: 'icm_missing_contact_feedback_started',
                    userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                };
                this.AnalyticsService.trackFeedbackLoop('started', data);
            }
        }, {
            key: 'FeedbackModalController',
            value: function FeedbackModalController() {
                this.requestPending = false;
                this.requestSuccess = false;
                this.requestRejected = false;
                this.showContactForm = false;
                this.feedbackType = 'share';
                this.errorMessage = '';
                this.selectedReason = 'incorrect';
                this.feedbackDescription = '';
                this.sourceCountry = '';

                // validation rules to mirror Haven's Scooter API validation
                this.SOURCE_NAME_MAX_CHAR = 255;
                this.EMAIL_REGEX = this.VALIDATION_CONSTANTS.EMAIL_REGEX;
                this.URL_REGEX = this.VALIDATION_CONSTANTS.URL_REGEX;

                this.toggleContactForm = function toggleContactForm() {
                    this.showContactForm = this.selectedReason === 'missingContact';
                };

                this.nextModal = function () {
                    this.$mdDialog.hide();
                    var miniModalVars = {
                        backToMainModal: this.backToMainModal,
                        $mdDialog: this.$mdDialog,
                        $translate: this.$translate,
                        contactName: this.contactName,
                        nextModal: this.nextModal,
                        feedbackType: this.feedbackType,
                        FeedbackRequestDialogService: this.FeedbackRequestDialogService,
                        FeedbackShareDialogService: this.FeedbackShareDialogService,
                        InfluencerContactService: this.InfluencerContactService,
                        AnalyticsService: this.AnalyticsService,
                        currentCompany: this.currentCompany,
                        currentUser: this.currentUser,
                        contact: this.contact,
                        headerTranslation: this.headerTranslation
                    };

                    if (this.feedbackType === 'share') {
                        this.FeedbackShareDialogService.showShareDialog(miniModalVars);
                    } else if (this.feedbackType === 'request') {
                        this.FeedbackRequestDialogService.showRequestDialog(miniModalVars);
                    }
                };

                this.backToMainModal = function (vars) {
                    this.$mdDialog.hide();
                    var miniModalVars = {
                        InfluencerContactService: this.InfluencerContactService,
                        AnalyticsService: this.AnalyticsService,
                        $mdDialog: this.$mdDialog,
                        $translate: this.$translate,
                        currentUser: this.currentUser,
                        currentCompany: this.currentCompany,
                        contact: this.contact,
                        contactName: this.contactName,
                        countries: this.countries,
                        FeedbackRequestDialogService: this.FeedbackRequestDialogService,
                        FeedbackShareDialogService: this.FeedbackShareDialogService,
                        type: this.type,
                        feedbackType: this.feedbackType,
                        headerTranslation: this.headerTranslation
                    };

                    this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                        locals: miniModalVars,
                        controller: function controller() {
                            this.nextModal = vars.nextModal;
                            this.$mdDialog = vars.$mdDialog;
                            this.backToMainModal = vars.backToMainModal;
                        },
                        templateUrl: 'icm-web/views/feedback_modal',
                        controllerAs: '$ctrl'
                    }));
                };

                this.okModal = function () {
                    if (this.type === 'source' && this.selectedReason === 'missingContact') {
                        if (!this.feedbackForm.$valid) {
                            this.shouldValidateForm = true;
                            this.errorMessage = this.$translate.instant('icm-web__profile-feedback--form-error');
                        } else {
                            this.shouldValidateForm = false;
                            this.submitFeedback();
                        }
                    } else if (!this.feedbackForm.$valid) {
                        this.shouldValidateForm = true;
                        this.errorMessage = this.$translate.instant('icm-web__profile-feedback--form-error');
                    } else {
                        this.shouldValidateForm = false;
                        this.submitFeedback();
                    }
                };

                this.submitFeedback = function submitFeedback() {
                    var feedbackFunction;
                    if (this.type === 'missing_contact') {
                        feedbackFunction = this.CreateContactFeedback;
                    } else if (this.type === 'missing_source') {
                        feedbackFunction = this.CreateSourceFeedback;
                    }

                    var payload = this.getPayload();
                    this.requestPending = true;

                    feedbackFunction(payload).then(function onSuccess() {
                        this.feedbackSubmissionSuccess();
                    }.bind(this)).catch(function onError() {
                        this.feedbackSubmissionError();
                    }.bind(this)).finally(function afterAll() {
                        this.trackFeedbackCompleted();
                    }.bind(this));
                };

                this.CreateContactFeedback = function CreateContactFeedback(payload) {
                    return this.InfluencerContactService.submitContactCreateFeedback(payload);
                }.bind(this);

                this.CreateSourceFeedback = function CreateSourceFeedback(payload) {
                    return this.InfluencerContactService.submitSourceCreateFeedback(payload);
                }.bind(this);

                this.feedbackSubmissionError = function feedbackSubmissionError() {
                    this.errorMessage = this.$translate.instant('icm-web__profile-feedback--error-text');
                    this.requestPending = false;
                    this.requestRejected = true;
                }.bind(this);

                this.feedbackSubmissionSuccess = function feedbackSubmissionSuccess() {
                    this.requestPending = false;
                    this.requestSuccess = true;
                }.bind(this);

                // completed tracking functions
                this.trackFeedbackCompleted = function trackFeedbackCompleted() {
                    switch (this.type) {
                        case 'source':
                            this.trackSourceFeedbackCompleted();
                            break;
                        case 'missing_contact':
                            this.trackMissingContactFeedbackCompleted();
                            break;
                    }
                };

                this.trackSourceFeedbackCompleted = function trackSourceFeedbackCompleted() {
                    var data = {
                        source: 'webapp',
                        label: 'icm_source_feedback_completed',
                        sourceId: this.source.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                        feedbackData = {
                        type: this.selectedReason,
                        description: this.feedbackDescription || 'No description'
                    };
                    this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
                }.bind(this);

                this.trackMissingContactFeedbackCompleted = function trackMissingContactFeedbackCompleted() {
                    var data = {
                        source: 'webapp',
                        label: 'icm_missing_contact_feedback_completed',
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                        feedbackData = {
                        type: this.selectedReason,
                        description: this.feedbackDescription || 'No description'
                    };
                    this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
                }.bind(this);

                // payload functions
                this.getPayload = function getPayload() {
                    if (this.type === 'source' || this.type === 'missing_source') {
                        return this.getSourcePayload();
                    } else if (this.type === 'missing_contact') {
                        return this.getMissingContactPayload();
                    }
                };

                this.getSourcePayload = function getSourcePayload() {
                    var payload = void 0;

                    payload = {
                        companyId: this.currentCompany._id,
                        userId: this.currentUser._id,
                        companyName: this.currentCompany.name,
                        opportunityId: this.currentCompany.opportunityId,
                        customerEmail: this.currentUser.email,
                        sourceName: this.sourceName,
                        sourceUrl: this.sourceUrl,
                        sourceCountry: this.country,
                        language: this.currentUser.language
                    };

                    if (this.feedbackDescription.length > 0) {
                        payload.description = this.feedbackDescription;
                    }
                    return payload;
                };

                this.getMissingContactPayload = function getMissingContactPayload() {
                    var payload = {
                        resourceType: 'Contact',

                        firstName: this.firstName,
                        lastName: this.lastName,
                        resourceCountry: this.country,
                        newResourceEmail: this.emailAddress,
                        newResourceSourceName: this.sourceName,

                        // company doing the update
                        companyName: this.currentCompany.name,
                        companyId: this.currentCompany._id,
                        accountId: this.currentCompany.accountId,
                        opportunityId: this.currentCompany.opportunityId,

                        // user doing the update
                        customerEmail: this.currentUser.email,
                        userId: this.currentUser._id,
                        language: this.currentUser.language
                    };
                    if (this.feedbackDescription.length > 0) {
                        // source of contact
                        payload.description = this.feedbackDescription;
                    }
                    return payload;
                };
                /* jshint ignore:end */
            }
        }, {
            key: 'showFeedbackModal',
            value: function showFeedbackModal(name) {
                var _this = this,
                    miniModalVars = {
                    InfluencerContactService: _this.InfluencerContactService,
                    AnalyticsService: _this.AnalyticsService,
                    FeedbackRequestDialogService: _this.FeedbackRequestDialogService,
                    FeedbackShareDialogService: _this.FeedbackShareDialogService,
                    VALIDATION_CONSTANTS: _this.VALIDATION_CONSTANTS,
                    $mdDialog: _this.$mdDialog,
                    $translate: _this.$translate,
                    currentUser: _this.currentUser,
                    currentCompany: _this.currentCompany,
                    countries: _this.countries,
                    type: _this.type
                },
                    template;

                if (_this.type === 'contact') {
                    miniModalVars.contact = _this.contact;
                    miniModalVars.contactName = name.firstName + ' ' + (name.middleName ? name.middleName + ' ' : '') + name.lastName;
                    miniModalVars.headerTranslation = _this.$translate.instant('icm-web__profile-feedback--header', {
                        contactName: miniModalVars.contactName
                    });
                    template = 'icm-web/views/feedback_modal';
                } else if (_this.type === 'source') {
                    miniModalVars.source = _this.source;
                    template = 'icm-web/views/source_feedback_modal';
                } else if (_this.type === 'missing_contact') {
                    template = 'icm-web/views/missing_contact_feedback_modal';
                } else if (_this.type === 'missing_source') {
                    template = 'icm-web/views/missing_source_feedback_modal';
                }

                _this.trackFeedbackStarted(_this.type);
                _this.$mdDialog.show(_this.$mdDialog.mwMiniModal({
                    locals: miniModalVars,
                    controller: _this.FeedbackModalController,
                    templateUrl: template,
                    controllerAs: '$ctrl'
                }));
            }
        }]);

        return FeedbackService;
    }();

    angular.module('MW.Influencers.FeedbackService', ['MW.Framework.InfluencerContactService', 'MW.Influencers.AnalyticsService', 'MW.Framework.CoreCompanyService', 'MW.Framework.CoreUserService', 'ngMaterial', 'ngMessages', 'mwAppComponents', 'MW.Influencers.FeedbackRequestDialogService', 'MW.Influencers.FeedbackShareDialogService', 'MW.Framework.ValidationConstants']).service('FeedbackService', ['InfluencerContactService', 'AnalyticsService', 'CoreCompanyService', 'CoreUserService', '$q', '$mdDialog', '$translate', 'FeedbackRequestDialogService', 'FeedbackShareDialogService', 'VALIDATION_CONSTANTS', FeedbackService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var FeedbackShareDialogService = function () {
        function FeedbackShareDialogService($mdDialog, $translate) {
            _classCallCheck(this, FeedbackShareDialogService);

            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
        }

        _createClass(FeedbackShareDialogService, [{
            key: 'feedbackRequstController',
            value: function feedbackRequstController() {
                this.requestPending = false;
                this.requestSuccess = false;
                this.emailRegex = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[\w-]+(?:\.[\w-]{1,64})+$/;
                this.SOURCE_NAME_MAX_CHAR = 255;
                this.invalidForm = false;
                this.shareModalHeader = this.$translate.instant('icm-web__profile-feedback--send-updates-modal-header', {
                    contactName: this.contactName
                });

                this.submitFeedback = function () {
                    this.invalidForm = false;
                    if (!this.feedbackForm.$valid) {
                        this.invalidForm = true;
                        this.errorMessage = this.$translate.instant('icm-web__profile-feedback--update-error-message');
                    } else if (this.feedbackForm.$dirty && (this.sourceName || this.email || this.feedbackDescription)) {
                        var payload = this.getContactPayload();
                        this.requestPending = true;
                        this.requestRejected = false;
                        this.InfluencerContactService.submitFeedback(payload).then(function onSuccess() {
                            this.requestPending = false;
                            this.requestSuccess = true;
                        }.bind(this)).catch(function onError() {
                            this.errorMessage = this.$translate.instant('icm-web__profile-feedback--update-error-message');
                            this.requestPending = false;
                            this.requestRejected = true;
                        }.bind(this)).finally(function afterAll() {
                            this.trackContactFeedbackCompleted();
                        }.bind(this));
                    }
                };

                this.getContactPayload = function getContactPayload() {
                    var payload = {
                        update_request: {
                            type: 'incorrect',
                            // contact being updated
                            resource_uuid: this.contact.id,
                            // company doing the update
                            company_name: this.currentCompany.name,
                            company_id: this.currentCompany._id,
                            account_id: this.currentCompany.accountId,
                            opportunity_id: this.currentCompany.opportunityId,
                            // user doing the update
                            customer_email: this.currentUser.email,
                            user_id: this.currentUser._id,
                            language: this.currentUser.language
                        }
                    };

                    if (this.email) {
                        payload.update_request.new_resource_email = this.email;
                    }
                    if (this.sourceName) {
                        payload.update_request.new_resource_source_name = this.sourceName;
                    }
                    if (this.feedbackDescription) {
                        payload.update_request.description = this.feedbackDescription;
                    }
                    return payload;
                };

                this.trackContactFeedbackCompleted = function trackContactFeedbackCompleted() {
                    var data = {
                        source: 'webapp',
                        label: 'icm_contact_feedback_completed',
                        emailRegex: this.emailRegex,
                        contactId: this.contact.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                        feedbackData = {
                        type: 'incorrect',
                        description: this.feedbackDescription || 'No description'
                    };
                    this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
                }.bind(this);
            }
        }, {
            key: 'showShareDialog',
            value: function showShareDialog(vars) {
                this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                    locals: vars,
                    controller: this.feedbackRequstController,
                    templateUrl: 'icm-web/views/feedback_share_modal',
                    controllerAs: '$ctrl'
                }));
            }
        }]);

        return FeedbackShareDialogService;
    }();

    angular.module('MW.Influencers.FeedbackShareDialogService', ['ngMaterial', 'ngMessages', 'mwAppComponents']).service('FeedbackShareDialogService', ['$mdDialog', '$translate', FeedbackShareDialogService]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('MW.Influencers.FilterFactory', ['ngMaterial', 'mwAppComponents', 'MW.ContactManager.SelectionFactory']).factory('FilterFactory', ['$mdDialog', '$filter', '$translate', '$q', 'FilterSelectionFactory', function ($mdDialog, $filter, $translate, $q, FilterSelectionFactory) {
        function FilterFactory(name, triggerSearchFunction) {
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;

            this.filterName = name;
            this.currentOptions = [];

            this.callback = triggerSearchFunction;

            this.selectionFactory = new FilterSelectionFactory(name);
            this.searchInProgress = null;
        }

        FilterFactory.prototype.showModal = function showModal(event) {
            this.selectionFactory.snapshotState();

            // this = mwModal
            function MiniModalController() {

                if (this.searchInProgress) {
                    this.loading = true;
                    this.filteredOptions = [];
                    this.searchInProgress.promise.then(function (results) {
                        this.filteredOptions = results;
                        this.loading = false;
                    }.bind(this));
                } else {
                    this.filteredOptions = this.SelectionFactory.currentOptions;
                }

                if (this.filterName === 'icm-search__location-filter--title') {
                    // skip the country page if there is only 1 country entitlement
                    if (this.filteredOptions.length === 1) {
                        this.SelectionFactory.openChild(this.filteredOptions[0]);
                        this.filterName = this.filteredOptions[0].display;
                        this.filteredOptions = this.filteredOptions[0].children;
                        this.SelectionFactory.parent.name = null;
                    }
                }

                this.hasChildren = this.SelectionFactory.parent && this.SelectionFactory.parent.children.length ? true : false;
                this.updateCount();

                this.onFocus = function onFocus() {
                    angular.element('i.material-icons > span').addClass('active');
                }.bind(this);

                this.onBlur = function onBlur() {
                    if (this.filterText.length === 0) {
                        angular.element('i.material-icons > span').removeClass('active');
                    }
                }.bind(this);

                this.shouldDisplayCount = function shouldDisplayCount() {
                    return !(this.SelectionFactory.currentOptions.length > 0 && this.SelectionFactory.currentOptions[0].level && this.SelectionFactory.currentOptions[0].level === 'country');
                };

                this.clearPage = function clearPage() {
                    this.SelectionFactory.deselectAll();
                    this.updateCount();
                };

                this.bubbleSelected = function bubbleSelected() {
                    var selected = [],
                        notSelected = [];

                    this.filteredOptions.forEach(function (option) {
                        if (this.SelectionFactory.isSelected(option) || this.SelectionFactory.isPartiallySelected(option)) {
                            selected.push(option);
                        } else {
                            notSelected.push(option);
                        }
                    }, this);

                    this.filteredOptions = selected.concat(notSelected);
                    this.currentSelectedCount = selected.length;
                };

                this.filterCurrentOptions = function filterCurrentOptions(dataRetrievalPromise) {
                    // in some cases we need to retrieve data, so wait until its ready before acting on it
                    $q.when(dataRetrievalPromise, function () {
                        if (this.filterText.length > 1) {
                            this.filteredOptions = this.$filter('filter')(this.SelectionFactory.currentOptions, this.nameMatchPredicate);

                            if (this.filteredOptions.length === 1) {
                                this.filteredCount = this.$translate.instant('icm-search__mini-mod__result-count-label');
                            } else {
                                this.filteredCount = this.$translate.instant('icm-search__mini-mod__plural-results-count-label', { count: this.filteredOptions.length });
                            }
                        } else if (this.filterText.length < 1) {
                            this.filteredOptions = _.sortBy(this.SelectionFactory.currentOptions, 'name');
                            this.updateCount();
                        }

                        this.hasChildren = this.filteredOptions.length > 0;

                        this.bubbleSelected();
                    }.bind(this));
                };

                this.nameMatchPredicate = function nameMatchPredicate(element) {
                    var foundMatch = false;

                    if (element && element.display && element.display.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0) {
                        foundMatch = true;
                    } else if (element.children) {
                        foundMatch = element.children.some(function (child) {
                            return child.display.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0;
                        }.bind(this));
                    }

                    return foundMatch;
                }.bind(this);

                this.scrollToTop = function scrollToTop() {
                    $('md-virtual-repeat-scroller').scrollTop(0);
                };

                this.toggle = function toggle(item) {
                    this.SelectionFactory.toggle(item);
                    this.updateCount();
                };

                this.radioButtonChange = function radioButtonChange(item) {
                    this.SelectionFactory.displayState.selected = {};
                    this.SelectionFactory.toggle(item);
                };

                this.getTooltipMessage = function getTooltipMessage(itemDisplay, count) {
                    var tooltip = this.$translate.instant('icm-search__mini-mod--option-match-tooltip', { option: _.unescape(itemDisplay), count: count });

                    return _.unescape(tooltip);
                };

                this.bubbleSelected();
            }

            MiniModalController.prototype.updateCount = function updateCount() {
                this.filteredCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', { count: this.SelectionFactory.selectedCurrentOptionCount() });
            };

            this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                multiple: true,
                locals: {
                    SelectionFactory: this.selectionFactory,
                    filteredOptions: this.filteredOptions,
                    searchInProgress: this.searchInProgress,
                    filteredCount: this.filteredCount,
                    currentSelection: this.selectionFactory.displayState.radioSelection,
                    filterText: '',
                    filterName: this.filterName,
                    hasChildren: false,
                    $mdDialog: $mdDialog,
                    $filter: $filter,
                    $translate: $translate,
                    onlyLeafNodeSelection: this.onlyLeafNodeSelection || false,
                    selectedCount: function selectedCount() {
                        return this.currentSelectedCount;
                    },
                    openChild: function openChild(item, callback) {
                        var _this = this;

                        _this.loading = true;
                        return _this.SelectionFactory.openChild(item, callback).finally(function () {
                            _this.loading = false;
                        });
                    }
                },
                controller: MiniModalController,
                templateUrl: 'icm-web/views/filter_modals/filter_mini_modal',
                controllerAs: '$ctrl'
            }).targetEvent(event)).then(function okHandler() {
                this.selectionFactory.resetDepth();
                this.callback();
            }.bind(this), function cancelHandler() {
                this.selectionFactory.rollback();
                this.selectionFactory.resetDepth();
            }.bind(this)).catch(function () {});
        };

        // called from expansion panel
        FilterFactory.prototype.selectionChanged = function selectionChanged(option, updateAncestors) {
            this.selectionFactory.toggle(option, updateAncestors);
            this.callback();
        };

        FilterFactory.prototype.clearAll = function clearAll() {
            this.selectionFactory.reset();
        };

        // Allow minimodal to pupulate new data after its rendered
        FilterFactory.prototype.waitOnSearch = function waitOnSearch() {
            this.searchInProgress = $q.defer();
        };

        FilterFactory.prototype.filterOptions = function filterOptions(searchText) {
            var currentFilters = this.selectionFactory.getSelection();

            return this.currentOptions.filter(function (option) {
                return typeof currentFilters[option.key] === 'undefined';
            }.bind(this)).filter(function (option) {
                return option.display.match(new RegExp(searchText, 'i'));
            });
        };

        FilterFactory.prototype.filterRelevantOptions = function filterRelevantOptions(searchText) {
            return this.filterOptions(searchText).filter(function (option) {
                return !option.nonRelevant;
            });
        };

        FilterFactory.prototype.updateOptions = function updateOptions(options) {
            if (this.allOptionsObject) {
                options = this.insertNonRelevantOptions(options);
            }
            this.currentOptions = options;

            this.currentOptions.forEach(function (currentOption) {
                if (!currentOption.name) {
                    currentOption.name = currentOption.key;
                }
            });

            // if were waiting on a search, we are now satisfied
            if (this.searchInProgress) {
                this.searchInProgress.resolve(this.currentOptions);
                this.searchInProgress = null;
            }

            if (this.filterName === 'icm-search__location-filter--title') {
                this.selectionFactory.updateCurrentOptions(options, true);
            } else {
                this.selectionFactory.updateCurrentOptions(options);
            }
        };

        FilterFactory.prototype.insertNonRelevantOptions = function (relevantOptions) {
            var relevantOptionsObject = {},
                tempList = angular.copy(this.allOptionsObject),
                finalList = [];

            // make a hashmap for relevantOptions, already have one for all options
            relevantOptions.forEach(function (option) {
                relevantOptionsObject[option.key] = option;
                if (option.children) {
                    option.children.forEach(function (childOption) {
                        relevantOptionsObject[childOption.key + childOption.parentKey] = childOption; // child ID's are not always unique
                    }.bind(this));
                }
            });

            // isolate the non relevant options
            Object.keys(tempList).forEach(function (optionKey) {
                if (relevantOptionsObject[optionKey]) {
                    // grab the count from the relevant option
                    tempList[optionKey].count = relevantOptionsObject[optionKey].count;

                    if (relevantOptionsObject && relevantOptionsObject[optionKey] && relevantOptionsObject[optionKey].name) {
                        tempList[optionKey].name = relevantOptionsObject[optionKey].name;
                    }

                    if (relevantOptionsObject && relevantOptionsObject[optionKey] && relevantOptionsObject[optionKey].display) {
                        tempList[optionKey].display = relevantOptionsObject[optionKey].display;
                    }

                    if (tempList[optionKey].children) {
                        tempList[optionKey].children.forEach(function (child) {
                            var relevantOption = relevantOptionsObject[child.key + child.parentKey];

                            child.count = relevantOption ? relevantOption.count : 0;

                            if (relevantOption && relevantOption.name) {
                                child.name = relevantOption.name;
                            }

                            if (relevantOption && relevantOption.display) {
                                child.display = relevantOption.display;
                            } else if (child.name && !child.display) {
                                child.display = 'icm-search__filter--' + child.name.toLowerCase().replace(new RegExp(' ', 'g'), '-');
                            }

                            if (!relevantOption) {
                                child.nonRelevant = true;
                                child.count = 0;
                            }
                        }.bind(this));
                    }
                } else {
                    tempList[optionKey].nonRelevant = true;
                    tempList[optionKey].count = 0;
                }
            }.bind(this));

            // convert back to array
            Object.keys(tempList).forEach(function (tempKey) {
                finalList.push(tempList[tempKey]);
            });

            return finalList;
        };

        FilterFactory.prototype.setAllOptions = function setAllOptions(options) {
            var optionsObject = {};
            options.forEach(function (option) {
                optionsObject[option.key] = option;
            });
            this.allOptionsObject = optionsObject;
        };

        FilterFactory.prototype.getSelectedCount = function getSelectedCount() {
            return Object.keys(this.selectionFactory.displayState.selected).length;
        };

        FilterFactory.prototype.getSelectedValues = function getSelectedValues() {
            return Object.keys(this.selectionFactory.displayState.selected);
        };

        return FilterFactory;
    }]).factory('BeatFilter', ['FilterFactory', 'BeatSelectionFactory', function (FilterFactory, BeatSelectionFactory) {
        function BeatFilter(name, triggerSearchFunction) {
            FilterFactory.call(this, name, triggerSearchFunction);

            this.selectionFactory = new BeatSelectionFactory(name);

            this.getSelectedCount = function getSelectedCount() {
                return this.selectionFactory.getSelectedChildren().length;
            };

            this.filterOptions = function filterBeats(searchText, allBeats) {
                var currentFilters = this.selectionFactory.getSelection();
                return allBeats.filter(function (option) {
                    return typeof currentFilters[this.selectionFactory.keyScheme(option)] === 'undefined';
                }.bind(this)).map(function (option) {
                    if (option.parentKey && option.display.indexOf(option.parentDisplay) < 0) {
                        option.display = option.display + ', ' + option.parentDisplay;
                    }

                    return option;
                }).filter(function (option) {
                    return option.display.match(new RegExp(searchText, 'i'));
                });
            };

            this.selectionFactory.hasChildren = function hasChildren(option, filterText) {
                if (!option.children || !option.children.length) {
                    return false;
                }
                if (filterText && filterText.length) {
                    return option.children.filter(function (child) {
                        return child.display.toLowerCase().includes(filterText.toLowerCase());
                    }).length;
                } else {
                    return true;
                }
            };
        }

        BeatFilter.prototype = Object.create(FilterFactory.prototype);

        return BeatFilter;
    }]).factory('LocationFilter', ['FilterFactory', 'LocationSelectionFactory', function (FilterFactory, LocationSelectionFactory) {
        function LocationFilter(name, triggerSearchFunction) {
            FilterFactory.call(this, name, triggerSearchFunction);

            this.selectionFactory = new LocationSelectionFactory(name);

            this.getSelectedCount = function getSelectedCount() {
                return this.selectionFactory.getQuerySelectionCount();
            };

            this.updateQuery = function updateQuery(searchText, filters, searchType, chips, dateRangeDays, language) {
                this.selectionFactory.updateQuery(searchText, filters, searchType, chips, dateRangeDays, language);
            };
        }

        LocationFilter.prototype = Object.create(FilterFactory.prototype);

        return LocationFilter;
    }]).factory('SourceFilter', ['FilterFactory', 'FilterSelectionFactory', function (FilterFactory, FilterSelectionFactory) {
        function SourceFilter(name, triggerSearchFunction) {
            FilterFactory.call(this, name, triggerSearchFunction);

            this.selectionFactory = new FilterSelectionFactory(name);

            this.showModal = function showModal(event) {
                function MiniModalController() {
                    // convert the object to an array list, so we can properly use ngRepeat & orderBy
                    this.filteredOptions = Object.keys(this.SelectionFactory.displayState.selected).map(function (key) {
                        return this.SelectionFactory.displayState.selected[key];
                    }, this);

                    this.isSelected = function isSelected(item) {
                        return this.filteredIds.indexOf(item.key) > -1;
                    };

                    this.getSelectedCount = function getSelectedCount() {
                        return this.filteredIds.length;
                    };

                    this.updateCount = function updateCount() {
                        this.filteredCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', { count: this.getSelectedCount() });
                    };

                    this.toggle = function toggle(item) {
                        var index = this.filteredIds.indexOf(item.key);
                        if (index >= 0) {
                            this.filteredIds.splice(index, 1);
                        } else {
                            this.filteredIds.push(item.key);
                        }

                        this.updateCount();
                    };

                    this.clearAll = function clearAll() {
                        this.filteredIds = [];
                        this.updateCount();
                    };

                    this.updateCount();
                }

                this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                    locals: {
                        SelectionFactory: this.selectionFactory,
                        filteredOptions: this.filteredOptions,
                        filteredIds: this.selectionFactory.getSelectedValues(),
                        filteredCount: this.getSelectedCount(),
                        filterName: 'icm-search__sourceName-filter--title',
                        $mdDialog: this.$mdDialog,
                        $translate: this.$translate
                    },
                    controller: MiniModalController,
                    templateUrl: 'icm-web/views/filter_modals/source_name_mini_modal',
                    controllerAs: '$ctrl'
                }).targetEvent(event)).then(function okHandler(selectedIds) {
                    if (selectedIds.length < this.getSelectedCount()) {
                        var temp = {};
                        selectedIds.forEach(function (selectedId) {
                            temp[selectedId] = this.selectionFactory.displayState.selected[selectedId];
                        }.bind(this));
                        this.selectionFactory.displayState.selected = temp;
                        this.selectionFactory.resetDepth();
                        this.callback();
                    }
                }.bind(this)).catch(function () {});
            };
        }

        SourceFilter.prototype = Object.create(FilterFactory.prototype);

        return SourceFilter;
    }]).factory('EmailFilter', ['FilterFactory', 'FilterSelectionFactory', function (FilterFactory) {
        function EmailFilter(name, triggerSearchFunction) {
            var _this = this;
            FilterFactory.call(this, name, triggerSearchFunction);

            this.selectedEmails = [];

            this.selectionChanged = function selectionChanged(emailAddress) {
                this.selectedEmails.push(emailAddress);

                this.callback();
            };

            this.getSelectedCount = function getSelectedCount() {
                return this.selectedEmails.length;
            };

            this.clearAll = function clearAll() {
                this.selectedEmails = [];
            };

            this.isSelected = function isSelected(emailAddress) {
                return this.selectedEmails.indexOf(emailAddress) >= 0;
            };

            this.showModal = function showModal(event) {
                function MiniModalController() {
                    this.isSelected = function isSelected(emailAddress) {
                        return this.selectedEmailAddresses.indexOf(emailAddress) >= 0;
                    };

                    this.getSelectedCount = function getSelectedCount() {
                        return this.selectedEmailAddresses.length;
                    };

                    this.updateCount = function updateCount() {
                        this.selectedCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', { count: this.getSelectedCount() });
                    };

                    this.toggle = function toggle(emailAddress) {
                        var index = this.selectedEmailAddresses.indexOf(emailAddress);

                        if (index >= 0) {
                            this.selectedEmailAddresses.splice(index, 1);
                        } else {
                            this.selectedEmailAddresses.push(emailAddress);
                        }

                        this.updateCount();
                    };

                    this.clearAll = function clearAll() {
                        this.selectedEmailAddresses = [];
                        this.updateCount();
                    };

                    this.updateCount();
                }

                this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                    locals: {
                        emailAddressList: angular.copy(this.selectedEmails),
                        selectedEmailAddresses: angular.copy(this.selectedEmails),
                        selectedCount: this.getSelectedCount(),
                        filterName: 'icm-search__email-filter-modal--title',
                        $mdDialog: this.$mdDialog,
                        $translate: this.$translate
                    },
                    controller: MiniModalController,
                    templateUrl: 'icm-web/views/filter_modals/email_address_mini_modal',
                    controllerAs: '$ctrl'
                }).targetEvent(event)).then(function okHandler(selectedEmailAddresses) {
                    _this.selectedEmails = angular.copy(selectedEmailAddresses);
                    _this.callback();
                }.bind(this)).catch(function () {});
            };
        }

        EmailFilter.prototype = Object.create(FilterFactory.prototype);

        return EmailFilter;
    }]).factory('ListStatusFilter', ['FilterFactory', 'FilterSelectionFactory', function (FilterFactory) {
        function ListStatusFilter(name, triggerSearchFunction) {
            var _this = this;
            FilterFactory.call(this, name, triggerSearchFunction);

            this.selectedOption = null;

            this.selectionChanged = function selectionChanged(selectedOption) {
                this.selectedOption = selectedOption;

                this.callback();
            };

            this.getIsFilterSelected = function getIsFilterSelected() {
                return this.selectedOption !== null;
            };

            this.getSelectedCount = function getSelectedCount() {
                return this.selectedOption === null ? 0 : 1;
            };

            this.getSelectedOption = function getSelectedOption() {
                return this.selectedOption;
            };

            this.clearAll = function clearAll() {
                this.selectedOption = null;
            };

            this.showModal = function showModal(event) {
                function MiniModalController() {
                    this.getSelectedCount = function getSelectedCount() {
                        return this.selectedOption === null ? 0 : 1;
                    };

                    this.clearAll = function clearAll() {
                        this.selectedOption = null;

                        this.updateCountString(0);
                    };

                    this.updateCountString = function updateCountString(count) {
                        this.selectedCountString = this.$translate.instant('icm-search__mini-mod__selected-count-label', { count: count });
                    };

                    this.updateCountString(this.getSelectedCount());
                }

                this.$mdDialog.show(this.$mdDialog.mwMiniModal({
                    locals: {
                        selectedOption: angular.copy(this.selectedOption),
                        selectedCountString: this.selectedCountString,
                        filterName: 'icm-search__list-status-filter-modal--title',
                        $mdDialog: this.$mdDialog,
                        $translate: this.$translate
                    },
                    controller: MiniModalController,
                    templateUrl: 'icm-web/views/filter_modals/list_status_mini_modal',
                    controllerAs: '$ctrl'
                }).targetEvent(event)).then(function okHandler(selectedOption) {
                    _this.selectedOption = angular.copy(selectedOption);
                    _this.callback();
                }.bind(this)).catch(function () {});
            };
        }

        ListStatusFilter.prototype = Object.create(FilterFactory.prototype);

        return ListStatusFilter;
    }]);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var IdentityService = function IdentityService(EXTERNAL_NAME, ENV, ACCOUNTS_APP_URL) {
        _classCallCheck(this, IdentityService);

        this.EXTERNAL_NAME = EXTERNAL_NAME;
        this.ENV = ENV;
        this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
        var AuthenticationErrorCodes = window[this.EXTERNAL_NAME].AuthenticationErrorCodes,
            AuthenticationClient = window[this.EXTERNAL_NAME].AuthenticationClient,
            Environments = window[this.EXTERNAL_NAME].Environments,
            Initializer = window[this.EXTERNAL_NAME].Initializer;

        AuthenticationClient.onError(function (errorCode) {
            if (errorCode === AuthenticationErrorCodes.NOT_SIGNED_IN || errorCode === AuthenticationErrorCodes.MISSING_OR_MALFORMED_COOKIE) {
                // redirect to login
                window.location.href = this.ACCOUNTS_APP_URL + '/logout';
                console.error('Failed to Auth ' + errorCode);
            } else {
                // just log it?
                console.error('Failed to Auth ' + errorCode);
            }
        });

        if (this.ENV === 'production') {
            Initializer.initialize(Environments.PRODUCTION);
        } else if (this.ENV !== 'production') {
            Initializer.initialize(Environments.STAGING);
        }
    };

    angular.module('MW.Influencers.IdentityService', []).service('IdentityService', ['EXTERNAL_NAME', 'ENV', 'ACCOUNTS_APP_URL', IdentityService]);
})();
/*globals Dialog*/
'use strict';

angular.module('MW.Influencers.IcmDialogService', ['ladda']).factory('DialogService', ['$translate', '$timeout', '$q', function ($translate, $timeout, $q) {

    var currentFlashMessageId = 0,
        serviceObj = {};

    serviceObj.flashMessages = [];
    serviceObj.currentDialog = null;
    serviceObj.showBackground = true;
    serviceObj.dialogType = 'alert';
    serviceObj.dialogChanging = [];
    serviceObj.mainDialog = {};

    serviceObj.getCurrentDialog = function () {
        return serviceObj.currentDialog;
    };

    serviceObj.registerDialogChanging = function (observer) {
        serviceObj.dialogChanging.push(observer);
    };

    serviceObj.alert = function (alertMessageText, alertMessageTitle, callback) {
        serviceObj.dialogType = 'alert';
        serviceObj.currentDialog = new Dialog();
        serviceObj.currentDialog.title = alertMessageTitle ? alertMessageTitle : $translate.instant('Alert');
        serviceObj.currentDialog.payload = { content: alertMessageText };
        serviceObj.currentDialog.template = 'icm-gaf-legacy/views/partials/dialog_alert';
        serviceObj.currentDialog.callback = callback || function () {};
        serviceObj.currentDialog.callbackOnCancel = true;
        serviceObj.showDialog();
    };

    serviceObj.getRootElement = function () {
        return serviceObj.mainDialog;
    };
    serviceObj.setRootElement = function (element) {
        serviceObj.mainDialog = element;
    };

    serviceObj.dialog = function (options, template, payload, callback, initFunction, validateFunction, callbackOnCancel, customDialogCss) {
        // GYDA-3460 The following timeout was added to address this issue.
        // This is not ideal solution but necessary to handle scenarios where there are back to back dialogs.
        // The only reason we did it this way for now is because of the use of nested $timeout in the dialog.js contentLoaded function.
        // This timeout delay was apparently needed for some other purpose but caused issue when having back to back dialogs.
        // This was a quick fix before the H1C release.
        // GYDA-3513 was created to handle addressing this a better way in the future.

        var deferred = $q.defer();
        $timeout(function () {
            var optionsType = Object.prototype.toString.call(options);
            serviceObj.dialogType = 'message';
            serviceObj.currentDialog = new Dialog();
            if (customDialogCss) {
                serviceObj.currentDialog.customDialogCss = customDialogCss;
            }

            if (optionsType === '[object String]' || optionsType === '[object Null]') {
                serviceObj.currentDialog.title = options;
                serviceObj.currentDialog.template = template;
                serviceObj.currentDialog.callbackOnCancel = angular.isDefined(callbackOnCancel) && callbackOnCancel === true;
                if (angular.isDefined(payload) && angular.isDefined(payload.wrapperTemplate)) {
                    serviceObj.currentDialog.wrapperTemplate = payload.wrapperTemplate;
                }
                if (angular.isDefined(payload)) {
                    serviceObj.currentDialog.payload = payload;
                }
                if (angular.isDefined(callback)) {
                    serviceObj.currentDialog.callback = callback;
                }
                if (angular.isDefined(initFunction)) {
                    serviceObj.currentDialog.init = initFunction;
                }
                if (angular.isDefined(validateFunction)) {
                    serviceObj.currentDialog.validate = validateFunction;
                }
            } else if (optionsType === '[object Object]') {
                //Supports function overloading via an object, making it easier for us to add
                //options to the dialog at a later point.
                serviceObj.currentDialog.callbackOnCancel = false;
                serviceObj.currentDialog = angular.extend(serviceObj.currentDialog, options);
            }

            serviceObj.showDialog();

            $timeout(function () {
                deferred.resolve();
            }, 500);
        }, 200);

        return deferred.promise;
    };

    serviceObj.confirm = function (confirmMessageText, confirmMessageTitle, options) {
        var callback;

        // This supports an older method of calling DialogService.confirm with a callback directly.
        if (typeof options === 'function') {
            callback = options;
            options = {};
        } else {
            options = options || {};
            callback = options.callback || function () {};
        }

        var okText = options.okText || 'OK',
            cancelText = options.cancelText || 'Cancel';

        serviceObj.dialogType = 'confirm';
        serviceObj.currentDialog = new Dialog();
        serviceObj.currentDialog.title = confirmMessageTitle ? confirmMessageTitle : $translate.instant('Alert');
        serviceObj.currentDialog.payload = {
            content: confirmMessageText,
            okText: okText,
            cancelText: cancelText };

        serviceObj.currentDialog.template = 'icm-gaf-legacy/views/partials/dialog_confirm';
        serviceObj.currentDialog.callbackOnCancel = true;
        serviceObj.currentDialog.callback = callback;
        serviceObj.showDialog();
    };

    serviceObj.confirmExit = function (options, payload, callback) {

        var dialogOptions = {
            callbackOnCancel: false,
            init: null,
            title: $translate.instant('Leave Page?'),
            validate: null,
            customDialogCss: {}
        };

        angular.extend(dialogOptions, options);

        serviceObj.dialog(dialogOptions.title, 'icm-gaf-legacy/views/partials/dialog_confirm_exit', angular.extend({
            content: $translate.instant('You are about to leave the page. Any unsaved changes will be lost.'),
            confirm: $translate.instant('Save'),
            cancel: $translate.instant('Cancel'),
            reject: $translate.instant('Don\'t Save')
        }, payload), callback || function () {}, dialogOptions.init, dialogOptions.validate, dialogOptions.callbackOnCancel, dialogOptions.customDialogCss);
    };

    serviceObj.showDialog = function () {

        if (serviceObj.dialogChanging.length > 0) {
            for (var i = 0; i < serviceObj.dialogChanging.length; i++) {
                serviceObj.dialogChanging[i](serviceObj.currentDialog);
            }
        }
        angular.element('body:not(".noScroll")').addClass('noScroll');
    };
    serviceObj.closeDialog = function () {

        if (serviceObj.dialogChanging.length > 0) {
            for (var i = 0; i < serviceObj.dialogChanging.length; i++) {
                serviceObj.dialogChanging[i]();
            }
        }
        angular.element('body.noScroll').removeClass('noScroll');
    };
    serviceObj.clearCallbacks = function () {
        if (serviceObj.currentDialog) {
            serviceObj.currentDialog.callback = null;
            serviceObj.currentDialog.init = null;
            serviceObj.currentDialog.validate = null;
        }
    };
    /**
     * Shows a "flash" message at the top of the screen that can show various types of information. This is a rather raw
     * method. There are flashAlert/flashSuccess/flashError methods to show a specific type of flash. Use those.
     * @param {string} text The text of the message.
     * @param {string} type What type of message. (alert/warning/success/error/info) This is provided by the shortcut methods.
     * @param {number} timeout How long until this thing disappears. (0 to disable)
     * @param {Object} options A variety of options to impact the message. Summarized below:
     * @param {string} options.class The name of a class (or space-separated list of classes) to apply to the .info-box div on the element. (Allows you to style your info box differently).
     * @param {string} options.icon The name of an icon-font icon to show at the left of the message.
     * @param {string} options.hideOnPageChange If set to true, this flash message will disappear whenever the user navigates to a new page. If false, it will stick around forever. (Or until its timeout expires)
     * @param {string} options.uniqueId If set to a string value, only one flash message with the given id will be shown on the screen at a time. Newer messages will replace older ones.
     * @returns {number} The id of the message, which can later be used to remove it programmatically.
     */
    serviceObj.flash = function (text, type, timeout, options) {

        options = options || {};
        type = type || 'info'; // one of: error, success, info, alert
        timeout = typeof timeout !== 'undefined' ? timeout : 5; // 0 to disable.
        var messageId = currentFlashMessageId++;

        if (typeof options.uniqueId !== 'undefined') {
            for (var i = 0; i < serviceObj.flashMessages.length; i++) {
                if (serviceObj.flashMessages[i].uniqueId === options.uniqueId) {
                    serviceObj.flashMessages.splice(i, 1);
                    i--; // We modified the array. Iterate over the element in our place. (If there is one)
                }
            }
        }

        serviceObj.flashMessages.push({
            id: messageId,
            uniqueId: options.uniqueId,
            type: type,
            timeout: timeout,
            text: text,
            className: options.class || '',
            iconName: options.icon,
            hideOnPageChange: options.hideOnPageChange || false
        });
        return messageId;
    };

    /**
     * Show an error message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashError = function flashError(text, timeout, options) {

        // if there is no supplied uniqueId, use the text
        // will force us to only show 1 flash error per string message
        options = options || {};
        options.uniqueId = options.uniqueId || text;

        return this.flash(text, 'error', timeout, options);
    };
    /**
     * Show an error message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashAlert = function flashAlert(text, timeout, options) {
        return this.flash(text, 'alert', timeout, options);
    };
    /**
     * Show a warning message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashWarning = function flashWarning(text, timeout, options) {
        return this.flash(text, 'warning', timeout, options);
    };
    /**
     * Show an informational message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashInfo = function flashInfo(text, timeout, options) {
        return this.flash(text, 'info', timeout, options);
    };
    /**
     * Show a success message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashSuccess = function flashSuccess(text, timeout, options) {

        return this.flash(text, 'success', timeout, options);
    };

    /**
     * Remove a flash message programatically.
     * @param id The id of the message. (This is returned by the various "flash" methods)
     * @returns {boolean} True if we were able to remove the method; false otherwise.
     */
    serviceObj.removeFlash = function removeFlash(id) {

        for (var i = 0; i < serviceObj.flashMessages.length; i++) {
            if (serviceObj.flashMessages[i].id === id) {
                serviceObj.flashMessages.splice(i, 1);
                return true;
            }
        }
        return false;
    };

    serviceObj.getFlashMessage = function getFlashMessage(id) {

        for (var i = 0; i < serviceObj.flashMessages.length; i++) {
            if (serviceObj.flashMessages[i].id === id) {
                return serviceObj.flashMessages[i];
            }
        }
        return null;
    };

    serviceObj.removeFlashMessageByClassName = function removeFlashMessageByClassName(_className) {

        var flashArray = serviceObj.flashMessages;
        for (var i = 0; i < flashArray.length; i++) {
            if (flashArray[i].className === _className) {
                serviceObj.removeFlash(flashArray[i].id);
            }
        }
    };
    return serviceObj;
}]);
/*globals angular*/
'use strict';

angular.module('MW.Influencers.IcmLanguageService', []).factory('IcmLanguageService', [function () {
    var languageServiceObj = {},
        languageList,
        languageDictionary,
        updateLanguages;

    updateLanguages = function updateLanguages(languages) {
        // Hold original array to optimize for literal return of getLanguageList
        languageList = languages;

        // Copy values to optimize for lookup
        languageDictionary = {};
        for (var i = 0; i < languages.length; i++) {
            languageDictionary[languages[i].val] = languages[i];
        }
    };

    languageServiceObj.getLanguageList = function () {
        return languageList;
    };

    languageServiceObj.getLanguage = function getLanguage(code) {
        return languageDictionary[code];
    };

    languageServiceObj.isAsianLanguage = function isAsianLanguage(language) {
        return ['jp', 'cn', 'kp', 'kr'].indexOf(language) !== -1;
    };

    updateLanguages([{ val: 'ar', name: 'Arabic' }, { val: 'bg', name: 'Bulgarian' }, { val: 'bn', name: 'Bengali' }, { val: 'cs', name: 'Czech' }, { val: 'da', name: 'Danish' }, { val: 'de', name: 'German' }, { val: 'el', name: 'Greek' }, { val: 'en', name: 'English' }, { val: 'es', name: 'Spanish / Castilian' }, { val: 'et', name: 'Estonian' }, { val: 'fa', name: 'Persian' }, { val: 'fi', name: 'Finnish' }, { val: 'fr', name: 'French' }, { val: 'he', name: 'Hebrew' }, { val: 'hi', name: 'Hindi' }, { val: 'hr', name: 'Croatian' }, { val: 'hu', name: 'Hungarian' }, { val: 'it', name: 'Italian' }, { val: 'ja', name: 'Japanese' }, { val: 'ko', name: 'Korean' }, { val: 'lt', name: 'Lithuanian' }, { val: 'lv', name: 'Latvian' }, { val: 'mk', name: 'Macedonian' }, { val: 'ms', name: 'Malay' }, { val: 'ne', name: 'Nepali' }, { val: 'nl', name: 'Dutch' }, { val: 'no', name: 'Norwegian' }, { val: 'pl', name: 'Polish' }, { val: 'pt', name: 'Portuguese' }, { val: 'ro', name: 'Romanian' }, { val: 'ru', name: 'Russian' }, { val: 'sk', name: 'Slovak' }, { val: 'sl', name: 'Slovenian' }, { val: 'so', name: 'Somali' }, { val: 'se', name: 'Northern Sami' }, { val: 'sq', name: 'Albanian' }, { val: 'sv', name: 'Swedish' }, { val: 'sw', name: 'Swahili' }, { val: 'tr', name: 'Turkish' }, { val: 'uk', name: 'Ukrainian' }, { val: 'ur', name: 'Urdu' }, { val: 'vi', name: 'Vietnamese' }, { val: 'kn', name: 'Kannada' }, { val: 'ml', name: 'Malayalam' }, { val: 'mr', name: 'Marathi' }, { val: 'pa', name: 'Punjabi' }, { val: 'ta', name: 'Tamil' }, { val: 'te', name: 'Telugu' }, { val: 'th', name: 'Thai' }, { val: 'af', name: 'Afrikaans' }, { val: 'am', name: 'Amharic' }, { val: 'hy', name: 'Armenian' }, { val: 'az', name: 'Azerbaijani' }, { val: 'eu', name: 'Basque' }, { val: 'be', name: 'Belarusian' }, { val: 'bs', name: 'Bosnian' }, { val: 'my', name: 'Burmese' }, { val: 'ca', name: 'Catalan' }, { val: 'km', name: 'Central Khmer' }, { val: 'zh-Hans', name: 'Chinese (simpl.)' }, { val: 'zh-Hant', name: 'Chinese (trad.)' }, { val: 'fo', name: 'Faroese' }, { val: 'tl', name: 'Filipino' }, { val: 'gl', name: 'Galician' }, { val: 'ka', name: 'Georgian' }, { val: 'gu', name: 'Gujarati' }, { val: 'ha', name: 'Hausa' }, { val: 'is', name: 'Icelandic' }, { val: 'id', name: 'Indonesian' }, { val: 'ga', name: 'Irish' }, { val: 'kl', name: 'Kalaallisut, Greenlandic' }, { val: 'kk', name: 'Kazakh' }, { val: 'rw', name: 'Kinyarwanda' }, { val: 'ky', name: 'Kirghiz, Kyrgyz' }, { val: 'ku', name: 'Kurdish' }, { val: 'lo', name: 'Lao' }, { val: 'lb', name: 'Luxembourgish' }, { val: 'mt', name: 'Maltese' }, { val: 'el', name: 'Modern Greek' }, { val: 'he', name: 'Modern Hebrew' }, { val: 'nd', name: 'North Ndebele' }, { val: 'ps', name: 'Pashto, Pushto' }, { val: 'rm', name: 'Romansh' }, { val: 'sr', name: 'Serbian' }, { val: 'si', name: 'Sinhala, Sinhalese' }, { val: 'nr', name: 'South Ndebele' }, { val: 'uz', name: 'Uzbek' }, { val: 'cy', name: 'Welsh' }, { val: 'zu', name: 'Zulu' }, { val: 'as', name: 'Assamese' }, { val: 'xh', name: 'Xhosa' }, { val: 'mi', name: 'Māori' }, { val: 'eo', name: 'Esperanto' }, { val: 'fj', name: 'Fijian' }, { val: 'la', name: 'Latin' }, { val: 'mn', name: 'Mongolian' }, { val: 'sm', name: 'Samoan' }, { val: 'yi', name: 'Yiddish' }, { val: 'or', name: 'Oriya' }, { val: 'mg', name: 'Malagasy' }, { val: 'dv', name: 'Dhivehi' }]);

    return languageServiceObj;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TranslationService = function () {
    function TranslationService(CoreCommon, $interpolate, $translate, $q) {
        _classCallCheck(this, TranslationService);

        this.dictionary = {};
        this.language = 'en';
        this.CoreCommon = CoreCommon;
        this.$translate = $translate;
        this.$interpolate = $interpolate;
        this.$q = $q;

        this.untranslatedWrapper = '@@';
        this.exposeUntranslatedStrings = false;
    }

    _createClass(TranslationService, [{
        key: 'registerDictionary',
        value: function registerDictionary(data) {
            this.dictionary = angular.merge(this.dictionary, data);
            this.dictionaryReady = true;
        }
    }, {
        key: 'setLanguage',
        value: function setLanguage(lang) {
            if (this.CoreCommon.isUsable(lang)) {
                this.language = lang;
                this.$translate.use(lang);
            } else {
                throw new Error('Invalid language selected');
            }
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage() {
            return this.language;
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            return this.dictionaryReady && !$.isEmptyObject(this.dictionary);
        }
    }, {
        key: 'getDictionaryString',
        value: function getDictionaryString(text) {
            if (text === undefined || text === null || text === '') {
                return text;
            }

            if (typeof this.dictionary[text] !== 'undefined' && this.dictionary[text] !== '') {
                return this.dictionary[text];
            } else {
                return this.exposeUntranslatedStrings ? this.untranslatedWrapper + text + this.untranslatedWrapper : text;
            }
        }
    }, {
        key: 'getLocalizedString',
        value: function getLocalizedString(text, scope, waitForTranslation) {
            var localizedString;

            localizedString = this.getDictionaryString(text);

            if (scope) {
                localizedString = this.getPostTranslationInterpolatedText(localizedString, scope);
            }

            return waitForTranslation ? this.$q.when(localizedString) : localizedString;
        }
    }, {
        key: 'getLocalizedStringAsync',
        value: function getLocalizedStringAsync(text, scope) {
            var _this = this;

            return this.waitForTranslations().then(function () {
                return _this.getLocalizedString(text, scope, false);
            });
        }
    }, {
        key: 'waitForTranslations',
        value: function waitForTranslations() {
            return this.$q.when(); //legacy support, we don't need this promise
        }
    }, {
        key: 'getPostTranslationInterpolatedText',
        value: function getPostTranslationInterpolatedText(text, scope) {
            if (text === null || text === undefined) {
                return text;
            }

            // first replace swaps out matching double square brackets for curly brackets (disregarding spaces) - Example: "[ [place.holder [1 ]]     ]" -> "{{place.holder [1 ]}}"
            // second replace removes all whitespace within the double curly brackets - Example: "{{place.holder [1 ]}}" -> "{{place.holder[1]}}"
            // this should protect us against bad translation files that introduce spaces and cause interpolation to fail (bad side effects) - GYDA-5299
            // sorry, but you're sadly out of luck if you really want to surround a interpolated string with square or curly braces...
            return this.$interpolate(text.replace(/(\[ *\[)(.*?)(\] *\])(?! *])/g, '{{$2}}').replace(/[ ]+(?=[^{}]*}})/g, ''))(scope);
        }
    }]);

    return TranslationService;
}();

angular.module('MW.Framework.TranslationService', ['MW.Framework.CoreCommon', 'pascalprecht.translate']).service('translationService', ['CoreCommon', '$interpolate', '$translate', '$q', TranslationService]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var ManifestService = function () {
        function ManifestService($q) {
            _classCallCheck(this, ManifestService);

            this.$q = $q;
            this.manifest = null;
        }

        _createClass(ManifestService, [{
            key: 'getManifest',
            value: function getManifest() {
                var _this = this;

                var deferred = this.$q.defer();

                if (!this.manifest) {
                    var manifestClient = window.miManifestClientV1;

                    var currentHostName = window.location.hostname;

                    if (manifestClient) {
                        var currentManifestEnvironment = void 0;

                        if (currentHostName.indexOf('.com') !== -1) {
                            currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
                        } else {
                            currentManifestEnvironment = manifestClient.Environments.STAGING;
                        }

                        manifestClient.Initializer.initialize(currentManifestEnvironment);

                        manifestClient.ManifestClient.getInstance().then(function (manifestClientInstance) {
                            manifestClientInstance.getCurrentManifest().then(function (manifest) {
                                _this.manifest = manifest;
                                deferred.resolve(manifest);
                            });
                        });
                    }
                } else {
                    deferred.resolve(this.manifest);
                }

                return deferred.promise;
            }
        }, {
            key: 'getCompanyOverrides',
            value: function getCompanyOverrides() {
                var deferred = this.$q.defer();
                var overrides = {};

                this.getManifest().then(function (manifest) {
                    if (manifest && manifest.company && manifest.company.overrides) {
                        overrides = manifest.company.overrides;
                    }
                }).finally(function () {
                    deferred.resolve(overrides);
                });

                return deferred.promise;
            }
        }, {
            key: 'setOverride',
            value: function setOverride(overrideName, overrideValue) {
                var deferred = this.$q.defer();

                this.getManifest().then(function (manifest) {
                    if (manifest && manifest.company && manifest.company.overrides) {
                        manifest.company.overrides[overrideName] = overrideValue;
                    }
                });

                return deferred.promise;
            }
        }]);

        return ManifestService;
    }();

    angular.module('MW.Influencers.ManifestService', []).service('ManifestService', ['$q', ManifestService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapService = function () {
    function MapService(CoreCompanyService, CoreUserService, $q) {
        _classCallCheck(this, MapService);

        this.mapBoxBounds = {};
        this.mapSearchText = '';
        this.dragListeners = [];
        this.CoreCompanyService = CoreCompanyService;
        this.CoreUserService = CoreUserService;

        // the interaction panel has 5 states
        this.SHOW_BUTTON = 'button';
        this.LOADING_TEXT = 'loading';
        this.HELPER_TEXT = 'text';
        this.RESULTS_COUNT = 'count';
        this.BLANK = '';
        this.interactionState = this.HELPER_TEXT;
        this.isMapSupported = true;
        this.shouldUpdateCount = true;
        this.$q = $q;

        // the default map viewport bounds
        this.DEFAULT_VIEWPORT_BOUNDS = {
            bounds: {
                _ne: {
                    lat: 53.3308729830153,
                    lng: 112.5000000002348
                },
                _sw: {
                    lat: -53.33087298302015,
                    lng: -112.49999999997999
                }
            },
            viewport: {
                bottomRight: {
                    lat: -53.33087298302015,
                    lon: 112.5000000002348
                },
                topLeft: {
                    lat: 53.3308729830153,
                    long: -112.49999999997999
                }
            }
        };

        // Layers in mapbox to update to get the full translation we want
        this.MAPBOX_LAYERS_TO_UPDATE_LANGUAGE = ['housenum-label', 'waterway-label', 'road-label-small', 'road-label-medium', 'road-label-large', 'rail-label', 'water-label-sm', 'water-label', 'airport-label', 'marine-label-sm-ln', 'marine-label-sm-pt', 'marine-label-md-ln', 'marine-label-md-pt', 'marine-label-lg-ln', 'marine-label-lg-pt', 'state-label-sm', 'state-label-md', 'state-label-lg', 'country-label-sm', 'country-label-md', 'country-label-lg', 'place-city-lg-n', 'place-city-lg-s', 'place-city-md-n', 'place-city-md-s', 'place-city-sm'];
    }

    _createClass(MapService, [{
        key: 'initialize',
        value: function initialize(contactSourceServiceViewportBounds) {
            if (contactSourceServiceViewportBounds) {
                this.viewportBounds = new ViewportBounds(contactSourceServiceViewportBounds.bounds, contactSourceServiceViewportBounds.viewport);
            }
        }

        // Grab the users language if it is compliant with mapbox

    }, {
        key: 'getUsersMBLanguage',
        value: function getUsersMBLanguage() {
            var deferred = this.$q.defer();

            this.CoreUserService.getCurrent(true).then(function getUser() {
                var userLanguage = this.CoreUserService.getLanguage(),
                    supportedMapBoxLanguages = ['en', 'es', 'fr', 'de', 'ru', 'zh', 'zh-hans', 'pt', 'ar'];

                // translate our chinese simplified code to mapbox' chinese simplified code
                if (userLanguage === 'zh_CN') {
                    userLanguage = 'zh-Hans';
                } else if (userLanguage === 'zh_TW') {
                    userLanguage = 'zh';
                }

                if (supportedMapBoxLanguages.includes(userLanguage)) {
                    deferred.resolve(userLanguage);
                } else {
                    deferred.resolve(false);
                }
            }.bind(this));

            return deferred.promise;
        }
    }, {
        key: 'registerMap',
        value: function registerMap(map) {
            this.map = map;
        }
    }, {
        key: 'resetMap',
        value: function resetMap() {
            if (this.map) {
                this.setInteractionState(this.HELPER_TEXT);
            }
        }

        // -------------------------------
        // Search Logic
        // -------------------------------

    }, {
        key: 'triggerSearch',
        value: function triggerSearch() {
            this.refreshSearch();
        }
    }, {
        key: 'registerRefreshSearch',
        value: function registerRefreshSearch(refreshSearchFunction) {
            this.refreshSearch = refreshSearchFunction;
        }
    }, {
        key: 'clear',
        value: function clear() {
            if (this.viewportBounds) {
                this.cachedViewportBounds = this.viewportBounds;
            }
            delete this.viewportBounds;
            delete this.yesTheMapIsDirty;
            this.setGeoCoderText('');
            this.resetModalCountComponent();
        }

        // -------------------------------
        // Bounds Selection
        // -------------------------------

    }, {
        key: 'boundsSelected',
        value: function boundsSelected(bounds) {
            try {
                this.viewportBounds = new ViewportBounds(bounds);
            } catch (err) {
                // jshint ignore:line
                this.viewportBounds = undefined;
            }
        }
    }, {
        key: 'getViewportBounds',
        value: function getViewportBounds() {
            return this.viewportBounds;
        }
    }, {
        key: 'getCachedViewportBounds',
        value: function getCachedViewportBounds() {
            if (this.viewportBounds) {
                return this.viewportBounds;
            }
            return this.cachedViewportBounds;
        }
    }, {
        key: 'getCachedBoundsAsArray',
        value: function getCachedBoundsAsArray() {
            var bounds;
            if (this.cachedViewportBounds) {
                bounds = this.cachedViewportBounds.bounds;
                return [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]];
            }
            return null;
        }

        // -------------------------------
        // Modal Count component
        // -------------------------------

    }, {
        key: 'resetModalCountComponent',
        value: function resetModalCountComponent() {
            this.mapDataPointsCount = undefined;
        }
    }, {
        key: 'getMapModalCountComponentValue',
        value: function getMapModalCountComponentValue() {
            return this.mapDataPointsCount;
        }
    }, {
        key: 'setMapModalCountComponent',
        value: function setMapModalCountComponent(count) {
            this.mapDataPointsCount = count;
        }
    }, {
        key: 'getShouldUpdateCount',
        value: function getShouldUpdateCount() {
            return this.shouldUpdateCount;
        }
    }, {
        key: 'setShouldUpdateCount',
        value: function setShouldUpdateCount(bool) {
            this.shouldUpdateCount = bool;
        }

        // -------------------------------
        // Map functions
        // -------------------------------

    }, {
        key: 'registerMiniMapBoundsSetter',
        value: function registerMiniMapBoundsSetter(boundsSetter) {
            // This is how we get at the minimap, since it is the first defined map
            if (!!!this.miniMapBoundsSetter) {
                this.miniMapBoundsSetter = boundsSetter;
            }
        }
    }, {
        key: 'registerMiniMapBoundsGetter',
        value: function registerMiniMapBoundsGetter(boundsGetter) {
            // This is how we get at the minimap, since it is the first defined map
            if (!!!this.miniMapBoundsGetter) {
                this.miniMapBoundsGetter = boundsGetter;
            }
        }
    }, {
        key: 'setMiniMapBounds',
        value: function setMiniMapBounds() {
            if (this.miniMapBoundsSetter) {
                this.miniMapBoundsSetter(this.viewportBounds.getBounds());
            }
        }
    }, {
        key: 'getScaleUnits',
        value: function getScaleUnits() {
            return this.CoreCompanyService.getCurrent(true).then(function (currentCompany) {
                return currentCompany.country === 'us' ? 'imperial' : 'metric';
            });
        }

        // -------------------------------
        // GeoCoder (In map Search Bar) Logic
        // -------------------------------

    }, {
        key: 'getGeoCoderText',
        value: function getGeoCoderText() {
            return this.mapSearchText;
        }
    }, {
        key: 'setGeoCoderText',
        value: function setGeoCoderText(text) {
            this.mapSearchText = text;
        }
    }, {
        key: 'registerUpdateInteractState',
        value: function registerUpdateInteractState(updateFunction) {
            this.updateInteractState = updateFunction;
        }
    }, {
        key: 'getInteractionState',
        value: function getInteractionState() {
            return this.interactionState;
        }
    }, {
        key: 'setInteractionState',
        value: function setInteractionState(state) {
            this.interactionState = state;
            // check if the map has become dirty
            if (state === this.RESULTS_COUNT) {
                this.yesTheMapIsDirty = true;
            }
            if (this.updateInteractState) {
                this.updateInteractState();
            }
        }
    }, {
        key: 'isMapDirty',
        value: function isMapDirty() {
            return this.yesTheMapIsDirty || false;
        }
    }, {
        key: 'registerLocationFilter',
        value: function registerLocationFilter(locFunct) {
            this.locationFilterVar = locFunct;
        }
    }, {
        key: 'isLocationFilterDirty',
        value: function isLocationFilterDirty() {
            return this.locationFilterVar.getQuerySelectionCount() > 0;
        }
    }]);

    return MapService;
}();

angular.module('MW.Influencers.MapService', ['MW.Framework.CoreCompanyService', 'MW.Framework.CoreUserService']).service('MapService', ['CoreCompanyService', 'CoreUserService', '$q', MapService]);

// -------------------------------
// Viewport Bounds Class
// -------------------------------

var ViewportBounds = function () {
    function ViewportBounds(bounds, viewport) {
        _classCallCheck(this, ViewportBounds);

        this.bounds = bounds;
        if (viewport) {
            this.viewport = viewport;
        } else {
            try {
                this.viewport = this.translateBoundsToViewport();
            } catch (err) {
                this.viewport = this.translateArrayToViewport();
            }
        }
    }

    _createClass(ViewportBounds, [{
        key: 'getViewport',
        value: function getViewport() {
            return this.filterViewport();
        }
    }, {
        key: 'filterViewport',
        value: function filterViewport() {
            var vp = this.viewport;

            // Bottom Right
            if (vp && vp.bottomRight) {
                // Lat
                if (vp.bottomRight.lat > 90) {
                    vp.bottomRight.lat = 90;
                } else if (vp.bottomRight.lat < -90) {
                    vp.bottomRight.lat = -90;
                }
                // Lon
                if (vp.bottomRight.lon > 180) {
                    vp.bottomRight.lon = 180;
                } else if (vp.bottomRight.lon < -180) {
                    vp.bottomRight.lon = -180;
                }
            }

            // Top Left
            if (vp && vp.topLeft) {
                // Lat
                if (vp.topLeft.lat > 90) {
                    vp.topLeft.lat = 90;
                } else if (vp.topLeft.lat < -90) {
                    vp.topLeft.lat = -90;
                }
                // Lon
                if (vp.topLeft.lon > 180) {
                    vp.topLeft.lon = 180;
                } else if (vp.topLeft.lon < -180) {
                    vp.topLeft.lon = -180;
                }
            }

            return vp;
        }
    }, {
        key: 'translateBoundsToViewport',
        value: function translateBoundsToViewport() {
            return {
                topLeft: {
                    lat: this.bounds.getNorthWest().lat,
                    lon: this.bounds.getNorthWest().lng
                },
                bottomRight: {
                    lat: this.bounds.getSouthEast().lat,
                    lon: this.bounds.getSouthEast().lng
                }
            };
        }
    }, {
        key: 'translateArrayToViewport',
        value: function translateArrayToViewport() {
            return {
                topLeft: {
                    lat: this.bounds[0][1],
                    lon: this.bounds[0][0]
                },
                bottomRight: {
                    lat: this.bounds[1][1],
                    lon: this.bounds[1][0]
                }
            };
        }
    }, {
        key: 'getBounds',
        value: function getBounds() {
            return this.bounds;
        }
    }, {
        key: 'getBoundsAsArray',
        value: function getBoundsAsArray() {
            return [[this.bounds._sw.lng, this.bounds._sw.lat], [this.bounds._ne.lng, this.bounds._ne.lat]];
        }
    }]);

    return ViewportBounds;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var MediaListService = function () {
        function MediaListService($http, INFLUENCERS_URL) {
            _classCallCheck(this, MediaListService);

            this.$http = $http;
            this.influencersUrl = INFLUENCERS_URL;
        }

        _createClass(MediaListService, [{
            key: 'getById',
            value: function getById(id) {
                var url = this.influencersUrl + '/mediaLists/' + id;
                return this.$http.get(url).then(function (response) {
                    if (response && response.data) {
                        return response.data;
                    }
                });
            }
        }]);

        return MediaListService;
    }();

    angular.module('MW.Influencers.MediaListService', []).service('MediaListService', ['$http', 'INFLUENCERS_URL', MediaListService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var MiniProfileService = function () {
        function MiniProfileService(ICM_CONTACT_SOURCE_SERVICE_API_KEY, mwBannerService, $translate) {
            _classCallCheck(this, MiniProfileService);

            this.ICM_CONTACT_SOURCE_SERVICE_API_KEY = ICM_CONTACT_SOURCE_SERVICE_API_KEY;
            this.mwBannerService = mwBannerService;
            this.$translate = $translate;
            this.openBanners = null;
            this.miniProfileId = '';
        }

        _createClass(MiniProfileService, [{
            key: 'openMiniProfile',
            value: function openMiniProfile(contactId) {
                var preventDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                try {
                    this.miniProfileId = contactId;
                    var chromeContent = document.querySelector('mi-app-chrome-content');
                    var miniProfileHeader = document.querySelector('icm-mini-profile-header');
                    miniProfileHeader.setContactId(contactId);
                    chromeContent.openDrawer();
                    if (preventDefault) {
                        var e = window.event;
                        e.preventDefault();
                    }
                } catch (error) {
                    try {
                        this.OpenErrorBanner(contactId);
                        var _e = window.event;
                        _e.preventDefault();
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        }, {
            key: 'OpenErrorBanner',
            value: function OpenErrorBanner(contactId) {
                var _this = this;

                var chromeContent = document.querySelector('mi-app-chrome-content');
                chromeContent.closeDrawer();

                this.mwBannerService.open({
                    bindToController: true,
                    template: '\n                <mw-banner type="\'alert\'" on-close="$ctrl.close()">\n                    {{$ctrl.alertBannerText}}\n                    <mw-banner-actions>\n                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.TryToOpenMiniAgain()">\n                            {{$ctrl.tryAgainText}}\n                        </md-button>\n                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.ViewProfile()">\n                            {{$ctrl.ViewProfileText}}\n                        </md-button>\n                    </mw-banner-actions>\n                </mw-banner>\n                ',
                    controller: function () {
                        BannerPanel.$inject = ["mdPanelRef", "$translate", "MiniProfileService", "$window", "$scope", "IRM_BASE_URL"];
                        function BannerPanel(mdPanelRef, $translate, MiniProfileService, $window, $scope, IRM_BASE_URL) {
                            'ngInject';

                            _classCallCheck(this, BannerPanel);

                            this.$translate = $translate;
                            this.mdPanelRef = mdPanelRef;
                            this.MiniProfileService = MiniProfileService;
                            this.$window = $window;
                            this.$scope = $scope;
                            this.IRM_BASE_URL = IRM_BASE_URL;

                            this.alertBannerText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--body');
                            this.tryAgainText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--try-again');
                            this.ViewProfileText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--view-contact');
                        }

                        _createClass(BannerPanel, [{
                            key: 'TryToOpenMiniAgain',
                            value: function TryToOpenMiniAgain() {
                                this.mdPanelRef.close();
                                this.MiniProfileService.openMiniProfile(contactId, false);
                            }
                        }, {
                            key: 'ViewProfile',
                            value: function ViewProfile() {
                                this.contactUrl = this.IRM_BASE_URL + '/contact/' + contactId;
                                this.$window.open(this.contactUrl);
                            }
                        }, {
                            key: 'close',
                            value: function close() {
                                this.mdPanelRef.close();
                                this.MiniProfileService.miniProfileId = '';
                            }
                        }]);

                        return BannerPanel;
                    }(),
                    controllerAs: '$ctrl'
                }).then(function (newBanner) {
                    _this.closeMiniProfileBanner(newBanner);
                });
            }
        }, {
            key: 'closeMiniProfileBanner',
            value: function closeMiniProfileBanner() {
                var newBanner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                if (this.openBanners !== null) {
                    if (newBanner !== null) {
                        this.openBanners.close();
                        this.openBanners = newBanner;
                    } else {
                        this.openBanners.close();
                        this.openBanners = null;
                    }
                } else {
                    this.openBanners = newBanner;
                }
            }
        }, {
            key: 'closeMiniProfile',
            value: function closeMiniProfile() {
                var miniProfileHeader = document.querySelector('icm-mini-profile-header');
                miniProfileHeader.setContactId('');
                this.miniProfileId = '';
                var chromeContent = document.querySelector('mi-app-chrome-content');
                chromeContent.closeDrawer();
            }
        }]);

        return MiniProfileService;
    }();

    angular.module('MW.Influencers.MiniProfileService', []).service('MiniProfileService', ['ICM_CONTACT_SOURCE_SERVICE_API_KEY', 'mwBannerService', '$translate', MiniProfileService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var MrCompanyService = function () {
        function MrCompanyService($q, $http, MR_COMPANY_SERVICE_URL) {
            _classCallCheck(this, MrCompanyService);

            this.$q = $q;
            this.$http = $http;
            this.MR_COMPANY_SERVICE_URL = MR_COMPANY_SERVICE_URL;
        }

        _createClass(MrCompanyService, [{
            key: 'setAcceptedTerms',
            value: function setAcceptedTerms() {
                var deferred = this.$q.defer();

                this.$http.put(this.MR_COMPANY_SERVICE_URL + '/overrides', {
                    'name': 'mrShowUpdatedTerms0923',
                    'value': false
                }).finally(function () {
                    // ignoring errors to set accepted terms. worst case they need to accept them again. if this becomes problematic we can revisit.
                    deferred.resolve();
                });

                return deferred.promise;
            }
        }]);

        return MrCompanyService;
    }();

    angular.module('MW.Influencers.MrCompanyService', ['MW.Configuration']).service('MrCompanyService', ['$q', '$http', 'MR_COMPANY_SERVICE_URL', MrCompanyService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var OutreachBannerService = function () {
        function OutreachBannerService($scope, mwBannerService, SendgridService, $q, $http, $location, $timeout, NONVERIFY_DOMAINS) {
            _classCallCheck(this, OutreachBannerService);

            this.mwBannerService = mwBannerService;
            this.$scope = $scope;
            this.$q = $q;
            this.openOne = false;
            this.$http = $http;
            this.$location = $location;
            this.$timeout = $timeout;
            this.SendgridService = SendgridService;
            this.NONVERIFY_DOMAINS = NONVERIFY_DOMAINS;

            this.bannerPannelRef = {
                close: function close() {}
            };
            this.$scope.$on('$locationChangeStart', function (e, next, current) {
                if (!(next.indexOf('influencers/contact/outreach') > -1 && current.indexOf('influencers/contact/outreach') > -1)) {
                    this.openOne = false;
                    this.bannerPannelRef.close();
                } else if (next.indexOf('?view=preview') > -1) {
                    this.openOne = false;
                    this.bannerPannelRef.close();
                }
            }.bind(this));
            this.nonValidateDomains = {};
            this.getNonVerifiableDomains();
        }

        _createClass(OutreachBannerService, [{
            key: 'isEmpty',
            value: function isEmpty(checkObj) {
                for (var key in checkObj) {
                    if (checkObj.hasOwnProperty(key)) {
                        return false;
                    }
                }
                return true;
            }
        }, {
            key: 'getNonVerifiableDomains',
            value: function getNonVerifiableDomains() {
                var _this = this;

                var deferred = this.$q.defer();
                this.$http.get(this.NONVERIFY_DOMAINS, { skipAuthInterceptor: true }).then(function (res) {
                    res.data.domains.forEach(function (domain) {
                        _this.nonValidateDomains[domain] = true;
                    });
                    deferred.resolve();
                }).catch(function () {
                    _this.nonValidateDomains = {
                        'meltwater.com': true,
                        'aol.com': true,
                        'comcast.net': true,
                        'gmail.com': true,
                        'hotmail.co.uk': true,
                        'hotmail.com': true,
                        'hotmail.fr': true,
                        'msn.com': true,
                        'outlook.com': true,
                        'yahoo.com': true,
                        'mail.com': true
                    };
                    deferred.resolve();
                });
                return deferred.promise;
            }
        }, {
            key: '_areDomainsVerified',
            value: function _areDomainsVerified(approvedSenderDomains, sendgridDomains, unverifiableDomains) {
                var allVerified = false;
                var verifiableApprovedSenderDomains = [];

                // lower case all domains for consistency
                approvedSenderDomains = approvedSenderDomains.map(function (approvedSenderDomain) {
                    return approvedSenderDomain.toLowerCase();
                });
                sendgridDomains = sendgridDomains.map(function (sendgridDomain) {
                    if (sendgridDomain.domain) {
                        sendgridDomain.domain = sendgridDomain.domain.toLowerCase();
                    }

                    return sendgridDomain;
                });
                unverifiableDomains = Object.keys(unverifiableDomains).map(function (unverifiableDomain) {
                    return unverifiableDomain.toLowerCase();
                });

                // if we have a set of approved sender domains
                //   then remove any non-verifiable domains from the list of approved sender domains
                // if we don't have any approved sender domains, then we consider them "all verified"
                if (Array.isArray(approvedSenderDomains) && approvedSenderDomains.length) {
                    verifiableApprovedSenderDomains = approvedSenderDomains.filter(function (domain) {
                        return unverifiableDomains.indexOf(domain) < 0;
                    });

                    // if we have a set of verifiable approved sender domains
                    //   then check that every verifiable approved sender domain is verified in sendgrid
                    // if we do not have any verifiable approved sender domains, then we consider them "all verified"
                    if (Array.isArray(verifiableApprovedSenderDomains) && verifiableApprovedSenderDomains.length) {
                        if (Array.isArray(sendgridDomains) && sendgridDomains.length) {
                            allVerified = verifiableApprovedSenderDomains.every(function (verifiableApprovedSenderDomain) {
                                return sendgridDomains.some(function (sendgridDomainObject) {
                                    if (sendgridDomainObject.domain === verifiableApprovedSenderDomain) {
                                        return sendgridDomainObject.isVerified;
                                    } else {
                                        return false;
                                    }
                                });
                            });
                        }
                    } else {
                        allVerified = true;
                    }
                } else {
                    allVerified = true;
                }

                return allVerified;
            }
        }, {
            key: 'checkVerifiedDomains',
            value: function checkVerifiedDomains(domainNames, config, sendgridDomainsArray) {
                var _this2 = this;

                if (!sessionStorage.getItem('outreachBanner') && !this.openOne && domainNames.length > 0) {
                    this.openOne = true;
                    var domainsPromise = void 0;

                    if (sendgridDomainsArray) {
                        domainsPromise = this.$q.when(sendgridDomainsArray);
                    } else {
                        domainsPromise = this.SendgridService.getCompanyDomains();
                    }

                    domainsPromise.then(function (sgDomains) {
                        var allVerified = _this2._areDomainsVerified(domainNames, sgDomains, _this2.nonValidateDomains);

                        if (!allVerified) {
                            _this2.openApprovedSendersAlertBanner(config);
                        }
                    }).catch(function () {});
                }
            }
        }, {
            key: 'openApprovedSendersAlertBanner',
            value: function openApprovedSendersAlertBanner(config) {
                var openConfig = {
                    bindToController: true,
                    controller: function () {
                        BannerPanel.$inject = ["$mdToast", "mdPanelRef", "ACCOUNTS_APP_URL", "$window", "$translate"];
                        function BannerPanel($mdToast, mdPanelRef, ACCOUNTS_APP_URL, $window, $translate) {
                            'ngInject';

                            _classCallCheck(this, BannerPanel);

                            this.mdPanelRef = mdPanelRef;
                            this.$mdToast = $mdToast;
                            this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
                            this.$window = $window;
                            this.$translate = $translate;
                            this.isCloseVisible = false;
                            //translation
                            this.description = this.$translate.instant('icm-outreach__email-banner--verify-domains-description');
                            this.settingsButton = this.$translate.instant('icm-outreach__email-banner--verify-domains-configure');
                            this.helpButton = this.$translate.instant('icm-outreach__email-banner--verify-domains-help');
                        }

                        _createClass(BannerPanel, [{
                            key: 'close',
                            value: function close() {
                                //store the session so we don't show it again after user dismisses it
                                sessionStorage.setItem('outreachBanner', 'true');
                                this.mdPanelRef.close();
                            }
                        }, {
                            key: 'goToApprovedSenders',
                            value: function goToApprovedSenders() {
                                this.$window.open(this.ACCOUNTS_APP_URL + '/settings/email');
                            }
                        }, {
                            key: 'goToHelpPage',
                            value: function goToHelpPage() {
                                this.$window.open('https://support.meltwater.com/hc/en-us/articles/115009946947');
                            }
                        }]);

                        return BannerPanel;
                    }(),
                    template: '\n                <mw-banner type="\'info\'" on-close="$ctrl.close($event)">\n                {{$ctrl.description}}\n                    <mw-banner-actions>\n                        <md-button class="outreachBannerButton mw-button mw-button--link md-primary " ng-click="$ctrl.goToApprovedSenders()">\n                            {{$ctrl.settingsButton}}\n                        </md-button>\n                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.goToHelpPage()">\n                            {{$ctrl.helpButton}}\n                        </md-button>\n                    </mw-banner-actions>\n                </mw-banner>',
                    controllerAs: '$ctrl'
                };

                if (config && config.attachTo) {
                    openConfig.attachTo = config.attachTo;
                }

                if (this.bannerPannelRef) {
                    // making sure there is only 1 outreach banner on page
                    this.bannerPannelRef.close();
                }

                this.mwBannerService.open(openConfig).then(function (panelRef) {
                    this.bannerPannelRef = panelRef;

                    var currentUrl = this.$location.url();
                    if (currentUrl.indexOf('influencers/contact/outreach') === -1) {
                        this.bannerPannelRef.close();
                    } else if (currentUrl.indexOf('?view=preview') > -1 || this.$location.search() && this.$location.search().view) {
                        this.bannerPannelRef.close();
                    }

                    if (this.$location.search() && this.$location.search().branch) {
                        this.$timeout(function () {
                            if (this.$location.search() && this.$location.search().view) {
                                this.bannerPannelRef.close();
                            }
                        }.bind(this), 600);
                    }
                }.bind(this));
            }
        }, {
            key: 'openAttachmentAlertBanner',
            value: function openAttachmentAlertBanner(config) {
                var openConfig = {
                    bindToController: true,
                    controller: function () {
                        BannerPanel.$inject = ["mdPanelRef", "$translate"];
                        function BannerPanel(mdPanelRef, $translate) {
                            'ngInject';

                            _classCallCheck(this, BannerPanel);

                            this.mdPanelRef = mdPanelRef;
                            this.$translate = $translate;

                            //translation
                            this.description = this.$translate.instant('icm-outreach__email-banner--attachment-failed--message');
                            this.dismissButton = this.$translate.instant('icm-outreach__email-banner--attachment-failed--dismiss-button');
                        }

                        _createClass(BannerPanel, [{
                            key: 'close',
                            value: function close() {
                                this.mdPanelRef.close();
                            }
                        }]);

                        return BannerPanel;
                    }(),
                    template: '\n                <mw-banner type="\'alert\'" on-close="$ctrl.close($event)">\n                {{$ctrl.description}}\n                    <mw-banner-actions>\n                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.close($event)">\n                            {{$ctrl.dismissButton}}\n                        </md-button>\n                    </mw-banner-actions>\n                </mw-banner>',
                    controllerAs: '$ctrl'
                };

                if (config && config.attachTo) {
                    openConfig.attachTo = config.attachTo;
                }

                if (this.bannerPannelRef) {
                    // making sure there is only 1 outreach banner on page
                    this.bannerPannelRef.close();
                }
                this.mwBannerService.open(openConfig).then(function (panelRef) {
                    this.bannerPannelRef = panelRef;
                }.bind(this));
            }
        }]);

        return OutreachBannerService;
    }();

    angular.module('MW.Influencers.OutreachBannerService', ['MW.Configuration', 'MW.Influencers.SendgridService', 'mwAppComponents']).service('OutreachBannerService', ['$rootScope', 'mwBannerService', 'SendgridService', '$q', '$http', '$location', '$timeout', 'NONVERIFY_DOMAINS', OutreachBannerService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SegmentTrackingService = function () {
    function SegmentTrackingService($q, CoreUserService, CoreCompanyService, $analytics, ANALYTICS_CONSTANTS) {
        var _this = this;

        _classCallCheck(this, SegmentTrackingService);

        this.$q = $q;
        this.$analytics = $analytics;
        this.ANALYTICS_CONSTANTS = ANALYTICS_CONSTANTS;

        this.companyInfoPromise = CoreCompanyService.getCurrent(true).then(function (company) {
            _this.companyName = company.name;
        });

        this.userInfoPromise = CoreUserService.getCurrent(true).then(function (user) {
            _this.userId = user._id;
            _this.userEmail = user.email;
        });
    }

    _createClass(SegmentTrackingService, [{
        key: 'getDefaultEvent',
        value: function getDefaultEvent() {
            var properties = {};

            properties[this.ANALYTICS_CONSTANTS.SOURCE] = 'webapp';
            properties[this.ANALYTICS_CONSTANTS.LABEL] = undefined;
            properties[this.ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = undefined;
            properties[this.ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = undefined;
            properties[this.ANALYTICS_CONSTANTS.PARENT_TYPE] = undefined;
            properties[this.ANALYTICS_CONSTANTS.ICM_USER_ID] = undefined;

            return properties;
        }
    }, {
        key: 'createMediaListEvent',
        value: function createMediaListEvent(mediaListId, numberOfContacts, parentType, subType) {
            var obj = {};
            obj[this.ANALYTICS_CONSTANTS.MEDIA_LIST_ID] = mediaListId;
            obj[this.ANALYTICS_CONSTANTS.NBR_OF_CONTACTS] = numberOfContacts;
            obj[this.ANALYTICS_CONSTANTS.PARENT_TYPE] = parentType;
            obj.subType = subType;

            return obj;
        }
    }, {
        key: 'trackEvent',
        value: function trackEvent(eventName, mediaListId, numberOfContacts, parentType, subType) {
            var _this2 = this;

            var thisEvent = this.getEventType(eventName),
                eventData = this.getDefaultEvent(),
                data = this.createMediaListEvent(mediaListId, numberOfContacts, parentType, subType);

            this.getUserInformation().then(function (userInfo) {
                eventData = Object.assign(eventData, userInfo, data);
                eventData[_this2.ANALYTICS_CONSTANTS.LABEL] = eventName;

                return _this2.$analytics.eventTrack(thisEvent, eventData);
            });
        }
    }, {
        key: 'getUserInformation',
        value: function getUserInformation() {
            var _this3 = this;

            var promises = [];
            promises.push(this.companyInfoPromise);
            promises.push(this.userInfoPromise);

            return this.$q(function (resolve, reject) {
                _this3.$q.all(promises).then(function () {
                    var info = {};
                    info[_this3.ANALYTICS_CONSTANTS.ICM_USER_ID] = _this3.userEmail + ' (' + _this3.userId + ') ' + _this3.companyName;
                    resolve(info);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }, {
        key: 'getEventType',
        value: function getEventType(eventName) {
            var thisEvent = null;
            switch (eventName) {
                case 'add_contact':
                    thisEvent = this.ANALYTICS_CONSTANTS.ICM_ADD_CONTACT;
                    break;
                case 'remove_contact':
                    thisEvent = this.ANALYTICS_CONSTANTS.ICM_REMOVE_CONTACT;
                    break;
                case 'export_contact':
                    thisEvent = this.ANALYTICS_CONSTANTS.ICM_EXPORT_CONTACT;
                    break;
                case 'outreach_email':
                    thisEvent = this.ANALYTICS_CONSTANTS.ICM_OUTREACH_EMAIL;
                    break;
                case 'import_contact':
                    thisEvent = this.ANALYTICS_CONSTANTS.ICM_IMPORT_CONTACT;
                    break;
                default:
                    thisEvent = null;
                    break;
            }

            return thisEvent;
        }
    }]);

    return SegmentTrackingService;
}();

angular.module('MW.Influencers.SegmentTrackingService', ['MW.Framework.CoreUserService', 'MW.Framework.CoreCompanyService', 'MW.Influencers.AnalyticsService', 'MW.Framework.AnalyticsConstants', 'angulartics', 'angulartics.segment.io']).service('SegmentTrackingService', ['$q', 'CoreUserService', 'CoreCompanyService', '$analytics', 'ANALYTICS_CONSTANTS', SegmentTrackingService]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var SendgridService = function () {
        function SendgridService($q, $http, SENDGRID_ACCOUNT_SERVICE_URL) {
            _classCallCheck(this, SendgridService);

            this.$q = $q;
            this.$http = $http;
            this.SENDGRID_ACCOUNT_SERVICE_URL = SENDGRID_ACCOUNT_SERVICE_URL;
        }

        _createClass(SendgridService, [{
            key: 'getCompanyDomains',
            value: function getCompanyDomains() {
                var deferred = this.$q.defer();
                this.$http.get(this.SENDGRID_ACCOUNT_SERVICE_URL + '/domains').then(function (res) {
                    deferred.resolve(res.data);
                }).catch(function () {
                    deferred.resolve([]);
                });
                return deferred.promise;
            }
        }]);

        return SendgridService;
    }();

    angular.module('MW.Influencers.SendgridService', ['MW.Configuration']).service('SendgridService', ['$q', '$http', 'SENDGRID_ACCOUNT_SERVICE_URL', SendgridService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular, jwtDecode) {
    'use strict';

    var TranslationBootstrapService = function () {
        function TranslationBootstrapService($http, $window, $q, translationService) {
            _classCallCheck(this, TranslationBootstrapService);

            this.$http = $http;
            this.$window = $window;
            this.$q = $q;
            this.translationService = translationService;
        }

        _createClass(TranslationBootstrapService, [{
            key: 'getCookie',
            value: function getCookie(cname) {
                var name = cname + '=';
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) === 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            }
        }, {
            key: 'parseJwt',
            value: function parseJwt(token) {
                var decodedToken;

                if (token) {
                    try {
                        decodedToken = jwtDecode(token);
                    } catch (error) {
                        //Do nothing, we'll bail out later
                    }
                }

                return decodedToken;
            }
        }, {
            key: 'getBrowserLocale',
            value: function getBrowserLocale() {
                var userLang = navigator.language;

                if (userLang === 'zh') {
                    return 'zh_CN';
                }

                return userLang;
            }
        }, {
            key: 'getJwtLocale',
            value: function getJwtLocale() {
                var jwt = this.getCookie('gydaToken');
                var decodedJwt = this.parseJwt(jwt);
                var jwtLocale;

                if (decodedJwt && decodedJwt.user) {
                    jwtLocale = decodedJwt.user.language;
                }

                return jwtLocale;
            }
        }, {
            key: 'getUserTranslationData',
            value: function getUserTranslationData(ICM_ASSETS_URL) {
                var translationConfig = this.$q.defer();
                var jwtLocale = this.getJwtLocale();
                var translationPath = ICM_ASSETS_URL + 'translations/';
                var translationConfigObj = {
                    $locale: 'en',
                    $translationList: {}
                };

                if (jwtLocale) {
                    translationConfigObj.$locale = jwtLocale;
                } else if (this.getBrowserLocale()) {
                    translationConfigObj.$locale = this.getBrowserLocale().split('-')[0];
                }

                if (translationConfigObj.$locale === 'us') {
                    translationConfigObj.$locale = 'en';
                }

                translationPath += translationConfigObj.$locale + '.json';
                this.$http.get(translationPath).then(function (res) {
                    translationConfigObj.$translationList = res.data;
                    translationConfig.resolve(translationConfigObj);
                });

                return translationConfig.promise;
            }
        }]);

        return TranslationBootstrapService;
    }();

    angular.module('MW.Influencers.TranslationBootstrapService', ['MW.Framework.TranslationService']).service('TranslationBootstrapService', ['$http', '$window', '$q', 'translationService', TranslationBootstrapService]);
})(window.angular, window.jwt_decode); // jshint ignore:line
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var UnsubscribeService = function () {
        function UnsubscribeService($http, ICM_UNSUBSCRIBE_API, $q) {
            _classCallCheck(this, UnsubscribeService);

            this.$http = $http;
            this.icmUnsubscribeApi = ICM_UNSUBSCRIBE_API;
            this.$q = $q;
        }

        _createClass(UnsubscribeService, [{
            key: 'getDistributionUnsubscribes',
            value: function getDistributionUnsubscribes(distributionId) {
                var unsubsDistUrl = this.icmUnsubscribeApi + '/unsubscribes/',
                    httpOptions = {
                    distributionId: distributionId
                };

                return this.$http.post(unsubsDistUrl, httpOptions).then(function (response) {
                    if (response && response.data) {
                        return {
                            unsubscribes: response.data
                        };
                    }
                });
            }
        }, {
            key: 'getDistributionUnsubscribeTotal',
            value: function getDistributionUnsubscribeTotal(distributionId) {
                var unsubsDistUrl = this.icmUnsubscribeApi + '/unsubscribes/count',
                    httpOptions = {
                    distributionId: distributionId
                };

                return this.$http.post(unsubsDistUrl, httpOptions).then(function (response) {
                    if (response && response.data) {
                        return response.data;
                    }
                    return 0;
                });
            }
        }, {
            key: 'didEmailUnsubscribeFromICM',
            value: function didEmailUnsubscribeFromICM(emailAddress) {
                var unsubsDistUrl = this.icmUnsubscribeApi + '/unsubscribes/',
                    didUnsubscribe = false,
                    httpOptions = {
                    type: 'unsubscribe',
                    recipientEmails: [emailAddress]
                };

                return this.$http.post(unsubsDistUrl, httpOptions).then(function (response) {
                    if (response && response.data) {
                        if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                            didUnsubscribe = true;
                        }
                        return didUnsubscribe;
                    }
                });
            }
        }, {
            key: 'unsubscribedContactStatus',
            value: function unsubscribedContactStatus(contactsEmailArray) {
                for (var i = 0; i < contactsEmailArray.length; i++) {
                    contactsEmailArray[i] = contactsEmailArray[i].trim().toLowerCase();
                }

                var defer = this.$q.defer(),
                    unsubsDistUrl = this.icmUnsubscribeApi + '/validate/unsubscribe/subscription/statuses',
                    httpOptions = {
                    recipientEmails: contactsEmailArray
                };

                this.$http.post(unsubsDistUrl, httpOptions).then(function (response) {
                    defer.resolve({ to: response.data });
                }).catch(function (error) {
                    defer.reject(error);
                });

                return defer.promise;
            }
        }]);

        return UnsubscribeService;
    }();

    angular.module('MW.Influencers.IcmUnsubscribeService', ['Configuration']).service('IcmUnsubscribeService', ['$http', 'ICM_UNSUBSCRIBE_API', '$q', UnsubscribeService]);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var UserActivityService = function () {
        function UserActivityService($http, ICM_WARPZONE_PRODUCER_URL) {
            _classCallCheck(this, UserActivityService);

            this.$http = $http;
            this.ICM_WARPZONE_PRODUCER_URL = ICM_WARPZONE_PRODUCER_URL;
        }

        _createClass(UserActivityService, [{
            key: 'postToWarpzone',
            value: function postToWarpzone(assetType, assetId) {
                var payload = {
                    assetType: assetType
                };

                if (assetId) {
                    payload.assetId = assetId;
                }

                return this.$http.post(this.ICM_WARPZONE_PRODUCER_URL + '/user-activity', payload);
            }
        }, {
            key: 'trackOutreachListPage',
            value: function trackOutreachListPage() {
                var assetType = 'outreach-list';

                return this.postToWarpzone(assetType);
            }
        }]);

        return UserActivityService;
    }();

    angular.module('MW.Influencers.UserActivityService', ['MW.Configuration']).service('UserActivityService', ['$http', 'ICM_WARPZONE_PRODUCER_URL', UserActivityService]);
})();
'use strict';

angular.module('MW.Framework.ICMUserService', []).service('ICMUserService', ['$q', '$http', '$cookies', 'IDENTITY_SERVICE', function ($q, $http, $cookies, IDENTITY_SERVICE) {

    var userId,
        identityData,
        availableRoles = {
        'REGULAR': {
            name: 'Listener',
            value: 'REGULAR',
            description: 'This is a read-only role. You can\'t create, edit or delete anything in system. Exception is creating and editing own archives.'
        },
        'ADMINISTRATOR': {
            name: 'Administrator',
            value: 'ADMINISTRATOR',
            description: 'You have full access to the account, you can change settings for all users, as well as add or delete users from the account'
        }
    };

    if ($cookies.get('gydaToken') !== undefined) {
        getIdentity(true);
    }

    function setUserId(id) {
        userId = id;
    }

    /**
    * takes in a user object and takes the requested properties to include to create a subset that can be used for requesting data .
    * @param fullUser full user object or original object to pull data from
    * @param propertiesToInclude array of first level scope properties to add to the returned object. If the properties are not found it skips and continues
    * @returns object that has a subset of passed in object.
    */
    function createRequestUserData(fullUser, propertiesToInclude) {
        var requestUserData = {};

        for (var x = 0; x < propertiesToInclude.length; x++) {
            if ('undefined' !== typeof fullUser[propertiesToInclude[x]]) {
                requestUserData[propertiesToInclude[x]] = fullUser[propertiesToInclude[x]];
            }
        }

        return requestUserData;
    }

    function updateUser(userId, settings) {
        // confirmed that notification settings could be one of the followings:
        // timezoneNotificationStatus=yes; timezone=Pacific/Kwajalein
        // timezoneNotificationStatus=no; nextTimezoneNotificationCheck=DateTimeString
        // timezoneNotificationStatus=never
        // cookiePolicy=DateTimeString

        var defer = $q.defer(),
            fieldsToUpdate = ['firstName', 'lastName', 'timezone', 'language'],
            // other user properties require admin-level token to PATCH in IDENTITY_SERVICE
        notificationsFields = ['timezoneNotificationStatus', 'nextTimezoneNotificationCheck', 'cookiePolicy', 'notifications'],
            userData = createRequestUserData(settings, fieldsToUpdate),
            notificationData = createRequestUserData(settings, notificationsFields),
            userPromises = [];

        getAppSettings('notificationSettings', userId).then(function (settings) {
            if (Object.keys(notificationData).length > 0) {
                var newSettings = Object.assign(settings, notificationData);
                userPromises.push(setAppSettings('notificationSettings', newSettings));
            }

            if (Object.keys(userData).length > 0) {
                userPromises.push(putUsers(userId, userData));
            }

            Promise.all(userPromises).then(function (results) {
                defer.resolve(results);
            });
        });
        return defer.promise;
    }

    function getIdentity(wait) {
        var defer = $q.defer();
        if (wait || !identityData) {
            $http.get(IDENTITY_SERVICE, { headers: { 'x-client-name': 'icm-web' } }).then(function (response) {
                identityData = response.data;
                defer.resolve(response.data);
            }).catch(function (error) {
                defer.reject(error);
            });
        } else {
            defer.resolve(identityData);
        }

        return defer.promise;
    }

    function putUsers(userId, userData) {
        var defer = $q.defer();
        $http.patch(IDENTITY_SERVICE + '/users/' + userId, userData, { headers: { 'x-client-name': 'icm-web' } }).then(function (response) {
            defer.resolve(response.data);
        }).catch(function (error) {
            defer.reject(error);
        });
        return defer.promise;
    }

    function getAppSettings(settingName, currentUserId) {
        var defer = $q.defer();
        if (currentUserId) {
            setUserId(currentUserId);
        }

        if (!userId) {
            defer.reject('user id not available');
        }

        $http.get(IDENTITY_SERVICE + '/users/' + userId + '/app_settings/' + settingName, { headers: { 'x-client-name': 'icm-web' } }).then(function (response) {
            defer.resolve(response.data);
        }).catch(function () {
            defer.reject();
        });

        return defer.promise;
    }

    function setAppSettings(settingName, settings) {
        var defer = $q.defer();
        if (!userId) {
            defer.reject('user id not available');
        }

        $http.put(IDENTITY_SERVICE + '/users/' + userId + '/app_settings/' + settingName, settings, { headers: { 'x-client-name': 'icm-web' } }).then(function () {
            defer.resolve();
        }).catch(function () {
            defer.reject();
        });
        return defer.promise;
    }

    function getRoleName() {
        return availableRoles[identityData.companyMembership.role].name;
    }

    /**
     * 
     * @description make sure the identity is loaded before this is used on page load otherwise identityDate will be undefined when a refresh happens
     * @returns the timezone name of the user
     */
    function getTimezoneName() {
        return identityData.user.currentTimeFormat;
    }

    /**
     * 
     * @description make sure the identity is loaded before this is used on page load otherwise identityDate will be undefined when a refresh happens
     * @returns the timezone of the user
     */
    function getTimezone() {
        return identityData.user.timezone;
    }

    return {
        getTimezoneName: getTimezoneName,
        getTimezone: getTimezone,
        setUserId: setUserId,
        updateUser: updateUser,
        putUsers: putUsers,
        getAppSettings: getAppSettings,
        setAppSettings: setAppSettings,
        getIdentity: getIdentity,
        getRoleName: getRoleName
    };
}]);